import { Box, CircularProgress, Grid,  Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { callApiAction } from "../../store/actions/commonAction";
import { getCountsByRegionBeneficiaryApi } from "../../apis/beneficiary.api";
import { REGIONS_TYPE } from "../../utils/constants";
import { useDispatch } from "react-redux";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { useTheme } from "@mui/material";
import NoDataComponent from "../../components/layouts/NoDataComponent";
import { Map } from "@mui/icons-material";
// 1. IMPORT YOUR MAHARASHTRA DISTRICTS TOPOJSON HERE
const MAHARASHTRA_TOPO_JSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [80.562754, 20.820986],
              [80.557634, 20.816769],
              [80.555763, 20.809723],
              [80.552554, 20.802692],
              [80.550213, 20.793129],
              [80.55234, 20.783629],
              [80.552399, 20.76675],
              [80.555047, 20.760467],
              [80.558874, 20.754856],
              [80.561407, 20.748569],
              [80.562758, 20.724034],
              [80.56706, 20.713249],
              [80.570833, 20.708675],
              [80.58181, 20.699941],
              [80.584611, 20.695598],
              [80.586201, 20.691511],
              [80.587021, 20.685182],
              [80.585245, 20.680319],
              [80.579681, 20.675841],
              [80.573696, 20.674477],
              [80.559599, 20.674627],
              [80.554275, 20.672794],
              [80.544286, 20.665549],
              [80.532441, 20.664699],
              [80.525783, 20.663272],
              [80.514458, 20.656105],
              [80.508889, 20.650705],
              [80.496506, 20.641411],
              [80.491684, 20.6367],
              [80.488435, 20.631277],
              [80.487801, 20.625081],
              [80.488442, 20.618641],
              [80.491048, 20.613507],
              [80.499774, 20.605666],
              [80.504048, 20.597404],
              [80.506971, 20.588476],
              [80.51877, 20.586743],
              [80.526384, 20.586315],
              [80.536707, 20.591722],
              [80.558294, 20.600732],
              [80.565939, 20.611622],
              [80.574209, 20.614055],
              [80.585571, 20.615772],
              [80.592643, 20.615811],
              [80.599396, 20.614764],
              [80.609498, 20.60908],
              [80.615873, 20.607686],
              [80.624604, 20.607878],
              [80.629258, 20.605584],
              [80.626426, 20.599646],
              [80.619794, 20.592309],
              [80.621546, 20.587009],
              [80.624403, 20.582785],
              [80.621175, 20.578683],
              [80.626646, 20.569094],
              [80.624002, 20.564012],
              [80.61909, 20.561364],
              [80.616907, 20.558115],
              [80.61872, 20.552753],
              [80.617228, 20.546862],
              [80.620351, 20.543377],
              [80.619672, 20.539076],
              [80.616975, 20.533818],
              [80.615459, 20.518051],
              [80.613829, 20.514386],
              [80.614182, 20.505772],
              [80.613148, 20.48896],
              [80.611901, 20.483054],
              [80.610283, 20.464352],
              [80.608627, 20.459198],
              [80.601638, 20.448364],
              [80.604075, 20.444028],
              [80.608397, 20.439332],
              [80.6104, 20.435232],
              [80.606837, 20.4289],
              [80.601393, 20.422697],
              [80.59868, 20.417043],
              [80.596704, 20.414762],
              [80.593478, 20.40274],
              [80.592984, 20.397632],
              [80.592934, 20.394074],
              [80.594393, 20.389924],
              [80.597142, 20.386391],
              [80.605361, 20.382733],
              [80.609201, 20.378504],
              [80.607679, 20.374673],
              [80.607871, 20.371282],
              [80.612096, 20.368249],
              [80.613166, 20.362889],
              [80.612978, 20.358529],
              [80.618483, 20.351463],
              [80.617686, 20.347391],
              [80.623663, 20.339741],
              [80.624756, 20.335825],
              [80.623669, 20.327908],
              [80.613683, 20.327504],
              [80.612389, 20.322351],
              [80.591199, 20.321436],
              [80.558521, 20.313639],
              [80.548962, 20.308967],
              [80.546255, 20.302516],
              [80.542769, 20.296808],
              [80.53362, 20.286909],
              [80.517767, 20.271737],
              [80.501418, 20.276907],
              [80.482781, 20.27578],
              [80.472347, 20.273706],
              [80.463366, 20.270985],
              [80.455269, 20.265956],
              [80.444185, 20.260553],
              [80.429806, 20.254675],
              [80.426504, 20.25362],
              [80.422142, 20.254345],
              [80.415895, 20.25119],
              [80.410583, 20.249755],
              [80.393082, 20.246653],
              [80.389815, 20.243759],
              [80.394899, 20.232679],
              [80.404873, 20.214886],
              [80.416698, 20.207416],
              [80.418906, 20.204351],
              [80.420869, 20.192383],
              [80.420289, 20.189693],
              [80.410938, 20.186568],
              [80.405147, 20.185587],
              [80.401477, 20.183737],
              [80.399659, 20.179553],
              [80.398775, 20.172906],
              [80.39732, 20.16844],
              [80.392892, 20.164981],
              [80.391434, 20.160683],
              [80.394507, 20.153767],
              [80.400722, 20.146231],
              [80.408388, 20.141733],
              [80.433854, 20.132515],
              [80.438856, 20.133617],
              [80.44654, 20.131406],
              [80.451054, 20.132631],
              [80.454798, 20.143849],
              [80.458255, 20.147147],
              [80.465599, 20.146837],
              [80.473718, 20.144971],
              [80.48424, 20.140851],
              [80.489884, 20.14021],
              [80.498078, 20.143802],
              [80.50497, 20.141263],
              [80.510543, 20.13115],
              [80.517505, 20.129297],
              [80.525109, 20.129218],
              [80.530545, 20.126861],
              [80.533655, 20.123784],
              [80.53579, 20.119909],
              [80.542731, 20.116271],
              [80.54735, 20.112263],
              [80.54824, 20.10739],
              [80.54222, 20.094646],
              [80.541961, 20.087868],
              [80.548829, 20.079175],
              [80.553162, 20.068222],
              [80.552236, 20.062093],
              [80.548079, 20.050726],
              [80.548589, 20.039766],
              [80.542423, 20.013802],
              [80.539557, 20.006532],
              [80.542791, 20.002536],
              [80.546965, 20.000345],
              [80.550545, 19.997705],
              [80.552574, 19.989828],
              [80.551157, 19.984162],
              [80.544778, 19.976222],
              [80.541754, 19.973583],
              [80.539386, 19.969718],
              [80.540862, 19.955724],
              [80.53328, 19.951312],
              [80.533041, 19.943809],
              [80.527399, 19.933589],
              [80.515764, 19.928611],
              [80.50875, 19.927447],
              [80.48747, 19.930469],
              [80.479878, 19.933901],
              [80.476817, 19.936307],
              [80.475733, 19.942903],
              [80.471465, 19.948872],
              [80.459949, 19.947841],
              [80.450657, 19.955255],
              [80.445501, 19.949714],
              [80.437963, 19.943524],
              [80.432056, 19.939895],
              [80.427531, 19.938809],
              [80.416256, 19.937945],
              [80.413229, 19.935072],
              [80.412738, 19.928027],
              [80.409604, 19.912203],
              [80.414643, 19.908517],
              [80.421703, 19.90555],
              [80.437974, 19.901071],
              [80.442779, 19.898189],
              [80.451429, 19.896229],
              [80.459771, 19.902694],
              [80.468215, 19.906119],
              [80.475939, 19.90606],
              [80.489643, 19.901613],
              [80.496833, 19.896401],
              [80.498668, 19.893284],
              [80.503937, 19.879966],
              [80.504546, 19.871535],
              [80.494648, 19.867906],
              [80.482025, 19.859837],
              [80.478042, 19.845461],
              [80.475632, 19.840334],
              [80.470622, 19.838639],
              [80.467312, 19.83084],
              [80.462126, 19.826613],
              [80.453978, 19.823128],
              [80.438656, 19.8131],
              [80.431572, 19.810846],
              [80.424298, 19.811938],
              [80.411959, 19.818184],
              [80.404511, 19.818986],
              [80.405413, 19.805965],
              [80.401671, 19.797369],
              [80.40712, 19.796426],
              [80.424682, 19.799949],
              [80.435997, 19.797946],
              [80.442804, 19.794698],
              [80.449702, 19.793393],
              [80.456552, 19.795522],
              [80.459461, 19.795764],
              [80.468786, 19.791099],
              [80.473825, 19.787761],
              [80.485132, 19.775333],
              [80.489601, 19.783621],
              [80.489104, 19.7924],
              [80.487269, 19.798329],
              [80.484163, 19.804105],
              [80.481838, 19.806258],
              [80.469916, 19.808617],
              [80.466561, 19.814171],
              [80.476178, 19.827492],
              [80.483044, 19.830827],
              [80.497749, 19.828201],
              [80.505422, 19.832319],
              [80.514558, 19.832816],
              [80.524853, 19.831742],
              [80.542443, 19.821045],
              [80.54951, 19.822197],
              [80.551297, 19.814145],
              [80.549014, 19.806102],
              [80.549508, 19.797212],
              [80.545958, 19.783684],
              [80.546751, 19.777592],
              [80.557305, 19.767578],
              [80.574755, 19.75974],
              [80.57763, 19.757802],
              [80.585801, 19.747019],
              [80.589201, 19.74118],
              [80.597451, 19.737554],
              [80.620285, 19.732097],
              [80.627345, 19.726945],
              [80.640653, 19.72169],
              [80.647459, 19.715679],
              [80.652796, 19.709745],
              [80.668518, 19.700781],
              [80.673025, 19.695501],
              [80.671739, 19.694039],
              [80.672649, 19.691274],
              [80.673208, 19.689576],
              [80.672574, 19.676293],
              [80.669401, 19.665911],
              [80.663322, 19.628536],
              [80.663095, 19.620392],
              [80.664034, 19.615679],
              [80.669238, 19.61216],
              [80.690258, 19.614056],
              [80.703918, 19.614295],
              [80.715003, 19.613941],
              [80.728238, 19.611897],
              [80.765232, 19.59375],
              [80.771553, 19.588428],
              [80.772309, 19.577869],
              [80.773699, 19.571945],
              [80.792459, 19.56407],
              [80.816547, 19.568195],
              [80.826928, 19.569104],
              [80.834939, 19.566393],
              [80.840872, 19.559706],
              [80.843385, 19.552724],
              [80.844725, 19.544393],
              [80.848159, 19.537346],
              [80.852732, 19.532963],
              [80.859606, 19.527972],
              [80.87071, 19.525779],
              [80.880967, 19.52618],
              [80.886412, 19.522875],
              [80.892926, 19.513133],
              [80.897088, 19.50315],
              [80.898782, 19.494758],
              [80.899558, 19.485457],
              [80.899466, 19.469639],
              [80.893022, 19.46047],
              [80.88339, 19.451918],
              [80.874877, 19.447426],
              [80.864863, 19.446507],
              [80.842437, 19.446314],
              [80.832617, 19.443042],
              [80.815369, 19.435537],
              [80.801684, 19.432672],
              [80.795282, 19.430601],
              [80.799801, 19.426577],
              [80.80275, 19.422687],
              [80.805331, 19.415589],
              [80.815925, 19.401023],
              [80.820119, 19.386748],
              [80.823373, 19.383081],
              [80.830612, 19.378775],
              [80.842397, 19.374734],
              [80.850237, 19.370184],
              [80.85243, 19.364994],
              [80.84649, 19.359244],
              [80.833827, 19.352138],
              [80.833767, 19.352104],
              [80.823888, 19.346559],
              [80.820221, 19.342212],
              [80.813738, 19.338992],
              [80.810229, 19.336364],
              [80.806751, 19.329256],
              [80.795285, 19.32819],
              [80.78985, 19.325813],
              [80.785487, 19.322617],
              [80.773586, 19.312215],
              [80.767124, 19.303841],
              [80.762436, 19.29933],
              [80.756632, 19.290831],
              [80.750798, 19.290066],
              [80.744105, 19.291039],
              [80.738049, 19.288103],
              [80.725674, 19.28956],
              [80.716544, 19.287359],
              [80.707812, 19.286301],
              [80.701097, 19.286351],
              [80.69597, 19.287519],
              [80.690898, 19.290929],
              [80.689137, 19.299838],
              [80.692619, 19.316575],
              [80.69155, 19.323987],
              [80.686547, 19.328083],
              [80.679211, 19.330379],
              [80.671701, 19.330495],
              [80.665183, 19.328197],
              [80.64261, 19.31675],
              [80.632805, 19.310719],
              [80.625018, 19.308718],
              [80.617438, 19.311018],
              [80.611239, 19.315642],
              [80.607361, 19.321945],
              [80.605793, 19.328506],
              [80.602956, 19.335146],
              [80.599945, 19.339029],
              [80.595881, 19.348205],
              [80.59284, 19.35679],
              [80.589503, 19.372089],
              [80.591963, 19.377438],
              [80.591183, 19.380895],
              [80.580089, 19.402098],
              [80.575046, 19.404586],
              [80.566564, 19.401215],
              [80.538744, 19.377971],
              [80.533344, 19.370891],
              [80.529932, 19.363437],
              [80.526191, 19.357705],
              [80.521049, 19.351887],
              [80.514422, 19.347283],
              [80.507597, 19.344983],
              [80.488275, 19.341489],
              [80.482781, 19.338706],
              [80.477701, 19.332592],
              [80.472491, 19.319607],
              [80.46931, 19.31184],
              [80.463995, 19.302869],
              [80.452617, 19.273636],
              [80.44423, 19.264816],
              [80.435266, 19.258127],
              [80.426359, 19.254021],
              [80.415356, 19.251432],
              [80.404012, 19.249933],
              [80.395606, 19.247024],
              [80.39051, 19.242854],
              [80.386334, 19.236325],
              [80.384187, 19.221112],
              [80.387116, 19.212466],
              [80.393295, 19.199429],
              [80.393839, 19.192832],
              [80.388303, 19.184544],
              [80.380087, 19.178937],
              [80.369528, 19.173128],
              [80.352655, 19.166714],
              [80.347748, 19.16272],
              [80.346795, 19.156835],
              [80.342708, 19.151388],
              [80.33201, 19.145345],
              [80.328019, 19.128322],
              [80.32951, 19.124061],
              [80.336847, 19.111299],
              [80.338724, 19.104966],
              [80.331293, 19.098823],
              [80.327128, 19.092118],
              [80.329743, 19.086069],
              [80.329303, 19.078794],
              [80.32715, 19.073325],
              [80.322962, 19.068512],
              [80.30943, 19.059479],
              [80.298871, 19.053722],
              [80.29602, 19.050218],
              [80.297722, 19.043949],
              [80.302468, 19.032701],
              [80.300589, 19.025574],
              [80.295302, 19.017912],
              [80.279488, 19.001432],
              [80.274907, 18.991327],
              [80.274529, 18.984696],
              [80.276211, 18.968199],
              [80.274698, 18.956634],
              [80.272521, 18.951063],
              [80.271341, 18.944603],
              [80.272373, 18.938649],
              [80.27484, 18.932896],
              [80.277678, 18.929026],
              [80.298627, 18.911764],
              [80.305345, 18.904653],
              [80.315834, 18.890408],
              [80.320737, 18.885423],
              [80.328935, 18.879084],
              [80.33293, 18.874245],
              [80.343033, 18.860443],
              [80.346937, 18.852676],
              [80.352898, 18.838303],
              [80.355836, 18.828331],
              [80.355104, 18.820349],
              [80.353553, 18.815486],
              [80.342021, 18.810511],
              [80.326051, 18.800381],
              [80.306731, 18.797912],
              [80.301458, 18.794971],
              [80.297485, 18.790631],
              [80.286829, 18.772243],
              [80.283844, 18.769245],
              [80.279107, 18.766612],
              [80.272698, 18.767546],
              [80.268725, 18.769343],
              [80.261831, 18.770318],
              [80.256251, 18.76961],
              [80.249434, 18.764116],
              [80.247781, 18.760975],
              [80.246826, 18.756595],
              [80.248077, 18.753067],
              [80.254721, 18.747951],
              [80.26211, 18.740551],
              [80.264843, 18.73569],
              [80.274848, 18.722437],
              [80.267674, 18.718564],
              [80.25396, 18.705783],
              [80.248996, 18.704679],
              [80.24285, 18.704872],
              [80.237272, 18.701989],
              [80.23262, 18.700601],
              [80.227293, 18.703631],
              [80.221634, 18.705555],
              [80.215152, 18.704881],
              [80.209172, 18.701861],
              [80.201366, 18.692949],
              [80.198927, 18.688064],
              [80.19822, 18.683403],
              [80.196214, 18.68002],
              [80.182904, 18.680324],
              [80.178224, 18.681754],
              [80.174653, 18.684472],
              [80.171874, 18.694679],
              [80.169233, 18.6984],
              [80.165326, 18.700307],
              [80.159441, 18.699645],
              [80.155955, 18.697601],
              [80.149484, 18.690611],
              [80.143813, 18.691153],
              [80.138075, 18.68975],
              [80.128503, 18.685547],
              [80.125624, 18.683464],
              [80.123195, 18.680193],
              [80.11801, 18.680523],
              [80.113756, 18.681845],
              [80.107749, 18.689266],
              [80.094116, 18.701828],
              [80.091614, 18.705098],
              [80.089271, 18.706701],
              [80.086061, 18.705586],
              [80.081863, 18.706799],
              [80.075053, 18.712933],
              [80.072628, 18.717471],
              [80.069036, 18.72071],
              [80.060387, 18.721983],
              [80.053476, 18.725084],
              [80.039956, 18.750556],
              [80.036744, 18.7528],
              [80.025794, 18.755094],
              [80.023606, 18.761087],
              [80.021566, 18.764189],
              [80.019407, 18.770813],
              [80.01615, 18.772623],
              [79.999966, 18.777536],
              [79.988575, 18.778272],
              [79.957153, 18.783862],
              [79.947064, 18.785715],
              [79.938959, 18.788346],
              [79.923223, 18.801214],
              [79.916052, 18.810539],
              [79.900918, 18.834639],
              [79.911027, 18.838674],
              [79.92777, 18.840019],
              [79.932454, 18.841361],
              [79.940283, 18.848851],
              [79.945944, 18.862689],
              [79.947899, 18.881156],
              [79.947062, 18.900477],
              [79.948267, 18.919477],
              [79.947856, 18.941327],
              [79.942793, 18.961263],
              [79.939096, 18.975182],
              [79.938235, 18.978385],
              [79.939661, 18.999263],
              [79.941356, 19.025213],
              [79.939931, 19.03319],
              [79.932841, 19.045964],
              [79.922955, 19.050811],
              [79.909775, 19.051416],
              [79.897678, 19.048874],
              [79.887913, 19.044807],
              [79.877829, 19.038961],
              [79.866373, 19.038035],
              [79.8638, 19.04559],
              [79.867891, 19.063315],
              [79.866839, 19.094269],
              [79.864814, 19.10739],
              [79.869893, 19.119096],
              [79.877975, 19.12597],
              [79.912778, 19.145069],
              [79.929122, 19.160405],
              [79.932946, 19.164212],
              [79.947526, 19.167685],
              [79.950039, 19.173881],
              [79.949254, 19.179151],
              [79.942065, 19.187096],
              [79.929295, 19.206607],
              [79.926118, 19.218198],
              [79.926948, 19.229569],
              [79.938692, 19.262435],
              [79.95196, 19.287226],
              [79.955728, 19.291952],
              [79.968578, 19.300578],
              [79.970423, 19.309622],
              [79.964153, 19.327502],
              [79.963922, 19.337592],
              [79.971294, 19.353685],
              [79.973298, 19.363879],
              [79.974009, 19.377548],
              [79.977516, 19.385082],
              [79.979358, 19.394531],
              [79.979804, 19.403952],
              [79.976763, 19.412381],
              [79.965989, 19.428786],
              [79.952487, 19.443621],
              [79.952922, 19.453759],
              [79.951718, 19.461633],
              [79.946912, 19.467299],
              [79.943989, 19.469739],
              [79.939579, 19.471891],
              [79.930245, 19.480333],
              [79.924485, 19.488273],
              [79.917712, 19.495049],
              [79.908911, 19.49918],
              [79.884866, 19.503359],
              [79.876844, 19.507598],
              [79.870417, 19.516216],
              [79.862842, 19.519719],
              [79.8348, 19.539544],
              [79.829728, 19.546827],
              [79.827186, 19.554849],
              [79.826115, 19.563983],
              [79.823154, 19.571483],
              [79.817657, 19.576299],
              [79.811771, 19.579209],
              [79.799832, 19.582514],
              [79.792831, 19.59205],
              [79.791952, 19.595987],
              [79.794105, 19.604674],
              [79.794282, 19.617511],
              [79.789233, 19.631386],
              [79.786983, 19.649379],
              [79.787969, 19.663665],
              [79.786864, 19.69229],
              [79.787439, 19.708572],
              [79.786807, 19.71744],
              [79.781982, 19.726281],
              [79.760962, 19.748766],
              [79.754992, 19.760384],
              [79.751793, 19.772182],
              [79.747385, 19.779082],
              [79.745607, 19.790037],
              [79.743809, 19.816524],
              [79.744073, 19.823403],
              [79.747588, 19.830799],
              [79.758538, 19.846773],
              [79.766054, 19.854421],
              [79.781728, 19.863442],
              [79.786577, 19.868754],
              [79.786605, 19.875214],
              [79.791558, 19.88127],
              [79.798913, 19.885315],
              [79.803417, 19.889755],
              [79.80515, 19.893631],
              [79.805668, 19.899936],
              [79.799233, 19.912966],
              [79.795566, 19.916791],
              [79.79279, 19.924085],
              [79.78444, 19.935947],
              [79.776875, 19.950016],
              [79.772213, 19.971961],
              [79.775534, 19.979732],
              [79.77973, 19.986983],
              [79.780702, 20.000362],
              [79.788395, 20.009707],
              [79.798724, 20.020285],
              [79.814204, 20.028866],
              [79.848695, 20.032476],
              [79.856684, 20.021422],
              [79.870704, 20.001143],
              [79.869854, 20.000111],
              [79.868771, 19.991215],
              [79.871162, 19.984016],
              [79.880972, 19.976821],
              [79.895038, 19.969527],
              [79.912501, 19.967594],
              [79.924374, 19.970592],
              [79.937595, 19.975803],
              [79.950544, 19.984769],
              [79.957233, 19.993024],
              [79.962603, 19.999807],
              [79.964685, 20.004184],
              [79.972438, 20.014926],
              [79.984008, 20.02934],
              [79.991586, 20.045336],
              [79.985942, 20.066697],
              [79.984562, 20.079492],
              [79.978324, 20.103191],
              [79.972359, 20.112745],
              [79.965408, 20.121125],
              [79.957069, 20.125388],
              [79.938852, 20.128888],
              [79.930188, 20.131451],
              [79.920559, 20.135877],
              [79.913679, 20.140746],
              [79.912211, 20.145525],
              [79.91269, 20.149779],
              [79.916953, 20.159822],
              [79.921564, 20.168788],
              [79.934195, 20.18689],
              [79.941506, 20.192103],
              [79.946698, 20.19396],
              [79.95565, 20.198807],
              [79.96519, 20.202331],
              [79.972452, 20.204387],
              [79.983359, 20.205161],
              [79.989519, 20.206761],
              [79.993791, 20.212114],
              [79.995839, 20.219772],
              [79.995407, 20.229071],
              [79.992288, 20.237543],
              [79.985419, 20.248494],
              [79.979078, 20.256691],
              [79.971619, 20.264231],
              [79.956845, 20.275725],
              [79.949355, 20.284955],
              [79.945386, 20.294014],
              [79.944916, 20.305481],
              [79.94563, 20.31659],
              [79.949995, 20.326876],
              [79.95715, 20.333824],
              [79.963719, 20.338428],
              [79.968585, 20.342164],
              [79.973857, 20.349978],
              [79.973509, 20.36074],
              [79.965962, 20.371499],
              [79.960325, 20.383515],
              [79.961664, 20.397399],
              [79.964015, 20.405045],
              [79.962125, 20.41498],
              [79.955231, 20.423695],
              [79.94306, 20.434865],
              [79.941313, 20.446752],
              [79.945314, 20.474423],
              [79.951974, 20.500173],
              [79.951321, 20.511421],
              [79.952811, 20.528154],
              [79.948527, 20.536905],
              [79.934714, 20.543557],
              [79.927619, 20.552169],
              [79.933587, 20.566453],
              [79.938301, 20.582356],
              [79.941166, 20.601617],
              [79.940681, 20.612087],
              [79.942849, 20.624101],
              [79.943319, 20.637858],
              [79.941011, 20.648771],
              [79.936342, 20.660574],
              [79.932995, 20.666525],
              [79.934705, 20.671607],
              [79.934456, 20.676176],
              [79.943026, 20.6783],
              [79.949104, 20.680939],
              [79.961435, 20.690664],
              [79.964497, 20.689879],
              [79.96453, 20.68987],
              [79.970927, 20.688218],
              [79.983727, 20.682678],
              [79.989223, 20.673481],
              [80.000015, 20.672806],
              [80.008238, 20.667278],
              [80.01408, 20.672736],
              [80.018507, 20.666256],
              [80.022504, 20.668976],
              [80.024601, 20.671781],
              [80.027216, 20.676765],
              [80.032671, 20.691158],
              [80.036885, 20.697625],
              [80.042463, 20.700686],
              [80.051831, 20.70378],
              [80.058402, 20.707756],
              [80.065627, 20.704998],
              [80.069563, 20.702612],
              [80.073976, 20.698271],
              [80.087095, 20.688699],
              [80.097313, 20.686492],
              [80.104829, 20.687296],
              [80.111691, 20.689995],
              [80.120481, 20.685673],
              [80.126111, 20.683608],
              [80.135639, 20.684455],
              [80.137084, 20.677721],
              [80.141536, 20.67808],
              [80.143807, 20.68404],
              [80.161587, 20.686984],
              [80.17039, 20.678637],
              [80.176253, 20.674459],
              [80.189456, 20.671815],
              [80.195276, 20.668666],
              [80.202638, 20.662683],
              [80.208817, 20.658894],
              [80.218823, 20.655243],
              [80.22935, 20.652967],
              [80.241604, 20.653028],
              [80.247816, 20.656883],
              [80.248362, 20.671807],
              [80.263596, 20.670688],
              [80.273493, 20.671685],
              [80.277527, 20.682328],
              [80.279335, 20.690581],
              [80.28327, 20.702261],
              [80.291878, 20.7027],
              [80.298665, 20.703954],
              [80.304465, 20.713714],
              [80.311633, 20.730419],
              [80.318831, 20.744251],
              [80.321929, 20.752775],
              [80.321627, 20.75737],
              [80.316979, 20.775385],
              [80.321045, 20.783333],
              [80.326076, 20.790002],
              [80.326586, 20.796198],
              [80.322847, 20.799331],
              [80.331778, 20.819631],
              [80.338125, 20.819794],
              [80.343929, 20.815784],
              [80.348248, 20.810053],
              [80.353911, 20.808625],
              [80.365197, 20.80817],
              [80.380831, 20.804917],
              [80.392079, 20.805895],
              [80.400905, 20.809079],
              [80.40849, 20.818708],
              [80.415388, 20.823573],
              [80.4229, 20.823672],
              [80.445319, 20.820236],
              [80.456234, 20.819778],
              [80.477085, 20.822263],
              [80.50615, 20.831497],
              [80.519083, 20.830899],
              [80.543624, 20.822945],
              [80.562754, 20.820986],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 193,
        censuscode: 508,
        dt_cen_cd: 12,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Garhchiroli",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [80.663424, 21.331383],
              [80.664841, 21.32999],
              [80.666763, 21.328396],
              [80.669284, 21.326752],
              [80.670456, 21.325493],
              [80.672497, 21.322751],
              [80.673438, 21.319988],
              [80.673903, 21.316828],
              [80.674967, 21.314472],
              [80.677851, 21.312943],
              [80.679638, 21.311927],
              [80.68069, 21.309746],
              [80.679269, 21.306569],
              [80.679994, 21.301854],
              [80.679836, 21.298972],
              [80.677848, 21.296589],
              [80.675185, 21.294671],
              [80.672159, 21.292977],
              [80.670218, 21.291636],
              [80.667794, 21.290464],
              [80.664989, 21.29009],
              [80.6617, 21.29018],
              [80.660576, 21.286718],
              [80.659023, 21.283935],
              [80.657696, 21.282259],
              [80.65551, 21.280858],
              [80.653646, 21.278826],
              [80.651773, 21.276683],
              [80.650299, 21.272981],
              [80.649537, 21.269753],
              [80.648798, 21.265137],
              [80.647976, 21.262138],
              [80.646376, 21.258214],
              [80.645609, 21.2555],
              [80.644237, 21.253408],
              [80.64219, 21.250859],
              [80.639109, 21.248015],
              [80.634549, 21.246419],
              [80.631512, 21.24501],
              [80.626968, 21.243074],
              [80.622594, 21.240734],
              [80.620312, 21.237549],
              [80.618569, 21.235285],
              [80.617366, 21.234004],
              [80.615555, 21.232498],
              [80.61453, 21.231964],
              [80.612953, 21.230689],
              [80.611927, 21.229474],
              [80.610301, 21.228135],
              [80.607872, 21.226896],
              [80.605752, 21.225846],
              [80.60307, 21.225243],
              [80.59917, 21.225555],
              [80.596235, 21.225418],
              [80.591318, 21.223762],
              [80.588408, 21.222474],
              [80.584952, 21.220601],
              [80.581672, 21.21896],
              [80.578695, 21.21755],
              [80.575262, 21.214584],
              [80.57346, 21.211511],
              [80.572975, 21.210991],
              [80.57087, 21.208726],
              [80.568088, 21.206519],
              [80.564634, 21.204646],
              [80.560499, 21.203226],
              [80.557471, 21.201871],
              [80.556129, 21.201685],
              [80.553395, 21.201373],
              [80.55035, 21.200717],
              [80.54871, 21.199893],
              [80.545728, 21.199982],
              [80.541809, 21.200295],
              [80.539182, 21.200902],
              [80.537291, 21.201521],
              [80.534718, 21.202701],
              [80.531835, 21.203307],
              [80.527565, 21.204194],
              [80.525032, 21.201751],
              [80.523051, 21.19897],
              [80.521614, 21.196711],
              [80.519983, 21.194283],
              [80.518374, 21.191793],
              [80.517603, 21.189594],
              [80.517149, 21.187171],
              [80.516144, 21.184171],
              [80.514448, 21.183123],
              [80.51133, 21.183727],
              [80.509376, 21.183994],
              [80.506689, 21.18472],
              [80.504677, 21.184699],
              [80.502303, 21.183932],
              [80.499111, 21.180614],
              [80.496333, 21.178231],
              [80.492795, 21.177857],
              [80.488604, 21.177242],
              [80.486238, 21.175601],
              [80.483885, 21.173745],
              [80.481706, 21.172103],
              [80.480128, 21.171977],
              [80.474633, 21.172151],
              [80.470976, 21.172749],
              [80.468408, 21.173477],
              [80.464079, 21.173488],
              [80.462045, 21.169731],
              [80.461047, 21.166097],
              [80.460786, 21.162404],
              [80.460704, 21.159292],
              [80.459596, 21.155012],
              [80.458366, 21.150335],
              [80.456878, 21.147605],
              [80.455994, 21.145112],
              [80.454988, 21.142221],
              [80.453743, 21.13886],
              [80.452801, 21.136475],
              [80.45079, 21.13131],
              [80.44924, 21.128865],
              [80.447507, 21.126179],
              [80.445427, 21.12211],
              [80.447146, 21.121023],
              [80.450639, 21.119964],
              [80.452966, 21.118894],
              [80.454999, 21.117009],
              [80.455923, 21.116035],
              [80.456115, 21.115577],
              [80.456029, 21.112686],
              [80.453726, 21.111789],
              [80.452273, 21.111994],
              [80.450493, 21.112381],
              [80.44903, 21.112597],
              [80.446284, 21.112504],
              [80.445834, 21.109895],
              [80.445498, 21.107701],
              [80.444438, 21.105262],
              [80.443488, 21.103401],
              [80.442841, 21.101786],
              [80.441954, 21.099751],
              [80.440985, 21.098767],
              [80.440082, 21.097884],
              [80.442274, 21.095927],
              [80.443156, 21.093461],
              [80.444908, 21.089569],
              [80.446781, 21.086083],
              [80.447727, 21.084022],
              [80.448787, 21.081376],
              [80.449315, 21.078207],
              [80.449549, 21.074979],
              [80.449384, 21.073248],
              [80.44774, 21.071187],
              [80.449368, 21.067774],
              [80.449744, 21.066738],
              [80.450757, 21.064043],
              [80.451521, 21.062385],
              [80.452883, 21.060799],
              [80.454047, 21.057478],
              [80.454405, 21.055311],
              [80.455014, 21.052797],
              [80.455278, 21.050444],
              [80.454653, 21.047688],
              [80.453858, 21.045158],
              [80.454125, 21.041599],
              [80.454325, 21.040462],
              [80.454126, 21.037468],
              [80.453307, 21.034462],
              [80.452026, 21.031798],
              [80.450036, 21.030049],
              [80.447641, 21.028865],
              [80.445377, 21.028021],
              [80.44353, 21.025869],
              [80.442741, 21.022906],
              [80.441323, 21.020104],
              [80.439241, 21.017995],
              [80.436889, 21.017224],
              [80.435599, 21.014431],
              [80.434339, 21.013324],
              [80.430532, 21.01046],
              [80.43152, 21.008208],
              [80.433418, 21.005918],
              [80.436258, 21.003518],
              [80.440085, 21.000641],
              [80.444867, 20.99301],
              [80.445724, 20.972501],
              [80.447491, 20.96641],
              [80.450549, 20.96199],
              [80.455132, 20.95199],
              [80.455571, 20.946292],
              [80.463382, 20.938258],
              [80.462346, 20.933133],
              [80.465886, 20.929175],
              [80.472116, 20.928328],
              [80.480721, 20.928406],
              [80.489562, 20.929525],
              [80.498108, 20.928913],
              [80.507505, 20.929981],
              [80.517456, 20.929887],
              [80.533254, 20.933208],
              [80.542106, 20.932428],
              [80.548697, 20.935031],
              [80.544973, 20.927195],
              [80.545949, 20.92219],
              [80.553029, 20.904246],
              [80.556619, 20.890094],
              [80.555761, 20.869314],
              [80.557464, 20.861144],
              [80.557228, 20.846928],
              [80.56167, 20.830708],
              [80.562754, 20.820986],
              [80.543624, 20.822945],
              [80.519083, 20.830899],
              [80.50615, 20.831497],
              [80.477085, 20.822263],
              [80.456234, 20.819778],
              [80.445319, 20.820236],
              [80.4229, 20.823672],
              [80.415388, 20.823573],
              [80.40849, 20.818708],
              [80.400905, 20.809079],
              [80.392079, 20.805895],
              [80.380831, 20.804917],
              [80.365197, 20.80817],
              [80.353911, 20.808625],
              [80.348248, 20.810053],
              [80.343929, 20.815784],
              [80.338125, 20.819794],
              [80.331778, 20.819631],
              [80.322847, 20.799331],
              [80.326586, 20.796198],
              [80.326076, 20.790002],
              [80.321045, 20.783333],
              [80.316979, 20.775385],
              [80.321627, 20.75737],
              [80.321929, 20.752775],
              [80.318831, 20.744251],
              [80.311633, 20.730419],
              [80.304465, 20.713714],
              [80.298665, 20.703954],
              [80.291878, 20.7027],
              [80.28327, 20.702261],
              [80.279335, 20.690581],
              [80.277527, 20.682328],
              [80.273493, 20.671685],
              [80.263596, 20.670688],
              [80.248362, 20.671807],
              [80.247816, 20.656883],
              [80.241604, 20.653028],
              [80.22935, 20.652967],
              [80.218823, 20.655243],
              [80.208817, 20.658894],
              [80.202638, 20.662683],
              [80.195276, 20.668666],
              [80.189456, 20.671815],
              [80.176253, 20.674459],
              [80.17039, 20.678637],
              [80.161587, 20.686984],
              [80.143807, 20.68404],
              [80.141536, 20.67808],
              [80.137084, 20.677721],
              [80.135639, 20.684455],
              [80.126111, 20.683608],
              [80.120481, 20.685673],
              [80.111691, 20.689995],
              [80.104829, 20.687296],
              [80.097313, 20.686492],
              [80.087095, 20.688699],
              [80.073976, 20.698271],
              [80.069563, 20.702612],
              [80.065627, 20.704998],
              [80.058402, 20.707756],
              [80.051831, 20.70378],
              [80.042463, 20.700686],
              [80.036885, 20.697625],
              [80.032671, 20.691158],
              [80.027216, 20.676765],
              [80.024601, 20.671781],
              [80.022504, 20.668976],
              [80.018507, 20.666256],
              [80.01408, 20.672736],
              [80.008238, 20.667278],
              [80.000015, 20.672806],
              [79.989223, 20.673481],
              [79.983727, 20.682678],
              [79.970927, 20.688218],
              [79.96453, 20.68987],
              [79.966278, 20.693618],
              [79.972043, 20.701253],
              [79.972335, 20.709439],
              [79.970379, 20.713945],
              [79.960895, 20.716334],
              [79.95327, 20.716884],
              [79.947209, 20.71587],
              [79.934404, 20.71191],
              [79.931957, 20.71752],
              [79.929657, 20.728703],
              [79.928817, 20.739225],
              [79.915911, 20.738206],
              [79.917079, 20.746117],
              [79.926075, 20.746398],
              [79.926464, 20.750905],
              [79.926029, 20.75895],
              [79.925673, 20.765529],
              [79.926943, 20.768657],
              [79.937894, 20.773813],
              [79.940334, 20.785311],
              [79.935248, 20.785769],
              [79.927484, 20.784837],
              [79.918091, 20.783057],
              [79.910015, 20.781525],
              [79.904344, 20.778762],
              [79.899192, 20.773638],
              [79.896773, 20.771233],
              [79.893886, 20.768361],
              [79.888803, 20.766242],
              [79.886453, 20.769184],
              [79.885066, 20.78997],
              [79.87697, 20.783869],
              [79.870403, 20.780392],
              [79.866, 20.781308],
              [79.868334, 20.795383],
              [79.866468, 20.802004],
              [79.867147, 20.808168],
              [79.856677, 20.810274],
              [79.858433, 20.814783],
              [79.863422, 20.814879],
              [79.862342, 20.819018],
              [79.859503, 20.820763],
              [79.862922, 20.825917],
              [79.86327, 20.837],
              [79.863396, 20.841003],
              [79.862803, 20.845786],
              [79.866714, 20.849836],
              [79.868009, 20.852986],
              [79.868893, 20.857112],
              [79.868076, 20.862604],
              [79.867481, 20.865107],
              [79.864833, 20.870348],
              [79.865317, 20.876144],
              [79.873826, 20.882774],
              [79.880486, 20.879192],
              [79.889689, 20.875612],
              [79.901908, 20.881866],
              [79.905345, 20.883625],
              [79.909356, 20.886571],
              [79.911012, 20.897703],
              [79.927259, 20.905347],
              [79.933708, 20.912929],
              [79.93788, 20.917076],
              [79.944696, 20.923238],
              [79.94781, 20.926054],
              [79.948494, 20.929549],
              [79.946094, 20.940708],
              [79.945157, 20.948683],
              [79.941823, 20.959261],
              [79.943679, 20.970485],
              [79.954741, 20.988244],
              [79.953855, 21.000111],
              [79.94866, 21.007101],
              [79.947875, 21.009309],
              [79.949246, 21.011793],
              [79.952969, 21.013082],
              [79.965708, 21.008762],
              [79.987557, 21.007754],
              [79.997158, 21.02137],
              [80, 21.022014],
              [80.001764, 21.020266],
              [80.003527, 21.016954],
              [80.003919, 21.01539],
              [80.005487, 21.014286],
              [80.008916, 21.013274],
              [80.012052, 21.012629],
              [80.015873, 21.009869],
              [80.015872, 21.008029],
              [80.017538, 21.004625],
              [80.018321, 21.002969],
              [80.019399, 21.001221],
              [80.024494, 21.004992],
              [80.02567, 21.007292],
              [80.027238, 21.00812],
              [80.029099, 21.007843],
              [80.032363, 21.006597],
              [80.034684, 21.006002],
              [80.037329, 21.004713],
              [80.039777, 21.003057],
              [80.043402, 21.00278],
              [80.047615, 21.003055],
              [80.048694, 21.005354],
              [80.049968, 21.007286],
              [80.051145, 21.009401],
              [80.052224, 21.013633],
              [80.056244, 21.019059],
              [80.066734, 21.029543],
              [80.068302, 21.030186],
              [80.06899, 21.033406],
              [80.071833, 21.036072],
              [80.076245, 21.039106],
              [80.078817, 21.040614],
              [80.082109, 21.042735],
              [80.083303, 21.043518],
              [80.085755, 21.046001],
              [80.087031, 21.048208],
              [80.08419, 21.051338],
              [80.081251, 21.052444],
              [80.078703, 21.054539],
              [80.078116, 21.055021],
              [80.077431, 21.05723],
              [80.082727, 21.062839],
              [80.082124, 21.069913],
              [80.081867, 21.076688],
              [80.081661, 21.081332],
              [80.080977, 21.085013],
              [80.07843, 21.08943],
              [80.078431, 21.091086],
              [80.081082, 21.097157],
              [80.080986, 21.100193],
              [80.078045, 21.101391],
              [80.075496, 21.101484],
              [80.071048, 21.101066],
              [80.064989, 21.100899],
              [80.063828, 21.100938],
              [80.061966, 21.102042],
              [80.061281, 21.105355],
              [80.062951, 21.111702],
              [80.064521, 21.114462],
              [80.070014, 21.11722],
              [80.072368, 21.118875],
              [80.072958, 21.120898],
              [80.07305, 21.122054],
              [80.072964, 21.131571],
              [80.073456, 21.134975],
              [80.075026, 21.136907],
              [80.080073, 21.140524],
              [80.083661, 21.143434],
              [80.081523, 21.149173],
              [80.080767, 21.151295],
              [80.080038, 21.153557],
              [80.078599, 21.155143],
              [80.077396, 21.156666],
              [80.076172, 21.158638],
              [80.074256, 21.162209],
              [80.06987, 21.167381],
              [80.06642, 21.170971],
              [80.062588, 21.174359],
              [80.061217, 21.179053],
              [80.062395, 21.180892],
              [80.063181, 21.18356],
              [80.063183, 21.18586],
              [80.062573, 21.18876],
              [80.060456, 21.195302],
              [80.059852, 21.197363],
              [80.058283, 21.199664],
              [80.056424, 21.200287],
              [80.052986, 21.201966],
              [80.052202, 21.205187],
              [80.051124, 21.208316],
              [80.049751, 21.210248],
              [80.045826, 21.210158],
              [80.03984, 21.209239],
              [80.036112, 21.213197],
              [80.030323, 21.215038],
              [80.027771, 21.216695],
              [80.027183, 21.219547],
              [80.026988, 21.224056],
              [80.023703, 21.225289],
              [80.023063, 21.225529],
              [80.020181, 21.223339],
              [80.019431, 21.222769],
              [80.015996, 21.220561],
              [80.01158, 21.217433],
              [80.008047, 21.216053],
              [80.00471, 21.217249],
              [80.003435, 21.21817],
              [80, 21.220194],
              [79.996075, 21.223782],
              [79.991658, 21.229947],
              [79.971637, 21.228104],
              [79.956914, 21.235094],
              [79.952103, 21.238865],
              [79.94189, 21.252203],
              [79.922846, 21.253299],
              [79.905579, 21.240499],
              [79.901654, 21.240405],
              [79.89566, 21.248866],
              [79.889083, 21.248585],
              [79.887313, 21.252448],
              [79.87966, 21.24913],
              [79.867392, 21.247279],
              [79.864647, 21.244425],
              [79.864554, 21.239732],
              [79.86947, 21.230627],
              [79.868981, 21.228878],
              [79.860245, 21.23025],
              [79.856026, 21.228774],
              [79.852885, 21.230059],
              [79.848963, 21.226651],
              [79.836895, 21.224154],
              [79.832472, 21.229578],
              [79.848353, 21.245053],
              [79.8456, 21.248455],
              [79.841868, 21.250935],
              [79.842648, 21.255077],
              [79.85433, 21.253892],
              [79.85679, 21.248926],
              [79.861596, 21.252243],
              [79.865524, 21.250866],
              [79.865418, 21.258227],
              [79.847847, 21.258303],
              [79.833219, 21.259759],
              [79.830655, 21.268222],
              [79.826039, 21.270333],
              [79.827794, 21.278984],
              [79.837509, 21.283136],
              [79.835932, 21.288011],
              [79.833672, 21.289389],
              [79.828468, 21.289659],
              [79.829928, 21.299691],
              [79.834933, 21.301445],
              [79.837974, 21.304392],
              [79.838855, 21.306418],
              [79.838752, 21.31019],
              [79.835708, 21.309911],
              [79.834436, 21.306689],
              [79.827058, 21.316343],
              [79.823031, 21.31689],
              [79.815372, 21.315869],
              [79.815252, 21.331328],
              [79.811318, 21.33528],
              [79.812194, 21.340894],
              [79.811695, 21.346231],
              [79.814248, 21.34697],
              [79.813062, 21.35249],
              [79.811197, 21.351015],
              [79.808343, 21.355152],
              [79.806087, 21.352849],
              [79.801658, 21.357996],
              [79.797813, 21.367285],
              [79.799468, 21.376858],
              [79.80251, 21.379439],
              [79.819794, 21.386362],
              [79.836199, 21.397421],
              [79.842149, 21.401431],
              [79.851603, 21.409863],
              [79.870564, 21.41577],
              [79.878423, 21.42001],
              [79.883038, 21.42443],
              [79.88116, 21.436116],
              [79.884204, 21.440628],
              [79.889704, 21.445325],
              [79.892158, 21.450481],
              [79.899476, 21.45845],
              [79.902641, 21.461746],
              [79.918451, 21.475814],
              [79.923893, 21.481881],
              [79.925857, 21.486484],
              [79.929685, 21.498357],
              [79.929977, 21.503879],
              [79.928399, 21.512069],
              [79.924381, 21.519877],
              [79.92223, 21.524148],
              [79.924715, 21.539886],
              [79.927653, 21.545771],
              [79.933594, 21.5533],
              [79.937462, 21.555192],
              [79.942816, 21.55637],
              [79.953526, 21.554832],
              [79.967897, 21.557595],
              [79.9727, 21.556869],
              [79.978225, 21.554723],
              [79.992042, 21.536426],
              [80.000012, 21.534369],
              [80.00316, 21.534972],
              [80.004655, 21.5363],
              [80.008546, 21.538635],
              [80.011234, 21.540528],
              [80.013952, 21.542231],
              [80.016481, 21.544244],
              [80.018711, 21.545635],
              [80.021142, 21.547011],
              [80.023373, 21.548504],
              [80.025616, 21.550447],
              [80.029141, 21.553475],
              [80.032671, 21.556311],
              [80.034718, 21.556998],
              [80.038484, 21.557223],
              [80.040894, 21.557135],
              [80.044908, 21.556524],
              [80.048066, 21.55592],
              [80.050542, 21.554822],
              [80.052082, 21.554419],
              [80.054679, 21.553833],
              [80.056588, 21.553803],
              [80.057257, 21.553803],
              [80.06071, 21.553231],
              [80.06372, 21.553289],
              [80.066168, 21.553412],
              [80.067698, 21.553699],
              [80.06865, 21.553931],
              [80.070081, 21.55428],
              [80.073118, 21.556538],
              [80.074983, 21.558164],
              [80.076551, 21.560071],
              [80.077688, 21.561688],
              [80.079864, 21.563545],
              [80.081616, 21.564828],
              [80.08355, 21.566456],
              [80.085298, 21.568089],
              [80.088557, 21.571453],
              [80.091367, 21.57586],
              [80.093221, 21.57824],
              [80.096217, 21.581959],
              [80.09736, 21.583244],
              [80.099844, 21.585051],
              [80.10056, 21.585983],
              [80.102866, 21.587106],
              [80.105288, 21.588351],
              [80.106941, 21.588426],
              [80.108644, 21.589083],
              [80.112162, 21.590795],
              [80.11447, 21.591798],
              [80.116459, 21.593095],
              [80.118128, 21.59616],
              [80.118755, 21.599225],
              [80.118973, 21.600488],
              [80.119424, 21.603439],
              [80.121513, 21.606686],
              [80.125147, 21.608573],
              [80.128018, 21.608729],
              [80.130653, 21.608301],
              [80.132794, 21.607977],
              [80.139555, 21.605299],
              [80.144087, 21.604895],
              [80.147273, 21.60442],
              [80.150509, 21.604679],
              [80.154457, 21.605998],
              [80.156577, 21.607121],
              [80.159232, 21.609399],
              [80.161585, 21.611499],
              [80.163325, 21.613821],
              [80.166506, 21.6172],
              [80.168684, 21.619188],
              [80.171585, 21.621414],
              [80.175532, 21.622896],
              [80.17772, 21.623439],
              [80.17998, 21.623816],
              [80.181508, 21.62366],
              [80.183339, 21.623625],
              [80.186919, 21.625225],
              [80.188976, 21.626741],
              [80.190305, 21.628202],
              [80.191802, 21.630347],
              [80.192809, 21.632373],
              [80.194824, 21.633898],
              [80.196025, 21.63395],
              [80.198718, 21.634324],
              [80.201766, 21.634644],
              [80.207025, 21.634411],
              [80.211325, 21.633257],
              [80.214616, 21.629375],
              [80.217055, 21.626008],
              [80.218666, 21.623956],
              [80.221277, 21.620986],
              [80.222941, 21.620086],
              [80.227234, 21.619382],
              [80.233517, 21.619861],
              [80.23871, 21.620207],
              [80.242624, 21.620537],
              [80.246782, 21.620291],
              [80.249351, 21.620266],
              [80.254277, 21.622275],
              [80.258738, 21.622031],
              [80.261939, 21.620513],
              [80.263294, 21.620069],
              [80.266898, 21.619934],
              [80.27166, 21.616364],
              [80.277546, 21.610437],
              [80.279057, 21.60694],
              [80.280406, 21.602464],
              [80.282106, 21.59892],
              [80.286484, 21.595971],
              [80.289498, 21.594964],
              [80.293251, 21.593287],
              [80.294673, 21.592143],
              [80.295317, 21.589507],
              [80.295767, 21.588298],
              [80.296467, 21.585775],
              [80.296942, 21.582502],
              [80.298597, 21.577911],
              [80.302055, 21.575364],
              [80.305774, 21.575285],
              [80.310047, 21.576024],
              [80.314319, 21.576643],
              [80.316566, 21.577239],
              [80.319687, 21.576989],
              [80.323622, 21.575586],
              [80.325536, 21.574457],
              [80.326887, 21.573497],
              [80.328094, 21.57051],
              [80.329543, 21.567359],
              [80.331355, 21.56404],
              [80.332982, 21.561526],
              [80.334167, 21.559579],
              [80.335285, 21.55821],
              [80.336471, 21.556263],
              [80.336796, 21.554656],
              [80.335778, 21.553614],
              [80.333973, 21.551697],
              [80.332277, 21.550297],
              [80.331136, 21.548675],
              [80.334101, 21.546057],
              [80.336386, 21.544407],
              [80.337683, 21.543675],
              [80.339659, 21.542198],
              [80.341871, 21.540723],
              [80.344711, 21.538737],
              [80.346374, 21.537889],
              [80.349007, 21.537405],
              [80.353131, 21.535718],
              [80.358606, 21.533008],
              [80.363639, 21.530817],
              [80.368922, 21.528508],
              [80.372558, 21.526367],
              [80.374348, 21.524712],
              [80.375964, 21.522944],
              [80.377335, 21.520998],
              [80.37753, 21.517917],
              [80.37758, 21.517135],
              [80.377899, 21.515197],
              [80.379215, 21.512844],
              [80.38029, 21.509515],
              [80.380599, 21.505147],
              [80.380623, 21.503132],
              [80.380952, 21.501175],
              [80.381285, 21.499053],
              [80.381566, 21.495999],
              [80.38159, 21.494915],
              [80.381673, 21.492955],
              [80.382068, 21.491228],
              [80.382533, 21.491032],
              [80.384401, 21.490224],
              [80.385326, 21.489423],
              [80.386945, 21.487369],
              [80.388439, 21.48491],
              [80.389453, 21.482557],
              [80.390409, 21.479114],
              [80.391177, 21.476471],
              [80.393602, 21.473561],
              [80.396682, 21.471064],
              [80.398843, 21.469531],
              [80.402039, 21.46801],
              [80.403322, 21.467388],
              [80.405783, 21.466549],
              [80.407692, 21.465584],
              [80.408993, 21.463528],
              [80.410425, 21.461472],
              [80.411264, 21.458776],
              [80.41141, 21.456532],
              [80.412112, 21.454579],
              [80.413183, 21.451369],
              [80.415009, 21.447412],
              [80.416221, 21.443799],
              [80.417297, 21.440358],
              [80.418057, 21.438408],
              [80.416987, 21.436609],
              [80.415353, 21.435038],
              [80.412758, 21.432655],
              [80.41101, 21.430906],
              [80.408358, 21.428291],
              [80.405653, 21.425153],
              [80.404763, 21.423301],
              [80.406703, 21.419698],
              [80.405983, 21.418133],
              [80.403518, 21.415577],
              [80.4002, 21.412892],
              [80.396638, 21.409116],
              [80.395811, 21.407607],
              [80.395789, 21.404561],
              [80.396558, 21.401108],
              [80.39827, 21.396875],
              [80.400644, 21.392401],
              [80.403272, 21.388113],
              [80.404663, 21.384382],
              [80.406111, 21.380771],
              [80.407848, 21.378544],
              [80.408709, 21.378093],
              [80.410129, 21.376782],
              [80.411179, 21.376103],
              [80.413303, 21.376698],
              [80.415203, 21.376377],
              [80.417038, 21.37576],
              [80.420833, 21.37557],
              [80.424356, 21.375947],
              [80.427716, 21.375983],
              [80.429737, 21.375545],
              [80.431699, 21.37481],
              [80.433613, 21.373394],
              [80.434342, 21.373227],
              [80.437234, 21.372217],
              [80.440297, 21.371502],
              [80.442371, 21.371579],
              [80.444009, 21.371708],
              [80.447173, 21.37243],
              [80.449718, 21.374132],
              [80.450415, 21.376725],
              [80.450505, 21.380012],
              [80.450062, 21.384957],
              [80.449966, 21.388298],
              [80.451036, 21.390839],
              [80.452347, 21.392869],
              [80.453836, 21.395873],
              [80.454411, 21.398761],
              [80.455093, 21.402624],
              [80.457471, 21.402647],
              [80.46012, 21.40066],
              [80.461533, 21.399975],
              [80.463136, 21.399015],
              [80.466948, 21.397324],
              [80.469638, 21.396662],
              [80.471108, 21.396216],
              [80.473549, 21.395891],
              [80.474957, 21.395564],
              [80.478136, 21.396169],
              [80.48065, 21.399644],
              [80.481546, 21.396082],
              [80.482414, 21.39506],
              [80.485759, 21.396245],
              [80.488245, 21.3973],
              [80.490747, 21.397612],
              [80.492276, 21.397975],
              [80.496683, 21.396695],
              [80.500245, 21.394594],
              [80.503129, 21.393299],
              [80.507368, 21.391152],
              [80.509691, 21.390944],
              [80.5125, 21.391091],
              [80.515668, 21.391462],
              [80.518226, 21.392233],
              [80.521527, 21.3914],
              [80.52331, 21.390904],
              [80.52625, 21.389957],
              [80.527188, 21.388641],
              [80.528476, 21.387732],
              [80.531021, 21.384122],
              [80.533678, 21.382077],
              [80.536554, 21.381361],
              [80.538856, 21.377692],
              [80.539924, 21.375282],
              [80.541055, 21.372478],
              [80.54371, 21.369567],
              [80.546469, 21.368959],
              [80.547759, 21.368566],
              [80.551061, 21.367735],
              [80.552604, 21.366708],
              [80.557071, 21.365196],
              [80.562045, 21.363174],
              [80.565048, 21.361757],
              [80.565846, 21.361599],
              [80.56653, 21.360852],
              [80.571009, 21.358364],
              [80.570609, 21.356224],
              [80.567941, 21.354883],
              [80.565215, 21.353642],
              [80.564874, 21.351513],
              [80.566669, 21.349054],
              [80.56738, 21.34595],
              [80.568198, 21.343824],
              [80.571015, 21.343279],
              [80.573205, 21.343301],
              [80.575938, 21.344937],
              [80.578606, 21.346112],
              [80.582291, 21.344308],
              [80.584736, 21.343521],
              [80.587131, 21.342624],
              [80.588482, 21.34211],
              [80.589265, 21.337747],
              [80.588747, 21.334862],
              [80.589941, 21.331708],
              [80.593562, 21.33001],
              [80.596324, 21.328886],
              [80.598119, 21.327293],
              [80.600026, 21.325351],
              [80.604253, 21.324064],
              [80.60627, 21.323798],
              [80.609202, 21.324286],
              [80.61218, 21.324883],
              [80.615356, 21.324507],
              [80.61696, 21.323198],
              [80.617825, 21.322286],
              [80.619854, 21.320923],
              [80.624629, 21.319762],
              [80.627546, 21.320764],
              [80.630155, 21.322058],
              [80.631791, 21.322412],
              [80.635211, 21.323189],
              [80.638666, 21.324315],
              [80.640428, 21.324791],
              [80.645067, 21.325468],
              [80.651278, 21.326095],
              [80.655179, 21.326996],
              [80.657333, 21.330529],
              [80.658655, 21.331802],
              [80.663424, 21.331383],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 205,
        censuscode: 507,
        dt_cen_cd: 11,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Gondiya",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [76.995371, 18.827376],
              [77.000048, 18.81915],
              [77.001013, 18.8181],
              [77.001302, 18.809817],
              [77.005136, 18.788477],
              [77.008128, 18.767097],
              [77.025577, 18.767107],
              [77.046615, 18.773075],
              [77.053382, 18.772522],
              [77.056849, 18.765842],
              [77.054481, 18.745857],
              [77.054674, 18.738821],
              [77.057577, 18.729863],
              [77.056996, 18.718174],
              [77.052102, 18.716542],
              [77.044645, 18.698012],
              [77.044408, 18.694753],
              [77.046845, 18.689802],
              [77.046547, 18.682998],
              [77.059749, 18.683413],
              [77.067461, 18.682503],
              [77.067723, 18.686398],
              [77.080611, 18.69015],
              [77.095054, 18.691219],
              [77.100786, 18.694374],
              [77.119086, 18.695337],
              [77.136313, 18.698338],
              [77.136628, 18.710881],
              [77.146103, 18.712156],
              [77.149831, 18.706026],
              [77.157051, 18.701407],
              [77.166256, 18.703479],
              [77.182134, 18.702447],
              [77.194364, 18.689459],
              [77.186483, 18.685686],
              [77.177807, 18.679691],
              [77.159382, 18.680375],
              [77.157753, 18.67182],
              [77.157487, 18.657306],
              [77.155839, 18.646344],
              [77.178003, 18.648703],
              [77.199785, 18.647238],
              [77.201347, 18.643459],
              [77.205476, 18.638628],
              [77.208852, 18.638233],
              [77.212314, 18.635148],
              [77.214194, 18.624819],
              [77.251447, 18.617867],
              [77.270621, 18.610964],
              [77.267922, 18.591077],
              [77.27058, 18.584233],
              [77.267377, 18.580825],
              [77.266658, 18.565471],
              [77.275311, 18.562225],
              [77.280767, 18.559242],
              [77.288039, 18.552756],
              [77.296487, 18.547334],
              [77.290089, 18.542365],
              [77.287984, 18.537617],
              [77.287527, 18.531434],
              [77.277346, 18.520223],
              [77.271228, 18.521789],
              [77.247292, 18.49912],
              [77.248519, 18.491111],
              [77.251957, 18.482282],
              [77.264296, 18.480981],
              [77.265785, 18.476688],
              [77.274899, 18.474858],
              [77.269461, 18.459368],
              [77.268733, 18.455233],
              [77.268332, 18.452971],
              [77.256508, 18.453628],
              [77.256002, 18.447793],
              [77.264119, 18.44151],
              [77.267575, 18.431306],
              [77.267413, 18.419783],
              [77.261212, 18.411829],
              [77.251954, 18.40965],
              [77.243027, 18.410041],
              [77.239215, 18.401209],
              [77.235662, 18.38755],
              [77.247861, 18.372023],
              [77.244454, 18.367829],
              [77.233612, 18.367021],
              [77.224162, 18.348665],
              [77.230057, 18.346359],
              [77.225766, 18.339265],
              [77.2197, 18.326369],
              [77.212734, 18.315224],
              [77.202895, 18.320638],
              [77.198151, 18.31418],
              [77.200385, 18.297022],
              [77.207212, 18.291985],
              [77.208955, 18.279489],
              [77.201571, 18.280746],
              [77.194399, 18.275806],
              [77.18054, 18.283344],
              [77.173206, 18.28236],
              [77.170054, 18.274946],
              [77.168358, 18.257439],
              [77.159874, 18.2546],
              [77.154043, 18.239463],
              [77.150414, 18.239177],
              [77.150338, 18.222945],
              [77.153298, 18.22308],
              [77.152642, 18.218113],
              [77.144846, 18.2176],
              [77.14213, 18.208794],
              [77.133768, 18.20773],
              [77.123563, 18.208245],
              [77.119188, 18.203954],
              [77.109158, 18.203336],
              [77.098066, 18.19663],
              [77.105487, 18.187866],
              [77.118902, 18.169183],
              [77.111458, 18.154287],
              [77.099161, 18.159713],
              [77.091793, 18.157541],
              [77.0887, 18.151859],
              [77.0716, 18.151004],
              [77.060112, 18.153914],
              [77.060116, 18.157472],
              [77.052742, 18.162813],
              [77.051882, 18.174726],
              [77.040498, 18.182814],
              [77.035205, 18.185268],
              [77.032691, 18.180834],
              [77.024054, 18.179708],
              [77.026357, 18.16419],
              [77.00006, 18.168337],
              [76.997572, 18.174802],
              [76.997769, 18.179854],
              [76.995234, 18.183503],
              [76.993738, 18.188103],
              [76.990149, 18.189926],
              [76.982791, 18.190833],
              [76.982097, 18.188835],
              [76.961016, 18.187565],
              [76.956292, 18.186312],
              [76.953138, 18.17391],
              [76.945915, 18.156186],
              [76.935509, 18.159342],
              [76.927487, 18.146268],
              [76.929804, 18.141311],
              [76.9339, 18.13805],
              [76.932126, 18.133714],
              [76.926297, 18.125936],
              [76.924404, 18.12166],
              [76.924682, 18.117587],
              [76.934307, 18.112479],
              [76.944699, 18.112917],
              [76.955596, 18.111623],
              [76.960791, 18.107947],
              [76.97052, 18.098648],
              [76.969594, 18.094184],
              [76.966556, 18.089762],
              [76.957042, 18.086904],
              [76.951938, 18.083876],
              [76.949236, 18.075315],
              [76.951695, 18.069833],
              [76.954879, 18.06498],
              [76.952829, 18.059846],
              [76.950666, 18.05025],
              [76.950843, 18.047322],
              [76.956554, 18.044325],
              [76.95686, 18.041283],
              [76.954288, 18.039313],
              [76.940835, 18.038823],
              [76.919862, 18.034808],
              [76.921551, 18.023603],
              [76.922407, 18.01536],
              [76.919814, 18.01394],
              [76.920324, 18.003483],
              [76.920645, 18.000322],
              [76.919759, 17.997879],
              [76.92183, 17.992263],
              [76.921749, 17.987015],
              [76.920389, 17.974505],
              [76.919438, 17.962145],
              [76.915379, 17.938902],
              [76.921368, 17.938358],
              [76.920518, 17.924819],
              [76.918616, 17.916813],
              [76.915361, 17.915517],
              [76.902356, 17.916396],
              [76.89872, 17.909731],
              [76.895792, 17.90908],
              [76.894518, 17.904562],
              [76.891486, 17.898899],
              [76.88531, 17.898794],
              [76.883261, 17.89477],
              [76.877335, 17.894445],
              [76.873926, 17.896435],
              [76.855848, 17.899526],
              [76.848928, 17.898084],
              [76.833717, 17.892342],
              [76.835044, 17.884437],
              [76.8223, 17.886117],
              [76.819058, 17.884766],
              [76.812984, 17.885753],
              [76.81014, 17.884754],
              [76.807256, 17.875876],
              [76.808145, 17.872167],
              [76.804683, 17.869999],
              [76.79933, 17.87101],
              [76.776376, 17.878614],
              [76.775065, 17.880302],
              [76.775616, 17.883871],
              [76.77492, 17.88678],
              [76.77194, 17.893974],
              [76.76774, 17.900042],
              [76.744679, 17.900606],
              [76.742381, 17.899597],
              [76.739314, 17.903796],
              [76.735822, 17.911101],
              [76.726963, 17.913718],
              [76.72434, 17.917824],
              [76.718864, 17.91695],
              [76.684525, 17.918747],
              [76.675592, 17.921965],
              [76.676068, 17.925945],
              [76.681858, 17.946276],
              [76.677274, 17.949521],
              [76.675914, 17.952912],
              [76.674, 17.966912],
              [76.679954, 17.970017],
              [76.689522, 17.970408],
              [76.68947, 17.976598],
              [76.68533, 17.98749],
              [76.681581, 17.992657],
              [76.680181, 17.993872],
              [76.676805, 17.996813],
              [76.670695, 17.998602],
              [76.662389, 17.999418],
              [76.625493, 17.999847],
              [76.623952, 18.000744],
              [76.607382, 18.01044],
              [76.610079, 18.019693],
              [76.612401, 18.037885],
              [76.606204, 18.035833],
              [76.602613, 18.032839],
              [76.596688, 18.032796],
              [76.589098, 18.03815],
              [76.582029, 18.040127],
              [76.577773, 18.036732],
              [76.568141, 18.038965],
              [76.557044, 18.029748],
              [76.547586, 18.024178],
              [76.54014, 18.023114],
              [76.53267, 18.021011],
              [76.529505, 18.02271],
              [76.525039, 18.021214],
              [76.522489, 18.024275],
              [76.517669, 18.023242],
              [76.512751, 18.02438],
              [76.502925, 18.02271],
              [76.494268, 18.023377],
              [76.486844, 18.026439],
              [76.482341, 18.026829],
              [76.478412, 18.026068],
              [76.473123, 18.026182],
              [76.441727, 18.032989],
              [76.428392, 18.030374],
              [76.424702, 18.033794],
              [76.418841, 18.041709],
              [76.408587, 18.045191],
              [76.405181, 18.047125],
              [76.402818, 18.050871],
              [76.399295, 18.053031],
              [76.39959, 18.062536],
              [76.398501, 18.066624],
              [76.386911, 18.080494],
              [76.381765, 18.089306],
              [76.370385, 18.087993],
              [76.358583, 18.083925],
              [76.347824, 18.078989],
              [76.342691, 18.078582],
              [76.331287, 18.074216],
              [76.323862, 18.074867],
              [76.321335, 18.076549],
              [76.315044, 18.084232],
              [76.312162, 18.08615],
              [76.308378, 18.091002],
              [76.305754, 18.096122],
              [76.306448, 18.103799],
              [76.305698, 18.108561],
              [76.303027, 18.11409],
              [76.301449, 18.11646],
              [76.295863, 18.121731],
              [76.283153, 18.129075],
              [76.277029, 18.139453],
              [76.277514, 18.143169],
              [76.279666, 18.14585],
              [76.279195, 18.150383],
              [76.281592, 18.154256],
              [76.282004, 18.16176],
              [76.281106, 18.17203],
              [76.282132, 18.182044],
              [76.295158, 18.199055],
              [76.296149, 18.20673],
              [76.298162, 18.213818],
              [76.302445, 18.213368],
              [76.302135, 18.22971],
              [76.297692, 18.231924],
              [76.292198, 18.231694],
              [76.286783, 18.232603],
              [76.283335, 18.248401],
              [76.287014, 18.248423],
              [76.289234, 18.252702],
              [76.294001, 18.258266],
              [76.307303, 18.265361],
              [76.311262, 18.269624],
              [76.308156, 18.272],
              [76.311473, 18.277186],
              [76.316294, 18.281721],
              [76.31853, 18.29317],
              [76.319528, 18.311381],
              [76.31865, 18.328978],
              [76.285216, 18.340701],
              [76.287504, 18.355868],
              [76.289601, 18.379119],
              [76.288289, 18.385831],
              [76.282175, 18.384861],
              [76.275356, 18.380173],
              [76.27041, 18.375749],
              [76.26392, 18.368356],
              [76.259216, 18.364564],
              [76.255255, 18.366604],
              [76.249008, 18.37509],
              [76.243293, 18.377208],
              [76.237072, 18.377258],
              [76.230681, 18.378293],
              [76.216834, 18.382379],
              [76.207647, 18.38779],
              [76.201394, 18.395247],
              [76.200343, 18.398695],
              [76.211779, 18.400188],
              [76.219569, 18.414906],
              [76.222196, 18.42251],
              [76.225951, 18.428889],
              [76.233071, 18.43329],
              [76.239316, 18.434378],
              [76.256993, 18.426998],
              [76.266903, 18.421517],
              [76.271659, 18.420041],
              [76.267573, 18.437105],
              [76.26347, 18.463842],
              [76.268318, 18.464545],
              [76.272427, 18.464273],
              [76.271928, 18.467889],
              [76.269874, 18.473189],
              [76.256798, 18.48242],
              [76.255276, 18.486042],
              [76.258036, 18.489684],
              [76.258927, 18.49363],
              [76.256104, 18.495265],
              [76.256477, 18.50569],
              [76.255298, 18.518828],
              [76.257983, 18.526031],
              [76.268213, 18.532174],
              [76.27482, 18.538416],
              [76.276348, 18.544821],
              [76.276918, 18.556972],
              [76.277061, 18.563955],
              [76.278031, 18.569227],
              [76.279962, 18.574305],
              [76.282328, 18.5748],
              [76.289215, 18.574049],
              [76.292379, 18.575273],
              [76.295449, 18.573985],
              [76.299578, 18.57039],
              [76.30711, 18.567623],
              [76.311511, 18.566894],
              [76.321891, 18.569837],
              [76.326001, 18.569168],
              [76.335605, 18.563109],
              [76.342984, 18.563264],
              [76.347305, 18.565569],
              [76.352128, 18.56444],
              [76.362096, 18.558604],
              [76.36488, 18.554222],
              [76.368282, 18.545418],
              [76.373755, 18.543239],
              [76.377497, 18.542574],
              [76.381375, 18.543511],
              [76.384758, 18.542961],
              [76.387708, 18.541494],
              [76.40575, 18.548312],
              [76.412685, 18.550584],
              [76.424018, 18.552823],
              [76.432558, 18.544192],
              [76.439662, 18.541881],
              [76.441022, 18.530409],
              [76.446927, 18.528401],
              [76.453776, 18.524776],
              [76.45856, 18.511716],
              [76.463294, 18.50845],
              [76.465373, 18.505389],
              [76.468006, 18.498713],
              [76.468278, 18.496308],
              [76.471632, 18.493865],
              [76.476884, 18.493181],
              [76.481443, 18.49044],
              [76.486734, 18.48368],
              [76.491639, 18.484652],
              [76.496688, 18.482361],
              [76.500394, 18.479003],
              [76.503948, 18.477757],
              [76.511388, 18.469196],
              [76.52028, 18.469846],
              [76.530036, 18.471686],
              [76.531985, 18.468463],
              [76.53665, 18.468985],
              [76.539335, 18.466376],
              [76.543241, 18.464437],
              [76.549055, 18.465294],
              [76.55152, 18.468358],
              [76.548586, 18.470914],
              [76.548591, 18.475789],
              [76.549446, 18.485292],
              [76.552267, 18.496669],
              [76.557583, 18.496775],
              [76.568593, 18.492929],
              [76.568982, 18.49041],
              [76.566924, 18.47639],
              [76.565289, 18.472336],
              [76.566623, 18.468135],
              [76.569479, 18.464552],
              [76.572352, 18.462737],
              [76.583381, 18.459986],
              [76.593224, 18.459245],
              [76.600848, 18.455485],
              [76.605181, 18.454635],
              [76.609125, 18.455164],
              [76.619087, 18.463136],
              [76.629805, 18.464335],
              [76.630507, 18.475614],
              [76.624119, 18.477062],
              [76.623557, 18.479823],
              [76.619337, 18.480733],
              [76.617681, 18.483382],
              [76.618064, 18.489169],
              [76.618852, 18.493513],
              [76.624629, 18.500442],
              [76.630172, 18.503755],
              [76.631942, 18.513423],
              [76.640821, 18.525534],
              [76.643358, 18.525156],
              [76.643148, 18.519319],
              [76.648096, 18.518113],
              [76.652836, 18.515309],
              [76.649094, 18.503433],
              [76.648483, 18.494095],
              [76.648566, 18.487212],
              [76.652251, 18.486943],
              [76.652607, 18.482127],
              [76.676005, 18.482366],
              [76.683288, 18.493057],
              [76.687718, 18.498283],
              [76.696693, 18.499606],
              [76.699475, 18.500267],
              [76.702001, 18.532845],
              [76.705594, 18.547194],
              [76.697405, 18.549581],
              [76.692702, 18.55021],
              [76.680191, 18.554992],
              [76.674545, 18.553918],
              [76.659711, 18.54423],
              [76.653054, 18.543905],
              [76.633615, 18.551004],
              [76.63792, 18.564022],
              [76.643475, 18.572155],
              [76.647927, 18.583223],
              [76.656801, 18.581811],
              [76.662744, 18.59171],
              [76.673991, 18.62471],
              [76.671882, 18.629777],
              [76.674215, 18.632385],
              [76.679746, 18.634045],
              [76.682335, 18.636994],
              [76.682033, 18.641234],
              [76.684892, 18.646873],
              [76.665357, 18.656048],
              [76.676701, 18.674886],
              [76.681204, 18.684285],
              [76.68579, 18.691859],
              [76.687725, 18.692352],
              [76.698857, 18.6913],
              [76.702495, 18.691891],
              [76.712618, 18.697387],
              [76.720216, 18.699017],
              [76.730697, 18.695626],
              [76.732461, 18.696349],
              [76.736326, 18.699803],
              [76.737386, 18.702254],
              [76.735624, 18.713734],
              [76.735477, 18.719981],
              [76.733352, 18.724251],
              [76.731495, 18.725653],
              [76.730344, 18.729671],
              [76.730191, 18.735294],
              [76.727261, 18.738479],
              [76.727116, 18.749263],
              [76.730677, 18.749922],
              [76.736018, 18.754557],
              [76.739488, 18.759962],
              [76.745526, 18.774153],
              [76.753129, 18.772291],
              [76.76198, 18.773038],
              [76.767145, 18.774349],
              [76.774177, 18.774498],
              [76.781782, 18.776584],
              [76.783533, 18.780118],
              [76.784104, 18.793463],
              [76.790994, 18.796589],
              [76.801154, 18.799389],
              [76.816467, 18.79943],
              [76.818754, 18.802605],
              [76.825919, 18.808368],
              [76.832021, 18.811445],
              [76.839137, 18.813704],
              [76.844677, 18.81209],
              [76.854152, 18.806699],
              [76.856489, 18.813429],
              [76.859972, 18.819683],
              [76.86608, 18.81984],
              [76.872605, 18.828295],
              [76.881619, 18.828644],
              [76.884419, 18.830321],
              [76.885147, 18.834781],
              [76.907134, 18.835936],
              [76.941422, 18.832676],
              [76.955428, 18.832614],
              [76.963549, 18.830327],
              [76.995371, 18.827376],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 337,
        censuscode: 524,
        dt_cen_cd: 28,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Latur",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [74.833877, 18.339199],
              [74.832659, 18.329084],
              [74.836698, 18.320724],
              [74.84378, 18.309636],
              [74.846337, 18.299888],
              [74.842346, 18.295729],
              [74.836651, 18.294938],
              [74.829072, 18.295524],
              [74.820394, 18.298903],
              [74.804094, 18.301367],
              [74.799606, 18.299339],
              [74.79777, 18.297203],
              [74.795136, 18.284265],
              [74.796566, 18.279276],
              [74.812392, 18.269673],
              [74.819434, 18.262532],
              [74.82601, 18.252752],
              [74.833158, 18.246307],
              [74.842016, 18.243256],
              [74.850414, 18.243655],
              [74.867012, 18.247196],
              [74.876674, 18.247314],
              [74.88113, 18.252626],
              [74.887986, 18.257438],
              [74.895179, 18.258978],
              [74.906051, 18.259107],
              [74.915904, 18.257992],
              [74.922504, 18.258401],
              [74.935401, 18.260407],
              [74.944865, 18.262991],
              [74.951108, 18.263428],
              [74.955209, 18.260932],
              [74.964, 18.252723],
              [74.976194, 18.245913],
              [74.986142, 18.241412],
              [74.99318, 18.240984],
              [74.99647, 18.242389],
              [75.000028, 18.242714],
              [75.013117, 18.247807],
              [75.031613, 18.258405],
              [75.03663, 18.261967],
              [75.041375, 18.263126],
              [75.044723, 18.26212],
              [75.046002, 18.256332],
              [75.044779, 18.253419],
              [75.037772, 18.246549],
              [75.032042, 18.242367],
              [75.019708, 18.229308],
              [75.014988, 18.223109],
              [75.008547, 18.212053],
              [75.008331, 18.208103],
              [75.013304, 18.198727],
              [75.021985, 18.187482],
              [75.028054, 18.18898],
              [75.032465, 18.193576],
              [75.036557, 18.195597],
              [75.043633, 18.195308],
              [75.049395, 18.1968],
              [75.054135, 18.196353],
              [75.059365, 18.197563],
              [75.073143, 18.211467],
              [75.082006, 18.217915],
              [75.097151, 18.221151],
              [75.102063, 18.220528],
              [75.105886, 18.217916],
              [75.109635, 18.214337],
              [75.111642, 18.210768],
              [75.114196, 18.199513],
              [75.110874, 18.188433],
              [75.110017, 18.178544],
              [75.103446, 18.167148],
              [75.095326, 18.156055],
              [75.091654, 18.146016],
              [75.091775, 18.138227],
              [75.093403, 18.131392],
              [75.093804, 18.122232],
              [75.095285, 18.119749],
              [75.098695, 18.118404],
              [75.109851, 18.119156],
              [75.118351, 18.118105],
              [75.130543, 18.119821],
              [75.139135, 18.122599],
              [75.145788, 18.123339],
              [75.158062, 18.120982],
              [75.162783, 18.118762],
              [75.163896, 18.115544],
              [75.163717, 18.113389],
              [75.163165, 18.106508],
              [75.159418, 18.102589],
              [75.155747, 18.100453],
              [75.143355, 18.095766],
              [75.137626, 18.09158],
              [75.134229, 18.087033],
              [75.132422, 18.077715],
              [75.130303, 18.075387],
              [75.121307, 18.073986],
              [75.115858, 18.074897],
              [75.109135, 18.073699],
              [75.096872, 18.069519],
              [75.092296, 18.066129],
              [75.090722, 18.063733],
              [75.08639, 18.045854],
              [75.083784, 18.042041],
              [75.077144, 18.03557],
              [75.062539, 18.029294],
              [75.057413, 18.024877],
              [75.052642, 18.020283],
              [75.044994, 18.006779],
              [75.039191, 18.000109],
              [75.029166, 17.988439],
              [75.025043, 17.981029],
              [75.021523, 17.967355],
              [75.02155, 17.962016],
              [75.034495, 17.952361],
              [75.040346, 17.946738],
              [75.050727, 17.946624],
              [75.059115, 17.951276],
              [75.063676, 17.959128],
              [75.070588, 17.975768],
              [75.079359, 17.978263],
              [75.089269, 17.975966],
              [75.099039, 17.972802],
              [75.102613, 17.973208],
              [75.105346, 17.977126],
              [75.109084, 17.993102],
              [75.113923, 17.997706],
              [75.120092, 17.997876],
              [75.123434, 17.996435],
              [75.126861, 17.992062],
              [75.1293, 17.979209],
              [75.131015, 17.975299],
              [75.135026, 17.969576],
              [75.129461, 17.969124],
              [75.124051, 17.970834],
              [75.119814, 17.971021],
              [75.117355, 17.968466],
              [75.11822, 17.964285],
              [75.125609, 17.961153],
              [75.129483, 17.957957],
              [75.130702, 17.954196],
              [75.127547, 17.950407],
              [75.118481, 17.944909],
              [75.11479, 17.936632],
              [75.11105, 17.934623],
              [75.106392, 17.936452],
              [75.099767, 17.942297],
              [75.088982, 17.940755],
              [75.084543, 17.938729],
              [75.082843, 17.936171],
              [75.082605, 17.932243],
              [75.087381, 17.927329],
              [75.089524, 17.923134],
              [75.083242, 17.918518],
              [75.072253, 17.914303],
              [75.067296, 17.916583],
              [75.058483, 17.925187],
              [75.05264, 17.924388],
              [75.048245, 17.921134],
              [75.046452, 17.917591],
              [75.048368, 17.913735],
              [75.055842, 17.90428],
              [75.054468, 17.90193],
              [75.051453, 17.900558],
              [75.043773, 17.903553],
              [75.039371, 17.903262],
              [75.026846, 17.893025],
              [75.02398, 17.892092],
              [75.020902, 17.894211],
              [75.019765, 17.898921],
              [75.019477, 17.905623],
              [75.017706, 17.907411],
              [75.000028, 17.910443],
              [74.988103, 17.912463],
              [74.981208, 17.915306],
              [74.975274, 17.916069],
              [74.962101, 17.914981],
              [74.956311, 17.921053],
              [74.943457, 17.924695],
              [74.944579, 17.935129],
              [74.943545, 17.937665],
              [74.939094, 17.93992],
              [74.928593, 17.941051],
              [74.917119, 17.944848],
              [74.911298, 17.94486],
              [74.906997, 17.94368],
              [74.898952, 17.937704],
              [74.896621, 17.937398],
              [74.891934, 17.93788],
              [74.887062, 17.940652],
              [74.874865, 17.944678],
              [74.869533, 17.950834],
              [74.867436, 17.950981],
              [74.851774, 17.945623],
              [74.846964, 17.947757],
              [74.844947, 17.952329],
              [74.848196, 17.958333],
              [74.850395, 17.961166],
              [74.858312, 17.967891],
              [74.861339, 17.971589],
              [74.862065, 17.978314],
              [74.865302, 17.985861],
              [74.864556, 17.98998],
              [74.86382, 17.991349],
              [74.859196, 17.993208],
              [74.852528, 17.994692],
              [74.847428, 17.994821],
              [74.838942, 17.991527],
              [74.832694, 17.992681],
              [74.831302, 17.99467],
              [74.830787, 18.000389],
              [74.829804, 18.00517],
              [74.826358, 18.009711],
              [74.822745, 18.013617],
              [74.815857, 18.016658],
              [74.813174, 18.017309],
              [74.810264, 18.016688],
              [74.80985, 18.015988],
              [74.809133, 18.014312],
              [74.808636, 18.011047],
              [74.809499, 18.002435],
              [74.810104, 18.000427],
              [74.810448, 17.999389],
              [74.810252, 17.998378],
              [74.809533, 17.997445],
              [74.808807, 17.996701],
              [74.807384, 17.996569],
              [74.805728, 17.996891],
              [74.803221, 17.997997],
              [74.801434, 18.000232],
              [74.800381, 18.003971],
              [74.79842, 18.006536],
              [74.793904, 18.009032],
              [74.787283, 18.010488],
              [74.783, 18.009875],
              [74.777333, 18.010699],
              [74.774167, 18.013066],
              [74.772397, 18.016348],
              [74.766561, 18.022458],
              [74.763439, 18.02415],
              [74.760068, 18.024057],
              [74.756032, 18.022189],
              [74.751122, 18.018412],
              [74.747892, 18.018556],
              [74.743003, 18.025061],
              [74.730391, 18.028699],
              [74.726671, 18.029359],
              [74.718098, 18.027511],
              [74.712276, 18.02804],
              [74.710008, 18.029332],
              [74.707997, 18.030471],
              [74.70124, 18.036736],
              [74.692582, 18.039089],
              [74.689603, 18.043079],
              [74.686302, 18.059135],
              [74.673162, 18.063391],
              [74.66517, 18.068842],
              [74.656612, 18.068607],
              [74.65435, 18.065374],
              [74.654487, 18.058827],
              [74.649864, 18.052988],
              [74.641104, 18.044535],
              [74.63861, 18.044861],
              [74.633843, 18.053609],
              [74.628782, 18.055403],
              [74.617194, 18.04779],
              [74.610908, 18.046932],
              [74.606048, 18.047176],
              [74.590039, 18.055255],
              [74.586555, 18.054024],
              [74.585231, 18.048616],
              [74.582608, 18.046584],
              [74.578865, 18.051838],
              [74.568683, 18.056171],
              [74.566571, 18.06103],
              [74.561922, 18.067028],
              [74.558706, 18.069464],
              [74.551364, 18.069633],
              [74.546343, 18.066892],
              [74.535269, 18.057326],
              [74.527804, 18.057838],
              [74.521777, 18.059219],
              [74.508727, 18.059501],
              [74.493292, 18.058679],
              [74.487732, 18.056503],
              [74.478914, 18.050802],
              [74.472204, 18.048614],
              [74.464294, 18.047283],
              [74.459839, 18.047815],
              [74.454094, 18.050688],
              [74.449475, 18.055013],
              [74.445672, 18.056755],
              [74.440385, 18.061707],
              [74.432956, 18.065135],
              [74.423627, 18.066316],
              [74.410907, 18.070104],
              [74.400453, 18.070115],
              [74.393974, 18.073508],
              [74.388698, 18.07242],
              [74.384285, 18.070025],
              [74.380073, 18.070504],
              [74.376492, 18.073569],
              [74.36928, 18.08344],
              [74.365533, 18.084833],
              [74.362378, 18.087158],
              [74.357522, 18.096068],
              [74.353252, 18.096031],
              [74.346841, 18.094301],
              [74.33345, 18.088545],
              [74.329248, 18.087987],
              [74.325032, 18.084159],
              [74.320325, 18.076303],
              [74.317356, 18.073349],
              [74.306927, 18.071058],
              [74.302997, 18.068604],
              [74.297763, 18.069479],
              [74.293039, 18.073051],
              [74.279952, 18.074577],
              [74.265209, 18.080577],
              [74.257309, 18.084231],
              [74.249244, 18.089772],
              [74.241342, 18.097096],
              [74.237785, 18.098661],
              [74.230754, 18.099054],
              [74.219553, 18.096525],
              [74.20833, 18.098822],
              [74.193383, 18.105735],
              [74.188661, 18.110799],
              [74.183058, 18.110906],
              [74.171254, 18.10734],
              [74.162807, 18.10645],
              [74.157554, 18.109605],
              [74.151221, 18.116944],
              [74.147645, 18.118634],
              [74.134281, 18.11694],
              [74.123432, 18.129048],
              [74.11771, 18.130313],
              [74.109027, 18.127229],
              [74.102232, 18.122101],
              [74.097618, 18.120503],
              [74.083692, 18.120057],
              [74.077432, 18.12131],
              [74.073804, 18.123566],
              [74.070282, 18.12726],
              [74.068373, 18.13183],
              [74.065994, 18.134852],
              [74.061474, 18.137216],
              [74.051942, 18.138125],
              [74.043918, 18.132807],
              [74.0359, 18.130996],
              [74.03175, 18.13169],
              [74.027824, 18.133598],
              [74.023989, 18.137347],
              [74.009522, 18.145968],
              [74.006361, 18.152939],
              [74.003672, 18.156466],
              [74.001629, 18.156273],
              [74.000032, 18.154194],
              [73.994999, 18.149861],
              [73.990011, 18.149396],
              [73.978424, 18.154743],
              [73.973048, 18.158547],
              [73.969145, 18.163439],
              [73.956997, 18.170905],
              [73.953279, 18.174751],
              [73.945814, 18.180515],
              [73.943793, 18.179457],
              [73.937711, 18.172888],
              [73.932911, 18.173315],
              [73.920298, 18.169913],
              [73.911177, 18.165345],
              [73.904546, 18.159929],
              [73.902435, 18.160539],
              [73.901218, 18.165109],
              [73.89869, 18.169775],
              [73.897466, 18.182425],
              [73.893853, 18.183236],
              [73.890552, 18.179004],
              [73.887476, 18.176502],
              [73.88313, 18.174317],
              [73.877565, 18.176251],
              [73.875548, 18.175479],
              [73.873837, 18.172932],
              [73.874135, 18.169439],
              [73.87642, 18.165636],
              [73.87989, 18.162585],
              [73.883271, 18.157648],
              [73.891904, 18.150711],
              [73.897129, 18.139209],
              [73.903658, 18.136086],
              [73.902754, 18.13241],
              [73.899903, 18.126807],
              [73.896268, 18.124642],
              [73.89445, 18.121981],
              [73.893248, 18.118011],
              [73.890645, 18.115792],
              [73.877606, 18.116414],
              [73.862187, 18.119805],
              [73.86324, 18.113969],
              [73.871264, 18.103411],
              [73.879815, 18.088705],
              [73.880466, 18.084571],
              [73.876074, 18.080995],
              [73.871021, 18.07327],
              [73.870829, 18.069585],
              [73.873349, 18.052527],
              [73.871489, 18.04866],
              [73.867, 18.047971],
              [73.866029, 18.044639],
              [73.866738, 18.042136],
              [73.86481, 18.039246],
              [73.86156, 18.036468],
              [73.860717, 18.033602],
              [73.857693, 18.031563],
              [73.854316, 18.032955],
              [73.850884, 18.037484],
              [73.846989, 18.040931],
              [73.845004, 18.034561],
              [73.839602, 18.031351],
              [73.828994, 18.031734],
              [73.820002, 18.035339],
              [73.81322, 18.03588],
              [73.800902, 18.026196],
              [73.796383, 18.023491],
              [73.791668, 18.022109],
              [73.788105, 18.023885],
              [73.776407, 18.026976],
              [73.766602, 18.024887],
              [73.762021, 18.026365],
              [73.758514, 18.031412],
              [73.758114, 18.034042],
              [73.759403, 18.035721],
              [73.759621, 18.037331],
              [73.750231, 18.039082],
              [73.732988, 18.040255],
              [73.725297, 18.044485],
              [73.713478, 18.043738],
              [73.705605, 18.048152],
              [73.683979, 18.038025],
              [73.664522, 18.026841],
              [73.658617, 18.028417],
              [73.65899, 18.03123],
              [73.655506, 18.035245],
              [73.649899, 18.036994],
              [73.649776, 18.041118],
              [73.640344, 18.045551],
              [73.633916, 18.046085],
              [73.628525, 18.04543],
              [73.626177, 18.049226],
              [73.618449, 18.054904],
              [73.612929, 18.057968],
              [73.615757, 18.068092],
              [73.619913, 18.078128],
              [73.602335, 18.084839],
              [73.607398, 18.090822],
              [73.609212, 18.096691],
              [73.596927, 18.106406],
              [73.59706, 18.10905],
              [73.608199, 18.132029],
              [73.60617, 18.138067],
              [73.611368, 18.139584],
              [73.612151, 18.135819],
              [73.605493, 18.118116],
              [73.61219, 18.122862],
              [73.614525, 18.123473],
              [73.620087, 18.120979],
              [73.624175, 18.120587],
              [73.627987, 18.122595],
              [73.628083, 18.124317],
              [73.620497, 18.125347],
              [73.620292, 18.126777],
              [73.627993, 18.132853],
              [73.629467, 18.137861],
              [73.63233, 18.139281],
              [73.634798, 18.145915],
              [73.636882, 18.146858],
              [73.63909, 18.144258],
              [73.63978, 18.142266],
              [73.641814, 18.143098],
              [73.650773, 18.152753],
              [73.649534, 18.154907],
              [73.650229, 18.156867],
              [73.657077, 18.156749],
              [73.665812, 18.154699],
              [73.666994, 18.156097],
              [73.662202, 18.162439],
              [73.662265, 18.165594],
              [73.657314, 18.17108],
              [73.653622, 18.172507],
              [73.647141, 18.172404],
              [73.6416, 18.173129],
              [73.637788, 18.17496],
              [73.632912, 18.175629],
              [73.628171, 18.175378],
              [73.623953, 18.176294],
              [73.616374, 18.181181],
              [73.610763, 18.1827],
              [73.607292, 18.185679],
              [73.602697, 18.187097],
              [73.599424, 18.189346],
              [73.594235, 18.176705],
              [73.590516, 18.176419],
              [73.581587, 18.179206],
              [73.578635, 18.183226],
              [73.570253, 18.185098],
              [73.56554, 18.190238],
              [73.564328, 18.201282],
              [73.56278, 18.20372],
              [73.561325, 18.211151],
              [73.559534, 18.210432],
              [73.557976, 18.2037],
              [73.55505, 18.195975],
              [73.547971, 18.202163],
              [73.541667, 18.205843],
              [73.540396, 18.202958],
              [73.540084, 18.193553],
              [73.538581, 18.190095],
              [73.536803, 18.188569],
              [73.523345, 18.18572],
              [73.521393, 18.187408],
              [73.523323, 18.193856],
              [73.532438, 18.204321],
              [73.53385, 18.209215],
              [73.533689, 18.211622],
              [73.532536, 18.212519],
              [73.526078, 18.211155],
              [73.523432, 18.211344],
              [73.523406, 18.21283],
              [73.529023, 18.217507],
              [73.535068, 18.225451],
              [73.534847, 18.227745],
              [73.531386, 18.22975],
              [73.523278, 18.229963],
              [73.524762, 18.233998],
              [73.529972, 18.234941],
              [73.536471, 18.241186],
              [73.536769, 18.244565],
              [73.532455, 18.247421],
              [73.526081, 18.247724],
              [73.519379, 18.246181],
              [73.517591, 18.25228],
              [73.512551, 18.255351],
              [73.505178, 18.257755],
              [73.505258, 18.259992],
              [73.512294, 18.269795],
              [73.516215, 18.271978],
              [73.508963, 18.274096],
              [73.505556, 18.273405],
              [73.504353, 18.276431],
              [73.504779, 18.280046],
              [73.509454, 18.283844],
              [73.509344, 18.286363],
              [73.500835, 18.281582],
              [73.491649, 18.278278],
              [73.480115, 18.271329],
              [73.480274, 18.279761],
              [73.478121, 18.28219],
              [73.478666, 18.288727],
              [73.478206, 18.293708],
              [73.476049, 18.300435],
              [73.473091, 18.301137],
              [73.461469, 18.299335],
              [73.455013, 18.297563],
              [73.446394, 18.308603],
              [73.436005, 18.308485],
              [73.424044, 18.305365],
              [73.421734, 18.306756],
              [73.421397, 18.308876],
              [73.425221, 18.316329],
              [73.42572, 18.318747],
              [73.423062, 18.321055],
              [73.422034, 18.326021],
              [73.425136, 18.330603],
              [73.428927, 18.333928],
              [73.427833, 18.337522],
              [73.430888, 18.344507],
              [73.437331, 18.3535],
              [73.443136, 18.358128],
              [73.444372, 18.360038],
              [73.436088, 18.365749],
              [73.427848, 18.372714],
              [73.427123, 18.376088],
              [73.427715, 18.379761],
              [73.426835, 18.388119],
              [73.423373, 18.393219],
              [73.421875, 18.40265],
              [73.420277, 18.404452],
              [73.414558, 18.405395],
              [73.411157, 18.400464],
              [73.409305, 18.399631],
              [73.401789, 18.399901],
              [73.400591, 18.409111],
              [73.400805, 18.414215],
              [73.398851, 18.418539],
              [73.399473, 18.427322],
              [73.397756, 18.432507],
              [73.398043, 18.439443],
              [73.396242, 18.449218],
              [73.396394, 18.453921],
              [73.40673, 18.467272],
              [73.404721, 18.474863],
              [73.406804, 18.479194],
              [73.407624, 18.483854],
              [73.407798, 18.493599],
              [73.410182, 18.49823],
              [73.408449, 18.500437],
              [73.405918, 18.50073],
              [73.403193, 18.498742],
              [73.399649, 18.492259],
              [73.397802, 18.490856],
              [73.393769, 18.49096],
              [73.39139, 18.483468],
              [73.383301, 18.484761],
              [73.381106, 18.483411],
              [73.381411, 18.479568],
              [73.38381, 18.476687],
              [73.381984, 18.474823],
              [73.377695, 18.478763],
              [73.376169, 18.477361],
              [73.377153, 18.469358],
              [73.376293, 18.467332],
              [73.370113, 18.466538],
              [73.364361, 18.468508],
              [73.360806, 18.481691],
              [73.36209, 18.483604],
              [73.364167, 18.48501],
              [73.366806, 18.48546],
              [73.368572, 18.484341],
              [73.3705, 18.480878],
              [73.375192, 18.481015],
              [73.379209, 18.485036],
              [73.378188, 18.491208],
              [73.381683, 18.494078],
              [73.383179, 18.494331],
              [73.385603, 18.496954],
              [73.393049, 18.500862],
              [73.394209, 18.503063],
              [73.392866, 18.503838],
              [73.387177, 18.502422],
              [73.384562, 18.504162],
              [73.370487, 18.516582],
              [73.359676, 18.528441],
              [73.356899, 18.532516],
              [73.343533, 18.532522],
              [73.340702, 18.539229],
              [73.344127, 18.542731],
              [73.347401, 18.544273],
              [73.344571, 18.547665],
              [73.346703, 18.549426],
              [73.352859, 18.551992],
              [73.358326, 18.555411],
              [73.357388, 18.557231],
              [73.349691, 18.553884],
              [73.33674, 18.551203],
              [73.332588, 18.548036],
              [73.327698, 18.552253],
              [73.323588, 18.559346],
              [73.322555, 18.563108],
              [73.322233, 18.570609],
              [73.3255, 18.575994],
              [73.331623, 18.582982],
              [73.332283, 18.586034],
              [73.332118, 18.591585],
              [73.330902, 18.595172],
              [73.334981, 18.599485],
              [73.335358, 18.601842],
              [73.33436, 18.606701],
              [73.335541, 18.607809],
              [73.339678, 18.602436],
              [73.343313, 18.604221],
              [73.342889, 18.610629],
              [73.351482, 18.614617],
              [73.355311, 18.622415],
              [73.356378, 18.629777],
              [73.361188, 18.636099],
              [73.370014, 18.643876],
              [73.377286, 18.644916],
              [73.379147, 18.651193],
              [73.386084, 18.654007],
              [73.388901, 18.654282],
              [73.388287, 18.66161],
              [73.386401, 18.668743],
              [73.386181, 18.67774],
              [73.38414, 18.68366],
              [73.385515, 18.687353],
              [73.384872, 18.692849],
              [73.375244, 18.707988],
              [73.370398, 18.70309],
              [73.36419, 18.700458],
              [73.360811, 18.700802],
              [73.361627, 18.70506],
              [73.360479, 18.708478],
              [73.358503, 18.708334],
              [73.353852, 18.705792],
              [73.348959, 18.696992],
              [73.345697, 18.697169],
              [73.342775, 18.695627],
              [73.340414, 18.696499],
              [73.336223, 18.695224],
              [73.334465, 18.695829],
              [73.333167, 18.697408],
              [73.3317, 18.701625],
              [73.335339, 18.70352],
              [73.341596, 18.710166],
              [73.344915, 18.719445],
              [73.352067, 18.723127],
              [73.352713, 18.724341],
              [73.352044, 18.730978],
              [73.352835, 18.737118],
              [73.353858, 18.740404],
              [73.357296, 18.746197],
              [73.358092, 18.751823],
              [73.354337, 18.752734],
              [73.358398, 18.758305],
              [73.36218, 18.761929],
              [73.365584, 18.776367],
              [73.366189, 18.785837],
              [73.368076, 18.791032],
              [73.369322, 18.792365],
              [73.374027, 18.787197],
              [73.375749, 18.788666],
              [73.378556, 18.793353],
              [73.381045, 18.80239],
              [73.376744, 18.816704],
              [73.384462, 18.819645],
              [73.387038, 18.846745],
              [73.388753, 18.852041],
              [73.392128, 18.851704],
              [73.392457, 18.850619],
              [73.40297, 18.842422],
              [73.413177, 18.858584],
              [73.414953, 18.860103],
              [73.427628, 18.862612],
              [73.433899, 18.87286],
              [73.437654, 18.88198],
              [73.437774, 18.888395],
              [73.436639, 18.89451],
              [73.434589, 18.898032],
              [73.439458, 18.898802],
              [73.436816, 18.904891],
              [73.430607, 18.914363],
              [73.436645, 18.917268],
              [73.4387, 18.9208],
              [73.438829, 18.923436],
              [73.441114, 18.927312],
              [73.447673, 18.924501],
              [73.451423, 18.924332],
              [73.455908, 18.92595],
              [73.458437, 18.929492],
              [73.458721, 18.937177],
              [73.456928, 18.946489],
              [73.459885, 18.952841],
              [73.461554, 18.960946],
              [73.461251, 18.964036],
              [73.462242, 18.965888],
              [73.467498, 18.96838],
              [73.479311, 18.965465],
              [73.478385, 18.973816],
              [73.478587, 18.979152],
              [73.487896, 18.97763],
              [73.500593, 18.969171],
              [73.511786, 18.967682],
              [73.513566, 18.969311],
              [73.511887, 18.972322],
              [73.518522, 18.978377],
              [73.521219, 18.976242],
              [73.522323, 18.977739],
              [73.522585, 18.981856],
              [73.526769, 18.985674],
              [73.532296, 18.988344],
              [73.534369, 18.991184],
              [73.535786, 18.996599],
              [73.540359, 18.996144],
              [73.542587, 19.000675],
              [73.5467, 19.00549],
              [73.55408, 19.011447],
              [73.557227, 19.015968],
              [73.5468, 19.017995],
              [73.54434, 19.021433],
              [73.54605, 19.026651],
              [73.540278, 19.032621],
              [73.535818, 19.032174],
              [73.537829, 19.040769],
              [73.542867, 19.048111],
              [73.542323, 19.050571],
              [73.531283, 19.048524],
              [73.518133, 19.04905],
              [73.519957, 19.053697],
              [73.519252, 19.058576],
              [73.524439, 19.058397],
              [73.527814, 19.056272],
              [73.524042, 19.065851],
              [73.523994, 19.070152],
              [73.52535, 19.07744],
              [73.529357, 19.085526],
              [73.524044, 19.084154],
              [73.51728, 19.084327],
              [73.512787, 19.090812],
              [73.512428, 19.094029],
              [73.514612, 19.097585],
              [73.521443, 19.101241],
              [73.521694, 19.104282],
              [73.518877, 19.108304],
              [73.520143, 19.111514],
              [73.52317, 19.112598],
              [73.526561, 19.115754],
              [73.524396, 19.120285],
              [73.528409, 19.126935],
              [73.527384, 19.129174],
              [73.531492, 19.129568],
              [73.534447, 19.127849],
              [73.53961, 19.121817],
              [73.541122, 19.122851],
              [73.541442, 19.126631],
              [73.545651, 19.139078],
              [73.545052, 19.142574],
              [73.542649, 19.144471],
              [73.539326, 19.143269],
              [73.537035, 19.144306],
              [73.533194, 19.150387],
              [73.533022, 19.155547],
              [73.534003, 19.158703],
              [73.537389, 19.159963],
              [73.540649, 19.159846],
              [73.540554, 19.16822],
              [73.538582, 19.174299],
              [73.539609, 19.173668],
              [73.539315, 19.17665],
              [73.542143, 19.17464],
              [73.544673, 19.174583],
              [73.544465, 19.18295],
              [73.548151, 19.184953],
              [73.554363, 19.18197],
              [73.562823, 19.184134],
              [73.566681, 19.182064],
              [73.567789, 19.188144],
              [73.570632, 19.18929],
              [73.596517, 19.187366],
              [73.597377, 19.191544],
              [73.609016, 19.189353],
              [73.614219, 19.20626],
              [73.626786, 19.20986],
              [73.630198, 19.201764],
              [73.633154, 19.202162],
              [73.636325, 19.209847],
              [73.648622, 19.219454],
              [73.652998, 19.225993],
              [73.65543, 19.230461],
              [73.662523, 19.239104],
              [73.665194, 19.240082],
              [73.674061, 19.238914],
              [73.680099, 19.239309],
              [73.686878, 19.241816],
              [73.690445, 19.244277],
              [73.693123, 19.248686],
              [73.696118, 19.256767],
              [73.695214, 19.257625],
              [73.690737, 19.269628],
              [73.683691, 19.274053],
              [73.680388, 19.278706],
              [73.671669, 19.288188],
              [73.670114, 19.29261],
              [73.670496, 19.296449],
              [73.672018, 19.300462],
              [73.673907, 19.302638],
              [73.682913, 19.304911],
              [73.687228, 19.31093],
              [73.70109, 19.316178],
              [73.708424, 19.323387],
              [73.716051, 19.326527],
              [73.752766, 19.334139],
              [73.750088, 19.331047],
              [73.748376, 19.327381],
              [73.753522, 19.327255],
              [73.77449, 19.329955],
              [73.774838, 19.339587],
              [73.785567, 19.334232],
              [73.787507, 19.335607],
              [73.789081, 19.335714],
              [73.792695, 19.333696],
              [73.794368, 19.330257],
              [73.796977, 19.330704],
              [73.798029, 19.336153],
              [73.795609, 19.34843],
              [73.790494, 19.364614],
              [73.781649, 19.385975],
              [73.783531, 19.390643],
              [73.796902, 19.394455],
              [73.801314, 19.394902],
              [73.813696, 19.392872],
              [73.817369, 19.38954],
              [73.83352, 19.380559],
              [73.839367, 19.378141],
              [73.843586, 19.375264],
              [73.844537, 19.372224],
              [73.84392, 19.369477],
              [73.849688, 19.363906],
              [73.857213, 19.35878],
              [73.862714, 19.357905],
              [73.868331, 19.358286],
              [73.872754, 19.359531],
              [73.877789, 19.362954],
              [73.884328, 19.376275],
              [73.891937, 19.375495],
              [73.896161, 19.374271],
              [73.902236, 19.369525],
              [73.914849, 19.365191],
              [73.919765, 19.358431],
              [73.922682, 19.350898],
              [73.925677, 19.346112],
              [73.930953, 19.340559],
              [73.939983, 19.343672],
              [73.941024, 19.345871],
              [73.943994, 19.347697],
              [73.946954, 19.347629],
              [73.947351, 19.344265],
              [73.951957, 19.345692],
              [73.956662, 19.343859],
              [73.958076, 19.349795],
              [73.964851, 19.350447],
              [73.972621, 19.355339],
              [73.973254, 19.351272],
              [73.979965, 19.351193],
              [74.000027, 19.357521],
              [74.003479, 19.352324],
              [74.003816, 19.349288],
              [74.011935, 19.336508],
              [74.011888, 19.329671],
              [74.013082, 19.325604],
              [74.019054, 19.321014],
              [74.020786, 19.317649],
              [74.028298, 19.310317],
              [74.029142, 19.30556],
              [74.027563, 19.300547],
              [74.022944, 19.29693],
              [74.019371, 19.296894],
              [74.014339, 19.29874],
              [74.014129, 19.295582],
              [74.01549, 19.292261],
              [74.020393, 19.286114],
              [74.022227, 19.285101],
              [74.026527, 19.289332],
              [74.031909, 19.283708],
              [74.032123, 19.28026],
              [74.030381, 19.273756],
              [74.026808, 19.268837],
              [74.034631, 19.259959],
              [74.036059, 19.256466],
              [74.033145, 19.25242],
              [74.034561, 19.25025],
              [74.047412, 19.258253],
              [74.050708, 19.250189],
              [74.05336, 19.243728],
              [74.056279, 19.242494],
              [74.060971, 19.244373],
              [74.066147, 19.240872],
              [74.076969, 19.235232],
              [74.082478, 19.233623],
              [74.084804, 19.231126],
              [74.08978, 19.229167],
              [74.093858, 19.226221],
              [74.096469, 19.22544],
              [74.096679, 19.227797],
              [74.089569, 19.232088],
              [74.089181, 19.234901],
              [74.092804, 19.234533],
              [74.098092, 19.23223],
              [74.104329, 19.230743],
              [74.111715, 19.229959],
              [74.128371, 19.220074],
              [74.142626, 19.220325],
              [74.143796, 19.224645],
              [74.152832, 19.221803],
              [74.155421, 19.215798],
              [74.158938, 19.202742],
              [74.166459, 19.206027],
              [74.1658, 19.211481],
              [74.167608, 19.218328],
              [74.168624, 19.219659],
              [74.171766, 19.219707],
              [74.176474, 19.216701],
              [74.184214, 19.216143],
              [74.187129, 19.214964],
              [74.194256, 19.209288],
              [74.209784, 19.203804],
              [74.219996, 19.20333],
              [74.22171, 19.201506],
              [74.228872, 19.204503],
              [74.242028, 19.212376],
              [74.261715, 19.219623],
              [74.264876, 19.224071],
              [74.280418, 19.217324],
              [74.292573, 19.216053],
              [74.316451, 19.208059],
              [74.316652, 19.206222],
              [74.313656, 19.20315],
              [74.310451, 19.196916],
              [74.304309, 19.18877],
              [74.29243, 19.18613],
              [74.270985, 19.185537],
              [74.26815, 19.184534],
              [74.266552, 19.18171],
              [74.265979, 19.165845],
              [74.265042, 19.162623],
              [74.26077, 19.160691],
              [74.256555, 19.153123],
              [74.252846, 19.149471],
              [74.249124, 19.147252],
              [74.244336, 19.142047],
              [74.237741, 19.130786],
              [74.236009, 19.123301],
              [74.230735, 19.12446],
              [74.227213, 19.126666],
              [74.224711, 19.129744],
              [74.220725, 19.129588],
              [74.21447, 19.127173],
              [74.210567, 19.125073],
              [74.204145, 19.113921],
              [74.200995, 19.109359],
              [74.19741, 19.105824],
              [74.199122, 19.096702],
              [74.200353, 19.093842],
              [74.200418, 19.087584],
              [74.19538, 19.083751],
              [74.193338, 19.075624],
              [74.192506, 19.067177],
              [74.189604, 19.060716],
              [74.183945, 19.052334],
              [74.175248, 19.041798],
              [74.175131, 19.035881],
              [74.179339, 19.031037],
              [74.188962, 19.026194],
              [74.191318, 19.020755],
              [74.191038, 19.01926],
              [74.193514, 19.017736],
              [74.198893, 19.016005],
              [74.202525, 19.011104],
              [74.20538, 19.009699],
              [74.210848, 19.009585],
              [74.214754, 19.006922],
              [74.216665, 19.000466],
              [74.213573, 18.998648],
              [74.212713, 18.995302],
              [74.215752, 18.993441],
              [74.221002, 18.993549],
              [74.224338, 18.99221],
              [74.226154, 18.98723],
              [74.223463, 18.980661],
              [74.223101, 18.976065],
              [74.224832, 18.973039],
              [74.230078, 18.968891],
              [74.236308, 18.967124],
              [74.239668, 18.964173],
              [74.23823, 18.958471],
              [74.239869, 18.953372],
              [74.245964, 18.95258],
              [74.250365, 18.952793],
              [74.260711, 18.936474],
              [74.267506, 18.928389],
              [74.270795, 18.920952],
              [74.274831, 18.917318],
              [74.282789, 18.912119],
              [74.285441, 18.907495],
              [74.294419, 18.903218],
              [74.295861, 18.89915],
              [74.297572, 18.888032],
              [74.300584, 18.88318],
              [74.303632, 18.880397],
              [74.30321, 18.875963],
              [74.304212, 18.872651],
              [74.309404, 18.86747],
              [74.30883, 18.860465],
              [74.311331, 18.853424],
              [74.321582, 18.84336],
              [74.325783, 18.839781],
              [74.332149, 18.837372],
              [74.338769, 18.837725],
              [74.351704, 18.843652],
              [74.358667, 18.84142],
              [74.370483, 18.836019],
              [74.385992, 18.833869],
              [74.38996, 18.835055],
              [74.392988, 18.83376],
              [74.397425, 18.830413],
              [74.397786, 18.825763],
              [74.392652, 18.816703],
              [74.38601, 18.808079],
              [74.385535, 18.803193],
              [74.389752, 18.798069],
              [74.390498, 18.791409],
              [74.392131, 18.785566],
              [74.394543, 18.781168],
              [74.399648, 18.777259],
              [74.397505, 18.774711],
              [74.396051, 18.770216],
              [74.395805, 18.766078],
              [74.399543, 18.741311],
              [74.411804, 18.743024],
              [74.419635, 18.747811],
              [74.424927, 18.748945],
              [74.440887, 18.738587],
              [74.44333, 18.735451],
              [74.444842, 18.724722],
              [74.447112, 18.721584],
              [74.451109, 18.719445],
              [74.460515, 18.72337],
              [74.467362, 18.724759],
              [74.469674, 18.723452],
              [74.477149, 18.722197],
              [74.481085, 18.715689],
              [74.481717, 18.702663],
              [74.477064, 18.694177],
              [74.475673, 18.689051],
              [74.479072, 18.681561],
              [74.486558, 18.674618],
              [74.500981, 18.677217],
              [74.507292, 18.677445],
              [74.510906, 18.672658],
              [74.511563, 18.667434],
              [74.509762, 18.662418],
              [74.50475, 18.658591],
              [74.500202, 18.65631],
              [74.492462, 18.654061],
              [74.492125, 18.651471],
              [74.489781, 18.64651],
              [74.475682, 18.647647],
              [74.474144, 18.645336],
              [74.474557, 18.641205],
              [74.478913, 18.634011],
              [74.48558, 18.63028],
              [74.495855, 18.626118],
              [74.503504, 18.625845],
              [74.507453, 18.622434],
              [74.51072, 18.615912],
              [74.51698, 18.615796],
              [74.526881, 18.617777],
              [74.539094, 18.618109],
              [74.545546, 18.617305],
              [74.550694, 18.613965],
              [74.550925, 18.609658],
              [74.545046, 18.591978],
              [74.546306, 18.587338],
              [74.543762, 18.583351],
              [74.5487, 18.578052],
              [74.55467, 18.576551],
              [74.558586, 18.570383],
              [74.561207, 18.567943],
              [74.565879, 18.559075],
              [74.570784, 18.555555],
              [74.579909, 18.552356],
              [74.581528, 18.547836],
              [74.580584, 18.545878],
              [74.572761, 18.545749],
              [74.57121, 18.544708],
              [74.573039, 18.532205],
              [74.570844, 18.529255],
              [74.563687, 18.523513],
              [74.558671, 18.521054],
              [74.549789, 18.5138],
              [74.547689, 18.508274],
              [74.553874, 18.498849],
              [74.560735, 18.492479],
              [74.568744, 18.486628],
              [74.575399, 18.476803],
              [74.580493, 18.473295],
              [74.60223, 18.470142],
              [74.612178, 18.467463],
              [74.622406, 18.461408],
              [74.628481, 18.455942],
              [74.63773, 18.451416],
              [74.643573, 18.449797],
              [74.65076, 18.451983],
              [74.661592, 18.456839],
              [74.670167, 18.458975],
              [74.674649, 18.461301],
              [74.67113, 18.464782],
              [74.663789, 18.465409],
              [74.657808, 18.473745],
              [74.65669, 18.476959],
              [74.65676, 18.481666],
              [74.659485, 18.485365],
              [74.663717, 18.488607],
              [74.680909, 18.49466],
              [74.687826, 18.500568],
              [74.691363, 18.501407],
              [74.700757, 18.505728],
              [74.704923, 18.504152],
              [74.710757, 18.498507],
              [74.71584, 18.495157],
              [74.720466, 18.489746],
              [74.726942, 18.479685],
              [74.72715, 18.471936],
              [74.725883, 18.460263],
              [74.723699, 18.450483],
              [74.717393, 18.437921],
              [74.71471, 18.430257],
              [74.723088, 18.41614],
              [74.728152, 18.40929],
              [74.734579, 18.397907],
              [74.747702, 18.395596],
              [74.755028, 18.396396],
              [74.759042, 18.397457],
              [74.766064, 18.404231],
              [74.770246, 18.406447],
              [74.773962, 18.408024],
              [74.779848, 18.408414],
              [74.783775, 18.406082],
              [74.798377, 18.393551],
              [74.808485, 18.386046],
              [74.809074, 18.382265],
              [74.808169, 18.375763],
              [74.803004, 18.370047],
              [74.796785, 18.360414],
              [74.794436, 18.355111],
              [74.79592, 18.351096],
              [74.800755, 18.347347],
              [74.810054, 18.343219],
              [74.815822, 18.342748],
              [74.824646, 18.343902],
              [74.832715, 18.342063],
              [74.833877, 18.339199],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 452,
        censuscode: 521,
        dt_cen_cd: 25,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Pune",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [73.783371, 16.659741],
              [73.788136, 16.659662],
              [73.795654, 16.66089],
              [73.802623, 16.659531],
              [73.810455, 16.654615],
              [73.814805, 16.653209],
              [73.823495, 16.651847],
              [73.833906, 16.648116],
              [73.842336, 16.652609],
              [73.845678, 16.652189],
              [73.848342, 16.650224],
              [73.854007, 16.650192],
              [73.852659, 16.635766],
              [73.854473, 16.631509],
              [73.855104, 16.627313],
              [73.858267, 16.620182],
              [73.863888, 16.61326],
              [73.863373, 16.608389],
              [73.859389, 16.600217],
              [73.849629, 16.593246],
              [73.843912, 16.58549],
              [73.846442, 16.58163],
              [73.845331, 16.575789],
              [73.84794, 16.573765],
              [73.84745, 16.571009],
              [73.840718, 16.562172],
              [73.833807, 16.55459],
              [73.832538, 16.55168],
              [73.833356, 16.548805],
              [73.832682, 16.546459],
              [73.826166, 16.543522],
              [73.820221, 16.545276],
              [73.81874, 16.546549],
              [73.818135, 16.54495],
              [73.823649, 16.541185],
              [73.82746, 16.539841],
              [73.831999, 16.533045],
              [73.839137, 16.530991],
              [73.843607, 16.531305],
              [73.848338, 16.526342],
              [73.84867, 16.523184],
              [73.84779, 16.516816],
              [73.843851, 16.514948],
              [73.843616, 16.506686],
              [73.846851, 16.500698],
              [73.851517, 16.494568],
              [73.852076, 16.490022],
              [73.853612, 16.487187],
              [73.856452, 16.484626],
              [73.860495, 16.483488],
              [73.861655, 16.479791],
              [73.864301, 16.475223],
              [73.86935, 16.473317],
              [73.875025, 16.475831],
              [73.878906, 16.476595],
              [73.88234, 16.473931],
              [73.884907, 16.474768],
              [73.884544, 16.473568],
              [73.886139, 16.47178],
              [73.88854, 16.457505],
              [73.887759, 16.448627],
              [73.885503, 16.449893],
              [73.883921, 16.445228],
              [73.882605, 16.444103],
              [73.880409, 16.444347],
              [73.880384, 16.441892],
              [73.879423, 16.440356],
              [73.875261, 16.440618],
              [73.871373, 16.438873],
              [73.868062, 16.433012],
              [73.867743, 16.430094],
              [73.866721, 16.428499],
              [73.862159, 16.424353],
              [73.854036, 16.419708],
              [73.852714, 16.417079],
              [73.847435, 16.411495],
              [73.837853, 16.403005],
              [73.839024, 16.392215],
              [73.852576, 16.388241],
              [73.859691, 16.384702],
              [73.862815, 16.380677],
              [73.866341, 16.373714],
              [73.864203, 16.366666],
              [73.859675, 16.366121],
              [73.856739, 16.362753],
              [73.857539, 16.358562],
              [73.851567, 16.355098],
              [73.846516, 16.355868],
              [73.843297, 16.355314],
              [73.842513, 16.352907],
              [73.840722, 16.352404],
              [73.839687, 16.348796],
              [73.835736, 16.345947],
              [73.835792, 16.34423],
              [73.838642, 16.343639],
              [73.846066, 16.333328],
              [73.845976, 16.328976],
              [73.848868, 16.325342],
              [73.848848, 16.32219],
              [73.841261, 16.316779],
              [73.847849, 16.314851],
              [73.849385, 16.313409],
              [73.848675, 16.304868],
              [73.847216, 16.300119],
              [73.849786, 16.302285],
              [73.853061, 16.310585],
              [73.85701, 16.315033],
              [73.860157, 16.312839],
              [73.863281, 16.309381],
              [73.866436, 16.309246],
              [73.870702, 16.315248],
              [73.876778, 16.317106],
              [73.884802, 16.324004],
              [73.887272, 16.328518],
              [73.887488, 16.325025],
              [73.88843, 16.323411],
              [73.899067, 16.330171],
              [73.901506, 16.330445],
              [73.904703, 16.328306],
              [73.905341, 16.317295],
              [73.902629, 16.304123],
              [73.89673, 16.302605],
              [73.891354, 16.299479],
              [73.891025, 16.295636],
              [73.891603, 16.29294],
              [73.890631, 16.290023],
              [73.881638, 16.279402],
              [73.887664, 16.274777],
              [73.893807, 16.268202],
              [73.89626, 16.261072],
              [73.896527, 16.257227],
              [73.898065, 16.256699],
              [73.907467, 16.256918],
              [73.910426, 16.254777],
              [73.90831, 16.249783],
              [73.916384, 16.248282],
              [73.920117, 16.245892],
              [73.915333, 16.241893],
              [73.898981, 16.234496],
              [73.893008, 16.230934],
              [73.894017, 16.230688],
              [73.899683, 16.23288],
              [73.910693, 16.233912],
              [73.915327, 16.233575],
              [73.917273, 16.231579],
              [73.917617, 16.230244],
              [73.921567, 16.232923],
              [73.925196, 16.232933],
              [73.927114, 16.234595],
              [73.927835, 16.236794],
              [73.929689, 16.237648],
              [73.932182, 16.237455],
              [73.940003, 16.241641],
              [73.941594, 16.2389],
              [73.943511, 16.240927],
              [73.944175, 16.243005],
              [73.946901, 16.241089],
              [73.947709, 16.238187],
              [73.942574, 16.234545],
              [73.93849, 16.229617],
              [73.939072, 16.227636],
              [73.934883, 16.223698],
              [73.931996, 16.219833],
              [73.927065, 16.219788],
              [73.925926, 16.218874],
              [73.926983, 16.217177],
              [73.92906, 16.216331],
              [73.927911, 16.214146],
              [73.927961, 16.212646],
              [73.930341, 16.211973],
              [73.931153, 16.209769],
              [73.929906, 16.209095],
              [73.929174, 16.207207],
              [73.927988, 16.207288],
              [73.928748, 16.205948],
              [73.927515, 16.200071],
              [73.930334, 16.202835],
              [73.932894, 16.20325],
              [73.939567, 16.206172],
              [73.942184, 16.206272],
              [73.943486, 16.204431],
              [73.946086, 16.203065],
              [73.953237, 16.205446],
              [73.957642, 16.206182],
              [73.959072, 16.205732],
              [73.957371, 16.201638],
              [73.959858, 16.200276],
              [73.959614, 16.199128],
              [73.953575, 16.194604],
              [73.948799, 16.192419],
              [73.945654, 16.192145],
              [73.94228, 16.186753],
              [73.943271, 16.18345],
              [73.948482, 16.180519],
              [73.949297, 16.17856],
              [73.948935, 16.17735],
              [73.948909, 16.174257],
              [73.946815, 16.17222],
              [73.940093, 16.1727],
              [73.934083, 16.170921],
              [73.931503, 16.168464],
              [73.926344, 16.170034],
              [73.924581, 16.17281],
              [73.922032, 16.174114],
              [73.916076, 16.172394],
              [73.91961, 16.167081],
              [73.909077, 16.158574],
              [73.914245, 16.157481],
              [73.919922, 16.153369],
              [73.919009, 16.150417],
              [73.917513, 16.148496],
              [73.914782, 16.148755],
              [73.91669, 16.141837],
              [73.916192, 16.13922],
              [73.913979, 16.137578],
              [73.912081, 16.137364],
              [73.909924, 16.135267],
              [73.905531, 16.135472],
              [73.899601, 16.138261],
              [73.891655, 16.139923],
              [73.889464, 16.141136],
              [73.886575, 16.14511],
              [73.876824, 16.143734],
              [73.872889, 16.142435],
              [73.870183, 16.146181],
              [73.867327, 16.146479],
              [73.866246, 16.143675],
              [73.867274, 16.138334],
              [73.855847, 16.144702],
              [73.845851, 16.152313],
              [73.852091, 16.143111],
              [73.854958, 16.135697],
              [73.854104, 16.132887],
              [73.847548, 16.131083],
              [73.849143, 16.128493],
              [73.84925, 16.126715],
              [73.84805, 16.12511],
              [73.850757, 16.120972],
              [73.849957, 16.118221],
              [73.848346, 16.116217],
              [73.845431, 16.107685],
              [73.839942, 16.10392],
              [73.835546, 16.09567],
              [73.835775, 16.09389],
              [73.836836, 16.092742],
              [73.84092, 16.091407],
              [73.843282, 16.088922],
              [73.845122, 16.078763],
              [73.858107, 16.075036],
              [73.856911, 16.082844],
              [73.85442, 16.084005],
              [73.851204, 16.082242],
              [73.848119, 16.083058],
              [73.845304, 16.08944],
              [73.845408, 16.095289],
              [73.848258, 16.094937],
              [73.85101, 16.09779],
              [73.852738, 16.098014],
              [73.854855, 16.103576],
              [73.858237, 16.102586],
              [73.860347, 16.107167],
              [73.87353, 16.106358],
              [73.869941, 16.10322],
              [73.865086, 16.097388],
              [73.871423, 16.094549],
              [73.876373, 16.097223],
              [73.884911, 16.093857],
              [73.886583, 16.095458],
              [73.896596, 16.091443],
              [73.898539, 16.089027],
              [73.901217, 16.089011],
              [73.903181, 16.098469],
              [73.906994, 16.099878],
              [73.918563, 16.097384],
              [73.933529, 16.095981],
              [73.936552, 16.095134],
              [73.940435, 16.09727],
              [73.948051, 16.098432],
              [73.958074, 16.096124],
              [73.965253, 16.094875],
              [73.967159, 16.095125],
              [73.973665, 16.091313],
              [73.988575, 16.090543],
              [73.997596, 16.088369],
              [73.998824, 16.086946],
              [73.994321, 16.080845],
              [73.992872, 16.077636],
              [74.000005, 16.078422],
              [74.006475, 16.075869],
              [74.006133, 16.074141],
              [74.005751, 16.072409],
              [74.005492, 16.070703],
              [74.00573, 16.069061],
              [74.006736, 16.067588],
              [74.00592, 16.066153],
              [74.004664, 16.064831],
              [74.003429, 16.06362],
              [74.002155, 16.062461],
              [74.000015, 16.061192],
              [73.996542, 16.059804],
              [73.994322, 16.057505],
              [73.997591, 16.057382],
              [74.000012, 16.056453],
              [74.001825, 16.05231],
              [74.001881, 16.037681],
              [74.011441, 16.037054],
              [74.026045, 16.033767],
              [74.037063, 16.035064],
              [74.044808, 16.033768],
              [74.048663, 16.034154],
              [74.050467, 16.037417],
              [74.050937, 16.041211],
              [74.052075, 16.044856],
              [74.054157, 16.048098],
              [74.056698, 16.051044],
              [74.059817, 16.050127],
              [74.061732, 16.046783],
              [74.063354, 16.043296],
              [74.064931, 16.039796],
              [74.066671, 16.036363],
              [74.069116, 16.033394],
              [74.071882, 16.030683],
              [74.073917, 16.02741],
              [74.0755, 16.023912],
              [74.076844, 16.020346],
              [74.080306, 16.018687],
              [74.084116, 16.017715],
              [74.087441, 16.015673],
              [74.089372, 16.012377],
              [74.090917, 16.006443],
              [74.084087, 16.003594],
              [74.080678, 16.000127],
              [74.072698, 15.991845],
              [74.066855, 15.987294],
              [74.058537, 15.977404],
              [74.05695, 15.972691],
              [74.057437, 15.97034],
              [74.056326, 15.96621],
              [74.054088, 15.962128],
              [74.049884, 15.960803],
              [74.04699, 15.958898],
              [74.045992, 15.956712],
              [74.048731, 15.952875],
              [74.049466, 15.949835],
              [74.057249, 15.946181],
              [74.059806, 15.943487],
              [74.066222, 15.940583],
              [74.068538, 15.941559],
              [74.071531, 15.94857],
              [74.073605, 15.94817],
              [74.077096, 15.935268],
              [74.081136, 15.933386],
              [74.082355, 15.926905],
              [74.086983, 15.912622],
              [74.08895, 15.909191],
              [74.090041, 15.902758],
              [74.093918, 15.897494],
              [74.091561, 15.896277],
              [74.092773, 15.889047],
              [74.088507, 15.873202],
              [74.092848, 15.871657],
              [74.089896, 15.868497],
              [74.087348, 15.86717],
              [74.083784, 15.867845],
              [74.07315, 15.858928],
              [74.064639, 15.853911],
              [74.043534, 15.8387],
              [74.032349, 15.833909],
              [74.033961, 15.830872],
              [74.031166, 15.820071],
              [74.035213, 15.803492],
              [74.039668, 15.800921],
              [74.040992, 15.796038],
              [74.041068, 15.791968],
              [74.037769, 15.786732],
              [74.035898, 15.781109],
              [74.040847, 15.775548],
              [74.042583, 15.7709],
              [74.029214, 15.764329],
              [74.040811, 15.75534],
              [74.052136, 15.754507],
              [74.056386, 15.758542],
              [74.06628, 15.760398],
              [74.069585, 15.763284],
              [74.077098, 15.766517],
              [74.079704, 15.768468],
              [74.056735, 15.774217],
              [74.055488, 15.788158],
              [74.051884, 15.799806],
              [74.048829, 15.806687],
              [74.066589, 15.813443],
              [74.066147, 15.817807],
              [74.067739, 15.821603],
              [74.066241, 15.824639],
              [74.070608, 15.830215],
              [74.070297, 15.833141],
              [74.076637, 15.833386],
              [74.086937, 15.837833],
              [74.094762, 15.839519],
              [74.103476, 15.839372],
              [74.104875, 15.830534],
              [74.10799, 15.823246],
              [74.111373, 15.821538],
              [74.125771, 15.824666],
              [74.144476, 15.831538],
              [74.142027, 15.821607],
              [74.159394, 15.821357],
              [74.155721, 15.807283],
              [74.155501, 15.787823],
              [74.16686, 15.778721],
              [74.173571, 15.774257],
              [74.184298, 15.775025],
              [74.193758, 15.780387],
              [74.200497, 15.785336],
              [74.210541, 15.780866],
              [74.208838, 15.775986],
              [74.207739, 15.768113],
              [74.204446, 15.760708],
              [74.197476, 15.755528],
              [74.190135, 15.752347],
              [74.164059, 15.752067],
              [74.160562, 15.751365],
              [74.155143, 15.744184],
              [74.152982, 15.736481],
              [74.148186, 15.734405],
              [74.143332, 15.733821],
              [74.140189, 15.732199],
              [74.135761, 15.729318],
              [74.134651, 15.725303],
              [74.133237, 15.72381],
              [74.127604, 15.724309],
              [74.123351, 15.720048],
              [74.127505, 15.718161],
              [74.128304, 15.711388],
              [74.131698, 15.708475],
              [74.134326, 15.702504],
              [74.131665, 15.70118],
              [74.133227, 15.696705],
              [74.13166, 15.688378],
              [74.126358, 15.680554],
              [74.119733, 15.675891],
              [74.110209, 15.672936],
              [74.098889, 15.672794],
              [74.093141, 15.674501],
              [74.089115, 15.673002],
              [74.090616, 15.668123],
              [74.097157, 15.66136],
              [74.104706, 15.657195],
              [74.114073, 15.65584],
              [74.118766, 15.652458],
              [74.115476, 15.647399],
              [74.105293, 15.645247],
              [74.100691, 15.641041],
              [74.095056, 15.641147],
              [74.073066, 15.628344],
              [74.066013, 15.628846],
              [74.060158, 15.626881],
              [74.049204, 15.624893],
              [74.031618, 15.623017],
              [74.027879, 15.611464],
              [74.020196, 15.606794],
              [74.005363, 15.611514],
              [73.999994, 15.610478],
              [73.994511, 15.611228],
              [73.990807, 15.613298],
              [73.984997, 15.618478],
              [73.982282, 15.622778],
              [73.978104, 15.625552],
              [73.973424, 15.627186],
              [73.967961, 15.631095],
              [73.96121, 15.646464],
              [73.962687, 15.651801],
              [73.966192, 15.656809],
              [73.967675, 15.661917],
              [73.963536, 15.670513],
              [73.964152, 15.678809],
              [73.963265, 15.68937],
              [73.957656, 15.697136],
              [73.949119, 15.698856],
              [73.950553, 15.703358],
              [73.947899, 15.706905],
              [73.949655, 15.70946],
              [73.950734, 15.713395],
              [73.947816, 15.719027],
              [73.94265, 15.72533],
              [73.941594, 15.734728],
              [73.937163, 15.743612],
              [73.915861, 15.744908],
              [73.909601, 15.747493],
              [73.906465, 15.747574],
              [73.900214, 15.74441],
              [73.877395, 15.749341],
              [73.87393, 15.751424],
              [73.87169, 15.754617],
              [73.874076, 15.758771],
              [73.875812, 15.766701],
              [73.878336, 15.7692],
              [73.878364, 15.772357],
              [73.871701, 15.779451],
              [73.87132, 15.781276],
              [73.86653, 15.784956],
              [73.866259, 15.788397],
              [73.867357, 15.795287],
              [73.864902, 15.797378],
              [73.856866, 15.799589],
              [73.852941, 15.795932],
              [73.851416, 15.789841],
              [73.847137, 15.785324],
              [73.848326, 15.780289],
              [73.843227, 15.78047],
              [73.840933, 15.778092],
              [73.838449, 15.7682],
              [73.836405, 15.765426],
              [73.830032, 15.762957],
              [73.831567, 15.758273],
              [73.829707, 15.75091],
              [73.824265, 15.739838],
              [73.811545, 15.741991],
              [73.807153, 15.737357],
              [73.803739, 15.735601],
              [73.793918, 15.734288],
              [73.788608, 15.727179],
              [73.784231, 15.725752],
              [73.77748, 15.725336],
              [73.766718, 15.732612],
              [73.749088, 15.734831],
              [73.739508, 15.732658],
              [73.734823, 15.727732],
              [73.73177, 15.720812],
              [73.727755, 15.71934],
              [73.722967, 15.72267],
              [73.718323, 15.72457],
              [73.713222, 15.724975],
              [73.709202, 15.723712],
              [73.701569, 15.722318],
              [73.697165, 15.723821],
              [73.693215, 15.726995],
              [73.687859, 15.728315],
              [73.682344, 15.729005],
              [73.675734, 15.727968],
              [73.672933, 15.736765],
              [73.659972, 15.745163],
              [73.658964, 15.74898],
              [73.662206, 15.751532],
              [73.670578, 15.753219],
              [73.679238, 15.751915],
              [73.679953, 15.751791],
              [73.685343, 15.753635],
              [73.688938, 15.754581],
              [73.685191, 15.755793],
              [73.679154, 15.75775],
              [73.674005, 15.759404],
              [73.666448, 15.764719],
              [73.664788, 15.774423],
              [73.656379, 15.797808],
              [73.65358, 15.80221],
              [73.64819, 15.808636],
              [73.646138, 15.811015],
              [73.642184, 15.818657],
              [73.636327, 15.835774],
              [73.633175, 15.851126],
              [73.62891, 15.8558],
              [73.628202, 15.855026],
              [73.627526, 15.854211],
              [73.62368, 15.852681],
              [73.621812, 15.8522],
              [73.617705, 15.853381],
              [73.615754, 15.866679],
              [73.611749, 15.875683],
              [73.600853, 15.894117],
              [73.599536, 15.896328],
              [73.595755, 15.900335],
              [73.59361, 15.901892],
              [73.591539, 15.908475],
              [73.589526, 15.910171],
              [73.581144, 15.911405],
              [73.579694, 15.911613],
              [73.574632, 15.91292],
              [73.571611, 15.915013],
              [73.570401, 15.917932],
              [73.566649, 15.922497],
              [73.564984, 15.924057],
              [73.556778, 15.926232],
              [73.549919, 15.930634],
              [73.549666, 15.931781],
              [73.545402, 15.935768],
              [73.538697, 15.937499],
              [73.537294, 15.937254],
              [73.536147, 15.936545],
              [73.535373, 15.932458],
              [73.533863, 15.932096],
              [73.530018, 15.931918],
              [73.529101, 15.932369],
              [73.520837, 15.936999],
              [73.513799, 15.938756],
              [73.512367, 15.939128],
              [73.507623, 15.943351],
              [73.506172, 15.948269],
              [73.505766, 15.950101],
              [73.505709, 15.953272],
              [73.50845, 15.957502],
              [73.509233, 15.962229],
              [73.504648, 15.962393],
              [73.499921, 15.96238],
              [73.49893, 15.969339],
              [73.498767, 15.969695],
              [73.487592, 15.974948],
              [73.489173, 15.992017],
              [73.492537, 16.000519],
              [73.4945, 16.004676],
              [73.49211, 16.008707],
              [73.492018, 16.015048],
              [73.486503, 16.037576],
              [73.482711, 16.041817],
              [73.471387, 16.046633],
              [73.468013, 16.053817],
              [73.465207, 16.054229],
              [73.460256, 16.055951],
              [73.458596, 16.057053],
              [73.457905, 16.064742],
              [73.467346, 16.066447],
              [73.468478, 16.067821],
              [73.467255, 16.073313],
              [73.466823, 16.075218],
              [73.466644, 16.080477],
              [73.468252, 16.09002],
              [73.469881, 16.092385],
              [73.474121, 16.095991],
              [73.473591, 16.099803],
              [73.469897, 16.104516],
              [73.468656, 16.116914],
              [73.470782, 16.129628],
              [73.469371, 16.143854],
              [73.469504, 16.144438],
              [73.472422, 16.158589],
              [73.469052, 16.15799],
              [73.467772, 16.15785],
              [73.464791, 16.153943],
              [73.463679, 16.144344],
              [73.463351, 16.141278],
              [73.462413, 16.140372],
              [73.46082, 16.137406],
              [73.460285, 16.134896],
              [73.46097, 16.126262],
              [73.461705, 16.117265],
              [73.462058, 16.113014],
              [73.461459, 16.110315],
              [73.458787, 16.114323],
              [73.458029, 16.117205],
              [73.455665, 16.126179],
              [73.453821, 16.133252],
              [73.451365, 16.144152],
              [73.450596, 16.147356],
              [73.442886, 16.187757],
              [73.441948, 16.188652],
              [73.44174, 16.189685],
              [73.441467, 16.193291],
              [73.441728, 16.196355],
              [73.438524, 16.199708],
              [73.435596, 16.200486],
              [73.432178, 16.201392],
              [73.427935, 16.214887],
              [73.425751, 16.221887],
              [73.419755, 16.252797],
              [73.411683, 16.281159],
              [73.411089, 16.282625],
              [73.406082, 16.294631],
              [73.398223, 16.30397],
              [73.394363, 16.309838],
              [73.394421, 16.326574],
              [73.388564, 16.33224],
              [73.38762, 16.333237],
              [73.3863, 16.335494],
              [73.386361, 16.338874],
              [73.39086, 16.344623],
              [73.389561, 16.351376],
              [73.39055, 16.356129],
              [73.392165, 16.356381],
              [73.402332, 16.353768],
              [73.405118, 16.353649],
              [73.409898, 16.355267],
              [73.415353, 16.35839],
              [73.419336, 16.36213],
              [73.420175, 16.362948],
              [73.420507, 16.364763],
              [73.420137, 16.365656],
              [73.416172, 16.366282],
              [73.410661, 16.361373],
              [73.409803, 16.360982],
              [73.409028, 16.36035],
              [73.40783, 16.359804],
              [73.400524, 16.360912],
              [73.399895, 16.361131],
              [73.398655, 16.361681],
              [73.396397, 16.364238],
              [73.395405, 16.366276],
              [73.394592, 16.366374],
              [73.393891, 16.365949],
              [73.391467, 16.364396],
              [73.387889, 16.360386],
              [73.38675, 16.358322],
              [73.381602, 16.357569],
              [73.373603, 16.361692],
              [73.372608, 16.362868],
              [73.371893, 16.37145],
              [73.371965, 16.378669],
              [73.372308, 16.382533],
              [73.374472, 16.38517],
              [73.381371, 16.385851],
              [73.389978, 16.389372],
              [73.401692, 16.389788],
              [73.409186, 16.398479],
              [73.411037, 16.400419],
              [73.411783, 16.401352],
              [73.414027, 16.402766],
              [73.416589, 16.403492],
              [73.431941, 16.403873],
              [73.433029, 16.404057],
              [73.44409, 16.4063],
              [73.446242, 16.407368],
              [73.448519, 16.408253],
              [73.450693, 16.409112],
              [73.451595, 16.409587],
              [73.453674, 16.410451],
              [73.453901, 16.410893],
              [73.454851, 16.410904],
              [73.455495, 16.411216],
              [73.456609, 16.411436],
              [73.458792, 16.411867],
              [73.459954, 16.412109],
              [73.463841, 16.413159],
              [73.469527, 16.415068],
              [73.463788, 16.416727],
              [73.459517, 16.415872],
              [73.458115, 16.415398],
              [73.455934, 16.414646],
              [73.453951, 16.413898],
              [73.452998, 16.413661],
              [73.451158, 16.412755],
              [73.450422, 16.412375],
              [73.448457, 16.412113],
              [73.446048, 16.411796],
              [73.437241, 16.410053],
              [73.432926, 16.410349],
              [73.427228, 16.410929],
              [73.416837, 16.411288],
              [73.412195, 16.411033],
              [73.411154, 16.410716],
              [73.410098, 16.410152],
              [73.409033, 16.408221],
              [73.408017, 16.406165],
              [73.406425, 16.402985],
              [73.402124, 16.399628],
              [73.393535, 16.401629],
              [73.389194, 16.401007],
              [73.377977, 16.392114],
              [73.370357, 16.393668],
              [73.369761, 16.393797],
              [73.367367, 16.397601],
              [73.366307, 16.403691],
              [73.358895, 16.426874],
              [73.35375, 16.441501],
              [73.352067, 16.443497],
              [73.346889, 16.453885],
              [73.346589, 16.454873],
              [73.344082, 16.466664],
              [73.343821, 16.47194],
              [73.344393, 16.475034],
              [73.341026, 16.476921],
              [73.336716, 16.476491],
              [73.334348, 16.478503],
              [73.332214, 16.486828],
              [73.327475, 16.510026],
              [73.319939, 16.511948],
              [73.319237, 16.512831],
              [73.318241, 16.516674],
              [73.314159, 16.532695],
              [73.313853, 16.535103],
              [73.313902, 16.536277],
              [73.314579, 16.538763],
              [73.323007, 16.552927],
              [73.324979, 16.554887],
              [73.331451, 16.557038],
              [73.336049, 16.557888],
              [73.341119, 16.560588],
              [73.34735, 16.540756],
              [73.352435, 16.529371],
              [73.358006, 16.522238],
              [73.361075, 16.520113],
              [73.362344, 16.518494],
              [73.365544, 16.516101],
              [73.370606, 16.514569],
              [73.375318, 16.512276],
              [73.380704, 16.511486],
              [73.388793, 16.510121],
              [73.398025, 16.508835],
              [73.404521, 16.508477],
              [73.407897, 16.509419],
              [73.411998, 16.510759],
              [73.416843, 16.512517],
              [73.420327, 16.511615],
              [73.424267, 16.50964],
              [73.42908, 16.505884],
              [73.436302, 16.500044],
              [73.445626, 16.497286],
              [73.455328, 16.494539],
              [73.462741, 16.493609],
              [73.465306, 16.493285],
              [73.469438, 16.494268],
              [73.470146, 16.494785],
              [73.471231, 16.494749],
              [73.475413, 16.495706],
              [73.480426, 16.49914],
              [73.48284, 16.506359],
              [73.485728, 16.511005],
              [73.488714, 16.514549],
              [73.494989, 16.518496],
              [73.501018, 16.520311],
              [73.513626, 16.51556],
              [73.519617, 16.52329],
              [73.522245, 16.524084],
              [73.526646, 16.523835],
              [73.541015, 16.51489],
              [73.542932, 16.515222],
              [73.552552, 16.521217],
              [73.554825, 16.523904],
              [73.571481, 16.531478],
              [73.573109, 16.535665],
              [73.57689, 16.540818],
              [73.581194, 16.543384],
              [73.591267, 16.543232],
              [73.596089, 16.542467],
              [73.605764, 16.548287],
              [73.610377, 16.552627],
              [73.612301, 16.555898],
              [73.613633, 16.560314],
              [73.614664, 16.573744],
              [73.62053, 16.577798],
              [73.621619, 16.581067],
              [73.623592, 16.582663],
              [73.633109, 16.579701],
              [73.63518, 16.576303],
              [73.637498, 16.564863],
              [73.639332, 16.562678],
              [73.643738, 16.562536],
              [73.648515, 16.564531],
              [73.649657, 16.566474],
              [73.648681, 16.573258],
              [73.649946, 16.574914],
              [73.654356, 16.575927],
              [73.66145, 16.575902],
              [73.662591, 16.578193],
              [73.667454, 16.583288],
              [73.663962, 16.588352],
              [73.670988, 16.587463],
              [73.676775, 16.598571],
              [73.677499, 16.610114],
              [73.685928, 16.614377],
              [73.688102, 16.618164],
              [73.689733, 16.623899],
              [73.702746, 16.625499],
              [73.707739, 16.614337],
              [73.710588, 16.611403],
              [73.715104, 16.610404],
              [73.718804, 16.610496],
              [73.719203, 16.607057],
              [73.72508, 16.603352],
              [73.735154, 16.604333],
              [73.740199, 16.601498],
              [73.744849, 16.600331],
              [73.755579, 16.600965],
              [73.759986, 16.600318],
              [73.76565, 16.601544],
              [73.768103, 16.603375],
              [73.767689, 16.612849],
              [73.768312, 16.617152],
              [73.771018, 16.621387],
              [73.771941, 16.624948],
              [73.774979, 16.624533],
              [73.773478, 16.632517],
              [73.771655, 16.637175],
              [73.767285, 16.643001],
              [73.76653, 16.645586],
              [73.768167, 16.659763],
              [73.772781, 16.662671],
              [73.780575, 16.661653],
              [73.783371, 16.659741],
            ],
          ],
          [
            [
              [73.462703, 16.037102],
              [73.461776, 16.035731],
              [73.456493, 16.03779],
              [73.455834, 16.041668],
              [73.455172, 16.045699],
              [73.455986, 16.047063],
              [73.45622, 16.047535],
              [73.458064, 16.048018],
              [73.459595, 16.047586],
              [73.460803, 16.04645],
              [73.461704, 16.042012],
              [73.462703, 16.037102],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 528,
        censuscode: 529,
        dt_cen_cd: 33,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Sindhudurg",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [72.877693, 20.2264],
              [72.888861, 20.222229],
              [72.894416, 20.226779],
              [72.899933, 20.226609],
              [72.911308, 20.224115],
              [72.917559, 20.223887],
              [72.93099, 20.218304],
              [72.950086, 20.214507],
              [72.958556, 20.211365],
              [72.959738, 20.21279],
              [72.965227, 20.190056],
              [72.965488, 20.180482],
              [72.975365, 20.176999],
              [72.976022, 20.171761],
              [72.975261, 20.157981],
              [72.962453, 20.131283],
              [72.968867, 20.125785],
              [72.974588, 20.11392],
              [72.978523, 20.113677],
              [72.983461, 20.114354],
              [72.993664, 20.118361],
              [72.996003, 20.12169],
              [72.997136, 20.126824],
              [72.997008, 20.132906],
              [72.998143, 20.137441],
              [72.999906, 20.140642],
              [73.006886, 20.135381],
              [73.006086, 20.130912],
              [73.004389, 20.125282],
              [72.999556, 20.110833],
              [73.00895, 20.105451],
              [73.014095, 20.096725],
              [73.021175, 20.084837],
              [73.027981, 20.078504],
              [73.034724, 20.072177],
              [73.042294, 20.068065],
              [73.048728, 20.068324],
              [73.047531, 20.097099],
              [73.050213, 20.099433],
              [73.067844, 20.095618],
              [73.077992, 20.094799],
              [73.088175, 20.09399],
              [73.094907, 20.087531],
              [73.097687, 20.087635],
              [73.100142, 20.084916],
              [73.101594, 20.083318],
              [73.107325, 20.07911],
              [73.11293, 20.078237],
              [73.117566, 20.078449],
              [73.121245, 20.079728],
              [73.126571, 20.085526],
              [73.129425, 20.084544],
              [73.134376, 20.078125],
              [73.146695, 20.074215],
              [73.153273, 20.073355],
              [73.160226, 20.065855],
              [73.165397, 20.058288],
              [73.171459, 20.051851],
              [73.175918, 20.05312],
              [73.18901, 20.062468],
              [73.188166, 20.07801],
              [73.197087, 20.083888],
              [73.204144, 20.090809],
              [73.209347, 20.097656],
              [73.207972, 20.106499],
              [73.206566, 20.122156],
              [73.211756, 20.120943],
              [73.217012, 20.122726],
              [73.220649, 20.128301],
              [73.219832, 20.1333],
              [73.220791, 20.137842],
              [73.222961, 20.140724],
              [73.225831, 20.141121],
              [73.227252, 20.137042],
              [73.227014, 20.129853],
              [73.228465, 20.128244],
              [73.234284, 20.129159],
              [73.244024, 20.128626],
              [73.246563, 20.127993],
              [73.249897, 20.124743],
              [73.249834, 20.120806],
              [73.25396, 20.112936],
              [73.257215, 20.110576],
              [73.268948, 20.107588],
              [73.271958, 20.104947],
              [73.273197, 20.09707],
              [73.272631, 20.093796],
              [73.274434, 20.087868],
              [73.273661, 20.083449],
              [73.271932, 20.081433],
              [73.269124, 20.080863],
              [73.265942, 20.078678],
              [73.263678, 20.076501],
              [73.26316, 20.073855],
              [73.268479, 20.071661],
              [73.265004, 20.063445],
              [73.265528, 20.060795],
              [73.268603, 20.056713],
              [73.270026, 20.055811],
              [73.270791, 20.05533],
              [73.278575, 20.046597],
              [73.279731, 20.046644],
              [73.280994, 20.044923],
              [73.282857, 20.044765],
              [73.284522, 20.044633],
              [73.285556, 20.04624],
              [73.284544, 20.049348],
              [73.285713, 20.050551],
              [73.289366, 20.048654],
              [73.291212, 20.049747],
              [73.290148, 20.054862],
              [73.290346, 20.058078],
              [73.292692, 20.060038],
              [73.295579, 20.060492],
              [73.298272, 20.058365],
              [73.302677, 20.050898],
              [73.305025, 20.05107],
              [73.305829, 20.05308],
              [73.308542, 20.055834],
              [73.311194, 20.057324],
              [73.313397, 20.054626],
              [73.313891, 20.052444],
              [73.315867, 20.049512],
              [73.32172, 20.045664],
              [73.333533, 20.039675],
              [73.335968, 20.039844],
              [73.340291, 20.041569],
              [73.346183, 20.03668],
              [73.352557, 20.039196],
              [73.356429, 20.038685],
              [73.360347, 20.034657],
              [73.363376, 20.035119],
              [73.364439, 20.020982],
              [73.373109, 20.014724],
              [73.375998, 20.016732],
              [73.37531, 20.020295],
              [73.377401, 20.025462],
              [73.380084, 20.024033],
              [73.382096, 20.021848],
              [73.384288, 20.014331],
              [73.386434, 20.013414],
              [73.389792, 20.019318],
              [73.390761, 20.019548],
              [73.398301, 20.016714],
              [73.405887, 20.016915],
              [73.411082, 20.012675],
              [73.413493, 20.009435],
              [73.416553, 20.004749],
              [73.417211, 20.00104],
              [73.420627, 19.99141],
              [73.426123, 19.984581],
              [73.436674, 19.980336],
              [73.44407, 19.979813],
              [73.4525, 19.981992],
              [73.451087, 19.972933],
              [73.448518, 19.966055],
              [73.454867, 19.959107],
              [73.452732, 19.956417],
              [73.448544, 19.955043],
              [73.441935, 19.95424],
              [73.442946, 19.946556],
              [73.442446, 19.940707],
              [73.440241, 19.934577],
              [73.438472, 19.931021],
              [73.434335, 19.926034],
              [73.423701, 19.91566],
              [73.423685, 19.910613],
              [73.426456, 19.905968],
              [73.428067, 19.894847],
              [73.43528, 19.872933],
              [73.42703, 19.869549],
              [73.418347, 19.86417],
              [73.416761, 19.859751],
              [73.416737, 19.852125],
              [73.418003, 19.848341],
              [73.417927, 19.842601],
              [73.420941, 19.836755],
              [73.422638, 19.835314],
              [73.428868, 19.832388],
              [73.435835, 19.830552],
              [73.442789, 19.825447],
              [73.443818, 19.783986],
              [73.4449, 19.777898],
              [73.446704, 19.773141],
              [73.45074, 19.767234],
              [73.458601, 19.760808],
              [73.461924, 19.75948],
              [73.475733, 19.757639],
              [73.492341, 19.759632],
              [73.500937, 19.758706],
              [73.50394, 19.750961],
              [73.503872, 19.74792],
              [73.504952, 19.744254],
              [73.504214, 19.741956],
              [73.504926, 19.736565],
              [73.503575, 19.731693],
              [73.507087, 19.729795],
              [73.490637, 19.720062],
              [73.491292, 19.714558],
              [73.493767, 19.712151],
              [73.499878, 19.71053],
              [73.505015, 19.707262],
              [73.517773, 19.703351],
              [73.520253, 19.701799],
              [73.522711, 19.693885],
              [73.526759, 19.691815],
              [73.531284, 19.685907],
              [73.532412, 19.680677],
              [73.544289, 19.665817],
              [73.546815, 19.659215],
              [73.551629, 19.650266],
              [73.556338, 19.646934],
              [73.558742, 19.644235],
              [73.563703, 19.642337],
              [73.567025, 19.621457],
              [73.565976, 19.616531],
              [73.576383, 19.616282],
              [73.582476, 19.612257],
              [73.586463, 19.608645],
              [73.577594, 19.601424],
              [73.57959, 19.600276],
              [73.590191, 19.601409],
              [73.595566, 19.599965],
              [73.620211, 19.587029],
              [73.62165, 19.583014],
              [73.628684, 19.572561],
              [73.629793, 19.5631],
              [73.627548, 19.546408],
              [73.626208, 19.542743],
              [73.635143, 19.538949],
              [73.635121, 19.53281],
              [73.637171, 19.530744],
              [73.63967, 19.536416],
              [73.656487, 19.534777],
              [73.663176, 19.529033],
              [73.665401, 19.526047],
              [73.668631, 19.517495],
              [73.668376, 19.514289],
              [73.679075, 19.512202],
              [73.682421, 19.517524],
              [73.686526, 19.516142],
              [73.688795, 19.508853],
              [73.699668, 19.50522],
              [73.703332, 19.500107],
              [73.709247, 19.496314],
              [73.707316, 19.483012],
              [73.697027, 19.481829],
              [73.696021, 19.472883],
              [73.689777, 19.46911],
              [73.675786, 19.462593],
              [73.681867, 19.457138],
              [73.686949, 19.44376],
              [73.690915, 19.439281],
              [73.707448, 19.431565],
              [73.724189, 19.431074],
              [73.72903, 19.430258],
              [73.726687, 19.420053],
              [73.729921, 19.414482],
              [73.733474, 19.411607],
              [73.736566, 19.411945],
              [73.741154, 19.410674],
              [73.752934, 19.409442],
              [73.755295, 19.396987],
              [73.766036, 19.393867],
              [73.771962, 19.395401],
              [73.77435, 19.388119],
              [73.779666, 19.3873],
              [73.781649, 19.385975],
              [73.790494, 19.364614],
              [73.795609, 19.34843],
              [73.798029, 19.336153],
              [73.796977, 19.330704],
              [73.794368, 19.330257],
              [73.792695, 19.333696],
              [73.789081, 19.335714],
              [73.787507, 19.335607],
              [73.785567, 19.334232],
              [73.774838, 19.339587],
              [73.77449, 19.329955],
              [73.753522, 19.327255],
              [73.748376, 19.327381],
              [73.750088, 19.331047],
              [73.752766, 19.334139],
              [73.716051, 19.326527],
              [73.708424, 19.323387],
              [73.70109, 19.316178],
              [73.687228, 19.31093],
              [73.682913, 19.304911],
              [73.673907, 19.302638],
              [73.672018, 19.300462],
              [73.670496, 19.296449],
              [73.670114, 19.29261],
              [73.671669, 19.288188],
              [73.680388, 19.278706],
              [73.683691, 19.274053],
              [73.690737, 19.269628],
              [73.695214, 19.257625],
              [73.696118, 19.256767],
              [73.693123, 19.248686],
              [73.690445, 19.244277],
              [73.686878, 19.241816],
              [73.680099, 19.239309],
              [73.674061, 19.238914],
              [73.665194, 19.240082],
              [73.662523, 19.239104],
              [73.65543, 19.230461],
              [73.652998, 19.225993],
              [73.648622, 19.219454],
              [73.636325, 19.209847],
              [73.633154, 19.202162],
              [73.630198, 19.201764],
              [73.626786, 19.20986],
              [73.614219, 19.20626],
              [73.609016, 19.189353],
              [73.597377, 19.191544],
              [73.596517, 19.187366],
              [73.570632, 19.18929],
              [73.567789, 19.188144],
              [73.566681, 19.182064],
              [73.562823, 19.184134],
              [73.554363, 19.18197],
              [73.548151, 19.184953],
              [73.544465, 19.18295],
              [73.544673, 19.174583],
              [73.542143, 19.17464],
              [73.539315, 19.17665],
              [73.539609, 19.173668],
              [73.538582, 19.174299],
              [73.540554, 19.16822],
              [73.540649, 19.159846],
              [73.537389, 19.159963],
              [73.534003, 19.158703],
              [73.533022, 19.155547],
              [73.533194, 19.150387],
              [73.537035, 19.144306],
              [73.539326, 19.143269],
              [73.542649, 19.144471],
              [73.545052, 19.142574],
              [73.545651, 19.139078],
              [73.541442, 19.126631],
              [73.541122, 19.122851],
              [73.53961, 19.121817],
              [73.534447, 19.127849],
              [73.531492, 19.129568],
              [73.527384, 19.129174],
              [73.51466, 19.130672],
              [73.50681, 19.129016],
              [73.494982, 19.128284],
              [73.486575, 19.124736],
              [73.482917, 19.130184],
              [73.47261, 19.134898],
              [73.459379, 19.130374],
              [73.454801, 19.131875],
              [73.44569, 19.132683],
              [73.441036, 19.129184],
              [73.432155, 19.127467],
              [73.413036, 19.130111],
              [73.4023, 19.134649],
              [73.3933, 19.132074],
              [73.390111, 19.132304],
              [73.384922, 19.131735],
              [73.375795, 19.127377],
              [73.372536, 19.12898],
              [73.359151, 19.129727],
              [73.350147, 19.128696],
              [73.332698, 19.121071],
              [73.327439, 19.119632],
              [73.323513, 19.117056],
              [73.317108, 19.110002],
              [73.310943, 19.107359],
              [73.310703, 19.105237],
              [73.318461, 19.093652],
              [73.316807, 19.08201],
              [73.312158, 19.081205],
              [73.308301, 19.08201],
              [73.30498, 19.081492],
              [73.302921, 19.075061],
              [73.300323, 19.074953],
              [73.298273, 19.076903],
              [73.299913, 19.082177],
              [73.297983, 19.082975],
              [73.294974, 19.082983],
              [73.291292, 19.085443],
              [73.28767, 19.085617],
              [73.281574, 19.083545],
              [73.279413, 19.084523],
              [73.272215, 19.078552],
              [73.262901, 19.066054],
              [73.257959, 19.064841],
              [73.251084, 19.065989],
              [73.249994, 19.064894],
              [73.246551, 19.063864],
              [73.238779, 19.069079],
              [73.234986, 19.07349],
              [73.231685, 19.08152],
              [73.227773, 19.088177],
              [73.215235, 19.096714],
              [73.212886, 19.099748],
              [73.21042, 19.105196],
              [73.205424, 19.111845],
              [73.202474, 19.12165],
              [73.198013, 19.124743],
              [73.194635, 19.125029],
              [73.191314, 19.124169],
              [73.187938, 19.122221],
              [73.18153, 19.117395],
              [73.178391, 19.110678],
              [73.17676, 19.109017],
              [73.15413, 19.11301],
              [73.148953, 19.118396],
              [73.147688, 19.12361],
              [73.144073, 19.126016],
              [73.140629, 19.124237],
              [73.130358, 19.110117],
              [73.126677, 19.109427],
              [73.121846, 19.110048],
              [73.117263, 19.108953],
              [73.112254, 19.109747],
              [73.109666, 19.111406],
              [73.101459, 19.107498],
              [73.096991, 19.108297],
              [73.095725, 19.11237],
              [73.092894, 19.114315],
              [73.088722, 19.115343],
              [73.084626, 19.114646],
              [73.072188, 19.112047],
              [73.067784, 19.110437],
              [73.064047, 19.110609],
              [73.058251, 19.104232],
              [73.048174, 19.099917],
              [73.046906, 19.097899],
              [73.042727, 19.07128],
              [73.04822, 19.051383],
              [73.048569, 19.040374],
              [73.047718, 19.033259],
              [73.048265, 19.027579],
              [73.046405, 19.018498],
              [73.04609, 19.016971],
              [73.043076, 19.013183],
              [73.034985, 19.006915],
              [73.031195, 19.000117],
              [73.030789, 18.999661],
              [73.025732, 18.993881],
              [73.01739, 18.989354],
              [73.008962, 18.986727],
              [72.99981, 18.987503],
              [72.979814, 18.989212],
              [72.962631, 18.987895],
              [72.958587, 18.987335],
              [72.961547, 18.999788],
              [72.975019, 19.02462],
              [72.978525, 19.032716],
              [72.979184, 19.041036],
              [72.97804, 19.047232],
              [72.971987, 19.05963],
              [72.970303, 19.066805],
              [72.968725, 19.074722],
              [72.969395, 19.081432],
              [72.967762, 19.093551],
              [72.970299, 19.111746],
              [72.973139, 19.120014],
              [72.979607, 19.13374],
              [72.982508, 19.144875],
              [72.983351, 19.151311],
              [72.982869, 19.15602],
              [72.979737, 19.161553],
              [72.974534, 19.170766],
              [72.972941, 19.173559],
              [72.971138, 19.176744],
              [72.963518, 19.181441],
              [72.955895, 19.183341],
              [72.948342, 19.186604],
              [72.937335, 19.189713],
              [72.937264, 19.205038],
              [72.927466, 19.213243],
              [72.921832, 19.221447],
              [72.911424, 19.234189],
              [72.906764, 19.241871],
              [72.907614, 19.246755],
              [72.892727, 19.249669],
              [72.888489, 19.251155],
              [72.873787, 19.259702],
              [72.867002, 19.26498],
              [72.856478, 19.269217],
              [72.856356, 19.269182],
              [72.842203, 19.265989],
              [72.838084, 19.263856],
              [72.837009, 19.25284],
              [72.835256, 19.249282],
              [72.829087, 19.245429],
              [72.824788, 19.244677],
              [72.818203, 19.245473],
              [72.805591, 19.256396],
              [72.800335, 19.260957],
              [72.79586, 19.259684],
              [72.790598, 19.260077],
              [72.781523, 19.263249],
              [72.781283, 19.267697],
              [72.782473, 19.273642],
              [72.78314, 19.277594],
              [72.783092, 19.279571],
              [72.782869, 19.280698],
              [72.782998, 19.28526],
              [72.783572, 19.28987],
              [72.7842, 19.298202],
              [72.784351, 19.299922],
              [72.79394, 19.304144],
              [72.797845, 19.318633],
              [72.800084, 19.330324],
              [72.79694, 19.332503],
              [72.795856, 19.333282],
              [72.79002, 19.337227],
              [72.77669, 19.352347],
              [72.775476, 19.353516],
              [72.765976, 19.363261],
              [72.757584, 19.37368],
              [72.755247, 19.37844],
              [72.754418, 19.382283],
              [72.758706, 19.38913],
              [72.75773, 19.398743],
              [72.755825, 19.417017],
              [72.753237, 19.432383],
              [72.749128, 19.448687],
              [72.746604, 19.462125],
              [72.745802, 19.464036],
              [72.748652, 19.485928],
              [72.743342, 19.492935],
              [72.73028, 19.500128],
              [72.730207, 19.511263],
              [72.730216, 19.512781],
              [72.728414, 19.51511],
              [72.728042, 19.519486],
              [72.728025, 19.520148],
              [72.720547, 19.527855],
              [72.718278, 19.530724],
              [72.715399, 19.534586],
              [72.713082, 19.539955],
              [72.711781, 19.546907],
              [72.709593, 19.553076],
              [72.709825, 19.566635],
              [72.71028, 19.569978],
              [72.710745, 19.573634],
              [72.711528, 19.575662],
              [72.711681, 19.577346],
              [72.711738, 19.581144],
              [72.712413, 19.583433],
              [72.713215, 19.585728],
              [72.713144, 19.586755],
              [72.713987, 19.590124],
              [72.715741, 19.593814],
              [72.718973, 19.598639],
              [72.720376, 19.599683],
              [72.721171, 19.602063],
              [72.721178, 19.603489],
              [72.721176, 19.609668],
              [72.721185, 19.616527],
              [72.720268, 19.619242],
              [72.704962, 19.630428],
              [72.703768, 19.633614],
              [72.700811, 19.637526],
              [72.699971, 19.640097],
              [72.699042, 19.640749],
              [72.696826, 19.647698],
              [72.694884, 19.656858],
              [72.694806, 19.662139],
              [72.694737, 19.667879],
              [72.697171, 19.673678],
              [72.697078, 19.674296],
              [72.697391, 19.676784],
              [72.697793, 19.67996],
              [72.699072, 19.681253],
              [72.699554, 19.681468],
              [72.702038, 19.682075],
              [72.703203, 19.680977],
              [72.70371, 19.682364],
              [72.704156, 19.683754],
              [72.708447, 19.683848],
              [72.712399, 19.685035],
              [72.71283, 19.68542],
              [72.714229, 19.686687],
              [72.714349, 19.690819],
              [72.713945, 19.69341],
              [72.712477, 19.6948],
              [72.712686, 19.696138],
              [72.706729, 19.705711],
              [72.70628, 19.706144],
              [72.70555, 19.707277],
              [72.699265, 19.71331],
              [72.695513, 19.716925],
              [72.693418, 19.717972],
              [72.69091, 19.716701],
              [72.687868, 19.717071],
              [72.685267, 19.71701],
              [72.67977, 19.713701],
              [72.678461, 19.713664],
              [72.676071, 19.714048],
              [72.675777, 19.72006],
              [72.675288, 19.73121],
              [72.676224, 19.734647],
              [72.677697, 19.739851],
              [72.677671, 19.745955],
              [72.671202, 19.751368],
              [72.669957, 19.758576],
              [72.669815, 19.759348],
              [72.670922, 19.761885],
              [72.671884, 19.762461],
              [72.674106, 19.763772],
              [72.677185, 19.765805],
              [72.68004, 19.767965],
              [72.682166, 19.769268],
              [72.685215, 19.772278],
              [72.686804, 19.773609],
              [72.686336, 19.776694],
              [72.685722, 19.792706],
              [72.686769, 19.79374],
              [72.710167, 19.800028],
              [72.713477, 19.80169],
              [72.722391, 19.813419],
              [72.722746, 19.819068],
              [72.720633, 19.821734],
              [72.719664, 19.821942],
              [72.709722, 19.818115],
              [72.709622, 19.817328],
              [72.709355, 19.816427],
              [72.699413, 19.809956],
              [72.694874, 19.809747],
              [72.692044, 19.810693],
              [72.689503, 19.811141],
              [72.686967, 19.811332],
              [72.684852, 19.810278],
              [72.684516, 19.807993],
              [72.683985, 19.805703],
              [72.682453, 19.804657],
              [72.680113, 19.804862],
              [72.677355, 19.806318],
              [72.675918, 19.809065],
              [72.673104, 19.812536],
              [72.669694, 19.816502],
              [72.665067, 19.821691],
              [72.66434, 19.82042],
              [72.663224, 19.818122],
              [72.660515, 19.809718],
              [72.658983, 19.808674],
              [72.657194, 19.809897],
              [72.655005, 19.812126],
              [72.653565, 19.814871],
              [72.652128, 19.817876],
              [72.651817, 19.820655],
              [72.644416, 19.838997],
              [72.64293, 19.851153],
              [72.645143, 19.863421],
              [72.644397, 19.869048],
              [72.64928, 19.869945],
              [72.650492, 19.869301],
              [72.651543, 19.862948],
              [72.653193, 19.861348],
              [72.655861, 19.860495],
              [72.667, 19.86369],
              [72.669761, 19.867601],
              [72.671462, 19.870011],
              [72.672768, 19.873326],
              [72.67148, 19.887142],
              [72.671277, 19.889322],
              [72.669824, 19.892824],
              [72.669114, 19.894068],
              [72.66961, 19.894633],
              [72.667705, 19.89805],
              [72.665763, 19.900057],
              [72.663278, 19.917834],
              [72.65768, 19.922235],
              [72.653967, 19.930898],
              [72.653234, 19.932714],
              [72.651811, 19.934245],
              [72.650838, 19.936312],
              [72.650448, 19.942412],
              [72.653742, 19.944756],
              [72.655167, 19.944992],
              [72.66554, 19.942522],
              [72.668866, 19.9426],
              [72.66998, 19.943362],
              [72.675046, 19.946986],
              [72.675642, 19.946682],
              [72.676402, 19.947384],
              [72.677319, 19.947478],
              [72.680228, 19.949751],
              [72.680608, 19.950053],
              [72.681651, 19.951434],
              [72.684336, 19.960362],
              [72.686605, 19.961104],
              [72.688757, 19.960685],
              [72.696032, 19.961408],
              [72.699133, 19.961933],
              [72.704385, 19.96681],
              [72.705331, 19.967606],
              [72.707967, 19.968361],
              [72.710507, 19.96185],
              [72.711171, 19.954421],
              [72.715074, 19.952123],
              [72.720331, 19.952589],
              [72.72097, 19.952648],
              [72.721983, 19.952629],
              [72.723909, 19.951543],
              [72.724534, 19.945676],
              [72.722553, 19.944162],
              [72.720651, 19.943667],
              [72.72007, 19.942635],
              [72.724375, 19.937451],
              [72.725007, 19.936662],
              [72.725772, 19.933927],
              [72.725975, 19.932532],
              [72.726883, 19.928324],
              [72.728285, 19.924542],
              [72.729926, 19.923087],
              [72.73263, 19.922713],
              [72.736505, 19.922587],
              [72.738056, 19.92131],
              [72.737119, 19.918232],
              [72.734494, 19.915111],
              [72.733894, 19.912256],
              [72.734794, 19.909659],
              [72.737554, 19.907095],
              [72.739768, 19.906055],
              [72.742435, 19.907207],
              [72.743695, 19.910949],
              [72.745333, 19.912729],
              [72.747179, 19.91321],
              [72.749554, 19.912392],
              [72.751487, 19.909371],
              [72.752576, 19.905902],
              [72.753908, 19.902964],
              [72.754029, 19.898164],
              [72.75383, 19.892479],
              [72.75361, 19.887667],
              [72.75373, 19.882425],
              [72.756739, 19.8838],
              [72.75928, 19.889981],
              [72.761886, 19.893531],
              [72.762546, 19.89441],
              [72.767547, 19.896277],
              [72.772582, 19.897263],
              [72.773549, 19.899026],
              [72.771814, 19.900743],
              [72.767396, 19.902827],
              [72.765761, 19.903773],
              [72.770745, 19.907179],
              [72.769646, 19.910657],
              [72.768034, 19.914554],
              [72.76606, 19.919533],
              [72.763736, 19.925374],
              [72.762467, 19.929063],
              [72.762276, 19.929714],
              [72.762519, 19.933653],
              [72.763296, 19.936511],
              [72.765972, 19.937221],
              [72.769501, 19.937744],
              [72.770487, 19.938855],
              [72.769905, 19.941903],
              [72.769284, 19.946479],
              [72.767022, 19.949479],
              [72.765657, 19.950326],
              [72.763476, 19.94962],
              [72.759802, 19.948231],
              [72.757971, 19.947537],
              [72.756113, 19.947927],
              [72.754904, 19.948773],
              [72.754366, 19.950076],
              [72.753265, 19.953987],
              [72.753356, 19.95704],
              [72.754865, 19.957299],
              [72.759397, 19.958272],
              [72.764308, 19.957287],
              [72.767522, 19.956705],
              [72.76882, 19.958921],
              [72.768576, 19.961753],
              [72.767609, 19.96697],
              [72.765906, 19.971167],
              [72.764193, 19.974652],
              [72.761922, 19.9786],
              [72.760025, 19.981494],
              [72.75882, 19.982156],
              [72.758089, 19.982139],
              [72.752497, 19.981441],
              [72.749446, 19.978663],
              [72.747581, 19.976485],
              [72.747227, 19.972041],
              [72.744211, 19.971973],
              [72.740612, 19.973021],
              [72.737611, 19.978737],
              [72.735716, 19.97757],
              [72.735615, 19.97679],
              [72.73399, 19.974507],
              [72.731831, 19.975579],
              [72.730997, 19.975656],
              [72.727917, 19.983505],
              [72.725629, 19.983334],
              [72.724622, 19.981154],
              [72.721382, 19.977459],
              [72.720246, 19.978789],
              [72.719541, 19.979003],
              [72.7195, 19.984463],
              [72.718776, 19.98532],
              [72.718807, 19.986141],
              [72.719392, 19.986961],
              [72.719124, 19.991117],
              [72.719238, 19.992404],
              [72.71973, 19.992187],
              [72.719735, 19.995742],
              [72.720056, 19.999522],
              [72.718449, 20.006063],
              [72.717614, 20.010513],
              [72.71626, 20.014004],
              [72.714851, 20.016439],
              [72.715187, 20.019591],
              [72.7169, 20.023255],
              [72.717969, 20.024131],
              [72.723233, 20.027462],
              [72.724181, 20.028839],
              [72.724945, 20.036319],
              [72.724235, 20.036303],
              [72.724441, 20.037662],
              [72.721483, 20.041659],
              [72.719206, 20.041177],
              [72.718661, 20.040589],
              [72.714685, 20.035165],
              [72.711779, 20.036688],
              [72.711136, 20.047002],
              [72.709436, 20.047632],
              [72.708751, 20.05365],
              [72.707242, 20.056699],
              [72.70522, 20.059824],
              [72.704038, 20.064319],
              [72.703705, 20.072166],
              [72.704234, 20.081041],
              [72.709567, 20.092474],
              [72.713301, 20.095987],
              [72.720804, 20.102792],
              [72.721024, 20.103534],
              [72.721816, 20.105757],
              [72.727167, 20.121576],
              [72.72816, 20.130426],
              [72.728644, 20.134815],
              [72.729275, 20.136807],
              [72.736564, 20.135224],
              [72.750113, 20.132299],
              [72.776015, 20.130836],
              [72.782917, 20.128925],
              [72.790326, 20.125744],
              [72.793689, 20.127739],
              [72.789732, 20.13854],
              [72.789164, 20.146003],
              [72.790562, 20.149202],
              [72.797668, 20.152516],
              [72.804434, 20.153985],
              [72.814627, 20.146958],
              [72.820909, 20.144702],
              [72.82399, 20.145315],
              [72.822809, 20.150411],
              [72.817468, 20.157257],
              [72.822295, 20.184243],
              [72.824217, 20.188331],
              [72.825964, 20.189342],
              [72.830927, 20.189519],
              [72.832241, 20.190696],
              [72.838434, 20.189898],
              [72.837802, 20.191582],
              [72.834467, 20.194793],
              [72.832879, 20.198435],
              [72.8349, 20.204217],
              [72.83906, 20.208573],
              [72.843888, 20.209736],
              [72.860872, 20.208843],
              [72.86176, 20.213108],
              [72.860785, 20.223164],
              [72.863452, 20.226403],
              [72.873256, 20.227162],
              [72.877693, 20.2264],
            ],
          ],
          [
            [
              [72.729576, 19.464293],
              [72.734306, 19.46203],
              [72.73569, 19.458867],
              [72.73599, 19.457771],
              [72.736043, 19.453365],
              [72.735354, 19.45266],
              [72.735354, 19.45266],
              [72.735354, 19.45266],
              [72.734177, 19.452412],
              [72.730648, 19.455155],
              [72.729315, 19.458136],
              [72.728908, 19.458838],
              [72.728078, 19.461271],
              [72.728038, 19.462973],
              [72.729576, 19.464293],
              [72.729576, 19.464293],
              [72.729576, 19.464293],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 562,
        censuscode: 517,
        dt_cen_cd: 21,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Thane",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [78.251274, 21.328596],
              [78.255994, 21.325041],
              [78.257887, 21.328211],
              [78.260271, 21.329366],
              [78.263888, 21.32661],
              [78.271356, 21.319614],
              [78.273074, 21.315139],
              [78.277484, 21.310213],
              [78.28447, 21.303959],
              [78.290156, 21.302591],
              [78.294998, 21.294619],
              [78.297999, 21.293017],
              [78.303752, 21.293087],
              [78.3081, 21.294242],
              [78.311282, 21.293951],
              [78.313423, 21.291831],
              [78.312816, 21.288613],
              [78.307378, 21.277527],
              [78.307495, 21.273793],
              [78.30976, 21.270011],
              [78.314413, 21.268696],
              [78.322789, 21.271516],
              [78.326227, 21.271177],
              [78.327263, 21.269574],
              [78.327572, 21.265209],
              [78.326595, 21.26073],
              [78.327261, 21.256189],
              [78.330142, 21.252522],
              [78.332957, 21.250575],
              [78.352841, 21.250886],
              [78.35657, 21.248426],
              [78.360485, 21.248198],
              [78.371805, 21.243271],
              [78.401166, 21.237681],
              [78.407042, 21.237518],
              [78.410531, 21.235963],
              [78.415606, 21.229136],
              [78.419394, 21.227763],
              [78.424103, 21.227534],
              [78.429116, 21.228344],
              [78.442512, 21.23468],
              [78.446552, 21.234106],
              [78.45566, 21.226192],
              [78.464837, 21.222975],
              [78.46966, 21.218442],
              [78.47266, 21.216782],
              [78.47817, 21.219543],
              [78.479813, 21.215412],
              [78.482501, 21.211793],
              [78.492766, 21.203014],
              [78.49515, 21.198992],
              [78.49863, 21.195778],
              [78.507004, 21.189805],
              [78.509263, 21.18522],
              [78.518482, 21.175051],
              [78.521531, 21.170004],
              [78.521647, 21.161789],
              [78.525729, 21.152892],
              [78.538422, 21.139858],
              [78.554949, 21.117864],
              [78.558667, 21.114765],
              [78.585369, 21.114998],
              [78.589705, 21.114655],
              [78.592811, 21.112131],
              [78.596472, 21.10857],
              [78.597187, 21.100983],
              [78.596573, 21.098171],
              [78.59908, 21.095641],
              [78.598634, 21.090128],
              [78.602113, 21.089038],
              [78.610668, 21.088524],
              [78.610416, 21.081911],
              [78.606918, 21.069223],
              [78.61443, 21.069106],
              [78.615466, 21.064281],
              [78.621085, 21.06738],
              [78.625184, 21.066974],
              [78.628057, 21.065024],
              [78.631716, 21.059567],
              [78.634405, 21.058246],
              [78.63936, 21.058478],
              [78.643217, 21.059511],
              [78.648042, 21.053712],
              [78.651099, 21.051469],
              [78.652061, 21.035901],
              [78.65737, 21.034466],
              [78.670699, 21.034172],
              [78.685838, 21.030163],
              [78.68858, 21.029442],
              [78.693919, 21.024912],
              [78.695164, 21.020145],
              [78.701375, 21.017558],
              [78.707836, 21.016687],
              [78.713237, 21.014717],
              [78.716255, 21.00916],
              [78.724348, 21.007663],
              [78.726008, 21.005195],
              [78.730942, 21.004614],
              [78.73118, 21.000524],
              [78.730985, 20.995274],
              [78.726171, 20.988342],
              [78.726648, 20.971798],
              [78.72692, 20.968702],
              [78.73194, 20.961845],
              [78.735089, 20.946988],
              [78.736948, 20.944647],
              [78.740015, 20.943405],
              [78.746112, 20.944073],
              [78.749423, 20.943233],
              [78.744338, 20.938899],
              [78.745962, 20.935401],
              [78.757395, 20.922094],
              [78.760788, 20.919186],
              [78.765896, 20.920934],
              [78.773732, 20.907604],
              [78.774011, 20.903416],
              [78.77294, 20.901165],
              [78.770029, 20.898903],
              [78.778471, 20.891199],
              [78.787892, 20.890289],
              [78.79188, 20.888184],
              [78.796203, 20.8835],
              [78.804818, 20.87672],
              [78.809707, 20.876115],
              [78.813002, 20.876305],
              [78.820489, 20.878875],
              [78.826438, 20.88879],
              [78.828557, 20.891109],
              [78.832132, 20.89308],
              [78.836408, 20.893674],
              [78.842472, 20.89061],
              [78.839818, 20.888181],
              [78.839566, 20.882379],
              [78.84111, 20.880432],
              [78.848804, 20.87479],
              [78.852956, 20.874297],
              [78.858867, 20.875258],
              [78.86218, 20.873836],
              [78.864705, 20.871321],
              [78.864001, 20.870138],
              [78.862743, 20.86785],
              [78.861221, 20.861008],
              [78.864025, 20.842178],
              [78.868827, 20.837374],
              [78.873002, 20.828896],
              [78.875039, 20.82672],
              [78.883717, 20.831483],
              [78.885638, 20.835113],
              [78.885775, 20.840966],
              [78.888447, 20.841784],
              [78.900556, 20.83922],
              [78.908504, 20.838344],
              [78.915919, 20.835121],
              [78.914912, 20.818273],
              [78.919063, 20.817383],
              [78.919777, 20.813093],
              [78.917043, 20.811638],
              [78.915501, 20.806406],
              [78.921126, 20.805244],
              [78.925673, 20.801538],
              [78.92803, 20.797418],
              [78.931817, 20.797836],
              [78.945344, 20.793797],
              [78.946739, 20.793926],
              [78.948506, 20.788617],
              [78.94897, 20.784615],
              [78.948436, 20.782369],
              [78.942111, 20.779995],
              [78.945159, 20.766975],
              [78.956872, 20.766809],
              [78.958177, 20.764093],
              [78.965736, 20.758275],
              [78.971713, 20.755232],
              [78.973701, 20.754223],
              [78.978946, 20.754192],
              [78.988891, 20.751668],
              [78.997526, 20.753885],
              [78.999957, 20.742415],
              [79.005074, 20.741063],
              [79.010389, 20.741298],
              [79.012684, 20.74232],
              [79.018, 20.739922],
              [79.019739, 20.736112],
              [79.037729, 20.734619],
              [79.041575, 20.73752],
              [79.045373, 20.734275],
              [79.052826, 20.734274],
              [79.05357, 20.726313],
              [79.060674, 20.722626],
              [79.069287, 20.722703],
              [79.074157, 20.723616],
              [79.076735, 20.715239],
              [79.086055, 20.713442],
              [79.08965, 20.711342],
              [79.092181, 20.70795],
              [79.098548, 20.709637],
              [79.104113, 20.712174],
              [79.109112, 20.696393],
              [79.106921, 20.685679],
              [79.131408, 20.678129],
              [79.142875, 20.675855],
              [79.145076, 20.66804],
              [79.146862, 20.667276],
              [79.1447, 20.660066],
              [79.149261, 20.658444],
              [79.150082, 20.657023],
              [79.149418, 20.651565],
              [79.151286, 20.650111],
              [79.170371, 20.643012],
              [79.171086, 20.641535],
              [79.169996, 20.638076],
              [79.171204, 20.635916],
              [79.171875, 20.630595],
              [79.170735, 20.624493],
              [79.175404, 20.623156],
              [79.176033, 20.619846],
              [79.180868, 20.616736],
              [79.183238, 20.61691],
              [79.186245, 20.618807],
              [79.186307, 20.613582],
              [79.188009, 20.611158],
              [79.188572, 20.602624],
              [79.19257, 20.596112],
              [79.195512, 20.600648],
              [79.209384, 20.597392],
              [79.212069, 20.594694],
              [79.213714, 20.593601],
              [79.220252, 20.589253],
              [79.224721, 20.582068],
              [79.221364, 20.579487],
              [79.221496, 20.565774],
              [79.217279, 20.556387],
              [79.216987, 20.551231],
              [79.214382, 20.546417],
              [79.19184, 20.532696],
              [79.186102, 20.524696],
              [79.182436, 20.515356],
              [79.179412, 20.510608],
              [79.171739, 20.512368],
              [79.1673, 20.505329],
              [79.163624, 20.487278],
              [79.160057, 20.482989],
              [79.156589, 20.476698],
              [79.146423, 20.479208],
              [79.139345, 20.477517],
              [79.136515, 20.466169],
              [79.130696, 20.454036],
              [79.121033, 20.450062],
              [79.113657, 20.45003],
              [79.102278, 20.452661],
              [79.097363, 20.455204],
              [79.096362, 20.459968],
              [79.089978, 20.461371],
              [79.076882, 20.462624],
              [79.063189, 20.466116],
              [79.057405, 20.466427],
              [79.051897, 20.46398],
              [79.048801, 20.46577],
              [79.045514, 20.466588],
              [79.046728, 20.473463],
              [79.040085, 20.474528],
              [79.030172, 20.477945],
              [79.023961, 20.478484],
              [79.017031, 20.472772],
              [79.011731, 20.464996],
              [79.001864, 20.447645],
              [78.999898, 20.448342],
              [78.999138, 20.44828],
              [78.998292, 20.454647],
              [78.992383, 20.456101],
              [78.989724, 20.462826],
              [78.988325, 20.462927],
              [78.989082, 20.459732],
              [78.98495, 20.45895],
              [78.983936, 20.456361],
              [78.968553, 20.458553],
              [78.968104, 20.45389],
              [78.969044, 20.450395],
              [78.963711, 20.436068],
              [78.960815, 20.433397],
              [78.95082, 20.428438],
              [78.939495, 20.428712],
              [78.919813, 20.430001],
              [78.916414, 20.429287],
              [78.907924, 20.432294],
              [78.899223, 20.437191],
              [78.892287, 20.430434],
              [78.879203, 20.423346],
              [78.871484, 20.421694],
              [78.865753, 20.422302],
              [78.856832, 20.425691],
              [78.852361, 20.42831],
              [78.846346, 20.433445],
              [78.841797, 20.431058],
              [78.842468, 20.424514],
              [78.84359, 20.421704],
              [78.848514, 20.416908],
              [78.856663, 20.411101],
              [78.855708, 20.408965],
              [78.853608, 20.406142],
              [78.843233, 20.401361],
              [78.826492, 20.4019],
              [78.823407, 20.399931],
              [78.820936, 20.396806],
              [78.819391, 20.392837],
              [78.819016, 20.387319],
              [78.822017, 20.379695],
              [78.822105, 20.370326],
              [78.828025, 20.362145],
              [78.827399, 20.358177],
              [78.823907, 20.353679],
              [78.823767, 20.349372],
              [78.825025, 20.346098],
              [78.833602, 20.33357],
              [78.833714, 20.328054],
              [78.830032, 20.3189],
              [78.825242, 20.316573],
              [78.811964, 20.312528],
              [78.805868, 20.306972],
              [78.801235, 20.301418],
              [78.801818, 20.297798],
              [78.791987, 20.295666],
              [78.784601, 20.297926],
              [78.780399, 20.299215],
              [78.776019, 20.298035],
              [78.769365, 20.294314],
              [78.760925, 20.293056],
              [78.754501, 20.295832],
              [78.748962, 20.296776],
              [78.740542, 20.292639],
              [78.738227, 20.292909],
              [78.736721, 20.302958],
              [78.734152, 20.304786],
              [78.720913, 20.307917],
              [78.708185, 20.309384],
              [78.708134, 20.313806],
              [78.710587, 20.317448],
              [78.711631, 20.322631],
              [78.710358, 20.327505],
              [78.710378, 20.332213],
              [78.712148, 20.337172],
              [78.711296, 20.349173],
              [78.709432, 20.352325],
              [78.692401, 20.356813],
              [78.690855, 20.359381],
              [78.689851, 20.368749],
              [78.6848, 20.374118],
              [78.682228, 20.381052],
              [78.668871, 20.388949],
              [78.666145, 20.393414],
              [78.661397, 20.404537],
              [78.657866, 20.410372],
              [78.657401, 20.413702],
              [78.647052, 20.419438],
              [78.645609, 20.423158],
              [78.647814, 20.427431],
              [78.647771, 20.431909],
              [78.640921, 20.43422],
              [78.626577, 20.431875],
              [78.619629, 20.431827],
              [78.616986, 20.434508],
              [78.615698, 20.440191],
              [78.611235, 20.442232],
              [78.608296, 20.438533],
              [78.608283, 20.433639],
              [78.607098, 20.430356],
              [78.603896, 20.428499],
              [78.590196, 20.428168],
              [78.577457, 20.429109],
              [78.570912, 20.432392],
              [78.563279, 20.438894],
              [78.558732, 20.44794],
              [78.553344, 20.450594],
              [78.539526, 20.460265],
              [78.537363, 20.463067],
              [78.535808, 20.471098],
              [78.537092, 20.475706],
              [78.535654, 20.479547],
              [78.525633, 20.487289],
              [78.524453, 20.489459],
              [78.524577, 20.50004],
              [78.523072, 20.503419],
              [78.521332, 20.506506],
              [78.516301, 20.509516],
              [78.509233, 20.51958],
              [78.502752, 20.522051],
              [78.498172, 20.522366],
              [78.492165, 20.525419],
              [78.485147, 20.526799],
              [78.480983, 20.528375],
              [78.47661, 20.527195],
              [78.469395, 20.523861],
              [78.465961, 20.520441],
              [78.454064, 20.511787],
              [78.449303, 20.512384],
              [78.444536, 20.513953],
              [78.44159, 20.515998],
              [78.43456, 20.517838],
              [78.422681, 20.512512],
              [78.412576, 20.511451],
              [78.404249, 20.51494],
              [78.39387, 20.516696],
              [78.386823, 20.519799],
              [78.381549, 20.527401],
              [78.378408, 20.530131],
              [78.373387, 20.531987],
              [78.369543, 20.532186],
              [78.359928, 20.526701],
              [78.356252, 20.528277],
              [78.350382, 20.534314],
              [78.347344, 20.538601],
              [78.344024, 20.54139],
              [78.34059, 20.54309],
              [78.336989, 20.543342],
              [78.309209, 20.552182],
              [78.298047, 20.557028],
              [78.29467, 20.559751],
              [78.287959, 20.559695],
              [78.279885, 20.562385],
              [78.277591, 20.564772],
              [78.273586, 20.573073],
              [78.268123, 20.575605],
              [78.263991, 20.57942],
              [78.262711, 20.588377],
              [78.259533, 20.594093],
              [78.258669, 20.60386],
              [78.25619, 20.607625],
              [78.252779, 20.615874],
              [78.25235, 20.621045],
              [78.253189, 20.626272],
              [78.252624, 20.632828],
              [78.249919, 20.643082],
              [78.250621, 20.645619],
              [78.251261, 20.647466],
              [78.255496, 20.650204],
              [78.266943, 20.661282],
              [78.269019, 20.665273],
              [78.270009, 20.669354],
              [78.268239, 20.678419],
              [78.277331, 20.687874],
              [78.278403, 20.693909],
              [78.279534, 20.696391],
              [78.281453, 20.698823],
              [78.286823, 20.699103],
              [78.289178, 20.700505],
              [78.292565, 20.698288],
              [78.296606, 20.696835],
              [78.299353, 20.700996],
              [78.301854, 20.710903],
              [78.300708, 20.714859],
              [78.30822, 20.72325],
              [78.311366, 20.734949],
              [78.311198, 20.738505],
              [78.307921, 20.742041],
              [78.306846, 20.744499],
              [78.306877, 20.747259],
              [78.310305, 20.758338],
              [78.308372, 20.763417],
              [78.29428, 20.777947],
              [78.293677, 20.781622],
              [78.294136, 20.783364],
              [78.296641, 20.792846],
              [78.295542, 20.802435],
              [78.299096, 20.805799],
              [78.299758, 20.811208],
              [78.304371, 20.813549],
              [78.311253, 20.814583],
              [78.31819, 20.820965],
              [78.317857, 20.823091],
              [78.314451, 20.826569],
              [78.312625, 20.831723],
              [78.309231, 20.834444],
              [78.30655, 20.834021],
              [78.304238, 20.833079],
              [78.302514, 20.829624],
              [78.300461, 20.827761],
              [78.296684, 20.826987],
              [78.293867, 20.827651],
              [78.292561, 20.829929],
              [78.292246, 20.839702],
              [78.291136, 20.840955],
              [78.28838, 20.841503],
              [78.284237, 20.841179],
              [78.281903, 20.842079],
              [78.279981, 20.843899],
              [78.278994, 20.845273],
              [78.275457, 20.858573],
              [78.272746, 20.865159],
              [78.265243, 20.869453],
              [78.255677, 20.886442],
              [78.252538, 20.887615],
              [78.250252, 20.88949],
              [78.247322, 20.889923],
              [78.242158, 20.892462],
              [78.23778, 20.895591],
              [78.233497, 20.896063],
              [78.227533, 20.89952],
              [78.223178, 20.900451],
              [78.215992, 20.908266],
              [78.212596, 20.90197],
              [78.204687, 20.899479],
              [78.19993, 20.899035],
              [78.184401, 20.904641],
              [78.183043, 20.906235],
              [78.182689, 20.90905],
              [78.181013, 20.911788],
              [78.178722, 20.913441],
              [78.178234, 20.922566],
              [78.177464, 20.925096],
              [78.176327, 20.927838],
              [78.172611, 20.931774],
              [78.172137, 20.934871],
              [78.16955, 20.940998],
              [78.167501, 20.943448],
              [78.152386, 20.949809],
              [78.148651, 20.950577],
              [78.146123, 20.952225],
              [78.148779, 20.962939],
              [78.150452, 20.966065],
              [78.149563, 20.985894],
              [78.148098, 20.990071],
              [78.143324, 20.994854],
              [78.139466, 20.999715],
              [78.138098, 21.000314],
              [78.137575, 21.004094],
              [78.139002, 21.007948],
              [78.14087, 21.011744],
              [78.146053, 21.018936],
              [78.147215, 21.022729],
              [78.146654, 21.02589],
              [78.140301, 21.034948],
              [78.142345, 21.03719],
              [78.147767, 21.039843],
              [78.151231, 21.044396],
              [78.15217, 21.047209],
              [78.150442, 21.056681],
              [78.152777, 21.063348],
              [78.153952, 21.071911],
              [78.153942, 21.074901],
              [78.152235, 21.078337],
              [78.147623, 21.099581],
              [78.145612, 21.102326],
              [78.136927, 21.103511],
              [78.134851, 21.105058],
              [78.132513, 21.110164],
              [78.132206, 21.11298],
              [78.133056, 21.11545],
              [78.137631, 21.121377],
              [78.140173, 21.131328],
              [78.144814, 21.135073],
              [78.145311, 21.137193],
              [78.142853, 21.140406],
              [78.134339, 21.146659],
              [78.130305, 21.148092],
              [78.12644, 21.151711],
              [78.119094, 21.156648],
              [78.116816, 21.159359],
              [78.110011, 21.164484],
              [78.098425, 21.175072],
              [78.094562, 21.176904],
              [78.093344, 21.180924],
              [78.099636, 21.187189],
              [78.09994, 21.193899],
              [78.098762, 21.199217],
              [78.087368, 21.211999],
              [78.077705, 21.216479],
              [78.073842, 21.219563],
              [78.071024, 21.224192],
              [78.074196, 21.228795],
              [78.071745, 21.235322],
              [78.068371, 21.238474],
              [78.060904, 21.238334],
              [78.058638, 21.240217],
              [78.055493, 21.249164],
              [78.05592, 21.25364],
              [78.05884, 21.262038],
              [78.061197, 21.274223],
              [78.06634, 21.277339],
              [78.075771, 21.273977],
              [78.078829, 21.274849],
              [78.081697, 21.277787],
              [78.082486, 21.282612],
              [78.08125, 21.286915],
              [78.079102, 21.289777],
              [78.075977, 21.292468],
              [78.072054, 21.294527],
              [78.068007, 21.298821],
              [78.068061, 21.302671],
              [78.070875, 21.305488],
              [78.075631, 21.313712],
              [78.079764, 21.328034],
              [78.078023, 21.340666],
              [78.076109, 21.347831],
              [78.074388, 21.350816],
              [78.07512, 21.353292],
              [78.081907, 21.35578],
              [78.090174, 21.356668],
              [78.096669, 21.353697],
              [78.100347, 21.353589],
              [78.105247, 21.354758],
              [78.112845, 21.349725],
              [78.116762, 21.348527],
              [78.124149, 21.347899],
              [78.131564, 21.344759],
              [78.139036, 21.34323],
              [78.144425, 21.34077],
              [78.150245, 21.341297],
              [78.15295, 21.337518],
              [78.155404, 21.331488],
              [78.15798, 21.329776],
              [78.178486, 21.331091],
              [78.202056, 21.329755],
              [78.22042, 21.33077],
              [78.231691, 21.326948],
              [78.251274, 21.328596],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 609,
        censuscode: 504,
        dt_cen_cd: 8,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Wardha",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [77.653073, 20.564183],
              [77.650228, 20.546712],
              [77.644882, 20.529203],
              [77.656042, 20.528415],
              [77.658701, 20.532237],
              [77.666673, 20.536976],
              [77.670406, 20.537177],
              [77.688121, 20.5334],
              [77.690429, 20.532059],
              [77.691084, 20.523329],
              [77.688906, 20.519449],
              [77.686766, 20.518034],
              [77.672881, 20.514947],
              [77.668603, 20.514933],
              [77.668465, 20.512923],
              [77.665107, 20.505382],
              [77.664751, 20.500109],
              [77.662895, 20.496854],
              [77.654953, 20.496063],
              [77.654021, 20.494701],
              [77.655039, 20.49165],
              [77.654843, 20.484478],
              [77.654318, 20.479669],
              [77.65032, 20.469662],
              [77.650704, 20.458873],
              [77.650922, 20.455771],
              [77.647571, 20.448974],
              [77.640564, 20.450131],
              [77.623656, 20.455848],
              [77.616688, 20.460786],
              [77.613558, 20.458579],
              [77.613749, 20.453119],
              [77.608372, 20.452197],
              [77.601352, 20.444853],
              [77.607137, 20.43609],
              [77.605337, 20.432716],
              [77.60233, 20.430106],
              [77.598289, 20.428358],
              [77.593379, 20.424562],
              [77.592868, 20.422615],
              [77.593941, 20.419391],
              [77.597251, 20.415227],
              [77.597536, 20.413048],
              [77.596362, 20.410537],
              [77.589666, 20.412659],
              [77.584966, 20.411608],
              [77.582506, 20.408766],
              [77.582177, 20.406586],
              [77.575474, 20.392533],
              [77.574383, 20.386283],
              [77.574905, 20.376812],
              [77.578151, 20.370993],
              [77.577085, 20.367845],
              [77.57134, 20.359055],
              [77.570334, 20.355282],
              [77.567799, 20.33769],
              [77.567643, 20.333327],
              [77.568472, 20.330112],
              [77.570418, 20.329121],
              [77.575601, 20.330389],
              [77.578592, 20.329962],
              [77.580331, 20.327769],
              [77.58092, 20.325643],
              [77.584392, 20.325322],
              [77.585759, 20.320892],
              [77.585359, 20.316188],
              [77.586652, 20.311306],
              [77.58906, 20.307782],
              [77.593661, 20.304302],
              [77.595156, 20.301245],
              [77.595599, 20.29642],
              [77.594998, 20.290461],
              [77.595949, 20.280583],
              [77.609338, 20.278115],
              [77.611649, 20.263918],
              [77.624598, 20.2614],
              [77.63319, 20.260686],
              [77.642872, 20.25349],
              [77.648938, 20.250963],
              [77.653508, 20.25069],
              [77.668582, 20.24757],
              [77.6667, 20.240994],
              [77.659621, 20.225565],
              [77.654609, 20.21052],
              [77.655082, 20.208797],
              [77.658997, 20.204119],
              [77.659835, 20.202045],
              [77.656706, 20.200005],
              [77.653169, 20.198834],
              [77.647883, 20.193602],
              [77.646636, 20.190054],
              [77.647649, 20.188206],
              [77.650553, 20.186746],
              [77.651822, 20.185192],
              [77.651361, 20.181693],
              [77.653721, 20.173584],
              [77.657004, 20.172972],
              [77.664989, 20.173931],
              [77.668817, 20.173609],
              [77.681374, 20.168852],
              [77.68165, 20.165696],
              [77.679227, 20.159923],
              [77.676861, 20.147891],
              [77.682978, 20.145768],
              [77.68424, 20.144434],
              [77.680545, 20.132877],
              [77.673572, 20.123304],
              [77.672327, 20.119929],
              [77.672761, 20.10874],
              [77.671737, 20.104267],
              [77.668586, 20.099991],
              [77.664666, 20.09779],
              [77.659229, 20.096464],
              [77.658275, 20.088039],
              [77.656226, 20.08077],
              [77.654422, 20.078209],
              [77.649551, 20.075666],
              [77.648496, 20.071598],
              [77.644238, 20.069634],
              [77.640244, 20.066455],
              [77.640628, 20.059164],
              [77.63464, 20.050666],
              [77.627002, 20.044999],
              [77.625928, 20.041271],
              [77.615056, 20.039819],
              [77.611536, 20.037729],
              [77.608312, 20.037818],
              [77.604907, 20.035667],
              [77.602573, 20.035342],
              [77.599592, 20.037498],
              [77.597127, 20.037286],
              [77.593338, 20.032438],
              [77.583386, 20.030866],
              [77.580904, 20.029743],
              [77.56878, 20.042875],
              [77.565517, 20.043247],
              [77.561358, 20.046553],
              [77.558631, 20.046352],
              [77.556938, 20.048315],
              [77.554579, 20.06159],
              [77.553383, 20.064184],
              [77.546317, 20.068257],
              [77.540461, 20.072783],
              [77.539277, 20.076176],
              [77.532673, 20.086741],
              [77.526101, 20.093963],
              [77.502865, 20.087279],
              [77.496129, 20.081539],
              [77.491119, 20.079685],
              [77.488269, 20.080796],
              [77.485859, 20.083573],
              [77.482935, 20.083935],
              [77.47558, 20.078947],
              [77.469807, 20.0732],
              [77.465884, 20.071221],
              [77.45585, 20.070329],
              [77.450225, 20.070892],
              [77.437618, 20.073745],
              [77.432989, 20.075846],
              [77.425732, 20.076875],
              [77.419833, 20.079728],
              [77.416125, 20.082742],
              [77.41217, 20.082602],
              [77.408141, 20.085623],
              [77.403983, 20.08485],
              [77.398472, 20.084892],
              [77.390363, 20.086269],
              [77.387137, 20.087505],
              [77.376939, 20.093782],
              [77.369455, 20.10101],
              [77.36795, 20.08828],
              [77.364031, 20.08309],
              [77.357193, 20.077689],
              [77.355464, 20.073967],
              [77.355178, 20.068182],
              [77.37052, 20.052169],
              [77.373218, 20.048188],
              [77.373766, 20.046182],
              [77.369745, 20.03869],
              [77.361618, 20.028367],
              [77.354468, 20.014065],
              [77.352783, 20.012707],
              [77.342436, 20.008705],
              [77.340963, 20.00625],
              [77.341669, 20.000597],
              [77.340725, 19.990287],
              [77.340558, 19.983918],
              [77.33822, 19.976],
              [77.340467, 19.97266],
              [77.340097, 19.969052],
              [77.332398, 19.9709],
              [77.325034, 19.956194],
              [77.321621, 19.959232],
              [77.307599, 19.962468],
              [77.307341, 19.953227],
              [77.305535, 19.946514],
              [77.301018, 19.940559],
              [77.294426, 19.937491],
              [77.287379, 19.935467],
              [77.286416, 19.923435],
              [77.286611, 19.915156],
              [77.285844, 19.910471],
              [77.285005, 19.916007],
              [77.284765, 19.916022],
              [77.279139, 19.916365],
              [77.275487, 19.914344],
              [77.273725, 19.908891],
              [77.273728, 19.900329],
              [77.269078, 19.897139],
              [77.265635, 19.899374],
              [77.262559, 19.899754],
              [77.249635, 19.89251],
              [77.243955, 19.891244],
              [77.240895, 19.892258],
              [77.237567, 19.895839],
              [77.237678, 19.895957],
              [77.240902, 19.899414],
              [77.248755, 19.905723],
              [77.248263, 19.906179],
              [77.243759, 19.910355],
              [77.243597, 19.910791],
              [77.241648, 19.916054],
              [77.240627, 19.923148],
              [77.240888, 19.930835],
              [77.239316, 19.938058],
              [77.239081, 19.938227],
              [77.236711, 19.939924],
              [77.220359, 19.938692],
              [77.214093, 19.939917],
              [77.210491, 19.942954],
              [77.210314, 19.943417],
              [77.208935, 19.947016],
              [77.210432, 19.957022],
              [77.210478, 19.963858],
              [77.211763, 19.967614],
              [77.217325, 19.972271],
              [77.218002, 19.977819],
              [77.217634, 19.978076],
              [77.213613, 19.980879],
              [77.203963, 19.991337],
              [77.200125, 19.990938],
              [77.194241, 19.983933],
              [77.181674, 19.97983],
              [77.178316, 19.977459],
              [77.178101, 19.972928],
              [77.17701, 19.969232],
              [77.171739, 19.964334],
              [77.165741, 19.964507],
              [77.162545, 19.966786],
              [77.157447, 19.966592],
              [77.139277, 19.953237],
              [77.138056, 19.950982],
              [77.137285, 19.946293],
              [77.133959, 19.942828],
              [77.125793, 19.939802],
              [77.118337, 19.940017],
              [77.112021, 19.937732],
              [77.108753, 19.934564],
              [77.102023, 19.932686],
              [77.096649, 19.936868],
              [77.096434, 19.937369],
              [77.094903, 19.94094],
              [77.092937, 19.949152],
              [77.092717, 19.949291],
              [77.086635, 19.953129],
              [77.086379, 19.953673],
              [77.08466, 19.957322],
              [77.08544, 19.96442],
              [77.085103, 19.964917],
              [77.08365, 19.967055],
              [77.077328, 19.97045],
              [77.073178, 19.975105],
              [77.073122, 19.975389],
              [77.071934, 19.981392],
              [77.071695, 19.981533],
              [77.065687, 19.985075],
              [77.065604, 19.985519],
              [77.064864, 19.989453],
              [77.064541, 19.990015],
              [77.061076, 19.99605],
              [77.052335, 20.000127],
              [77.046409, 20.007187],
              [77.042649, 20.008864],
              [77.036328, 20.01032],
              [77.032014, 20.009928],
              [77.027941, 20.008272],
              [77.02402, 20.006165],
              [77.020865, 20.002859],
              [77.015204, 20.002541],
              [77.012957, 20.004617],
              [77.007452, 20.00689],
              [77.000009, 20.012287],
              [76.993205, 20.017769],
              [76.992637, 20.009097],
              [76.991789, 20.000027],
              [76.989126, 19.996103],
              [76.972564, 19.994147],
              [76.968381, 19.989482],
              [76.96232, 19.985311],
              [76.949273, 19.983031],
              [76.946731, 19.983606],
              [76.943638, 19.981323],
              [76.939037, 19.979243],
              [76.927843, 19.975827],
              [76.918075, 19.971293],
              [76.914894, 19.967688],
              [76.900861, 19.962556],
              [76.900668, 19.951845],
              [76.899266, 19.951584],
              [76.896155, 19.945978],
              [76.891207, 19.949708],
              [76.887208, 19.950252],
              [76.878751, 19.949354],
              [76.873991, 19.950718],
              [76.873724, 19.951288],
              [76.871734, 19.955531],
              [76.871678, 19.95554],
              [76.837128, 19.960764],
              [76.8327, 19.948251],
              [76.823454, 19.926667],
              [76.773328, 19.932686],
              [76.774002, 19.922244],
              [76.77155, 19.913809],
              [76.767251, 19.903698],
              [76.746444, 19.906617],
              [76.742091, 19.896731],
              [76.742855, 19.887939],
              [76.742377, 19.880382],
              [76.739383, 19.871963],
              [76.7236, 19.868921],
              [76.711881, 19.868543],
              [76.698322, 19.872446],
              [76.691393, 19.872357],
              [76.690744, 19.8679],
              [76.688493, 19.864913],
              [76.6893, 19.860022],
              [76.685226, 19.849099],
              [76.67863, 19.846141],
              [76.678608, 19.846131],
              [76.663337, 19.849777],
              [76.654491, 19.855871],
              [76.649661, 19.861942],
              [76.649497, 19.862321],
              [76.648041, 19.865699],
              [76.647967, 19.865693],
              [76.646947, 19.865606],
              [76.647387, 19.866259],
              [76.652661, 19.874097],
              [76.65817, 19.886819],
              [76.65907, 19.892019],
              [76.656582, 19.897063],
              [76.654485, 19.898423],
              [76.647474, 19.89989],
              [76.641401, 19.899562],
              [76.63498, 19.897519],
              [76.626879, 19.890807],
              [76.611764, 19.890436],
              [76.611068, 19.897556],
              [76.614587, 19.900175],
              [76.614923, 19.90705],
              [76.611117, 19.916071],
              [76.606737, 19.92098],
              [76.607987, 19.922736],
              [76.612341, 19.921615],
              [76.623257, 19.921265],
              [76.63345, 19.926497],
              [76.635502, 19.928697],
              [76.635964, 19.932925],
              [76.636149, 19.938486],
              [76.63484, 19.945393],
              [76.634533, 19.953025],
              [76.638049, 19.958448],
              [76.641144, 19.960851],
              [76.645687, 19.962992],
              [76.659406, 19.962933],
              [76.660336, 19.97197],
              [76.659825, 19.976284],
              [76.651059, 19.980597],
              [76.645496, 19.981747],
              [76.658856, 20.00066],
              [76.657978, 20.012558],
              [76.659285, 20.018823],
              [76.659355, 20.026791],
              [76.661104, 20.034155],
              [76.662585, 20.047943],
              [76.624881, 20.049705],
              [76.626252, 20.061997],
              [76.63039, 20.082291],
              [76.634788, 20.078944],
              [76.636821, 20.069387],
              [76.647706, 20.0684],
              [76.649152, 20.08373],
              [76.652131, 20.090074],
              [76.660877, 20.097497],
              [76.658483, 20.106197],
              [76.658791, 20.112859],
              [76.660599, 20.117301],
              [76.663617, 20.120031],
              [76.667251, 20.121156],
              [76.670911, 20.126345],
              [76.681871, 20.124098],
              [76.706268, 20.122436],
              [76.71947, 20.127428],
              [76.736445, 20.126492],
              [76.748876, 20.130104],
              [76.758657, 20.130763],
              [76.762028, 20.16166],
              [76.749514, 20.166261],
              [76.749715, 20.171484],
              [76.751183, 20.176771],
              [76.750137, 20.185022],
              [76.747214, 20.192912],
              [76.7463, 20.199044],
              [76.747224, 20.204735],
              [76.750224, 20.208953],
              [76.763059, 20.208724],
              [76.766588, 20.208405],
              [76.782143, 20.203669],
              [76.786837, 20.203014],
              [76.791678, 20.2123],
              [76.79666, 20.219228],
              [76.811499, 20.219587],
              [76.815009, 20.229828],
              [76.82049, 20.234977],
              [76.826968, 20.245883],
              [76.826929, 20.250869],
              [76.823131, 20.261278],
              [76.823165, 20.263406],
              [76.829773, 20.266956],
              [76.826791, 20.273192],
              [76.821987, 20.280375],
              [76.82172, 20.280403],
              [76.827549, 20.283264],
              [76.834439, 20.288652],
              [76.836966, 20.293028],
              [76.837099, 20.299744],
              [76.839887, 20.301366],
              [76.841895, 20.298926],
              [76.859331, 20.299477],
              [76.863564, 20.297727],
              [76.866294, 20.293554],
              [76.868669, 20.283764],
              [76.870096, 20.281127],
              [76.872988, 20.278337],
              [76.876304, 20.278222],
              [76.883033, 20.282225],
              [76.883127, 20.286549],
              [76.880156, 20.28851],
              [76.882075, 20.293976],
              [76.884816, 20.29762],
              [76.905865, 20.310473],
              [76.908707, 20.314026],
              [76.904766, 20.315784],
              [76.892235, 20.318007],
              [76.891974, 20.320852],
              [76.893449, 20.324469],
              [76.895394, 20.324694],
              [76.897317, 20.332969],
              [76.900387, 20.340523],
              [76.918706, 20.353686],
              [76.920803, 20.359983],
              [76.930572, 20.359264],
              [76.934606, 20.370383],
              [76.946826, 20.364931],
              [76.95181, 20.364481],
              [76.961435, 20.365781],
              [76.965657, 20.36881],
              [76.974608, 20.369572],
              [76.975586, 20.369655],
              [76.97963, 20.371944],
              [76.979076, 20.374876],
              [76.975638, 20.380232],
              [76.976755, 20.382554],
              [76.981174, 20.381264],
              [76.983171, 20.383512],
              [76.982818, 20.386172],
              [76.984801, 20.389063],
              [76.987991, 20.390323],
              [76.991275, 20.396091],
              [76.997841, 20.394751],
              [76.998266, 20.397519],
              [76.994941, 20.401287],
              [76.992425, 20.405587],
              [76.993921, 20.408468],
              [76.995365, 20.409325],
              [76.998229, 20.407737],
              [77.000693, 20.406673],
              [77.003272, 20.409465],
              [77.006407, 20.412857],
              [77.008243, 20.41363],
              [77.011359, 20.413876],
              [77.01763, 20.412714],
              [77.017147, 20.421166],
              [77.015598, 20.42932],
              [77.018842, 20.439714],
              [77.022002, 20.44398],
              [77.02469, 20.450287],
              [77.042344, 20.45073],
              [77.047264, 20.449868],
              [77.05508, 20.448498],
              [77.057758, 20.446527],
              [77.059301, 20.438556],
              [77.078255, 20.437456],
              [77.080346, 20.435566],
              [77.081916, 20.426307],
              [77.085637, 20.421229],
              [77.097607, 20.418151],
              [77.101463, 20.415718],
              [77.104641, 20.413711],
              [77.106497, 20.41277],
              [77.110062, 20.411362],
              [77.114181, 20.409735],
              [77.116661, 20.407852],
              [77.117892, 20.409531],
              [77.121278, 20.410884],
              [77.123644, 20.409734],
              [77.122633, 20.406863],
              [77.124641, 20.404235],
              [77.13234, 20.40006],
              [77.133753, 20.39788],
              [77.134553, 20.392469],
              [77.141009, 20.382569],
              [77.150075, 20.391847],
              [77.152222, 20.4009],
              [77.162807, 20.400893],
              [77.176733, 20.39971],
              [77.182464, 20.40083],
              [77.18614, 20.402279],
              [77.192674, 20.407],
              [77.195126, 20.411001],
              [77.196864, 20.416459],
              [77.197072, 20.42051],
              [77.195644, 20.423426],
              [77.186775, 20.427582],
              [77.184782, 20.429568],
              [77.184007, 20.433876],
              [77.186717, 20.448734],
              [77.206156, 20.44934],
              [77.225084, 20.44798],
              [77.225424, 20.445687],
              [77.226924, 20.443967],
              [77.227967, 20.440768],
              [77.233081, 20.434149],
              [77.23592, 20.432168],
              [77.241299, 20.428414],
              [77.247003, 20.42622],
              [77.248365, 20.426429],
              [77.24966, 20.429856],
              [77.250577, 20.437415],
              [77.258521, 20.435287],
              [77.264435, 20.432519],
              [77.269341, 20.431229],
              [77.277935, 20.430834],
              [77.2792, 20.426258],
              [77.282718, 20.421172],
              [77.286175, 20.41912],
              [77.290372, 20.419012],
              [77.295528, 20.419749],
              [77.297226, 20.422631],
              [77.295952, 20.432448],
              [77.296382, 20.435307],
              [77.2983, 20.44178],
              [77.301209, 20.447442],
              [77.316277, 20.450289],
              [77.321944, 20.449931],
              [77.333243, 20.45096],
              [77.337601, 20.452602],
              [77.341533, 20.456074],
              [77.346642, 20.462416],
              [77.348675, 20.464938],
              [77.348655, 20.46595],
              [77.343747, 20.467334],
              [77.342532, 20.46952],
              [77.346441, 20.479062],
              [77.339812, 20.483543],
              [77.327088, 20.485248],
              [77.3272, 20.489389],
              [77.329064, 20.498619],
              [77.339732, 20.497246],
              [77.365865, 20.49872],
              [77.371347, 20.497897],
              [77.372162, 20.491289],
              [77.37065, 20.483813],
              [77.367413, 20.479709],
              [77.381011, 20.483075],
              [77.384381, 20.488466],
              [77.386065, 20.492035],
              [77.392261, 20.507451],
              [77.39327, 20.509962],
              [77.397937, 20.525863],
              [77.395961, 20.527024],
              [77.371054, 20.527508],
              [77.366813, 20.519799],
              [77.361723, 20.520445],
              [77.354155, 20.522979],
              [77.339472, 20.524834],
              [77.336214, 20.526615],
              [77.335199, 20.528529],
              [77.336015, 20.531671],
              [77.339313, 20.537616],
              [77.337821, 20.538969],
              [77.344102, 20.547175],
              [77.34378, 20.548641],
              [77.337698, 20.550004],
              [77.337423, 20.553954],
              [77.339821, 20.575612],
              [77.340484, 20.576636],
              [77.345207, 20.57527],
              [77.346477, 20.574903],
              [77.349762, 20.572509],
              [77.351037, 20.57158],
              [77.355968, 20.569184],
              [77.362447, 20.567551],
              [77.363954, 20.570337],
              [77.365592, 20.581311],
              [77.390761, 20.582948],
              [77.39835, 20.581165],
              [77.400967, 20.58055],
              [77.403932, 20.578762],
              [77.402716, 20.586007],
              [77.403461, 20.58786],
              [77.40698, 20.587737],
              [77.409544, 20.586494],
              [77.412555, 20.587374],
              [77.414325, 20.591819],
              [77.41404, 20.596413],
              [77.414574, 20.59909],
              [77.411863, 20.602814],
              [77.412777, 20.60605],
              [77.417713, 20.608435],
              [77.438246, 20.612651],
              [77.444, 20.613209],
              [77.452117, 20.612795],
              [77.466824, 20.610102],
              [77.469619, 20.617232],
              [77.461658, 20.619672],
              [77.460654, 20.626186],
              [77.455585, 20.625548],
              [77.448613, 20.636419],
              [77.440614, 20.646909],
              [77.434445, 20.647539],
              [77.433631, 20.65424],
              [77.433983, 20.661329],
              [77.445778, 20.658504],
              [77.452899, 20.656234],
              [77.454617, 20.655611],
              [77.456703, 20.653898],
              [77.455194, 20.661232],
              [77.462487, 20.670565],
              [77.466621, 20.676971],
              [77.471297, 20.688089],
              [77.474688, 20.684559],
              [77.480136, 20.680787],
              [77.489013, 20.681764],
              [77.492833, 20.681368],
              [77.496279, 20.680046],
              [77.499894, 20.674955],
              [77.49963, 20.673387],
              [77.502886, 20.671785],
              [77.504393, 20.664452],
              [77.510761, 20.663638],
              [77.51345, 20.666166],
              [77.517524, 20.673041],
              [77.514025, 20.677214],
              [77.511991, 20.681412],
              [77.51284, 20.683081],
              [77.517733, 20.682795],
              [77.523443, 20.68059],
              [77.533144, 20.678135],
              [77.538607, 20.676752],
              [77.543577, 20.675494],
              [77.546445, 20.678945],
              [77.539424, 20.68858],
              [77.523467, 20.695032],
              [77.524826, 20.700758],
              [77.519465, 20.699933],
              [77.51559, 20.698029],
              [77.515034, 20.701608],
              [77.50975, 20.707039],
              [77.508032, 20.710046],
              [77.51609, 20.718275],
              [77.518734, 20.72853],
              [77.521709, 20.731523],
              [77.524644, 20.731479],
              [77.539259, 20.729053],
              [77.565809, 20.721023],
              [77.566882, 20.726468],
              [77.566029, 20.730318],
              [77.56685, 20.733551],
              [77.569643, 20.735896],
              [77.571895, 20.735749],
              [77.571993, 20.741086],
              [77.576589, 20.741068],
              [77.577409, 20.744393],
              [77.582707, 20.748802],
              [77.588789, 20.747796],
              [77.591161, 20.757218],
              [77.597886, 20.758522],
              [77.611674, 20.75865],
              [77.616118, 20.759908],
              [77.616114, 20.759898],
              [77.617146, 20.758567],
              [77.620624, 20.757565],
              [77.63125, 20.757866],
              [77.634426, 20.756753],
              [77.636485, 20.75513],
              [77.634539, 20.742641],
              [77.632723, 20.738068],
              [77.631608, 20.736298],
              [77.630015, 20.735054],
              [77.627927, 20.734607],
              [77.626939, 20.733409],
              [77.625076, 20.730273],
              [77.625728, 20.727456],
              [77.617848, 20.728451],
              [77.616378, 20.727717],
              [77.614171, 20.719012],
              [77.617801, 20.715712],
              [77.623422, 20.715776],
              [77.631032, 20.713128],
              [77.63353, 20.711498],
              [77.634354, 20.708218],
              [77.633936, 20.702437],
              [77.64026, 20.692793],
              [77.640488, 20.690554],
              [77.640527, 20.688494],
              [77.638039, 20.683867],
              [77.637526, 20.68135],
              [77.636305, 20.667595],
              [77.637012, 20.657428],
              [77.638961, 20.656788],
              [77.649753, 20.662419],
              [77.652933, 20.662623],
              [77.652937, 20.656605],
              [77.651144, 20.653691],
              [77.652579, 20.650466],
              [77.655428, 20.648257],
              [77.655728, 20.647172],
              [77.652169, 20.625749],
              [77.651798, 20.61858],
              [77.649567, 20.608558],
              [77.640638, 20.586152],
              [77.635487, 20.577308],
              [77.630762, 20.566791],
              [77.638434, 20.565229],
              [77.645942, 20.565394],
              [77.653073, 20.564183],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 610,
        censuscode: 502,
        dt_cen_cd: 6,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Washim",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [78.279534, 20.696391],
              [78.278403, 20.693909],
              [78.277331, 20.687874],
              [78.268239, 20.678419],
              [78.270009, 20.669354],
              [78.269019, 20.665273],
              [78.266943, 20.661282],
              [78.255496, 20.650204],
              [78.251261, 20.647466],
              [78.250621, 20.645619],
              [78.249919, 20.643082],
              [78.252624, 20.632828],
              [78.253189, 20.626272],
              [78.25235, 20.621045],
              [78.252779, 20.615874],
              [78.25619, 20.607625],
              [78.258669, 20.60386],
              [78.259533, 20.594093],
              [78.262711, 20.588377],
              [78.263991, 20.57942],
              [78.268123, 20.575605],
              [78.273586, 20.573073],
              [78.277591, 20.564772],
              [78.279885, 20.562385],
              [78.287959, 20.559695],
              [78.29467, 20.559751],
              [78.298047, 20.557028],
              [78.309209, 20.552182],
              [78.336989, 20.543342],
              [78.34059, 20.54309],
              [78.344024, 20.54139],
              [78.347344, 20.538601],
              [78.350382, 20.534314],
              [78.356252, 20.528277],
              [78.359928, 20.526701],
              [78.369543, 20.532186],
              [78.373387, 20.531987],
              [78.378408, 20.530131],
              [78.381549, 20.527401],
              [78.386823, 20.519799],
              [78.39387, 20.516696],
              [78.404249, 20.51494],
              [78.412576, 20.511451],
              [78.422681, 20.512512],
              [78.43456, 20.517838],
              [78.44159, 20.515998],
              [78.444536, 20.513953],
              [78.449303, 20.512384],
              [78.454064, 20.511787],
              [78.465961, 20.520441],
              [78.469395, 20.523861],
              [78.47661, 20.527195],
              [78.480983, 20.528375],
              [78.485147, 20.526799],
              [78.492165, 20.525419],
              [78.498172, 20.522366],
              [78.502752, 20.522051],
              [78.509233, 20.51958],
              [78.516301, 20.509516],
              [78.521332, 20.506506],
              [78.523072, 20.503419],
              [78.524577, 20.50004],
              [78.524453, 20.489459],
              [78.525633, 20.487289],
              [78.535654, 20.479547],
              [78.537092, 20.475706],
              [78.535808, 20.471098],
              [78.537363, 20.463067],
              [78.539526, 20.460265],
              [78.553344, 20.450594],
              [78.558732, 20.44794],
              [78.563279, 20.438894],
              [78.570912, 20.432392],
              [78.577457, 20.429109],
              [78.590196, 20.428168],
              [78.603896, 20.428499],
              [78.607098, 20.430356],
              [78.608283, 20.433639],
              [78.608296, 20.438533],
              [78.611235, 20.442232],
              [78.615698, 20.440191],
              [78.616986, 20.434508],
              [78.619629, 20.431827],
              [78.626577, 20.431875],
              [78.640921, 20.43422],
              [78.647771, 20.431909],
              [78.647814, 20.427431],
              [78.645609, 20.423158],
              [78.647052, 20.419438],
              [78.657401, 20.413702],
              [78.657866, 20.410372],
              [78.661397, 20.404537],
              [78.666145, 20.393414],
              [78.668871, 20.388949],
              [78.682228, 20.381052],
              [78.6848, 20.374118],
              [78.689851, 20.368749],
              [78.690855, 20.359381],
              [78.692401, 20.356813],
              [78.709432, 20.352325],
              [78.711296, 20.349173],
              [78.712148, 20.337172],
              [78.710378, 20.332213],
              [78.710358, 20.327505],
              [78.711631, 20.322631],
              [78.710587, 20.317448],
              [78.708134, 20.313806],
              [78.708185, 20.309384],
              [78.720913, 20.307917],
              [78.734152, 20.304786],
              [78.736721, 20.302958],
              [78.738227, 20.292909],
              [78.740542, 20.292639],
              [78.748962, 20.296776],
              [78.754501, 20.295832],
              [78.760925, 20.293056],
              [78.769365, 20.294314],
              [78.776019, 20.298035],
              [78.780399, 20.299215],
              [78.784601, 20.297926],
              [78.791987, 20.295666],
              [78.801818, 20.297798],
              [78.802833, 20.293388],
              [78.804824, 20.28921],
              [78.818281, 20.275105],
              [78.819793, 20.270568],
              [78.816727, 20.266298],
              [78.812808, 20.262711],
              [78.811378, 20.259774],
              [78.812534, 20.25386],
              [78.814383, 20.251112],
              [78.820144, 20.246903],
              [78.827069, 20.247006],
              [78.850331, 20.251462],
              [78.860662, 20.252157],
              [78.869975, 20.25112],
              [78.885273, 20.247367],
              [78.889416, 20.247333],
              [78.895011, 20.248067],
              [78.89846, 20.249287],
              [78.905419, 20.253064],
              [78.918793, 20.254463],
              [78.921297, 20.252353],
              [78.922735, 20.249255],
              [78.921678, 20.237179],
              [78.930151, 20.229345],
              [78.934555, 20.227696],
              [78.936761, 20.224947],
              [78.937908, 20.219995],
              [78.941477, 20.215573],
              [78.946688, 20.21179],
              [78.951863, 20.210479],
              [78.960294, 20.206827],
              [78.962708, 20.202626],
              [78.961527, 20.198878],
              [78.957384, 20.192642],
              [78.956903, 20.184707],
              [78.957781, 20.181718],
              [78.957764, 20.177349],
              [78.956839, 20.171813],
              [78.955116, 20.168303],
              [78.958116, 20.16532],
              [78.96355, 20.16237],
              [78.968863, 20.160821],
              [78.969766, 20.160483],
              [78.979821, 20.152531],
              [78.981418, 20.148646],
              [78.981434, 20.144949],
              [78.978197, 20.142088],
              [78.973888, 20.141054],
              [78.970413, 20.137627],
              [78.968987, 20.133545],
              [78.970517, 20.123177],
              [78.974129, 20.120278],
              [78.980046, 20.120335],
              [78.983296, 20.121624],
              [78.990577, 20.122507],
              [78.995142, 20.122111],
              [78.999837, 20.120706],
              [79.004097, 20.120461],
              [79.01668, 20.11277],
              [79.035147, 20.093554],
              [79.043256, 20.08864],
              [79.048329, 20.084134],
              [79.047251, 20.077428],
              [79.044098, 20.071307],
              [79.048581, 20.067902],
              [79.054528, 20.066504],
              [79.059286, 20.067398],
              [79.064341, 20.069445],
              [79.070704, 20.063761],
              [79.07298, 20.054052],
              [79.079253, 20.043095],
              [79.083258, 20.028528],
              [79.090436, 20.020994],
              [79.098362, 20.017177],
              [79.104534, 20.015061],
              [79.108608, 20.007989],
              [79.110513, 20.000873],
              [79.115207, 19.988435],
              [79.113532, 19.985838],
              [79.107999, 19.986326],
              [79.101586, 19.984742],
              [79.095055, 19.981386],
              [79.093718, 19.977132],
              [79.097768, 19.973395],
              [79.108379, 19.968408],
              [79.110453, 19.964634],
              [79.108253, 19.958883],
              [79.105423, 19.95403],
              [79.093599, 19.945636],
              [79.09208, 19.939997],
              [79.09154, 19.932616],
              [79.092736, 19.919743],
              [79.094886, 19.914664],
              [79.102312, 19.91297],
              [79.109117, 19.909663],
              [79.113629, 19.903776],
              [79.151663, 19.893038],
              [79.149456, 19.886845],
              [79.138016, 19.871101],
              [79.135861, 19.865554],
              [79.132594, 19.86301],
              [79.125127, 19.861404],
              [79.120722, 19.858433],
              [79.10978, 19.846483],
              [79.103041, 19.842252],
              [79.094067, 19.840479],
              [79.091065, 19.837323],
              [79.088455, 19.830957],
              [79.080198, 19.822559],
              [79.072865, 19.818142],
              [79.065625, 19.814754],
              [79.058912, 19.814466],
              [79.051371, 19.815071],
              [79.042886, 19.817146],
              [79.038253, 19.813578],
              [79.035054, 19.806383],
              [79.029309, 19.801351],
              [79.020456, 19.799088],
              [79.011189, 19.803883],
              [79.000939, 19.804099],
              [78.997323, 19.804716],
              [78.990024, 19.803667],
              [78.98872, 19.803725],
              [78.972371, 19.804385],
              [78.958617, 19.803205],
              [78.957064, 19.801931],
              [78.950849, 19.796842],
              [78.945618, 19.788562],
              [78.941846, 19.784552],
              [78.940445, 19.778282],
              [78.941435, 19.771592],
              [78.947743, 19.763146],
              [78.950127, 19.75872],
              [78.951796, 19.75324],
              [78.948901, 19.748613],
              [78.941061, 19.74677],
              [78.931594, 19.746455],
              [78.923634, 19.74484],
              [78.917132, 19.742617],
              [78.907675, 19.738121],
              [78.902904, 19.737075],
              [78.890028, 19.74347],
              [78.883029, 19.745997],
              [78.879881, 19.75196],
              [78.881393, 19.758178],
              [78.880771, 19.763212],
              [78.875046, 19.76765],
              [78.866727, 19.769643],
              [78.858879, 19.770148],
              [78.85365, 19.766343],
              [78.84972, 19.760103],
              [78.843675, 19.763165],
              [78.830649, 19.761452],
              [78.822503, 19.761473],
              [78.812958, 19.759054],
              [78.808521, 19.761128],
              [78.802269, 19.769614],
              [78.790189, 19.779758],
              [78.778502, 19.780361],
              [78.768503, 19.776623],
              [78.757511, 19.778269],
              [78.748327, 19.780624],
              [78.743584, 19.780392],
              [78.737084, 19.773814],
              [78.729945, 19.769936],
              [78.721678, 19.767761],
              [78.714397, 19.773648],
              [78.706982, 19.78649],
              [78.701092, 19.790606],
              [78.691529, 19.790835],
              [78.653437, 19.802299],
              [78.640296, 19.804603],
              [78.624399, 19.809511],
              [78.6194, 19.814049],
              [78.608696, 19.818273],
              [78.600308, 19.818109],
              [78.596781, 19.816171],
              [78.590001, 19.81245],
              [78.57869, 19.814543],
              [78.562889, 19.81634],
              [78.531195, 19.822351],
              [78.52413, 19.820588],
              [78.517292, 19.814976],
              [78.514515, 19.801887],
              [78.508559, 19.793125],
              [78.498808, 19.793852],
              [78.494337, 19.799196],
              [78.489156, 19.807863],
              [78.481036, 19.817011],
              [78.469482, 19.816847],
              [78.449385, 19.819844],
              [78.433447, 19.8237],
              [78.413779, 19.830435],
              [78.402384, 19.836943],
              [78.39395, 19.846705],
              [78.390645, 19.853215],
              [78.390691, 19.856213],
              [78.388883, 19.864121],
              [78.389673, 19.874372],
              [78.388848, 19.879703],
              [78.379149, 19.879733],
              [78.370422, 19.883346],
              [78.351327, 19.88184],
              [78.34088, 19.883615],
              [78.329854, 19.890881],
              [78.327572, 19.895368],
              [78.331222, 19.899777],
              [78.339204, 19.904691],
              [78.339734, 19.910494],
              [78.332978, 19.916462],
              [78.324101, 19.915839],
              [78.314777, 19.913107],
              [78.302493, 19.917152],
              [78.294693, 19.914577],
              [78.286947, 19.910687],
              [78.284205, 19.907558],
              [78.28234, 19.891451],
              [78.280784, 19.885188],
              [78.275459, 19.879602],
              [78.267252, 19.875675],
              [78.254723, 19.872987],
              [78.251365, 19.873842],
              [78.242332, 19.887496],
              [78.243555, 19.892324],
              [78.248379, 19.898091],
              [78.255291, 19.903946],
              [78.25965, 19.911697],
              [78.260266, 19.918873],
              [78.257661, 19.925768],
              [78.252799, 19.92935],
              [78.247172, 19.928161],
              [78.239756, 19.923956],
              [78.236423, 19.918797],
              [78.230327, 19.916445],
              [78.221819, 19.915485],
              [78.209794, 19.906896],
              [78.200534, 19.902651],
              [78.195206, 19.902378],
              [78.189232, 19.903291],
              [78.177864, 19.9103],
              [78.156219, 19.913844],
              [78.149469, 19.91595],
              [78.142141, 19.915291],
              [78.137646, 19.911359],
              [78.134939, 19.906499],
              [78.131132, 19.902006],
              [78.125659, 19.90006],
              [78.111524, 19.897422],
              [78.103033, 19.896676],
              [78.093936, 19.897633],
              [78.078394, 19.900597],
              [78.070053, 19.906574],
              [78.063236, 19.912581],
              [78.058873, 19.918076],
              [78.057349, 19.923927],
              [78.055102, 19.928916],
              [78.05327, 19.930717],
              [78.048122, 19.931148],
              [78.033454, 19.92846],
              [78.027872, 19.925552],
              [78.01866, 19.915625],
              [78.01191, 19.914187],
              [78.000019, 19.917775],
              [77.99232, 19.916438],
              [77.988171, 19.91671],
              [77.982579, 19.915541],
              [77.978495, 19.912919],
              [77.971476, 19.910395],
              [77.965016, 19.909916],
              [77.960239, 19.911036],
              [77.953905, 19.911225],
              [77.947826, 19.907114],
              [77.943783, 19.900688],
              [77.940522, 19.892868],
              [77.934326, 19.890794],
              [77.92398, 19.891266],
              [77.920021, 19.884676],
              [77.902748, 19.880339],
              [77.898107, 19.877997],
              [77.891888, 19.871013],
              [77.891861, 19.867151],
              [77.887792, 19.862332],
              [77.88619, 19.856919],
              [77.876207, 19.849553],
              [77.872869, 19.836838],
              [77.871072, 19.832707],
              [77.87113, 19.827715],
              [77.870315, 19.823896],
              [77.863597, 19.816273],
              [77.856362, 19.81085],
              [77.849069, 19.800774],
              [77.850659, 19.793123],
              [77.853222, 19.788781],
              [77.862044, 19.778677],
              [77.865522, 19.771419],
              [77.866246, 19.766503],
              [77.85901, 19.753145],
              [77.860528, 19.743656],
              [77.863258, 19.742004],
              [77.866679, 19.741245],
              [77.869783, 19.741707],
              [77.872212, 19.743226],
              [77.876737, 19.744437],
              [77.877437, 19.743776],
              [77.878368, 19.737874],
              [77.891589, 19.727188],
              [77.89595, 19.725582],
              [77.897345, 19.7288],
              [77.897539, 19.732308],
              [77.899459, 19.734879],
              [77.902303, 19.734884],
              [77.906252, 19.73185],
              [77.91441, 19.729784],
              [77.91975, 19.731697],
              [77.923088, 19.73496],
              [77.933556, 19.739319],
              [77.936855, 19.736861],
              [77.953178, 19.729356],
              [77.961017, 19.717361],
              [77.9649, 19.706408],
              [77.970561, 19.702527],
              [77.982119, 19.701609],
              [77.985388, 19.699407],
              [77.984551, 19.686572],
              [77.98846, 19.680786],
              [77.997032, 19.680731],
              [78.000019, 19.681474],
              [78.019263, 19.694105],
              [78.031845, 19.69922],
              [78.040304, 19.70031],
              [78.047102, 19.69889],
              [78.05288, 19.691553],
              [78.055467, 19.685189],
              [78.05668, 19.670992],
              [78.066972, 19.668159],
              [78.071867, 19.663729],
              [78.076754, 19.655566],
              [78.082223, 19.648451],
              [78.089856, 19.645214],
              [78.095369, 19.645441],
              [78.097895, 19.65163],
              [78.102145, 19.656924],
              [78.107073, 19.659947],
              [78.122383, 19.658014],
              [78.125904, 19.659687],
              [78.127336, 19.664127],
              [78.131053, 19.667119],
              [78.140299, 19.666789],
              [78.153111, 19.664684],
              [78.163065, 19.66098],
              [78.168691, 19.657992],
              [78.174377, 19.656953],
              [78.178994, 19.655041],
              [78.187055, 19.642471],
              [78.189406, 19.635923],
              [78.194727, 19.625536],
              [78.195701, 19.618274],
              [78.195476, 19.613911],
              [78.191963, 19.604786],
              [78.192323, 19.592178],
              [78.18562, 19.584085],
              [78.189867, 19.571153],
              [78.189027, 19.567355],
              [78.184604, 19.563656],
              [78.167098, 19.559135],
              [78.158417, 19.555869],
              [78.147412, 19.5529],
              [78.139976, 19.553903],
              [78.131612, 19.557526],
              [78.124758, 19.557504],
              [78.119906, 19.553619],
              [78.12343, 19.546469],
              [78.130236, 19.540701],
              [78.135031, 19.535118],
              [78.136261, 19.531181],
              [78.135108, 19.525831],
              [78.125204, 19.51744],
              [78.123357, 19.514596],
              [78.1217, 19.508195],
              [78.121075, 19.501359],
              [78.114378, 19.491371],
              [78.101978, 19.486939],
              [78.095475, 19.487329],
              [78.083045, 19.478649],
              [78.074209, 19.471027],
              [78.067865, 19.466999],
              [78.063197, 19.466904],
              [78.053949, 19.476583],
              [78.044151, 19.482919],
              [78.030711, 19.494691],
              [78.02589, 19.497401],
              [78.019503, 19.496117],
              [78.016417, 19.490734],
              [78.014847, 19.483589],
              [78.01317, 19.465439],
              [78.009426, 19.461407],
              [78.000021, 19.462597],
              [77.991437, 19.455198],
              [77.99103, 19.455553],
              [77.987031, 19.459957],
              [77.986421, 19.465392],
              [77.987199, 19.478571],
              [77.980254, 19.48908],
              [77.974161, 19.493866],
              [77.973497, 19.496955],
              [77.975739, 19.506086],
              [77.972392, 19.508477],
              [77.958826, 19.510939],
              [77.953145, 19.509432],
              [77.947487, 19.501026],
              [77.94345, 19.498288],
              [77.938155, 19.500385],
              [77.936061, 19.504198],
              [77.932421, 19.508574],
              [77.916583, 19.515206],
              [77.912893, 19.527823],
              [77.912779, 19.530927],
              [77.907599, 19.533238],
              [77.904175, 19.53239],
              [77.901733, 19.526975],
              [77.898739, 19.523122],
              [77.889946, 19.519378],
              [77.888347, 19.512497],
              [77.890552, 19.505077],
              [77.885463, 19.500334],
              [77.882493, 19.500213],
              [77.879338, 19.504748],
              [77.878669, 19.509187],
              [77.877384, 19.512157],
              [77.869764, 19.513763],
              [77.861578, 19.519574],
              [77.853524, 19.51776],
              [77.847785, 19.514926],
              [77.842874, 19.509834],
              [77.843735, 19.494309],
              [77.846955, 19.486735],
              [77.843514, 19.483706],
              [77.828504, 19.4803],
              [77.827532, 19.475403],
              [77.83217, 19.468641],
              [77.837948, 19.462986],
              [77.847541, 19.45581],
              [77.847038, 19.452278],
              [77.837655, 19.448779],
              [77.834694, 19.439315],
              [77.830374, 19.43866],
              [77.825675, 19.440835],
              [77.819676, 19.445296],
              [77.816122, 19.453569],
              [77.809947, 19.462961],
              [77.804859, 19.464296],
              [77.801339, 19.459373],
              [77.798103, 19.450478],
              [77.789513, 19.448837],
              [77.781978, 19.4448],
              [77.774983, 19.438674],
              [77.75618, 19.432275],
              [77.748994, 19.431032],
              [77.742105, 19.437461],
              [77.732644, 19.433716],
              [77.722352, 19.43475],
              [77.713192, 19.437363],
              [77.707618, 19.437146],
              [77.704472, 19.438637],
              [77.698911, 19.438649],
              [77.695967, 19.440983],
              [77.698099, 19.44935],
              [77.698452, 19.457376],
              [77.699082, 19.459765],
              [77.7011, 19.461817],
              [77.705419, 19.464256],
              [77.710674, 19.467231],
              [77.713981, 19.476478],
              [77.717563, 19.476866],
              [77.722269, 19.474871],
              [77.725344, 19.474712],
              [77.728696, 19.478723],
              [77.73736, 19.480497],
              [77.740292, 19.483089],
              [77.739739, 19.486153],
              [77.73584, 19.491739],
              [77.736444, 19.494936],
              [77.739176, 19.501668],
              [77.752771, 19.509628],
              [77.754135, 19.515265],
              [77.749662, 19.521791],
              [77.733708, 19.53205],
              [77.729209, 19.53146],
              [77.72272, 19.527663],
              [77.713925, 19.525617],
              [77.705823, 19.533701],
              [77.700407, 19.537855],
              [77.689106, 19.539843],
              [77.673593, 19.54077],
              [77.66589, 19.545399],
              [77.659292, 19.546768],
              [77.646304, 19.547546],
              [77.639904, 19.551154],
              [77.634141, 19.555709],
              [77.636218, 19.557995],
              [77.642308, 19.555664],
              [77.64932, 19.555548],
              [77.648241, 19.563963],
              [77.64057, 19.587477],
              [77.640599, 19.596441],
              [77.643267, 19.59991],
              [77.644801, 19.605259],
              [77.644766, 19.607785],
              [77.642599, 19.609699],
              [77.638305, 19.609893],
              [77.633526, 19.608337],
              [77.629464, 19.608006],
              [77.628429, 19.614419],
              [77.630193, 19.621256],
              [77.629217, 19.624388],
              [77.627143, 19.62727],
              [77.616017, 19.629304],
              [77.614128, 19.632189],
              [77.616807, 19.637784],
              [77.615107, 19.639277],
              [77.610982, 19.639064],
              [77.608199, 19.640765],
              [77.608994, 19.644299],
              [77.607463, 19.646937],
              [77.601066, 19.644397],
              [77.599684, 19.647774],
              [77.596996, 19.650674],
              [77.586495, 19.651363],
              [77.584188, 19.653051],
              [77.582572, 19.656725],
              [77.5803, 19.65766],
              [77.574027, 19.651599],
              [77.568354, 19.650355],
              [77.555223, 19.652453],
              [77.554119, 19.660299],
              [77.555034, 19.663718],
              [77.546554, 19.66192],
              [77.542519, 19.662462],
              [77.539062, 19.663949],
              [77.539535, 19.668696],
              [77.534929, 19.668567],
              [77.529519, 19.66983],
              [77.523228, 19.66998],
              [77.516646, 19.672319],
              [77.513218, 19.67444],
              [77.505339, 19.676068],
              [77.502123, 19.677617],
              [77.495037, 19.679102],
              [77.491494, 19.678295],
              [77.48485, 19.675291],
              [77.48264, 19.676335],
              [77.47905, 19.682367],
              [77.476638, 19.68279],
              [77.467371, 19.67929],
              [77.462786, 19.679722],
              [77.459593, 19.681949],
              [77.45899, 19.682311],
              [77.451945, 19.686551],
              [77.446054, 19.687658],
              [77.445883, 19.688218],
              [77.444643, 19.692293],
              [77.451395, 19.699836],
              [77.451, 19.700347],
              [77.448612, 19.703427],
              [77.44858, 19.703639],
              [77.447825, 19.708571],
              [77.446002, 19.711897],
              [77.445999, 19.711899],
              [77.442572, 19.714018],
              [77.442469, 19.71447],
              [77.440734, 19.72206],
              [77.440508, 19.722217],
              [77.436419, 19.725062],
              [77.436372, 19.725457],
              [77.435911, 19.729386],
              [77.435644, 19.729481],
              [77.419879, 19.735062],
              [77.417456, 19.736917],
              [77.417569, 19.73717],
              [77.418449, 19.739129],
              [77.418023, 19.739495],
              [77.413326, 19.743538],
              [77.398998, 19.732148],
              [77.396774, 19.725726],
              [77.388872, 19.725112],
              [77.385471, 19.726314],
              [77.383251, 19.728791],
              [77.383258, 19.729008],
              [77.383328, 19.731028],
              [77.386389, 19.735414],
              [77.384924, 19.738504],
              [77.384862, 19.738537],
              [77.381718, 19.740217],
              [77.379333, 19.742927],
              [77.379313, 19.74317],
              [77.379068, 19.746036],
              [77.37974, 19.749404],
              [77.385713, 19.76088],
              [77.387107, 19.766007],
              [77.396146, 19.766359],
              [77.404546, 19.764146],
              [77.407148, 19.765616],
              [77.409929, 19.772532],
              [77.40893, 19.776703],
              [77.40869, 19.776935],
              [77.407584, 19.778003],
              [77.389897, 19.779994],
              [77.383526, 19.788116],
              [77.383568, 19.788237],
              [77.3904, 19.807829],
              [77.395243, 19.811124],
              [77.390015, 19.820938],
              [77.390004, 19.820936],
              [77.382151, 19.819922],
              [77.373757, 19.822189],
              [77.370667, 19.822231],
              [77.362231, 19.815028],
              [77.357848, 19.816195],
              [77.346827, 19.825202],
              [77.344542, 19.829123],
              [77.344545, 19.829148],
              [77.344916, 19.832904],
              [77.346215, 19.83378],
              [77.349478, 19.835235],
              [77.363587, 19.833018],
              [77.363847, 19.83697],
              [77.363508, 19.837366],
              [77.356625, 19.845406],
              [77.356741, 19.845478],
              [77.36648, 19.851534],
              [77.365319, 19.858062],
              [77.365089, 19.858109],
              [77.360681, 19.859012],
              [77.354002, 19.858528],
              [77.349083, 19.860231],
              [77.348976, 19.860744],
              [77.34815, 19.864681],
              [77.350321, 19.869557],
              [77.349978, 19.870107],
              [77.347913, 19.873418],
              [77.340173, 19.874057],
              [77.336055, 19.875906],
              [77.326692, 19.883721],
              [77.323636, 19.88496],
              [77.318005, 19.883356],
              [77.306498, 19.878304],
              [77.302373, 19.878432],
              [77.298593, 19.879526],
              [77.298285, 19.88011],
              [77.296833, 19.882856],
              [77.29788, 19.885122],
              [77.297248, 19.889792],
              [77.298199, 19.892636],
              [77.302156, 19.893146],
              [77.30977, 19.890618],
              [77.315019, 19.889819],
              [77.315845, 19.890884],
              [77.316298, 19.893455],
              [77.315429, 19.901638],
              [77.317768, 19.906163],
              [77.316131, 19.909606],
              [77.316081, 19.909614],
              [77.310765, 19.910401],
              [77.303898, 19.906361],
              [77.296523, 19.900152],
              [77.292734, 19.899295],
              [77.289084, 19.900724],
              [77.288772, 19.901308],
              [77.287774, 19.903175],
              [77.287756, 19.903187],
              [77.285283, 19.904863],
              [77.285317, 19.905207],
              [77.285844, 19.910471],
              [77.286611, 19.915156],
              [77.286416, 19.923435],
              [77.287379, 19.935467],
              [77.294426, 19.937491],
              [77.301018, 19.940559],
              [77.305535, 19.946514],
              [77.307341, 19.953227],
              [77.307599, 19.962468],
              [77.321621, 19.959232],
              [77.325034, 19.956194],
              [77.332398, 19.9709],
              [77.340097, 19.969052],
              [77.340467, 19.97266],
              [77.33822, 19.976],
              [77.340558, 19.983918],
              [77.340725, 19.990287],
              [77.341669, 20.000597],
              [77.340963, 20.00625],
              [77.342436, 20.008705],
              [77.352783, 20.012707],
              [77.354468, 20.014065],
              [77.361618, 20.028367],
              [77.369745, 20.03869],
              [77.373766, 20.046182],
              [77.373218, 20.048188],
              [77.37052, 20.052169],
              [77.355178, 20.068182],
              [77.355464, 20.073967],
              [77.357193, 20.077689],
              [77.364031, 20.08309],
              [77.36795, 20.08828],
              [77.369455, 20.10101],
              [77.376939, 20.093782],
              [77.387137, 20.087505],
              [77.390363, 20.086269],
              [77.398472, 20.084892],
              [77.403983, 20.08485],
              [77.408141, 20.085623],
              [77.41217, 20.082602],
              [77.416125, 20.082742],
              [77.419833, 20.079728],
              [77.425732, 20.076875],
              [77.432989, 20.075846],
              [77.437618, 20.073745],
              [77.450225, 20.070892],
              [77.45585, 20.070329],
              [77.465884, 20.071221],
              [77.469807, 20.0732],
              [77.47558, 20.078947],
              [77.482935, 20.083935],
              [77.485859, 20.083573],
              [77.488269, 20.080796],
              [77.491119, 20.079685],
              [77.496129, 20.081539],
              [77.502865, 20.087279],
              [77.526101, 20.093963],
              [77.532673, 20.086741],
              [77.539277, 20.076176],
              [77.540461, 20.072783],
              [77.546317, 20.068257],
              [77.553383, 20.064184],
              [77.554579, 20.06159],
              [77.556938, 20.048315],
              [77.558631, 20.046352],
              [77.561358, 20.046553],
              [77.565517, 20.043247],
              [77.56878, 20.042875],
              [77.580904, 20.029743],
              [77.583386, 20.030866],
              [77.593338, 20.032438],
              [77.597127, 20.037286],
              [77.599592, 20.037498],
              [77.602573, 20.035342],
              [77.604907, 20.035667],
              [77.608312, 20.037818],
              [77.611536, 20.037729],
              [77.615056, 20.039819],
              [77.625928, 20.041271],
              [77.627002, 20.044999],
              [77.63464, 20.050666],
              [77.640628, 20.059164],
              [77.640244, 20.066455],
              [77.644238, 20.069634],
              [77.648496, 20.071598],
              [77.649551, 20.075666],
              [77.654422, 20.078209],
              [77.656226, 20.08077],
              [77.658275, 20.088039],
              [77.659229, 20.096464],
              [77.664666, 20.09779],
              [77.668586, 20.099991],
              [77.671737, 20.104267],
              [77.672761, 20.10874],
              [77.672327, 20.119929],
              [77.673572, 20.123304],
              [77.680545, 20.132877],
              [77.68424, 20.144434],
              [77.682978, 20.145768],
              [77.676861, 20.147891],
              [77.679227, 20.159923],
              [77.68165, 20.165696],
              [77.681374, 20.168852],
              [77.668817, 20.173609],
              [77.664989, 20.173931],
              [77.657004, 20.172972],
              [77.653721, 20.173584],
              [77.651361, 20.181693],
              [77.651822, 20.185192],
              [77.650553, 20.186746],
              [77.647649, 20.188206],
              [77.646636, 20.190054],
              [77.647883, 20.193602],
              [77.653169, 20.198834],
              [77.656706, 20.200005],
              [77.659835, 20.202045],
              [77.658997, 20.204119],
              [77.655082, 20.208797],
              [77.654609, 20.21052],
              [77.659621, 20.225565],
              [77.6667, 20.240994],
              [77.668582, 20.24757],
              [77.653508, 20.25069],
              [77.648938, 20.250963],
              [77.642872, 20.25349],
              [77.63319, 20.260686],
              [77.624598, 20.2614],
              [77.611649, 20.263918],
              [77.609338, 20.278115],
              [77.595949, 20.280583],
              [77.594998, 20.290461],
              [77.595599, 20.29642],
              [77.595156, 20.301245],
              [77.593661, 20.304302],
              [77.58906, 20.307782],
              [77.586652, 20.311306],
              [77.585359, 20.316188],
              [77.585759, 20.320892],
              [77.584392, 20.325322],
              [77.58092, 20.325643],
              [77.580331, 20.327769],
              [77.578592, 20.329962],
              [77.575601, 20.330389],
              [77.570418, 20.329121],
              [77.568472, 20.330112],
              [77.567643, 20.333327],
              [77.567799, 20.33769],
              [77.570334, 20.355282],
              [77.57134, 20.359055],
              [77.577085, 20.367845],
              [77.578151, 20.370993],
              [77.574905, 20.376812],
              [77.574383, 20.386283],
              [77.575474, 20.392533],
              [77.582177, 20.406586],
              [77.582506, 20.408766],
              [77.584966, 20.411608],
              [77.589666, 20.412659],
              [77.596362, 20.410537],
              [77.597536, 20.413048],
              [77.597251, 20.415227],
              [77.593941, 20.419391],
              [77.592868, 20.422615],
              [77.593379, 20.424562],
              [77.598289, 20.428358],
              [77.60233, 20.430106],
              [77.605337, 20.432716],
              [77.607137, 20.43609],
              [77.601352, 20.444853],
              [77.608372, 20.452197],
              [77.613749, 20.453119],
              [77.613558, 20.458579],
              [77.616688, 20.460786],
              [77.623656, 20.455848],
              [77.640564, 20.450131],
              [77.647571, 20.448974],
              [77.650922, 20.455771],
              [77.650704, 20.458873],
              [77.65032, 20.469662],
              [77.654318, 20.479669],
              [77.654843, 20.484478],
              [77.655039, 20.49165],
              [77.654021, 20.494701],
              [77.654953, 20.496063],
              [77.662895, 20.496854],
              [77.664751, 20.500109],
              [77.665107, 20.505382],
              [77.668465, 20.512923],
              [77.668603, 20.514933],
              [77.672881, 20.514947],
              [77.686766, 20.518034],
              [77.688906, 20.519449],
              [77.691084, 20.523329],
              [77.690429, 20.532059],
              [77.688121, 20.5334],
              [77.670406, 20.537177],
              [77.666673, 20.536976],
              [77.658701, 20.532237],
              [77.656042, 20.528415],
              [77.644882, 20.529203],
              [77.650228, 20.546712],
              [77.653073, 20.564183],
              [77.655632, 20.564194],
              [77.659176, 20.56519],
              [77.65975, 20.568222],
              [77.662592, 20.571589],
              [77.666826, 20.580435],
              [77.687387, 20.579724],
              [77.690794, 20.578027],
              [77.692941, 20.57267],
              [77.702843, 20.567407],
              [77.711684, 20.567081],
              [77.721079, 20.565435],
              [77.729832, 20.562705],
              [77.735549, 20.559897],
              [77.741911, 20.561375],
              [77.745296, 20.558186],
              [77.750509, 20.547911],
              [77.756032, 20.544701],
              [77.766037, 20.544653],
              [77.771608, 20.539935],
              [77.782447, 20.543718],
              [77.785599, 20.547533],
              [77.789714, 20.55638],
              [77.794204, 20.560178],
              [77.806968, 20.566802],
              [77.81151, 20.587188],
              [77.817102, 20.585283],
              [77.821398, 20.581043],
              [77.827484, 20.573272],
              [77.837603, 20.565569],
              [77.846803, 20.570388],
              [77.848086, 20.576219],
              [77.847185, 20.577556],
              [77.846682, 20.587654],
              [77.854569, 20.589492],
              [77.862109, 20.592415],
              [77.865793, 20.594872],
              [77.864673, 20.598209],
              [77.866136, 20.609253],
              [77.868666, 20.61155],
              [77.873225, 20.609798],
              [77.877371, 20.609369],
              [77.881373, 20.612084],
              [77.882883, 20.616909],
              [77.88565, 20.618457],
              [77.888249, 20.621685],
              [77.893089, 20.623464],
              [77.900871, 20.614532],
              [77.906894, 20.612223],
              [77.909059, 20.608905],
              [77.916482, 20.606477],
              [77.919082, 20.604524],
              [77.918131, 20.59606],
              [77.915181, 20.588712],
              [77.918482, 20.588158],
              [77.917334, 20.577868],
              [77.912373, 20.565422],
              [77.919335, 20.565236],
              [77.922191, 20.564172],
              [77.921778, 20.560112],
              [77.924327, 20.558545],
              [77.926488, 20.561042],
              [77.928496, 20.566579],
              [77.930658, 20.568727],
              [77.931509, 20.573471],
              [77.934105, 20.577054],
              [77.939395, 20.575286],
              [77.943074, 20.576387],
              [77.944571, 20.579519],
              [77.951348, 20.579961],
              [77.95106, 20.575336],
              [77.957528, 20.58137],
              [77.970605, 20.587354],
              [77.973804, 20.590099],
              [77.976419, 20.59443],
              [77.978904, 20.603337],
              [77.982009, 20.607938],
              [77.988408, 20.612554],
              [77.996081, 20.622844],
              [78.000011, 20.62443],
              [78.015153, 20.626563],
              [78.020315, 20.628172],
              [78.022405, 20.631182],
              [78.026645, 20.632831],
              [78.027358, 20.633816],
              [78.025249, 20.636667],
              [78.02126, 20.642255],
              [78.025559, 20.648856],
              [78.028487, 20.656809],
              [78.034119, 20.659737],
              [78.036444, 20.659478],
              [78.03866, 20.666447],
              [78.040556, 20.666129],
              [78.041688, 20.667519],
              [78.058391, 20.668024],
              [78.05873, 20.670105],
              [78.063258, 20.669395],
              [78.06363, 20.672682],
              [78.071526, 20.671094],
              [78.070895, 20.668326],
              [78.077484, 20.667698],
              [78.077062, 20.663786],
              [78.080213, 20.664688],
              [78.081017, 20.668546],
              [78.083079, 20.668903],
              [78.084912, 20.673064],
              [78.089017, 20.672067],
              [78.089057, 20.668793],
              [78.094961, 20.669775],
              [78.095662, 20.667539],
              [78.100322, 20.665977],
              [78.100302, 20.659021],
              [78.098216, 20.659519],
              [78.097368, 20.65083],
              [78.093298, 20.640962],
              [78.101491, 20.643917],
              [78.103916, 20.640207],
              [78.111902, 20.640167],
              [78.112271, 20.648963],
              [78.119728, 20.648006],
              [78.126413, 20.648989],
              [78.131369, 20.648004],
              [78.132327, 20.654046],
              [78.126601, 20.657605],
              [78.125032, 20.660814],
              [78.130803, 20.662709],
              [78.132241, 20.66433],
              [78.136144, 20.659886],
              [78.145343, 20.660547],
              [78.159023, 20.659132],
              [78.158916, 20.667224],
              [78.168129, 20.667085],
              [78.169609, 20.669975],
              [78.173802, 20.671396],
              [78.181129, 20.670545],
              [78.182863, 20.677223],
              [78.193547, 20.676585],
              [78.200246, 20.677215],
              [78.209045, 20.67649],
              [78.211063, 20.680194],
              [78.212529, 20.689053],
              [78.21338, 20.68935],
              [78.226467, 20.691311],
              [78.231289, 20.690954],
              [78.233691, 20.689651],
              [78.236602, 20.68634],
              [78.254016, 20.683915],
              [78.256755, 20.684517],
              [78.257333, 20.691414],
              [78.259648, 20.695695],
              [78.274891, 20.696747],
              [78.279534, 20.696391],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 623,
        censuscode: 510,
        dt_cen_cd: 14,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Yavatmal",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [74.693252, 16.716762],
              [74.690975, 16.712106],
              [74.690078, 16.694023],
              [74.690652, 16.687414],
              [74.683971, 16.685705],
              [74.682537, 16.683244],
              [74.682289, 16.680605],
              [74.689613, 16.68024],
              [74.69115, 16.676563],
              [74.666692, 16.665127],
              [74.663749, 16.657153],
              [74.655415, 16.639193],
              [74.657958, 16.63379],
              [74.660926, 16.630342],
              [74.668841, 16.630089],
              [74.680309, 16.621512],
              [74.68626, 16.619777],
              [74.689353, 16.616837],
              [74.689694, 16.612469],
              [74.688431, 16.608919],
              [74.685441, 16.606105],
              [74.673546, 16.608201],
              [74.670262, 16.607633],
              [74.663766, 16.604322],
              [74.658813, 16.602719],
              [74.646626, 16.608605],
              [74.642578, 16.60971],
              [74.637636, 16.608399],
              [74.635963, 16.606327],
              [74.634573, 16.601167],
              [74.634208, 16.595996],
              [74.635355, 16.583595],
              [74.631174, 16.577397],
              [74.625459, 16.579306],
              [74.621722, 16.582585],
              [74.618688, 16.583567],
              [74.619152, 16.579207],
              [74.61741, 16.5753],
              [74.611737, 16.569623],
              [74.599516, 16.563795],
              [74.590538, 16.566049],
              [74.587978, 16.565481],
              [74.586421, 16.562379],
              [74.586238, 16.560486],
              [74.587187, 16.558932],
              [74.586589, 16.557208],
              [74.576102, 16.556657],
              [74.576095, 16.553498],
              [74.568599, 16.553629],
              [74.563611, 16.558054],
              [74.560043, 16.559437],
              [74.556707, 16.559679],
              [74.554155, 16.561397],
              [74.553571, 16.568755],
              [74.554183, 16.573004],
              [74.559604, 16.576266],
              [74.56433, 16.58286],
              [74.560063, 16.591998],
              [74.549051, 16.594027],
              [74.544288, 16.593802],
              [74.544684, 16.610629],
              [74.543804, 16.617122],
              [74.545872, 16.634804],
              [74.524429, 16.632197],
              [74.504536, 16.633028],
              [74.495894, 16.62873],
              [74.492199, 16.628218],
              [74.489701, 16.629253],
              [74.485958, 16.633913],
              [74.484003, 16.637648],
              [74.480017, 16.640692],
              [74.475465, 16.655629],
              [74.471485, 16.662336],
              [74.464204, 16.656751],
              [74.45885, 16.654508],
              [74.459251, 16.648466],
              [74.456869, 16.646054],
              [74.458524, 16.635565],
              [74.463886, 16.625057],
              [74.465452, 16.623362],
              [74.464881, 16.61654],
              [74.466544, 16.6064],
              [74.440948, 16.601935],
              [74.434784, 16.60028],
              [74.427475, 16.595955],
              [74.422732, 16.584338],
              [74.416149, 16.585105],
              [74.407558, 16.581839],
              [74.397279, 16.58027],
              [74.395933, 16.576337],
              [74.394986, 16.572552],
              [74.392173, 16.56704],
              [74.394552, 16.565086],
              [74.394915, 16.562504],
              [74.389249, 16.56113],
              [74.389399, 16.5373],
              [74.386646, 16.532708],
              [74.383664, 16.529549],
              [74.379147, 16.529039],
              [74.364753, 16.539272],
              [74.359753, 16.539266],
              [74.356188, 16.540361],
              [74.358274, 16.545304],
              [74.356489, 16.550182],
              [74.362869, 16.55489],
              [74.359247, 16.558684],
              [74.356687, 16.557816],
              [74.353346, 16.5553],
              [74.348641, 16.554722],
              [74.339649, 16.548071],
              [74.333698, 16.551741],
              [74.32561, 16.555308],
              [74.322871, 16.555081],
              [74.317211, 16.553072],
              [74.315659, 16.546123],
              [74.315589, 16.540664],
              [74.31666, 16.533838],
              [74.316105, 16.520627],
              [74.317345, 16.50794],
              [74.314894, 16.504314],
              [74.307517, 16.503743],
              [74.306862, 16.504899],
              [74.304965, 16.508569],
              [74.301822, 16.523499],
              [74.302299, 16.525628],
              [74.30028, 16.530795],
              [74.290936, 16.533552],
              [74.28779, 16.533157],
              [74.288136, 16.530913],
              [74.282899, 16.524193],
              [74.28284, 16.526889],
              [74.280399, 16.528957],
              [74.279986, 16.531031],
              [74.281484, 16.541079],
              [74.277556, 16.544699],
              [74.269588, 16.546136],
              [74.264758, 16.540277],
              [74.265169, 16.535044],
              [74.268735, 16.526784],
              [74.269856, 16.522238],
              [74.275155, 16.522181],
              [74.277655, 16.518112],
              [74.279962, 16.508403],
              [74.279017, 16.505011],
              [74.271872, 16.502664],
              [74.256278, 16.500592],
              [74.24884, 16.498413],
              [74.246281, 16.496519],
              [74.253236, 16.492551],
              [74.255317, 16.490319],
              [74.257692, 16.487103],
              [74.25835, 16.484053],
              [74.261975, 16.477683],
              [74.271675, 16.4813],
              [74.275787, 16.484226],
              [74.274237, 16.48744],
              [74.27376, 16.491002],
              [74.27657, 16.497669],
              [74.282229, 16.505418],
              [74.293234, 16.504271],
              [74.293888, 16.501276],
              [74.290898, 16.483251],
              [74.288149, 16.476012],
              [74.28975, 16.46838],
              [74.289628, 16.460685],
              [74.294737, 16.460736],
              [74.295752, 16.462749],
              [74.298016, 16.462465],
              [74.300455, 16.461257],
              [74.308244, 16.454877],
              [74.315376, 16.451721],
              [74.324003, 16.454471],
              [74.329062, 16.454757],
              [74.332394, 16.453841],
              [74.333523, 16.44982],
              [74.332271, 16.448326],
              [74.33256, 16.446547],
              [74.336011, 16.444019],
              [74.335769, 16.441262],
              [74.334159, 16.437872],
              [74.334037, 16.434664],
              [74.3373, 16.427248],
              [74.330811, 16.421911],
              [74.3317, 16.415084],
              [74.335487, 16.406927],
              [74.3362, 16.402215],
              [74.342861, 16.40112],
              [74.342745, 16.405661],
              [74.353154, 16.405714],
              [74.358212, 16.404964],
              [74.361477, 16.400193],
              [74.362781, 16.396059],
              [74.36236, 16.392899],
              [74.353242, 16.380562],
              [74.355304, 16.366495],
              [74.345492, 16.368049],
              [74.344676, 16.378502],
              [74.342177, 16.382113],
              [74.3413, 16.38774],
              [74.33934, 16.391244],
              [74.336601, 16.3924],
              [74.333873, 16.392685],
              [74.329463, 16.391364],
              [74.328512, 16.390444],
              [74.328273, 16.384594],
              [74.326059, 16.377304],
              [74.318931, 16.380972],
              [74.321245, 16.372073],
              [74.321116, 16.369841],
              [74.325744, 16.358694],
              [74.325025, 16.357319],
              [74.317174, 16.355368],
              [74.325075, 16.348243],
              [74.327924, 16.342273],
              [74.321739, 16.342853],
              [74.316926, 16.341649],
              [74.318294, 16.338435],
              [74.322626, 16.334354],
              [74.320781, 16.330963],
              [74.317508, 16.32919],
              [74.316491, 16.326894],
              [74.323451, 16.324132],
              [74.326897, 16.325512],
              [74.330823, 16.325159],
              [74.333556, 16.318698],
              [74.329229, 16.316776],
              [74.325037, 16.318184],
              [74.324528, 16.316813],
              [74.325622, 16.312542],
              [74.334148, 16.313404],
              [74.3359, 16.30688],
              [74.333678, 16.305776],
              [74.334718, 16.304612],
              [74.338418, 16.305055],
              [74.342313, 16.293265],
              [74.33625, 16.290568],
              [74.32992, 16.291963],
              [74.325312, 16.287978],
              [74.325676, 16.285903],
              [74.322816, 16.282862],
              [74.322207, 16.281229],
              [74.324174, 16.274752],
              [74.327386, 16.269881],
              [74.330605, 16.267535],
              [74.333987, 16.269379],
              [74.337492, 16.273926],
              [74.343072, 16.27508],
              [74.342952, 16.276867],
              [74.344372, 16.278067],
              [74.34574, 16.27629],
              [74.348771, 16.276302],
              [74.353524, 16.281419],
              [74.354001, 16.283714],
              [74.34531, 16.29001],
              [74.346906, 16.293633],
              [74.348225, 16.291563],
              [74.34976, 16.292722],
              [74.352201, 16.290599],
              [74.356246, 16.288946],
              [74.363311, 16.292517],
              [74.367481, 16.292123],
              [74.37383, 16.295301],
              [74.381207, 16.292157],
              [74.384178, 16.292045],
              [74.385082, 16.277417],
              [74.394595, 16.278071],
              [74.411943, 16.282753],
              [74.415154, 16.282407],
              [74.415522, 16.273288],
              [74.414758, 16.265709],
              [74.416482, 16.259284],
              [74.430334, 16.256612],
              [74.434971, 16.254502],
              [74.435863, 16.255994],
              [74.436818, 16.251404],
              [74.455358, 16.250289],
              [74.455598, 16.245636],
              [74.45756, 16.243688],
              [74.467364, 16.240381],
              [74.470281, 16.240898],
              [74.475025, 16.246193],
              [74.478348, 16.248604],
              [74.489116, 16.239895],
              [74.489351, 16.237829],
              [74.497435, 16.232912],
              [74.502673, 16.224823],
              [74.502073, 16.223162],
              [74.497268, 16.218104],
              [74.496436, 16.216032],
              [74.497506, 16.213451],
              [74.507674, 16.203135],
              [74.507613, 16.201129],
              [74.505175, 16.200722],
              [74.506901, 16.197745],
              [74.507264, 16.191315],
              [74.507261, 16.190172],
              [74.503461, 16.189757],
              [74.496097, 16.187338],
              [74.492119, 16.183255],
              [74.48963, 16.170917],
              [74.488979, 16.156972],
              [74.484246, 16.149155],
              [74.480085, 16.148922],
              [74.481389, 16.145021],
              [74.485251, 16.14394],
              [74.491447, 16.114334],
              [74.490738, 16.103544],
              [74.487826, 16.10056],
              [74.486945, 16.097515],
              [74.487123, 16.094817],
              [74.484754, 16.092344],
              [74.483388, 16.089302],
              [74.476143, 16.088945],
              [74.47317, 16.089863],
              [74.472221, 16.093873],
              [74.458744, 16.104067],
              [74.454166, 16.104864],
              [74.449062, 16.104626],
              [74.438612, 16.107129],
              [74.432014, 16.110105],
              [74.428631, 16.112565],
              [74.416762, 16.104511],
              [74.412428, 16.102832],
              [74.410062, 16.097953],
              [74.40918, 16.093765],
              [74.401521, 16.092651],
              [74.39796, 16.092932],
              [74.391194, 16.089076],
              [74.392208, 16.082078],
              [74.391142, 16.080349],
              [74.384311, 16.081886],
              [74.380632, 16.080046],
              [74.374815, 16.080208],
              [74.373393, 16.078762],
              [74.374409, 16.074983],
              [74.373883, 16.071536],
              [74.368905, 16.065331],
              [74.364758, 16.061529],
              [74.361915, 16.054924],
              [74.364528, 16.052987],
              [74.373956, 16.056735],
              [74.375564, 16.055541],
              [74.3727, 16.045376],
              [74.372042, 16.041245],
              [74.372389, 16.038604],
              [74.383904, 16.037111],
              [74.389961, 16.04158],
              [74.403269, 16.047315],
              [74.403567, 16.049094],
              [74.405172, 16.050979],
              [74.409512, 16.053044],
              [74.416931, 16.055168],
              [74.426193, 16.057112],
              [74.430406, 16.058713],
              [74.434563, 16.058993],
              [74.442155, 16.054394],
              [74.450046, 16.054156],
              [74.458047, 16.049731],
              [74.462197, 16.048695],
              [74.464505, 16.04255],
              [74.461879, 16.035657],
              [74.461339, 16.032274],
              [74.458125, 16.024581],
              [74.45062, 16.010935],
              [74.447529, 16.007831],
              [74.443821, 16.000554],
              [74.444329, 15.994628],
              [74.442566, 15.990321],
              [74.442631, 15.988432],
              [74.44412, 15.985273],
              [74.438094, 15.976375],
              [74.436403, 15.967528],
              [74.429333, 15.953229],
              [74.406278, 15.927263],
              [74.396004, 15.913124],
              [74.385779, 15.903236],
              [74.386263, 15.901344],
              [74.392318, 15.899805],
              [74.393267, 15.897852],
              [74.395613, 15.889365],
              [74.396531, 15.880353],
              [74.393159, 15.876448],
              [74.406255, 15.859757],
              [74.40562, 15.854707],
              [74.400522, 15.854011],
              [74.397097, 15.85108],
              [74.387366, 15.853881],
              [74.386217, 15.859559],
              [74.382426, 15.859323],
              [74.38187, 15.866041],
              [74.37947, 15.875329],
              [74.377015, 15.879863],
              [74.37041, 15.887029],
              [74.36661, 15.889773],
              [74.368325, 15.89202],
              [74.367959, 15.893685],
              [74.364354, 15.89247],
              [74.364444, 15.882083],
              [74.363808, 15.877772],
              [74.361262, 15.875307],
              [74.360853, 15.873174],
              [74.357892, 15.872251],
              [74.346719, 15.861334],
              [74.347153, 15.857829],
              [74.338265, 15.854143],
              [74.340118, 15.851445],
              [74.347533, 15.850199],
              [74.381327, 15.849222],
              [74.383241, 15.846243],
              [74.383376, 15.838426],
              [74.380185, 15.83538],
              [74.368412, 15.829625],
              [74.367231, 15.827955],
              [74.364589, 15.819343],
              [74.360212, 15.817616],
              [74.363003, 15.814288],
              [74.367876, 15.81257],
              [74.368424, 15.80666],
              [74.369686, 15.803334],
              [74.3694, 15.798859],
              [74.364701, 15.78433],
              [74.361743, 15.783745],
              [74.358685, 15.775816],
              [74.344729, 15.765523],
              [74.340524, 15.765266],
              [74.33601, 15.767677],
              [74.328243, 15.769844],
              [74.32343, 15.772533],
              [74.321241, 15.770343],
              [74.3186, 15.76345],
              [74.317728, 15.75869],
              [74.312289, 15.755578],
              [74.308264, 15.754304],
              [74.306614, 15.750452],
              [74.285665, 15.741467],
              [74.278418, 15.745467],
              [74.267417, 15.755263],
              [74.264276, 15.754055],
              [74.259439, 15.749164],
              [74.252277, 15.745529],
              [74.2434, 15.743338],
              [74.237159, 15.746531],
              [74.232218, 15.754273],
              [74.22847, 15.756102],
              [74.228395, 15.761736],
              [74.233589, 15.782867],
              [74.232155, 15.786657],
              [74.228703, 15.78894],
              [74.220529, 15.78778],
              [74.21562, 15.783808],
              [74.210541, 15.780866],
              [74.200497, 15.785336],
              [74.193758, 15.780387],
              [74.184298, 15.775025],
              [74.173571, 15.774257],
              [74.16686, 15.778721],
              [74.155501, 15.787823],
              [74.155721, 15.807283],
              [74.159394, 15.821357],
              [74.142027, 15.821607],
              [74.144476, 15.831538],
              [74.125771, 15.824666],
              [74.111373, 15.821538],
              [74.10799, 15.823246],
              [74.104875, 15.830534],
              [74.103476, 15.839372],
              [74.094762, 15.839519],
              [74.086937, 15.837833],
              [74.076637, 15.833386],
              [74.070297, 15.833141],
              [74.070608, 15.830215],
              [74.066241, 15.824639],
              [74.067739, 15.821603],
              [74.066147, 15.817807],
              [74.066589, 15.813443],
              [74.048829, 15.806687],
              [74.051884, 15.799806],
              [74.055488, 15.788158],
              [74.056735, 15.774217],
              [74.079704, 15.768468],
              [74.077098, 15.766517],
              [74.069585, 15.763284],
              [74.06628, 15.760398],
              [74.056386, 15.758542],
              [74.052136, 15.754507],
              [74.040811, 15.75534],
              [74.029214, 15.764329],
              [74.042583, 15.7709],
              [74.040847, 15.775548],
              [74.035898, 15.781109],
              [74.037769, 15.786732],
              [74.041068, 15.791968],
              [74.040992, 15.796038],
              [74.039668, 15.800921],
              [74.035213, 15.803492],
              [74.031166, 15.820071],
              [74.033961, 15.830872],
              [74.032349, 15.833909],
              [74.043534, 15.8387],
              [74.064639, 15.853911],
              [74.07315, 15.858928],
              [74.083784, 15.867845],
              [74.087348, 15.86717],
              [74.089896, 15.868497],
              [74.092848, 15.871657],
              [74.088507, 15.873202],
              [74.092773, 15.889047],
              [74.091561, 15.896277],
              [74.093918, 15.897494],
              [74.090041, 15.902758],
              [74.08895, 15.909191],
              [74.086983, 15.912622],
              [74.082355, 15.926905],
              [74.081136, 15.933386],
              [74.077096, 15.935268],
              [74.073605, 15.94817],
              [74.071531, 15.94857],
              [74.068538, 15.941559],
              [74.066222, 15.940583],
              [74.059806, 15.943487],
              [74.057249, 15.946181],
              [74.049466, 15.949835],
              [74.048731, 15.952875],
              [74.045992, 15.956712],
              [74.04699, 15.958898],
              [74.049884, 15.960803],
              [74.054088, 15.962128],
              [74.056326, 15.96621],
              [74.057437, 15.97034],
              [74.05695, 15.972691],
              [74.058537, 15.977404],
              [74.066855, 15.987294],
              [74.072698, 15.991845],
              [74.080678, 16.000127],
              [74.084087, 16.003594],
              [74.090917, 16.006443],
              [74.089372, 16.012377],
              [74.087441, 16.015673],
              [74.084116, 16.017715],
              [74.080306, 16.018687],
              [74.076844, 16.020346],
              [74.0755, 16.023912],
              [74.073917, 16.02741],
              [74.071882, 16.030683],
              [74.069116, 16.033394],
              [74.066671, 16.036363],
              [74.064931, 16.039796],
              [74.063354, 16.043296],
              [74.061732, 16.046783],
              [74.059817, 16.050127],
              [74.056698, 16.051044],
              [74.054157, 16.048098],
              [74.052075, 16.044856],
              [74.050937, 16.041211],
              [74.050467, 16.037417],
              [74.048663, 16.034154],
              [74.044808, 16.033768],
              [74.037063, 16.035064],
              [74.026045, 16.033767],
              [74.011441, 16.037054],
              [74.001881, 16.037681],
              [74.001825, 16.05231],
              [74.000012, 16.056453],
              [73.997591, 16.057382],
              [73.994322, 16.057505],
              [73.996542, 16.059804],
              [74.000015, 16.061192],
              [74.002155, 16.062461],
              [74.003429, 16.06362],
              [74.004664, 16.064831],
              [74.00592, 16.066153],
              [74.006736, 16.067588],
              [74.00573, 16.069061],
              [74.005492, 16.070703],
              [74.005751, 16.072409],
              [74.006133, 16.074141],
              [74.006475, 16.075869],
              [74.000005, 16.078422],
              [73.992872, 16.077636],
              [73.994321, 16.080845],
              [73.998824, 16.086946],
              [73.997596, 16.088369],
              [73.988575, 16.090543],
              [73.973665, 16.091313],
              [73.967159, 16.095125],
              [73.965253, 16.094875],
              [73.958074, 16.096124],
              [73.948051, 16.098432],
              [73.940435, 16.09727],
              [73.936552, 16.095134],
              [73.933529, 16.095981],
              [73.918563, 16.097384],
              [73.906994, 16.099878],
              [73.903181, 16.098469],
              [73.901217, 16.089011],
              [73.898539, 16.089027],
              [73.896596, 16.091443],
              [73.886583, 16.095458],
              [73.884911, 16.093857],
              [73.876373, 16.097223],
              [73.871423, 16.094549],
              [73.865086, 16.097388],
              [73.869941, 16.10322],
              [73.87353, 16.106358],
              [73.860347, 16.107167],
              [73.858237, 16.102586],
              [73.854855, 16.103576],
              [73.852738, 16.098014],
              [73.85101, 16.09779],
              [73.848258, 16.094937],
              [73.845408, 16.095289],
              [73.845304, 16.08944],
              [73.848119, 16.083058],
              [73.851204, 16.082242],
              [73.85442, 16.084005],
              [73.856911, 16.082844],
              [73.858107, 16.075036],
              [73.845122, 16.078763],
              [73.843282, 16.088922],
              [73.84092, 16.091407],
              [73.836836, 16.092742],
              [73.835775, 16.09389],
              [73.835546, 16.09567],
              [73.839942, 16.10392],
              [73.845431, 16.107685],
              [73.848346, 16.116217],
              [73.849957, 16.118221],
              [73.850757, 16.120972],
              [73.84805, 16.12511],
              [73.84925, 16.126715],
              [73.849143, 16.128493],
              [73.847548, 16.131083],
              [73.854104, 16.132887],
              [73.854958, 16.135697],
              [73.852091, 16.143111],
              [73.845851, 16.152313],
              [73.855847, 16.144702],
              [73.867274, 16.138334],
              [73.866246, 16.143675],
              [73.867327, 16.146479],
              [73.870183, 16.146181],
              [73.872889, 16.142435],
              [73.876824, 16.143734],
              [73.886575, 16.14511],
              [73.889464, 16.141136],
              [73.891655, 16.139923],
              [73.899601, 16.138261],
              [73.905531, 16.135472],
              [73.909924, 16.135267],
              [73.912081, 16.137364],
              [73.913979, 16.137578],
              [73.916192, 16.13922],
              [73.91669, 16.141837],
              [73.914782, 16.148755],
              [73.917513, 16.148496],
              [73.919009, 16.150417],
              [73.919922, 16.153369],
              [73.914245, 16.157481],
              [73.909077, 16.158574],
              [73.91961, 16.167081],
              [73.916076, 16.172394],
              [73.922032, 16.174114],
              [73.924581, 16.17281],
              [73.926344, 16.170034],
              [73.931503, 16.168464],
              [73.934083, 16.170921],
              [73.940093, 16.1727],
              [73.946815, 16.17222],
              [73.948909, 16.174257],
              [73.948935, 16.17735],
              [73.949297, 16.17856],
              [73.948482, 16.180519],
              [73.943271, 16.18345],
              [73.94228, 16.186753],
              [73.945654, 16.192145],
              [73.948799, 16.192419],
              [73.953575, 16.194604],
              [73.959614, 16.199128],
              [73.959858, 16.200276],
              [73.957371, 16.201638],
              [73.959072, 16.205732],
              [73.957642, 16.206182],
              [73.953237, 16.205446],
              [73.946086, 16.203065],
              [73.943486, 16.204431],
              [73.942184, 16.206272],
              [73.939567, 16.206172],
              [73.932894, 16.20325],
              [73.930334, 16.202835],
              [73.927515, 16.200071],
              [73.928748, 16.205948],
              [73.927988, 16.207288],
              [73.929174, 16.207207],
              [73.929906, 16.209095],
              [73.931153, 16.209769],
              [73.930341, 16.211973],
              [73.927961, 16.212646],
              [73.927911, 16.214146],
              [73.92906, 16.216331],
              [73.926983, 16.217177],
              [73.925926, 16.218874],
              [73.927065, 16.219788],
              [73.931996, 16.219833],
              [73.934883, 16.223698],
              [73.939072, 16.227636],
              [73.93849, 16.229617],
              [73.942574, 16.234545],
              [73.947709, 16.238187],
              [73.946901, 16.241089],
              [73.944175, 16.243005],
              [73.943511, 16.240927],
              [73.941594, 16.2389],
              [73.940003, 16.241641],
              [73.932182, 16.237455],
              [73.929689, 16.237648],
              [73.927835, 16.236794],
              [73.927114, 16.234595],
              [73.925196, 16.232933],
              [73.921567, 16.232923],
              [73.917617, 16.230244],
              [73.917273, 16.231579],
              [73.915327, 16.233575],
              [73.910693, 16.233912],
              [73.899683, 16.23288],
              [73.894017, 16.230688],
              [73.893008, 16.230934],
              [73.898981, 16.234496],
              [73.915333, 16.241893],
              [73.920117, 16.245892],
              [73.916384, 16.248282],
              [73.90831, 16.249783],
              [73.910426, 16.254777],
              [73.907467, 16.256918],
              [73.898065, 16.256699],
              [73.896527, 16.257227],
              [73.89626, 16.261072],
              [73.893807, 16.268202],
              [73.887664, 16.274777],
              [73.881638, 16.279402],
              [73.890631, 16.290023],
              [73.891603, 16.29294],
              [73.891025, 16.295636],
              [73.891354, 16.299479],
              [73.89673, 16.302605],
              [73.902629, 16.304123],
              [73.905341, 16.317295],
              [73.904703, 16.328306],
              [73.901506, 16.330445],
              [73.899067, 16.330171],
              [73.88843, 16.323411],
              [73.887488, 16.325025],
              [73.887272, 16.328518],
              [73.884802, 16.324004],
              [73.876778, 16.317106],
              [73.870702, 16.315248],
              [73.866436, 16.309246],
              [73.863281, 16.309381],
              [73.860157, 16.312839],
              [73.85701, 16.315033],
              [73.853061, 16.310585],
              [73.849786, 16.302285],
              [73.847216, 16.300119],
              [73.848675, 16.304868],
              [73.849385, 16.313409],
              [73.847849, 16.314851],
              [73.841261, 16.316779],
              [73.848848, 16.32219],
              [73.848868, 16.325342],
              [73.845976, 16.328976],
              [73.846066, 16.333328],
              [73.838642, 16.343639],
              [73.835792, 16.34423],
              [73.835736, 16.345947],
              [73.839687, 16.348796],
              [73.840722, 16.352404],
              [73.842513, 16.352907],
              [73.843297, 16.355314],
              [73.846516, 16.355868],
              [73.851567, 16.355098],
              [73.857539, 16.358562],
              [73.856739, 16.362753],
              [73.859675, 16.366121],
              [73.864203, 16.366666],
              [73.866341, 16.373714],
              [73.862815, 16.380677],
              [73.859691, 16.384702],
              [73.852576, 16.388241],
              [73.839024, 16.392215],
              [73.837853, 16.403005],
              [73.847435, 16.411495],
              [73.852714, 16.417079],
              [73.854036, 16.419708],
              [73.862159, 16.424353],
              [73.866721, 16.428499],
              [73.867743, 16.430094],
              [73.868062, 16.433012],
              [73.871373, 16.438873],
              [73.875261, 16.440618],
              [73.879423, 16.440356],
              [73.880384, 16.441892],
              [73.880409, 16.444347],
              [73.882605, 16.444103],
              [73.883921, 16.445228],
              [73.885503, 16.449893],
              [73.887759, 16.448627],
              [73.88854, 16.457505],
              [73.886139, 16.47178],
              [73.884544, 16.473568],
              [73.884907, 16.474768],
              [73.88234, 16.473931],
              [73.878906, 16.476595],
              [73.875025, 16.475831],
              [73.86935, 16.473317],
              [73.864301, 16.475223],
              [73.861655, 16.479791],
              [73.860495, 16.483488],
              [73.856452, 16.484626],
              [73.853612, 16.487187],
              [73.852076, 16.490022],
              [73.851517, 16.494568],
              [73.846851, 16.500698],
              [73.843616, 16.506686],
              [73.843851, 16.514948],
              [73.84779, 16.516816],
              [73.84867, 16.523184],
              [73.848338, 16.526342],
              [73.843607, 16.531305],
              [73.839137, 16.530991],
              [73.831999, 16.533045],
              [73.82746, 16.539841],
              [73.823649, 16.541185],
              [73.818135, 16.54495],
              [73.81874, 16.546549],
              [73.820221, 16.545276],
              [73.826166, 16.543522],
              [73.832682, 16.546459],
              [73.833356, 16.548805],
              [73.832538, 16.55168],
              [73.833807, 16.55459],
              [73.840718, 16.562172],
              [73.84745, 16.571009],
              [73.84794, 16.573765],
              [73.845331, 16.575789],
              [73.846442, 16.58163],
              [73.843912, 16.58549],
              [73.849629, 16.593246],
              [73.859389, 16.600217],
              [73.863373, 16.608389],
              [73.863888, 16.61326],
              [73.858267, 16.620182],
              [73.855104, 16.627313],
              [73.854473, 16.631509],
              [73.852659, 16.635766],
              [73.854007, 16.650192],
              [73.854975, 16.651619],
              [73.85712, 16.65184],
              [73.85833, 16.654307],
              [73.856093, 16.659429],
              [73.858913, 16.66073],
              [73.863163, 16.664329],
              [73.862033, 16.664788],
              [73.865037, 16.667758],
              [73.866009, 16.669938],
              [73.864825, 16.671611],
              [73.859651, 16.672963],
              [73.8547, 16.672357],
              [73.853446, 16.673276],
              [73.860753, 16.677548],
              [73.860599, 16.68059],
              [73.855632, 16.686595],
              [73.847611, 16.691339],
              [73.843392, 16.692918],
              [73.837376, 16.69369],
              [73.827434, 16.697476],
              [73.826311, 16.698629],
              [73.825434, 16.701512],
              [73.823047, 16.701233],
              [73.821708, 16.705608],
              [73.820106, 16.706472],
              [73.816121, 16.707639],
              [73.813306, 16.706566],
              [73.813448, 16.710009],
              [73.816987, 16.713897],
              [73.820936, 16.715888],
              [73.824522, 16.7165],
              [73.828031, 16.714417],
              [73.832529, 16.727949],
              [73.839007, 16.732909],
              [73.841182, 16.736282],
              [73.841076, 16.738813],
              [73.837024, 16.739978],
              [73.83311, 16.742591],
              [73.833482, 16.745112],
              [73.834806, 16.747282],
              [73.832305, 16.748216],
              [73.830769, 16.749723],
              [73.828065, 16.755481],
              [73.823435, 16.758949],
              [73.819124, 16.765],
              [73.813704, 16.766116],
              [73.80767, 16.765861],
              [73.804142, 16.764153],
              [73.801316, 16.760724],
              [73.794522, 16.76145],
              [73.791732, 16.762786],
              [73.787526, 16.76769],
              [73.785894, 16.7739],
              [73.780579, 16.782368],
              [73.778245, 16.780999],
              [73.769892, 16.771679],
              [73.762123, 16.770107],
              [73.761031, 16.777116],
              [73.759553, 16.779076],
              [73.756815, 16.780131],
              [73.756706, 16.781161],
              [73.75712, 16.785121],
              [73.759268, 16.785637],
              [73.761501, 16.798662],
              [73.760631, 16.802799],
              [73.756413, 16.805686],
              [73.753066, 16.80536],
              [73.752415, 16.806339],
              [73.752881, 16.812944],
              [73.747771, 16.81687],
              [73.743246, 16.817924],
              [73.737884, 16.820653],
              [73.734214, 16.816251],
              [73.729375, 16.816215],
              [73.730483, 16.820519],
              [73.718151, 16.825401],
              [73.715289, 16.825522],
              [73.713506, 16.82651],
              [73.712215, 16.829901],
              [73.718694, 16.835334],
              [73.724795, 16.837027],
              [73.728107, 16.832642],
              [73.730274, 16.834241],
              [73.732586, 16.832511],
              [73.734593, 16.838296],
              [73.737793, 16.843681],
              [73.7523, 16.834366],
              [73.760655, 16.842306],
              [73.766437, 16.848943],
              [73.766095, 16.851874],
              [73.769273, 16.854097],
              [73.768451, 16.856167],
              [73.764004, 16.859983],
              [73.767906, 16.86232],
              [73.768654, 16.866787],
              [73.767843, 16.870417],
              [73.762199, 16.873425],
              [73.748795, 16.882564],
              [73.750872, 16.894556],
              [73.750135, 16.898986],
              [73.748902, 16.901575],
              [73.747529, 16.901752],
              [73.74088, 16.897647],
              [73.739022, 16.897368],
              [73.740369, 16.908505],
              [73.739555, 16.912646],
              [73.744509, 16.916646],
              [73.748482, 16.904858],
              [73.752598, 16.905118],
              [73.754339, 16.906719],
              [73.755889, 16.906889],
              [73.757798, 16.906473],
              [73.761174, 16.90387],
              [73.764118, 16.908048],
              [73.767817, 16.908441],
              [73.771558, 16.90779],
              [73.776457, 16.909136],
              [73.780928, 16.909178],
              [73.788253, 16.906731],
              [73.790346, 16.907866],
              [73.793124, 16.912099],
              [73.793746, 16.915662],
              [73.792051, 16.921357],
              [73.795188, 16.926446],
              [73.795571, 16.930177],
              [73.789848, 16.941348],
              [73.783603, 16.945119],
              [73.78223, 16.944667],
              [73.778245, 16.947897],
              [73.776179, 16.952731],
              [73.768571, 16.958863],
              [73.765848, 16.962605],
              [73.767248, 16.967138],
              [73.773451, 16.974002],
              [73.778293, 16.974723],
              [73.786619, 16.985473],
              [73.785461, 16.991228],
              [73.787751, 16.992767],
              [73.796538, 16.992666],
              [73.801008, 16.990397],
              [73.808013, 16.98956],
              [73.817259, 16.98722],
              [73.823312, 16.989362],
              [73.829125, 16.990081],
              [73.831799, 16.98915],
              [73.833911, 16.990633],
              [73.835351, 17.000401],
              [73.831978, 17.00911],
              [73.82766, 17.012774],
              [73.833784, 17.021969],
              [73.834325, 17.025767],
              [73.828653, 17.033248],
              [73.823091, 17.037932],
              [73.834602, 17.053872],
              [73.82363, 17.061518],
              [73.817278, 17.0635],
              [73.803917, 17.061644],
              [73.805322, 17.072106],
              [73.807766, 17.081492],
              [73.807649, 17.085618],
              [73.796288, 17.094414],
              [73.793286, 17.094715],
              [73.788714, 17.093101],
              [73.781322, 17.107629],
              [73.768842, 17.108761],
              [73.763132, 17.117513],
              [73.759468, 17.121314],
              [73.751278, 17.128533],
              [73.746887, 17.131284],
              [73.743622, 17.124462],
              [73.739449, 17.121595],
              [73.729418, 17.126905],
              [73.723662, 17.128433],
              [73.718463, 17.132374],
              [73.710573, 17.140396],
              [73.703056, 17.140119],
              [73.697444, 17.138536],
              [73.694208, 17.138717],
              [73.691615, 17.143383],
              [73.690049, 17.150408],
              [73.689456, 17.158323],
              [73.702287, 17.162938],
              [73.709278, 17.167295],
              [73.709323, 17.169653],
              [73.713271, 17.171547],
              [73.717104, 17.171707],
              [73.723294, 17.16905],
              [73.732136, 17.167342],
              [73.736481, 17.168495],
              [73.743402, 17.175247],
              [73.747386, 17.173756],
              [73.748405, 17.16924],
              [73.746289, 17.160312],
              [73.749951, 17.152157],
              [73.752282, 17.153681],
              [73.756846, 17.154214],
              [73.759805, 17.152593],
              [73.765815, 17.152563],
              [73.768147, 17.153402],
              [73.77698, 17.151808],
              [73.778569, 17.153721],
              [73.777813, 17.156584],
              [73.77236, 17.164711],
              [73.769931, 17.171268],
              [73.77213, 17.17681],
              [73.775449, 17.179333],
              [73.780595, 17.180035],
              [73.793306, 17.178034],
              [73.803514, 17.171868],
              [73.815118, 17.171747],
              [73.81893, 17.168935],
              [73.82762, 17.167339],
              [73.845825, 17.153768],
              [73.849312, 17.152671],
              [73.857638, 17.142683],
              [73.860518, 17.137903],
              [73.864052, 17.137669],
              [73.865986, 17.13609],
              [73.868506, 17.131471],
              [73.874837, 17.131621],
              [73.878389, 17.130233],
              [73.879619, 17.127672],
              [73.876717, 17.125391],
              [73.874851, 17.121979],
              [73.878096, 17.116687],
              [73.886559, 17.109914],
              [73.896604, 17.105641],
              [73.901849, 17.102274],
              [73.904848, 17.097379],
              [73.907968, 17.083301],
              [73.910724, 17.078806],
              [73.915323, 17.074221],
              [73.916905, 17.067992],
              [73.921991, 17.071739],
              [73.931111, 17.073349],
              [73.933575, 17.072295],
              [73.940318, 17.068661],
              [73.944468, 17.06252],
              [73.949739, 17.060703],
              [73.950327, 17.057379],
              [73.954137, 17.054052],
              [73.959808, 17.054355],
              [73.963824, 17.04816],
              [73.974748, 17.038614],
              [73.976745, 17.035598],
              [73.980998, 17.034109],
              [73.98337, 17.02829],
              [73.982048, 17.013325],
              [73.978881, 17.007736],
              [73.972275, 17.004001],
              [73.972979, 17.000163],
              [73.971064, 16.996146],
              [73.971265, 16.993078],
              [73.975936, 16.988018],
              [73.981069, 16.985762],
              [73.985631, 16.985297],
              [73.990049, 16.986914],
              [73.995575, 16.99462],
              [74.000031, 16.990109],
              [74.006952, 16.987756],
              [74.02268, 16.984409],
              [74.023669, 16.978131],
              [74.023199, 16.97368],
              [74.020582, 16.968946],
              [74.025153, 16.965896],
              [74.026759, 16.963345],
              [74.02547, 16.961617],
              [74.020931, 16.961093],
              [74.0207, 16.958707],
              [74.022774, 16.955807],
              [74.026288, 16.953048],
              [74.02716, 16.949549],
              [74.023537, 16.942076],
              [74.026431, 16.940457],
              [74.03102, 16.94044],
              [74.035982, 16.938475],
              [74.036702, 16.932871],
              [74.039369, 16.923927],
              [74.041782, 16.922208],
              [74.047396, 16.9221],
              [74.052772, 16.913506],
              [74.061147, 16.911276],
              [74.065055, 16.908747],
              [74.066426, 16.903344],
              [74.071502, 16.902483],
              [74.07772, 16.904525],
              [74.084778, 16.909358],
              [74.090278, 16.914742],
              [74.093602, 16.913382],
              [74.096254, 16.911344],
              [74.098033, 16.908564],
              [74.108325, 16.908379],
              [74.113291, 16.910039],
              [74.121327, 16.911425],
              [74.123755, 16.902907],
              [74.134287, 16.889521],
              [74.140643, 16.885915],
              [74.14806, 16.883894],
              [74.152273, 16.886246],
              [74.155023, 16.887209],
              [74.158317, 16.890474],
              [74.162074, 16.89609],
              [74.170234, 16.898175],
              [74.176753, 16.898844],
              [74.182076, 16.896793],
              [74.18779, 16.893232],
              [74.192236, 16.891884],
              [74.201681, 16.892618],
              [74.208637, 16.891798],
              [74.212229, 16.892246],
              [74.213476, 16.897672],
              [74.213049, 16.905437],
              [74.217169, 16.910759],
              [74.223373, 16.910631],
              [74.229585, 16.903046],
              [74.232013, 16.894216],
              [74.232356, 16.887885],
              [74.237552, 16.885549],
              [74.243988, 16.885185],
              [74.249857, 16.886047],
              [74.254463, 16.900031],
              [74.257423, 16.904512],
              [74.270228, 16.90891],
              [74.276668, 16.914124],
              [74.281705, 16.915461],
              [74.285549, 16.91113],
              [74.291963, 16.896416],
              [74.297584, 16.891765],
              [74.30868, 16.888906],
              [74.314432, 16.889995],
              [74.319892, 16.885978],
              [74.324086, 16.88182],
              [74.326708, 16.876196],
              [74.332013, 16.876088],
              [74.339021, 16.877499],
              [74.348587, 16.870177],
              [74.35502, 16.869819],
              [74.355642, 16.863376],
              [74.357974, 16.858449],
              [74.361322, 16.853386],
              [74.365247, 16.852784],
              [74.37971, 16.867076],
              [74.387113, 16.86739],
              [74.395925, 16.8772],
              [74.402843, 16.879877],
              [74.404822, 16.875127],
              [74.415489, 16.877145],
              [74.416061, 16.870991],
              [74.411713, 16.860975],
              [74.406451, 16.855048],
              [74.405087, 16.850197],
              [74.40807, 16.845194],
              [74.413896, 16.841852],
              [74.421131, 16.842281],
              [74.429896, 16.844741],
              [74.435968, 16.849444],
              [74.460772, 16.851569],
              [74.46466, 16.854535],
              [74.466444, 16.858209],
              [74.467289, 16.863546],
              [74.47016, 16.867165],
              [74.480177, 16.865602],
              [74.48571, 16.861408],
              [74.486961, 16.859272],
              [74.493287, 16.858755],
              [74.495956, 16.855531],
              [74.494936, 16.851458],
              [74.49425, 16.839963],
              [74.49479, 16.837611],
              [74.496807, 16.834682],
              [74.497812, 16.829057],
              [74.503723, 16.832437],
              [74.507067, 16.835759],
              [74.513995, 16.839483],
              [74.514774, 16.84413],
              [74.513491, 16.854643],
              [74.516955, 16.856654],
              [74.524804, 16.848023],
              [74.529153, 16.846067],
              [74.53571, 16.845651],
              [74.549385, 16.83064],
              [74.557115, 16.81943],
              [74.55929, 16.806672],
              [74.561844, 16.804834],
              [74.569232, 16.80293],
              [74.581451, 16.801352],
              [74.590992, 16.801799],
              [74.599397, 16.801089],
              [74.607258, 16.798494],
              [74.614043, 16.79509],
              [74.631843, 16.785806],
              [74.641173, 16.776605],
              [74.645081, 16.769237],
              [74.644691, 16.757525],
              [74.645812, 16.754018],
              [74.648005, 16.750742],
              [74.661238, 16.749794],
              [74.700459, 16.733967],
              [74.701045, 16.731378],
              [74.697621, 16.722948],
              [74.693252, 16.716762],
            ],
            [
              [74.289747, 15.830796],
              [74.277359, 15.827286],
              [74.260348, 15.826894],
              [74.261961, 15.823917],
              [74.26552, 15.821465],
              [74.265573, 15.819193],
              [74.26514, 15.816646],
              [74.267, 15.811856],
              [74.267029, 15.810496],
              [74.268172, 15.809157],
              [74.26708, 15.80792],
              [74.26711, 15.806424],
              [74.267224, 15.801092],
              [74.266245, 15.799679],
              [74.265233, 15.797057],
              [74.265022, 15.79445],
              [74.26638, 15.793179],
              [74.270055, 15.793438],
              [74.28707, 15.788338],
              [74.289628, 15.793829],
              [74.292288, 15.793879],
              [74.297787, 15.788585],
              [74.309107, 15.798563],
              [74.303606, 15.806058],
              [74.296282, 15.815704],
              [74.289747, 15.830796],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 313,
        censuscode: 530,
        dt_cen_cd: 34,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Kolhapur",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [79.511888, 21.589401],
              [79.516736, 21.582312],
              [79.527802, 21.579485],
              [79.53375, 21.573974],
              [79.538233, 21.572161],
              [79.543642, 21.568181],
              [79.54561, 21.564393],
              [79.54216, 21.554176],
              [79.539976, 21.54997],
              [79.54031, 21.54739],
              [79.542714, 21.543442],
              [79.534511, 21.539637],
              [79.529347, 21.540049],
              [79.514229, 21.534129],
              [79.503764, 21.521457],
              [79.496903, 21.514412],
              [79.493194, 21.508321],
              [79.485759, 21.502003],
              [79.475124, 21.483627],
              [79.474607, 21.480802],
              [79.470019, 21.479104],
              [79.45933, 21.460672],
              [79.456268, 21.4588],
              [79.449303, 21.456517],
              [79.45021, 21.451774],
              [79.452406, 21.448508],
              [79.450496, 21.434946],
              [79.455231, 21.428998],
              [79.460421, 21.425936],
              [79.471503, 21.424208],
              [79.479611, 21.426921],
              [79.48328, 21.427325],
              [79.49165, 21.404821],
              [79.491605, 21.40252],
              [79.487886, 21.398666],
              [79.500351, 21.397557],
              [79.507623, 21.386117],
              [79.516032, 21.372746],
              [79.517753, 21.368891],
              [79.523309, 21.364059],
              [79.526449, 21.354722],
              [79.529378, 21.351541],
              [79.535742, 21.34799],
              [79.547694, 21.331345],
              [79.556918, 21.330299],
              [79.557913, 21.327966],
              [79.558405, 21.322638],
              [79.55495, 21.316101],
              [79.558107, 21.31332],
              [79.559043, 21.310988],
              [79.556865, 21.308798],
              [79.556027, 21.306244],
              [79.558724, 21.302698],
              [79.565232, 21.301921],
              [79.568085, 21.299022],
              [79.5756, 21.283324],
              [79.576719, 21.277434],
              [79.575923, 21.273739],
              [79.571279, 21.273765],
              [79.56897, 21.25352],
              [79.571464, 21.247044],
              [79.5657, 21.241926],
              [79.56112, 21.236329],
              [79.560515, 21.234526],
              [79.563879, 21.225606],
              [79.556084, 21.208777],
              [79.553179, 21.206153],
              [79.554135, 21.204863],
              [79.558026, 21.204061],
              [79.559513, 21.201638],
              [79.560396, 21.192007],
              [79.5618, 21.190493],
              [79.562961, 21.187081],
              [79.554545, 21.172109],
              [79.554728, 21.170161],
              [79.560704, 21.163733],
              [79.562033, 21.160784],
              [79.561778, 21.155488],
              [79.556188, 21.15595],
              [79.551865, 21.157251],
              [79.548134, 21.156968],
              [79.543833, 21.155637],
              [79.534339, 21.156089],
              [79.528618, 21.167645],
              [79.531404, 21.170313],
              [79.532552, 21.174492],
              [79.5264, 21.175512],
              [79.519612, 21.173349],
              [79.501646, 21.183267],
              [79.499183, 21.180142],
              [79.498137, 21.17166],
              [79.510491, 21.16267],
              [79.506218, 21.145807],
              [79.504019, 21.143957],
              [79.493404, 21.141341],
              [79.492735, 21.13936],
              [79.498343, 21.135966],
              [79.50768, 21.133839],
              [79.511766, 21.131497],
              [79.512831, 21.128018],
              [79.51211, 21.124719],
              [79.513704, 21.121323],
              [79.527544, 21.117493],
              [79.528366, 21.114536],
              [79.53202, 21.107925],
              [79.530106, 21.105913],
              [79.533818, 21.103436],
              [79.532772, 21.101227],
              [79.530904, 21.099846],
              [79.53104, 21.09738],
              [79.533182, 21.095602],
              [79.530651, 21.088291],
              [79.523014, 21.08766],
              [79.529472, 21.075318],
              [79.542688, 21.081001],
              [79.551934, 21.086385],
              [79.558184, 21.083524],
              [79.568884, 21.070045],
              [79.57312, 21.067232],
              [79.577966, 21.066004],
              [79.581987, 21.068589],
              [79.586451, 21.072813],
              [79.588722, 21.076097],
              [79.592576, 21.076618],
              [79.599651, 21.072462],
              [79.603583, 21.061658],
              [79.607377, 21.056308],
              [79.610207, 21.050465],
              [79.612629, 21.038412],
              [79.618879, 21.026698],
              [79.636701, 21.000608],
              [79.63649, 20.996511],
              [79.63758, 20.990897],
              [79.643091, 20.984615],
              [79.647205, 20.981884],
              [79.653513, 20.97751],
              [79.659604, 20.969417],
              [79.659524, 20.957888],
              [79.660915, 20.952813],
              [79.659012, 20.9436],
              [79.651578, 20.926601],
              [79.644136, 20.916538],
              [79.639302, 20.913638],
              [79.621937, 20.907227],
              [79.616588, 20.902533],
              [79.611277, 20.878398],
              [79.615433, 20.872162],
              [79.615946, 20.867994],
              [79.619129, 20.864723],
              [79.617426, 20.864116],
              [79.612716, 20.864778],
              [79.60422, 20.864266],
              [79.596131, 20.85637],
              [79.588257, 20.846934],
              [79.583033, 20.842415],
              [79.57903, 20.843482],
              [79.568948, 20.843577],
              [79.568749, 20.84707],
              [79.566313, 20.849606],
              [79.559825, 20.853318],
              [79.554487, 20.848116],
              [79.546192, 20.850069],
              [79.543517, 20.849621],
              [79.541595, 20.847803],
              [79.549055, 20.836022],
              [79.551672, 20.830564],
              [79.554314, 20.820927],
              [79.560413, 20.809638],
              [79.56043, 20.802868],
              [79.549021, 20.792902],
              [79.54556, 20.78589],
              [79.537509, 20.776329],
              [79.53557, 20.772848],
              [79.537192, 20.765028],
              [79.533259, 20.748892],
              [79.533313, 20.745912],
              [79.535458, 20.739986],
              [79.521904, 20.724813],
              [79.51375, 20.714209],
              [79.509309, 20.707651],
              [79.509017, 20.703948],
              [79.505689, 20.69989],
              [79.496338, 20.699146],
              [79.494382, 20.70443],
              [79.491563, 20.704044],
              [79.489611, 20.698151],
              [79.482697, 20.689589],
              [79.475042, 20.680915],
              [79.467412, 20.67442],
              [79.460032, 20.668905],
              [79.451028, 20.664373],
              [79.445398, 20.663313],
              [79.434922, 20.658781],
              [79.428709, 20.660599],
              [79.417987, 20.656071],
              [79.406876, 20.655501],
              [79.399021, 20.657326],
              [79.392706, 20.660462],
              [79.389517, 20.665585],
              [79.389461, 20.672354],
              [79.384977, 20.675764],
              [79.375521, 20.6773],
              [79.371041, 20.674055],
              [79.363687, 20.670826],
              [79.352827, 20.671287],
              [79.350396, 20.665221],
              [79.355897, 20.659917],
              [79.357388, 20.655263],
              [79.353622, 20.650524],
              [79.34588, 20.644259],
              [79.344752, 20.640587],
              [79.347376, 20.634038],
              [79.334692, 20.613568],
              [79.33433, 20.607829],
              [79.332882, 20.60211],
              [79.327093, 20.589231],
              [79.321791, 20.583241],
              [79.313112, 20.580647],
              [79.304167, 20.583438],
              [79.296519, 20.58767],
              [79.292501, 20.588775],
              [79.280637, 20.585221],
              [79.263373, 20.58497],
              [79.251491, 20.586058],
              [79.226393, 20.58336],
              [79.224721, 20.582068],
              [79.220252, 20.589253],
              [79.213714, 20.593601],
              [79.212069, 20.594694],
              [79.209384, 20.597392],
              [79.195512, 20.600648],
              [79.19257, 20.596112],
              [79.188572, 20.602624],
              [79.188009, 20.611158],
              [79.186307, 20.613582],
              [79.186245, 20.618807],
              [79.183238, 20.61691],
              [79.180868, 20.616736],
              [79.176033, 20.619846],
              [79.175404, 20.623156],
              [79.170735, 20.624493],
              [79.171875, 20.630595],
              [79.171204, 20.635916],
              [79.169996, 20.638076],
              [79.171086, 20.641535],
              [79.170371, 20.643012],
              [79.151286, 20.650111],
              [79.149418, 20.651565],
              [79.150082, 20.657023],
              [79.149261, 20.658444],
              [79.1447, 20.660066],
              [79.146862, 20.667276],
              [79.145076, 20.66804],
              [79.142875, 20.675855],
              [79.131408, 20.678129],
              [79.106921, 20.685679],
              [79.109112, 20.696393],
              [79.104113, 20.712174],
              [79.098548, 20.709637],
              [79.092181, 20.70795],
              [79.08965, 20.711342],
              [79.086055, 20.713442],
              [79.076735, 20.715239],
              [79.074157, 20.723616],
              [79.069287, 20.722703],
              [79.060674, 20.722626],
              [79.05357, 20.726313],
              [79.052826, 20.734274],
              [79.045373, 20.734275],
              [79.041575, 20.73752],
              [79.037729, 20.734619],
              [79.019739, 20.736112],
              [79.018, 20.739922],
              [79.012684, 20.74232],
              [79.010389, 20.741298],
              [79.005074, 20.741063],
              [78.999957, 20.742415],
              [78.997526, 20.753885],
              [78.988891, 20.751668],
              [78.978946, 20.754192],
              [78.973701, 20.754223],
              [78.971713, 20.755232],
              [78.965736, 20.758275],
              [78.958177, 20.764093],
              [78.956872, 20.766809],
              [78.945159, 20.766975],
              [78.942111, 20.779995],
              [78.948436, 20.782369],
              [78.94897, 20.784615],
              [78.948506, 20.788617],
              [78.946739, 20.793926],
              [78.945344, 20.793797],
              [78.931817, 20.797836],
              [78.92803, 20.797418],
              [78.925673, 20.801538],
              [78.921126, 20.805244],
              [78.915501, 20.806406],
              [78.917043, 20.811638],
              [78.919777, 20.813093],
              [78.919063, 20.817383],
              [78.914912, 20.818273],
              [78.915919, 20.835121],
              [78.908504, 20.838344],
              [78.900556, 20.83922],
              [78.888447, 20.841784],
              [78.885775, 20.840966],
              [78.885638, 20.835113],
              [78.883717, 20.831483],
              [78.875039, 20.82672],
              [78.873002, 20.828896],
              [78.868827, 20.837374],
              [78.864025, 20.842178],
              [78.861221, 20.861008],
              [78.862743, 20.86785],
              [78.864001, 20.870138],
              [78.864705, 20.871321],
              [78.86218, 20.873836],
              [78.858867, 20.875258],
              [78.852956, 20.874297],
              [78.848804, 20.87479],
              [78.84111, 20.880432],
              [78.839566, 20.882379],
              [78.839818, 20.888181],
              [78.842472, 20.89061],
              [78.836408, 20.893674],
              [78.832132, 20.89308],
              [78.828557, 20.891109],
              [78.826438, 20.88879],
              [78.820489, 20.878875],
              [78.813002, 20.876305],
              [78.809707, 20.876115],
              [78.804818, 20.87672],
              [78.796203, 20.8835],
              [78.79188, 20.888184],
              [78.787892, 20.890289],
              [78.778471, 20.891199],
              [78.770029, 20.898903],
              [78.77294, 20.901165],
              [78.774011, 20.903416],
              [78.773732, 20.907604],
              [78.765896, 20.920934],
              [78.760788, 20.919186],
              [78.757395, 20.922094],
              [78.745962, 20.935401],
              [78.744338, 20.938899],
              [78.749423, 20.943233],
              [78.746112, 20.944073],
              [78.740015, 20.943405],
              [78.736948, 20.944647],
              [78.735089, 20.946988],
              [78.73194, 20.961845],
              [78.72692, 20.968702],
              [78.726648, 20.971798],
              [78.726171, 20.988342],
              [78.730985, 20.995274],
              [78.73118, 21.000524],
              [78.730942, 21.004614],
              [78.726008, 21.005195],
              [78.724348, 21.007663],
              [78.716255, 21.00916],
              [78.713237, 21.014717],
              [78.707836, 21.016687],
              [78.701375, 21.017558],
              [78.695164, 21.020145],
              [78.693919, 21.024912],
              [78.68858, 21.029442],
              [78.685838, 21.030163],
              [78.670699, 21.034172],
              [78.65737, 21.034466],
              [78.652061, 21.035901],
              [78.651099, 21.051469],
              [78.648042, 21.053712],
              [78.643217, 21.059511],
              [78.63936, 21.058478],
              [78.634405, 21.058246],
              [78.631716, 21.059567],
              [78.628057, 21.065024],
              [78.625184, 21.066974],
              [78.621085, 21.06738],
              [78.615466, 21.064281],
              [78.61443, 21.069106],
              [78.606918, 21.069223],
              [78.610416, 21.081911],
              [78.610668, 21.088524],
              [78.602113, 21.089038],
              [78.598634, 21.090128],
              [78.59908, 21.095641],
              [78.596573, 21.098171],
              [78.597187, 21.100983],
              [78.596472, 21.10857],
              [78.592811, 21.112131],
              [78.589705, 21.114655],
              [78.585369, 21.114998],
              [78.558667, 21.114765],
              [78.554949, 21.117864],
              [78.538422, 21.139858],
              [78.525729, 21.152892],
              [78.521647, 21.161789],
              [78.521531, 21.170004],
              [78.518482, 21.175051],
              [78.509263, 21.18522],
              [78.507004, 21.189805],
              [78.49863, 21.195778],
              [78.49515, 21.198992],
              [78.492766, 21.203014],
              [78.482501, 21.211793],
              [78.479813, 21.215412],
              [78.47817, 21.219543],
              [78.47266, 21.216782],
              [78.46966, 21.218442],
              [78.464837, 21.222975],
              [78.45566, 21.226192],
              [78.446552, 21.234106],
              [78.442512, 21.23468],
              [78.429116, 21.228344],
              [78.424103, 21.227534],
              [78.419394, 21.227763],
              [78.415606, 21.229136],
              [78.410531, 21.235963],
              [78.407042, 21.237518],
              [78.401166, 21.237681],
              [78.371805, 21.243271],
              [78.360485, 21.248198],
              [78.35657, 21.248426],
              [78.352841, 21.250886],
              [78.332957, 21.250575],
              [78.330142, 21.252522],
              [78.327261, 21.256189],
              [78.326595, 21.26073],
              [78.327572, 21.265209],
              [78.327263, 21.269574],
              [78.326227, 21.271177],
              [78.322789, 21.271516],
              [78.314413, 21.268696],
              [78.30976, 21.270011],
              [78.307495, 21.273793],
              [78.307378, 21.277527],
              [78.312816, 21.288613],
              [78.313423, 21.291831],
              [78.311282, 21.293951],
              [78.3081, 21.294242],
              [78.303752, 21.293087],
              [78.297999, 21.293017],
              [78.294998, 21.294619],
              [78.290156, 21.302591],
              [78.28447, 21.303959],
              [78.277484, 21.310213],
              [78.273074, 21.315139],
              [78.271356, 21.319614],
              [78.263888, 21.32661],
              [78.260271, 21.329366],
              [78.257887, 21.328211],
              [78.255994, 21.325041],
              [78.251274, 21.328596],
              [78.252256, 21.33698],
              [78.270614, 21.343448],
              [78.275997, 21.350807],
              [78.286586, 21.349909],
              [78.310768, 21.356958],
              [78.313278, 21.360637],
              [78.317568, 21.363973],
              [78.321791, 21.366275],
              [78.326325, 21.366452],
              [78.330239, 21.368527],
              [78.333055, 21.371117],
              [78.338756, 21.372563],
              [78.344077, 21.376641],
              [78.348489, 21.384859],
              [78.350753, 21.380791],
              [78.354797, 21.379986],
              [78.358351, 21.380393],
              [78.366983, 21.383568],
              [78.367226, 21.391149],
              [78.373778, 21.394537],
              [78.376416, 21.39403],
              [78.379354, 21.39122],
              [78.381741, 21.387319],
              [78.384067, 21.386345],
              [78.389086, 21.389733],
              [78.392333, 21.389627],
              [78.397418, 21.385156],
              [78.401945, 21.383552],
              [78.405927, 21.38315],
              [78.409422, 21.383675],
              [78.41095, 21.387117],
              [78.41812, 21.388044],
              [78.422403, 21.390981],
              [78.421362, 21.395281],
              [78.423325, 21.396894],
              [78.428896, 21.397992],
              [78.43509, 21.400928],
              [78.446237, 21.402776],
              [78.448685, 21.404555],
              [78.450458, 21.406972],
              [78.451507, 21.411157],
              [78.451079, 21.415354],
              [78.443969, 21.421952],
              [78.443922, 21.431774],
              [78.441222, 21.439635],
              [78.441402, 21.442042],
              [78.444476, 21.445437],
              [78.442574, 21.448533],
              [78.439271, 21.460532],
              [78.437926, 21.469549],
              [78.435777, 21.472646],
              [78.431739, 21.475745],
              [78.430394, 21.4797],
              [78.432842, 21.488374],
              [78.432106, 21.497738],
              [78.434935, 21.500151],
              [78.443448, 21.502168],
              [78.449518, 21.500332],
              [78.456557, 21.495747],
              [78.459068, 21.496726],
              [78.461157, 21.50287],
              [78.464104, 21.50304],
              [78.466553, 21.501956],
              [78.470172, 21.501958],
              [78.475804, 21.503288],
              [78.476978, 21.50535],
              [78.485313, 21.50455],
              [78.488309, 21.506166],
              [78.490527, 21.51047],
              [78.495672, 21.516391],
              [78.500944, 21.516393],
              [78.50285, 21.521382],
              [78.507023, 21.525059],
              [78.509285, 21.52512],
              [78.513517, 21.526849],
              [78.525041, 21.52381],
              [78.529703, 21.524267],
              [78.533317, 21.523062],
              [78.542261, 21.523009],
              [78.551452, 21.518424],
              [78.5574, 21.517851],
              [78.561498, 21.514289],
              [78.56505, 21.513083],
              [78.571554, 21.514178],
              [78.569703, 21.507803],
              [78.570312, 21.504475],
              [78.578278, 21.497006],
              [78.586228, 21.488165],
              [78.589901, 21.485413],
              [78.598298, 21.486221],
              [78.603685, 21.483351],
              [78.606082, 21.485697],
              [78.610438, 21.486909],
              [78.62115, 21.48007],
              [78.626039, 21.476111],
              [78.630399, 21.476393],
              [78.635552, 21.479895],
              [78.642541, 21.482768],
              [78.648667, 21.482821],
              [78.655776, 21.481386],
              [78.664226, 21.477479],
              [78.669313, 21.479321],
              [78.689228, 21.48057],
              [78.689585, 21.476556],
              [78.693457, 21.477469],
              [78.697129, 21.477293],
              [78.70135, 21.476032],
              [78.700925, 21.473049],
              [78.706797, 21.473325],
              [78.709068, 21.469831],
              [78.719102, 21.466597],
              [78.724977, 21.463274],
              [78.729389, 21.463037],
              [78.734938, 21.470016],
              [78.740338, 21.470069],
              [78.744078, 21.471558],
              [78.745629, 21.482353],
              [78.751723, 21.492509],
              [78.755755, 21.489402],
              [78.766294, 21.488414],
              [78.766044, 21.483364],
              [78.769632, 21.472957],
              [78.777458, 21.465824],
              [78.780784, 21.472201],
              [78.782331, 21.477767],
              [78.785456, 21.479491],
              [78.789896, 21.487814],
              [78.794976, 21.487167],
              [78.79811, 21.488542],
              [78.815397, 21.489554],
              [78.818459, 21.487426],
              [78.824585, 21.48833],
              [78.828699, 21.489814],
              [78.83329, 21.48866],
              [78.84953, 21.488689],
              [78.853094, 21.490179],
              [78.856907, 21.494421],
              [78.880541, 21.486672],
              [78.885252, 21.483723],
              [78.890775, 21.484344],
              [78.895898, 21.496978],
              [78.901185, 21.499315],
              [78.908159, 21.496771],
              [78.91335, 21.49301],
              [78.926016, 21.486412],
              [78.937275, 21.486191],
              [78.939253, 21.491174],
              [78.942366, 21.509205],
              [78.946107, 21.512466],
              [78.944155, 21.516053],
              [78.941785, 21.518142],
              [78.931688, 21.520385],
              [78.928884, 21.522528],
              [78.928853, 21.531805],
              [78.930033, 21.5374],
              [78.927232, 21.541899],
              [78.909868, 21.55352],
              [78.914548, 21.560429],
              [78.918165, 21.56181],
              [78.929435, 21.558844],
              [78.933289, 21.55898],
              [78.933853, 21.563123],
              [78.925362, 21.567637],
              [78.919787, 21.568312],
              [78.917088, 21.569575],
              [78.917623, 21.583826],
              [78.918693, 21.591001],
              [78.928129, 21.59125],
              [78.934509, 21.593286],
              [78.945839, 21.592429],
              [78.951357, 21.594704],
              [78.967787, 21.604537],
              [78.980287, 21.616212],
              [78.987021, 21.615822],
              [79.000009, 21.617425],
              [79.002933, 21.614453],
              [79.005549, 21.608486],
              [79.01135, 21.602719],
              [79.015119, 21.600206],
              [79.036545, 21.604329],
              [79.048534, 21.603441],
              [79.053524, 21.604423],
              [79.056349, 21.602674],
              [79.081714, 21.606427],
              [79.087187, 21.605908],
              [79.093743, 21.597961],
              [79.097685, 21.602197],
              [79.103781, 21.601615],
              [79.10978, 21.608128],
              [79.10514, 21.611029],
              [79.104381, 21.615065],
              [79.104836, 21.617652],
              [79.116909, 21.624318],
              [79.133425, 21.626825],
              [79.142783, 21.635611],
              [79.146793, 21.638291],
              [79.152846, 21.655297],
              [79.153557, 21.659261],
              [79.191945, 21.653206],
              [79.222397, 21.649002],
              [79.225691, 21.649624],
              [79.227366, 21.655712],
              [79.232735, 21.656455],
              [79.234201, 21.670181],
              [79.232621, 21.67318],
              [79.230354, 21.674657],
              [79.225958, 21.675781],
              [79.223966, 21.680025],
              [79.226718, 21.695339],
              [79.227679, 21.699343],
              [79.240581, 21.713942],
              [79.234746, 21.719219],
              [79.233891, 21.720632],
              [79.234497, 21.722657],
              [79.2635, 21.716283],
              [79.270715, 21.713688],
              [79.277615, 21.707821],
              [79.280631, 21.704009],
              [79.282652, 21.699018],
              [79.290674, 21.692719],
              [79.323227, 21.684666],
              [79.326135, 21.685445],
              [79.328039, 21.687228],
              [79.348536, 21.683383],
              [79.35425, 21.683281],
              [79.354932, 21.677777],
              [79.367734, 21.678407],
              [79.389031, 21.674305],
              [79.400719, 21.673512],
              [79.40307, 21.674563],
              [79.40643, 21.678571],
              [79.413701, 21.684486],
              [79.417377, 21.689889],
              [79.42177, 21.690368],
              [79.428978, 21.689498],
              [79.433947, 21.684197],
              [79.438246, 21.68243],
              [79.44675, 21.681194],
              [79.457043, 21.68329],
              [79.46454, 21.686281],
              [79.494625, 21.673122],
              [79.495718, 21.664819],
              [79.496949, 21.662731],
              [79.500614, 21.65957],
              [79.503436, 21.650983],
              [79.505356, 21.646899],
              [79.507208, 21.644776],
              [79.506341, 21.63958],
              [79.508696, 21.633672],
              [79.515661, 21.632443],
              [79.517702, 21.630213],
              [79.518538, 21.625577],
              [79.51456, 21.621949],
              [79.510801, 21.622356],
              [79.509303, 21.621449],
              [79.507187, 21.618743],
              [79.504254, 21.61147],
              [79.509139, 21.606617],
              [79.512879, 21.601505],
              [79.511888, 21.589401],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 393,
        censuscode: 505,
        dt_cen_cd: 9,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Nagpur",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [76.646947, 19.865606],
              [76.647967, 19.865693],
              [76.648041, 19.865699],
              [76.649497, 19.862321],
              [76.649661, 19.861942],
              [76.654491, 19.855871],
              [76.663337, 19.849777],
              [76.678608, 19.846131],
              [76.67863, 19.846141],
              [76.678627, 19.846054],
              [76.676586, 19.838287],
              [76.680517, 19.840397],
              [76.696185, 19.839274],
              [76.706082, 19.835817],
              [76.70182, 19.819637],
              [76.698824, 19.819019],
              [76.702348, 19.806137],
              [76.697677, 19.79868],
              [76.693416, 19.794265],
              [76.687528, 19.781082],
              [76.689574, 19.7769],
              [76.693127, 19.774589],
              [76.7028, 19.764325],
              [76.705428, 19.767968],
              [76.708576, 19.770244],
              [76.714295, 19.770646],
              [76.716473, 19.768138],
              [76.718675, 19.763333],
              [76.723969, 19.749131],
              [76.725621, 19.744697],
              [76.727348, 19.741009],
              [76.729758, 19.737527],
              [76.734046, 19.733305],
              [76.739063, 19.730566],
              [76.733778, 19.71648],
              [76.73535, 19.711736],
              [76.738375, 19.711067],
              [76.742731, 19.71153],
              [76.745876, 19.709944],
              [76.749076, 19.706062],
              [76.7521, 19.693446],
              [76.755223, 19.688735],
              [76.759986, 19.684427],
              [76.764356, 19.684247],
              [76.7698, 19.687857],
              [76.772693, 19.692607],
              [76.773457, 19.697127],
              [76.771937, 19.703803],
              [76.770016, 19.706978],
              [76.76798, 19.71493],
              [76.771848, 19.719517],
              [76.77555, 19.72695],
              [76.781194, 19.730381],
              [76.785413, 19.728542],
              [76.79003, 19.722208],
              [76.790601, 19.718636],
              [76.787189, 19.71121],
              [76.784531, 19.700675],
              [76.787557, 19.687874],
              [76.786469, 19.676639],
              [76.788356, 19.670798],
              [76.794419, 19.668815],
              [76.799887, 19.671414],
              [76.809347, 19.681542],
              [76.81299, 19.679323],
              [76.816388, 19.671806],
              [76.817804, 19.668674],
              [76.819492, 19.667056],
              [76.824452, 19.670991],
              [76.826157, 19.672344],
              [76.827211, 19.681097],
              [76.814742, 19.695352],
              [76.815957, 19.701351],
              [76.818702, 19.704259],
              [76.830597, 19.70194],
              [76.834904, 19.700377],
              [76.8411, 19.700968],
              [76.843775, 19.702771],
              [76.85092, 19.704301],
              [76.853518, 19.70114],
              [76.857507, 19.688358],
              [76.864632, 19.674171],
              [76.86415, 19.669934],
              [76.860163, 19.666838],
              [76.855124, 19.66184],
              [76.853216, 19.652242],
              [76.854003, 19.647664],
              [76.857168, 19.645066],
              [76.862231, 19.644254],
              [76.866874, 19.644811],
              [76.875667, 19.642147],
              [76.874822, 19.636799],
              [76.869539, 19.626304],
              [76.868391, 19.621501],
              [76.871181, 19.618344],
              [76.876501, 19.618915],
              [76.881008, 19.621123],
              [76.885533, 19.625141],
              [76.889665, 19.629855],
              [76.894627, 19.635514],
              [76.898493, 19.640787],
              [76.90337, 19.64383],
              [76.908241, 19.64292],
              [76.913158, 19.63999],
              [76.91577, 19.636092],
              [76.915801, 19.630579],
              [76.912531, 19.625181],
              [76.913408, 19.620789],
              [76.919828, 19.615776],
              [76.926124, 19.61609],
              [76.938366, 19.623602],
              [76.942764, 19.62213],
              [76.944611, 19.613439],
              [76.944981, 19.597273],
              [76.955848, 19.592718],
              [76.961586, 19.583462],
              [76.961746, 19.580709],
              [76.953759, 19.578065],
              [76.951424, 19.574157],
              [76.95372, 19.571264],
              [76.9573, 19.568388],
              [76.9632, 19.563648],
              [76.966248, 19.55859],
              [76.967313, 19.55574],
              [76.969241, 19.54521],
              [76.968509, 19.540128],
              [76.967549, 19.53577],
              [76.965358, 19.528932],
              [76.964804, 19.527202],
              [76.967901, 19.523131],
              [76.959394, 19.513677],
              [76.959543, 19.511383],
              [76.975535, 19.507189],
              [76.977416, 19.505224],
              [76.977713, 19.500636],
              [76.97953, 19.493139],
              [76.97957, 19.487076],
              [76.987915, 19.490828],
              [76.986429, 19.475087],
              [76.980965, 19.476814],
              [76.972675, 19.474991],
              [76.968202, 19.475727],
              [76.964676, 19.477401],
              [76.96354, 19.480501],
              [76.961656, 19.482392],
              [76.959404, 19.483449],
              [76.955533, 19.487504],
              [76.952986, 19.488738],
              [76.948953, 19.47864],
              [76.936923, 19.466724],
              [76.934866, 19.463466],
              [76.933842, 19.457473],
              [76.930118, 19.450873],
              [76.925398, 19.449765],
              [76.921218, 19.446187],
              [76.922509, 19.44061],
              [76.926664, 19.432611],
              [76.924236, 19.42803],
              [76.922839, 19.426284],
              [76.921118, 19.421104],
              [76.92227, 19.417361],
              [76.919945, 19.413179],
              [76.914689, 19.406921],
              [76.910993, 19.402519],
              [76.906618, 19.394895],
              [76.903971, 19.38795],
              [76.9008, 19.384013],
              [76.898602, 19.381896],
              [76.897166, 19.380826],
              [76.895772, 19.378316],
              [76.895115, 19.37294],
              [76.894715, 19.369659],
              [76.895174, 19.366545],
              [76.891737, 19.356184],
              [76.89172, 19.348559],
              [76.893536, 19.345382],
              [76.89944, 19.339179],
              [76.90048, 19.338086],
              [76.901685, 19.332048],
              [76.901621, 19.327317],
              [76.901578, 19.324146],
              [76.90041, 19.320264],
              [76.897339, 19.316029],
              [76.892971, 19.311381],
              [76.893814, 19.30846],
              [76.896865, 19.306227],
              [76.902238, 19.299817],
              [76.902775, 19.297532],
              [76.91974, 19.297413],
              [76.932206, 19.296674],
              [76.929242, 19.290918],
              [76.932354, 19.290247],
              [76.92923, 19.283018],
              [76.928853, 19.279134],
              [76.928604, 19.276575],
              [76.926795, 19.271118],
              [76.92291, 19.263414],
              [76.921439, 19.255851],
              [76.926177, 19.247499],
              [76.929472, 19.2472],
              [76.932385, 19.250934],
              [76.93291, 19.253333],
              [76.936176, 19.254319],
              [76.939662, 19.254116],
              [76.945914, 19.251397],
              [76.950232, 19.248639],
              [76.956722, 19.248221],
              [76.955432, 19.253889],
              [76.96946, 19.253717],
              [76.971708, 19.252661],
              [76.969817, 19.26787],
              [76.970197, 19.276695],
              [76.976217, 19.275716],
              [76.987428, 19.276128],
              [76.989168, 19.28048],
              [76.992464, 19.284497],
              [76.994015, 19.284344],
              [76.997461, 19.281659],
              [77.021822, 19.282425],
              [77.021884, 19.276268],
              [77.021903, 19.274436],
              [77.011483, 19.273216],
              [77.010561, 19.271176],
              [77.011614, 19.258706],
              [77.01332, 19.251576],
              [77.019049, 19.250589],
              [77.0226, 19.247445],
              [77.026218, 19.245681],
              [77.036801, 19.24378],
              [77.041553, 19.244381],
              [77.049289, 19.247611],
              [77.049345, 19.236315],
              [77.049806, 19.232926],
              [77.051411, 19.230294],
              [77.048647, 19.224085],
              [77.046763, 19.221844],
              [77.041234, 19.218243],
              [77.03853, 19.209372],
              [77.038357, 19.205891],
              [77.038129, 19.201282],
              [77.055842, 19.19594],
              [77.062997, 19.19149],
              [77.070602, 19.192926],
              [77.075892, 19.189724],
              [77.07769, 19.187096],
              [77.079237, 19.182627],
              [77.085331, 19.182471],
              [77.084903, 19.175483],
              [77.088854, 19.17602],
              [77.088358, 19.172153],
              [77.100139, 19.172659],
              [77.094882, 19.156576],
              [77.098475, 19.15582],
              [77.113823, 19.156671],
              [77.114107, 19.152452],
              [77.12064, 19.149732],
              [77.11172, 19.14662],
              [77.09755, 19.144965],
              [77.093495, 19.135886],
              [77.099891, 19.130593],
              [77.104132, 19.122135],
              [77.105207, 19.117106],
              [77.104997, 19.113428],
              [77.101615, 19.107698],
              [77.101782, 19.107692],
              [77.104071, 19.103781],
              [77.104087, 19.103722],
              [77.102107, 19.107104],
              [77.101266, 19.107131],
              [77.084933, 19.107628],
              [77.083539, 19.100326],
              [77.078825, 19.092682],
              [77.076848, 19.084146],
              [77.071224, 19.079917],
              [77.067899, 19.076059],
              [77.062721, 19.067389],
              [77.062255, 19.058794],
              [77.066533, 19.047811],
              [77.067302, 19.041922],
              [77.065612, 19.029004],
              [77.044661, 19.030068],
              [77.042336, 19.016422],
              [77.043132, 19.011094],
              [77.04288, 19.003621],
              [77.042865, 19.003167],
              [77.051244, 18.999866],
              [77.055081, 18.995755],
              [77.055426, 18.995386],
              [77.054786, 18.988163],
              [77.039121, 18.971537],
              [77.035018, 18.964473],
              [77.032193, 18.95217],
              [77.029386, 18.952325],
              [77.026252, 18.939498],
              [77.022968, 18.939361],
              [77.02062, 18.934193],
              [77.010211, 18.931925],
              [77.004346, 18.929495],
              [77.000042, 18.931581],
              [76.993468, 18.936254],
              [76.988285, 18.922274],
              [76.986729, 18.915416],
              [76.984532, 18.914017],
              [76.977225, 18.91503],
              [76.977131, 18.915585],
              [76.975888, 18.9229],
              [76.975576, 18.923409],
              [76.973123, 18.927409],
              [76.964621, 18.931986],
              [76.961899, 18.932252],
              [76.956021, 18.92712],
              [76.952371, 18.922064],
              [76.950913, 18.913831],
              [76.951036, 18.906716],
              [76.939929, 18.903425],
              [76.934015, 18.900294],
              [76.935363, 18.896883],
              [76.935584, 18.896324],
              [76.95314, 18.891616],
              [76.957657, 18.889824],
              [76.958068, 18.889661],
              [76.956282, 18.880682],
              [76.95706, 18.875004],
              [76.957146, 18.874375],
              [76.978792, 18.878151],
              [76.994484, 18.879317],
              [77.000047, 18.880506],
              [77.003216, 18.878519],
              [77.012637, 18.877919],
              [77.012821, 18.877908],
              [77.016712, 18.862003],
              [77.01904, 18.842979],
              [77.009824, 18.839977],
              [77.000046, 18.832364],
              [76.997936, 18.830797],
              [76.995371, 18.827376],
              [76.963549, 18.830327],
              [76.955428, 18.832614],
              [76.941422, 18.832676],
              [76.907134, 18.835936],
              [76.885147, 18.834781],
              [76.884419, 18.830321],
              [76.881619, 18.828644],
              [76.872605, 18.828295],
              [76.86608, 18.81984],
              [76.859972, 18.819683],
              [76.856489, 18.813429],
              [76.854152, 18.806699],
              [76.844677, 18.81209],
              [76.839137, 18.813704],
              [76.832021, 18.811445],
              [76.825919, 18.808368],
              [76.818754, 18.802605],
              [76.816467, 18.79943],
              [76.801154, 18.799389],
              [76.790994, 18.796589],
              [76.784104, 18.793463],
              [76.783533, 18.780118],
              [76.781782, 18.776584],
              [76.774177, 18.774498],
              [76.767145, 18.774349],
              [76.76198, 18.773038],
              [76.753129, 18.772291],
              [76.745526, 18.774153],
              [76.739488, 18.759962],
              [76.736018, 18.754557],
              [76.730677, 18.749922],
              [76.727116, 18.749263],
              [76.721023, 18.749514],
              [76.709559, 18.75252],
              [76.702118, 18.756616],
              [76.697519, 18.753695],
              [76.689464, 18.753389],
              [76.681884, 18.756854],
              [76.675954, 18.761278],
              [76.675939, 18.761632],
              [76.675688, 18.767704],
              [76.682771, 18.779714],
              [76.682399, 18.780223],
              [76.677317, 18.787169],
              [76.677286, 18.787353],
              [76.675921, 18.795384],
              [76.670867, 18.806277],
              [76.6736, 18.81037],
              [76.673184, 18.810825],
              [76.669363, 18.815003],
              [76.669117, 18.815502],
              [76.667371, 18.819036],
              [76.667333, 18.81904],
              [76.654957, 18.820268],
              [76.648141, 18.821895],
              [76.648014, 18.822434],
              [76.643455, 18.841841],
              [76.643585, 18.846592],
              [76.643241, 18.846559],
              [76.636782, 18.845924],
              [76.632398, 18.848447],
              [76.628038, 18.853707],
              [76.627775, 18.854216],
              [76.624324, 18.860912],
              [76.622974, 18.869064],
              [76.622747, 18.869047],
              [76.608823, 18.868026],
              [76.592832, 18.870041],
              [76.588148, 18.874159],
              [76.58795, 18.874632],
              [76.584602, 18.882627],
              [76.586721, 18.887296],
              [76.588702, 18.917599],
              [76.583963, 18.944816],
              [76.583721, 18.944913],
              [76.578664, 18.946939],
              [76.566979, 18.94775],
              [76.553142, 18.950135],
              [76.539645, 18.949425],
              [76.535267, 18.932508],
              [76.533958, 18.923413],
              [76.536865, 18.917247],
              [76.529663, 18.91675],
              [76.522839, 18.917223],
              [76.514506, 18.921554],
              [76.510508, 18.927276],
              [76.510435, 18.927498],
              [76.505508, 18.942512],
              [76.501124, 18.95104],
              [76.501095, 18.951046],
              [76.487681, 18.95371],
              [76.478848, 18.956439],
              [76.478879, 18.956915],
              [76.480018, 18.97448],
              [76.479668, 18.974726],
              [76.479024, 18.975177],
              [76.475409, 18.974299],
              [76.471963, 18.976393],
              [76.471896, 18.976821],
              [76.471121, 18.981791],
              [76.473621, 18.983712],
              [76.473398, 18.986983],
              [76.477417, 18.988878],
              [76.479043, 18.990639],
              [76.478958, 19.000678],
              [76.478634, 19.000808],
              [76.474194, 19.002585],
              [76.463806, 19.005025],
              [76.460284, 19.006815],
              [76.460168, 19.007293],
              [76.459725, 19.009127],
              [76.459557, 19.009053],
              [76.45632, 19.00764],
              [76.456307, 19.008364],
              [76.456095, 19.019805],
              [76.45577, 19.02022],
              [76.453861, 19.02266],
              [76.449645, 19.023266],
              [76.449385, 19.023843],
              [76.448027, 19.026852],
              [76.449378, 19.033416],
              [76.448991, 19.033713],
              [76.447065, 19.035186],
              [76.444229, 19.035529],
              [76.442175, 19.038209],
              [76.442107, 19.038456],
              [76.441446, 19.040855],
              [76.441219, 19.044477],
              [76.44774, 19.050306],
              [76.451807, 19.051028],
              [76.451287, 19.051581],
              [76.437636, 19.066107],
              [76.43751, 19.066478],
              [76.435817, 19.071477],
              [76.435943, 19.074745],
              [76.438681, 19.084211],
              [76.439126, 19.088159],
              [76.438495, 19.092637],
              [76.437229, 19.095649],
              [76.437117, 19.095721],
              [76.432641, 19.09861],
              [76.429458, 19.099133],
              [76.424625, 19.096589],
              [76.419627, 19.091468],
              [76.411796, 19.092486],
              [76.400191, 19.106245],
              [76.39698, 19.108603],
              [76.394144, 19.111932],
              [76.394025, 19.112273],
              [76.392893, 19.115516],
              [76.390576, 19.123239],
              [76.390383, 19.123372],
              [76.387001, 19.125721],
              [76.383811, 19.129165],
              [76.3783, 19.131051],
              [76.372557, 19.128013],
              [76.368416, 19.12374],
              [76.362236, 19.114167],
              [76.360334, 19.109731],
              [76.355231, 19.1026],
              [76.350005, 19.100701],
              [76.343036, 19.099572],
              [76.337311, 19.100316],
              [76.327786, 19.10406],
              [76.324701, 19.107037],
              [76.324413, 19.107584],
              [76.320978, 19.114109],
              [76.323308, 19.118885],
              [76.329849, 19.122195],
              [76.334106, 19.13559],
              [76.336451, 19.138004],
              [76.353095, 19.145025],
              [76.359407, 19.149603],
              [76.360916, 19.15215],
              [76.361302, 19.156097],
              [76.360956, 19.15651],
              [76.356759, 19.161522],
              [76.356638, 19.16186],
              [76.354818, 19.166953],
              [76.358105, 19.176864],
              [76.357237, 19.181867],
              [76.356921, 19.182379],
              [76.353082, 19.188601],
              [76.353076, 19.188664],
              [76.352688, 19.192683],
              [76.359157, 19.201449],
              [76.364611, 19.21114],
              [76.366271, 19.223894],
              [76.365149, 19.233952],
              [76.363519, 19.237079],
              [76.363473, 19.237122],
              [76.357059, 19.243174],
              [76.346852, 19.249339],
              [76.339544, 19.250052],
              [76.332351, 19.249677],
              [76.312442, 19.260898],
              [76.307486, 19.261103],
              [76.300384, 19.259525],
              [76.2974, 19.261185],
              [76.29143, 19.262278],
              [76.280282, 19.260883],
              [76.269115, 19.255885],
              [76.264183, 19.251099],
              [76.258813, 19.242492],
              [76.255922, 19.239962],
              [76.25137, 19.239592],
              [76.242664, 19.242224],
              [76.226509, 19.241439],
              [76.22515, 19.242893],
              [76.22514, 19.243138],
              [76.225064, 19.244847],
              [76.228686, 19.25086],
              [76.22847, 19.255163],
              [76.228165, 19.255269],
              [76.215264, 19.259769],
              [76.215193, 19.260265],
              [76.214836, 19.262757],
              [76.209814, 19.27461],
              [76.209269, 19.277538],
              [76.217643, 19.288048],
              [76.220608, 19.28822],
              [76.221685, 19.293766],
              [76.221282, 19.293974],
              [76.216842, 19.296261],
              [76.210223, 19.298228],
              [76.2102, 19.298724],
              [76.210094, 19.300981],
              [76.213346, 19.318232],
              [76.235079, 19.313351],
              [76.241914, 19.337882],
              [76.25764, 19.334485],
              [76.265055, 19.333659],
              [76.26859, 19.334963],
              [76.273802, 19.338536],
              [76.279673, 19.344159],
              [76.280731, 19.348841],
              [76.280265, 19.348824],
              [76.274678, 19.348609],
              [76.267729, 19.352128],
              [76.262019, 19.356769],
              [76.262158, 19.356974],
              [76.261689, 19.357355],
              [76.267555, 19.36601],
              [76.285288, 19.366308],
              [76.292353, 19.395983],
              [76.286414, 19.396206],
              [76.286492, 19.396777],
              [76.286084, 19.396792],
              [76.290912, 19.432076],
              [76.303565, 19.431955],
              [76.310217, 19.455275],
              [76.315236, 19.463952],
              [76.327654, 19.455914],
              [76.336022, 19.456499],
              [76.341355, 19.453927],
              [76.344952, 19.469912],
              [76.36551, 19.468367],
              [76.371507, 19.48929],
              [76.374075, 19.496005],
              [76.377236, 19.499675],
              [76.377475, 19.503343],
              [76.372473, 19.504456],
              [76.37248, 19.504968],
              [76.372635, 19.515347],
              [76.378645, 19.536103],
              [76.395849, 19.530778],
              [76.396114, 19.540635],
              [76.41265, 19.537664],
              [76.41295, 19.53761],
              [76.41322, 19.532768],
              [76.413258, 19.532095],
              [76.442573, 19.540744],
              [76.446475, 19.553677],
              [76.445837, 19.563444],
              [76.448555, 19.582706],
              [76.448158, 19.582808],
              [76.43723, 19.585628],
              [76.437267, 19.58612],
              [76.438314, 19.599884],
              [76.43795, 19.600023],
              [76.433868, 19.601584],
              [76.434165, 19.601931],
              [76.442565, 19.611729],
              [76.452086, 19.612112],
              [76.453412, 19.626017],
              [76.453063, 19.640706],
              [76.452747, 19.640718],
              [76.444226, 19.641046],
              [76.444405, 19.641614],
              [76.450074, 19.659626],
              [76.453616, 19.666608],
              [76.460238, 19.664696],
              [76.466236, 19.667272],
              [76.471449, 19.678519],
              [76.487902, 19.676923],
              [76.487547, 19.697231],
              [76.485243, 19.719867],
              [76.48497, 19.719897],
              [76.458696, 19.72287],
              [76.458726, 19.723416],
              [76.459995, 19.746525],
              [76.485744, 19.743197],
              [76.485138, 19.748709],
              [76.488551, 19.75495],
              [76.493878, 19.760234],
              [76.49937, 19.761834],
              [76.510842, 19.762294],
              [76.512834, 19.770046],
              [76.512379, 19.770145],
              [76.502384, 19.772328],
              [76.489899, 19.778257],
              [76.48473, 19.785817],
              [76.484714, 19.785946],
              [76.483846, 19.792828],
              [76.486176, 19.799655],
              [76.499873, 19.799095],
              [76.511724, 19.800288],
              [76.51491, 19.807165],
              [76.51446, 19.811295],
              [76.512729, 19.815352],
              [76.512599, 19.815472],
              [76.510052, 19.817808],
              [76.510176, 19.817979],
              [76.515733, 19.82566],
              [76.515145, 19.825891],
              [76.511407, 19.827358],
              [76.511542, 19.827763],
              [76.512186, 19.829695],
              [76.518241, 19.831804],
              [76.517774, 19.835374],
              [76.521607, 19.836206],
              [76.521181, 19.836772],
              [76.518894, 19.839819],
              [76.518981, 19.839851],
              [76.52232, 19.841069],
              [76.520603, 19.848325],
              [76.530906, 19.847885],
              [76.533018, 19.850419],
              [76.540423, 19.844768],
              [76.54368, 19.844014],
              [76.549686, 19.844004],
              [76.569045, 19.838384],
              [76.569059, 19.844463],
              [76.591401, 19.84286],
              [76.599915, 19.840731],
              [76.601299, 19.842999],
              [76.610537, 19.838101],
              [76.623372, 19.842536],
              [76.629482, 19.855137],
              [76.633428, 19.866231],
              [76.643392, 19.866709],
              [76.645775, 19.865968],
              [76.646947, 19.865606],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 432,
        censuscode: 513,
        dt_cen_cd: 17,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Parbhani",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [74.673327, 19.946696],
              [74.673927, 19.935095],
              [74.682017, 19.932225],
              [74.681951, 19.924934],
              [74.655994, 19.922163],
              [74.6531, 19.91939],
              [74.649161, 19.909826],
              [74.649993, 19.886344],
              [74.647107, 19.873237],
              [74.648099, 19.861239],
              [74.663329, 19.861116],
              [74.660867, 19.839049],
              [74.64472, 19.840892],
              [74.635122, 19.843694],
              [74.6328, 19.845059],
              [74.606685, 19.849635],
              [74.604273, 19.821595],
              [74.601452, 19.801644],
              [74.59197, 19.786993],
              [74.591657, 19.779698],
              [74.593383, 19.77649],
              [74.597832, 19.773021],
              [74.601973, 19.771618],
              [74.608643, 19.771039],
              [74.615485, 19.772289],
              [74.619766, 19.776458],
              [74.620823, 19.780714],
              [74.623999, 19.78585],
              [74.627665, 19.789493],
              [74.63407, 19.793961],
              [74.63613, 19.79432],
              [74.645862, 19.789565],
              [74.650138, 19.785342],
              [74.653752, 19.780083],
              [74.656487, 19.778441],
              [74.667468, 19.778173],
              [74.673765, 19.770755],
              [74.684264, 19.76899],
              [74.69191, 19.768518],
              [74.693353, 19.761009],
              [74.695364, 19.759414],
              [74.70512, 19.760343],
              [74.70747, 19.76231],
              [74.707265, 19.765702],
              [74.703099, 19.772216],
              [74.70393, 19.775321],
              [74.713036, 19.782273],
              [74.720109, 19.777209],
              [74.722468, 19.76781],
              [74.721417, 19.762348],
              [74.721525, 19.755002],
              [74.723721, 19.752542],
              [74.722548, 19.746965],
              [74.719355, 19.742411],
              [74.716442, 19.734926],
              [74.712332, 19.732773],
              [74.71023, 19.729653],
              [74.70583, 19.725894],
              [74.706644, 19.721822],
              [74.710776, 19.720533],
              [74.718071, 19.72575],
              [74.720867, 19.724902],
              [74.722831, 19.720784],
              [74.725381, 19.720688],
              [74.729903, 19.723467],
              [74.732392, 19.71436],
              [74.729945, 19.699181],
              [74.746265, 19.695616],
              [74.748289, 19.692182],
              [74.751269, 19.690763],
              [74.762381, 19.696348],
              [74.767272, 19.699998],
              [74.775226, 19.707056],
              [74.781187, 19.713756],
              [74.781242, 19.715075],
              [74.787474, 19.716611],
              [74.806649, 19.703003],
              [74.803708, 19.697184],
              [74.801303, 19.694245],
              [74.790064, 19.689753],
              [74.788129, 19.687617],
              [74.782171, 19.671725],
              [74.782397, 19.66501],
              [74.780531, 19.652307],
              [74.788847, 19.649547],
              [74.799959, 19.65507],
              [74.803942, 19.659404],
              [74.811183, 19.663066],
              [74.817263, 19.669707],
              [74.824824, 19.672335],
              [74.830618, 19.666634],
              [74.831579, 19.667895],
              [74.83699, 19.665516],
              [74.842598, 19.660038],
              [74.843093, 19.656603],
              [74.846207, 19.652659],
              [74.848584, 19.650371],
              [74.852957, 19.647933],
              [74.864228, 19.648529],
              [74.864858, 19.64856],
              [74.875053, 19.654228],
              [74.878084, 19.652754],
              [74.888614, 19.656295],
              [74.890373, 19.655735],
              [74.889793, 19.649847],
              [74.89145, 19.645916],
              [74.898616, 19.643894],
              [74.902436, 19.643671],
              [74.906005, 19.644485],
              [74.90914, 19.646493],
              [74.916997, 19.649582],
              [74.927422, 19.649444],
              [74.932156, 19.648086],
              [74.934783, 19.643761],
              [74.938196, 19.640372],
              [74.941882, 19.641559],
              [74.943687, 19.644514],
              [74.949067, 19.646334],
              [74.966505, 19.647113],
              [74.970085, 19.646419],
              [74.983868, 19.638008],
              [75.000034, 19.621753],
              [75.010825, 19.623126],
              [75.022692, 19.62121],
              [75.02826, 19.621628],
              [75.035034, 19.623933],
              [75.038056, 19.624056],
              [75.041821, 19.622235],
              [75.043572, 19.62046],
              [75.042919, 19.616621],
              [75.043412, 19.612946],
              [75.044695, 19.610486],
              [75.057894, 19.605879],
              [75.061773, 19.603365],
              [75.067337, 19.603265],
              [75.069884, 19.605105],
              [75.074116, 19.606204],
              [75.092322, 19.60946],
              [75.095831, 19.608613],
              [75.099231, 19.604658],
              [75.105653, 19.600947],
              [75.113941, 19.603032],
              [75.117277, 19.602524],
              [75.130126, 19.592009],
              [75.133269, 19.59207],
              [75.142886, 19.595469],
              [75.146398, 19.594904],
              [75.152703, 19.588957],
              [75.155371, 19.587472],
              [75.158326, 19.588509],
              [75.162497, 19.593447],
              [75.166555, 19.594775],
              [75.172057, 19.596102],
              [75.179677, 19.596692],
              [75.188027, 19.595853],
              [75.194451, 19.593223],
              [75.203913, 19.577991],
              [75.206514, 19.578342],
              [75.20852, 19.571747],
              [75.205146, 19.564234],
              [75.206782, 19.561826],
              [75.212785, 19.55695],
              [75.220278, 19.552694],
              [75.226402, 19.545753],
              [75.228952, 19.54197],
              [75.231553, 19.539852],
              [75.240207, 19.53677],
              [75.247293, 19.532882],
              [75.251228, 19.530246],
              [75.257591, 19.523326],
              [75.261701, 19.522471],
              [75.263692, 19.523729],
              [75.265991, 19.529297],
              [75.268933, 19.548109],
              [75.270925, 19.550923],
              [75.274558, 19.551445],
              [75.278793, 19.550534],
              [75.281338, 19.548984],
              [75.283151, 19.546298],
              [75.284493, 19.540214],
              [75.284618, 19.535457],
              [75.276832, 19.512859],
              [75.296857, 19.508641],
              [75.305807, 19.507739],
              [75.305875, 19.500569],
              [75.312896, 19.498861],
              [75.314476, 19.49404],
              [75.321967, 19.493366],
              [75.326806, 19.494118],
              [75.328502, 19.496694],
              [75.32795, 19.503457],
              [75.332911, 19.502954],
              [75.330509, 19.479212],
              [75.338067, 19.478531],
              [75.342651, 19.496658],
              [75.349004, 19.497237],
              [75.355955, 19.50062],
              [75.361102, 19.492656],
              [75.363044, 19.485204],
              [75.361529, 19.479589],
              [75.349804, 19.481006],
              [75.345512, 19.473319],
              [75.341409, 19.463453],
              [75.326346, 19.463152],
              [75.324722, 19.453974],
              [75.328177, 19.441479],
              [75.332046, 19.436952],
              [75.334533, 19.437469],
              [75.345347, 19.446082],
              [75.349332, 19.447806],
              [75.35278, 19.44535],
              [75.356052, 19.441165],
              [75.356955, 19.437609],
              [75.356782, 19.429988],
              [75.354431, 19.423272],
              [75.350258, 19.415415],
              [75.344154, 19.408926],
              [75.343075, 19.405715],
              [75.366167, 19.39737],
              [75.377283, 19.403403],
              [75.380548, 19.406381],
              [75.381941, 19.408733],
              [75.384293, 19.410171],
              [75.391069, 19.409947],
              [75.395837, 19.414646],
              [75.404059, 19.414775],
              [75.407929, 19.4173],
              [75.411437, 19.417475],
              [75.415002, 19.41753],
              [75.422437, 19.415756],
              [75.430236, 19.415989],
              [75.439978, 19.421102],
              [75.444087, 19.427415],
              [75.447527, 19.426841],
              [75.447409, 19.41835],
              [75.448918, 19.413083],
              [75.452849, 19.411767],
              [75.456958, 19.413768],
              [75.462095, 19.41475],
              [75.468805, 19.413087],
              [75.472853, 19.41412],
              [75.474972, 19.414984],
              [75.477992, 19.421408],
              [75.479144, 19.421062],
              [75.483555, 19.419454],
              [75.486822, 19.414642],
              [75.489479, 19.416193],
              [75.490876, 19.41241],
              [75.487419, 19.386485],
              [75.487178, 19.382301],
              [75.488862, 19.378973],
              [75.492072, 19.377311],
              [75.497568, 19.376853],
              [75.506093, 19.378469],
              [75.517398, 19.383918],
              [75.524045, 19.379097],
              [75.531474, 19.377379],
              [75.535468, 19.374915],
              [75.527838, 19.350826],
              [75.519303, 19.329667],
              [75.544201, 19.325715],
              [75.541713, 19.308451],
              [75.53482, 19.302202],
              [75.528837, 19.298595],
              [75.526723, 19.296241],
              [75.520366, 19.280758],
              [75.517407, 19.27652],
              [75.497775, 19.264932],
              [75.494936, 19.260395],
              [75.492704, 19.259314],
              [75.489859, 19.260686],
              [75.485875, 19.258387],
              [75.479531, 19.256327],
              [75.475971, 19.252079],
              [75.470232, 19.252653],
              [75.464134, 19.252246],
              [75.459778, 19.247891],
              [75.456516, 19.237625],
              [75.445469, 19.216977],
              [75.42929, 19.219313],
              [75.424456, 19.21862],
              [75.417639, 19.2134],
              [75.414076, 19.206751],
              [75.407677, 19.202497],
              [75.405258, 19.198942],
              [75.405031, 19.197258],
              [75.404544, 19.193605],
              [75.405807, 19.189774],
              [75.423073, 19.178829],
              [75.428327, 19.171148],
              [75.448853, 19.170018],
              [75.4544, 19.145417],
              [75.454459, 19.142029],
              [75.451014, 19.140083],
              [75.435611, 19.139437],
              [75.428471, 19.137486],
              [75.427332, 19.136452],
              [75.427929, 19.132554],
              [75.433846, 19.116445],
              [75.436506, 19.115241],
              [75.447262, 19.122703],
              [75.448775, 19.124772],
              [75.453731, 19.125689],
              [75.485147, 19.125761],
              [75.485274, 19.121576],
              [75.484244, 19.11572],
              [75.486784, 19.111421],
              [75.487259, 19.10362],
              [75.47342, 19.093351],
              [75.456982, 19.084289],
              [75.449966, 19.083254],
              [75.44852, 19.085148],
              [75.447794, 19.091512],
              [75.420968, 19.084156],
              [75.410207, 19.07864],
              [75.407675, 19.078243],
              [75.398917, 19.079213],
              [75.393487, 19.077997],
              [75.38437, 19.077819],
              [75.38207, 19.079941],
              [75.370781, 19.08222],
              [75.368903, 19.089104],
              [75.380128, 19.101214],
              [75.389017, 19.112916],
              [75.389685, 19.116586],
              [75.396508, 19.124336],
              [75.405691, 19.123027],
              [75.407384, 19.124627],
              [75.410047, 19.130252],
              [75.41059, 19.133925],
              [75.406429, 19.139484],
              [75.399476, 19.138669],
              [75.373619, 19.127238],
              [75.368605, 19.12752],
              [75.362206, 19.129982],
              [75.359545, 19.12511],
              [75.35495, 19.125161],
              [75.352772, 19.126361],
              [75.354113, 19.143563],
              [75.352063, 19.147286],
              [75.338236, 19.153181],
              [75.332377, 19.150023],
              [75.330869, 19.144973],
              [75.33152, 19.134826],
              [75.334478, 19.129205],
              [75.339849, 19.123307],
              [75.349575, 19.121998],
              [75.351444, 19.120224],
              [75.352535, 19.113628],
              [75.361955, 19.107736],
              [75.364915, 19.099136],
              [75.364431, 19.089042],
              [75.36559, 19.081015],
              [75.364564, 19.076197],
              [75.360887, 19.07608],
              [75.335642, 19.081159],
              [75.320538, 19.093236],
              [75.315343, 19.093691],
              [75.30816, 19.093283],
              [75.29702, 19.084435],
              [75.290022, 19.082306],
              [75.283743, 19.083161],
              [75.283644, 19.078571],
              [75.291858, 19.075367],
              [75.294182, 19.068552],
              [75.294051, 19.062241],
              [75.289278, 19.049276],
              [75.287699, 19.041641],
              [75.287387, 19.032069],
              [75.308012, 19.031063],
              [75.31755, 19.028782],
              [75.330455, 19.032011],
              [75.347087, 19.022854],
              [75.346174, 19.000618],
              [75.345245, 18.997128],
              [75.341581, 18.99156],
              [75.341745, 18.989611],
              [75.339259, 18.988497],
              [75.331425, 18.987887],
              [75.321475, 18.980489],
              [75.314464, 18.978337],
              [75.297947, 18.977707],
              [75.293131, 18.978216],
              [75.289099, 18.979403],
              [75.285468, 18.984018],
              [75.281807, 18.985375],
              [75.278032, 18.987815],
              [75.273309, 18.992388],
              [75.271198, 19.000546],
              [75.270526, 19.003374],
              [75.272152, 19.013869],
              [75.271182, 19.0157],
              [75.263326, 19.021427],
              [75.261445, 19.025036],
              [75.261249, 19.026644],
              [75.263184, 19.026933],
              [75.268375, 19.031756],
              [75.270556, 19.052921],
              [75.268458, 19.055841],
              [75.265777, 19.062264],
              [75.263596, 19.069655],
              [75.260511, 19.070278],
              [75.246651, 19.066014],
              [75.245264, 19.064923],
              [75.242481, 19.066239],
              [75.241701, 19.064861],
              [75.242435, 19.063314],
              [75.240152, 19.061647],
              [75.234893, 19.061866],
              [75.226588, 19.065695],
              [75.228479, 19.077225],
              [75.22998, 19.081412],
              [75.226757, 19.094823],
              [75.225738, 19.097404],
              [75.223505, 19.098891],
              [75.223319, 19.108526],
              [75.222585, 19.110184],
              [75.218483, 19.110979],
              [75.215952, 19.108456],
              [75.20637, 19.102364],
              [75.204744, 19.099891],
              [75.199141, 19.096379],
              [75.193585, 19.095168],
              [75.190209, 19.092695],
              [75.189847, 19.089939],
              [75.190514, 19.088224],
              [75.194259, 19.083241],
              [75.194927, 19.08112],
              [75.195479, 19.077109],
              [75.194751, 19.0743],
              [75.196448, 19.070977],
              [75.197181, 19.065294],
              [75.188392, 19.052435],
              [75.189, 19.049973],
              [75.198191, 19.044661],
              [75.206324, 19.037332],
              [75.208825, 19.03378],
              [75.209914, 19.022772],
              [75.208949, 19.021395],
              [75.206766, 19.020248],
              [75.185993, 19.013153],
              [75.18135, 19.012683],
              [75.176815, 19.014974],
              [75.17343, 19.018063],
              [75.170704, 19.022817],
              [75.168634, 19.035772],
              [75.160733, 19.036612],
              [75.150783, 19.040094],
              [75.147951, 19.040084],
              [75.145899, 19.038985],
              [75.145179, 19.036066],
              [75.100761, 19.044104],
              [75.092859, 19.048102],
              [75.075733, 19.053112],
              [75.07163, 19.057516],
              [75.072161, 19.06107],
              [75.073661, 19.063998],
              [75.076186, 19.066415],
              [75.089265, 19.067761],
              [75.090111, 19.068793],
              [75.085098, 19.073146],
              [75.082312, 19.076921],
              [75.081043, 19.080356],
              [75.083092, 19.081682],
              [75.092499, 19.081875],
              [75.097086, 19.079367],
              [75.098402, 19.081946],
              [75.097916, 19.082753],
              [75.101201, 19.102309],
              [75.10223, 19.103919],
              [75.106692, 19.106507],
              [75.110363, 19.111449],
              [75.111488, 19.1204],
              [75.109982, 19.123722],
              [75.098518, 19.124724],
              [75.095139, 19.125925],
              [75.093266, 19.125462],
              [75.090921, 19.120692],
              [75.079105, 19.119691],
              [75.076221, 19.114869],
              [75.077804, 19.107303],
              [75.074065, 19.103846],
              [75.070996, 19.104649],
              [75.067976, 19.103781],
              [75.06081, 19.098942],
              [75.054303, 19.098758],
              [75.053513, 19.101101],
              [75.05435, 19.103052],
              [75.05386, 19.10598],
              [75.049762, 19.104077],
              [75.045974, 19.101196],
              [75.039454, 19.102214],
              [75.03679, 19.108055],
              [75.033054, 19.107934],
              [75.028056, 19.103619],
              [75.026363, 19.104761],
              [75.027557, 19.111124],
              [75.02689, 19.112617],
              [75.025622, 19.113183],
              [75.023996, 19.111746],
              [75.020687, 19.106405],
              [75.016955, 19.105081],
              [75.010983, 19.104257],
              [75.004876, 19.110255],
              [75.002879, 19.111458],
              [75.000023, 19.111313],
              [74.991925, 19.111226],
              [74.988528, 19.112369],
              [74.983977, 19.115812],
              [74.980632, 19.117254],
              [74.980606, 19.111111],
              [74.976061, 19.112395],
              [74.960881, 19.119487],
              [74.957919, 19.121203],
              [74.957068, 19.123379],
              [74.954526, 19.125557],
              [74.949146, 19.129106],
              [74.946852, 19.12931],
              [74.942435, 19.129798],
              [74.942457, 19.126268],
              [74.936438, 19.116044],
              [74.933491, 19.107758],
              [74.925531, 19.100273],
              [74.921762, 19.087976],
              [74.919212, 19.064883],
              [74.918723, 19.05256],
              [74.916368, 19.03991],
              [74.924896, 19.033276],
              [74.935623, 19.034753],
              [74.946229, 19.035076],
              [74.952386, 19.03287],
              [74.948967, 19.017429],
              [74.949049, 19.005568],
              [74.955428, 19.003914],
              [74.960023, 19.000125],
              [74.960672, 18.996083],
              [74.956296, 18.9865],
              [74.95746, 18.977953],
              [74.95659, 18.972994],
              [74.953083, 18.968424],
              [74.944872, 18.96931],
              [74.939319, 18.976427],
              [74.933926, 18.972429],
              [74.928641, 18.970594],
              [74.917158, 18.960101],
              [74.907115, 18.963664],
              [74.903264, 18.975631],
              [74.899679, 18.979116],
              [74.887918, 18.979002],
              [74.878296, 18.982961],
              [74.869626, 18.980658],
              [74.861174, 18.975894],
              [74.842855, 18.96829],
              [74.837741, 18.97377],
              [74.826801, 18.988092],
              [74.824422, 18.984688],
              [74.813887, 18.977201],
              [74.812419, 18.972827],
              [74.817449, 18.963733],
              [74.827524, 18.963238],
              [74.831402, 18.96189],
              [74.835471, 18.958594],
              [74.83897, 18.952587],
              [74.838732, 18.946041],
              [74.835804, 18.942802],
              [74.828491, 18.938322],
              [74.832952, 18.932213],
              [74.848579, 18.924459],
              [74.850565, 18.918728],
              [74.850872, 18.912236],
              [74.858175, 18.904409],
              [74.863799, 18.902311],
              [74.868592, 18.899003],
              [74.872526, 18.904212],
              [74.873943, 18.907726],
              [74.878849, 18.911161],
              [74.882165, 18.911466],
              [74.88646, 18.909477],
              [74.88781, 18.900784],
              [74.88639, 18.89114],
              [74.888136, 18.885359],
              [74.897778, 18.878874],
              [74.899675, 18.869152],
              [74.898855, 18.85926],
              [74.899089, 18.8474],
              [74.911724, 18.849235],
              [74.913454, 18.850982],
              [74.917539, 18.853155],
              [74.92171, 18.851874],
              [74.922646, 18.847847],
              [74.920999, 18.836623],
              [74.917198, 18.830927],
              [74.923367, 18.828364],
              [74.93088, 18.829707],
              [74.938842, 18.829518],
              [74.942521, 18.828967],
              [74.945677, 18.826012],
              [74.954934, 18.822118],
              [74.959096, 18.821901],
              [74.967139, 18.824737],
              [74.970419, 18.82143],
              [74.971692, 18.814487],
              [74.974202, 18.810243],
              [74.977114, 18.807302],
              [74.979438, 18.80349],
              [74.987144, 18.797663],
              [74.990891, 18.796479],
              [74.994845, 18.799101],
              [75.000031, 18.806203],
              [75.008548, 18.804408],
              [75.009736, 18.802738],
              [75.006685, 18.796299],
              [75.002971, 18.791116],
              [75.002536, 18.788542],
              [75.002988, 18.784879],
              [75.007576, 18.779224],
              [75.009677, 18.777945],
              [75.016306, 18.771072],
              [75.022441, 18.770499],
              [75.025989, 18.76927],
              [75.037014, 18.763321],
              [75.041987, 18.752458],
              [75.051629, 18.746185],
              [75.054778, 18.741234],
              [75.058862, 18.732202],
              [75.065714, 18.730255],
              [75.069704, 18.725462],
              [75.07374, 18.717695],
              [75.077804, 18.714046],
              [75.086304, 18.709095],
              [75.098135, 18.705725],
              [75.10226, 18.703108],
              [75.108176, 18.690227],
              [75.11093, 18.688427],
              [75.123411, 18.684526],
              [75.131056, 18.670192],
              [75.137761, 18.666527],
              [75.140794, 18.661109],
              [75.14242, 18.654561],
              [75.143668, 18.652948],
              [75.149783, 18.649859],
              [75.153623, 18.648613],
              [75.155723, 18.648996],
              [75.159043, 18.649885],
              [75.162757, 18.655458],
              [75.165454, 18.662134],
              [75.168387, 18.689304],
              [75.16585, 18.696142],
              [75.170475, 18.70263],
              [75.175625, 18.706588],
              [75.17662, 18.717916],
              [75.174037, 18.72624],
              [75.174185, 18.735865],
              [75.19668, 18.735927],
              [75.208798, 18.738441],
              [75.214385, 18.737467],
              [75.216946, 18.733552],
              [75.220591, 18.730302],
              [75.227121, 18.727782],
              [75.233136, 18.727597],
              [75.245025, 18.724558],
              [75.254258, 18.720801],
              [75.265205, 18.727675],
              [75.270937, 18.729332],
              [75.276855, 18.732248],
              [75.281361, 18.737763],
              [75.292658, 18.762382],
              [75.308377, 18.777281],
              [75.322227, 18.792018],
              [75.327278, 18.798154],
              [75.332098, 18.798391],
              [75.335687, 18.795483],
              [75.338188, 18.792536],
              [75.340581, 18.785128],
              [75.342666, 18.782412],
              [75.34681, 18.781679],
              [75.351464, 18.78335],
              [75.359697, 18.788305],
              [75.366653, 18.778951],
              [75.37095, 18.776094],
              [75.377314, 18.767375],
              [75.3822, 18.768412],
              [75.38114, 18.771746],
              [75.386564, 18.772255],
              [75.386482, 18.776265],
              [75.391117, 18.788877],
              [75.390436, 18.793118],
              [75.391643, 18.799748],
              [75.391327, 18.804789],
              [75.392061, 18.812401],
              [75.39552, 18.827595],
              [75.398437, 18.830822],
              [75.411362, 18.822725],
              [75.420432, 18.814033],
              [75.42784, 18.808392],
              [75.429494, 18.805342],
              [75.435518, 18.798976],
              [75.440853, 18.791072],
              [75.443152, 18.785487],
              [75.443263, 18.778675],
              [75.444418, 18.774189],
              [75.44537, 18.760607],
              [75.448409, 18.763957],
              [75.448184, 18.75296],
              [75.450745, 18.750124],
              [75.453382, 18.748837],
              [75.45922, 18.748773],
              [75.461576, 18.750062],
              [75.463712, 18.752958],
              [75.478463, 18.742312],
              [75.481283, 18.741415],
              [75.490373, 18.735358],
              [75.496678, 18.728012],
              [75.504085, 18.723175],
              [75.510708, 18.723208],
              [75.518736, 18.725866],
              [75.521472, 18.728128],
              [75.527747, 18.730744],
              [75.530072, 18.734493],
              [75.530358, 18.738216],
              [75.527937, 18.742593],
              [75.526541, 18.753327],
              [75.53086, 18.75178],
              [75.537725, 18.746779],
              [75.551833, 18.743178],
              [75.556864, 18.741],
              [75.558691, 18.737708],
              [75.555094, 18.732886],
              [75.552351, 18.717967],
              [75.553198, 18.71298],
              [75.558718, 18.705808],
              [75.563368, 18.701748],
              [75.569078, 18.701052],
              [75.572283, 18.702385],
              [75.582996, 18.697275],
              [75.587373, 18.697059],
              [75.588841, 18.6877],
              [75.577153, 18.685604],
              [75.556935, 18.684933],
              [75.552298, 18.684181],
              [75.548665, 18.682332],
              [75.546077, 18.675835],
              [75.544683, 18.669729],
              [75.543965, 18.664234],
              [75.544213, 18.658853],
              [75.553924, 18.655935],
              [75.554134, 18.653178],
              [75.551337, 18.64399],
              [75.548122, 18.641683],
              [75.542043, 18.641123],
              [75.537715, 18.641752],
              [75.531513, 18.640672],
              [75.525835, 18.638513],
              [75.516236, 18.628374],
              [75.509588, 18.625015],
              [75.507624, 18.621767],
              [75.496484, 18.625623],
              [75.490957, 18.626141],
              [75.488406, 18.62411],
              [75.487402, 18.619602],
              [75.481919, 18.61227],
              [75.473398, 18.607842],
              [75.467853, 18.606761],
              [75.465716, 18.603985],
              [75.465262, 18.600033],
              [75.462609, 18.593762],
              [75.456074, 18.594869],
              [75.452462, 18.58873],
              [75.444506, 18.568428],
              [75.439359, 18.55234],
              [75.430902, 18.547455],
              [75.426827, 18.542976],
              [75.422552, 18.535291],
              [75.419097, 18.533098],
              [75.414983, 18.535945],
              [75.394101, 18.546254],
              [75.380328, 18.550991],
              [75.362632, 18.555017],
              [75.345864, 18.561674],
              [75.343329, 18.553395],
              [75.335494, 18.538586],
              [75.335555, 18.524905],
              [75.317123, 18.520912],
              [75.314401, 18.51854],
              [75.308508, 18.518603],
              [75.280543, 18.515284],
              [75.268477, 18.510317],
              [75.261313, 18.508842],
              [75.255102, 18.519615],
              [75.249021, 18.526207],
              [75.244531, 18.534725],
              [75.24224, 18.540996],
              [75.239977, 18.543482],
              [75.231557, 18.542242],
              [75.227717, 18.543314],
              [75.224389, 18.54747],
              [75.222976, 18.550866],
              [75.219086, 18.553884],
              [75.215371, 18.554429],
              [75.208363, 18.543334],
              [75.204247, 18.532729],
              [75.2008, 18.529898],
              [75.197356, 18.528501],
              [75.186422, 18.528776],
              [75.182875, 18.527731],
              [75.172487, 18.522043],
              [75.159435, 18.519888],
              [75.138092, 18.526621],
              [75.134903, 18.526243],
              [75.128686, 18.508153],
              [75.127845, 18.500491],
              [75.12569, 18.493862],
              [75.120091, 18.491745],
              [75.106978, 18.490491],
              [75.105646, 18.489242],
              [75.101175, 18.469647],
              [75.098736, 18.465427],
              [75.094914, 18.461117],
              [75.092716, 18.456322],
              [75.09215, 18.445273],
              [75.092662, 18.433818],
              [75.091149, 18.431425],
              [75.088498, 18.430024],
              [75.084884, 18.429771],
              [75.08193, 18.427908],
              [75.079869, 18.42512],
              [75.078632, 18.420552],
              [75.076543, 18.422456],
              [75.072523, 18.423526],
              [75.070483, 18.423376],
              [75.065667, 18.421239],
              [75.058987, 18.419988],
              [75.053518, 18.427307],
              [75.050298, 18.429689],
              [75.035372, 18.434348],
              [75.01623, 18.436639],
              [75.013425, 18.431565],
              [75.010743, 18.417793],
              [75.006514, 18.405515],
              [75.00415, 18.402906],
              [75.000032, 18.40362],
              [74.983655, 18.399673],
              [74.972763, 18.394186],
              [74.970766, 18.38949],
              [74.968507, 18.386912],
              [74.965331, 18.385081],
              [74.958102, 18.387757],
              [74.950899, 18.386999],
              [74.946283, 18.385311],
              [74.940216, 18.385286],
              [74.924717, 18.378022],
              [74.915828, 18.37712],
              [74.911997, 18.369506],
              [74.907371, 18.356197],
              [74.891452, 18.355881],
              [74.885442, 18.356418],
              [74.871174, 18.35288],
              [74.868902, 18.351661],
              [74.866074, 18.346242],
              [74.865417, 18.339968],
              [74.863897, 18.334732],
              [74.861689, 18.333744],
              [74.851867, 18.330752],
              [74.838168, 18.336819],
              [74.833877, 18.339199],
              [74.832715, 18.342063],
              [74.824646, 18.343902],
              [74.815822, 18.342748],
              [74.810054, 18.343219],
              [74.800755, 18.347347],
              [74.79592, 18.351096],
              [74.794436, 18.355111],
              [74.796785, 18.360414],
              [74.803004, 18.370047],
              [74.808169, 18.375763],
              [74.809074, 18.382265],
              [74.808485, 18.386046],
              [74.798377, 18.393551],
              [74.783775, 18.406082],
              [74.779848, 18.408414],
              [74.773962, 18.408024],
              [74.770246, 18.406447],
              [74.766064, 18.404231],
              [74.759042, 18.397457],
              [74.755028, 18.396396],
              [74.747702, 18.395596],
              [74.734579, 18.397907],
              [74.728152, 18.40929],
              [74.723088, 18.41614],
              [74.71471, 18.430257],
              [74.717393, 18.437921],
              [74.723699, 18.450483],
              [74.725883, 18.460263],
              [74.72715, 18.471936],
              [74.726942, 18.479685],
              [74.720466, 18.489746],
              [74.71584, 18.495157],
              [74.710757, 18.498507],
              [74.704923, 18.504152],
              [74.700757, 18.505728],
              [74.691363, 18.501407],
              [74.687826, 18.500568],
              [74.680909, 18.49466],
              [74.663717, 18.488607],
              [74.659485, 18.485365],
              [74.65676, 18.481666],
              [74.65669, 18.476959],
              [74.657808, 18.473745],
              [74.663789, 18.465409],
              [74.67113, 18.464782],
              [74.674649, 18.461301],
              [74.670167, 18.458975],
              [74.661592, 18.456839],
              [74.65076, 18.451983],
              [74.643573, 18.449797],
              [74.63773, 18.451416],
              [74.628481, 18.455942],
              [74.622406, 18.461408],
              [74.612178, 18.467463],
              [74.60223, 18.470142],
              [74.580493, 18.473295],
              [74.575399, 18.476803],
              [74.568744, 18.486628],
              [74.560735, 18.492479],
              [74.553874, 18.498849],
              [74.547689, 18.508274],
              [74.549789, 18.5138],
              [74.558671, 18.521054],
              [74.563687, 18.523513],
              [74.570844, 18.529255],
              [74.573039, 18.532205],
              [74.57121, 18.544708],
              [74.572761, 18.545749],
              [74.580584, 18.545878],
              [74.581528, 18.547836],
              [74.579909, 18.552356],
              [74.570784, 18.555555],
              [74.565879, 18.559075],
              [74.561207, 18.567943],
              [74.558586, 18.570383],
              [74.55467, 18.576551],
              [74.5487, 18.578052],
              [74.543762, 18.583351],
              [74.546306, 18.587338],
              [74.545046, 18.591978],
              [74.550925, 18.609658],
              [74.550694, 18.613965],
              [74.545546, 18.617305],
              [74.539094, 18.618109],
              [74.526881, 18.617777],
              [74.51698, 18.615796],
              [74.51072, 18.615912],
              [74.507453, 18.622434],
              [74.503504, 18.625845],
              [74.495855, 18.626118],
              [74.48558, 18.63028],
              [74.478913, 18.634011],
              [74.474557, 18.641205],
              [74.474144, 18.645336],
              [74.475682, 18.647647],
              [74.489781, 18.64651],
              [74.492125, 18.651471],
              [74.492462, 18.654061],
              [74.500202, 18.65631],
              [74.50475, 18.658591],
              [74.509762, 18.662418],
              [74.511563, 18.667434],
              [74.510906, 18.672658],
              [74.507292, 18.677445],
              [74.500981, 18.677217],
              [74.486558, 18.674618],
              [74.479072, 18.681561],
              [74.475673, 18.689051],
              [74.477064, 18.694177],
              [74.481717, 18.702663],
              [74.481085, 18.715689],
              [74.477149, 18.722197],
              [74.469674, 18.723452],
              [74.467362, 18.724759],
              [74.460515, 18.72337],
              [74.451109, 18.719445],
              [74.447112, 18.721584],
              [74.444842, 18.724722],
              [74.44333, 18.735451],
              [74.440887, 18.738587],
              [74.424927, 18.748945],
              [74.419635, 18.747811],
              [74.411804, 18.743024],
              [74.399543, 18.741311],
              [74.395805, 18.766078],
              [74.396051, 18.770216],
              [74.397505, 18.774711],
              [74.399648, 18.777259],
              [74.394543, 18.781168],
              [74.392131, 18.785566],
              [74.390498, 18.791409],
              [74.389752, 18.798069],
              [74.385535, 18.803193],
              [74.38601, 18.808079],
              [74.392652, 18.816703],
              [74.397786, 18.825763],
              [74.397425, 18.830413],
              [74.392988, 18.83376],
              [74.38996, 18.835055],
              [74.385992, 18.833869],
              [74.370483, 18.836019],
              [74.358667, 18.84142],
              [74.351704, 18.843652],
              [74.338769, 18.837725],
              [74.332149, 18.837372],
              [74.325783, 18.839781],
              [74.321582, 18.84336],
              [74.311331, 18.853424],
              [74.30883, 18.860465],
              [74.309404, 18.86747],
              [74.304212, 18.872651],
              [74.30321, 18.875963],
              [74.303632, 18.880397],
              [74.300584, 18.88318],
              [74.297572, 18.888032],
              [74.295861, 18.89915],
              [74.294419, 18.903218],
              [74.285441, 18.907495],
              [74.282789, 18.912119],
              [74.274831, 18.917318],
              [74.270795, 18.920952],
              [74.267506, 18.928389],
              [74.260711, 18.936474],
              [74.250365, 18.952793],
              [74.245964, 18.95258],
              [74.239869, 18.953372],
              [74.23823, 18.958471],
              [74.239668, 18.964173],
              [74.236308, 18.967124],
              [74.230078, 18.968891],
              [74.224832, 18.973039],
              [74.223101, 18.976065],
              [74.223463, 18.980661],
              [74.226154, 18.98723],
              [74.224338, 18.99221],
              [74.221002, 18.993549],
              [74.215752, 18.993441],
              [74.212713, 18.995302],
              [74.213573, 18.998648],
              [74.216665, 19.000466],
              [74.214754, 19.006922],
              [74.210848, 19.009585],
              [74.20538, 19.009699],
              [74.202525, 19.011104],
              [74.198893, 19.016005],
              [74.193514, 19.017736],
              [74.191038, 19.01926],
              [74.191318, 19.020755],
              [74.188962, 19.026194],
              [74.179339, 19.031037],
              [74.175131, 19.035881],
              [74.175248, 19.041798],
              [74.183945, 19.052334],
              [74.189604, 19.060716],
              [74.192506, 19.067177],
              [74.193338, 19.075624],
              [74.19538, 19.083751],
              [74.200418, 19.087584],
              [74.200353, 19.093842],
              [74.199122, 19.096702],
              [74.19741, 19.105824],
              [74.200995, 19.109359],
              [74.204145, 19.113921],
              [74.210567, 19.125073],
              [74.21447, 19.127173],
              [74.220725, 19.129588],
              [74.224711, 19.129744],
              [74.227213, 19.126666],
              [74.230735, 19.12446],
              [74.236009, 19.123301],
              [74.237741, 19.130786],
              [74.244336, 19.142047],
              [74.249124, 19.147252],
              [74.252846, 19.149471],
              [74.256555, 19.153123],
              [74.26077, 19.160691],
              [74.265042, 19.162623],
              [74.265979, 19.165845],
              [74.266552, 19.18171],
              [74.26815, 19.184534],
              [74.270985, 19.185537],
              [74.29243, 19.18613],
              [74.304309, 19.18877],
              [74.310451, 19.196916],
              [74.313656, 19.20315],
              [74.316652, 19.206222],
              [74.316451, 19.208059],
              [74.292573, 19.216053],
              [74.280418, 19.217324],
              [74.264876, 19.224071],
              [74.261715, 19.219623],
              [74.242028, 19.212376],
              [74.228872, 19.204503],
              [74.22171, 19.201506],
              [74.219996, 19.20333],
              [74.209784, 19.203804],
              [74.194256, 19.209288],
              [74.187129, 19.214964],
              [74.184214, 19.216143],
              [74.176474, 19.216701],
              [74.171766, 19.219707],
              [74.168624, 19.219659],
              [74.167608, 19.218328],
              [74.1658, 19.211481],
              [74.166459, 19.206027],
              [74.158938, 19.202742],
              [74.155421, 19.215798],
              [74.152832, 19.221803],
              [74.143796, 19.224645],
              [74.142626, 19.220325],
              [74.128371, 19.220074],
              [74.111715, 19.229959],
              [74.104329, 19.230743],
              [74.098092, 19.23223],
              [74.092804, 19.234533],
              [74.089181, 19.234901],
              [74.089569, 19.232088],
              [74.096679, 19.227797],
              [74.096469, 19.22544],
              [74.093858, 19.226221],
              [74.08978, 19.229167],
              [74.084804, 19.231126],
              [74.082478, 19.233623],
              [74.076969, 19.235232],
              [74.066147, 19.240872],
              [74.060971, 19.244373],
              [74.056279, 19.242494],
              [74.05336, 19.243728],
              [74.050708, 19.250189],
              [74.047412, 19.258253],
              [74.034561, 19.25025],
              [74.033145, 19.25242],
              [74.036059, 19.256466],
              [74.034631, 19.259959],
              [74.026808, 19.268837],
              [74.030381, 19.273756],
              [74.032123, 19.28026],
              [74.031909, 19.283708],
              [74.026527, 19.289332],
              [74.022227, 19.285101],
              [74.020393, 19.286114],
              [74.01549, 19.292261],
              [74.014129, 19.295582],
              [74.014339, 19.29874],
              [74.019371, 19.296894],
              [74.022944, 19.29693],
              [74.027563, 19.300547],
              [74.029142, 19.30556],
              [74.028298, 19.310317],
              [74.020786, 19.317649],
              [74.019054, 19.321014],
              [74.013082, 19.325604],
              [74.011888, 19.329671],
              [74.011935, 19.336508],
              [74.003816, 19.349288],
              [74.003479, 19.352324],
              [74.000027, 19.357521],
              [73.979965, 19.351193],
              [73.973254, 19.351272],
              [73.972621, 19.355339],
              [73.964851, 19.350447],
              [73.958076, 19.349795],
              [73.956662, 19.343859],
              [73.951957, 19.345692],
              [73.947351, 19.344265],
              [73.946954, 19.347629],
              [73.943994, 19.347697],
              [73.941024, 19.345871],
              [73.939983, 19.343672],
              [73.930953, 19.340559],
              [73.925677, 19.346112],
              [73.922682, 19.350898],
              [73.919765, 19.358431],
              [73.914849, 19.365191],
              [73.902236, 19.369525],
              [73.896161, 19.374271],
              [73.891937, 19.375495],
              [73.884328, 19.376275],
              [73.877789, 19.362954],
              [73.872754, 19.359531],
              [73.868331, 19.358286],
              [73.862714, 19.357905],
              [73.857213, 19.35878],
              [73.849688, 19.363906],
              [73.84392, 19.369477],
              [73.844537, 19.372224],
              [73.843586, 19.375264],
              [73.839367, 19.378141],
              [73.83352, 19.380559],
              [73.817369, 19.38954],
              [73.813696, 19.392872],
              [73.801314, 19.394902],
              [73.796902, 19.394455],
              [73.783531, 19.390643],
              [73.781649, 19.385975],
              [73.779666, 19.3873],
              [73.77435, 19.388119],
              [73.771962, 19.395401],
              [73.766036, 19.393867],
              [73.755295, 19.396987],
              [73.752934, 19.409442],
              [73.741154, 19.410674],
              [73.736566, 19.411945],
              [73.733474, 19.411607],
              [73.729921, 19.414482],
              [73.726687, 19.420053],
              [73.72903, 19.430258],
              [73.724189, 19.431074],
              [73.707448, 19.431565],
              [73.690915, 19.439281],
              [73.686949, 19.44376],
              [73.681867, 19.457138],
              [73.675786, 19.462593],
              [73.689777, 19.46911],
              [73.696021, 19.472883],
              [73.697027, 19.481829],
              [73.707316, 19.483012],
              [73.709247, 19.496314],
              [73.703332, 19.500107],
              [73.699668, 19.50522],
              [73.688795, 19.508853],
              [73.686526, 19.516142],
              [73.682421, 19.517524],
              [73.679075, 19.512202],
              [73.668376, 19.514289],
              [73.668631, 19.517495],
              [73.665401, 19.526047],
              [73.663176, 19.529033],
              [73.656487, 19.534777],
              [73.63967, 19.536416],
              [73.637171, 19.530744],
              [73.635121, 19.53281],
              [73.635143, 19.538949],
              [73.626208, 19.542743],
              [73.627548, 19.546408],
              [73.629793, 19.5631],
              [73.628684, 19.572561],
              [73.62165, 19.583014],
              [73.620211, 19.587029],
              [73.623832, 19.589672],
              [73.634143, 19.59699],
              [73.638389, 19.597441],
              [73.641224, 19.595429],
              [73.643693, 19.592438],
              [73.647433, 19.590257],
              [73.654144, 19.589328],
              [73.663636, 19.586271],
              [73.668232, 19.586841],
              [73.67515, 19.590543],
              [73.683249, 19.588982],
              [73.68744, 19.591204],
              [73.688842, 19.595211],
              [73.7038, 19.596554],
              [73.709617, 19.599694],
              [73.712294, 19.602725],
              [73.712767, 19.613997],
              [73.717085, 19.616906],
              [73.722354, 19.619299],
              [73.726299, 19.620374],
              [73.727757, 19.621633],
              [73.736215, 19.620236],
              [73.74095, 19.621882],
              [73.743315, 19.623705],
              [73.748402, 19.623575],
              [73.752708, 19.624935],
              [73.756113, 19.628761],
              [73.764587, 19.629018],
              [73.770658, 19.633276],
              [73.774578, 19.62972],
              [73.7781, 19.631829],
              [73.779567, 19.635591],
              [73.779362, 19.64239],
              [73.790141, 19.643078],
              [73.793781, 19.6458],
              [73.792402, 19.64752],
              [73.783804, 19.648361],
              [73.781342, 19.650313],
              [73.780804, 19.652889],
              [73.781425, 19.656189],
              [73.783688, 19.660797],
              [73.787446, 19.661289],
              [73.789273, 19.663037],
              [73.790679, 19.665876],
              [73.793286, 19.668532],
              [73.79715, 19.676163],
              [73.800296, 19.676991],
              [73.8049, 19.677006],
              [73.805876, 19.678523],
              [73.80426, 19.682217],
              [73.795556, 19.685648],
              [73.795143, 19.687631],
              [73.796545, 19.68931],
              [73.802596, 19.687767],
              [73.805993, 19.689591],
              [73.808573, 19.684424],
              [73.810622, 19.683838],
              [73.81354, 19.685664],
              [73.815555, 19.700805],
              [73.819358, 19.708523],
              [73.824896, 19.714876],
              [73.828537, 19.716512],
              [73.835393, 19.717441],
              [73.83783, 19.72097],
              [73.840773, 19.728266],
              [73.8415, 19.739286],
              [73.842779, 19.740949],
              [73.859643, 19.745424],
              [73.867723, 19.74953],
              [73.869801, 19.742428],
              [73.875902, 19.740553],
              [73.883181, 19.741853],
              [73.88725, 19.743841],
              [73.889265, 19.746667],
              [73.891233, 19.752526],
              [73.893762, 19.749452],
              [73.900295, 19.74818],
              [73.901563, 19.746528],
              [73.901035, 19.740645],
              [73.898828, 19.735379],
              [73.89892, 19.730828],
              [73.896618, 19.719097],
              [73.897452, 19.716428],
              [73.906924, 19.709932],
              [73.908955, 19.705606],
              [73.912652, 19.70509],
              [73.913169, 19.70104],
              [73.912425, 19.698882],
              [73.906178, 19.696288],
              [73.909518, 19.687856],
              [73.915658, 19.68161],
              [73.939462, 19.672825],
              [73.951438, 19.67238],
              [73.956348, 19.672821],
              [73.958514, 19.670076],
              [73.96223, 19.674032],
              [73.98022, 19.676348],
              [73.984017, 19.672991],
              [73.987699, 19.671221],
              [73.991381, 19.670084],
              [74.000033, 19.669843],
              [74.012852, 19.669435],
              [74.019373, 19.672317],
              [74.02412, 19.669608],
              [74.034079, 19.66845],
              [74.038944, 19.666373],
              [74.060821, 19.660688],
              [74.070638, 19.660098],
              [74.083552, 19.647766],
              [74.088529, 19.64656],
              [74.09678, 19.639747],
              [74.098586, 19.641601],
              [74.101131, 19.646973],
              [74.107541, 19.642896],
              [74.121459, 19.643728],
              [74.127373, 19.658543],
              [74.131953, 19.660947],
              [74.137391, 19.669038],
              [74.141614, 19.67057],
              [74.14365, 19.673289],
              [74.137618, 19.682477],
              [74.134621, 19.691291],
              [74.135981, 19.694924],
              [74.141578, 19.69279],
              [74.150718, 19.687715],
              [74.153533, 19.69056],
              [74.154082, 19.696423],
              [74.157442, 19.700245],
              [74.156258, 19.703559],
              [74.162165, 19.712631],
              [74.163459, 19.716896],
              [74.164292, 19.725058],
              [74.167056, 19.726813],
              [74.167651, 19.728077],
              [74.171332, 19.729955],
              [74.181018, 19.731017],
              [74.188334, 19.733391],
              [74.189388, 19.736961],
              [74.196475, 19.737424],
              [74.22291, 19.736934],
              [74.225366, 19.740172],
              [74.246006, 19.743919],
              [74.249953, 19.750107],
              [74.25314, 19.753115],
              [74.258022, 19.755569],
              [74.263464, 19.757114],
              [74.266651, 19.760306],
              [74.272159, 19.767763],
              [74.275965, 19.776067],
              [74.278251, 19.778385],
              [74.281638, 19.778984],
              [74.295301, 19.776757],
              [74.307894, 19.771298],
              [74.311012, 19.768801],
              [74.319032, 19.767319],
              [74.324464, 19.770352],
              [74.326194, 19.773588],
              [74.325629, 19.783055],
              [74.328488, 19.79468],
              [74.333732, 19.799035],
              [74.365602, 19.801834],
              [74.367942, 19.804559],
              [74.37498, 19.804616],
              [74.378059, 19.80585],
              [74.375083, 19.807427],
              [74.371195, 19.814868],
              [74.370637, 19.822726],
              [74.371925, 19.828938],
              [74.372107, 19.835776],
              [74.363735, 19.836103],
              [74.365829, 19.853006],
              [74.364714, 19.870562],
              [74.340843, 19.873405],
              [74.338307, 19.886012],
              [74.29424, 19.900837],
              [74.292328, 19.904788],
              [74.285895, 19.90496],
              [74.277788, 19.908157],
              [74.27851, 19.915851],
              [74.275157, 19.930349],
              [74.272892, 19.932976],
              [74.263089, 19.936211],
              [74.250217, 19.936784],
              [74.249, 19.94981],
              [74.251694, 19.964079],
              [74.259381, 19.962824],
              [74.264358, 19.96276],
              [74.283516, 19.958911],
              [74.284773, 19.968337],
              [74.290003, 19.98676],
              [74.302221, 19.972168],
              [74.306135, 19.968477],
              [74.309608, 19.967009],
              [74.311538, 19.968286],
              [74.312351, 19.972773],
              [74.314997, 19.975848],
              [74.318263, 19.976789],
              [74.319522, 19.978584],
              [74.31976, 19.985416],
              [74.348134, 19.983711],
              [74.351503, 19.966286],
              [74.365899, 19.965488],
              [74.366728, 19.974108],
              [74.37829, 19.971627],
              [74.385982, 19.980478],
              [74.428953, 19.974404],
              [74.445526, 19.974198],
              [74.449229, 19.974626],
              [74.458241, 19.986015],
              [74.469217, 19.987713],
              [74.475854, 19.985177],
              [74.485371, 19.979914],
              [74.480636, 19.971382],
              [74.480194, 19.966261],
              [74.496002, 19.963523],
              [74.497353, 19.969446],
              [74.511649, 19.973],
              [74.514769, 19.969465],
              [74.517877, 19.968343],
              [74.520484, 19.96842],
              [74.520828, 19.971815],
              [74.52225, 19.975264],
              [74.526567, 19.975526],
              [74.53148, 19.975396],
              [74.558067, 19.967441],
              [74.56204, 19.964427],
              [74.567673, 19.95821],
              [74.573524, 19.954526],
              [74.62757, 19.950787],
              [74.65898, 19.947049],
              [74.673327, 19.946696],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 4,
        censuscode: 522,
        dt_cen_cd: 26,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Ahmadnagar",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [77.616118, 20.759908],
              [77.611674, 20.75865],
              [77.597886, 20.758522],
              [77.591161, 20.757218],
              [77.588789, 20.747796],
              [77.582707, 20.748802],
              [77.577409, 20.744393],
              [77.576589, 20.741068],
              [77.571993, 20.741086],
              [77.571895, 20.735749],
              [77.569643, 20.735896],
              [77.56685, 20.733551],
              [77.566029, 20.730318],
              [77.566882, 20.726468],
              [77.565809, 20.721023],
              [77.539259, 20.729053],
              [77.524644, 20.731479],
              [77.521709, 20.731523],
              [77.518734, 20.72853],
              [77.51609, 20.718275],
              [77.508032, 20.710046],
              [77.50975, 20.707039],
              [77.515034, 20.701608],
              [77.51559, 20.698029],
              [77.519465, 20.699933],
              [77.524826, 20.700758],
              [77.523467, 20.695032],
              [77.539424, 20.68858],
              [77.546445, 20.678945],
              [77.543577, 20.675494],
              [77.538607, 20.676752],
              [77.533144, 20.678135],
              [77.523443, 20.68059],
              [77.517733, 20.682795],
              [77.51284, 20.683081],
              [77.511991, 20.681412],
              [77.514025, 20.677214],
              [77.517524, 20.673041],
              [77.51345, 20.666166],
              [77.510761, 20.663638],
              [77.504393, 20.664452],
              [77.502886, 20.671785],
              [77.49963, 20.673387],
              [77.499894, 20.674955],
              [77.496279, 20.680046],
              [77.492833, 20.681368],
              [77.489013, 20.681764],
              [77.480136, 20.680787],
              [77.474688, 20.684559],
              [77.471297, 20.688089],
              [77.466621, 20.676971],
              [77.462487, 20.670565],
              [77.455194, 20.661232],
              [77.456703, 20.653898],
              [77.454617, 20.655611],
              [77.452899, 20.656234],
              [77.445778, 20.658504],
              [77.433983, 20.661329],
              [77.433631, 20.65424],
              [77.434445, 20.647539],
              [77.440614, 20.646909],
              [77.448613, 20.636419],
              [77.455585, 20.625548],
              [77.460654, 20.626186],
              [77.461658, 20.619672],
              [77.469619, 20.617232],
              [77.466824, 20.610102],
              [77.452117, 20.612795],
              [77.444, 20.613209],
              [77.438246, 20.612651],
              [77.417713, 20.608435],
              [77.412777, 20.60605],
              [77.411863, 20.602814],
              [77.414574, 20.59909],
              [77.41404, 20.596413],
              [77.414325, 20.591819],
              [77.412555, 20.587374],
              [77.409544, 20.586494],
              [77.40698, 20.587737],
              [77.403461, 20.58786],
              [77.402716, 20.586007],
              [77.403932, 20.578762],
              [77.400967, 20.58055],
              [77.39835, 20.581165],
              [77.390761, 20.582948],
              [77.365592, 20.581311],
              [77.363954, 20.570337],
              [77.362447, 20.567551],
              [77.355968, 20.569184],
              [77.351037, 20.57158],
              [77.349762, 20.572509],
              [77.346477, 20.574903],
              [77.345207, 20.57527],
              [77.340484, 20.576636],
              [77.339821, 20.575612],
              [77.337423, 20.553954],
              [77.337698, 20.550004],
              [77.34378, 20.548641],
              [77.344102, 20.547175],
              [77.337821, 20.538969],
              [77.339313, 20.537616],
              [77.336015, 20.531671],
              [77.335199, 20.528529],
              [77.336214, 20.526615],
              [77.339472, 20.524834],
              [77.354155, 20.522979],
              [77.361723, 20.520445],
              [77.366813, 20.519799],
              [77.371054, 20.527508],
              [77.395961, 20.527024],
              [77.397937, 20.525863],
              [77.39327, 20.509962],
              [77.392261, 20.507451],
              [77.386065, 20.492035],
              [77.384381, 20.488466],
              [77.381011, 20.483075],
              [77.367413, 20.479709],
              [77.37065, 20.483813],
              [77.372162, 20.491289],
              [77.371347, 20.497897],
              [77.365865, 20.49872],
              [77.339732, 20.497246],
              [77.329064, 20.498619],
              [77.3272, 20.489389],
              [77.327088, 20.485248],
              [77.339812, 20.483543],
              [77.346441, 20.479062],
              [77.342532, 20.46952],
              [77.343747, 20.467334],
              [77.348655, 20.46595],
              [77.348675, 20.464938],
              [77.346642, 20.462416],
              [77.341533, 20.456074],
              [77.337601, 20.452602],
              [77.333243, 20.45096],
              [77.321944, 20.449931],
              [77.316277, 20.450289],
              [77.301209, 20.447442],
              [77.2983, 20.44178],
              [77.296382, 20.435307],
              [77.295952, 20.432448],
              [77.297226, 20.422631],
              [77.295528, 20.419749],
              [77.290372, 20.419012],
              [77.286175, 20.41912],
              [77.282718, 20.421172],
              [77.2792, 20.426258],
              [77.277935, 20.430834],
              [77.269341, 20.431229],
              [77.264435, 20.432519],
              [77.258521, 20.435287],
              [77.250577, 20.437415],
              [77.24966, 20.429856],
              [77.248365, 20.426429],
              [77.247003, 20.42622],
              [77.241299, 20.428414],
              [77.23592, 20.432168],
              [77.233081, 20.434149],
              [77.227967, 20.440768],
              [77.226924, 20.443967],
              [77.225424, 20.445687],
              [77.225084, 20.44798],
              [77.206156, 20.44934],
              [77.186717, 20.448734],
              [77.184007, 20.433876],
              [77.184782, 20.429568],
              [77.186775, 20.427582],
              [77.195644, 20.423426],
              [77.197072, 20.42051],
              [77.196864, 20.416459],
              [77.195126, 20.411001],
              [77.192674, 20.407],
              [77.18614, 20.402279],
              [77.182464, 20.40083],
              [77.176733, 20.39971],
              [77.162807, 20.400893],
              [77.152222, 20.4009],
              [77.150075, 20.391847],
              [77.141009, 20.382569],
              [77.134553, 20.392469],
              [77.133753, 20.39788],
              [77.13234, 20.40006],
              [77.124641, 20.404235],
              [77.122633, 20.406863],
              [77.123644, 20.409734],
              [77.121278, 20.410884],
              [77.117892, 20.409531],
              [77.116661, 20.407852],
              [77.114181, 20.409735],
              [77.110062, 20.411362],
              [77.106497, 20.41277],
              [77.104641, 20.413711],
              [77.101463, 20.415718],
              [77.097607, 20.418151],
              [77.085637, 20.421229],
              [77.081916, 20.426307],
              [77.080346, 20.435566],
              [77.078255, 20.437456],
              [77.059301, 20.438556],
              [77.057758, 20.446527],
              [77.05508, 20.448498],
              [77.047264, 20.449868],
              [77.042344, 20.45073],
              [77.02469, 20.450287],
              [77.022002, 20.44398],
              [77.018842, 20.439714],
              [77.015598, 20.42932],
              [77.017147, 20.421166],
              [77.01763, 20.412714],
              [77.011359, 20.413876],
              [77.008243, 20.41363],
              [77.006407, 20.412857],
              [77.003272, 20.409465],
              [77.000693, 20.406673],
              [76.998229, 20.407737],
              [76.995365, 20.409325],
              [76.993921, 20.408468],
              [76.992425, 20.405587],
              [76.994941, 20.401287],
              [76.998266, 20.397519],
              [76.997841, 20.394751],
              [76.991275, 20.396091],
              [76.987991, 20.390323],
              [76.984801, 20.389063],
              [76.982818, 20.386172],
              [76.983171, 20.383512],
              [76.981174, 20.381264],
              [76.976755, 20.382554],
              [76.975638, 20.380232],
              [76.979076, 20.374876],
              [76.97963, 20.371944],
              [76.975586, 20.369655],
              [76.974608, 20.369572],
              [76.965657, 20.36881],
              [76.961435, 20.365781],
              [76.95181, 20.364481],
              [76.946826, 20.364931],
              [76.934606, 20.370383],
              [76.930572, 20.359264],
              [76.920803, 20.359983],
              [76.918706, 20.353686],
              [76.900387, 20.340523],
              [76.897317, 20.332969],
              [76.895394, 20.324694],
              [76.893449, 20.324469],
              [76.891974, 20.320852],
              [76.892235, 20.318007],
              [76.904766, 20.315784],
              [76.908707, 20.314026],
              [76.905865, 20.310473],
              [76.884816, 20.29762],
              [76.882075, 20.293976],
              [76.880156, 20.28851],
              [76.883127, 20.286549],
              [76.883033, 20.282225],
              [76.876304, 20.278222],
              [76.872988, 20.278337],
              [76.870096, 20.281127],
              [76.868669, 20.283764],
              [76.866294, 20.293554],
              [76.863564, 20.297727],
              [76.859331, 20.299477],
              [76.841895, 20.298926],
              [76.839887, 20.301366],
              [76.837099, 20.299744],
              [76.836966, 20.293028],
              [76.834439, 20.288652],
              [76.827549, 20.283264],
              [76.82172, 20.280403],
              [76.819432, 20.280645],
              [76.814388, 20.27922],
              [76.810309, 20.279528],
              [76.80768, 20.288167],
              [76.800588, 20.28576],
              [76.792124, 20.286024],
              [76.788559, 20.290132],
              [76.785987, 20.298029],
              [76.791182, 20.309259],
              [76.792838, 20.315298],
              [76.788369, 20.317552],
              [76.780627, 20.320006],
              [76.769891, 20.322381],
              [76.769482, 20.313949],
              [76.762227, 20.321625],
              [76.75739, 20.324564],
              [76.744233, 20.326227],
              [76.747049, 20.338132],
              [76.743445, 20.338787],
              [76.736543, 20.342112],
              [76.73387, 20.341337],
              [76.731529, 20.337418],
              [76.726711, 20.338352],
              [76.727935, 20.343869],
              [76.699608, 20.353365],
              [76.706022, 20.363522],
              [76.707008, 20.36869],
              [76.706233, 20.373393],
              [76.708806, 20.385464],
              [76.717317, 20.386456],
              [76.725025, 20.389451],
              [76.727097, 20.395495],
              [76.72766, 20.40147],
              [76.727362, 20.40674],
              [76.722697, 20.411121],
              [76.722606, 20.414449],
              [76.720063, 20.418721],
              [76.713796, 20.418268],
              [76.713125, 20.424574],
              [76.714659, 20.437034],
              [76.697669, 20.455699],
              [76.693925, 20.458475],
              [76.69886, 20.472057],
              [76.707718, 20.469095],
              [76.708986, 20.470833],
              [76.705246, 20.479922],
              [76.704961, 20.483647],
              [76.712227, 20.507868],
              [76.716562, 20.513579],
              [76.727099, 20.514881],
              [76.736191, 20.512725],
              [76.739017, 20.51068],
              [76.741126, 20.506513],
              [76.741717, 20.501702],
              [76.737118, 20.491794],
              [76.742348, 20.492927],
              [76.747927, 20.495792],
              [76.750644, 20.497994],
              [76.752557, 20.502202],
              [76.752957, 20.512357],
              [76.757367, 20.5093],
              [76.761028, 20.509328],
              [76.764857, 20.51005],
              [76.770067, 20.512911],
              [76.771368, 20.517336],
              [76.773486, 20.539442],
              [76.775042, 20.543647],
              [76.776827, 20.554098],
              [76.781268, 20.562461],
              [76.78478, 20.571492],
              [76.770369, 20.575443],
              [76.778429, 20.586639],
              [76.778416, 20.588193],
              [76.783595, 20.588753],
              [76.789422, 20.59167],
              [76.790673, 20.595413],
              [76.788182, 20.600323],
              [76.785718, 20.60334],
              [76.775048, 20.603768],
              [76.763348, 20.602973],
              [76.772219, 20.627377],
              [76.7512, 20.6316],
              [76.755797, 20.642143],
              [76.756134, 20.645533],
              [76.758306, 20.647956],
              [76.761531, 20.649247],
              [76.766162, 20.64986],
              [76.760317, 20.65595],
              [76.735601, 20.657283],
              [76.739789, 20.665344],
              [76.738605, 20.674745],
              [76.739463, 20.681006],
              [76.736949, 20.682934],
              [76.737809, 20.689139],
              [76.730839, 20.69079],
              [76.727184, 20.690699],
              [76.722951, 20.693072],
              [76.722929, 20.695142],
              [76.724487, 20.698768],
              [76.726358, 20.700619],
              [76.728609, 20.701094],
              [76.732151, 20.700612],
              [76.734829, 20.701156],
              [76.735252, 20.715326],
              [76.749329, 20.716824],
              [76.756812, 20.71913],
              [76.759478, 20.720991],
              [76.760438, 20.722893],
              [76.760166, 20.72581],
              [76.756714, 20.729225],
              [76.754947, 20.736094],
              [76.755341, 20.74636],
              [76.75876, 20.752932],
              [76.759586, 20.75655],
              [76.764071, 20.759975],
              [76.767206, 20.763564],
              [76.771347, 20.771457],
              [76.772117, 20.774788],
              [76.772519, 20.783685],
              [76.771086, 20.787281],
              [76.76114, 20.793735],
              [76.750552, 20.797367],
              [76.745287, 20.798297],
              [76.746474, 20.80932],
              [76.7454, 20.820384],
              [76.745973, 20.823939],
              [76.755723, 20.825928],
              [76.755647, 20.827132],
              [76.751265, 20.832712],
              [76.751767, 20.838105],
              [76.755815, 20.842443],
              [76.753532, 20.844657],
              [76.754293, 20.848449],
              [76.759296, 20.84901],
              [76.760907, 20.854073],
              [76.7632, 20.855986],
              [76.762885, 20.85776],
              [76.761456, 20.860443],
              [76.7553, 20.86578],
              [76.751397, 20.871828],
              [76.746268, 20.872294],
              [76.746288, 20.876426],
              [76.744009, 20.88501],
              [76.744544, 20.88685],
              [76.743598, 20.890167],
              [76.733111, 20.888584],
              [76.728432, 20.885558],
              [76.722874, 20.885913],
              [76.722414, 20.889064],
              [76.72111, 20.891338],
              [76.717132, 20.892799],
              [76.71739, 20.897385],
              [76.716398, 20.898702],
              [76.713883, 20.900335],
              [76.70654, 20.901936],
              [76.707146, 20.908078],
              [76.70567, 20.909959],
              [76.695739, 20.907399],
              [76.694703, 20.913695],
              [76.688384, 20.91662],
              [76.689521, 20.918354],
              [76.696828, 20.921577],
              [76.705008, 20.921592],
              [76.715771, 20.920029],
              [76.718783, 20.91845],
              [76.724515, 20.919415],
              [76.727801, 20.920306],
              [76.739038, 20.927005],
              [76.746545, 20.927932],
              [76.752281, 20.922195],
              [76.769313, 20.923601],
              [76.773173, 20.922142],
              [76.778977, 20.915366],
              [76.778325, 20.91296],
              [76.774794, 20.911602],
              [76.774877, 20.909479],
              [76.778801, 20.907914],
              [76.785693, 20.908485],
              [76.787997, 20.910692],
              [76.7881, 20.913328],
              [76.785617, 20.92414],
              [76.78657, 20.927017],
              [76.784656, 20.929125],
              [76.779342, 20.928912],
              [76.776521, 20.929624],
              [76.775771, 20.931798],
              [76.779339, 20.936192],
              [76.780711, 20.939702],
              [76.785905, 20.940205],
              [76.786922, 20.941989],
              [76.788701, 20.955537],
              [76.788273, 20.961903],
              [76.807926, 20.957604],
              [76.806092, 20.971405],
              [76.783798, 20.971273],
              [76.784589, 20.977525],
              [76.782464, 20.990182],
              [76.780589, 20.988506],
              [76.776167, 20.99001],
              [76.777536, 21.00047],
              [76.778315, 21.003121],
              [76.789026, 21.003236],
              [76.788473, 21.005094],
              [76.788635, 21.013163],
              [76.792192, 21.016953],
              [76.793119, 21.022554],
              [76.789411, 21.026843],
              [76.789145, 21.031807],
              [76.785125, 21.032061],
              [76.785172, 21.03235],
              [76.782233, 21.032312],
              [76.781248, 21.029183],
              [76.778331, 21.028308],
              [76.777553, 21.032858],
              [76.775354, 21.033407],
              [76.771266, 21.034122],
              [76.771306, 21.03461],
              [76.770216, 21.037076],
              [76.768638, 21.038291],
              [76.765477, 21.03866],
              [76.765255, 21.043043],
              [76.77103, 21.045804],
              [76.77413, 21.052439],
              [76.779551, 21.053254],
              [76.782612, 21.061444],
              [76.783196, 21.072504],
              [76.776645, 21.078177],
              [76.774318, 21.088867],
              [76.781775, 21.093812],
              [76.788631, 21.110301],
              [76.788246, 21.122514],
              [76.782999, 21.133399],
              [76.776563, 21.143274],
              [76.778774, 21.148968],
              [76.777391, 21.156103],
              [76.77548, 21.171162],
              [76.772178, 21.180918],
              [76.775222, 21.188887],
              [76.78376, 21.188962],
              [76.788814, 21.189001],
              [76.792711, 21.184789],
              [76.807195, 21.185953],
              [76.809105, 21.186076],
              [76.827189, 21.187325],
              [76.842557, 21.189779],
              [76.848082, 21.193365],
              [76.855988, 21.190783],
              [76.878669, 21.194033],
              [76.897068, 21.198611],
              [76.921591, 21.202222],
              [76.942319, 21.201467],
              [76.943643, 21.20119],
              [76.955906, 21.198628],
              [76.963707, 21.199543],
              [76.964566, 21.199645],
              [76.9799, 21.204413],
              [76.999156, 21.204106],
              [77.006042, 21.207078],
              [77.005025, 21.214816],
              [77.00307, 21.22104],
              [77.004188, 21.228904],
              [77.011166, 21.237301],
              [77.020223, 21.237474],
              [77.023824, 21.245943],
              [77.037132, 21.245159],
              [77.043776, 21.243435],
              [77.051567, 21.237321],
              [77.05789, 21.233984],
              [77.060238, 21.230241],
              [77.060996, 21.226529],
              [77.064486, 21.223548],
              [77.069179, 21.221723],
              [77.073468, 21.221515],
              [77.077307, 21.219468],
              [77.07987, 21.217102],
              [77.087987, 21.223242],
              [77.092712, 21.225293],
              [77.10439, 21.220482],
              [77.110602, 21.219008],
              [77.116097, 21.219076],
              [77.119365, 21.220987],
              [77.121524, 21.226094],
              [77.130029, 21.222833],
              [77.138357, 21.225259],
              [77.1472, 21.226667],
              [77.152665, 21.234319],
              [77.155594, 21.237205],
              [77.16078, 21.238007],
              [77.16476, 21.237104],
              [77.173092, 21.225964],
              [77.175953, 21.215681],
              [77.175068, 21.208194],
              [77.18065, 21.207739],
              [77.182762, 21.2037],
              [77.179669, 21.199671],
              [77.17868, 21.196884],
              [77.178962, 21.19241],
              [77.17357, 21.192983],
              [77.17146, 21.188395],
              [77.167466, 21.186242],
              [77.165159, 21.182743],
              [77.165366, 21.17867],
              [77.161985, 21.171066],
              [77.162525, 21.168893],
              [77.164857, 21.165498],
              [77.16493, 21.159812],
              [77.162539, 21.151079],
              [77.159059, 21.1456],
              [77.161236, 21.143803],
              [77.164658, 21.144105],
              [77.163692, 21.140815],
              [77.163917, 21.136275],
              [77.171276, 21.135462],
              [77.190737, 21.13536],
              [77.193601, 21.138987],
              [77.196909, 21.13865],
              [77.195816, 21.121732],
              [77.188426, 21.121228],
              [77.18247, 21.122023],
              [77.18031, 21.119964],
              [77.172541, 21.119908],
              [77.171528, 21.113505],
              [77.172358, 21.106913],
              [77.171945, 21.100758],
              [77.172812, 21.092898],
              [77.175459, 21.089733],
              [77.176618, 21.086999],
              [77.175242, 21.083005],
              [77.176042, 21.074802],
              [77.171525, 21.073284],
              [77.16007, 21.073551],
              [77.149196, 21.072685],
              [77.151854, 21.058198],
              [77.151217, 21.054218],
              [77.152248, 21.047973],
              [77.15034, 21.044424],
              [77.150077, 21.041148],
              [77.150972, 21.036794],
              [77.153238, 21.034079],
              [77.160875, 21.028773],
              [77.173413, 21.022955],
              [77.173738, 21.007611],
              [77.173003, 21.004402],
              [77.170732, 21.003473],
              [77.167905, 21.000381],
              [77.169168, 20.996648],
              [77.169367, 20.98988],
              [77.164531, 20.988075],
              [77.151244, 20.988216],
              [77.135761, 20.987284],
              [77.136168, 20.974373],
              [77.147847, 20.972873],
              [77.156718, 20.973096],
              [77.162955, 20.971687],
              [77.157089, 20.96323],
              [77.153607, 20.955],
              [77.150845, 20.942917],
              [77.146256, 20.931584],
              [77.145973, 20.926428],
              [77.145234, 20.924712],
              [77.142529, 20.923639],
              [77.136802, 20.9161],
              [77.136836, 20.912492],
              [77.138508, 20.905938],
              [77.136758, 20.900221],
              [77.139321, 20.898195],
              [77.135652, 20.888466],
              [77.135641, 20.875958],
              [77.134156, 20.863354],
              [77.138004, 20.862291],
              [77.145157, 20.862193],
              [77.1542, 20.8607],
              [77.158096, 20.867214],
              [77.160428, 20.869039],
              [77.163411, 20.868039],
              [77.169314, 20.86278],
              [77.170948, 20.859851],
              [77.170868, 20.856921],
              [77.173726, 20.854555],
              [77.182389, 20.852202],
              [77.18795, 20.851709],
              [77.192551, 20.853053],
              [77.213568, 20.851361],
              [77.220028, 20.856831],
              [77.223642, 20.857664],
              [77.22737, 20.857756],
              [77.230295, 20.856994],
              [77.238014, 20.858022],
              [77.244294, 20.855175],
              [77.247774, 20.854576],
              [77.253285, 20.855395],
              [77.257932, 20.846761],
              [77.260497, 20.846281],
              [77.26436, 20.848318],
              [77.269155, 20.852757],
              [77.271674, 20.853546],
              [77.278564, 20.851665],
              [77.287211, 20.846442],
              [77.290459, 20.847336],
              [77.294463, 20.850923],
              [77.303261, 20.850509],
              [77.309221, 20.855002],
              [77.312046, 20.856242],
              [77.321158, 20.855837],
              [77.327825, 20.856991],
              [77.32799, 20.854236],
              [77.329735, 20.849743],
              [77.332776, 20.847373],
              [77.337469, 20.845908],
              [77.348595, 20.845535],
              [77.353411, 20.844176],
              [77.357776, 20.846732],
              [77.367023, 20.848839],
              [77.373583, 20.843512],
              [77.378284, 20.842617],
              [77.382944, 20.843781],
              [77.389518, 20.848439],
              [77.396021, 20.843632],
              [77.401802, 20.847141],
              [77.405898, 20.847911],
              [77.411236, 20.850108],
              [77.415363, 20.846285],
              [77.418596, 20.845345],
              [77.422652, 20.847264],
              [77.4248, 20.849429],
              [77.427622, 20.849403],
              [77.431153, 20.847771],
              [77.433699, 20.844887],
              [77.438033, 20.845018],
              [77.439845, 20.849252],
              [77.439258, 20.852123],
              [77.440056, 20.852517],
              [77.446894, 20.851315],
              [77.452271, 20.851221],
              [77.464162, 20.855364],
              [77.463321, 20.856516],
              [77.458612, 20.856788],
              [77.456079, 20.860651],
              [77.456161, 20.86312],
              [77.457665, 20.867233],
              [77.460428, 20.869794],
              [77.459967, 20.872659],
              [77.46378, 20.87596],
              [77.461721, 20.878041],
              [77.462274, 20.879071],
              [77.464794, 20.880425],
              [77.466878, 20.880463],
              [77.473461, 20.877834],
              [77.479581, 20.879271],
              [77.480221, 20.874855],
              [77.478362, 20.871081],
              [77.477059, 20.862491],
              [77.493621, 20.860975],
              [77.497472, 20.859738],
              [77.502635, 20.856772],
              [77.515021, 20.853003],
              [77.516887, 20.849947],
              [77.524914, 20.8512],
              [77.529466, 20.848005],
              [77.534767, 20.852257],
              [77.538932, 20.853835],
              [77.549269, 20.853912],
              [77.551155, 20.853149],
              [77.553036, 20.843792],
              [77.553588, 20.836675],
              [77.552731, 20.829858],
              [77.553195, 20.826577],
              [77.554827, 20.824333],
              [77.559707, 20.823023],
              [77.568139, 20.816123],
              [77.570948, 20.808245],
              [77.578824, 20.80743],
              [77.581031, 20.807928],
              [77.58574, 20.808461],
              [77.591787, 20.807379],
              [77.59578, 20.802636],
              [77.607049, 20.798118],
              [77.610834, 20.798201],
              [77.612582, 20.795373],
              [77.612306, 20.778285],
              [77.619166, 20.780059],
              [77.620936, 20.779531],
              [77.61974, 20.775981],
              [77.619555, 20.76887],
              [77.616118, 20.759908],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 7,
        censuscode: 501,
        dt_cen_cd: 5,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Akola",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [75.889526, 20.563359],
              [75.888326, 20.561405],
              [75.875766, 20.559123],
              [75.870219, 20.559853],
              [75.86497, 20.561746],
              [75.867095, 20.556181],
              [75.871885, 20.551527],
              [75.879325, 20.539367],
              [75.88642, 20.531107],
              [75.887143, 20.526001],
              [75.879279, 20.527475],
              [75.876146, 20.529932],
              [75.87359, 20.529827],
              [75.867911, 20.52731],
              [75.863586, 20.527649],
              [75.863079, 20.523865],
              [75.864671, 20.52324],
              [75.862605, 20.517851],
              [75.861581, 20.511238],
              [75.860378, 20.510204],
              [75.856915, 20.509676],
              [75.856695, 20.507669],
              [75.853535, 20.507537],
              [75.853175, 20.496552],
              [75.851671, 20.490232],
              [75.856208, 20.481047],
              [75.859536, 20.48194],
              [75.861851, 20.48173],
              [75.864351, 20.476705],
              [75.8667, 20.467497],
              [75.867881, 20.465391],
              [75.869838, 20.463851],
              [75.872701, 20.463831],
              [75.874919, 20.461262],
              [75.876199, 20.455545],
              [75.877675, 20.453838],
              [75.894345, 20.447045],
              [75.884208, 20.445573],
              [75.884114, 20.443793],
              [75.881905, 20.439808],
              [75.878333, 20.438916],
              [75.874176, 20.44031],
              [75.870109, 20.440219],
              [75.86523, 20.441204],
              [75.865031, 20.442983],
              [75.869248, 20.446174],
              [75.86898, 20.448189],
              [75.859409, 20.461923],
              [75.85751, 20.462875],
              [75.853165, 20.459855],
              [75.84381, 20.460048],
              [75.840438, 20.461566],
              [75.838643, 20.464879],
              [75.830953, 20.472716],
              [75.825589, 20.47428],
              [75.819754, 20.473468],
              [75.817838, 20.470988],
              [75.815467, 20.46569],
              [75.81175, 20.466225],
              [75.799572, 20.463291],
              [75.798258, 20.461093],
              [75.798958, 20.453003],
              [75.79621, 20.453956],
              [75.782638, 20.455765],
              [75.778141, 20.455431],
              [75.773696, 20.456076],
              [75.768974, 20.454075],
              [75.765489, 20.450708],
              [75.762769, 20.439373],
              [75.762746, 20.435746],
              [75.759692, 20.427159],
              [75.750666, 20.424536],
              [75.748045, 20.424859],
              [75.742901, 20.423365],
              [75.739238, 20.419429],
              [75.737295, 20.414294],
              [75.740287, 20.408179],
              [75.749736, 20.405925],
              [75.752493, 20.403775],
              [75.754494, 20.399202],
              [75.754659, 20.395693],
              [75.754342, 20.391445],
              [75.751061, 20.381535],
              [75.750556, 20.377739],
              [75.751707, 20.37338],
              [75.754536, 20.37094],
              [75.759706, 20.369957],
              [75.760862, 20.360325],
              [75.766173, 20.358198],
              [75.769448, 20.353522],
              [75.773356, 20.336788],
              [75.769092, 20.337605],
              [75.76704, 20.336441],
              [75.763439, 20.332436],
              [75.755845, 20.327764],
              [75.750504, 20.327817],
              [75.746108, 20.329207],
              [75.744923, 20.336953],
              [75.74072, 20.337937],
              [75.735268, 20.336215],
              [75.734415, 20.33155],
              [75.72628, 20.331062],
              [75.718856, 20.331845],
              [75.711936, 20.317058],
              [75.708182, 20.315759],
              [75.705225, 20.313719],
              [75.685725, 20.309372],
              [75.684352, 20.306828],
              [75.688153, 20.299517],
              [75.691971, 20.295132],
              [75.696639, 20.286162],
              [75.696229, 20.280236],
              [75.692765, 20.270428],
              [75.68956, 20.265166],
              [75.682662, 20.258082],
              [75.6794, 20.246899],
              [75.676084, 20.240135],
              [75.67576, 20.237313],
              [75.677248, 20.234919],
              [75.680794, 20.232943],
              [75.681577, 20.229222],
              [75.680059, 20.219716],
              [75.680176, 20.215008],
              [75.684145, 20.2043],
              [75.683937, 20.201484],
              [75.679211, 20.191023],
              [75.676929, 20.188986],
              [75.67445, 20.188218],
              [75.648715, 20.19133],
              [75.647644, 20.18499],
              [75.644726, 20.17628],
              [75.643235, 20.164482],
              [75.643418, 20.15965],
              [75.639581, 20.146108],
              [75.638708, 20.142362],
              [75.636159, 20.137624],
              [75.635316, 20.131985],
              [75.63578, 20.128028],
              [75.629512, 20.109393],
              [75.627162, 20.105375],
              [75.620832, 20.103724],
              [75.606993, 20.103609],
              [75.589375, 20.10196],
              [75.589202, 20.084128],
              [75.589548, 20.078512],
              [75.591766, 20.068275],
              [75.594276, 20.061271],
              [75.596536, 20.060834],
              [75.600285, 20.062476],
              [75.603309, 20.056091],
              [75.606327, 20.054297],
              [75.60738, 20.051785],
              [75.60295, 20.046912],
              [75.593465, 20.028138],
              [75.593688, 20.023317],
              [75.595484, 20.020782],
              [75.59872, 20.01827],
              [75.601104, 20.014067],
              [75.601378, 20.008578],
              [75.604972, 20.005861],
              [75.613194, 20.004503],
              [75.638539, 20.003783],
              [75.638006, 20.002914],
              [75.630007, 20.000604],
              [75.636334, 19.9947],
              [75.633981, 19.982861],
              [75.637902, 19.969024],
              [75.64079, 19.960518],
              [75.637382, 19.955083],
              [75.640938, 19.955161],
              [75.650822, 19.951112],
              [75.668014, 19.939727],
              [75.666574, 19.926833],
              [75.667628, 19.920429],
              [75.66241, 19.91602],
              [75.653666, 19.91046],
              [75.65009, 19.877152],
              [75.647505, 19.873877],
              [75.650261, 19.870728],
              [75.647228, 19.850297],
              [75.647622, 19.835311],
              [75.652346, 19.824704],
              [75.652602, 19.815065],
              [75.636641, 19.813621],
              [75.64142, 19.800872],
              [75.645197, 19.792389],
              [75.645388, 19.78489],
              [75.636571, 19.782536],
              [75.638518, 19.776153],
              [75.62786, 19.775907],
              [75.628062, 19.752562],
              [75.628047, 19.751698],
              [75.627918, 19.745861],
              [75.630214, 19.745342],
              [75.629786, 19.737663],
              [75.636263, 19.734445],
              [75.633018, 19.704349],
              [75.630045, 19.701316],
              [75.635776, 19.678724],
              [75.633512, 19.655385],
              [75.610384, 19.656196],
              [75.607164, 19.641352],
              [75.600375, 19.640609],
              [75.590939, 19.637627],
              [75.592372, 19.628969],
              [75.595395, 19.619396],
              [75.599928, 19.610102],
              [75.598658, 19.606838],
              [75.600827, 19.602249],
              [75.613896, 19.602132],
              [75.616013, 19.598056],
              [75.651898, 19.59483],
              [75.653348, 19.592078],
              [75.653281, 19.588177],
              [75.654545, 19.585481],
              [75.65514, 19.57665],
              [75.657128, 19.566674],
              [75.655719, 19.554457],
              [75.650865, 19.54512],
              [75.64395, 19.528206],
              [75.644115, 19.511689],
              [75.645306, 19.498729],
              [75.64281, 19.486182],
              [75.636086, 19.470187],
              [75.6348, 19.464397],
              [75.632079, 19.460501],
              [75.629656, 19.460673],
              [75.623919, 19.463883],
              [75.619388, 19.467844],
              [75.614904, 19.456553],
              [75.611335, 19.453337],
              [75.609615, 19.430351],
              [75.612391, 19.428053],
              [75.618435, 19.424891],
              [75.617568, 19.408726],
              [75.61587, 19.399891],
              [75.609871, 19.381439],
              [75.601345, 19.383048],
              [75.588103, 19.37835],
              [75.575959, 19.380876],
              [75.572028, 19.379612],
              [75.528762, 19.398943],
              [75.52303, 19.400658],
              [75.519522, 19.403238],
              [75.517836, 19.40846],
              [75.517716, 19.415507],
              [75.511974, 19.42021],
              [75.508347, 19.424218],
              [75.509197, 19.428466],
              [75.506534, 19.430814],
              [75.500968, 19.430468],
              [75.491907, 19.439985],
              [75.487069, 19.439588],
              [75.480298, 19.431557],
              [75.477456, 19.424849],
              [75.479144, 19.421062],
              [75.477992, 19.421408],
              [75.474972, 19.414984],
              [75.472853, 19.41412],
              [75.468805, 19.413087],
              [75.462095, 19.41475],
              [75.456958, 19.413768],
              [75.452849, 19.411767],
              [75.448918, 19.413083],
              [75.447409, 19.41835],
              [75.447527, 19.426841],
              [75.444087, 19.427415],
              [75.439978, 19.421102],
              [75.430236, 19.415989],
              [75.422437, 19.415756],
              [75.415002, 19.41753],
              [75.411437, 19.417475],
              [75.407929, 19.4173],
              [75.404059, 19.414775],
              [75.395837, 19.414646],
              [75.391069, 19.409947],
              [75.384293, 19.410171],
              [75.381941, 19.408733],
              [75.380548, 19.406381],
              [75.377283, 19.403403],
              [75.366167, 19.39737],
              [75.343075, 19.405715],
              [75.344154, 19.408926],
              [75.350258, 19.415415],
              [75.354431, 19.423272],
              [75.356782, 19.429988],
              [75.356955, 19.437609],
              [75.356052, 19.441165],
              [75.35278, 19.44535],
              [75.349332, 19.447806],
              [75.345347, 19.446082],
              [75.334533, 19.437469],
              [75.332046, 19.436952],
              [75.328177, 19.441479],
              [75.324722, 19.453974],
              [75.326346, 19.463152],
              [75.341409, 19.463453],
              [75.345512, 19.473319],
              [75.349804, 19.481006],
              [75.361529, 19.479589],
              [75.363044, 19.485204],
              [75.361102, 19.492656],
              [75.355955, 19.50062],
              [75.349004, 19.497237],
              [75.342651, 19.496658],
              [75.338067, 19.478531],
              [75.330509, 19.479212],
              [75.332911, 19.502954],
              [75.32795, 19.503457],
              [75.328502, 19.496694],
              [75.326806, 19.494118],
              [75.321967, 19.493366],
              [75.314476, 19.49404],
              [75.312896, 19.498861],
              [75.305875, 19.500569],
              [75.305807, 19.507739],
              [75.296857, 19.508641],
              [75.276832, 19.512859],
              [75.284618, 19.535457],
              [75.284493, 19.540214],
              [75.283151, 19.546298],
              [75.281338, 19.548984],
              [75.278793, 19.550534],
              [75.274558, 19.551445],
              [75.270925, 19.550923],
              [75.268933, 19.548109],
              [75.265991, 19.529297],
              [75.263692, 19.523729],
              [75.261701, 19.522471],
              [75.257591, 19.523326],
              [75.251228, 19.530246],
              [75.247293, 19.532882],
              [75.240207, 19.53677],
              [75.231553, 19.539852],
              [75.228952, 19.54197],
              [75.226402, 19.545753],
              [75.220278, 19.552694],
              [75.212785, 19.55695],
              [75.206782, 19.561826],
              [75.205146, 19.564234],
              [75.20852, 19.571747],
              [75.206514, 19.578342],
              [75.203913, 19.577991],
              [75.194451, 19.593223],
              [75.188027, 19.595853],
              [75.179677, 19.596692],
              [75.172057, 19.596102],
              [75.166555, 19.594775],
              [75.162497, 19.593447],
              [75.158326, 19.588509],
              [75.155371, 19.587472],
              [75.152703, 19.588957],
              [75.146398, 19.594904],
              [75.142886, 19.595469],
              [75.133269, 19.59207],
              [75.130126, 19.592009],
              [75.117277, 19.602524],
              [75.113941, 19.603032],
              [75.105653, 19.600947],
              [75.099231, 19.604658],
              [75.095831, 19.608613],
              [75.092322, 19.60946],
              [75.074116, 19.606204],
              [75.069884, 19.605105],
              [75.067337, 19.603265],
              [75.061773, 19.603365],
              [75.057894, 19.605879],
              [75.044695, 19.610486],
              [75.043412, 19.612946],
              [75.042919, 19.616621],
              [75.043572, 19.62046],
              [75.041821, 19.622235],
              [75.038056, 19.624056],
              [75.035034, 19.623933],
              [75.02826, 19.621628],
              [75.022692, 19.62121],
              [75.010825, 19.623126],
              [75.000034, 19.621753],
              [74.983868, 19.638008],
              [74.970085, 19.646419],
              [74.966505, 19.647113],
              [74.949067, 19.646334],
              [74.943687, 19.644514],
              [74.941882, 19.641559],
              [74.938196, 19.640372],
              [74.934783, 19.643761],
              [74.932156, 19.648086],
              [74.927422, 19.649444],
              [74.916997, 19.649582],
              [74.90914, 19.646493],
              [74.906005, 19.644485],
              [74.902436, 19.643671],
              [74.898616, 19.643894],
              [74.89145, 19.645916],
              [74.889793, 19.649847],
              [74.890373, 19.655735],
              [74.888614, 19.656295],
              [74.878084, 19.652754],
              [74.875053, 19.654228],
              [74.864858, 19.64856],
              [74.864228, 19.648529],
              [74.852957, 19.647933],
              [74.848584, 19.650371],
              [74.846207, 19.652659],
              [74.843093, 19.656603],
              [74.842598, 19.660038],
              [74.83699, 19.665516],
              [74.831579, 19.667895],
              [74.830618, 19.666634],
              [74.824824, 19.672335],
              [74.817263, 19.669707],
              [74.811183, 19.663066],
              [74.803942, 19.659404],
              [74.799959, 19.65507],
              [74.788847, 19.649547],
              [74.780531, 19.652307],
              [74.782397, 19.66501],
              [74.782171, 19.671725],
              [74.788129, 19.687617],
              [74.790064, 19.689753],
              [74.801303, 19.694245],
              [74.803708, 19.697184],
              [74.806649, 19.703003],
              [74.787474, 19.716611],
              [74.781242, 19.715075],
              [74.781187, 19.713756],
              [74.775226, 19.707056],
              [74.767272, 19.699998],
              [74.762381, 19.696348],
              [74.751269, 19.690763],
              [74.748289, 19.692182],
              [74.746265, 19.695616],
              [74.729945, 19.699181],
              [74.732392, 19.71436],
              [74.729903, 19.723467],
              [74.725381, 19.720688],
              [74.722831, 19.720784],
              [74.720867, 19.724902],
              [74.718071, 19.72575],
              [74.710776, 19.720533],
              [74.706644, 19.721822],
              [74.70583, 19.725894],
              [74.71023, 19.729653],
              [74.712332, 19.732773],
              [74.716442, 19.734926],
              [74.719355, 19.742411],
              [74.722548, 19.746965],
              [74.723721, 19.752542],
              [74.721525, 19.755002],
              [74.721417, 19.762348],
              [74.722468, 19.76781],
              [74.720109, 19.777209],
              [74.713036, 19.782273],
              [74.70393, 19.775321],
              [74.703099, 19.772216],
              [74.707265, 19.765702],
              [74.70747, 19.76231],
              [74.70512, 19.760343],
              [74.695364, 19.759414],
              [74.693353, 19.761009],
              [74.69191, 19.768518],
              [74.684264, 19.76899],
              [74.673765, 19.770755],
              [74.667468, 19.778173],
              [74.656487, 19.778441],
              [74.653752, 19.780083],
              [74.650138, 19.785342],
              [74.645862, 19.789565],
              [74.63613, 19.79432],
              [74.63407, 19.793961],
              [74.627665, 19.789493],
              [74.623999, 19.78585],
              [74.620823, 19.780714],
              [74.619766, 19.776458],
              [74.615485, 19.772289],
              [74.608643, 19.771039],
              [74.601973, 19.771618],
              [74.597832, 19.773021],
              [74.593383, 19.77649],
              [74.591657, 19.779698],
              [74.59197, 19.786993],
              [74.601452, 19.801644],
              [74.604273, 19.821595],
              [74.606685, 19.849635],
              [74.6328, 19.845059],
              [74.635122, 19.843694],
              [74.64472, 19.840892],
              [74.660867, 19.839049],
              [74.663329, 19.861116],
              [74.648099, 19.861239],
              [74.647107, 19.873237],
              [74.649993, 19.886344],
              [74.649161, 19.909826],
              [74.6531, 19.91939],
              [74.655994, 19.922163],
              [74.681951, 19.924934],
              [74.682017, 19.932225],
              [74.673927, 19.935095],
              [74.673327, 19.946696],
              [74.675196, 19.963125],
              [74.677371, 19.964805],
              [74.682088, 19.966675],
              [74.68562, 19.966351],
              [74.687432, 19.967572],
              [74.689523, 19.971487],
              [74.688582, 19.976769],
              [74.686106, 19.983356],
              [74.685279, 19.989206],
              [74.692947, 19.996375],
              [74.690914, 20.000573],
              [74.691903, 20.006336],
              [74.70093, 20.018228],
              [74.713443, 20.016624],
              [74.718081, 20.017264],
              [74.720227, 20.021141],
              [74.718012, 20.026547],
              [74.71316, 20.032264],
              [74.710336, 20.040262],
              [74.722935, 20.054759],
              [74.714982, 20.069105],
              [74.710848, 20.078375],
              [74.729287, 20.079688],
              [74.738254, 20.082298],
              [74.730464, 20.111428],
              [74.706985, 20.113144],
              [74.705296, 20.114588],
              [74.708012, 20.117493],
              [74.709522, 20.121773],
              [74.707414, 20.124311],
              [74.708603, 20.127168],
              [74.710999, 20.128757],
              [74.710565, 20.133688],
              [74.71546, 20.135069],
              [74.718784, 20.160148],
              [74.717727, 20.163595],
              [74.715269, 20.167517],
              [74.71763, 20.178899],
              [74.723364, 20.186515],
              [74.723086, 20.188922],
              [74.724014, 20.190339],
              [74.730705, 20.189939],
              [74.738491, 20.194673],
              [74.739319, 20.193065],
              [74.73886, 20.189166],
              [74.741679, 20.185936],
              [74.756314, 20.183047],
              [74.764109, 20.182792],
              [74.758841, 20.196427],
              [74.759972, 20.199509],
              [74.766698, 20.202937],
              [74.776106, 20.205309],
              [74.780726, 20.204804],
              [74.78236, 20.203808],
              [74.784369, 20.203959],
              [74.790384, 20.20832],
              [74.8041, 20.231094],
              [74.789854, 20.226022],
              [74.784669, 20.225386],
              [74.783869, 20.230438],
              [74.803402, 20.234255],
              [74.809434, 20.23958],
              [74.816421, 20.244206],
              [74.819656, 20.244114],
              [74.823231, 20.242757],
              [74.828834, 20.243045],
              [74.831875, 20.24238],
              [74.832384, 20.239626],
              [74.830426, 20.233576],
              [74.836376, 20.231966],
              [74.844041, 20.231421],
              [74.853764, 20.229662],
              [74.858602, 20.227094],
              [74.85333, 20.208522],
              [74.856665, 20.202534],
              [74.855889, 20.193384],
              [74.856475, 20.186675],
              [74.856114, 20.177056],
              [74.86945, 20.177612],
              [74.899052, 20.176797],
              [74.898165, 20.169483],
              [74.901599, 20.166894],
              [74.906685, 20.165665],
              [74.910907, 20.152648],
              [74.923882, 20.153568],
              [74.930507, 20.15252],
              [74.930677, 20.157562],
              [74.928836, 20.161008],
              [74.925344, 20.163799],
              [74.928442, 20.168612],
              [74.924454, 20.170661],
              [74.926871, 20.177992],
              [74.932144, 20.181305],
              [74.931417, 20.213691],
              [74.911112, 20.215727],
              [74.90839, 20.24335],
              [74.927566, 20.244813],
              [74.934217, 20.246658],
              [74.935473, 20.252008],
              [74.935768, 20.257492],
              [74.934923, 20.269694],
              [74.943465, 20.270504],
              [74.948992, 20.273168],
              [74.944383, 20.279863],
              [74.953623, 20.28979],
              [74.971015, 20.304068],
              [74.987469, 20.302375],
              [74.985386, 20.317402],
              [74.988932, 20.3303],
              [74.991922, 20.333728],
              [74.995391, 20.335896],
              [75.000025, 20.336852],
              [75.012597, 20.329799],
              [75.024885, 20.323084],
              [75.033305, 20.316416],
              [75.048254, 20.307706],
              [75.056509, 20.307308],
              [75.057389, 20.313809],
              [75.056229, 20.322363],
              [75.057398, 20.329681],
              [75.059456, 20.334011],
              [75.062591, 20.335095],
              [75.069327, 20.335067],
              [75.075012, 20.335894],
              [75.092334, 20.334633],
              [75.097192, 20.338834],
              [75.099616, 20.343063],
              [75.104384, 20.345252],
              [75.111091, 20.347478],
              [75.122691, 20.347569],
              [75.125456, 20.349392],
              [75.126432, 20.357333],
              [75.122524, 20.375095],
              [75.118469, 20.386074],
              [75.11635, 20.394207],
              [75.113769, 20.396124],
              [75.108078, 20.407027],
              [75.108432, 20.411859],
              [75.114333, 20.41481],
              [75.117444, 20.41847],
              [75.121118, 20.424669],
              [75.124949, 20.424606],
              [75.125852, 20.429038],
              [75.129466, 20.431507],
              [75.134873, 20.431581],
              [75.141025, 20.434588],
              [75.148759, 20.433489],
              [75.155435, 20.433979],
              [75.161473, 20.436585],
              [75.162772, 20.442638],
              [75.16146, 20.449519],
              [75.162053, 20.454868],
              [75.162669, 20.475148],
              [75.16345, 20.475967],
              [75.167933, 20.476715],
              [75.17286, 20.47649],
              [75.178927, 20.477606],
              [75.182609, 20.47558],
              [75.18913, 20.474121],
              [75.201321, 20.476286],
              [75.200583, 20.480764],
              [75.200821, 20.48525],
              [75.202175, 20.491819],
              [75.203323, 20.492286],
              [75.210095, 20.491342],
              [75.213049, 20.492821],
              [75.211691, 20.498319],
              [75.221084, 20.496195],
              [75.225622, 20.493446],
              [75.230014, 20.492347],
              [75.23116, 20.493053],
              [75.228241, 20.501059],
              [75.226672, 20.50863],
              [75.227374, 20.514433],
              [75.228501, 20.51664],
              [75.23168, 20.51984],
              [75.237964, 20.521984],
              [75.239555, 20.521605],
              [75.243081, 20.533715],
              [75.242634, 20.539052],
              [75.24367, 20.539236],
              [75.247389, 20.542794],
              [75.246881, 20.548588],
              [75.244958, 20.551596],
              [75.252193, 20.555209],
              [75.254829, 20.570068],
              [75.259992, 20.578919],
              [75.2668, 20.571133],
              [75.274555, 20.56917],
              [75.285516, 20.568384],
              [75.292924, 20.569167],
              [75.295826, 20.570181],
              [75.298015, 20.574865],
              [75.300661, 20.576448],
              [75.307216, 20.577735],
              [75.312016, 20.577738],
              [75.318063, 20.576664],
              [75.317908, 20.586952],
              [75.321313, 20.591532],
              [75.32879, 20.592196],
              [75.343423, 20.589729],
              [75.350654, 20.590225],
              [75.353093, 20.58956],
              [75.358909, 20.591355],
              [75.362544, 20.596865],
              [75.362223, 20.594099],
              [75.364047, 20.58952],
              [75.365051, 20.583508],
              [75.37025, 20.576906],
              [75.372698, 20.575441],
              [75.386094, 20.579506],
              [75.391261, 20.579633],
              [75.394131, 20.574437],
              [75.395586, 20.566235],
              [75.395864, 20.532975],
              [75.397323, 20.524083],
              [75.406718, 20.522067],
              [75.412661, 20.523407],
              [75.41967, 20.51786],
              [75.425049, 20.515391],
              [75.434202, 20.51326],
              [75.434277, 20.516708],
              [75.432414, 20.519616],
              [75.430382, 20.525511],
              [75.427233, 20.529093],
              [75.428531, 20.532096],
              [75.430584, 20.533042],
              [75.435569, 20.533215],
              [75.439214, 20.538023],
              [75.450985, 20.540288],
              [75.451864, 20.529042],
              [75.458614, 20.516016],
              [75.462584, 20.518943],
              [75.463523, 20.521709],
              [75.463384, 20.52728],
              [75.461371, 20.536795],
              [75.460909, 20.552931],
              [75.464434, 20.552975],
              [75.46826, 20.548935],
              [75.468991, 20.54441],
              [75.473329, 20.542675],
              [75.484704, 20.543098],
              [75.487168, 20.540085],
              [75.489727, 20.530971],
              [75.49567, 20.527769],
              [75.497799, 20.532162],
              [75.497996, 20.540087],
              [75.498813, 20.542571],
              [75.502678, 20.544911],
              [75.505407, 20.545233],
              [75.506296, 20.547481],
              [75.506368, 20.550761],
              [75.508637, 20.554349],
              [75.513798, 20.554573],
              [75.518617, 20.558538],
              [75.526196, 20.560688],
              [75.526108, 20.567073],
              [75.525091, 20.570279],
              [75.525501, 20.576309],
              [75.522518, 20.590357],
              [75.525734, 20.595164],
              [75.533631, 20.596454],
              [75.536741, 20.609651],
              [75.541427, 20.610619],
              [75.543827, 20.608917],
              [75.55562, 20.604281],
              [75.557558, 20.605275],
              [75.557605, 20.611308],
              [75.558909, 20.613444],
              [75.564949, 20.61271],
              [75.571177, 20.610539],
              [75.572727, 20.608837],
              [75.578174, 20.605793],
              [75.581874, 20.60692],
              [75.585506, 20.603576],
              [75.590323, 20.602651],
              [75.605081, 20.60482],
              [75.611568, 20.606956],
              [75.614941, 20.609227],
              [75.610911, 20.615158],
              [75.608938, 20.621971],
              [75.614994, 20.624153],
              [75.624838, 20.625237],
              [75.63324, 20.619701],
              [75.648335, 20.620031],
              [75.652797, 20.623231],
              [75.654339, 20.626343],
              [75.659998, 20.626638],
              [75.66234, 20.628551],
              [75.662747, 20.63539],
              [75.660596, 20.642139],
              [75.662531, 20.643428],
              [75.66058, 20.653509],
              [75.656266, 20.652489],
              [75.65798, 20.66186],
              [75.660608, 20.666021],
              [75.666701, 20.669925],
              [75.669433, 20.670473],
              [75.674739, 20.669373],
              [75.689786, 20.668323],
              [75.700973, 20.664522],
              [75.705877, 20.661535],
              [75.703062, 20.652844],
              [75.702365, 20.645313],
              [75.699551, 20.631283],
              [75.700085, 20.622505],
              [75.703118, 20.617718],
              [75.706496, 20.615337],
              [75.72438, 20.620516],
              [75.731019, 20.610419],
              [75.733392, 20.610096],
              [75.751335, 20.615899],
              [75.75871, 20.614193],
              [75.760199, 20.601236],
              [75.759035, 20.586533],
              [75.759783, 20.579946],
              [75.766854, 20.578409],
              [75.772318, 20.579263],
              [75.785135, 20.586783],
              [75.789699, 20.586594],
              [75.791325, 20.57732],
              [75.788024, 20.568104],
              [75.789208, 20.565366],
              [75.805699, 20.569917],
              [75.81102, 20.568405],
              [75.817256, 20.564835],
              [75.820579, 20.561694],
              [75.826485, 20.560796],
              [75.838013, 20.563666],
              [75.845932, 20.56761],
              [75.849067, 20.569986],
              [75.837603, 20.573076],
              [75.829618, 20.574348],
              [75.834481, 20.580559],
              [75.833943, 20.595283],
              [75.845376, 20.595589],
              [75.840728, 20.603021],
              [75.839446, 20.609173],
              [75.840756, 20.616544],
              [75.843357, 20.618454],
              [75.855889, 20.618298],
              [75.856067, 20.624806],
              [75.86916, 20.623565],
              [75.871777, 20.600824],
              [75.887396, 20.596833],
              [75.888942, 20.577557],
              [75.888683, 20.568101],
              [75.889526, 20.563359],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 30,
        censuscode: 515,
        dt_cen_cd: 19,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Aurangabad",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [75.609871, 19.381439],
              [75.611659, 19.382124],
              [75.615285, 19.378445],
              [75.62217, 19.37385],
              [75.628817, 19.374466],
              [75.641584, 19.380991],
              [75.650326, 19.368696],
              [75.655706, 19.365754],
              [75.674021, 19.366694],
              [75.676488, 19.364278],
              [75.678597, 19.35819],
              [75.681499, 19.356237],
              [75.688023, 19.355301],
              [75.701199, 19.360199],
              [75.704765, 19.358292],
              [75.712562, 19.357298],
              [75.739518, 19.358191],
              [75.7513, 19.35728],
              [75.754441, 19.358654],
              [75.758754, 19.368572],
              [75.762019, 19.371651],
              [75.761738, 19.38119],
              [75.758126, 19.389295],
              [75.765872, 19.393518],
              [75.771984, 19.395217],
              [75.783646, 19.396783],
              [75.796521, 19.396624],
              [75.811317, 19.388221],
              [75.817465, 19.383476],
              [75.835999, 19.371717],
              [75.839684, 19.370603],
              [75.852258, 19.371851],
              [75.867612, 19.375214],
              [75.873796, 19.380656],
              [75.881829, 19.38061],
              [75.887269, 19.378388],
              [75.894701, 19.380655],
              [75.899489, 19.385062],
              [75.904158, 19.387635],
              [75.909958, 19.389214],
              [75.917995, 19.387798],
              [75.921797, 19.384101],
              [75.922917, 19.376278],
              [75.922186, 19.373637],
              [75.915397, 19.365084],
              [75.916349, 19.361796],
              [75.909494, 19.351523],
              [75.90645, 19.343124],
              [75.90479, 19.33024],
              [75.907117, 19.319132],
              [75.920419, 19.300694],
              [75.933683, 19.293619],
              [75.938212, 19.292406],
              [75.946032, 19.293093],
              [75.954973, 19.294268],
              [75.970855, 19.299316],
              [75.983405, 19.312133],
              [76.000023, 19.323322],
              [76.012715, 19.336347],
              [76.01583, 19.338356],
              [76.019427, 19.339385],
              [76.023401, 19.338855],
              [76.025246, 19.336814],
              [76.024987, 19.332806],
              [76.023153, 19.328825],
              [76.022741, 19.326087],
              [76.025126, 19.321064],
              [76.026527, 19.312001],
              [76.026876, 19.301151],
              [76.028059, 19.297016],
              [76.031554, 19.289841],
              [76.039281, 19.285906],
              [76.050676, 19.283945],
              [76.054492, 19.284743],
              [76.065407, 19.28289],
              [76.072487, 19.280177],
              [76.077255, 19.279402],
              [76.083547, 19.279635],
              [76.091793, 19.284237],
              [76.095546, 19.293973],
              [76.095686, 19.298042],
              [76.098278, 19.306886],
              [76.101318, 19.308147],
              [76.107647, 19.306717],
              [76.112014, 19.301169],
              [76.115799, 19.29636],
              [76.117552, 19.296558],
              [76.121631, 19.301352],
              [76.125195, 19.303928],
              [76.12803, 19.303536],
              [76.129348, 19.300187],
              [76.134739, 19.294297],
              [76.137961, 19.292118],
              [76.142168, 19.290666],
              [76.152904, 19.29552],
              [76.158263, 19.297202],
              [76.159732, 19.295219],
              [76.161271, 19.28745],
              [76.163545, 19.283053],
              [76.167034, 19.282078],
              [76.172076, 19.283241],
              [76.179849, 19.288097],
              [76.185132, 19.28903],
              [76.195354, 19.286378],
              [76.19901, 19.284646],
              [76.209015, 19.277714],
              [76.209269, 19.277538],
              [76.209814, 19.27461],
              [76.214836, 19.262757],
              [76.215193, 19.260265],
              [76.215264, 19.259769],
              [76.228165, 19.255269],
              [76.22847, 19.255163],
              [76.228686, 19.25086],
              [76.225064, 19.244847],
              [76.22514, 19.243138],
              [76.22515, 19.242893],
              [76.226509, 19.241439],
              [76.242664, 19.242224],
              [76.25137, 19.239592],
              [76.255922, 19.239962],
              [76.258813, 19.242492],
              [76.264183, 19.251099],
              [76.269115, 19.255885],
              [76.280282, 19.260883],
              [76.29143, 19.262278],
              [76.2974, 19.261185],
              [76.300384, 19.259525],
              [76.307486, 19.261103],
              [76.312442, 19.260898],
              [76.332351, 19.249677],
              [76.339544, 19.250052],
              [76.346852, 19.249339],
              [76.357059, 19.243174],
              [76.363473, 19.237122],
              [76.363519, 19.237079],
              [76.365149, 19.233952],
              [76.366271, 19.223894],
              [76.364611, 19.21114],
              [76.359157, 19.201449],
              [76.352688, 19.192683],
              [76.353076, 19.188664],
              [76.353082, 19.188601],
              [76.356921, 19.182379],
              [76.357237, 19.181867],
              [76.358105, 19.176864],
              [76.354818, 19.166953],
              [76.356638, 19.16186],
              [76.356759, 19.161522],
              [76.360956, 19.15651],
              [76.361302, 19.156097],
              [76.360916, 19.15215],
              [76.359407, 19.149603],
              [76.353095, 19.145025],
              [76.336451, 19.138004],
              [76.334106, 19.13559],
              [76.329849, 19.122195],
              [76.323308, 19.118885],
              [76.320978, 19.114109],
              [76.324413, 19.107584],
              [76.324701, 19.107037],
              [76.327786, 19.10406],
              [76.337311, 19.100316],
              [76.343036, 19.099572],
              [76.350005, 19.100701],
              [76.355231, 19.1026],
              [76.360334, 19.109731],
              [76.362236, 19.114167],
              [76.368416, 19.12374],
              [76.372557, 19.128013],
              [76.3783, 19.131051],
              [76.383811, 19.129165],
              [76.387001, 19.125721],
              [76.390383, 19.123372],
              [76.390576, 19.123239],
              [76.392893, 19.115516],
              [76.394025, 19.112273],
              [76.394144, 19.111932],
              [76.39698, 19.108603],
              [76.400191, 19.106245],
              [76.411796, 19.092486],
              [76.419627, 19.091468],
              [76.424625, 19.096589],
              [76.429458, 19.099133],
              [76.432641, 19.09861],
              [76.437117, 19.095721],
              [76.437229, 19.095649],
              [76.438495, 19.092637],
              [76.439126, 19.088159],
              [76.438681, 19.084211],
              [76.435943, 19.074745],
              [76.435817, 19.071477],
              [76.43751, 19.066478],
              [76.437636, 19.066107],
              [76.451287, 19.051581],
              [76.451807, 19.051028],
              [76.44774, 19.050306],
              [76.441219, 19.044477],
              [76.441446, 19.040855],
              [76.442107, 19.038456],
              [76.442175, 19.038209],
              [76.444229, 19.035529],
              [76.447065, 19.035186],
              [76.448991, 19.033713],
              [76.449378, 19.033416],
              [76.448027, 19.026852],
              [76.449385, 19.023843],
              [76.449645, 19.023266],
              [76.453861, 19.02266],
              [76.45577, 19.02022],
              [76.456095, 19.019805],
              [76.456307, 19.008364],
              [76.45632, 19.00764],
              [76.459557, 19.009053],
              [76.459725, 19.009127],
              [76.460168, 19.007293],
              [76.460284, 19.006815],
              [76.463806, 19.005025],
              [76.474194, 19.002585],
              [76.478634, 19.000808],
              [76.478958, 19.000678],
              [76.479043, 18.990639],
              [76.477417, 18.988878],
              [76.473398, 18.986983],
              [76.473621, 18.983712],
              [76.471121, 18.981791],
              [76.471896, 18.976821],
              [76.471963, 18.976393],
              [76.475409, 18.974299],
              [76.479024, 18.975177],
              [76.479668, 18.974726],
              [76.480018, 18.97448],
              [76.478879, 18.956915],
              [76.478848, 18.956439],
              [76.487681, 18.95371],
              [76.501095, 18.951046],
              [76.501124, 18.95104],
              [76.505508, 18.942512],
              [76.510435, 18.927498],
              [76.510508, 18.927276],
              [76.514506, 18.921554],
              [76.522839, 18.917223],
              [76.529663, 18.91675],
              [76.536865, 18.917247],
              [76.533958, 18.923413],
              [76.535267, 18.932508],
              [76.539645, 18.949425],
              [76.553142, 18.950135],
              [76.566979, 18.94775],
              [76.578664, 18.946939],
              [76.583721, 18.944913],
              [76.583963, 18.944816],
              [76.588702, 18.917599],
              [76.586721, 18.887296],
              [76.584602, 18.882627],
              [76.58795, 18.874632],
              [76.588148, 18.874159],
              [76.592832, 18.870041],
              [76.608823, 18.868026],
              [76.622747, 18.869047],
              [76.622974, 18.869064],
              [76.624324, 18.860912],
              [76.627775, 18.854216],
              [76.628038, 18.853707],
              [76.632398, 18.848447],
              [76.636782, 18.845924],
              [76.643241, 18.846559],
              [76.643585, 18.846592],
              [76.643455, 18.841841],
              [76.648014, 18.822434],
              [76.648141, 18.821895],
              [76.654957, 18.820268],
              [76.667333, 18.81904],
              [76.667371, 18.819036],
              [76.669117, 18.815502],
              [76.669363, 18.815003],
              [76.673184, 18.810825],
              [76.6736, 18.81037],
              [76.670867, 18.806277],
              [76.675921, 18.795384],
              [76.677286, 18.787353],
              [76.677317, 18.787169],
              [76.682399, 18.780223],
              [76.682771, 18.779714],
              [76.675688, 18.767704],
              [76.675939, 18.761632],
              [76.675954, 18.761278],
              [76.681884, 18.756854],
              [76.689464, 18.753389],
              [76.697519, 18.753695],
              [76.702118, 18.756616],
              [76.709559, 18.75252],
              [76.721023, 18.749514],
              [76.727116, 18.749263],
              [76.727261, 18.738479],
              [76.730191, 18.735294],
              [76.730344, 18.729671],
              [76.731495, 18.725653],
              [76.733352, 18.724251],
              [76.735477, 18.719981],
              [76.735624, 18.713734],
              [76.737386, 18.702254],
              [76.736326, 18.699803],
              [76.732461, 18.696349],
              [76.730697, 18.695626],
              [76.720216, 18.699017],
              [76.712618, 18.697387],
              [76.702495, 18.691891],
              [76.698857, 18.6913],
              [76.687725, 18.692352],
              [76.68579, 18.691859],
              [76.681204, 18.684285],
              [76.676701, 18.674886],
              [76.665357, 18.656048],
              [76.684892, 18.646873],
              [76.682033, 18.641234],
              [76.682335, 18.636994],
              [76.679746, 18.634045],
              [76.674215, 18.632385],
              [76.671882, 18.629777],
              [76.673991, 18.62471],
              [76.662744, 18.59171],
              [76.656801, 18.581811],
              [76.647927, 18.583223],
              [76.643475, 18.572155],
              [76.63792, 18.564022],
              [76.633615, 18.551004],
              [76.653054, 18.543905],
              [76.659711, 18.54423],
              [76.674545, 18.553918],
              [76.680191, 18.554992],
              [76.692702, 18.55021],
              [76.697405, 18.549581],
              [76.705594, 18.547194],
              [76.702001, 18.532845],
              [76.699475, 18.500267],
              [76.696693, 18.499606],
              [76.687718, 18.498283],
              [76.683288, 18.493057],
              [76.676005, 18.482366],
              [76.652607, 18.482127],
              [76.652251, 18.486943],
              [76.648566, 18.487212],
              [76.648483, 18.494095],
              [76.649094, 18.503433],
              [76.652836, 18.515309],
              [76.648096, 18.518113],
              [76.643148, 18.519319],
              [76.643358, 18.525156],
              [76.640821, 18.525534],
              [76.631942, 18.513423],
              [76.630172, 18.503755],
              [76.624629, 18.500442],
              [76.618852, 18.493513],
              [76.618064, 18.489169],
              [76.617681, 18.483382],
              [76.619337, 18.480733],
              [76.623557, 18.479823],
              [76.624119, 18.477062],
              [76.630507, 18.475614],
              [76.629805, 18.464335],
              [76.619087, 18.463136],
              [76.609125, 18.455164],
              [76.605181, 18.454635],
              [76.600848, 18.455485],
              [76.593224, 18.459245],
              [76.583381, 18.459986],
              [76.572352, 18.462737],
              [76.569479, 18.464552],
              [76.566623, 18.468135],
              [76.565289, 18.472336],
              [76.566924, 18.47639],
              [76.568982, 18.49041],
              [76.568593, 18.492929],
              [76.557583, 18.496775],
              [76.552267, 18.496669],
              [76.549446, 18.485292],
              [76.548591, 18.475789],
              [76.548586, 18.470914],
              [76.55152, 18.468358],
              [76.549055, 18.465294],
              [76.543241, 18.464437],
              [76.539335, 18.466376],
              [76.53665, 18.468985],
              [76.531985, 18.468463],
              [76.530036, 18.471686],
              [76.52028, 18.469846],
              [76.511388, 18.469196],
              [76.503948, 18.477757],
              [76.500394, 18.479003],
              [76.496688, 18.482361],
              [76.491639, 18.484652],
              [76.486734, 18.48368],
              [76.481443, 18.49044],
              [76.476884, 18.493181],
              [76.471632, 18.493865],
              [76.468278, 18.496308],
              [76.468006, 18.498713],
              [76.465373, 18.505389],
              [76.463294, 18.50845],
              [76.45856, 18.511716],
              [76.453776, 18.524776],
              [76.446927, 18.528401],
              [76.441022, 18.530409],
              [76.439662, 18.541881],
              [76.432558, 18.544192],
              [76.424018, 18.552823],
              [76.412685, 18.550584],
              [76.40575, 18.548312],
              [76.387708, 18.541494],
              [76.384758, 18.542961],
              [76.381375, 18.543511],
              [76.377497, 18.542574],
              [76.373755, 18.543239],
              [76.368282, 18.545418],
              [76.36488, 18.554222],
              [76.362096, 18.558604],
              [76.352128, 18.56444],
              [76.347305, 18.565569],
              [76.342984, 18.563264],
              [76.335605, 18.563109],
              [76.326001, 18.569168],
              [76.321891, 18.569837],
              [76.311511, 18.566894],
              [76.30711, 18.567623],
              [76.299578, 18.57039],
              [76.295449, 18.573985],
              [76.292379, 18.575273],
              [76.289215, 18.574049],
              [76.282328, 18.5748],
              [76.279962, 18.574305],
              [76.278031, 18.569227],
              [76.277061, 18.563955],
              [76.276918, 18.556972],
              [76.268843, 18.561617],
              [76.259374, 18.563756],
              [76.254619, 18.566215],
              [76.254318, 18.576844],
              [76.238999, 18.575303],
              [76.234721, 18.57666],
              [76.221223, 18.575562],
              [76.216506, 18.575937],
              [76.212238, 18.578223],
              [76.202676, 18.577838],
              [76.199321, 18.580158],
              [76.199041, 18.58281],
              [76.187157, 18.585088],
              [76.176873, 18.585519],
              [76.170885, 18.585043],
              [76.166474, 18.58059],
              [76.165824, 18.576734],
              [76.167793, 18.5682],
              [76.167737, 18.563488],
              [76.166135, 18.560964],
              [76.163157, 18.559258],
              [76.158971, 18.558082],
              [76.156364, 18.568639],
              [76.15614, 18.57537],
              [76.153066, 18.582244],
              [76.151383, 18.583125],
              [76.144002, 18.58341],
              [76.128796, 18.586516],
              [76.116204, 18.585116],
              [76.103223, 18.587748],
              [76.098744, 18.587779],
              [76.076357, 18.575938],
              [76.069769, 18.576197],
              [76.058068, 18.573412],
              [76.05173, 18.574727],
              [76.049811, 18.57611],
              [76.046002, 18.581898],
              [76.043225, 18.58803],
              [76.035001, 18.593454],
              [76.033043, 18.597187],
              [76.028245, 18.601813],
              [76.020654, 18.604426],
              [76.010273, 18.606578],
              [76.006518, 18.60547],
              [76.004738, 18.60301],
              [76.006637, 18.593289],
              [76.006104, 18.588392],
              [76.000021, 18.585297],
              [75.99699, 18.587617],
              [75.990646, 18.59038],
              [75.98646, 18.595665],
              [75.98886, 18.601437],
              [75.996612, 18.607088],
              [75.998282, 18.610637],
              [75.998792, 18.613861],
              [75.996747, 18.618709],
              [75.993902, 18.620055],
              [75.971683, 18.614384],
              [75.961474, 18.608373],
              [75.957984, 18.607156],
              [75.952843, 18.607093],
              [75.949806, 18.608446],
              [75.945658, 18.616047],
              [75.944872, 18.619835],
              [75.945975, 18.625491],
              [75.948911, 18.629174],
              [75.949763, 18.634434],
              [75.949439, 18.636901],
              [75.94537, 18.642336],
              [75.941318, 18.645201],
              [75.938625, 18.645981],
              [75.929113, 18.645196],
              [75.920719, 18.647551],
              [75.918465, 18.649469],
              [75.916133, 18.650299],
              [75.903796, 18.650185],
              [75.894388, 18.648191],
              [75.885548, 18.648485],
              [75.883095, 18.649266],
              [75.879058, 18.649034],
              [75.874895, 18.652417],
              [75.871337, 18.652462],
              [75.862764, 18.649884],
              [75.860546, 18.650371],
              [75.858881, 18.651825],
              [75.860185, 18.659491],
              [75.858828, 18.661576],
              [75.852895, 18.659014],
              [75.846404, 18.659158],
              [75.837608, 18.663291],
              [75.835594, 18.665605],
              [75.83181, 18.666173],
              [75.827636, 18.664511],
              [75.825365, 18.67056],
              [75.813702, 18.671228],
              [75.811025, 18.67367],
              [75.801385, 18.67333],
              [75.79889, 18.666035],
              [75.797592, 18.657805],
              [75.796363, 18.655815],
              [75.793301, 18.656662],
              [75.782838, 18.662007],
              [75.781672, 18.668691],
              [75.776371, 18.67284],
              [75.77393, 18.669759],
              [75.76757, 18.67063],
              [75.767837, 18.672928],
              [75.76331, 18.6762],
              [75.752719, 18.680346],
              [75.749336, 18.678715],
              [75.743072, 18.677227],
              [75.738081, 18.676824],
              [75.734666, 18.678121],
              [75.730853, 18.675351],
              [75.72516, 18.676561],
              [75.718155, 18.679569],
              [75.713005, 18.680893],
              [75.708338, 18.682779],
              [75.705979, 18.686426],
              [75.697593, 18.688705],
              [75.690159, 18.690629],
              [75.672848, 18.690404],
              [75.670529, 18.687501],
              [75.670544, 18.683873],
              [75.668958, 18.676467],
              [75.666989, 18.672407],
              [75.666019, 18.666441],
              [75.667356, 18.662623],
              [75.66643, 18.64998],
              [75.66545, 18.648267],
              [75.661831, 18.647387],
              [75.653536, 18.646958],
              [75.647361, 18.648343],
              [75.638055, 18.653786],
              [75.621193, 18.661269],
              [75.614965, 18.668807],
              [75.614522, 18.672436],
              [75.611439, 18.681726],
              [75.608383, 18.686205],
              [75.601652, 18.692527],
              [75.592426, 18.696012],
              [75.587373, 18.697059],
              [75.582996, 18.697275],
              [75.572283, 18.702385],
              [75.569078, 18.701052],
              [75.563368, 18.701748],
              [75.558718, 18.705808],
              [75.553198, 18.71298],
              [75.552351, 18.717967],
              [75.555094, 18.732886],
              [75.558691, 18.737708],
              [75.556864, 18.741],
              [75.551833, 18.743178],
              [75.537725, 18.746779],
              [75.53086, 18.75178],
              [75.526541, 18.753327],
              [75.527937, 18.742593],
              [75.530358, 18.738216],
              [75.530072, 18.734493],
              [75.527747, 18.730744],
              [75.521472, 18.728128],
              [75.518736, 18.725866],
              [75.510708, 18.723208],
              [75.504085, 18.723175],
              [75.496678, 18.728012],
              [75.490373, 18.735358],
              [75.481283, 18.741415],
              [75.478463, 18.742312],
              [75.463712, 18.752958],
              [75.461576, 18.750062],
              [75.45922, 18.748773],
              [75.453382, 18.748837],
              [75.450745, 18.750124],
              [75.448184, 18.75296],
              [75.448409, 18.763957],
              [75.44537, 18.760607],
              [75.444418, 18.774189],
              [75.443263, 18.778675],
              [75.443152, 18.785487],
              [75.440853, 18.791072],
              [75.435518, 18.798976],
              [75.429494, 18.805342],
              [75.42784, 18.808392],
              [75.420432, 18.814033],
              [75.411362, 18.822725],
              [75.398437, 18.830822],
              [75.39552, 18.827595],
              [75.392061, 18.812401],
              [75.391327, 18.804789],
              [75.391643, 18.799748],
              [75.390436, 18.793118],
              [75.391117, 18.788877],
              [75.386482, 18.776265],
              [75.386564, 18.772255],
              [75.38114, 18.771746],
              [75.3822, 18.768412],
              [75.377314, 18.767375],
              [75.37095, 18.776094],
              [75.366653, 18.778951],
              [75.359697, 18.788305],
              [75.351464, 18.78335],
              [75.34681, 18.781679],
              [75.342666, 18.782412],
              [75.340581, 18.785128],
              [75.338188, 18.792536],
              [75.335687, 18.795483],
              [75.332098, 18.798391],
              [75.327278, 18.798154],
              [75.322227, 18.792018],
              [75.308377, 18.777281],
              [75.292658, 18.762382],
              [75.281361, 18.737763],
              [75.276855, 18.732248],
              [75.270937, 18.729332],
              [75.265205, 18.727675],
              [75.254258, 18.720801],
              [75.245025, 18.724558],
              [75.233136, 18.727597],
              [75.227121, 18.727782],
              [75.220591, 18.730302],
              [75.216946, 18.733552],
              [75.214385, 18.737467],
              [75.208798, 18.738441],
              [75.19668, 18.735927],
              [75.174185, 18.735865],
              [75.174037, 18.72624],
              [75.17662, 18.717916],
              [75.175625, 18.706588],
              [75.170475, 18.70263],
              [75.16585, 18.696142],
              [75.168387, 18.689304],
              [75.165454, 18.662134],
              [75.162757, 18.655458],
              [75.159043, 18.649885],
              [75.155723, 18.648996],
              [75.153623, 18.648613],
              [75.149783, 18.649859],
              [75.143668, 18.652948],
              [75.14242, 18.654561],
              [75.140794, 18.661109],
              [75.137761, 18.666527],
              [75.131056, 18.670192],
              [75.123411, 18.684526],
              [75.11093, 18.688427],
              [75.108176, 18.690227],
              [75.10226, 18.703108],
              [75.098135, 18.705725],
              [75.086304, 18.709095],
              [75.077804, 18.714046],
              [75.07374, 18.717695],
              [75.069704, 18.725462],
              [75.065714, 18.730255],
              [75.058862, 18.732202],
              [75.054778, 18.741234],
              [75.051629, 18.746185],
              [75.041987, 18.752458],
              [75.037014, 18.763321],
              [75.025989, 18.76927],
              [75.022441, 18.770499],
              [75.016306, 18.771072],
              [75.009677, 18.777945],
              [75.007576, 18.779224],
              [75.002988, 18.784879],
              [75.002536, 18.788542],
              [75.002971, 18.791116],
              [75.006685, 18.796299],
              [75.009736, 18.802738],
              [75.008548, 18.804408],
              [75.000031, 18.806203],
              [74.994845, 18.799101],
              [74.990891, 18.796479],
              [74.987144, 18.797663],
              [74.979438, 18.80349],
              [74.977114, 18.807302],
              [74.974202, 18.810243],
              [74.971692, 18.814487],
              [74.970419, 18.82143],
              [74.967139, 18.824737],
              [74.959096, 18.821901],
              [74.954934, 18.822118],
              [74.945677, 18.826012],
              [74.942521, 18.828967],
              [74.938842, 18.829518],
              [74.93088, 18.829707],
              [74.923367, 18.828364],
              [74.917198, 18.830927],
              [74.920999, 18.836623],
              [74.922646, 18.847847],
              [74.92171, 18.851874],
              [74.917539, 18.853155],
              [74.913454, 18.850982],
              [74.911724, 18.849235],
              [74.899089, 18.8474],
              [74.898855, 18.85926],
              [74.899675, 18.869152],
              [74.897778, 18.878874],
              [74.888136, 18.885359],
              [74.88639, 18.89114],
              [74.88781, 18.900784],
              [74.88646, 18.909477],
              [74.882165, 18.911466],
              [74.878849, 18.911161],
              [74.873943, 18.907726],
              [74.872526, 18.904212],
              [74.868592, 18.899003],
              [74.863799, 18.902311],
              [74.858175, 18.904409],
              [74.850872, 18.912236],
              [74.850565, 18.918728],
              [74.848579, 18.924459],
              [74.832952, 18.932213],
              [74.828491, 18.938322],
              [74.835804, 18.942802],
              [74.838732, 18.946041],
              [74.83897, 18.952587],
              [74.835471, 18.958594],
              [74.831402, 18.96189],
              [74.827524, 18.963238],
              [74.817449, 18.963733],
              [74.812419, 18.972827],
              [74.813887, 18.977201],
              [74.824422, 18.984688],
              [74.826801, 18.988092],
              [74.837741, 18.97377],
              [74.842855, 18.96829],
              [74.861174, 18.975894],
              [74.869626, 18.980658],
              [74.878296, 18.982961],
              [74.887918, 18.979002],
              [74.899679, 18.979116],
              [74.903264, 18.975631],
              [74.907115, 18.963664],
              [74.917158, 18.960101],
              [74.928641, 18.970594],
              [74.933926, 18.972429],
              [74.939319, 18.976427],
              [74.944872, 18.96931],
              [74.953083, 18.968424],
              [74.95659, 18.972994],
              [74.95746, 18.977953],
              [74.956296, 18.9865],
              [74.960672, 18.996083],
              [74.960023, 19.000125],
              [74.955428, 19.003914],
              [74.949049, 19.005568],
              [74.948967, 19.017429],
              [74.952386, 19.03287],
              [74.946229, 19.035076],
              [74.935623, 19.034753],
              [74.924896, 19.033276],
              [74.916368, 19.03991],
              [74.918723, 19.05256],
              [74.919212, 19.064883],
              [74.921762, 19.087976],
              [74.925531, 19.100273],
              [74.933491, 19.107758],
              [74.936438, 19.116044],
              [74.942457, 19.126268],
              [74.942435, 19.129798],
              [74.946852, 19.12931],
              [74.949146, 19.129106],
              [74.954526, 19.125557],
              [74.957068, 19.123379],
              [74.957919, 19.121203],
              [74.960881, 19.119487],
              [74.976061, 19.112395],
              [74.980606, 19.111111],
              [74.980632, 19.117254],
              [74.983977, 19.115812],
              [74.988528, 19.112369],
              [74.991925, 19.111226],
              [75.000023, 19.111313],
              [75.002879, 19.111458],
              [75.004876, 19.110255],
              [75.010983, 19.104257],
              [75.016955, 19.105081],
              [75.020687, 19.106405],
              [75.023996, 19.111746],
              [75.025622, 19.113183],
              [75.02689, 19.112617],
              [75.027557, 19.111124],
              [75.026363, 19.104761],
              [75.028056, 19.103619],
              [75.033054, 19.107934],
              [75.03679, 19.108055],
              [75.039454, 19.102214],
              [75.045974, 19.101196],
              [75.049762, 19.104077],
              [75.05386, 19.10598],
              [75.05435, 19.103052],
              [75.053513, 19.101101],
              [75.054303, 19.098758],
              [75.06081, 19.098942],
              [75.067976, 19.103781],
              [75.070996, 19.104649],
              [75.074065, 19.103846],
              [75.077804, 19.107303],
              [75.076221, 19.114869],
              [75.079105, 19.119691],
              [75.090921, 19.120692],
              [75.093266, 19.125462],
              [75.095139, 19.125925],
              [75.098518, 19.124724],
              [75.109982, 19.123722],
              [75.111488, 19.1204],
              [75.110363, 19.111449],
              [75.106692, 19.106507],
              [75.10223, 19.103919],
              [75.101201, 19.102309],
              [75.097916, 19.082753],
              [75.098402, 19.081946],
              [75.097086, 19.079367],
              [75.092499, 19.081875],
              [75.083092, 19.081682],
              [75.081043, 19.080356],
              [75.082312, 19.076921],
              [75.085098, 19.073146],
              [75.090111, 19.068793],
              [75.089265, 19.067761],
              [75.076186, 19.066415],
              [75.073661, 19.063998],
              [75.072161, 19.06107],
              [75.07163, 19.057516],
              [75.075733, 19.053112],
              [75.092859, 19.048102],
              [75.100761, 19.044104],
              [75.145179, 19.036066],
              [75.145899, 19.038985],
              [75.147951, 19.040084],
              [75.150783, 19.040094],
              [75.160733, 19.036612],
              [75.168634, 19.035772],
              [75.170704, 19.022817],
              [75.17343, 19.018063],
              [75.176815, 19.014974],
              [75.18135, 19.012683],
              [75.185993, 19.013153],
              [75.206766, 19.020248],
              [75.208949, 19.021395],
              [75.209914, 19.022772],
              [75.208825, 19.03378],
              [75.206324, 19.037332],
              [75.198191, 19.044661],
              [75.189, 19.049973],
              [75.188392, 19.052435],
              [75.197181, 19.065294],
              [75.196448, 19.070977],
              [75.194751, 19.0743],
              [75.195479, 19.077109],
              [75.194927, 19.08112],
              [75.194259, 19.083241],
              [75.190514, 19.088224],
              [75.189847, 19.089939],
              [75.190209, 19.092695],
              [75.193585, 19.095168],
              [75.199141, 19.096379],
              [75.204744, 19.099891],
              [75.20637, 19.102364],
              [75.215952, 19.108456],
              [75.218483, 19.110979],
              [75.222585, 19.110184],
              [75.223319, 19.108526],
              [75.223505, 19.098891],
              [75.225738, 19.097404],
              [75.226757, 19.094823],
              [75.22998, 19.081412],
              [75.228479, 19.077225],
              [75.226588, 19.065695],
              [75.234893, 19.061866],
              [75.240152, 19.061647],
              [75.242435, 19.063314],
              [75.241701, 19.064861],
              [75.242481, 19.066239],
              [75.245264, 19.064923],
              [75.246651, 19.066014],
              [75.260511, 19.070278],
              [75.263596, 19.069655],
              [75.265777, 19.062264],
              [75.268458, 19.055841],
              [75.270556, 19.052921],
              [75.268375, 19.031756],
              [75.263184, 19.026933],
              [75.261249, 19.026644],
              [75.261445, 19.025036],
              [75.263326, 19.021427],
              [75.271182, 19.0157],
              [75.272152, 19.013869],
              [75.270526, 19.003374],
              [75.271198, 19.000546],
              [75.273309, 18.992388],
              [75.278032, 18.987815],
              [75.281807, 18.985375],
              [75.285468, 18.984018],
              [75.289099, 18.979403],
              [75.293131, 18.978216],
              [75.297947, 18.977707],
              [75.314464, 18.978337],
              [75.321475, 18.980489],
              [75.331425, 18.987887],
              [75.339259, 18.988497],
              [75.341745, 18.989611],
              [75.341581, 18.99156],
              [75.345245, 18.997128],
              [75.346174, 19.000618],
              [75.347087, 19.022854],
              [75.330455, 19.032011],
              [75.31755, 19.028782],
              [75.308012, 19.031063],
              [75.287387, 19.032069],
              [75.287699, 19.041641],
              [75.289278, 19.049276],
              [75.294051, 19.062241],
              [75.294182, 19.068552],
              [75.291858, 19.075367],
              [75.283644, 19.078571],
              [75.283743, 19.083161],
              [75.290022, 19.082306],
              [75.29702, 19.084435],
              [75.30816, 19.093283],
              [75.315343, 19.093691],
              [75.320538, 19.093236],
              [75.335642, 19.081159],
              [75.360887, 19.07608],
              [75.364564, 19.076197],
              [75.36559, 19.081015],
              [75.364431, 19.089042],
              [75.364915, 19.099136],
              [75.361955, 19.107736],
              [75.352535, 19.113628],
              [75.351444, 19.120224],
              [75.349575, 19.121998],
              [75.339849, 19.123307],
              [75.334478, 19.129205],
              [75.33152, 19.134826],
              [75.330869, 19.144973],
              [75.332377, 19.150023],
              [75.338236, 19.153181],
              [75.352063, 19.147286],
              [75.354113, 19.143563],
              [75.352772, 19.126361],
              [75.35495, 19.125161],
              [75.359545, 19.12511],
              [75.362206, 19.129982],
              [75.368605, 19.12752],
              [75.373619, 19.127238],
              [75.399476, 19.138669],
              [75.406429, 19.139484],
              [75.41059, 19.133925],
              [75.410047, 19.130252],
              [75.407384, 19.124627],
              [75.405691, 19.123027],
              [75.396508, 19.124336],
              [75.389685, 19.116586],
              [75.389017, 19.112916],
              [75.380128, 19.101214],
              [75.368903, 19.089104],
              [75.370781, 19.08222],
              [75.38207, 19.079941],
              [75.38437, 19.077819],
              [75.393487, 19.077997],
              [75.398917, 19.079213],
              [75.407675, 19.078243],
              [75.410207, 19.07864],
              [75.420968, 19.084156],
              [75.447794, 19.091512],
              [75.44852, 19.085148],
              [75.449966, 19.083254],
              [75.456982, 19.084289],
              [75.47342, 19.093351],
              [75.487259, 19.10362],
              [75.486784, 19.111421],
              [75.484244, 19.11572],
              [75.485274, 19.121576],
              [75.485147, 19.125761],
              [75.453731, 19.125689],
              [75.448775, 19.124772],
              [75.447262, 19.122703],
              [75.436506, 19.115241],
              [75.433846, 19.116445],
              [75.427929, 19.132554],
              [75.427332, 19.136452],
              [75.428471, 19.137486],
              [75.435611, 19.139437],
              [75.451014, 19.140083],
              [75.454459, 19.142029],
              [75.4544, 19.145417],
              [75.448853, 19.170018],
              [75.428327, 19.171148],
              [75.423073, 19.178829],
              [75.405807, 19.189774],
              [75.404544, 19.193605],
              [75.405031, 19.197258],
              [75.405258, 19.198942],
              [75.407677, 19.202497],
              [75.414076, 19.206751],
              [75.417639, 19.2134],
              [75.424456, 19.21862],
              [75.42929, 19.219313],
              [75.445469, 19.216977],
              [75.456516, 19.237625],
              [75.459778, 19.247891],
              [75.464134, 19.252246],
              [75.470232, 19.252653],
              [75.475971, 19.252079],
              [75.479531, 19.256327],
              [75.485875, 19.258387],
              [75.489859, 19.260686],
              [75.492704, 19.259314],
              [75.494936, 19.260395],
              [75.497775, 19.264932],
              [75.517407, 19.27652],
              [75.520366, 19.280758],
              [75.526723, 19.296241],
              [75.528837, 19.298595],
              [75.53482, 19.302202],
              [75.541713, 19.308451],
              [75.544201, 19.325715],
              [75.519303, 19.329667],
              [75.527838, 19.350826],
              [75.535468, 19.374915],
              [75.531474, 19.377379],
              [75.524045, 19.379097],
              [75.517398, 19.383918],
              [75.506093, 19.378469],
              [75.497568, 19.376853],
              [75.492072, 19.377311],
              [75.488862, 19.378973],
              [75.487178, 19.382301],
              [75.487419, 19.386485],
              [75.490876, 19.41241],
              [75.489479, 19.416193],
              [75.486822, 19.414642],
              [75.483555, 19.419454],
              [75.479144, 19.421062],
              [75.477456, 19.424849],
              [75.480298, 19.431557],
              [75.487069, 19.439588],
              [75.491907, 19.439985],
              [75.500968, 19.430468],
              [75.506534, 19.430814],
              [75.509197, 19.428466],
              [75.508347, 19.424218],
              [75.511974, 19.42021],
              [75.517716, 19.415507],
              [75.517836, 19.40846],
              [75.519522, 19.403238],
              [75.52303, 19.400658],
              [75.528762, 19.398943],
              [75.572028, 19.379612],
              [75.575959, 19.380876],
              [75.588103, 19.37835],
              [75.601345, 19.383048],
              [75.609871, 19.381439],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 80,
        censuscode: 523,
        dt_cen_cd: 27,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Bid",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [76.78376, 21.188962],
              [76.775222, 21.188887],
              [76.772178, 21.180918],
              [76.77548, 21.171162],
              [76.777391, 21.156103],
              [76.778774, 21.148968],
              [76.776563, 21.143274],
              [76.782999, 21.133399],
              [76.788246, 21.122514],
              [76.788631, 21.110301],
              [76.781775, 21.093812],
              [76.774318, 21.088867],
              [76.776645, 21.078177],
              [76.783196, 21.072504],
              [76.782612, 21.061444],
              [76.779551, 21.053254],
              [76.77413, 21.052439],
              [76.77103, 21.045804],
              [76.765255, 21.043043],
              [76.765477, 21.03866],
              [76.768638, 21.038291],
              [76.770216, 21.037076],
              [76.771306, 21.03461],
              [76.771266, 21.034122],
              [76.775354, 21.033407],
              [76.777553, 21.032858],
              [76.778331, 21.028308],
              [76.781248, 21.029183],
              [76.782233, 21.032312],
              [76.785172, 21.03235],
              [76.785125, 21.032061],
              [76.789145, 21.031807],
              [76.789411, 21.026843],
              [76.793119, 21.022554],
              [76.792192, 21.016953],
              [76.788635, 21.013163],
              [76.788473, 21.005094],
              [76.789026, 21.003236],
              [76.778315, 21.003121],
              [76.777536, 21.00047],
              [76.776167, 20.99001],
              [76.780589, 20.988506],
              [76.782464, 20.990182],
              [76.784589, 20.977525],
              [76.783798, 20.971273],
              [76.806092, 20.971405],
              [76.807926, 20.957604],
              [76.788273, 20.961903],
              [76.788701, 20.955537],
              [76.786922, 20.941989],
              [76.785905, 20.940205],
              [76.780711, 20.939702],
              [76.779339, 20.936192],
              [76.775771, 20.931798],
              [76.776521, 20.929624],
              [76.779342, 20.928912],
              [76.784656, 20.929125],
              [76.78657, 20.927017],
              [76.785617, 20.92414],
              [76.7881, 20.913328],
              [76.787997, 20.910692],
              [76.785693, 20.908485],
              [76.778801, 20.907914],
              [76.774877, 20.909479],
              [76.774794, 20.911602],
              [76.778325, 20.91296],
              [76.778977, 20.915366],
              [76.773173, 20.922142],
              [76.769313, 20.923601],
              [76.752281, 20.922195],
              [76.746545, 20.927932],
              [76.739038, 20.927005],
              [76.727801, 20.920306],
              [76.724515, 20.919415],
              [76.718783, 20.91845],
              [76.715771, 20.920029],
              [76.705008, 20.921592],
              [76.696828, 20.921577],
              [76.689521, 20.918354],
              [76.688384, 20.91662],
              [76.694703, 20.913695],
              [76.695739, 20.907399],
              [76.70567, 20.909959],
              [76.707146, 20.908078],
              [76.70654, 20.901936],
              [76.713883, 20.900335],
              [76.716398, 20.898702],
              [76.71739, 20.897385],
              [76.717132, 20.892799],
              [76.72111, 20.891338],
              [76.722414, 20.889064],
              [76.722874, 20.885913],
              [76.728432, 20.885558],
              [76.733111, 20.888584],
              [76.743598, 20.890167],
              [76.744544, 20.88685],
              [76.744009, 20.88501],
              [76.746288, 20.876426],
              [76.746268, 20.872294],
              [76.751397, 20.871828],
              [76.7553, 20.86578],
              [76.761456, 20.860443],
              [76.762885, 20.85776],
              [76.7632, 20.855986],
              [76.760907, 20.854073],
              [76.759296, 20.84901],
              [76.754293, 20.848449],
              [76.753532, 20.844657],
              [76.755815, 20.842443],
              [76.751767, 20.838105],
              [76.751265, 20.832712],
              [76.755647, 20.827132],
              [76.755723, 20.825928],
              [76.745973, 20.823939],
              [76.7454, 20.820384],
              [76.746474, 20.80932],
              [76.745287, 20.798297],
              [76.750552, 20.797367],
              [76.76114, 20.793735],
              [76.771086, 20.787281],
              [76.772519, 20.783685],
              [76.772117, 20.774788],
              [76.771347, 20.771457],
              [76.767206, 20.763564],
              [76.764071, 20.759975],
              [76.759586, 20.75655],
              [76.75876, 20.752932],
              [76.755341, 20.74636],
              [76.754947, 20.736094],
              [76.756714, 20.729225],
              [76.760166, 20.72581],
              [76.760438, 20.722893],
              [76.759478, 20.720991],
              [76.756812, 20.71913],
              [76.749329, 20.716824],
              [76.735252, 20.715326],
              [76.734829, 20.701156],
              [76.732151, 20.700612],
              [76.728609, 20.701094],
              [76.726358, 20.700619],
              [76.724487, 20.698768],
              [76.722929, 20.695142],
              [76.722951, 20.693072],
              [76.727184, 20.690699],
              [76.730839, 20.69079],
              [76.737809, 20.689139],
              [76.736949, 20.682934],
              [76.739463, 20.681006],
              [76.738605, 20.674745],
              [76.739789, 20.665344],
              [76.735601, 20.657283],
              [76.760317, 20.65595],
              [76.766162, 20.64986],
              [76.761531, 20.649247],
              [76.758306, 20.647956],
              [76.756134, 20.645533],
              [76.755797, 20.642143],
              [76.7512, 20.6316],
              [76.772219, 20.627377],
              [76.763348, 20.602973],
              [76.775048, 20.603768],
              [76.785718, 20.60334],
              [76.788182, 20.600323],
              [76.790673, 20.595413],
              [76.789422, 20.59167],
              [76.783595, 20.588753],
              [76.778416, 20.588193],
              [76.778429, 20.586639],
              [76.770369, 20.575443],
              [76.78478, 20.571492],
              [76.781268, 20.562461],
              [76.776827, 20.554098],
              [76.775042, 20.543647],
              [76.773486, 20.539442],
              [76.771368, 20.517336],
              [76.770067, 20.512911],
              [76.764857, 20.51005],
              [76.761028, 20.509328],
              [76.757367, 20.5093],
              [76.752957, 20.512357],
              [76.752557, 20.502202],
              [76.750644, 20.497994],
              [76.747927, 20.495792],
              [76.742348, 20.492927],
              [76.737118, 20.491794],
              [76.741717, 20.501702],
              [76.741126, 20.506513],
              [76.739017, 20.51068],
              [76.736191, 20.512725],
              [76.727099, 20.514881],
              [76.716562, 20.513579],
              [76.712227, 20.507868],
              [76.704961, 20.483647],
              [76.705246, 20.479922],
              [76.708986, 20.470833],
              [76.707718, 20.469095],
              [76.69886, 20.472057],
              [76.693925, 20.458475],
              [76.697669, 20.455699],
              [76.714659, 20.437034],
              [76.713125, 20.424574],
              [76.713796, 20.418268],
              [76.720063, 20.418721],
              [76.722606, 20.414449],
              [76.722697, 20.411121],
              [76.727362, 20.40674],
              [76.72766, 20.40147],
              [76.727097, 20.395495],
              [76.725025, 20.389451],
              [76.717317, 20.386456],
              [76.708806, 20.385464],
              [76.706233, 20.373393],
              [76.707008, 20.36869],
              [76.706022, 20.363522],
              [76.699608, 20.353365],
              [76.727935, 20.343869],
              [76.726711, 20.338352],
              [76.731529, 20.337418],
              [76.73387, 20.341337],
              [76.736543, 20.342112],
              [76.743445, 20.338787],
              [76.747049, 20.338132],
              [76.744233, 20.326227],
              [76.75739, 20.324564],
              [76.762227, 20.321625],
              [76.769482, 20.313949],
              [76.769891, 20.322381],
              [76.780627, 20.320006],
              [76.788369, 20.317552],
              [76.792838, 20.315298],
              [76.791182, 20.309259],
              [76.785987, 20.298029],
              [76.788559, 20.290132],
              [76.792124, 20.286024],
              [76.800588, 20.28576],
              [76.80768, 20.288167],
              [76.810309, 20.279528],
              [76.814388, 20.27922],
              [76.819432, 20.280645],
              [76.82172, 20.280403],
              [76.821987, 20.280375],
              [76.826791, 20.273192],
              [76.829773, 20.266956],
              [76.823165, 20.263406],
              [76.823131, 20.261278],
              [76.826929, 20.250869],
              [76.826968, 20.245883],
              [76.82049, 20.234977],
              [76.815009, 20.229828],
              [76.811499, 20.219587],
              [76.79666, 20.219228],
              [76.791678, 20.2123],
              [76.786837, 20.203014],
              [76.782143, 20.203669],
              [76.766588, 20.208405],
              [76.763059, 20.208724],
              [76.750224, 20.208953],
              [76.747224, 20.204735],
              [76.7463, 20.199044],
              [76.747214, 20.192912],
              [76.750137, 20.185022],
              [76.751183, 20.176771],
              [76.749715, 20.171484],
              [76.749514, 20.166261],
              [76.762028, 20.16166],
              [76.758657, 20.130763],
              [76.748876, 20.130104],
              [76.736445, 20.126492],
              [76.71947, 20.127428],
              [76.706268, 20.122436],
              [76.681871, 20.124098],
              [76.670911, 20.126345],
              [76.667251, 20.121156],
              [76.663617, 20.120031],
              [76.660599, 20.117301],
              [76.658791, 20.112859],
              [76.658483, 20.106197],
              [76.660877, 20.097497],
              [76.652131, 20.090074],
              [76.649152, 20.08373],
              [76.647706, 20.0684],
              [76.636821, 20.069387],
              [76.634788, 20.078944],
              [76.63039, 20.082291],
              [76.626252, 20.061997],
              [76.624881, 20.049705],
              [76.662585, 20.047943],
              [76.661104, 20.034155],
              [76.659355, 20.026791],
              [76.659285, 20.018823],
              [76.657978, 20.012558],
              [76.658856, 20.00066],
              [76.645496, 19.981747],
              [76.651059, 19.980597],
              [76.659825, 19.976284],
              [76.660336, 19.97197],
              [76.659406, 19.962933],
              [76.645687, 19.962992],
              [76.641144, 19.960851],
              [76.638049, 19.958448],
              [76.634533, 19.953025],
              [76.63484, 19.945393],
              [76.636149, 19.938486],
              [76.635964, 19.932925],
              [76.635502, 19.928697],
              [76.63345, 19.926497],
              [76.623257, 19.921265],
              [76.612341, 19.921615],
              [76.607987, 19.922736],
              [76.606737, 19.92098],
              [76.611117, 19.916071],
              [76.614923, 19.90705],
              [76.614587, 19.900175],
              [76.611068, 19.897556],
              [76.611764, 19.890436],
              [76.626879, 19.890807],
              [76.63498, 19.897519],
              [76.641401, 19.899562],
              [76.647474, 19.89989],
              [76.654485, 19.898423],
              [76.656582, 19.897063],
              [76.65907, 19.892019],
              [76.65817, 19.886819],
              [76.652661, 19.874097],
              [76.647387, 19.866259],
              [76.646947, 19.865606],
              [76.645775, 19.865968],
              [76.643392, 19.866709],
              [76.633428, 19.866231],
              [76.629482, 19.855137],
              [76.623372, 19.842536],
              [76.610537, 19.838101],
              [76.601299, 19.842999],
              [76.599915, 19.840731],
              [76.591401, 19.84286],
              [76.569059, 19.844463],
              [76.569045, 19.838384],
              [76.549686, 19.844004],
              [76.54368, 19.844014],
              [76.540423, 19.844768],
              [76.533018, 19.850419],
              [76.532974, 19.850789],
              [76.532356, 19.855884],
              [76.530271, 19.860508],
              [76.533625, 19.864282],
              [76.52638, 19.868615],
              [76.519814, 19.870819],
              [76.515436, 19.87612],
              [76.511515, 19.874082],
              [76.500246, 19.883479],
              [76.495317, 19.891041],
              [76.492073, 19.898269],
              [76.49128, 19.903557],
              [76.491138, 19.90838],
              [76.493265, 19.916938],
              [76.490679, 19.918074],
              [76.482753, 19.919041],
              [76.465172, 19.917331],
              [76.451523, 19.920465],
              [76.447643, 19.918141],
              [76.440206, 19.916447],
              [76.417653, 19.917589],
              [76.408217, 19.919719],
              [76.403472, 19.915806],
              [76.399305, 19.908486],
              [76.39414, 19.905495],
              [76.390234, 19.904254],
              [76.387978, 19.906366],
              [76.383501, 19.918659],
              [76.378949, 19.918921],
              [76.373033, 19.923342],
              [76.36816, 19.925668],
              [76.366261, 19.924788],
              [76.366135, 19.921581],
              [76.357601, 19.908106],
              [76.354949, 19.900243],
              [76.354499, 19.896178],
              [76.353119, 19.89369],
              [76.347995, 19.88977],
              [76.345971, 19.891644],
              [76.34396, 19.891337],
              [76.343473, 19.888199],
              [76.339578, 19.881907],
              [76.334616, 19.882638],
              [76.327685, 19.881906],
              [76.32408, 19.880489],
              [76.320489, 19.877401],
              [76.318487, 19.877159],
              [76.31413, 19.874886],
              [76.312153, 19.875902],
              [76.310044, 19.876984],
              [76.308622, 19.878677],
              [76.305145, 19.877651],
              [76.301027, 19.875269],
              [76.29819, 19.869586],
              [76.294748, 19.870686],
              [76.283124, 19.871996],
              [76.262156, 19.873259],
              [76.256575, 19.873303],
              [76.252027, 19.870523],
              [76.248361, 19.869389],
              [76.24099, 19.870787],
              [76.230103, 19.863771],
              [76.214553, 19.8659],
              [76.212166, 19.864683],
              [76.209857, 19.861632],
              [76.198834, 19.862289],
              [76.19693, 19.858259],
              [76.193398, 19.854765],
              [76.187867, 19.850972],
              [76.17461, 19.849331],
              [76.169829, 19.850164],
              [76.151983, 19.855884],
              [76.149545, 19.855182],
              [76.149141, 19.853519],
              [76.14971, 19.845253],
              [76.14011, 19.844462],
              [76.137005, 19.850079],
              [76.135007, 19.856421],
              [76.129309, 19.862828],
              [76.121074, 19.86413],
              [76.120562, 19.859438],
              [76.109541, 19.860272],
              [76.100235, 19.855912],
              [76.096068, 19.866821],
              [76.093723, 19.870986],
              [76.083293, 19.880983],
              [76.081608, 19.884568],
              [76.080856, 19.889911],
              [76.080546, 19.911524],
              [76.063564, 19.915712],
              [76.061372, 19.918155],
              [76.060326, 19.924174],
              [76.058207, 19.93051],
              [76.051556, 19.931939],
              [76.049288, 19.937018],
              [76.05463, 19.940246],
              [76.053314, 19.941584],
              [76.048625, 19.947247],
              [76.04421, 19.945038],
              [76.042556, 19.950463],
              [76.037651, 19.947921],
              [76.028848, 19.948094],
              [76.014014, 19.953228],
              [76.016496, 19.966012],
              [76.016654, 19.973968],
              [76.013504, 19.971725],
              [76.011259, 19.971423],
              [76.005129, 19.971857],
              [76.00003, 19.973428],
              [75.994765, 19.976831],
              [75.990454, 19.975157],
              [75.988338, 19.981069],
              [75.984216, 19.981816],
              [75.974436, 19.984869],
              [75.969651, 19.989505],
              [75.966691, 19.994491],
              [75.967254, 20.00009],
              [75.968185, 20.001211],
              [75.968568, 20.002213],
              [75.976133, 20.000891],
              [75.985837, 20.00281],
              [75.99423, 20.004886],
              [76.000021, 20.013289],
              [76.003671, 20.012654],
              [76.008032, 20.014596],
              [76.009808, 20.018807],
              [76.013055, 20.023041],
              [76.024713, 20.023131],
              [76.024084, 20.03213],
              [76.024776, 20.044707],
              [76.019722, 20.058986],
              [76.02731, 20.060457],
              [76.057318, 20.063764],
              [76.060807, 20.066967],
              [76.068129, 20.069585],
              [76.070626, 20.074093],
              [76.066915, 20.083227],
              [76.061643, 20.087065],
              [76.055468, 20.08555],
              [76.056534, 20.096808],
              [76.057298, 20.098429],
              [76.061857, 20.098832],
              [76.065632, 20.097842],
              [76.071429, 20.100381],
              [76.078468, 20.101332],
              [76.085186, 20.098085],
              [76.089044, 20.100952],
              [76.092149, 20.095932],
              [76.095434, 20.095005],
              [76.097408, 20.097263],
              [76.098929, 20.106864],
              [76.102371, 20.11758],
              [76.101513, 20.123252],
              [76.102344, 20.129118],
              [76.107232, 20.132043],
              [76.109344, 20.137811],
              [76.109957, 20.142235],
              [76.10684, 20.152986],
              [76.110923, 20.161585],
              [76.118422, 20.159673],
              [76.1228, 20.159835],
              [76.121486, 20.167741],
              [76.122511, 20.168327],
              [76.125623, 20.167391],
              [76.126925, 20.170101],
              [76.126439, 20.174747],
              [76.128164, 20.177806],
              [76.128855, 20.180913],
              [76.13267, 20.182104],
              [76.133797, 20.183961],
              [76.132745, 20.190599],
              [76.13544, 20.198663],
              [76.143086, 20.199617],
              [76.151244, 20.204539],
              [76.151463, 20.205972],
              [76.140755, 20.210954],
              [76.135193, 20.2184],
              [76.134178, 20.221719],
              [76.138142, 20.225555],
              [76.138466, 20.229056],
              [76.146896, 20.231106],
              [76.149944, 20.234705],
              [76.153463, 20.235605],
              [76.166402, 20.236683],
              [76.170237, 20.24665],
              [76.170658, 20.251884],
              [76.172192, 20.256085],
              [76.178488, 20.263453],
              [76.183721, 20.267815],
              [76.188568, 20.284687],
              [76.191785, 20.290572],
              [76.194889, 20.300309],
              [76.192261, 20.301081],
              [76.191723, 20.300444],
              [76.184908, 20.300132],
              [76.183038, 20.298964],
              [76.177002, 20.300266],
              [76.176289, 20.298537],
              [76.172259, 20.294531],
              [76.167867, 20.295281],
              [76.160715, 20.297781],
              [76.156402, 20.302719],
              [76.152466, 20.300603],
              [76.145113, 20.299653],
              [76.141884, 20.299905],
              [76.142046, 20.301972],
              [76.148871, 20.306243],
              [76.145504, 20.310969],
              [76.141894, 20.312078],
              [76.136053, 20.317112],
              [76.133739, 20.317142],
              [76.132551, 20.314655],
              [76.129831, 20.313307],
              [76.12745, 20.313792],
              [76.126285, 20.31521],
              [76.129787, 20.316748],
              [76.131461, 20.319463],
              [76.126586, 20.324278],
              [76.126651, 20.328991],
              [76.128966, 20.337732],
              [76.128923, 20.341118],
              [76.12745, 20.342248],
              [76.12411, 20.341637],
              [76.122639, 20.342941],
              [76.121624, 20.345789],
              [76.119305, 20.346398],
              [76.116457, 20.345209],
              [76.113288, 20.345867],
              [76.108993, 20.35292],
              [76.104056, 20.353555],
              [76.100227, 20.352988],
              [76.097686, 20.346704],
              [76.095573, 20.345527],
              [76.091941, 20.348235],
              [76.092378, 20.357483],
              [76.087759, 20.360805],
              [76.087008, 20.362811],
              [76.083145, 20.364708],
              [76.080103, 20.36031],
              [76.07852, 20.355527],
              [76.072244, 20.346617],
              [76.069341, 20.345434],
              [76.068332, 20.343527],
              [76.065064, 20.341987],
              [76.056311, 20.340903],
              [76.053103, 20.339092],
              [76.049556, 20.335712],
              [76.045242, 20.326651],
              [76.037431, 20.314392],
              [76.036499, 20.310996],
              [76.033635, 20.306595],
              [76.030893, 20.297669],
              [76.030538, 20.292613],
              [76.031143, 20.28843],
              [76.026352, 20.287171],
              [76.018879, 20.286384],
              [76.017808, 20.288956],
              [76.008435, 20.288947],
              [76.002423, 20.287951],
              [76.001117, 20.290282],
              [76.002919, 20.296162],
              [76.002392, 20.299195],
              [76.004609, 20.302147],
              [76.004499, 20.305473],
              [76.000029, 20.311551],
              [75.997699, 20.313059],
              [75.995316, 20.311831],
              [75.994517, 20.309202],
              [75.984121, 20.309374],
              [75.980158, 20.310235],
              [75.978257, 20.312145],
              [75.97792, 20.314847],
              [75.975292, 20.316453],
              [75.969132, 20.313546],
              [75.955204, 20.303189],
              [75.950805, 20.300619],
              [75.94588, 20.300363],
              [75.932924, 20.304054],
              [75.928139, 20.306915],
              [75.927071, 20.309778],
              [75.926237, 20.320143],
              [75.92663, 20.323306],
              [75.929624, 20.328233],
              [75.932689, 20.331402],
              [75.934191, 20.338017],
              [75.937937, 20.340203],
              [75.942435, 20.345097],
              [75.944678, 20.351566],
              [75.944407, 20.361144],
              [75.94217, 20.371231],
              [75.953282, 20.371746],
              [75.960124, 20.368351],
              [75.960307, 20.373542],
              [75.968141, 20.373618],
              [75.965158, 20.380381],
              [75.953694, 20.389931],
              [75.950553, 20.394386],
              [75.948482, 20.400636],
              [75.949307, 20.408849],
              [75.94834, 20.413607],
              [75.945197, 20.423226],
              [75.942201, 20.425553],
              [75.94482, 20.436196],
              [75.949078, 20.446676],
              [75.957673, 20.456727],
              [75.95818, 20.46573],
              [75.954583, 20.46644],
              [75.95536, 20.473384],
              [75.950746, 20.473519],
              [75.947611, 20.481851],
              [75.944162, 20.486351],
              [75.942421, 20.495611],
              [75.944338, 20.503917],
              [75.949349, 20.513142],
              [75.950552, 20.51955],
              [75.954193, 20.52047],
              [75.956419, 20.522191],
              [75.957911, 20.524423],
              [75.958558, 20.527394],
              [75.970758, 20.52298],
              [75.973427, 20.529393],
              [75.973985, 20.533465],
              [75.983272, 20.529458],
              [75.990764, 20.530404],
              [75.994792, 20.533585],
              [75.998878, 20.529902],
              [76.000021, 20.530546],
              [76.001985, 20.530744],
              [76.008565, 20.535878],
              [76.01159, 20.537012],
              [76.01213, 20.533747],
              [76.013854, 20.532105],
              [76.018451, 20.530272],
              [76.019652, 20.535732],
              [76.019448, 20.54675],
              [76.018487, 20.550294],
              [76.021138, 20.552221],
              [76.02613, 20.553085],
              [76.032255, 20.555345],
              [76.036228, 20.554133],
              [76.040301, 20.555048],
              [76.03988, 20.559404],
              [76.039759, 20.563642],
              [76.038062, 20.567468],
              [76.037843, 20.570156],
              [76.041867, 20.578933],
              [76.042136, 20.581631],
              [76.038643, 20.588009],
              [76.038847, 20.595243],
              [76.040342, 20.597208],
              [76.039961, 20.603516],
              [76.038158, 20.610781],
              [76.0343, 20.616528],
              [76.031612, 20.62544],
              [76.033755, 20.63407],
              [76.032844, 20.638478],
              [76.026249, 20.643784],
              [76.02257, 20.64512],
              [76.017991, 20.645573],
              [76.013699, 20.642933],
              [76.011074, 20.643022],
              [76.008843, 20.645453],
              [76.006713, 20.649502],
              [76.006362, 20.652941],
              [76.004368, 20.655954],
              [76.002577, 20.65811],
              [76.000028, 20.658936],
              [75.998138, 20.667358],
              [75.99923, 20.672659],
              [76.000027, 20.674256],
              [76.003661, 20.680844],
              [76.003871, 20.683771],
              [76.003495, 20.688644],
              [76.000031, 20.690834],
              [75.998847, 20.693834],
              [75.997071, 20.696561],
              [75.998885, 20.709026],
              [75.998718, 20.712691],
              [76.000023, 20.715617],
              [76.013319, 20.72043],
              [76.017355, 20.724043],
              [76.016247, 20.724947],
              [76.014413, 20.729338],
              [76.016367, 20.729415],
              [76.016033, 20.731419],
              [76.012611, 20.731779],
              [76.012152, 20.738656],
              [76.007047, 20.741858],
              [76.002471, 20.74221],
              [76.000027, 20.743198],
              [75.991322, 20.750849],
              [75.98836, 20.754006],
              [75.986907, 20.758846],
              [75.990324, 20.763127],
              [75.996204, 20.764918],
              [75.997519, 20.767872],
              [75.997061, 20.771287],
              [75.997982, 20.777942],
              [76.000024, 20.779342],
              [76.01207, 20.780533],
              [76.012314, 20.785522],
              [76.01855, 20.784685],
              [76.035568, 20.785705],
              [76.042985, 20.783396],
              [76.049933, 20.788237],
              [76.049418, 20.790584],
              [76.050727, 20.792781],
              [76.0499, 20.795067],
              [76.050853, 20.797424],
              [76.057548, 20.803538],
              [76.052361, 20.807888],
              [76.049735, 20.812498],
              [76.051082, 20.816474],
              [76.054791, 20.818306],
              [76.056351, 20.819987],
              [76.058295, 20.825111],
              [76.061207, 20.826754],
              [76.065562, 20.825316],
              [76.066879, 20.827347],
              [76.068065, 20.829539],
              [76.073938, 20.833564],
              [76.073906, 20.8358],
              [76.075465, 20.837943],
              [76.075555, 20.844889],
              [76.080365, 20.846211],
              [76.080851, 20.850861],
              [76.082823, 20.854097],
              [76.0987, 20.872538],
              [76.107726, 20.878207],
              [76.111655, 20.881702],
              [76.115212, 20.890286],
              [76.115413, 20.893275],
              [76.11155, 20.894431],
              [76.105148, 20.898249],
              [76.10407, 20.901106],
              [76.100925, 20.903305],
              [76.093081, 20.90585],
              [76.080715, 20.908039],
              [76.084115, 20.927527],
              [76.089652, 20.929266],
              [76.090206, 20.933799],
              [76.092819, 20.939794],
              [76.092143, 20.943496],
              [76.100387, 20.944825],
              [76.104573, 20.947227],
              [76.109747, 20.948774],
              [76.113305, 20.952552],
              [76.116414, 20.957812],
              [76.117261, 20.962753],
              [76.122655, 20.975266],
              [76.124658, 20.977241],
              [76.132149, 20.978759],
              [76.144706, 20.985851],
              [76.147559, 20.991856],
              [76.156529, 20.997638],
              [76.15943, 21.000347],
              [76.162314, 21.008305],
              [76.162407, 21.010666],
              [76.16363, 21.01471],
              [76.163816, 21.020306],
              [76.165155, 21.022622],
              [76.165177, 21.027457],
              [76.164978, 21.030148],
              [76.164236, 21.033185],
              [76.165067, 21.036402],
              [76.165935, 21.038067],
              [76.166506, 21.040024],
              [76.167343, 21.040155],
              [76.168499, 21.03906],
              [76.170073, 21.036516],
              [76.170488, 21.035123],
              [76.17386, 21.032253],
              [76.177422, 21.03019],
              [76.182908, 21.028119],
              [76.186172, 21.026837],
              [76.188619, 21.025606],
              [76.191457, 21.023497],
              [76.193398, 21.021535],
              [76.195603, 21.018658],
              [76.197608, 21.016765],
              [76.200459, 21.014849],
              [76.203876, 21.014043],
              [76.207735, 21.013298],
              [76.212813, 21.013512],
              [76.215027, 21.013386],
              [76.220779, 21.012999],
              [76.225809, 21.011913],
              [76.2283, 21.00991],
              [76.230278, 21.007914],
              [76.232281, 21.000469],
              [76.239549, 20.990703],
              [76.247032, 20.988154],
              [76.252239, 20.9877],
              [76.258813, 20.984906],
              [76.267186, 20.979894],
              [76.27287, 20.974053],
              [76.276321, 20.971799],
              [76.27862, 20.96827],
              [76.280576, 20.958198],
              [76.284686, 20.957444],
              [76.288521, 20.958059],
              [76.293051, 20.957595],
              [76.29886, 20.957201],
              [76.314567, 20.951647],
              [76.320203, 20.950497],
              [76.338883, 20.951224],
              [76.346905, 20.949767],
              [76.346893, 20.956248],
              [76.353797, 20.955919],
              [76.35439, 20.958105],
              [76.353971, 20.962397],
              [76.3603, 20.964994],
              [76.365369, 20.970036],
              [76.36723, 20.973272],
              [76.36797, 20.977813],
              [76.376106, 20.976634],
              [76.379715, 20.976613],
              [76.383313, 20.977512],
              [76.383684, 20.987959],
              [76.386985, 20.99287],
              [76.390146, 21.00063],
              [76.392455, 21.010494],
              [76.393862, 21.012444],
              [76.394407, 21.014139],
              [76.394794, 21.015922],
              [76.394256, 21.018663],
              [76.393558, 21.020551],
              [76.394085, 21.022892],
              [76.394939, 21.025004],
              [76.396222, 21.026646],
              [76.39691, 21.028466],
              [76.398154, 21.030318],
              [76.398041, 21.032551],
              [76.397358, 21.036403],
              [76.396515, 21.04008],
              [76.39556, 21.042033],
              [76.394829, 21.043773],
              [76.393156, 21.045995],
              [76.390669, 21.04954],
              [76.388721, 21.055284],
              [76.387508, 21.059116],
              [76.387027, 21.062376],
              [76.38743, 21.065568],
              [76.38767, 21.067557],
              [76.386967, 21.070476],
              [76.386384, 21.072627],
              [76.385536, 21.074567],
              [76.384546, 21.076176],
              [76.383528, 21.077282],
              [76.383794, 21.077511],
              [76.391174, 21.086002],
              [76.397894, 21.088517],
              [76.41054, 21.092037],
              [76.412927, 21.105201],
              [76.434893, 21.104627],
              [76.438662, 21.105531],
              [76.44224, 21.110064],
              [76.448912, 21.110799],
              [76.451053, 21.111661],
              [76.4539, 21.112806],
              [76.454127, 21.122353],
              [76.457151, 21.12984],
              [76.458735, 21.136253],
              [76.466755, 21.137156],
              [76.468239, 21.141097],
              [76.46801, 21.145176],
              [76.470227, 21.148472],
              [76.476172, 21.149972],
              [76.478264, 21.153206],
              [76.478007, 21.159182],
              [76.479574, 21.173558],
              [76.483754, 21.186097],
              [76.488699, 21.193921],
              [76.492484, 21.195689],
              [76.499409, 21.19401],
              [76.522172, 21.187098],
              [76.530603, 21.187166],
              [76.542724, 21.194162],
              [76.560849, 21.203678],
              [76.576682, 21.201939],
              [76.577563, 21.201538],
              [76.588282, 21.196556],
              [76.607197, 21.195045],
              [76.613896, 21.193795],
              [76.618391, 21.19645],
              [76.621622, 21.193325],
              [76.624985, 21.190545],
              [76.628497, 21.196694],
              [76.633207, 21.203251],
              [76.632988, 21.213511],
              [76.633322, 21.226753],
              [76.638948, 21.236965],
              [76.644247, 21.245569],
              [76.65157, 21.246862],
              [76.660204, 21.24566],
              [76.660722, 21.251093],
              [76.661167, 21.259966],
              [76.661914, 21.271419],
              [76.662796, 21.280226],
              [76.675752, 21.281974],
              [76.684943, 21.288204],
              [76.699304, 21.286822],
              [76.709138, 21.285134],
              [76.715575, 21.285627],
              [76.724093, 21.289067],
              [76.730128, 21.281147],
              [76.737367, 21.269375],
              [76.746164, 21.255908],
              [76.749049, 21.253266],
              [76.74954, 21.250566],
              [76.744692, 21.243796],
              [76.744657, 21.238979],
              [76.746217, 21.234135],
              [76.74757, 21.228205],
              [76.748364, 21.222064],
              [76.75101, 21.219772],
              [76.754053, 21.218561],
              [76.756398, 21.222813],
              [76.759107, 21.223332],
              [76.760537, 21.221237],
              [76.764622, 21.202135],
              [76.765988, 21.193971],
              [76.768024, 21.191868],
              [76.772777, 21.190625],
              [76.779476, 21.192027],
              [76.782549, 21.192769],
              [76.78376, 21.188962],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 94,
        censuscode: 500,
        dt_cen_cd: 4,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Buldana",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [79.932995, 20.666525],
              [79.936342, 20.660574],
              [79.941011, 20.648771],
              [79.943319, 20.637858],
              [79.942849, 20.624101],
              [79.940681, 20.612087],
              [79.941166, 20.601617],
              [79.938301, 20.582356],
              [79.933587, 20.566453],
              [79.927619, 20.552169],
              [79.934714, 20.543557],
              [79.948527, 20.536905],
              [79.952811, 20.528154],
              [79.951321, 20.511421],
              [79.951974, 20.500173],
              [79.945314, 20.474423],
              [79.941313, 20.446752],
              [79.94306, 20.434865],
              [79.955231, 20.423695],
              [79.962125, 20.41498],
              [79.964015, 20.405045],
              [79.961664, 20.397399],
              [79.960325, 20.383515],
              [79.965962, 20.371499],
              [79.973509, 20.36074],
              [79.973857, 20.349978],
              [79.968585, 20.342164],
              [79.963719, 20.338428],
              [79.95715, 20.333824],
              [79.949995, 20.326876],
              [79.94563, 20.31659],
              [79.944916, 20.305481],
              [79.945386, 20.294014],
              [79.949355, 20.284955],
              [79.956845, 20.275725],
              [79.971619, 20.264231],
              [79.979078, 20.256691],
              [79.985419, 20.248494],
              [79.992288, 20.237543],
              [79.995407, 20.229071],
              [79.995839, 20.219772],
              [79.993791, 20.212114],
              [79.989519, 20.206761],
              [79.983359, 20.205161],
              [79.972452, 20.204387],
              [79.96519, 20.202331],
              [79.95565, 20.198807],
              [79.946698, 20.19396],
              [79.941506, 20.192103],
              [79.934195, 20.18689],
              [79.921564, 20.168788],
              [79.916953, 20.159822],
              [79.91269, 20.149779],
              [79.912211, 20.145525],
              [79.913679, 20.140746],
              [79.920559, 20.135877],
              [79.930188, 20.131451],
              [79.938852, 20.128888],
              [79.957069, 20.125388],
              [79.965408, 20.121125],
              [79.972359, 20.112745],
              [79.978324, 20.103191],
              [79.984562, 20.079492],
              [79.985942, 20.066697],
              [79.991586, 20.045336],
              [79.984008, 20.02934],
              [79.972438, 20.014926],
              [79.964685, 20.004184],
              [79.962603, 19.999807],
              [79.957233, 19.993024],
              [79.950544, 19.984769],
              [79.937595, 19.975803],
              [79.924374, 19.970592],
              [79.912501, 19.967594],
              [79.895038, 19.969527],
              [79.880972, 19.976821],
              [79.871162, 19.984016],
              [79.868771, 19.991215],
              [79.869854, 20.000111],
              [79.870704, 20.001143],
              [79.856684, 20.021422],
              [79.848695, 20.032476],
              [79.814204, 20.028866],
              [79.798724, 20.020285],
              [79.788395, 20.009707],
              [79.780702, 20.000362],
              [79.77973, 19.986983],
              [79.775534, 19.979732],
              [79.772213, 19.971961],
              [79.776875, 19.950016],
              [79.78444, 19.935947],
              [79.79279, 19.924085],
              [79.795566, 19.916791],
              [79.799233, 19.912966],
              [79.805668, 19.899936],
              [79.80515, 19.893631],
              [79.803417, 19.889755],
              [79.798913, 19.885315],
              [79.791558, 19.88127],
              [79.786605, 19.875214],
              [79.786577, 19.868754],
              [79.781728, 19.863442],
              [79.766054, 19.854421],
              [79.758538, 19.846773],
              [79.747588, 19.830799],
              [79.744073, 19.823403],
              [79.743809, 19.816524],
              [79.745607, 19.790037],
              [79.747385, 19.779082],
              [79.751793, 19.772182],
              [79.754992, 19.760384],
              [79.760962, 19.748766],
              [79.781982, 19.726281],
              [79.786807, 19.71744],
              [79.787439, 19.708572],
              [79.786864, 19.69229],
              [79.787969, 19.663665],
              [79.786983, 19.649379],
              [79.789233, 19.631386],
              [79.794282, 19.617511],
              [79.794105, 19.604674],
              [79.791952, 19.595987],
              [79.784049, 19.60006],
              [79.77279, 19.602519],
              [79.76075, 19.60467],
              [79.746805, 19.605472],
              [79.736376, 19.598899],
              [79.719383, 19.585657],
              [79.711565, 19.583543],
              [79.702126, 19.583407],
              [79.691214, 19.581465],
              [79.684435, 19.57886],
              [79.671471, 19.579447],
              [79.659015, 19.578958],
              [79.646103, 19.577255],
              [79.627763, 19.567353],
              [79.622176, 19.560879],
              [79.617268, 19.551439],
              [79.613572, 19.541733],
              [79.609309, 19.52337],
              [79.608805, 19.51683],
              [79.607216, 19.510263],
              [79.604424, 19.506085],
              [79.597697, 19.504046],
              [79.589013, 19.505347],
              [79.579781, 19.508929],
              [79.571932, 19.513174],
              [79.558811, 19.522282],
              [79.554002, 19.528306],
              [79.551502, 19.536212],
              [79.551042, 19.544903],
              [79.548958, 19.550705],
              [79.54128, 19.550247],
              [79.532497, 19.548227],
              [79.521254, 19.544117],
              [79.521091, 19.54292],
              [79.522231, 19.538987],
              [79.522111, 19.524553],
              [79.51968, 19.520266],
              [79.499563, 19.507388],
              [79.486284, 19.505997],
              [79.476658, 19.499625],
              [79.471345, 19.511164],
              [79.464392, 19.521088],
              [79.447447, 19.5356],
              [79.436447, 19.537173],
              [79.429347, 19.534911],
              [79.419761, 19.535536],
              [79.407979, 19.541862],
              [79.395096, 19.550926],
              [79.386819, 19.557837],
              [79.377285, 19.563513],
              [79.375117, 19.573178],
              [79.346936, 19.575682],
              [79.335719, 19.575582],
              [79.327529, 19.573643],
              [79.320286, 19.567421],
              [79.315642, 19.583876],
              [79.310843, 19.591996],
              [79.299221, 19.598547],
              [79.273829, 19.608448],
              [79.261168, 19.612966],
              [79.249805, 19.614291],
              [79.243023, 19.611234],
              [79.243634, 19.601304],
              [79.249726, 19.595113],
              [79.254619, 19.588651],
              [79.256049, 19.57949],
              [79.24571, 19.561308],
              [79.244103, 19.55277],
              [79.245294, 19.543897],
              [79.244303, 19.534625],
              [79.242575, 19.528668],
              [79.237932, 19.522609],
              [79.229364, 19.518877],
              [79.221639, 19.512457],
              [79.214002, 19.500534],
              [79.212781, 19.493558],
              [79.214705, 19.486702],
              [79.226629, 19.477517],
              [79.228883, 19.469741],
              [79.22466, 19.466447],
              [79.194947, 19.460624],
              [79.183689, 19.46259],
              [79.174978, 19.469654],
              [79.16284, 19.487392],
              [79.146097, 19.502911],
              [79.132272, 19.50826],
              [79.118614, 19.511541],
              [79.110536, 19.514481],
              [79.108135, 19.521095],
              [79.108638, 19.529668],
              [79.1024, 19.532185],
              [79.079598, 19.530277],
              [79.069113, 19.532919],
              [79.065829, 19.540379],
              [79.057234, 19.546907],
              [79.044514, 19.546619],
              [79.024018, 19.541568],
              [79.017847, 19.545361],
              [79.005712, 19.56093],
              [79.001214, 19.562576],
              [78.998479, 19.563587],
              [78.991979, 19.558593],
              [78.98409, 19.552469],
              [78.979141, 19.551441],
              [78.970447, 19.551861],
              [78.960139, 19.553351],
              [78.955135, 19.558982],
              [78.960037, 19.564221],
              [78.970286, 19.571788],
              [78.974578, 19.574955],
              [78.983456, 19.581438],
              [78.986123, 19.586583],
              [78.983909, 19.591905],
              [78.976928, 19.598729],
              [78.971208, 19.605964],
              [78.968443, 19.618754],
              [78.970252, 19.630965],
              [78.97358, 19.640775],
              [78.97453, 19.650617],
              [78.967233, 19.660136],
              [78.959753, 19.664763],
              [78.949131, 19.666484],
              [78.940524, 19.663513],
              [78.921413, 19.669038],
              [78.90928, 19.665855],
              [78.896459, 19.656564],
              [78.883413, 19.658081],
              [78.864228, 19.657568],
              [78.864552, 19.670156],
              [78.868641, 19.680728],
              [78.869422, 19.687921],
              [78.868905, 19.697974],
              [78.867081, 19.707098],
              [78.862815, 19.720906],
              [78.862331, 19.732457],
              [78.858979, 19.739141],
              [78.851016, 19.759449],
              [78.84972, 19.760103],
              [78.85365, 19.766343],
              [78.858879, 19.770148],
              [78.866727, 19.769643],
              [78.875046, 19.76765],
              [78.880771, 19.763212],
              [78.881393, 19.758178],
              [78.879881, 19.75196],
              [78.883029, 19.745997],
              [78.890028, 19.74347],
              [78.902904, 19.737075],
              [78.907675, 19.738121],
              [78.917132, 19.742617],
              [78.923634, 19.74484],
              [78.931594, 19.746455],
              [78.941061, 19.74677],
              [78.948901, 19.748613],
              [78.951796, 19.75324],
              [78.950127, 19.75872],
              [78.947743, 19.763146],
              [78.941435, 19.771592],
              [78.940445, 19.778282],
              [78.941846, 19.784552],
              [78.945618, 19.788562],
              [78.950849, 19.796842],
              [78.957064, 19.801931],
              [78.958617, 19.803205],
              [78.972371, 19.804385],
              [78.98872, 19.803725],
              [78.990024, 19.803667],
              [78.997323, 19.804716],
              [79.000939, 19.804099],
              [79.011189, 19.803883],
              [79.020456, 19.799088],
              [79.029309, 19.801351],
              [79.035054, 19.806383],
              [79.038253, 19.813578],
              [79.042886, 19.817146],
              [79.051371, 19.815071],
              [79.058912, 19.814466],
              [79.065625, 19.814754],
              [79.072865, 19.818142],
              [79.080198, 19.822559],
              [79.088455, 19.830957],
              [79.091065, 19.837323],
              [79.094067, 19.840479],
              [79.103041, 19.842252],
              [79.10978, 19.846483],
              [79.120722, 19.858433],
              [79.125127, 19.861404],
              [79.132594, 19.86301],
              [79.135861, 19.865554],
              [79.138016, 19.871101],
              [79.149456, 19.886845],
              [79.151663, 19.893038],
              [79.113629, 19.903776],
              [79.109117, 19.909663],
              [79.102312, 19.91297],
              [79.094886, 19.914664],
              [79.092736, 19.919743],
              [79.09154, 19.932616],
              [79.09208, 19.939997],
              [79.093599, 19.945636],
              [79.105423, 19.95403],
              [79.108253, 19.958883],
              [79.110453, 19.964634],
              [79.108379, 19.968408],
              [79.097768, 19.973395],
              [79.093718, 19.977132],
              [79.095055, 19.981386],
              [79.101586, 19.984742],
              [79.107999, 19.986326],
              [79.113532, 19.985838],
              [79.115207, 19.988435],
              [79.110513, 20.000873],
              [79.108608, 20.007989],
              [79.104534, 20.015061],
              [79.098362, 20.017177],
              [79.090436, 20.020994],
              [79.083258, 20.028528],
              [79.079253, 20.043095],
              [79.07298, 20.054052],
              [79.070704, 20.063761],
              [79.064341, 20.069445],
              [79.059286, 20.067398],
              [79.054528, 20.066504],
              [79.048581, 20.067902],
              [79.044098, 20.071307],
              [79.047251, 20.077428],
              [79.048329, 20.084134],
              [79.043256, 20.08864],
              [79.035147, 20.093554],
              [79.01668, 20.11277],
              [79.004097, 20.120461],
              [78.999837, 20.120706],
              [78.995142, 20.122111],
              [78.990577, 20.122507],
              [78.983296, 20.121624],
              [78.980046, 20.120335],
              [78.974129, 20.120278],
              [78.970517, 20.123177],
              [78.968987, 20.133545],
              [78.970413, 20.137627],
              [78.973888, 20.141054],
              [78.978197, 20.142088],
              [78.981434, 20.144949],
              [78.981418, 20.148646],
              [78.979821, 20.152531],
              [78.969766, 20.160483],
              [78.968863, 20.160821],
              [78.96355, 20.16237],
              [78.958116, 20.16532],
              [78.955116, 20.168303],
              [78.956839, 20.171813],
              [78.957764, 20.177349],
              [78.957781, 20.181718],
              [78.956903, 20.184707],
              [78.957384, 20.192642],
              [78.961527, 20.198878],
              [78.962708, 20.202626],
              [78.960294, 20.206827],
              [78.951863, 20.210479],
              [78.946688, 20.21179],
              [78.941477, 20.215573],
              [78.937908, 20.219995],
              [78.936761, 20.224947],
              [78.934555, 20.227696],
              [78.930151, 20.229345],
              [78.921678, 20.237179],
              [78.922735, 20.249255],
              [78.921297, 20.252353],
              [78.918793, 20.254463],
              [78.905419, 20.253064],
              [78.89846, 20.249287],
              [78.895011, 20.248067],
              [78.889416, 20.247333],
              [78.885273, 20.247367],
              [78.869975, 20.25112],
              [78.860662, 20.252157],
              [78.850331, 20.251462],
              [78.827069, 20.247006],
              [78.820144, 20.246903],
              [78.814383, 20.251112],
              [78.812534, 20.25386],
              [78.811378, 20.259774],
              [78.812808, 20.262711],
              [78.816727, 20.266298],
              [78.819793, 20.270568],
              [78.818281, 20.275105],
              [78.804824, 20.28921],
              [78.802833, 20.293388],
              [78.801818, 20.297798],
              [78.801235, 20.301418],
              [78.805868, 20.306972],
              [78.811964, 20.312528],
              [78.825242, 20.316573],
              [78.830032, 20.3189],
              [78.833714, 20.328054],
              [78.833602, 20.33357],
              [78.825025, 20.346098],
              [78.823767, 20.349372],
              [78.823907, 20.353679],
              [78.827399, 20.358177],
              [78.828025, 20.362145],
              [78.822105, 20.370326],
              [78.822017, 20.379695],
              [78.819016, 20.387319],
              [78.819391, 20.392837],
              [78.820936, 20.396806],
              [78.823407, 20.399931],
              [78.826492, 20.4019],
              [78.843233, 20.401361],
              [78.853608, 20.406142],
              [78.855708, 20.408965],
              [78.856663, 20.411101],
              [78.848514, 20.416908],
              [78.84359, 20.421704],
              [78.842468, 20.424514],
              [78.841797, 20.431058],
              [78.846346, 20.433445],
              [78.852361, 20.42831],
              [78.856832, 20.425691],
              [78.865753, 20.422302],
              [78.871484, 20.421694],
              [78.879203, 20.423346],
              [78.892287, 20.430434],
              [78.899223, 20.437191],
              [78.907924, 20.432294],
              [78.916414, 20.429287],
              [78.919813, 20.430001],
              [78.939495, 20.428712],
              [78.95082, 20.428438],
              [78.960815, 20.433397],
              [78.963711, 20.436068],
              [78.969044, 20.450395],
              [78.968104, 20.45389],
              [78.968553, 20.458553],
              [78.983936, 20.456361],
              [78.98495, 20.45895],
              [78.989082, 20.459732],
              [78.988325, 20.462927],
              [78.989724, 20.462826],
              [78.992383, 20.456101],
              [78.998292, 20.454647],
              [78.999138, 20.44828],
              [78.999898, 20.448342],
              [79.001864, 20.447645],
              [79.011731, 20.464996],
              [79.017031, 20.472772],
              [79.023961, 20.478484],
              [79.030172, 20.477945],
              [79.040085, 20.474528],
              [79.046728, 20.473463],
              [79.045514, 20.466588],
              [79.048801, 20.46577],
              [79.051897, 20.46398],
              [79.057405, 20.466427],
              [79.063189, 20.466116],
              [79.076882, 20.462624],
              [79.089978, 20.461371],
              [79.096362, 20.459968],
              [79.097363, 20.455204],
              [79.102278, 20.452661],
              [79.113657, 20.45003],
              [79.121033, 20.450062],
              [79.130696, 20.454036],
              [79.136515, 20.466169],
              [79.139345, 20.477517],
              [79.146423, 20.479208],
              [79.156589, 20.476698],
              [79.160057, 20.482989],
              [79.163624, 20.487278],
              [79.1673, 20.505329],
              [79.171739, 20.512368],
              [79.179412, 20.510608],
              [79.182436, 20.515356],
              [79.186102, 20.524696],
              [79.19184, 20.532696],
              [79.214382, 20.546417],
              [79.216987, 20.551231],
              [79.217279, 20.556387],
              [79.221496, 20.565774],
              [79.221364, 20.579487],
              [79.224721, 20.582068],
              [79.226393, 20.58336],
              [79.251491, 20.586058],
              [79.263373, 20.58497],
              [79.280637, 20.585221],
              [79.292501, 20.588775],
              [79.296519, 20.58767],
              [79.304167, 20.583438],
              [79.313112, 20.580647],
              [79.321791, 20.583241],
              [79.327093, 20.589231],
              [79.332882, 20.60211],
              [79.33433, 20.607829],
              [79.334692, 20.613568],
              [79.347376, 20.634038],
              [79.344752, 20.640587],
              [79.34588, 20.644259],
              [79.353622, 20.650524],
              [79.357388, 20.655263],
              [79.355897, 20.659917],
              [79.350396, 20.665221],
              [79.352827, 20.671287],
              [79.363687, 20.670826],
              [79.371041, 20.674055],
              [79.375521, 20.6773],
              [79.384977, 20.675764],
              [79.389461, 20.672354],
              [79.389517, 20.665585],
              [79.392706, 20.660462],
              [79.399021, 20.657326],
              [79.406876, 20.655501],
              [79.417987, 20.656071],
              [79.428709, 20.660599],
              [79.434922, 20.658781],
              [79.445398, 20.663313],
              [79.451028, 20.664373],
              [79.460032, 20.668905],
              [79.467412, 20.67442],
              [79.475042, 20.680915],
              [79.482697, 20.689589],
              [79.489611, 20.698151],
              [79.491563, 20.704044],
              [79.494382, 20.70443],
              [79.496338, 20.699146],
              [79.505689, 20.69989],
              [79.509017, 20.703948],
              [79.518563, 20.70531],
              [79.520787, 20.708688],
              [79.527494, 20.707666],
              [79.534576, 20.701712],
              [79.548372, 20.70214],
              [79.565952, 20.701571],
              [79.567829, 20.694161],
              [79.580917, 20.691035],
              [79.598301, 20.689199],
              [79.605094, 20.69087],
              [79.613155, 20.691165],
              [79.62315, 20.672973],
              [79.6446, 20.669843],
              [79.653367, 20.667599],
              [79.663321, 20.662485],
              [79.664756, 20.653696],
              [79.671651, 20.648375],
              [79.679761, 20.647397],
              [79.686379, 20.644879],
              [79.691046, 20.641346],
              [79.695665, 20.640339],
              [79.701569, 20.644717],
              [79.693833, 20.662498],
              [79.693469, 20.668746],
              [79.713494, 20.6853],
              [79.723286, 20.682642],
              [79.735428, 20.682551],
              [79.75256, 20.685751],
              [79.757681, 20.700859],
              [79.760913, 20.706795],
              [79.753946, 20.710637],
              [79.75818, 20.723394],
              [79.761744, 20.731055],
              [79.782597, 20.723206],
              [79.789304, 20.717419],
              [79.793891, 20.70792],
              [79.796838, 20.698892],
              [79.800582, 20.695305],
              [79.802879, 20.684219],
              [79.828459, 20.682447],
              [79.841968, 20.678781],
              [79.849886, 20.677568],
              [79.879146, 20.684638],
              [79.894263, 20.683076],
              [79.903887, 20.676431],
              [79.932995, 20.666525],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 108,
        censuscode: 509,
        dt_cen_cd: 13,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Chandrapur",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [75.205718, 21.41368],
              [75.192997, 21.412478],
              [75.190227, 21.411468],
              [75.183276, 21.407717],
              [75.181936, 21.405517],
              [75.177884, 21.403168],
              [75.172411, 21.401326],
              [75.165678, 21.402744],
              [75.161053, 21.402754],
              [75.157928, 21.398697],
              [75.157148, 21.395704],
              [75.154712, 21.391485],
              [75.152079, 21.388352],
              [75.141566, 21.38415],
              [75.136094, 21.365641],
              [75.138531, 21.360618],
              [75.149054, 21.354189],
              [75.148225, 21.349121],
              [75.140783, 21.347769],
              [75.135411, 21.349319],
              [75.128748, 21.350157],
              [75.125311, 21.348748],
              [75.121524, 21.343821],
              [75.123337, 21.340791],
              [75.125627, 21.339263],
              [75.144836, 21.331849],
              [75.151981, 21.323026],
              [75.149249, 21.318277],
              [75.136753, 21.316704],
              [75.135425, 21.313693],
              [75.138569, 21.305232],
              [75.139569, 21.293753],
              [75.130282, 21.285019],
              [75.128769, 21.28145],
              [75.130609, 21.272901],
              [75.130272, 21.26991],
              [75.128744, 21.267538],
              [75.12606, 21.264753],
              [75.11913, 21.261745],
              [75.104386, 21.236002],
              [75.09717, 21.232703],
              [75.092279, 21.232073],
              [75.089002, 21.228017],
              [75.079107, 21.227856],
              [75.067346, 21.224872],
              [75.064549, 21.223648],
              [75.058038, 21.218556],
              [75.055305, 21.213897],
              [75.047711, 21.213352],
              [75.041912, 21.211166],
              [75.039712, 21.207049],
              [75.038582, 21.202776],
              [75.032886, 21.192102],
              [75.024552, 21.19351],
              [75.019177, 21.193298],
              [75.017287, 21.192455],
              [75.01385, 21.192801],
              [75.009543, 21.191947],
              [75.004797, 21.189211],
              [75.002461, 21.187886],
              [74.999217, 21.187357],
              [74.990238, 21.195148],
              [74.980004, 21.209721],
              [74.97368, 21.220878],
              [74.96397, 21.222579],
              [74.952929, 21.221269],
              [74.94376, 21.224966],
              [74.944101, 21.221499],
              [74.949346, 21.216218],
              [74.95724, 21.213022],
              [74.959004, 21.21164],
              [74.959523, 21.208902],
              [74.958129, 21.206468],
              [74.95552, 21.203996],
              [74.952441, 21.202608],
              [74.951891, 21.200942],
              [74.953683, 21.2003],
              [74.958199, 21.200576],
              [74.962747, 21.199306],
              [74.964208, 21.196581],
              [74.963432, 21.191756],
              [74.9588, 21.186896],
              [74.952196, 21.181601],
              [74.936633, 21.171776],
              [74.93206, 21.166919],
              [74.928151, 21.165639],
              [74.918738, 21.166586],
              [74.913455, 21.166023],
              [74.902854, 21.157875],
              [74.8984, 21.155767],
              [74.892967, 21.1514],
              [74.888813, 21.145051],
              [74.886345, 21.137249],
              [74.884971, 21.127752],
              [74.886694, 21.113278],
              [74.874561, 21.10488],
              [74.870888, 21.101426],
              [74.87005, 21.097112],
              [74.872762, 21.092709],
              [74.874123, 21.088215],
              [74.868192, 21.072824],
              [74.859521, 21.065447],
              [74.858108, 21.063058],
              [74.864862, 21.051229],
              [74.891106, 21.052448],
              [74.894252, 21.039756],
              [74.905705, 21.03571],
              [74.910183, 21.031989],
              [74.921211, 21.010568],
              [74.918292, 21.006791],
              [74.91642, 21.000201],
              [74.916598, 20.98992],
              [74.919141, 20.98584],
              [74.926534, 20.980947],
              [74.929769, 20.977682],
              [74.928624, 20.971945],
              [74.930782, 20.967156],
              [74.930222, 20.960921],
              [74.918315, 20.962442],
              [74.912629, 20.962026],
              [74.911816, 20.945905],
              [74.914152, 20.926828],
              [74.935078, 20.925882],
              [74.934631, 20.917322],
              [74.9457, 20.914363],
              [74.949992, 20.911645],
              [74.955935, 20.90019],
              [74.961985, 20.905124],
              [74.962269, 20.902531],
              [74.960119, 20.894308],
              [74.960795, 20.887165],
              [74.967795, 20.883062],
              [74.970307, 20.877286],
              [74.966834, 20.856686],
              [74.967569, 20.851527],
              [74.981952, 20.843249],
              [74.981679, 20.840446],
              [74.983436, 20.834642],
              [74.98352, 20.830871],
              [74.986463, 20.822257],
              [74.982543, 20.821385],
              [74.974841, 20.821245],
              [74.968338, 20.819199],
              [74.968006, 20.811769],
              [74.96288, 20.807816],
              [74.96193, 20.804862],
              [74.963057, 20.802447],
              [74.965364, 20.801054],
              [74.968052, 20.797081],
              [74.973981, 20.783766],
              [74.984022, 20.777957],
              [74.98846, 20.773117],
              [74.990363, 20.766418],
              [74.992654, 20.761774],
              [74.994256, 20.748726],
              [74.991206, 20.736417],
              [74.989065, 20.733592],
              [74.983865, 20.732492],
              [74.971798, 20.725645],
              [74.964876, 20.720291],
              [74.961033, 20.719292],
              [74.951016, 20.72045],
              [74.950758, 20.719249],
              [74.954088, 20.717344],
              [74.957668, 20.717034],
              [74.960208, 20.715652],
              [74.953473, 20.711799],
              [74.952595, 20.704022],
              [74.953335, 20.698799],
              [74.955958, 20.694189],
              [74.954829, 20.691473],
              [74.942364, 20.682608],
              [74.941227, 20.673833],
              [74.937088, 20.669228],
              [74.934058, 20.664783],
              [74.932172, 20.66033],
              [74.929459, 20.657447],
              [74.914196, 20.65724],
              [74.900961, 20.65793],
              [74.897714, 20.651661],
              [74.891732, 20.646284],
              [74.887365, 20.644152],
              [74.876411, 20.641918],
              [74.868429, 20.638095],
              [74.856485, 20.635177],
              [74.843451, 20.637415],
              [74.840658, 20.633313],
              [74.836139, 20.633475],
              [74.828667, 20.631993],
              [74.814926, 20.633747],
              [74.81294, 20.635714],
              [74.808989, 20.637475],
              [74.803483, 20.636207],
              [74.80566, 20.656645],
              [74.800727, 20.65813],
              [74.798485, 20.659753],
              [74.795148, 20.660872],
              [74.790315, 20.660124],
              [74.784004, 20.664076],
              [74.776985, 20.663571],
              [74.774252, 20.665602],
              [74.770268, 20.664213],
              [74.771287, 20.662364],
              [74.76859, 20.661589],
              [74.766475, 20.662527],
              [74.764069, 20.666796],
              [74.759766, 20.663512],
              [74.757472, 20.666623],
              [74.750123, 20.664352],
              [74.749522, 20.670999],
              [74.743889, 20.669335],
              [74.741308, 20.667701],
              [74.738131, 20.66761],
              [74.737023, 20.672667],
              [74.733153, 20.675631],
              [74.730873, 20.679717],
              [74.726404, 20.678212],
              [74.723176, 20.679271],
              [74.71009, 20.689251],
              [74.694592, 20.690891],
              [74.685222, 20.693094],
              [74.670698, 20.693967],
              [74.655907, 20.693131],
              [74.650855, 20.6949],
              [74.656448, 20.709856],
              [74.658265, 20.720674],
              [74.656018, 20.727508],
              [74.658762, 20.733446],
              [74.661232, 20.736579],
              [74.657123, 20.746923],
              [74.656986, 20.751173],
              [74.654925, 20.753189],
              [74.655033, 20.757256],
              [74.661836, 20.759947],
              [74.665616, 20.770568],
              [74.665033, 20.774188],
              [74.657129, 20.777521],
              [74.65298, 20.778533],
              [74.64998, 20.778044],
              [74.645611, 20.780382],
              [74.637129, 20.781429],
              [74.630128, 20.790544],
              [74.62233, 20.798459],
              [74.612563, 20.805659],
              [74.598623, 20.81128],
              [74.589465, 20.812273],
              [74.582404, 20.813997],
              [74.578335, 20.817009],
              [74.574424, 20.823696],
              [74.573518, 20.830919],
              [74.572623, 20.832762],
              [74.567638, 20.823121],
              [74.553664, 20.825418],
              [74.548365, 20.826952],
              [74.542721, 20.831128],
              [74.539519, 20.83459],
              [74.536317, 20.832266],
              [74.533546, 20.824269],
              [74.531751, 20.821306],
              [74.528107, 20.817671],
              [74.524597, 20.814778],
              [74.516502, 20.810837],
              [74.512308, 20.80789],
              [74.507978, 20.814287],
              [74.507022, 20.817502],
              [74.493845, 20.819218],
              [74.491859, 20.816418],
              [74.484544, 20.817912],
              [74.482754, 20.82251],
              [74.483169, 20.828298],
              [74.47837, 20.831198],
              [74.472053, 20.822194],
              [74.467736, 20.818164],
              [74.465372, 20.813541],
              [74.456078, 20.812474],
              [74.450183, 20.80175],
              [74.43802, 20.801329],
              [74.422105, 20.805351],
              [74.40691, 20.815442],
              [74.39898, 20.823008],
              [74.395715, 20.827152],
              [74.395863, 20.830191],
              [74.387644, 20.834608],
              [74.389156, 20.839634],
              [74.405314, 20.835727],
              [74.402625, 20.841937],
              [74.398433, 20.84564],
              [74.397002, 20.849087],
              [74.396778, 20.859293],
              [74.395117, 20.857815],
              [74.394362, 20.85564],
              [74.390943, 20.855781],
              [74.387495, 20.853173],
              [74.385237, 20.853243],
              [74.384477, 20.849417],
              [74.386131, 20.843495],
              [74.385316, 20.840295],
              [74.368965, 20.844142],
              [74.363385, 20.842641],
              [74.358764, 20.845132],
              [74.358262, 20.842961],
              [74.357274, 20.856839],
              [74.348797, 20.859187],
              [74.348705, 20.847908],
              [74.345401, 20.8469],
              [74.339508, 20.851352],
              [74.338357, 20.845177],
              [74.33886, 20.839214],
              [74.336036, 20.838369],
              [74.332683, 20.839432],
              [74.329338, 20.841685],
              [74.326278, 20.847958],
              [74.318777, 20.842452],
              [74.315774, 20.84202],
              [74.307027, 20.848379],
              [74.29769, 20.849826],
              [74.290888, 20.855205],
              [74.276062, 20.851125],
              [74.270061, 20.850309],
              [74.265121, 20.850513],
              [74.260778, 20.851514],
              [74.255635, 20.857853],
              [74.254111, 20.858437],
              [74.249765, 20.856519],
              [74.244459, 20.851056],
              [74.239884, 20.850857],
              [74.235466, 20.849624],
              [74.228818, 20.850707],
              [74.225501, 20.857084],
              [74.221656, 20.858146],
              [74.218303, 20.858507],
              [74.213697, 20.856822],
              [74.207285, 20.856351],
              [74.201991, 20.859539],
              [74.194254, 20.854435],
              [74.167662, 20.86286],
              [74.159709, 20.862279],
              [74.157782, 20.85839],
              [74.15793, 20.852262],
              [74.144785, 20.852117],
              [74.138602, 20.859033],
              [74.13246, 20.863078],
              [74.126352, 20.865069],
              [74.119146, 20.864938],
              [74.115032, 20.862558],
              [74.113717, 20.858324],
              [74.105336, 20.857514],
              [74.101102, 20.854224],
              [74.102663, 20.849744],
              [74.102755, 20.845105],
              [74.097342, 20.841182],
              [74.092299, 20.844877],
              [74.080016, 20.845242],
              [74.074974, 20.849563],
              [74.069866, 20.844207],
              [74.060666, 20.848214],
              [74.056479, 20.844004],
              [74.0528, 20.842131],
              [74.049911, 20.840265],
              [74.047867, 20.835631],
              [74.041326, 20.835385],
              [74.037124, 20.837301],
              [74.033059, 20.842133],
              [74.029973, 20.847652],
              [74.025654, 20.850831],
              [74.019777, 20.848343],
              [74.018285, 20.844626],
              [74.021586, 20.835726],
              [74.010347, 20.836646],
              [74.003686, 20.83548],
              [74.000032, 20.835608],
              [73.998539, 20.836947],
              [73.993062, 20.839216],
              [73.990516, 20.843363],
              [73.987217, 20.843306],
              [73.983924, 20.845729],
              [73.968182, 20.851361],
              [73.967361, 20.846011],
              [73.963056, 20.842353],
              [73.959084, 20.842849],
              [73.945252, 20.838403],
              [73.941099, 20.8398],
              [73.938892, 20.839174],
              [73.929672, 20.842493],
              [73.927492, 20.844014],
              [73.924822, 20.847445],
              [73.925327, 20.851545],
              [73.923903, 20.859152],
              [73.925454, 20.86377],
              [73.923464, 20.867909],
              [73.925031, 20.875651],
              [73.924837, 20.884947],
              [73.921128, 20.898134],
              [73.918215, 20.901867],
              [73.916531, 20.906787],
              [73.914112, 20.910268],
              [73.910592, 20.914087],
              [73.905973, 20.916979],
              [73.90331, 20.920439],
              [73.897721, 20.924412],
              [73.890063, 20.932042],
              [73.888752, 20.939187],
              [73.888833, 20.945557],
              [73.890689, 20.951584],
              [73.895563, 20.96073],
              [73.905041, 20.961362],
              [73.909206, 20.963836],
              [73.907763, 20.968973],
              [73.904975, 20.974442],
              [73.900253, 20.982157],
              [73.892422, 20.981247],
              [73.872899, 20.985506],
              [73.866386, 20.98977],
              [73.850934, 20.996745],
              [73.854423, 21.000319],
              [73.856231, 21.015218],
              [73.85638, 21.029958],
              [73.860995, 21.027753],
              [73.883831, 21.028134],
              [73.888971, 21.029337],
              [73.894311, 21.030587],
              [73.907908, 21.035652],
              [73.909258, 21.040403],
              [73.91448, 21.035642],
              [73.934952, 21.038405],
              [73.941669, 21.035712],
              [73.954679, 21.031743],
              [73.960088, 21.0443],
              [73.950723, 21.060314],
              [73.95733, 21.072459],
              [73.951237, 21.080299],
              [73.951316, 21.085938],
              [73.965653, 21.0965],
              [73.973531, 21.102303],
              [73.975727, 21.105798],
              [73.975488, 21.111038],
              [73.986973, 21.113156],
              [74.002968, 21.11969],
              [74.010531, 21.100101],
              [74.017275, 21.102856],
              [74.012666, 21.130943],
              [74.019043, 21.135342],
              [74.019636, 21.14393],
              [74.027423, 21.143227],
              [74.033751, 21.144399],
              [74.040721, 21.1444],
              [74.051712, 21.137929],
              [74.051004, 21.127495],
              [74.062436, 21.126474],
              [74.069461, 21.127397],
              [74.072297, 21.132021],
              [74.082996, 21.136403],
              [74.084162, 21.141053],
              [74.081633, 21.144913],
              [74.058165, 21.171245],
              [74.081714, 21.188469],
              [74.086116, 21.191688],
              [74.091466, 21.192819],
              [74.102926, 21.199971],
              [74.10976, 21.206158],
              [74.114407, 21.21131],
              [74.120481, 21.21385],
              [74.14605, 21.208679],
              [74.149131, 21.212298],
              [74.142072, 21.216443],
              [74.142521, 21.219592],
              [74.149083, 21.222242],
              [74.149038, 21.225464],
              [74.155559, 21.224612],
              [74.156614, 21.231837],
              [74.163244, 21.226293],
              [74.160922, 21.221045],
              [74.161142, 21.216081],
              [74.166477, 21.215367],
              [74.169704, 21.215677],
              [74.176517, 21.210416],
              [74.180712, 21.208829],
              [74.18186, 21.209518],
              [74.183117, 21.216657],
              [74.184131, 21.22038],
              [74.187114, 21.221785],
              [74.196245, 21.221862],
              [74.206099, 21.221137],
              [74.211554, 21.222176],
              [74.213651, 21.223639],
              [74.217329, 21.231608],
              [74.219883, 21.238337],
              [74.222226, 21.240913],
              [74.224845, 21.241659],
              [74.235343, 21.24197],
              [74.239455, 21.244522],
              [74.240764, 21.246046],
              [74.251366, 21.248478],
              [74.265649, 21.249853],
              [74.272158, 21.249272],
              [74.275704, 21.244526],
              [74.27948, 21.241263],
              [74.284793, 21.238795],
              [74.291784, 21.238416],
              [74.297844, 21.239106],
              [74.302684, 21.240764],
              [74.309367, 21.245253],
              [74.314497, 21.247013],
              [74.315133, 21.245932],
              [74.315792, 21.235182],
              [74.317425, 21.233771],
              [74.323591, 21.23428],
              [74.325835, 21.234641],
              [74.329769, 21.234513],
              [74.33117, 21.23162],
              [74.332493, 21.230564],
              [74.33647, 21.231727],
              [74.338514, 21.232173],
              [74.339302, 21.23211],
              [74.340267, 21.230213],
              [74.340703, 21.229216],
              [74.342966, 21.229117],
              [74.34854, 21.231998],
              [74.351572, 21.232296],
              [74.353855, 21.231737],
              [74.355977, 21.232646],
              [74.356793, 21.234242],
              [74.358573, 21.240847],
              [74.358899, 21.244727],
              [74.358522, 21.246647],
              [74.356136, 21.249596],
              [74.355316, 21.250394],
              [74.355065, 21.251674],
              [74.359812, 21.253233],
              [74.363418, 21.253921],
              [74.368392, 21.254752],
              [74.380998, 21.256329],
              [74.389284, 21.257836],
              [74.393938, 21.259299],
              [74.395664, 21.260285],
              [74.398148, 21.261943],
              [74.402257, 21.264674],
              [74.405051, 21.265976],
              [74.408547, 21.266934],
              [74.410536, 21.266364],
              [74.410124, 21.264507],
              [74.40836, 21.259745],
              [74.408105, 21.258814],
              [74.408638, 21.257821],
              [74.412554, 21.258151],
              [74.415564, 21.259],
              [74.41886, 21.260043],
              [74.425448, 21.262221],
              [74.430318, 21.263231],
              [74.432491, 21.262943],
              [74.433142, 21.261494],
              [74.433036, 21.254675],
              [74.43406, 21.2537],
              [74.436289, 21.254428],
              [74.438341, 21.254688],
              [74.439383, 21.253253],
              [74.441021, 21.249354],
              [74.441401, 21.247342],
              [74.441537, 21.246426],
              [74.441207, 21.244941],
              [74.439355, 21.244596],
              [74.437982, 21.244545],
              [74.435726, 21.244461],
              [74.435094, 21.243149],
              [74.435434, 21.239754],
              [74.436398, 21.237856],
              [74.438096, 21.237182],
              [74.44263, 21.236798],
              [74.447451, 21.236608],
              [74.460597, 21.237001],
              [74.474021, 21.237772],
              [74.487329, 21.238938],
              [74.491824, 21.23953],
              [74.488508, 21.246039],
              [74.48818, 21.256248],
              [74.493327, 21.260736],
              [74.498986, 21.265669],
              [74.497865, 21.290215],
              [74.489728, 21.296823],
              [74.476596, 21.295973],
              [74.475493, 21.305878],
              [74.481956, 21.308786],
              [74.479649, 21.326506],
              [74.47877, 21.333257],
              [74.478952, 21.343561],
              [74.47912, 21.353069],
              [74.488759, 21.352962],
              [74.489102, 21.363675],
              [74.489228, 21.367622],
              [74.49144, 21.373505],
              [74.49932, 21.379553],
              [74.506685, 21.385206],
              [74.508567, 21.389603],
              [74.500476, 21.397319],
              [74.494706, 21.391859],
              [74.494034, 21.396163],
              [74.497914, 21.399804],
              [74.498574, 21.406441],
              [74.499407, 21.41483],
              [74.498374, 21.419429],
              [74.49739, 21.421796],
              [74.498044, 21.427345],
              [74.519154, 21.429313],
              [74.520776, 21.429465],
              [74.534034, 21.423069],
              [74.54918, 21.415762],
              [74.55726, 21.413015],
              [74.562099, 21.410151],
              [74.565948, 21.405041],
              [74.5728, 21.403446],
              [74.581382, 21.407797],
              [74.585709, 21.40999],
              [74.589619, 21.412985],
              [74.596233, 21.414789],
              [74.608505, 21.415321],
              [74.624965, 21.407671],
              [74.632643, 21.403122],
              [74.638557, 21.399451],
              [74.656679, 21.404532],
              [74.662801, 21.405892],
              [74.670649, 21.405933],
              [74.685833, 21.40251],
              [74.687525, 21.406898],
              [74.687983, 21.407743],
              [74.691326, 21.41265],
              [74.694211, 21.416712],
              [74.696928, 21.422517],
              [74.69673, 21.424996],
              [74.695678, 21.426709],
              [74.69361, 21.429215],
              [74.692655, 21.430931],
              [74.69285, 21.433424],
              [74.694885, 21.436627],
              [74.696655, 21.439084],
              [74.700016, 21.446017],
              [74.70141, 21.450486],
              [74.701889, 21.453266],
              [74.701721, 21.459891],
              [74.699935, 21.465169],
              [74.698747, 21.467798],
              [74.698541, 21.470462],
              [74.703206, 21.471915],
              [74.710013, 21.473904],
              [74.718004, 21.475843],
              [74.72475, 21.476908],
              [74.726614, 21.477066],
              [74.728434, 21.47584],
              [74.730611, 21.473062],
              [74.731124, 21.472527],
              [74.731451, 21.474196],
              [74.730911, 21.477861],
              [74.730969, 21.478876],
              [74.732686, 21.480225],
              [74.736904, 21.480557],
              [74.742254, 21.479639],
              [74.747557, 21.47743],
              [74.752158, 21.475564],
              [74.754108, 21.476001],
              [74.753977, 21.476825],
              [74.752662, 21.480187],
              [74.751952, 21.483201],
              [74.752035, 21.486059],
              [74.753809, 21.493396],
              [74.756366, 21.500852],
              [74.758993, 21.509048],
              [74.76, 21.513412],
              [74.760553, 21.516838],
              [74.760036, 21.517465],
              [74.757837, 21.518309],
              [74.756122, 21.519355],
              [74.755991, 21.520179],
              [74.756857, 21.523156],
              [74.755819, 21.524502],
              [74.752706, 21.526051],
              [74.752553, 21.527427],
              [74.75292, 21.528084],
              [74.757627, 21.533498],
              [74.758507, 21.536107],
              [74.759172, 21.541656],
              [74.759291, 21.551054],
              [74.758877, 21.561446],
              [74.757999, 21.566205],
              [74.756891, 21.571784],
              [74.756842, 21.575467],
              [74.757228, 21.578151],
              [74.759183, 21.583468],
              [74.762092, 21.589556],
              [74.765406, 21.595381],
              [74.768563, 21.600188],
              [74.771979, 21.605925],
              [74.773323, 21.609287],
              [74.772951, 21.611208],
              [74.77212, 21.613501],
              [74.772237, 21.613502],
              [74.773146, 21.613121],
              [74.774056, 21.612713],
              [74.774967, 21.612289],
              [74.775865, 21.611871],
              [74.776776, 21.611444],
              [74.777686, 21.611036],
              [74.778605, 21.610656],
              [74.77953, 21.610304],
              [74.780463, 21.60999],
              [74.781414, 21.609731],
              [74.782383, 21.60952],
              [74.783358, 21.609317],
              [74.784343, 21.609135],
              [74.78533, 21.608969],
              [74.786323, 21.608814],
              [74.787326, 21.608669],
              [74.788329, 21.608534],
              [74.789341, 21.608414],
              [74.790342, 21.608297],
              [74.791353, 21.608199],
              [74.792364, 21.608109],
              [74.793364, 21.608036],
              [74.794362, 21.607964],
              [74.795361, 21.607902],
              [74.796348, 21.607849],
              [74.797338, 21.607802],
              [74.798314, 21.607776],
              [74.799347, 21.607991],
              [74.800177, 21.608676],
              [74.800348, 21.609504],
              [74.800127, 21.610498],
              [74.799742, 21.611567],
              [74.799372, 21.612581],
              [74.799189, 21.613431],
              [74.799374, 21.613983],
              [74.800178, 21.614066],
              [74.801355, 21.61381],
              [74.80252, 21.613443],
              [74.803445, 21.613081],
              [74.804336, 21.612644],
              [74.8052, 21.61216],
              [74.806064, 21.611668],
              [74.806937, 21.611203],
              [74.807846, 21.610803],
              [74.80878, 21.610479],
              [74.809742, 21.610201],
              [74.810711, 21.609963],
              [74.811699, 21.609762],
              [74.812684, 21.609577],
              [74.813668, 21.609404],
              [74.814655, 21.609228],
              [74.815649, 21.609055],
              [74.816634, 21.608882],
              [74.817628, 21.608718],
              [74.818624, 21.608561],
              [74.819616, 21.608425],
              [74.820618, 21.608308],
              [74.821609, 21.608215],
              [74.822597, 21.608152],
              [74.823585, 21.608117],
              [74.824619, 21.60812],
              [74.825721, 21.608145],
              [74.826832, 21.608215],
              [74.827917, 21.608342],
              [74.828941, 21.608548],
              [74.829843, 21.608829],
              [74.830592, 21.609214],
              [74.831052, 21.60978],
              [74.831074, 21.610658],
              [74.830868, 21.611717],
              [74.830672, 21.612804],
              [74.830748, 21.613765],
              [74.831103, 21.614622],
              [74.831629, 21.615467],
              [74.832278, 21.616244],
              [74.833041, 21.61688],
              [74.833905, 21.617327],
              [74.834799, 21.6177],
              [74.835719, 21.618038],
              [74.836648, 21.618351],
              [74.837606, 21.618644],
              [74.838568, 21.618921],
              [74.839548, 21.619189],
              [74.84052, 21.619446],
              [74.841512, 21.619706],
              [74.842482, 21.619965],
              [74.843454, 21.62024],
              [74.844412, 21.620535],
              [74.845373, 21.620849],
              [74.8463, 21.621187],
              [74.847216, 21.621561],
              [74.848099, 21.621973],
              [74.848973, 21.622429],
              [74.849822, 21.62294],
              [74.85067, 21.623496],
              [74.851493, 21.624088],
              [74.852329, 21.624708],
              [74.853141, 21.625355],
              [74.853943, 21.626009],
              [74.854744, 21.626683],
              [74.855535, 21.627348],
              [74.856317, 21.628004],
              [74.857102, 21.628647],
              [74.857866, 21.629265],
              [74.858634, 21.629856],
              [74.8594, 21.630407],
              [74.860151, 21.630913],
              [74.860907, 21.631354],
              [74.861656, 21.631738],
              [74.862356, 21.631921],
              [74.862827, 21.631187],
              [74.863238, 21.630008],
              [74.863774, 21.629011],
              [74.864601, 21.628645],
              [74.865521, 21.628421],
              [74.866495, 21.628272],
              [74.867505, 21.628183],
              [74.868544, 21.62813],
              [74.869589, 21.628125],
              [74.870632, 21.628146],
              [74.871665, 21.628177],
              [74.872668, 21.628225],
              [74.873659, 21.628328],
              [74.874645, 21.628474],
              [74.875641, 21.62866],
              [74.876625, 21.628873],
              [74.877609, 21.629086],
              [74.878593, 21.629288],
              [74.879579, 21.629464],
              [74.880569, 21.629594],
              [74.881558, 21.629669],
              [74.882555, 21.629678],
              [74.88356, 21.62968],
              [74.884565, 21.629672],
              [74.885583, 21.629656],
              [74.886598, 21.629631],
              [74.887614, 21.629594],
              [74.888633, 21.62955],
              [74.88965, 21.629497],
              [74.890659, 21.629435],
              [74.89168, 21.629354],
              [74.89268, 21.629264],
              [74.893682, 21.629153],
              [74.894674, 21.629034],
              [74.895658, 21.628888],
              [74.896632, 21.62873],
              [74.897596, 21.628556],
              [74.898545, 21.628351],
              [74.899476, 21.628099],
              [74.900354, 21.62767],
              [74.901174, 21.627093],
              [74.901933, 21.6264],
              [74.902611, 21.625659],
              [74.903234, 21.624894],
              [74.903779, 21.624119],
              [74.904237, 21.623294],
              [74.90465, 21.622428],
              [74.905032, 21.621534],
              [74.905396, 21.620639],
              [74.90578, 21.619752],
              [74.9062, 21.618889],
              [74.906668, 21.618071],
              [74.907231, 21.617323],
              [74.907868, 21.616636],
              [74.908566, 21.615978],
              [74.909319, 21.615359],
              [74.910117, 21.614769],
              [74.910946, 21.61421],
              [74.911794, 21.613679],
              [74.912668, 21.613174],
              [74.913541, 21.612699],
              [74.914422, 21.612252],
              [74.915304, 21.611815],
              [74.916194, 21.611396],
              [74.917101, 21.610996],
              [74.918009, 21.610617],
              [74.918927, 21.610236],
              [74.919862, 21.609883],
              [74.920787, 21.609529],
              [74.921733, 21.609188],
              [74.922667, 21.608854],
              [74.92361, 21.608529],
              [74.924563, 21.608206],
              [74.925508, 21.60789],
              [74.926451, 21.607584],
              [74.927403, 21.60728],
              [74.928346, 21.606964],
              [74.929288, 21.606657],
              [74.930241, 21.606353],
              [74.931183, 21.606046],
              [74.932138, 21.605742],
              [74.93308, 21.605435],
              [74.934032, 21.605138],
              [74.934985, 21.604834],
              [74.935927, 21.604527],
              [74.936879, 21.604232],
              [74.937831, 21.603935],
              [74.938783, 21.603638],
              [74.939735, 21.603343],
              [74.940687, 21.603046],
              [74.941638, 21.60276],
              [74.94259, 21.602463],
              [74.943542, 21.602175],
              [74.944493, 21.601889],
              [74.945454, 21.601601],
              [74.946406, 21.601324],
              [74.947367, 21.601037],
              [74.948318, 21.60076],
              [74.949279, 21.600481],
              [74.95024, 21.600214],
              [74.951201, 21.599936],
              [74.952152, 21.599666],
              [74.953122, 21.599399],
              [74.954082, 21.599139],
              [74.95504, 21.598881],
              [74.956, 21.598621],
              [74.95697, 21.598363],
              [74.95793, 21.598121],
              [74.958899, 21.597882],
              [74.959875, 21.597659],
              [74.960854, 21.597448],
              [74.961828, 21.597255],
              [74.962806, 21.59705],
              [74.963791, 21.596867],
              [74.964775, 21.596681],
              [74.965762, 21.596498],
              [74.966746, 21.596323],
              [74.967733, 21.596138],
              [74.968717, 21.595963],
              [74.969702, 21.59578],
              [74.970689, 21.595594],
              [74.971673, 21.59541],
              [74.972648, 21.595215],
              [74.973626, 21.595013],
              [74.974601, 21.594801],
              [74.975579, 21.594588],
              [74.976538, 21.594357],
              [74.977506, 21.594106],
              [74.978466, 21.593857],
              [74.979426, 21.593579],
              [74.980378, 21.5933],
              [74.981329, 21.593014],
              [74.982281, 21.592707],
              [74.983233, 21.592402],
              [74.984178, 21.592086],
              [74.985121, 21.591761],
              [74.986054, 21.591428],
              [74.986988, 21.591084],
              [74.987925, 21.59074],
              [74.988859, 21.590389],
              [74.989786, 21.590026],
              [74.99071, 21.589663],
              [74.991628, 21.589291],
              [74.992553, 21.588928],
              [74.993471, 21.588548],
              [74.994386, 21.588167],
              [74.995285, 21.587766],
              [74.996175, 21.587337],
              [74.997056, 21.58689],
              [74.997928, 21.586424],
              [74.998791, 21.585958],
              [74.999663, 21.585482],
              [75.000525, 21.585005],
              [75.001397, 21.584538],
              [75.002626, 21.583886],
              [75.011278, 21.579018],
              [75.01372, 21.575713],
              [75.015714, 21.570442],
              [75.029758, 21.56714],
              [75.051534, 21.565014],
              [75.055722, 21.562757],
              [75.058155, 21.557155],
              [75.061563, 21.552826],
              [75.063007, 21.548644],
              [75.070217, 21.539475],
              [75.074257, 21.535848],
              [75.076331, 21.529953],
              [75.081561, 21.523579],
              [75.08801, 21.512164],
              [75.090692, 21.498752],
              [75.092905, 21.491657],
              [75.09846, 21.483159],
              [75.104695, 21.467487],
              [75.113155, 21.457416],
              [75.121038, 21.45119],
              [75.127855, 21.447133],
              [75.145555, 21.441189],
              [75.155523, 21.436123],
              [75.186254, 21.425153],
              [75.194237, 21.420696],
              [75.201981, 21.415161],
              [75.205718, 21.41368],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 154,
        censuscode: 498,
        dt_cen_cd: 2,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Dhule",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [78.314777, 19.913107],
              [78.312192, 19.908868],
              [78.302242, 19.873697],
              [78.29877, 19.855971],
              [78.298683, 19.849991],
              [78.307735, 19.846274],
              [78.343631, 19.839677],
              [78.346016, 19.833438],
              [78.340599, 19.819158],
              [78.343848, 19.814034],
              [78.35628, 19.810884],
              [78.365156, 19.806293],
              [78.371677, 19.795118],
              [78.372421, 19.781671],
              [78.369475, 19.767948],
              [78.365479, 19.754605],
              [78.357872, 19.738397],
              [78.350072, 19.735062],
              [78.348959, 19.724981],
              [78.349941, 19.714241],
              [78.337152, 19.709176],
              [78.327328, 19.70431],
              [78.324734, 19.697381],
              [78.320662, 19.691222],
              [78.309551, 19.6891],
              [78.290379, 19.690314],
              [78.277951, 19.670813],
              [78.274273, 19.663801],
              [78.277209, 19.660849],
              [78.292144, 19.655156],
              [78.296999, 19.644873],
              [78.300094, 19.632562],
              [78.303568, 19.624156],
              [78.313511, 19.612171],
              [78.315612, 19.604955],
              [78.314666, 19.587524],
              [78.316676, 19.579386],
              [78.315787, 19.572601],
              [78.310748, 19.568276],
              [78.304512, 19.567606],
              [78.303889, 19.562132],
              [78.30112, 19.559213],
              [78.289944, 19.561178],
              [78.283693, 19.559018],
              [78.289213, 19.551226],
              [78.296054, 19.543962],
              [78.299638, 19.538151],
              [78.300079, 19.531721],
              [78.303329, 19.514461],
              [78.304044, 19.505042],
              [78.308244, 19.494698],
              [78.314658, 19.487378],
              [78.316697, 19.480224],
              [78.316609, 19.46688],
              [78.313556, 19.457404],
              [78.301949, 19.44982],
              [78.295758, 19.449786],
              [78.286587, 19.453959],
              [78.277824, 19.454804],
              [78.271508, 19.448904],
              [78.2664, 19.441066],
              [78.256568, 19.431024],
              [78.250351, 19.429956],
              [78.238153, 19.433847],
              [78.228774, 19.434978],
              [78.219576, 19.427992],
              [78.209952, 19.415306],
              [78.202582, 19.40841],
              [78.186608, 19.412703],
              [78.192025, 19.39658],
              [78.191451, 19.38553],
              [78.189283, 19.377271],
              [78.188923, 19.369214],
              [78.185815, 19.361754],
              [78.184053, 19.354019],
              [78.186715, 19.346472],
              [78.191595, 19.339643],
              [78.201644, 19.332789],
              [78.199541, 19.326029],
              [78.199998, 19.315457],
              [78.19767, 19.304033],
              [78.187622, 19.280073],
              [78.187742, 19.26231],
              [78.190902, 19.250513],
              [78.187807, 19.242706],
              [78.174512, 19.237497],
              [78.154158, 19.2312],
              [78.143676, 19.240574],
              [78.131096, 19.247504],
              [78.10371, 19.246557],
              [78.099453, 19.25092],
              [78.086561, 19.255826],
              [78.079421, 19.247608],
              [78.061824, 19.240804],
              [78.055381, 19.24279],
              [78.05229, 19.248542],
              [78.051848, 19.25665],
              [78.053689, 19.263746],
              [78.049976, 19.271851],
              [78.037082, 19.27509],
              [78.03148, 19.279652],
              [78.022432, 19.297262],
              [78.015788, 19.302034],
              [78.000021, 19.306616],
              [77.989619, 19.309883],
              [77.981001, 19.321906],
              [77.970727, 19.328168],
              [77.96679, 19.332601],
              [77.952962, 19.342092],
              [77.94466, 19.343297],
              [77.941264, 19.336554],
              [77.930345, 19.332708],
              [77.926057, 19.326728],
              [77.916254, 19.318759],
              [77.909757, 19.316587],
              [77.903483, 19.31859],
              [77.897204, 19.321946],
              [77.891977, 19.313201],
              [77.879146, 19.309684],
              [77.875033, 19.306521],
              [77.864751, 19.302918],
              [77.866547, 19.296161],
              [77.864743, 19.288438],
              [77.86581, 19.284904],
              [77.879307, 19.280602],
              [77.897014, 19.279237],
              [77.904639, 19.277988],
              [77.909693, 19.268085],
              [77.904373, 19.256996],
              [77.89584, 19.257973],
              [77.888584, 19.261089],
              [77.871306, 19.256117],
              [77.871985, 19.246977],
              [77.869316, 19.238799],
              [77.866208, 19.234835],
              [77.865428, 19.227172],
              [77.862353, 19.219358],
              [77.85623, 19.210607],
              [77.856573, 19.205493],
              [77.850436, 19.197889],
              [77.848407, 19.189113],
              [77.862318, 19.181713],
              [77.856909, 19.177759],
              [77.858124, 19.173245],
              [77.857776, 19.170389],
              [77.854274, 19.168609],
              [77.854072, 19.163276],
              [77.852633, 19.160397],
              [77.853139, 19.156251],
              [77.841572, 19.13929],
              [77.834948, 19.136634],
              [77.837802, 19.133728],
              [77.842525, 19.119853],
              [77.849104, 19.115224],
              [77.848062, 19.097111],
              [77.852092, 19.09365],
              [77.852053, 19.091132],
              [77.850499, 19.089573],
              [77.846089, 19.087825],
              [77.83768, 19.087578],
              [77.832495, 19.085974],
              [77.829367, 19.092727],
              [77.826234, 19.097424],
              [77.819021, 19.10467],
              [77.809591, 19.104341],
              [77.806465, 19.102956],
              [77.80406, 19.099874],
              [77.803594, 19.095582],
              [77.805139, 19.085431],
              [77.801091, 19.075627],
              [77.79827, 19.074398],
              [77.797342, 19.07224],
              [77.800971, 19.065922],
              [77.799496, 19.062069],
              [77.800998, 19.052368],
              [77.798368, 19.051245],
              [77.794944, 19.051708],
              [77.786902, 19.05587],
              [77.781749, 19.055402],
              [77.774757, 19.057187],
              [77.765442, 19.063056],
              [77.763298, 19.060313],
              [77.764683, 19.052233],
              [77.761131, 19.029602],
              [77.763993, 19.023705],
              [77.765904, 19.021574],
              [77.768038, 19.020697],
              [77.769088, 19.016466],
              [77.769516, 19.008469],
              [77.772209, 19.000483],
              [77.771144, 18.982544],
              [77.785321, 18.977466],
              [77.790951, 18.985423],
              [77.821017, 18.983538],
              [77.816749, 18.961259],
              [77.819091, 18.960442],
              [77.816567, 18.950664],
              [77.831286, 18.946947],
              [77.83442, 18.951433],
              [77.857692, 18.953537],
              [77.852653, 18.932652],
              [77.848256, 18.931583],
              [77.845068, 18.922733],
              [77.844435, 18.912596],
              [77.860624, 18.907383],
              [77.873258, 18.911639],
              [77.885596, 18.909862],
              [77.886634, 18.897723],
              [77.891705, 18.886496],
              [77.902726, 18.885122],
              [77.903276, 18.869334],
              [77.910161, 18.868736],
              [77.929448, 18.860654],
              [77.928714, 18.855603],
              [77.936489, 18.852391],
              [77.933768, 18.847956],
              [77.948285, 18.843773],
              [77.949392, 18.833611],
              [77.946718, 18.823806],
              [77.93287, 18.823223],
              [77.91167, 18.830984],
              [77.863217, 18.815499],
              [77.841409, 18.808883],
              [77.831501, 18.787449],
              [77.827136, 18.769965],
              [77.81432, 18.74175],
              [77.806636, 18.730754],
              [77.806131, 18.717639],
              [77.790416, 18.695857],
              [77.790331, 18.685665],
              [77.773271, 18.69211],
              [77.772662, 18.703127],
              [77.768245, 18.709434],
              [77.761488, 18.708563],
              [77.753755, 18.699326],
              [77.753326, 18.691281],
              [77.748504, 18.685396],
              [77.736655, 18.6775],
              [77.731904, 18.665722],
              [77.737037, 18.663658],
              [77.73697, 18.65724],
              [77.734721, 18.656852],
              [77.733909, 18.649643],
              [77.733557, 18.647135],
              [77.733511, 18.644269],
              [77.739837, 18.632464],
              [77.746802, 18.622991],
              [77.751941, 18.606928],
              [77.751019, 18.590719],
              [77.739212, 18.564836],
              [77.740341, 18.556479],
              [77.731754, 18.553212],
              [77.716149, 18.556091],
              [77.686486, 18.542452],
              [77.679618, 18.542968],
              [77.665772, 18.53488],
              [77.66125, 18.528835],
              [77.64896, 18.537909],
              [77.653136, 18.542935],
              [77.65587, 18.55122],
              [77.653205, 18.551251],
              [77.652472, 18.554203],
              [77.644116, 18.555508],
              [77.638038, 18.546766],
              [77.632685, 18.552215],
              [77.61992, 18.550232],
              [77.619406, 18.544508],
              [77.616902, 18.543965],
              [77.614445, 18.549325],
              [77.600827, 18.549086],
              [77.601755, 18.536602],
              [77.596837, 18.529591],
              [77.596843, 18.524719],
              [77.603981, 18.526546],
              [77.60502, 18.52353],
              [77.600044, 18.51658],
              [77.59061, 18.511435],
              [77.589808, 18.504518],
              [77.597454, 18.495487],
              [77.606422, 18.493009],
              [77.607344, 18.486897],
              [77.604646, 18.475858],
              [77.596698, 18.475144],
              [77.594322, 18.482736],
              [77.580038, 18.485393],
              [77.574151, 18.468487],
              [77.563905, 18.469107],
              [77.561585, 18.46689],
              [77.549999, 18.467329],
              [77.549674, 18.464989],
              [77.552355, 18.462428],
              [77.553276, 18.459592],
              [77.562584, 18.459634],
              [77.587196, 18.455203],
              [77.586836, 18.448851],
              [77.588768, 18.447119],
              [77.586201, 18.44474],
              [77.57767, 18.441007],
              [77.570454, 18.440267],
              [77.563677, 18.436706],
              [77.549918, 18.4422],
              [77.537963, 18.444024],
              [77.531911, 18.442097],
              [77.529376, 18.428989],
              [77.539446, 18.425101],
              [77.538637, 18.422828],
              [77.547613, 18.422079],
              [77.558695, 18.419533],
              [77.552818, 18.38943],
              [77.545057, 18.38693],
              [77.533952, 18.377483],
              [77.524844, 18.36636],
              [77.522953, 18.350989],
              [77.530804, 18.341153],
              [77.545706, 18.335675],
              [77.556903, 18.333013],
              [77.570481, 18.319778],
              [77.5738, 18.310023],
              [77.558583, 18.300144],
              [77.553502, 18.293192],
              [77.543094, 18.295658],
              [77.527373, 18.304833],
              [77.523241, 18.309157],
              [77.512956, 18.308514],
              [77.511878, 18.303958],
              [77.516094, 18.283801],
              [77.513668, 18.280259],
              [77.501168, 18.275164],
              [77.495647, 18.26771],
              [77.483742, 18.270447],
              [77.478195, 18.264093],
              [77.472613, 18.264958],
              [77.468756, 18.261758],
              [77.454128, 18.267738],
              [77.448544, 18.271869],
              [77.448198, 18.278996],
              [77.440217, 18.283786],
              [77.437897, 18.294705],
              [77.439649, 18.308193],
              [77.431056, 18.310873],
              [77.42824, 18.306371],
              [77.411029, 18.30125],
              [77.3995, 18.304652],
              [77.395746, 18.3026],
              [77.38445, 18.307605],
              [77.365637, 18.309924],
              [77.361925, 18.312274],
              [77.358523, 18.320131],
              [77.370131, 18.323945],
              [77.377082, 18.33113],
              [77.381163, 18.330312],
              [77.384051, 18.333549],
              [77.38244, 18.340711],
              [77.389352, 18.339809],
              [77.392404, 18.342408],
              [77.396015, 18.342171],
              [77.395955, 18.347282],
              [77.399123, 18.34626],
              [77.401515, 18.349116],
              [77.401434, 18.355141],
              [77.394994, 18.367511],
              [77.403844, 18.371761],
              [77.411087, 18.380079],
              [77.413311, 18.390106],
              [77.403679, 18.39936],
              [77.395805, 18.398581],
              [77.372858, 18.402231],
              [77.36749, 18.431319],
              [77.368456, 18.439554],
              [77.372725, 18.449113],
              [77.357109, 18.450183],
              [77.348324, 18.435829],
              [77.3451, 18.431744],
              [77.340325, 18.436887],
              [77.336381, 18.443325],
              [77.33571, 18.449883],
              [77.329014, 18.450269],
              [77.328575, 18.456532],
              [77.32037, 18.455191],
              [77.316235, 18.440797],
              [77.305208, 18.439887],
              [77.297689, 18.434094],
              [77.267413, 18.419783],
              [77.267575, 18.431306],
              [77.264119, 18.44151],
              [77.256002, 18.447793],
              [77.256508, 18.453628],
              [77.268332, 18.452971],
              [77.275114, 18.449892],
              [77.286483, 18.45367],
              [77.29395, 18.45825],
              [77.300781, 18.46693],
              [77.30095, 18.476736],
              [77.291745, 18.476168],
              [77.286111, 18.473877],
              [77.274899, 18.474858],
              [77.265785, 18.476688],
              [77.264296, 18.480981],
              [77.251957, 18.482282],
              [77.248519, 18.491111],
              [77.247292, 18.49912],
              [77.271228, 18.521789],
              [77.277346, 18.520223],
              [77.287527, 18.531434],
              [77.287984, 18.537617],
              [77.290089, 18.542365],
              [77.296487, 18.547334],
              [77.288039, 18.552756],
              [77.280767, 18.559242],
              [77.275311, 18.562225],
              [77.266658, 18.565471],
              [77.267377, 18.580825],
              [77.27058, 18.584233],
              [77.267922, 18.591077],
              [77.270621, 18.610964],
              [77.251447, 18.617867],
              [77.214194, 18.624819],
              [77.212314, 18.635148],
              [77.208852, 18.638233],
              [77.205476, 18.638628],
              [77.201347, 18.643459],
              [77.199785, 18.647238],
              [77.178003, 18.648703],
              [77.155839, 18.646344],
              [77.157487, 18.657306],
              [77.157753, 18.67182],
              [77.159382, 18.680375],
              [77.177807, 18.679691],
              [77.186483, 18.685686],
              [77.194364, 18.689459],
              [77.182134, 18.702447],
              [77.166256, 18.703479],
              [77.157051, 18.701407],
              [77.149831, 18.706026],
              [77.146103, 18.712156],
              [77.136628, 18.710881],
              [77.136313, 18.698338],
              [77.119086, 18.695337],
              [77.100786, 18.694374],
              [77.095054, 18.691219],
              [77.080611, 18.69015],
              [77.067723, 18.686398],
              [77.067461, 18.682503],
              [77.059749, 18.683413],
              [77.046547, 18.682998],
              [77.046845, 18.689802],
              [77.044408, 18.694753],
              [77.044645, 18.698012],
              [77.052102, 18.716542],
              [77.056996, 18.718174],
              [77.057577, 18.729863],
              [77.054674, 18.738821],
              [77.054481, 18.745857],
              [77.056849, 18.765842],
              [77.053382, 18.772522],
              [77.046615, 18.773075],
              [77.025577, 18.767107],
              [77.008128, 18.767097],
              [77.005136, 18.788477],
              [77.001302, 18.809817],
              [77.001013, 18.8181],
              [77.000048, 18.81915],
              [76.995371, 18.827376],
              [76.997936, 18.830797],
              [77.000046, 18.832364],
              [77.009824, 18.839977],
              [77.01904, 18.842979],
              [77.016712, 18.862003],
              [77.012821, 18.877908],
              [77.012637, 18.877919],
              [77.003216, 18.878519],
              [77.000047, 18.880506],
              [76.994484, 18.879317],
              [76.978792, 18.878151],
              [76.957146, 18.874375],
              [76.95706, 18.875004],
              [76.956282, 18.880682],
              [76.958068, 18.889661],
              [76.957657, 18.889824],
              [76.95314, 18.891616],
              [76.935584, 18.896324],
              [76.935363, 18.896883],
              [76.934015, 18.900294],
              [76.939929, 18.903425],
              [76.951036, 18.906716],
              [76.950913, 18.913831],
              [76.952371, 18.922064],
              [76.956021, 18.92712],
              [76.961899, 18.932252],
              [76.964621, 18.931986],
              [76.973123, 18.927409],
              [76.975576, 18.923409],
              [76.975888, 18.9229],
              [76.977131, 18.915585],
              [76.977225, 18.91503],
              [76.984532, 18.914017],
              [76.986729, 18.915416],
              [76.988285, 18.922274],
              [76.993468, 18.936254],
              [77.000042, 18.931581],
              [77.004346, 18.929495],
              [77.010211, 18.931925],
              [77.02062, 18.934193],
              [77.022968, 18.939361],
              [77.026252, 18.939498],
              [77.029386, 18.952325],
              [77.032193, 18.95217],
              [77.035018, 18.964473],
              [77.039121, 18.971537],
              [77.054786, 18.988163],
              [77.055426, 18.995386],
              [77.055081, 18.995755],
              [77.051244, 18.999866],
              [77.042865, 19.003167],
              [77.04288, 19.003621],
              [77.043132, 19.011094],
              [77.042336, 19.016422],
              [77.044661, 19.030068],
              [77.065612, 19.029004],
              [77.067302, 19.041922],
              [77.066533, 19.047811],
              [77.062255, 19.058794],
              [77.062721, 19.067389],
              [77.067899, 19.076059],
              [77.071224, 19.079917],
              [77.076848, 19.084146],
              [77.078825, 19.092682],
              [77.083539, 19.100326],
              [77.084933, 19.107628],
              [77.101266, 19.107131],
              [77.102107, 19.107104],
              [77.104087, 19.103722],
              [77.104397, 19.103193],
              [77.105572, 19.098795],
              [77.104747, 19.095498],
              [77.102078, 19.093398],
              [77.091893, 19.090212],
              [77.089403, 19.087768],
              [77.08753, 19.084042],
              [77.087063, 19.075649],
              [77.087932, 19.071836],
              [77.088008, 19.071499],
              [77.090818, 19.068661],
              [77.098035, 19.066328],
              [77.117183, 19.07613],
              [77.125163, 19.078312],
              [77.128622, 19.077241],
              [77.137396, 19.07062],
              [77.141415, 19.070101],
              [77.14436, 19.071742],
              [77.147687, 19.075369],
              [77.153007, 19.077626],
              [77.158691, 19.083427],
              [77.164399, 19.093368],
              [77.166733, 19.105296],
              [77.165897, 19.110771],
              [77.166322, 19.116158],
              [77.168618, 19.11977],
              [77.172429, 19.122063],
              [77.177714, 19.119434],
              [77.182157, 19.124071],
              [77.182369, 19.130324],
              [77.188972, 19.129435],
              [77.191539, 19.130393],
              [77.19483, 19.143736],
              [77.194059, 19.156344],
              [77.194966, 19.165277],
              [77.194577, 19.165234],
              [77.18884, 19.1646],
              [77.18239, 19.164905],
              [77.178872, 19.169724],
              [77.178908, 19.169817],
              [77.181183, 19.175623],
              [77.179311, 19.180854],
              [77.182236, 19.186914],
              [77.18329, 19.193085],
              [77.182351, 19.20282],
              [77.182038, 19.203274],
              [77.179645, 19.206748],
              [77.179568, 19.206976],
              [77.178272, 19.210809],
              [77.179148, 19.217048],
              [77.181239, 19.223475],
              [77.184243, 19.230051],
              [77.187719, 19.233157],
              [77.195188, 19.236093],
              [77.195544, 19.242857],
              [77.205601, 19.242209],
              [77.205813, 19.251974],
              [77.211047, 19.256525],
              [77.222071, 19.269974],
              [77.222869, 19.273916],
              [77.238202, 19.273738],
              [77.238591, 19.309852],
              [77.244297, 19.320887],
              [77.262005, 19.315692],
              [77.262235, 19.315625],
              [77.262484, 19.314264],
              [77.262594, 19.313661],
              [77.280094, 19.314789],
              [77.283346, 19.324973],
              [77.298093, 19.326994],
              [77.301959, 19.33216],
              [77.310283, 19.330008],
              [77.314561, 19.340213],
              [77.313858, 19.353395],
              [77.313828, 19.353955],
              [77.333999, 19.355235],
              [77.342012, 19.352814],
              [77.351859, 19.352166],
              [77.352144, 19.352147],
              [77.352561, 19.346168],
              [77.35259, 19.345755],
              [77.364422, 19.33873],
              [77.380962, 19.338272],
              [77.386138, 19.340921],
              [77.389682, 19.352362],
              [77.401781, 19.356405],
              [77.40903, 19.363015],
              [77.415522, 19.365394],
              [77.418573, 19.371563],
              [77.419726, 19.376642],
              [77.436556, 19.377437],
              [77.442659, 19.379131],
              [77.446015, 19.381788],
              [77.449741, 19.382757],
              [77.451647, 19.389018],
              [77.451296, 19.38952],
              [77.444001, 19.399949],
              [77.4373, 19.40705],
              [77.437401, 19.407188],
              [77.449317, 19.42362],
              [77.45249, 19.439661],
              [77.472332, 19.436794],
              [77.477595, 19.455298],
              [77.490357, 19.457019],
              [77.493647, 19.466325],
              [77.493302, 19.466857],
              [77.487974, 19.47507],
              [77.488002, 19.475116],
              [77.490992, 19.480086],
              [77.489724, 19.495231],
              [77.489462, 19.495064],
              [77.48279, 19.490802],
              [77.476168, 19.488255],
              [77.47409, 19.489295],
              [77.474062, 19.489735],
              [77.473626, 19.496662],
              [77.473328, 19.496834],
              [77.470247, 19.498607],
              [77.470292, 19.498984],
              [77.473698, 19.527453],
              [77.473341, 19.527773],
              [77.470649, 19.530192],
              [77.470586, 19.530545],
              [77.46843, 19.542723],
              [77.469286, 19.556363],
              [77.468865, 19.563325],
              [77.468578, 19.563295],
              [77.456051, 19.562015],
              [77.456196, 19.562652],
              [77.457122, 19.566744],
              [77.456683, 19.56683],
              [77.453938, 19.567363],
              [77.454231, 19.567832],
              [77.463696, 19.583021],
              [77.481123, 19.599932],
              [77.48063, 19.600358],
              [77.471261, 19.608455],
              [77.46666, 19.608544],
              [77.459721, 19.612322],
              [77.460193, 19.612477],
              [77.466763, 19.614633],
              [77.470678, 19.641391],
              [77.47028, 19.641481],
              [77.467137, 19.642192],
              [77.467184, 19.642697],
              [77.467429, 19.645337],
              [77.467052, 19.645366],
              [77.464772, 19.64554],
              [77.465002, 19.646087],
              [77.469268, 19.656258],
              [77.470062, 19.664675],
              [77.469684, 19.664705],
              [77.464135, 19.665146],
              [77.464003, 19.66572],
              [77.462779, 19.671043],
              [77.462587, 19.671053],
              [77.457101, 19.671338],
              [77.456963, 19.671918],
              [77.456413, 19.674233],
              [77.456234, 19.674206],
              [77.453554, 19.673805],
              [77.453514, 19.674437],
              [77.453362, 19.676859],
              [77.459593, 19.681949],
              [77.462786, 19.679722],
              [77.467371, 19.67929],
              [77.476638, 19.68279],
              [77.47905, 19.682367],
              [77.48264, 19.676335],
              [77.48485, 19.675291],
              [77.491494, 19.678295],
              [77.495037, 19.679102],
              [77.502123, 19.677617],
              [77.505339, 19.676068],
              [77.513218, 19.67444],
              [77.516646, 19.672319],
              [77.523228, 19.66998],
              [77.529519, 19.66983],
              [77.534929, 19.668567],
              [77.539535, 19.668696],
              [77.539062, 19.663949],
              [77.542519, 19.662462],
              [77.546554, 19.66192],
              [77.555034, 19.663718],
              [77.554119, 19.660299],
              [77.555223, 19.652453],
              [77.568354, 19.650355],
              [77.574027, 19.651599],
              [77.5803, 19.65766],
              [77.582572, 19.656725],
              [77.584188, 19.653051],
              [77.586495, 19.651363],
              [77.596996, 19.650674],
              [77.599684, 19.647774],
              [77.601066, 19.644397],
              [77.607463, 19.646937],
              [77.608994, 19.644299],
              [77.608199, 19.640765],
              [77.610982, 19.639064],
              [77.615107, 19.639277],
              [77.616807, 19.637784],
              [77.614128, 19.632189],
              [77.616017, 19.629304],
              [77.627143, 19.62727],
              [77.629217, 19.624388],
              [77.630193, 19.621256],
              [77.628429, 19.614419],
              [77.629464, 19.608006],
              [77.633526, 19.608337],
              [77.638305, 19.609893],
              [77.642599, 19.609699],
              [77.644766, 19.607785],
              [77.644801, 19.605259],
              [77.643267, 19.59991],
              [77.640599, 19.596441],
              [77.64057, 19.587477],
              [77.648241, 19.563963],
              [77.64932, 19.555548],
              [77.642308, 19.555664],
              [77.636218, 19.557995],
              [77.634141, 19.555709],
              [77.639904, 19.551154],
              [77.646304, 19.547546],
              [77.659292, 19.546768],
              [77.66589, 19.545399],
              [77.673593, 19.54077],
              [77.689106, 19.539843],
              [77.700407, 19.537855],
              [77.705823, 19.533701],
              [77.713925, 19.525617],
              [77.72272, 19.527663],
              [77.729209, 19.53146],
              [77.733708, 19.53205],
              [77.749662, 19.521791],
              [77.754135, 19.515265],
              [77.752771, 19.509628],
              [77.739176, 19.501668],
              [77.736444, 19.494936],
              [77.73584, 19.491739],
              [77.739739, 19.486153],
              [77.740292, 19.483089],
              [77.73736, 19.480497],
              [77.728696, 19.478723],
              [77.725344, 19.474712],
              [77.722269, 19.474871],
              [77.717563, 19.476866],
              [77.713981, 19.476478],
              [77.710674, 19.467231],
              [77.705419, 19.464256],
              [77.7011, 19.461817],
              [77.699082, 19.459765],
              [77.698452, 19.457376],
              [77.698099, 19.44935],
              [77.695967, 19.440983],
              [77.698911, 19.438649],
              [77.704472, 19.438637],
              [77.707618, 19.437146],
              [77.713192, 19.437363],
              [77.722352, 19.43475],
              [77.732644, 19.433716],
              [77.742105, 19.437461],
              [77.748994, 19.431032],
              [77.75618, 19.432275],
              [77.774983, 19.438674],
              [77.781978, 19.4448],
              [77.789513, 19.448837],
              [77.798103, 19.450478],
              [77.801339, 19.459373],
              [77.804859, 19.464296],
              [77.809947, 19.462961],
              [77.816122, 19.453569],
              [77.819676, 19.445296],
              [77.825675, 19.440835],
              [77.830374, 19.43866],
              [77.834694, 19.439315],
              [77.837655, 19.448779],
              [77.847038, 19.452278],
              [77.847541, 19.45581],
              [77.837948, 19.462986],
              [77.83217, 19.468641],
              [77.827532, 19.475403],
              [77.828504, 19.4803],
              [77.843514, 19.483706],
              [77.846955, 19.486735],
              [77.843735, 19.494309],
              [77.842874, 19.509834],
              [77.847785, 19.514926],
              [77.853524, 19.51776],
              [77.861578, 19.519574],
              [77.869764, 19.513763],
              [77.877384, 19.512157],
              [77.878669, 19.509187],
              [77.879338, 19.504748],
              [77.882493, 19.500213],
              [77.885463, 19.500334],
              [77.890552, 19.505077],
              [77.888347, 19.512497],
              [77.889946, 19.519378],
              [77.898739, 19.523122],
              [77.901733, 19.526975],
              [77.904175, 19.53239],
              [77.907599, 19.533238],
              [77.912779, 19.530927],
              [77.912893, 19.527823],
              [77.916583, 19.515206],
              [77.932421, 19.508574],
              [77.936061, 19.504198],
              [77.938155, 19.500385],
              [77.94345, 19.498288],
              [77.947487, 19.501026],
              [77.953145, 19.509432],
              [77.958826, 19.510939],
              [77.972392, 19.508477],
              [77.975739, 19.506086],
              [77.973497, 19.496955],
              [77.974161, 19.493866],
              [77.980254, 19.48908],
              [77.987199, 19.478571],
              [77.986421, 19.465392],
              [77.987031, 19.459957],
              [77.99103, 19.455553],
              [77.991437, 19.455198],
              [78.000021, 19.462597],
              [78.009426, 19.461407],
              [78.01317, 19.465439],
              [78.014847, 19.483589],
              [78.016417, 19.490734],
              [78.019503, 19.496117],
              [78.02589, 19.497401],
              [78.030711, 19.494691],
              [78.044151, 19.482919],
              [78.053949, 19.476583],
              [78.063197, 19.466904],
              [78.067865, 19.466999],
              [78.074209, 19.471027],
              [78.083045, 19.478649],
              [78.095475, 19.487329],
              [78.101978, 19.486939],
              [78.114378, 19.491371],
              [78.121075, 19.501359],
              [78.1217, 19.508195],
              [78.123357, 19.514596],
              [78.125204, 19.51744],
              [78.135108, 19.525831],
              [78.136261, 19.531181],
              [78.135031, 19.535118],
              [78.130236, 19.540701],
              [78.12343, 19.546469],
              [78.119906, 19.553619],
              [78.124758, 19.557504],
              [78.131612, 19.557526],
              [78.139976, 19.553903],
              [78.147412, 19.5529],
              [78.158417, 19.555869],
              [78.167098, 19.559135],
              [78.184604, 19.563656],
              [78.189027, 19.567355],
              [78.189867, 19.571153],
              [78.18562, 19.584085],
              [78.192323, 19.592178],
              [78.191963, 19.604786],
              [78.195476, 19.613911],
              [78.195701, 19.618274],
              [78.194727, 19.625536],
              [78.189406, 19.635923],
              [78.187055, 19.642471],
              [78.178994, 19.655041],
              [78.174377, 19.656953],
              [78.168691, 19.657992],
              [78.163065, 19.66098],
              [78.153111, 19.664684],
              [78.140299, 19.666789],
              [78.131053, 19.667119],
              [78.127336, 19.664127],
              [78.125904, 19.659687],
              [78.122383, 19.658014],
              [78.107073, 19.659947],
              [78.102145, 19.656924],
              [78.097895, 19.65163],
              [78.095369, 19.645441],
              [78.089856, 19.645214],
              [78.082223, 19.648451],
              [78.076754, 19.655566],
              [78.071867, 19.663729],
              [78.066972, 19.668159],
              [78.05668, 19.670992],
              [78.055467, 19.685189],
              [78.05288, 19.691553],
              [78.047102, 19.69889],
              [78.040304, 19.70031],
              [78.031845, 19.69922],
              [78.019263, 19.694105],
              [78.000019, 19.681474],
              [77.997032, 19.680731],
              [77.98846, 19.680786],
              [77.984551, 19.686572],
              [77.985388, 19.699407],
              [77.982119, 19.701609],
              [77.970561, 19.702527],
              [77.9649, 19.706408],
              [77.961017, 19.717361],
              [77.953178, 19.729356],
              [77.936855, 19.736861],
              [77.933556, 19.739319],
              [77.923088, 19.73496],
              [77.91975, 19.731697],
              [77.91441, 19.729784],
              [77.906252, 19.73185],
              [77.902303, 19.734884],
              [77.899459, 19.734879],
              [77.897539, 19.732308],
              [77.897345, 19.7288],
              [77.89595, 19.725582],
              [77.891589, 19.727188],
              [77.878368, 19.737874],
              [77.877437, 19.743776],
              [77.876737, 19.744437],
              [77.872212, 19.743226],
              [77.869783, 19.741707],
              [77.866679, 19.741245],
              [77.863258, 19.742004],
              [77.860528, 19.743656],
              [77.85901, 19.753145],
              [77.866246, 19.766503],
              [77.865522, 19.771419],
              [77.862044, 19.778677],
              [77.853222, 19.788781],
              [77.850659, 19.793123],
              [77.849069, 19.800774],
              [77.856362, 19.81085],
              [77.863597, 19.816273],
              [77.870315, 19.823896],
              [77.87113, 19.827715],
              [77.871072, 19.832707],
              [77.872869, 19.836838],
              [77.876207, 19.849553],
              [77.88619, 19.856919],
              [77.887792, 19.862332],
              [77.891861, 19.867151],
              [77.891888, 19.871013],
              [77.898107, 19.877997],
              [77.902748, 19.880339],
              [77.920021, 19.884676],
              [77.92398, 19.891266],
              [77.934326, 19.890794],
              [77.940522, 19.892868],
              [77.943783, 19.900688],
              [77.947826, 19.907114],
              [77.953905, 19.911225],
              [77.960239, 19.911036],
              [77.965016, 19.909916],
              [77.971476, 19.910395],
              [77.978495, 19.912919],
              [77.982579, 19.915541],
              [77.988171, 19.91671],
              [77.99232, 19.916438],
              [78.000019, 19.917775],
              [78.01191, 19.914187],
              [78.01866, 19.915625],
              [78.027872, 19.925552],
              [78.033454, 19.92846],
              [78.048122, 19.931148],
              [78.05327, 19.930717],
              [78.055102, 19.928916],
              [78.057349, 19.923927],
              [78.058873, 19.918076],
              [78.063236, 19.912581],
              [78.070053, 19.906574],
              [78.078394, 19.900597],
              [78.093936, 19.897633],
              [78.103033, 19.896676],
              [78.111524, 19.897422],
              [78.125659, 19.90006],
              [78.131132, 19.902006],
              [78.134939, 19.906499],
              [78.137646, 19.911359],
              [78.142141, 19.915291],
              [78.149469, 19.91595],
              [78.156219, 19.913844],
              [78.177864, 19.9103],
              [78.189232, 19.903291],
              [78.195206, 19.902378],
              [78.200534, 19.902651],
              [78.209794, 19.906896],
              [78.221819, 19.915485],
              [78.230327, 19.916445],
              [78.236423, 19.918797],
              [78.239756, 19.923956],
              [78.247172, 19.928161],
              [78.252799, 19.92935],
              [78.257661, 19.925768],
              [78.260266, 19.918873],
              [78.25965, 19.911697],
              [78.255291, 19.903946],
              [78.248379, 19.898091],
              [78.243555, 19.892324],
              [78.242332, 19.887496],
              [78.251365, 19.873842],
              [78.254723, 19.872987],
              [78.267252, 19.875675],
              [78.275459, 19.879602],
              [78.280784, 19.885188],
              [78.28234, 19.891451],
              [78.284205, 19.907558],
              [78.286947, 19.910687],
              [78.294693, 19.914577],
              [78.302493, 19.917152],
              [78.314777, 19.913107],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 399,
        censuscode: 511,
        dt_cen_cd: 15,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Nanded",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [74.77212, 21.613501],
              [74.772951, 21.611208],
              [74.773323, 21.609287],
              [74.771979, 21.605925],
              [74.768563, 21.600188],
              [74.765406, 21.595381],
              [74.762092, 21.589556],
              [74.759183, 21.583468],
              [74.757228, 21.578151],
              [74.756842, 21.575467],
              [74.756891, 21.571784],
              [74.757999, 21.566205],
              [74.758877, 21.561446],
              [74.759291, 21.551054],
              [74.759172, 21.541656],
              [74.758507, 21.536107],
              [74.757627, 21.533498],
              [74.75292, 21.528084],
              [74.752553, 21.527427],
              [74.752706, 21.526051],
              [74.755819, 21.524502],
              [74.756857, 21.523156],
              [74.755991, 21.520179],
              [74.756122, 21.519355],
              [74.757837, 21.518309],
              [74.760036, 21.517465],
              [74.760553, 21.516838],
              [74.76, 21.513412],
              [74.758993, 21.509048],
              [74.756366, 21.500852],
              [74.753809, 21.493396],
              [74.752035, 21.486059],
              [74.751952, 21.483201],
              [74.752662, 21.480187],
              [74.753977, 21.476825],
              [74.754108, 21.476001],
              [74.752158, 21.475564],
              [74.747557, 21.47743],
              [74.742254, 21.479639],
              [74.736904, 21.480557],
              [74.732686, 21.480225],
              [74.730969, 21.478876],
              [74.730911, 21.477861],
              [74.731451, 21.474196],
              [74.731124, 21.472527],
              [74.730611, 21.473062],
              [74.728434, 21.47584],
              [74.726614, 21.477066],
              [74.72475, 21.476908],
              [74.718004, 21.475843],
              [74.710013, 21.473904],
              [74.703206, 21.471915],
              [74.698541, 21.470462],
              [74.698747, 21.467798],
              [74.699935, 21.465169],
              [74.701721, 21.459891],
              [74.701889, 21.453266],
              [74.70141, 21.450486],
              [74.700016, 21.446017],
              [74.696655, 21.439084],
              [74.694885, 21.436627],
              [74.69285, 21.433424],
              [74.692655, 21.430931],
              [74.69361, 21.429215],
              [74.695678, 21.426709],
              [74.69673, 21.424996],
              [74.696928, 21.422517],
              [74.694211, 21.416712],
              [74.691326, 21.41265],
              [74.687983, 21.407743],
              [74.687525, 21.406898],
              [74.685833, 21.40251],
              [74.670649, 21.405933],
              [74.662801, 21.405892],
              [74.656679, 21.404532],
              [74.638557, 21.399451],
              [74.632643, 21.403122],
              [74.624965, 21.407671],
              [74.608505, 21.415321],
              [74.596233, 21.414789],
              [74.589619, 21.412985],
              [74.585709, 21.40999],
              [74.581382, 21.407797],
              [74.5728, 21.403446],
              [74.565948, 21.405041],
              [74.562099, 21.410151],
              [74.55726, 21.413015],
              [74.54918, 21.415762],
              [74.534034, 21.423069],
              [74.520776, 21.429465],
              [74.519154, 21.429313],
              [74.498044, 21.427345],
              [74.49739, 21.421796],
              [74.498374, 21.419429],
              [74.499407, 21.41483],
              [74.498574, 21.406441],
              [74.497914, 21.399804],
              [74.494034, 21.396163],
              [74.494706, 21.391859],
              [74.500476, 21.397319],
              [74.508567, 21.389603],
              [74.506685, 21.385206],
              [74.49932, 21.379553],
              [74.49144, 21.373505],
              [74.489228, 21.367622],
              [74.489102, 21.363675],
              [74.488759, 21.352962],
              [74.47912, 21.353069],
              [74.478952, 21.343561],
              [74.47877, 21.333257],
              [74.479649, 21.326506],
              [74.481956, 21.308786],
              [74.475493, 21.305878],
              [74.476596, 21.295973],
              [74.489728, 21.296823],
              [74.497865, 21.290215],
              [74.498986, 21.265669],
              [74.493327, 21.260736],
              [74.48818, 21.256248],
              [74.488508, 21.246039],
              [74.491824, 21.23953],
              [74.487329, 21.238938],
              [74.474021, 21.237772],
              [74.460597, 21.237001],
              [74.447451, 21.236608],
              [74.44263, 21.236798],
              [74.438096, 21.237182],
              [74.436398, 21.237856],
              [74.435434, 21.239754],
              [74.435094, 21.243149],
              [74.435726, 21.244461],
              [74.437982, 21.244545],
              [74.439355, 21.244596],
              [74.441207, 21.244941],
              [74.441537, 21.246426],
              [74.441401, 21.247342],
              [74.441021, 21.249354],
              [74.439383, 21.253253],
              [74.438341, 21.254688],
              [74.436289, 21.254428],
              [74.43406, 21.2537],
              [74.433036, 21.254675],
              [74.433142, 21.261494],
              [74.432491, 21.262943],
              [74.430318, 21.263231],
              [74.425448, 21.262221],
              [74.41886, 21.260043],
              [74.415564, 21.259],
              [74.412554, 21.258151],
              [74.408638, 21.257821],
              [74.408105, 21.258814],
              [74.40836, 21.259745],
              [74.410124, 21.264507],
              [74.410536, 21.266364],
              [74.408547, 21.266934],
              [74.405051, 21.265976],
              [74.402257, 21.264674],
              [74.398148, 21.261943],
              [74.395664, 21.260285],
              [74.393938, 21.259299],
              [74.389284, 21.257836],
              [74.380998, 21.256329],
              [74.368392, 21.254752],
              [74.363418, 21.253921],
              [74.359812, 21.253233],
              [74.355065, 21.251674],
              [74.355316, 21.250394],
              [74.356136, 21.249596],
              [74.358522, 21.246647],
              [74.358899, 21.244727],
              [74.358573, 21.240847],
              [74.356793, 21.234242],
              [74.355977, 21.232646],
              [74.353855, 21.231737],
              [74.351572, 21.232296],
              [74.34854, 21.231998],
              [74.342966, 21.229117],
              [74.340703, 21.229216],
              [74.340267, 21.230213],
              [74.339302, 21.23211],
              [74.338514, 21.232173],
              [74.33647, 21.231727],
              [74.332493, 21.230564],
              [74.33117, 21.23162],
              [74.329769, 21.234513],
              [74.325835, 21.234641],
              [74.323591, 21.23428],
              [74.317425, 21.233771],
              [74.315792, 21.235182],
              [74.315133, 21.245932],
              [74.314497, 21.247013],
              [74.309367, 21.245253],
              [74.302684, 21.240764],
              [74.297844, 21.239106],
              [74.291784, 21.238416],
              [74.284793, 21.238795],
              [74.27948, 21.241263],
              [74.275704, 21.244526],
              [74.272158, 21.249272],
              [74.265649, 21.249853],
              [74.251366, 21.248478],
              [74.240764, 21.246046],
              [74.239455, 21.244522],
              [74.235343, 21.24197],
              [74.224845, 21.241659],
              [74.222226, 21.240913],
              [74.219883, 21.238337],
              [74.217329, 21.231608],
              [74.213651, 21.223639],
              [74.211554, 21.222176],
              [74.206099, 21.221137],
              [74.196245, 21.221862],
              [74.187114, 21.221785],
              [74.184131, 21.22038],
              [74.183117, 21.216657],
              [74.18186, 21.209518],
              [74.180712, 21.208829],
              [74.176517, 21.210416],
              [74.169704, 21.215677],
              [74.166477, 21.215367],
              [74.161142, 21.216081],
              [74.160922, 21.221045],
              [74.163244, 21.226293],
              [74.156614, 21.231837],
              [74.155559, 21.224612],
              [74.149038, 21.225464],
              [74.149083, 21.222242],
              [74.142521, 21.219592],
              [74.142072, 21.216443],
              [74.149131, 21.212298],
              [74.14605, 21.208679],
              [74.120481, 21.21385],
              [74.114407, 21.21131],
              [74.10976, 21.206158],
              [74.102926, 21.199971],
              [74.091466, 21.192819],
              [74.086116, 21.191688],
              [74.081714, 21.188469],
              [74.058165, 21.171245],
              [74.081633, 21.144913],
              [74.084162, 21.141053],
              [74.082996, 21.136403],
              [74.072297, 21.132021],
              [74.069461, 21.127397],
              [74.062436, 21.126474],
              [74.051004, 21.127495],
              [74.051712, 21.137929],
              [74.040721, 21.1444],
              [74.033751, 21.144399],
              [74.027423, 21.143227],
              [74.019636, 21.14393],
              [74.019043, 21.135342],
              [74.012666, 21.130943],
              [74.017275, 21.102856],
              [74.010531, 21.100101],
              [74.002968, 21.11969],
              [73.986973, 21.113156],
              [73.975488, 21.111038],
              [73.975727, 21.105798],
              [73.973531, 21.102303],
              [73.965653, 21.0965],
              [73.951316, 21.085938],
              [73.951237, 21.080299],
              [73.95733, 21.072459],
              [73.950723, 21.060314],
              [73.960088, 21.0443],
              [73.954679, 21.031743],
              [73.941669, 21.035712],
              [73.934952, 21.038405],
              [73.91448, 21.035642],
              [73.909258, 21.040403],
              [73.907908, 21.035652],
              [73.894311, 21.030587],
              [73.888971, 21.029337],
              [73.883831, 21.028134],
              [73.860995, 21.027753],
              [73.85638, 21.029958],
              [73.856231, 21.015218],
              [73.854423, 21.000319],
              [73.850934, 20.996745],
              [73.850882, 20.996769],
              [73.847409, 20.998166],
              [73.843754, 21.000482],
              [73.838702, 21.005673],
              [73.813886, 21.025081],
              [73.796199, 21.045006],
              [73.80852, 21.052905],
              [73.810735, 21.055669],
              [73.812482, 21.059812],
              [73.811296, 21.065802],
              [73.811319, 21.083802],
              [73.80484, 21.077724],
              [73.791702, 21.067329],
              [73.787114, 21.066091],
              [73.775435, 21.070907],
              [73.763764, 21.067363],
              [73.737462, 21.080799],
              [73.735582, 21.080716],
              [73.733794, 21.084008],
              [73.732416, 21.093986],
              [73.742853, 21.106875],
              [73.746013, 21.113214],
              [73.736722, 21.107386],
              [73.732226, 21.100473],
              [73.72913, 21.102377],
              [73.708037, 21.106363],
              [73.702232, 21.111519],
              [73.703857, 21.118197],
              [73.696464, 21.108139],
              [73.686553, 21.100188],
              [73.682565, 21.105185],
              [73.672044, 21.108462],
              [73.653014, 21.107617],
              [73.650807, 21.120286],
              [73.646095, 21.121775],
              [73.638494, 21.122208],
              [73.621688, 21.119418],
              [73.616556, 21.137251],
              [73.622081, 21.140908],
              [73.61182, 21.143439],
              [73.607182, 21.146258],
              [73.606411, 21.149709],
              [73.604406, 21.153743],
              [73.597833, 21.154345],
              [73.593162, 21.15362],
              [73.58956, 21.152027],
              [73.585154, 21.152242],
              [73.581664, 21.153493],
              [73.580391, 21.156047],
              [73.581622, 21.160164],
              [73.581174, 21.1672],
              [73.591118, 21.174005],
              [73.599874, 21.177731],
              [73.602884, 21.175946],
              [73.606147, 21.175328],
              [73.607164, 21.171715],
              [73.606809, 21.167235],
              [73.607675, 21.162747],
              [73.612685, 21.157211],
              [73.630482, 21.152381],
              [73.632018, 21.146586],
              [73.629422, 21.131915],
              [73.664662, 21.144348],
              [73.66777, 21.150217],
              [73.6745, 21.151309],
              [73.691509, 21.149285],
              [73.706519, 21.149616],
              [73.708484, 21.142268],
              [73.710378, 21.140899],
              [73.715674, 21.13839],
              [73.730068, 21.137415],
              [73.733224, 21.139285],
              [73.7366, 21.145921],
              [73.739438, 21.146733],
              [73.741403, 21.150646],
              [73.739615, 21.15394],
              [73.734185, 21.159523],
              [73.735053, 21.166224],
              [73.746553, 21.167282],
              [73.773215, 21.16362],
              [73.777232, 21.164127],
              [73.780779, 21.165381],
              [73.783363, 21.167742],
              [73.784751, 21.175285],
              [73.789952, 21.180778],
              [73.796192, 21.177607],
              [73.801185, 21.173639],
              [73.805814, 21.1711],
              [73.811652, 21.17047],
              [73.816269, 21.170943],
              [73.824234, 21.183396],
              [73.826078, 21.1844],
              [73.829699, 21.194173],
              [73.827835, 21.196189],
              [73.815085, 21.194334],
              [73.813257, 21.198612],
              [73.812519, 21.202876],
              [73.812163, 21.212728],
              [73.813892, 21.22086],
              [73.81695, 21.226556],
              [73.821294, 21.23213],
              [73.830192, 21.241314],
              [73.830349, 21.244797],
              [73.826086, 21.257277],
              [73.826011, 21.266434],
              [73.852359, 21.268898],
              [73.865735, 21.266304],
              [73.87834, 21.261541],
              [73.886053, 21.261321],
              [73.917726, 21.279887],
              [73.92782, 21.284182],
              [73.94278, 21.296377],
              [73.944235, 21.305414],
              [73.94447, 21.306874],
              [73.945598, 21.313836],
              [73.946281, 21.329413],
              [73.951378, 21.343254],
              [73.95097, 21.360404],
              [73.949707, 21.373055],
              [73.950044, 21.388798],
              [73.947261, 21.401157],
              [73.949888, 21.401316],
              [73.956389, 21.391885],
              [73.963157, 21.390829],
              [73.966405, 21.393563],
              [73.971908, 21.393729],
              [73.976083, 21.3961],
              [73.979812, 21.400659],
              [73.983375, 21.403235],
              [74.000078, 21.410551],
              [74.002278, 21.411295],
              [74.00411, 21.412091],
              [74.005713, 21.413246],
              [74.007148, 21.414558],
              [74.00871, 21.415747],
              [74.010445, 21.416686],
              [74.012359, 21.417269],
              [74.014255, 21.416686],
              [74.015988, 21.415728],
              [74.017981, 21.415798],
              [74.019935, 21.416205],
              [74.021861, 21.41674],
              [74.023766, 21.417311],
              [74.025682, 21.417847],
              [74.027635, 21.418273],
              [74.029619, 21.418499],
              [74.031618, 21.418345],
              [74.033589, 21.417988],
              [74.035558, 21.417643],
              [74.037548, 21.417452],
              [74.039532, 21.417206],
              [74.041542, 21.417194],
              [74.043288, 21.418106],
              [74.044426, 21.41965],
              [74.045226, 21.421369],
              [74.045856, 21.423156],
              [74.046397, 21.424953],
              [74.046878, 21.426777],
              [74.04729, 21.428615],
              [74.047642, 21.430457],
              [74.047954, 21.432319],
              [74.048244, 21.434177],
              [74.048507, 21.436034],
              [74.048757, 21.437891],
              [74.048981, 21.439755],
              [74.049063, 21.441631],
              [74.049129, 21.443505],
              [74.049251, 21.445382],
              [74.049533, 21.44724],
              [74.049945, 21.449078],
              [74.050476, 21.450886],
              [74.051166, 21.452645],
              [74.051989, 21.454358],
              [74.052863, 21.456044],
              [74.053776, 21.457715],
              [74.05472, 21.459369],
              [74.055674, 21.461014],
              [74.057215, 21.463723],
              [74.058139, 21.465383],
              [74.059012, 21.467071],
              [74.059843, 21.468782],
              [74.060557, 21.470526],
              [74.061048, 21.472348],
              [74.061358, 21.474201],
              [74.061542, 21.476071],
              [74.061301, 21.477929],
              [74.060866, 21.479758],
              [74.062038, 21.480567],
              [74.063814, 21.479693],
              [74.065335, 21.478484],
              [74.066661, 21.477079],
              [74.06792, 21.475615],
              [74.069096, 21.474091],
              [74.070175, 21.472517],
              [74.071152, 21.470873],
              [74.071923, 21.469144],
              [74.072311, 21.467303],
              [74.072432, 21.465438],
              [74.072487, 21.463561],
              [74.072303, 21.461689],
              [74.071983, 21.459838],
              [74.071956, 21.457974],
              [74.073043, 21.456438],
              [74.074921, 21.455825],
              [74.076883, 21.455467],
              [74.078863, 21.455149],
              [74.080838, 21.454866],
              [74.082824, 21.454591],
              [74.084808, 21.454338],
              [74.086801, 21.454091],
              [74.088785, 21.453856],
              [74.090771, 21.45361],
              [74.092755, 21.453354],
              [74.09474, 21.453091],
              [74.096726, 21.452807],
              [74.098705, 21.452496],
              [74.100337, 21.451542],
              [74.100565, 21.44969],
              [74.100599, 21.447822],
              [74.101974, 21.446724],
              [74.103969, 21.446607],
              [74.105972, 21.446695],
              [74.10797, 21.446909],
              [74.109939, 21.447207],
              [74.111909, 21.447549],
              [74.113876, 21.447902],
              [74.115841, 21.44829],
              [74.117497, 21.44928],
              [74.11793, 21.451091],
              [74.117905, 21.45296],
              [74.117746, 21.454833],
              [74.117603, 21.456706],
              [74.117657, 21.45858],
              [74.118392, 21.460295],
              [74.120109, 21.461244],
              [74.122026, 21.461777],
              [74.123997, 21.462091],
              [74.125996, 21.462243],
              [74.128004, 21.462264],
              [74.129999, 21.462166],
              [74.131991, 21.461956],
              [74.13396, 21.461609],
              [74.135874, 21.461053],
              [74.136988, 21.459554],
              [74.137695, 21.456284],
              [74.138293, 21.454497],
              [74.139764, 21.453277],
              [74.141703, 21.452825],
              [74.143691, 21.452651],
              [74.145692, 21.45245],
              [74.147668, 21.452168],
              [74.149645, 21.451893],
              [74.151637, 21.451685],
              [74.153647, 21.451632],
              [74.15562, 21.451902],
              [74.156441, 21.45352],
              [74.156772, 21.45537],
              [74.158411, 21.456139],
              [74.160407, 21.456002],
              [74.161826, 21.457183],
              [74.162428, 21.458975],
              [74.16306, 21.460749],
              [74.164524, 21.46196],
              [74.166497, 21.462237],
              [74.168486, 21.462047],
              [74.170286, 21.461274],
              [74.171731, 21.459976],
              [74.173567, 21.459398],
              [74.175407, 21.460084],
              [74.176793, 21.461438],
              [74.177996, 21.462938],
              [74.179217, 21.46442],
              [74.180794, 21.465535],
              [74.182784, 21.465545],
              [74.184776, 21.465328],
              [74.186722, 21.464885],
              [74.188558, 21.464141],
              [74.190272, 21.463161],
              [74.191892, 21.462057],
              [74.19344, 21.460873],
              [74.194707, 21.459409],
              [74.196207, 21.458198],
              [74.198181, 21.45794],
              [74.200172, 21.458088],
              [74.202152, 21.458377],
              [74.204136, 21.458635],
              [74.206143, 21.458685],
              [74.208133, 21.458473],
              [74.210103, 21.458135],
              [74.212065, 21.457766],
              [74.214045, 21.457435],
              [74.216033, 21.457262],
              [74.218009, 21.457474],
              [74.218951, 21.459053],
              [74.219125, 21.460916],
              [74.219202, 21.462791],
              [74.219101, 21.464666],
              [74.218883, 21.466534],
              [74.218625, 21.468391],
              [74.218398, 21.470259],
              [74.218276, 21.472134],
              [74.218423, 21.474002],
              [74.219127, 21.475735],
              [74.220651, 21.476929],
              [74.2225, 21.477634],
              [74.224454, 21.478065],
              [74.22644, 21.478289],
              [74.228448, 21.478338],
              [74.230445, 21.478173],
              [74.23239, 21.477748],
              [74.234156, 21.476872],
              [74.236037, 21.474019],
              [74.236656, 21.472236],
              [74.237146, 21.470417],
              [74.237608, 21.46859],
              [74.23813, 21.466773],
              [74.238785, 21.464999],
              [74.239748, 21.463362],
              [74.241256, 21.462161],
              [74.243152, 21.461556],
              [74.245136, 21.461319],
              [74.247145, 21.46132],
              [74.249143, 21.461488],
              [74.251115, 21.461782],
              [74.25307, 21.462198],
              [74.254998, 21.46272],
              [74.256871, 21.463361],
              [74.258697, 21.464147],
              [74.259666, 21.465735],
              [74.259912, 21.467592],
              [74.260067, 21.46946],
              [74.260551, 21.471275],
              [74.262057, 21.472458],
              [74.263905, 21.473171],
              [74.265827, 21.473684],
              [74.267794, 21.474051],
              [74.269777, 21.47433],
              [74.271772, 21.474551],
              [74.273759, 21.474737],
              [74.275759, 21.474921],
              [74.277744, 21.475144],
              [74.279729, 21.475383],
              [74.281725, 21.475588],
              [74.283715, 21.475756],
              [74.285717, 21.475894],
              [74.287717, 21.476016],
              [74.289718, 21.476145],
              [74.29172, 21.476285],
              [74.293708, 21.47645],
              [74.295707, 21.476646],
              [74.297691, 21.476905],
              [74.299658, 21.477272],
              [74.301576, 21.477794],
              [74.303425, 21.478516],
              [74.305077, 21.479577],
              [74.30626, 21.481066],
              [74.306936, 21.482835],
              [74.307431, 21.484647],
              [74.308045, 21.486439],
              [74.309094, 21.488014],
              [74.310673, 21.489163],
              [74.312487, 21.489957],
              [74.314392, 21.490552],
              [74.316324, 21.491055],
              [74.318243, 21.491568],
              [74.32015, 21.492146],
              [74.321987, 21.492911],
              [74.323463, 21.49412],
              [74.323978, 21.495926],
              [74.324341, 21.497768],
              [74.324816, 21.499601],
              [74.325272, 21.501421],
              [74.325717, 21.50325],
              [74.326152, 21.505088],
              [74.326578, 21.506916],
              [74.327011, 21.508744],
              [74.327436, 21.510582],
              [74.327834, 21.512381],
              [74.329133, 21.518161],
              [74.331333, 21.53857],
              [74.328539, 21.539505],
              [74.327455, 21.539524],
              [74.326441, 21.539528],
              [74.325425, 21.539512],
              [74.324412, 21.539497],
              [74.323399, 21.539473],
              [74.322385, 21.539458],
              [74.321372, 21.539452],
              [74.320365, 21.539457],
              [74.319359, 21.539479],
              [74.31837, 21.539529],
              [74.317382, 21.539607],
              [74.31641, 21.539725],
              [74.315453, 21.539877],
              [74.314436, 21.540122],
              [74.31339, 21.540474],
              [74.312407, 21.540948],
              [74.311565, 21.541522],
              [74.310944, 21.542219],
              [74.310602, 21.543022],
              [74.310363, 21.543867],
              [74.310176, 21.544732],
              [74.310036, 21.54563],
              [74.309932, 21.546547],
              [74.309858, 21.547481],
              [74.309812, 21.548428],
              [74.309785, 21.549387],
              [74.309768, 21.550363],
              [74.30976, 21.55133],
              [74.309743, 21.552306],
              [74.309726, 21.553272],
              [74.309679, 21.554247],
              [74.309623, 21.555203],
              [74.30953, 21.556148],
              [74.309397, 21.557073],
              [74.309233, 21.558004],
              [74.309031, 21.558924],
              [74.308792, 21.559843],
              [74.308521, 21.560752],
              [74.308222, 21.561648],
              [74.307886, 21.562524],
              [74.307517, 21.56342],
              [74.307037, 21.564399],
              [74.306437, 21.565235],
              [74.305731, 21.565678],
              [74.304854, 21.565679],
              [74.303825, 21.565405],
              [74.302809, 21.56492],
              [74.301977, 21.564306],
              [74.30144, 21.56356],
              [74.301059, 21.562646],
              [74.300783, 21.561636],
              [74.30053, 21.560599],
              [74.300242, 21.559628],
              [74.299837, 21.558795],
              [74.29927, 21.558184],
              [74.298493, 21.557823],
              [74.29762, 21.557585],
              [74.296673, 21.557453],
              [74.295681, 21.557394],
              [74.294638, 21.557387],
              [74.293571, 21.557413],
              [74.292485, 21.55746],
              [74.291408, 21.557497],
              [74.290344, 21.557508],
              [74.289312, 21.557464],
              [74.288322, 21.557357],
              [74.287398, 21.557154],
              [74.286715, 21.556548],
              [74.286216, 21.555626],
              [74.285664, 21.554788],
              [74.284855, 21.554331],
              [74.283861, 21.554132],
              [74.282813, 21.554005],
              [74.281843, 21.553782],
              [74.281022, 21.553306],
              [74.280282, 21.552658],
              [74.279638, 21.551897],
              [74.279082, 21.551095],
              [74.278701, 21.550238],
              [74.278584, 21.5492],
              [74.278475, 21.548198],
              [74.278076, 21.547449],
              [74.277281, 21.547066],
              [74.276274, 21.546887],
              [74.275158, 21.54681],
              [74.274039, 21.546736],
              [74.272995, 21.546562],
              [74.27214, 21.546196],
              [74.271534, 21.545565],
              [74.271059, 21.544785],
              [74.270656, 21.543915],
              [74.270319, 21.542958],
              [74.270022, 21.541966],
              [74.269747, 21.540938],
              [74.269494, 21.539901],
              [74.269228, 21.538885],
              [74.268931, 21.537901],
              [74.26859, 21.536979],
              [74.268195, 21.536149],
              [74.267727, 21.535424],
              [74.26715, 21.534822],
              [74.266468, 21.534372],
              [74.2657, 21.534039],
              [74.264848, 21.533774],
              [74.263943, 21.53359],
              [74.262973, 21.533474],
              [74.261974, 21.533404],
              [74.260929, 21.533396],
              [74.259854, 21.533434],
              [74.258765, 21.533517],
              [74.257666, 21.533615],
              [74.256564, 21.533753],
              [74.255482, 21.5339],
              [74.25441, 21.534057],
              [74.253364, 21.534215],
              [74.25236, 21.534375],
              [74.251396, 21.534539],
              [74.250507, 21.53488],
              [74.249688, 21.535436],
              [74.248927, 21.536125],
              [74.248216, 21.536853],
              [74.247542, 21.537574],
              [74.246926, 21.538317],
              [74.246338, 21.539107],
              [74.245787, 21.539927],
              [74.245247, 21.540756],
              [74.244697, 21.541566],
              [74.24412, 21.542329],
              [74.243505, 21.543045],
              [74.242838, 21.543664],
              [74.242, 21.544035],
              [74.240918, 21.543998],
              [74.239809, 21.543914],
              [74.238927, 21.544162],
              [74.238326, 21.544841],
              [74.237878, 21.545749],
              [74.237466, 21.546724],
              [74.237028, 21.547633],
              [74.236466, 21.548323],
              [74.235694, 21.548678],
              [74.234708, 21.548721],
              [74.233622, 21.548552],
              [74.232556, 21.548286],
              [74.231586, 21.548014],
              [74.230571, 21.547676],
              [74.22958, 21.547276],
              [74.228723, 21.546778],
              [74.22808, 21.546157],
              [74.227813, 21.545341],
              [74.227863, 21.54432],
              [74.228006, 21.543257],
              [74.22801, 21.542309],
              [74.227626, 21.541654],
              [74.226621, 21.541491],
              [74.22543, 21.541475],
              [74.224584, 21.541136],
              [74.224238, 21.540326],
              [74.224129, 21.539316],
              [74.224043, 21.53826],
              [74.223812, 21.537344],
              [74.223249, 21.536717],
              [74.222415, 21.536323],
              [74.221414, 21.536068],
              [74.220351, 21.535903],
              [74.219284, 21.535756],
              [74.218289, 21.535612],
              [74.217269, 21.535522],
              [74.216217, 21.535477],
              [74.215175, 21.535442],
              [74.214143, 21.535398],
              [74.213133, 21.535308],
              [74.212177, 21.535159],
              [74.211284, 21.534926],
              [74.210564, 21.534456],
              [74.210183, 21.533544],
              [74.209871, 21.532532],
              [74.209292, 21.53181],
              [74.208449, 21.531388],
              [74.207503, 21.53108],
              [74.206503, 21.530828],
              [74.205502, 21.530573],
              [74.204557, 21.530246],
              [74.20371, 21.529751],
              [74.203018, 21.528978],
              [74.202332, 21.528215],
              [74.201562, 21.527768],
              [74.200621, 21.527684],
              [74.199593, 21.527722],
              [74.198531, 21.527861],
              [74.197491, 21.528102],
              [74.196527, 21.528419],
              [74.195688, 21.528811],
              [74.195075, 21.529487],
              [74.194665, 21.530415],
              [74.194381, 21.531388],
              [74.1942, 21.532299],
              [74.194095, 21.533235],
              [74.194039, 21.534181],
              [74.193982, 21.535128],
              [74.193877, 21.53607],
              [74.193687, 21.536975],
              [74.193377, 21.537852],
              [74.192963, 21.538706],
              [74.192471, 21.539537],
              [74.191909, 21.540337],
              [74.191324, 21.541091],
              [74.190689, 21.541815],
              [74.190009, 21.542507],
              [74.189298, 21.54318],
              [74.188589, 21.543843],
              [74.18788, 21.544516],
              [74.187207, 21.54521],
              [74.186591, 21.545942],
              [74.186026, 21.546705],
              [74.185476, 21.547497],
              [74.184953, 21.54831],
              [74.184452, 21.549132],
              [74.183998, 21.549975],
              [74.183574, 21.550827],
              [74.183187, 21.551683],
              [74.182869, 21.552571],
              [74.182704, 21.553538],
              [74.182613, 21.554539],
              [74.182534, 21.555531],
              [74.182409, 21.556481],
              [74.182152, 21.557344],
              [74.181704, 21.558068],
              [74.181036, 21.558687],
              [74.180197, 21.559233],
              [74.179234, 21.559691],
              [74.178217, 21.560034],
              [74.177181, 21.560247],
              [74.176171, 21.560316],
              [74.175196, 21.560311],
              [74.174212, 21.560296],
              [74.173207, 21.560261],
              [74.172204, 21.560229],
              [74.171193, 21.560167],
              [74.170174, 21.560096],
              [74.169163, 21.560015],
              [74.168144, 21.559916],
              [74.167127, 21.559807],
              [74.166109, 21.559671],
              [74.165103, 21.559535],
              [74.164096, 21.559374],
              [74.163101, 21.559202],
              [74.162117, 21.559021],
              [74.161144, 21.558813],
              [74.160181, 21.558598],
              [74.15923, 21.558354],
              [74.1583, 21.558104],
              [74.157412, 21.557772],
              [74.156605, 21.55726],
              [74.155855, 21.55663],
              [74.155158, 21.555912],
              [74.154485, 21.555149],
              [74.15382, 21.554386],
              [74.153162, 21.55367],
              [74.152609, 21.552884],
              [74.152118, 21.552029],
              [74.151584, 21.551236],
              [74.150882, 21.550638],
              [74.14999, 21.550223],
              [74.148991, 21.54994],
              [74.148007, 21.549741],
              [74.147023, 21.54956],
              [74.146029, 21.549381],
              [74.145035, 21.549218],
              [74.144037, 21.549082],
              [74.14304, 21.548965],
              [74.142039, 21.548894],
              [74.141046, 21.548862],
              [74.140049, 21.548865],
              [74.139013, 21.548903],
              [74.137953, 21.548986],
              [74.13691, 21.549134],
              [74.13593, 21.549377],
              [74.135042, 21.549736],
              [74.1343, 21.550251],
              [74.133741, 21.551033],
              [74.133299, 21.552006],
              [74.132914, 21.553027],
              [74.132492, 21.553991],
              [74.131973, 21.554756],
              [74.131265, 21.555226],
              [74.130386, 21.555401],
              [74.129485, 21.555502],
              [74.128545, 21.555555],
              [74.12759, 21.55555],
              [74.126608, 21.555498],
              [74.125597, 21.55542],
              [74.124578, 21.555311],
              [74.123552, 21.555183],
              [74.122515, 21.555037],
              [74.12147, 21.554899],
              [74.120425, 21.554762],
              [74.119377, 21.554622],
              [74.118338, 21.554521],
              [74.11731, 21.55444],
              [74.116298, 21.554398],
              [74.115291, 21.5544],
              [74.114303, 21.554458],
              [74.113353, 21.554695],
              [74.112413, 21.555068],
              [74.111499, 21.555518],
              [74.110584, 21.555987],
              [74.109656, 21.556381],
              [74.108704, 21.556636],
              [74.107724, 21.556695],
              [74.106739, 21.556698],
              [74.105745, 21.556682],
              [74.104749, 21.556659],
              [74.103757, 21.556606],
              [74.102758, 21.556544],
              [74.101757, 21.556472],
              [74.100756, 21.556394],
              [74.099746, 21.556295],
              [74.098749, 21.556196],
              [74.097739, 21.556096],
              [74.096739, 21.555988],
              [74.095732, 21.555882],
              [74.094723, 21.555773],
              [74.093723, 21.555665],
              [74.092716, 21.555565],
              [74.091716, 21.555475],
              [74.090705, 21.555385],
              [74.089707, 21.555307],
              [74.088705, 21.555244],
              [74.087713, 21.555192],
              [74.086721, 21.555148],
              [74.085727, 21.555125],
              [74.08474, 21.555128],
              [74.083754, 21.555149],
              [74.082795, 21.555348],
              [74.081867, 21.555715],
              [74.080964, 21.556154],
              [74.08005, 21.556613],
              [74.079119, 21.557007],
              [74.078157, 21.557271],
              [74.077182, 21.557421],
              [74.076189, 21.557553],
              [74.075197, 21.557668],
              [74.074205, 21.557772],
              [74.073204, 21.557856],
              [74.072194, 21.557932],
              [74.071196, 21.558001],
              [74.070187, 21.558049],
              [74.069181, 21.558087],
              [74.068173, 21.558117],
              [74.067168, 21.55813],
              [74.06617, 21.558141],
              [74.065175, 21.558143],
              [74.064183, 21.5581],
              [74.063187, 21.557966],
              [74.062205, 21.557739],
              [74.061235, 21.557456],
              [74.0603, 21.557131],
              [74.059375, 21.556777],
              [74.058462, 21.556389],
              [74.05757, 21.555983],
              [74.056671, 21.555556],
              [74.055779, 21.555122],
              [74.054878, 21.554697],
              [74.053988, 21.554289],
              [74.049223, 21.550785],
              [74.042051, 21.548304],
              [74.036569, 21.549978],
              [74.020381, 21.551268],
              [74.013857, 21.549161],
              [74.000081, 21.53944],
              [73.978195, 21.540736],
              [73.976453, 21.53846],
              [73.977182, 21.534424],
              [73.98221, 21.521112],
              [73.980354, 21.520055],
              [73.976849, 21.520495],
              [73.969092, 21.522791],
              [73.967986, 21.530116],
              [73.964504, 21.537286],
              [73.960927, 21.537787],
              [73.957373, 21.536601],
              [73.955699, 21.51803],
              [73.951832, 21.515206],
              [73.948119, 21.514536],
              [73.933907, 21.508861],
              [73.932119, 21.519412],
              [73.930638, 21.521204],
              [73.928265, 21.522331],
              [73.925471, 21.521757],
              [73.922878, 21.519387],
              [73.920538, 21.518366],
              [73.904897, 21.518954],
              [73.904451, 21.512089],
              [73.897973, 21.507539],
              [73.891421, 21.504843],
              [73.880943, 21.503494],
              [73.876874, 21.508602],
              [73.874508, 21.506714],
              [73.871118, 21.500022],
              [73.864555, 21.4961],
              [73.85501, 21.494672],
              [73.848223, 21.506112],
              [73.844082, 21.509835],
              [73.839228, 21.52043],
              [73.834345, 21.535773],
              [73.827946, 21.552341],
              [73.823259, 21.571805],
              [73.818699, 21.59715],
              [73.817366, 21.59953],
              [73.81264, 21.601189],
              [73.801004, 21.601238],
              [73.784695, 21.617395],
              [73.783648, 21.6198],
              [73.781723, 21.623944],
              [73.784991, 21.627672],
              [73.794298, 21.63351],
              [73.803009, 21.634555],
              [73.823297, 21.638627],
              [73.832851, 21.634205],
              [73.839557, 21.631978],
              [73.847408, 21.634671],
              [73.85463, 21.640648],
              [73.864681, 21.637577],
              [73.880093, 21.643822],
              [73.885771, 21.650259],
              [73.888959, 21.655833],
              [73.892631, 21.666015],
              [73.890931, 21.699012],
              [73.888546, 21.70187],
              [73.884796, 21.709376],
              [73.879611, 21.713171],
              [73.872883, 21.715675],
              [73.865746, 21.720673],
              [73.859613, 21.728132],
              [73.854798, 21.731773],
              [73.850807, 21.733409],
              [73.840818, 21.74077],
              [73.825643, 21.761678],
              [73.83576, 21.767418],
              [73.837446, 21.770912],
              [73.832862, 21.7829],
              [73.838651, 21.785868],
              [73.839476, 21.789435],
              [73.830159, 21.792249],
              [73.82868, 21.795376],
              [73.833436, 21.798936],
              [73.82801, 21.803933],
              [73.826601, 21.80962],
              [73.82208, 21.810711],
              [73.812043, 21.807289],
              [73.807993, 21.808915],
              [73.804965, 21.822136],
              [73.810694, 21.827354],
              [73.822451, 21.833627],
              [73.83609, 21.83725],
              [73.858371, 21.835368],
              [73.874286, 21.837342],
              [73.894286, 21.853161],
              [73.901442, 21.852292],
              [73.916777, 21.855226],
              [73.931241, 21.861772],
              [73.944124, 21.868951],
              [73.955792, 21.874581],
              [73.974798, 21.886068],
              [74.00005, 21.897893],
              [74.006885, 21.899065],
              [74.018284, 21.904475],
              [74.030896, 21.914498],
              [74.041976, 21.92128],
              [74.05179, 21.924866],
              [74.056986, 21.926506],
              [74.066935, 21.928042],
              [74.094171, 21.936045],
              [74.109195, 21.943093],
              [74.133798, 21.951726],
              [74.141693, 21.952413],
              [74.142704, 21.952392],
              [74.143712, 21.95239],
              [74.14472, 21.952378],
              [74.145721, 21.952357],
              [74.14672, 21.952306],
              [74.147715, 21.952202],
              [74.148714, 21.952061],
              [74.149702, 21.951899],
              [74.150691, 21.951693],
              [74.151665, 21.95145],
              [74.152612, 21.951139],
              [74.153526, 21.950753],
              [74.15443, 21.950348],
              [74.155325, 21.949933],
              [74.156218, 21.949509],
              [74.157114, 21.949077],
              [74.158, 21.948634],
              [74.158886, 21.948192],
              [74.159764, 21.94773],
              [74.160641, 21.947269],
              [74.161521, 21.946808],
              [74.162388, 21.946337],
              [74.163257, 21.945855],
              [74.164115, 21.945374],
              [74.164974, 21.944885],
              [74.165835, 21.944404],
              [74.166694, 21.943905],
              [74.167533, 21.943413],
              [74.168367, 21.942876],
              [74.169179, 21.942308],
              [74.169947, 21.941705],
              [74.170689, 21.941052],
              [74.171371, 21.940375],
              [74.171998, 21.939653],
              [74.172566, 21.938881],
              [74.173097, 21.938088],
              [74.173612, 21.937274],
              [74.174135, 21.936463],
              [74.174686, 21.935671],
              [74.175284, 21.934927],
              [74.175919, 21.934196],
              [74.176556, 21.933463],
              [74.177194, 21.932714],
              [74.177839, 21.931972],
              [74.178496, 21.931241],
              [74.179173, 21.930519],
              [74.179855, 21.929827],
              [74.180568, 21.929163],
              [74.181307, 21.928538],
              [74.182061, 21.927959],
              [74.182855, 21.92742],
              [74.183703, 21.926955],
              [74.184587, 21.92655],
              [74.185515, 21.926212],
              [74.186472, 21.925911],
              [74.187466, 21.925649],
              [74.188468, 21.925423],
              [74.189467, 21.925217],
              [74.190468, 21.925021],
              [74.191457, 21.924831],
              [74.192448, 21.924643],
              [74.193436, 21.924456],
              [74.194424, 21.924275],
              [74.195434, 21.924107],
              [74.19644, 21.923956],
              [74.197445, 21.923831],
              [74.198449, 21.923746],
              [74.199448, 21.923706],
              [74.200448, 21.923712],
              [74.201442, 21.923771],
              [74.202422, 21.923887],
              [74.203404, 21.924021],
              [74.204392, 21.924172],
              [74.205369, 21.924352],
              [74.206356, 21.924533],
              [74.207332, 21.924739],
              [74.208308, 21.924947],
              [74.209283, 21.925173],
              [74.210267, 21.925409],
              [74.211242, 21.925642],
              [74.212216, 21.925877],
              [74.213188, 21.926122],
              [74.214172, 21.926365],
              [74.215147, 21.9266],
              [74.216131, 21.926836],
              [74.217106, 21.92706],
              [74.218082, 21.927277],
              [74.219068, 21.927485],
              [74.220054, 21.927682],
              [74.221031, 21.927862],
              [74.222018, 21.928033],
              [74.222997, 21.928177],
              [74.22399, 21.928281],
              [74.224985, 21.928315],
              [74.225994, 21.928294],
              [74.226996, 21.928235],
              [74.22801, 21.928147],
              [74.229014, 21.928052],
              [74.230027, 21.927967],
              [74.231027, 21.927908],
              [74.232037, 21.927894],
              [74.233033, 21.927927],
              [74.234024, 21.928025],
              [74.235016, 21.928132],
              [74.236019, 21.928246],
              [74.237008, 21.928371],
              [74.237997, 21.928506],
              [74.238988, 21.92865],
              [74.239977, 21.928791],
              [74.240967, 21.928944],
              [74.241965, 21.929106],
              [74.242953, 21.929269],
              [74.24394, 21.929428],
              [74.244931, 21.92959],
              [74.245918, 21.929752],
              [74.246906, 21.929924],
              [74.247896, 21.930084],
              [74.248894, 21.930246],
              [74.249882, 21.930399],
              [74.25087, 21.930549],
              [74.251861, 21.930693],
              [74.25286, 21.930837],
              [74.253851, 21.930971],
              [74.254851, 21.931088],
              [74.255843, 21.931202],
              [74.256844, 21.931309],
              [74.257837, 21.931406],
              [74.258849, 21.931505],
              [74.259853, 21.931591],
              [74.260854, 21.931671],
              [74.261868, 21.931751],
              [74.262871, 21.93183],
              [74.263885, 21.931901],
              [74.2649, 21.931972],
              [74.265911, 21.93204],
              [74.266915, 21.932111],
              [74.26793, 21.932172],
              [74.268944, 21.932243],
              [74.269948, 21.932313],
              [74.270962, 21.932384],
              [74.271966, 21.932452],
              [74.272978, 21.932523],
              [74.273982, 21.932602],
              [74.274985, 21.932682],
              [74.275979, 21.932768],
              [74.27698, 21.932857],
              [74.277973, 21.932954],
              [74.278966, 21.933061],
              [74.279956, 21.933165],
              [74.280939, 21.933281],
              [74.281918, 21.933405],
              [74.282899, 21.933546],
              [74.283868, 21.933689],
              [74.284839, 21.933841],
              [74.285807, 21.934009],
              [74.286739, 21.93427],
              [74.287598, 21.934784],
              [74.288348, 21.935466],
              [74.289015, 21.936265],
              [74.289559, 21.937087],
              [74.289995, 21.937903],
              [74.29036, 21.93876],
              [74.290663, 21.939651],
              [74.290916, 21.940568],
              [74.291138, 21.9415],
              [74.291329, 21.942442],
              [74.291513, 21.943373],
              [74.291695, 21.944294],
              [74.291837, 21.945223],
              [74.291972, 21.946152],
              [74.292065, 21.947088],
              [74.292158, 21.948024],
              [74.29225, 21.948961],
              [74.292336, 21.949897],
              [74.292439, 21.950822],
              [74.292561, 21.95175],
              [74.292716, 21.952682],
              [74.292898, 21.953594],
              [74.293111, 21.954507],
              [74.293355, 21.955415],
              [74.293627, 21.956323],
              [74.293911, 21.957223],
              [74.294225, 21.958115],
              [74.294547, 21.959007],
              [74.294902, 21.959881],
              [74.295256, 21.960756],
              [74.295628, 21.961634],
              [74.296022, 21.96252],
              [74.296455, 21.9634],
              [74.29694, 21.964236],
              [74.297517, 21.964985],
              [74.29821, 21.965629],
              [74.298968, 21.966219],
              [74.299755, 21.966804],
              [74.30057, 21.967362],
              [74.301419, 21.967894],
              [74.302288, 21.968399],
              [74.303191, 21.968868],
              [74.304093, 21.969303],
              [74.30501, 21.96969],
              [74.305948, 21.970034],
              [74.306882, 21.970321],
              [74.307834, 21.970573],
              [74.3088, 21.970787],
              [74.30978, 21.970976],
              [74.310768, 21.971137],
              [74.311757, 21.971269],
              [74.31277, 21.971385],
              [74.31377, 21.971492],
              [74.314784, 21.971581],
              [74.315797, 21.97167],
              [74.316811, 21.971749],
              [74.317816, 21.971817],
              [74.318817, 21.971896],
              [74.319821, 21.971985],
              [74.320825, 21.972073],
              [74.321819, 21.972141],
              [74.322822, 21.972211],
              [74.323826, 21.972271],
              [74.324832, 21.972323],
              [74.325837, 21.972375],
              [74.326842, 21.972424],
              [74.327848, 21.972475],
              [74.328853, 21.972518],
              [74.329859, 21.97256],
              [74.330855, 21.972602],
              [74.33186, 21.972651],
              [74.332866, 21.972694],
              [74.333871, 21.972745],
              [74.334876, 21.972806],
              [74.335872, 21.972855],
              [74.336876, 21.972925],
              [74.337871, 21.972994],
              [74.338875, 21.973064],
              [74.339867, 21.97315],
              [74.340861, 21.973238],
              [74.341853, 21.973353],
              [74.342841, 21.973533],
              [74.343813, 21.973793],
              [74.344763, 21.974137],
              [74.345678, 21.974524],
              [74.346562, 21.974965],
              [74.347444, 21.975417],
              [74.348339, 21.975867],
              [74.34923, 21.976336],
              [74.350103, 21.976813],
              [74.350963, 21.977317],
              [74.351802, 21.977849],
              [74.352598, 21.978415],
              [74.353365, 21.979008],
              [74.354088, 21.979643],
              [74.35476, 21.980322],
              [74.355382, 21.981037],
              [74.355979, 21.981796],
              [74.356548, 21.98258],
              [74.357094, 21.983381],
              [74.357639, 21.984193],
              [74.358165, 21.985003],
              [74.358701, 21.985813],
              [74.359249, 21.986617],
              [74.359815, 21.9874],
              [74.360396, 21.98815],
              [74.361024, 21.988873],
              [74.361686, 21.989552],
              [74.362404, 21.99015],
              [74.363245, 21.990635],
              [74.364172, 21.991022],
              [74.365151, 21.991358],
              [74.36613, 21.991676],
              [74.367098, 21.992027],
              [74.367994, 21.992443],
              [74.368793, 21.99297],
              [74.369507, 21.993598],
              [74.370169, 21.994286],
              [74.37079, 21.99501],
              [74.37138, 21.995766],
              [74.371957, 21.996543],
              [74.372513, 21.997345],
              [74.373069, 21.998139],
              [74.373628, 21.998941],
              [74.374609, 22.000263],
              [74.380132, 22.009833],
              [74.384786, 22.018256],
              [74.392946, 22.021766],
              [74.403052, 22.022458],
              [74.414321, 22.023854],
              [74.432187, 22.029028],
              [74.436095, 22.024541],
              [74.442699, 22.02454],
              [74.439216, 22.019628],
              [74.441161, 22.014008],
              [74.444278, 22.010504],
              [74.448159, 22.006992],
              [74.450476, 22.004187],
              [74.450571, 22.000291],
              [74.446601, 22.003478],
              [74.442367, 22.004888],
              [74.44045, 22.004191],
              [74.432816, 22.000269],
              [74.432886, 21.997516],
              [74.437688, 21.994476],
              [74.439264, 21.991669],
              [74.439644, 21.981114],
              [74.443781, 21.974324],
              [74.445244, 21.969171],
              [74.448308, 21.965543],
              [74.456592, 21.96087],
              [74.460811, 21.961237],
              [74.463971, 21.962825],
              [74.468862, 21.963538],
              [74.4718, 21.960735],
              [74.474546, 21.959564],
              [74.479624, 21.960452],
              [74.481194, 21.958762],
              [74.482386, 21.955537],
              [74.485998, 21.954778],
              [74.490101, 21.952502],
              [74.486547, 21.945171],
              [74.489045, 21.94347],
              [74.493508, 21.944421],
              [74.512324, 21.931916],
              [74.512372, 21.92587],
              [74.511405, 21.920476],
              [74.514106, 21.915558],
              [74.520773, 21.911058],
              [74.524278, 21.90678],
              [74.524246, 21.901452],
              [74.518217, 21.89352],
              [74.515155, 21.888124],
              [74.514487, 21.884256],
              [74.514185, 21.872921],
              [74.513692, 21.854525],
              [74.508454, 21.819284],
              [74.505945, 21.813942],
              [74.500241, 21.80525],
              [74.499741, 21.795871],
              [74.50256, 21.780691],
              [74.502915, 21.779813],
              [74.503234, 21.778908],
              [74.503552, 21.778013],
              [74.503879, 21.777106],
              [74.504216, 21.77622],
              [74.504581, 21.775344],
              [74.504996, 21.774507],
              [74.505466, 21.7737],
              [74.506048, 21.772975],
              [74.506794, 21.772348],
              [74.507617, 21.771779],
              [74.50844, 21.771195],
              [74.509158, 21.770548],
              [74.509821, 21.769833],
              [74.510522, 21.769113],
              [74.511225, 21.768383],
              [74.511909, 21.767643],
              [74.512555, 21.766881],
              [74.513122, 21.766108],
              [74.513602, 21.765303],
              [74.513955, 21.764473],
              [74.514181, 21.763608],
              [74.514332, 21.762702],
              [74.514444, 21.761787],
              [74.514496, 21.76084],
              [74.514501, 21.75988],
              [74.514468, 21.758912],
              [74.514404, 21.757949],
              [74.514292, 21.756976],
              [74.514159, 21.75602],
              [74.513987, 21.755081],
              [74.513801, 21.75416],
              [74.513587, 21.753263],
              [74.513239, 21.752426],
              [74.51257, 21.751692],
              [74.51175, 21.751025],
              [74.51095, 21.750348],
              [74.510349, 21.74962],
              [74.510103, 21.748777],
              [74.510054, 21.747898],
              [74.510116, 21.746991],
              [74.510236, 21.746065],
              [74.510418, 21.745125],
              [74.51063, 21.744177],
              [74.510843, 21.74322],
              [74.511035, 21.742271],
              [74.511188, 21.741319],
              [74.511282, 21.740373],
              [74.511284, 21.739443],
              [74.51119, 21.738516],
              [74.511036, 21.737596],
              [74.51083, 21.736675],
              [74.510597, 21.735759],
              [74.510325, 21.734842],
              [74.510041, 21.733915],
              [74.509729, 21.733005],
              [74.509414, 21.732086],
              [74.509112, 21.731177],
              [74.508818, 21.730259],
              [74.508535, 21.729351],
              [74.50829, 21.728446],
              [74.508076, 21.72754],
              [74.507909, 21.726648],
              [74.507793, 21.725748],
              [74.507754, 21.724853],
              [74.507925, 21.723947],
              [74.508293, 21.723053],
              [74.508805, 21.722185],
              [74.509423, 21.721367],
              [74.510077, 21.720627],
              [74.510765, 21.719979],
              [74.511529, 21.71939],
              [74.512379, 21.718861],
              [74.513264, 21.718389],
              [74.514186, 21.717964],
              [74.515114, 21.717568],
              [74.516034, 21.717207],
              [74.516979, 21.716887],
              [74.517942, 21.716611],
              [74.518922, 21.716375],
              [74.519909, 21.716174],
              [74.520894, 21.716021],
              [74.521887, 21.715905],
              [74.522889, 21.715815],
              [74.523881, 21.715726],
              [74.524891, 21.715666],
              [74.525889, 21.715615],
              [74.526899, 21.715571],
              [74.527905, 21.715557],
              [74.52891, 21.715561],
              [74.529915, 21.715575],
              [74.530919, 21.715614],
              [74.531912, 21.715673],
              [74.532923, 21.715788],
              [74.533959, 21.715949],
              [74.535002, 21.716167],
              [74.536064, 21.716413],
              [74.537122, 21.716686],
              [74.538183, 21.716962],
              [74.539243, 21.717235],
              [74.540283, 21.717489],
              [74.541306, 21.717724],
              [74.542321, 21.717904],
              [74.543301, 21.718043],
              [74.544254, 21.718109],
              [74.545172, 21.718099],
              [74.546046, 21.717995],
              [74.546865, 21.717787],
              [74.547643, 21.717465],
              [74.548368, 21.717022],
              [74.549042, 21.716466],
              [74.54968, 21.715816],
              [74.550284, 21.71509],
              [74.550843, 21.714288],
              [74.551373, 21.713439],
              [74.551888, 21.712541],
              [74.552385, 21.711617],
              [74.552862, 21.710681],
              [74.55334, 21.709738],
              [74.553805, 21.708811],
              [74.554271, 21.707914],
              [74.554745, 21.707051],
              [74.555225, 21.706228],
              [74.555706, 21.705384],
              [74.556148, 21.704532],
              [74.556564, 21.703658],
              [74.556918, 21.702773],
              [74.557226, 21.701874],
              [74.557466, 21.700964],
              [74.557615, 21.700051],
              [74.557727, 21.699125],
              [74.55782, 21.698188],
              [74.557913, 21.697236],
              [74.557988, 21.696272],
              [74.558052, 21.695307],
              [74.558097, 21.694341],
              [74.558122, 21.693375],
              [74.558118, 21.692417],
              [74.55809, 21.691465],
              [74.558046, 21.690515],
              [74.557961, 21.689588],
              [74.557856, 21.68867],
              [74.557708, 21.687778],
              [74.55752, 21.686903],
              [74.557202, 21.686074],
              [74.556435, 21.685374],
              [74.555413, 21.684762],
              [74.55438, 21.684195],
              [74.553585, 21.68363],
              [74.553253, 21.683023],
              [74.553439, 21.682342],
              [74.553925, 21.681618],
              [74.554648, 21.68087],
              [74.555515, 21.680158],
              [74.556451, 21.679503],
              [74.557379, 21.67894],
              [74.558252, 21.678504],
              [74.559278, 21.678177],
              [74.560373, 21.677982],
              [74.561442, 21.677926],
              [74.562361, 21.678045],
              [74.562925, 21.678523],
              [74.563013, 21.679616],
              [74.563188, 21.680674],
              [74.563924, 21.681108],
              [74.564814, 21.681401],
              [74.565738, 21.681648],
              [74.566692, 21.681871],
              [74.567677, 21.682059],
              [74.568682, 21.682229],
              [74.569701, 21.682378],
              [74.570738, 21.682503],
              [74.571778, 21.682628],
              [74.572806, 21.682734],
              [74.573826, 21.68284],
              [74.574825, 21.682936],
              [74.575855, 21.68306],
              [74.576989, 21.683209],
              [74.578128, 21.683329],
              [74.579211, 21.683345],
              [74.580156, 21.68319],
              [74.580879, 21.682801],
              [74.581417, 21.682183],
              [74.581882, 21.68144],
              [74.582286, 21.680602],
              [74.582621, 21.679689],
              [74.582912, 21.678725],
              [74.583148, 21.677725],
              [74.583342, 21.676719],
              [74.583497, 21.675723],
              [74.58361, 21.674769],
              [74.583662, 21.67385],
              [74.583417, 21.672927],
              [74.582977, 21.671992],
              [74.582508, 21.671066],
              [74.582183, 21.670174],
              [74.582161, 21.669317],
              [74.582464, 21.668483],
              [74.582841, 21.667598],
              [74.583287, 21.666689],
              [74.5838, 21.665784],
              [74.584383, 21.6649],
              [74.58502, 21.664084],
              [74.585713, 21.663342],
              [74.586468, 21.662716],
              [74.587264, 21.662231],
              [74.588113, 21.661895],
              [74.588992, 21.661653],
              [74.589911, 21.661476],
              [74.590855, 21.661347],
              [74.591824, 21.661275],
              [74.592813, 21.661233],
              [74.593818, 21.661234],
              [74.594842, 21.661257],
              [74.595875, 21.661289],
              [74.596918, 21.661341],
              [74.59797, 21.661392],
              [74.599022, 21.661444],
              [74.600065, 21.661477],
              [74.601109, 21.661491],
              [74.602147, 21.661478],
              [74.603173, 21.661436],
              [74.604185, 21.661339],
              [74.605168, 21.661204],
              [74.606155, 21.661048],
              [74.60714, 21.660876],
              [74.608116, 21.660694],
              [74.609094, 21.66051],
              [74.61007, 21.660311],
              [74.611049, 21.660108],
              [74.612026, 21.65989],
              [74.613005, 21.659679],
              [74.613973, 21.659451],
              [74.614943, 21.659223],
              [74.615923, 21.658993],
              [74.616891, 21.658756],
              [74.617861, 21.658517],
              [74.618832, 21.65828],
              [74.619802, 21.65804],
              [74.62077, 21.657803],
              [74.62175, 21.657564],
              [74.622721, 21.657327],
              [74.623691, 21.657088],
              [74.624669, 21.65686],
              [74.625639, 21.65663],
              [74.626616, 21.656402],
              [74.627586, 21.656184],
              [74.628565, 21.655972],
              [74.629541, 21.655763],
              [74.63052, 21.655561],
              [74.631496, 21.65537],
              [74.632484, 21.655186],
              [74.633469, 21.655014],
              [74.634453, 21.654851],
              [74.635438, 21.654695],
              [74.636434, 21.654542],
              [74.637427, 21.654407],
              [74.638421, 21.65426],
              [74.639404, 21.654134],
              [74.640407, 21.653999],
              [74.6414, 21.653871],
              [74.642393, 21.653754],
              [74.643386, 21.653628],
              [74.644379, 21.653502],
              [74.645381, 21.653384],
              [74.646374, 21.653258],
              [74.647367, 21.653132],
              [74.64836, 21.653004],
              [74.649353, 21.652869],
              [74.650336, 21.652733],
              [74.65133, 21.652596],
              [74.652326, 21.652442],
              [74.65331, 21.652288],
              [74.654295, 21.652123],
              [74.65527, 21.65195],
              [74.656257, 21.651776],
              [74.657234, 21.651576],
              [74.658222, 21.651367],
              [74.65919, 21.651136],
              [74.66017, 21.65089],
              [74.661141, 21.650632],
              [74.662104, 21.650339],
              [74.663048, 21.650034],
              [74.663992, 21.649711],
              [74.66492, 21.649352],
              [74.665827, 21.648981],
              [74.666718, 21.648573],
              [74.6676, 21.648128],
              [74.668464, 21.647663],
              [74.669312, 21.647159],
              [74.670148, 21.646638],
              [74.670975, 21.646108],
              [74.671805, 21.645557],
              [74.672616, 21.644999],
              [74.673425, 21.644438],
              [74.674245, 21.643889],
              [74.675046, 21.643328],
              [74.675854, 21.642769],
              [74.676646, 21.642198],
              [74.677437, 21.64163],
              [74.678239, 21.64105],
              [74.679018, 21.64047],
              [74.679801, 21.639883],
              [74.680583, 21.639293],
              [74.681375, 21.638707],
              [74.682148, 21.638117],
              [74.682937, 21.637537],
              [74.68372, 21.63695],
              [74.684501, 21.636369],
              [74.685293, 21.635789],
              [74.686085, 21.635212],
              [74.686884, 21.634641],
              [74.687685, 21.634082],
              [74.688486, 21.633521],
              [74.689293, 21.632972],
              [74.690113, 21.632429],
              [74.69094, 21.631908],
              [74.691778, 21.631385],
              [74.692643, 21.630893],
              [74.693507, 21.63041],
              [74.69438, 21.629955],
              [74.695272, 21.629519],
              [74.696173, 21.629102],
              [74.697089, 21.628722],
              [74.698018, 21.628363],
              [74.698943, 21.62802],
              [74.699877, 21.627687],
              [74.700814, 21.627363],
              [74.701767, 21.627051],
              [74.70271, 21.626746],
              [74.703653, 21.626443],
              [74.704615, 21.626157],
              [74.705568, 21.62587],
              [74.70653, 21.625586],
              [74.707491, 21.625318],
              [74.708452, 21.625053],
              [74.709423, 21.624794],
              [74.710384, 21.624538],
              [74.711352, 21.624289],
              [74.712322, 21.624051],
              [74.713292, 21.623811],
              [74.714259, 21.623583],
              [74.715229, 21.623352],
              [74.716208, 21.623115],
              [74.717178, 21.622884],
              [74.718145, 21.622664],
              [74.719114, 21.622436],
              [74.720091, 21.622215],
              [74.721061, 21.621986],
              [74.72204, 21.621765],
              [74.723007, 21.621545],
              [74.723986, 21.621324],
              [74.724962, 21.621114],
              [74.725931, 21.620893],
              [74.72691, 21.620674],
              [74.727886, 21.620464],
              [74.728856, 21.620242],
              [74.729832, 21.620032],
              [74.730811, 21.61982],
              [74.731787, 21.61961],
              [74.732766, 21.619398],
              [74.733744, 21.619188],
              [74.73472, 21.618978],
              [74.735699, 21.618766],
              [74.736675, 21.618565],
              [74.737654, 21.618353],
              [74.73863, 21.618143],
              [74.739608, 21.61794],
              [74.740584, 21.617739],
              [74.741562, 21.61753],
              [74.742538, 21.617326],
              [74.743517, 21.617117],
              [74.744493, 21.616913],
              [74.745471, 21.616713],
              [74.746457, 21.61651],
              [74.747435, 21.6163],
              [74.748411, 21.616099],
              [74.749389, 21.615896],
              [74.750365, 21.615695],
              [74.751343, 21.615492],
              [74.752319, 21.615291],
              [74.753307, 21.615091],
              [74.754283, 21.614888],
              [74.755261, 21.614687],
              [74.756246, 21.614493],
              [74.757234, 21.614311],
              [74.758218, 21.614148],
              [74.759202, 21.613981],
              [74.760196, 21.613827],
              [74.761188, 21.613701],
              [74.76218, 21.613581],
              [74.763172, 21.613482],
              [74.764171, 21.61342],
              [74.765168, 21.613383],
              [74.766165, 21.613376],
              [74.767169, 21.613388],
              [74.768173, 21.613418],
              [74.769177, 21.613439],
              [74.77018, 21.613467],
              [74.771184, 21.613498],
              [74.77212, 21.613501],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 400,
        censuscode: 497,
        dt_cen_cd: 1,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Nandurbar",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [77.285844, 19.910471],
              [77.285317, 19.905207],
              [77.285283, 19.904863],
              [77.287756, 19.903187],
              [77.287774, 19.903175],
              [77.288772, 19.901308],
              [77.289084, 19.900724],
              [77.292734, 19.899295],
              [77.296523, 19.900152],
              [77.303898, 19.906361],
              [77.310765, 19.910401],
              [77.316081, 19.909614],
              [77.316131, 19.909606],
              [77.317768, 19.906163],
              [77.315429, 19.901638],
              [77.316298, 19.893455],
              [77.315845, 19.890884],
              [77.315019, 19.889819],
              [77.30977, 19.890618],
              [77.302156, 19.893146],
              [77.298199, 19.892636],
              [77.297248, 19.889792],
              [77.29788, 19.885122],
              [77.296833, 19.882856],
              [77.298285, 19.88011],
              [77.298593, 19.879526],
              [77.302373, 19.878432],
              [77.306498, 19.878304],
              [77.318005, 19.883356],
              [77.323636, 19.88496],
              [77.326692, 19.883721],
              [77.336055, 19.875906],
              [77.340173, 19.874057],
              [77.347913, 19.873418],
              [77.349978, 19.870107],
              [77.350321, 19.869557],
              [77.34815, 19.864681],
              [77.348976, 19.860744],
              [77.349083, 19.860231],
              [77.354002, 19.858528],
              [77.360681, 19.859012],
              [77.365089, 19.858109],
              [77.365319, 19.858062],
              [77.36648, 19.851534],
              [77.356741, 19.845478],
              [77.356625, 19.845406],
              [77.363508, 19.837366],
              [77.363847, 19.83697],
              [77.363587, 19.833018],
              [77.349478, 19.835235],
              [77.346215, 19.83378],
              [77.344916, 19.832904],
              [77.344545, 19.829148],
              [77.344542, 19.829123],
              [77.346827, 19.825202],
              [77.357848, 19.816195],
              [77.362231, 19.815028],
              [77.370667, 19.822231],
              [77.373757, 19.822189],
              [77.382151, 19.819922],
              [77.390004, 19.820936],
              [77.390015, 19.820938],
              [77.395243, 19.811124],
              [77.3904, 19.807829],
              [77.383568, 19.788237],
              [77.383526, 19.788116],
              [77.389897, 19.779994],
              [77.407584, 19.778003],
              [77.40869, 19.776935],
              [77.40893, 19.776703],
              [77.409929, 19.772532],
              [77.407148, 19.765616],
              [77.404546, 19.764146],
              [77.396146, 19.766359],
              [77.387107, 19.766007],
              [77.385713, 19.76088],
              [77.37974, 19.749404],
              [77.379068, 19.746036],
              [77.379313, 19.74317],
              [77.379333, 19.742927],
              [77.381718, 19.740217],
              [77.384862, 19.738537],
              [77.384924, 19.738504],
              [77.386389, 19.735414],
              [77.383328, 19.731028],
              [77.383258, 19.729008],
              [77.383251, 19.728791],
              [77.385471, 19.726314],
              [77.388872, 19.725112],
              [77.396774, 19.725726],
              [77.398998, 19.732148],
              [77.413326, 19.743538],
              [77.418023, 19.739495],
              [77.418449, 19.739129],
              [77.417569, 19.73717],
              [77.417456, 19.736917],
              [77.419879, 19.735062],
              [77.435644, 19.729481],
              [77.435911, 19.729386],
              [77.436372, 19.725457],
              [77.436419, 19.725062],
              [77.440508, 19.722217],
              [77.440734, 19.72206],
              [77.442469, 19.71447],
              [77.442572, 19.714018],
              [77.445999, 19.711899],
              [77.446002, 19.711897],
              [77.447825, 19.708571],
              [77.44858, 19.703639],
              [77.448612, 19.703427],
              [77.451, 19.700347],
              [77.451395, 19.699836],
              [77.444643, 19.692293],
              [77.445883, 19.688218],
              [77.446054, 19.687658],
              [77.451945, 19.686551],
              [77.45899, 19.682311],
              [77.459593, 19.681949],
              [77.453362, 19.676859],
              [77.453514, 19.674437],
              [77.453554, 19.673805],
              [77.456234, 19.674206],
              [77.456413, 19.674233],
              [77.456963, 19.671918],
              [77.457101, 19.671338],
              [77.462587, 19.671053],
              [77.462779, 19.671043],
              [77.464003, 19.66572],
              [77.464135, 19.665146],
              [77.469684, 19.664705],
              [77.470062, 19.664675],
              [77.469268, 19.656258],
              [77.465002, 19.646087],
              [77.464772, 19.64554],
              [77.467052, 19.645366],
              [77.467429, 19.645337],
              [77.467184, 19.642697],
              [77.467137, 19.642192],
              [77.47028, 19.641481],
              [77.470678, 19.641391],
              [77.466763, 19.614633],
              [77.460193, 19.612477],
              [77.459721, 19.612322],
              [77.46666, 19.608544],
              [77.471261, 19.608455],
              [77.48063, 19.600358],
              [77.481123, 19.599932],
              [77.463696, 19.583021],
              [77.454231, 19.567832],
              [77.453938, 19.567363],
              [77.456683, 19.56683],
              [77.457122, 19.566744],
              [77.456196, 19.562652],
              [77.456051, 19.562015],
              [77.468578, 19.563295],
              [77.468865, 19.563325],
              [77.469286, 19.556363],
              [77.46843, 19.542723],
              [77.470586, 19.530545],
              [77.470649, 19.530192],
              [77.473341, 19.527773],
              [77.473698, 19.527453],
              [77.470292, 19.498984],
              [77.470247, 19.498607],
              [77.473328, 19.496834],
              [77.473626, 19.496662],
              [77.474062, 19.489735],
              [77.47409, 19.489295],
              [77.476168, 19.488255],
              [77.48279, 19.490802],
              [77.489462, 19.495064],
              [77.489724, 19.495231],
              [77.490992, 19.480086],
              [77.488002, 19.475116],
              [77.487974, 19.47507],
              [77.493302, 19.466857],
              [77.493647, 19.466325],
              [77.490357, 19.457019],
              [77.477595, 19.455298],
              [77.472332, 19.436794],
              [77.45249, 19.439661],
              [77.449317, 19.42362],
              [77.437401, 19.407188],
              [77.4373, 19.40705],
              [77.444001, 19.399949],
              [77.451296, 19.38952],
              [77.451647, 19.389018],
              [77.449741, 19.382757],
              [77.446015, 19.381788],
              [77.442659, 19.379131],
              [77.436556, 19.377437],
              [77.419726, 19.376642],
              [77.418573, 19.371563],
              [77.415522, 19.365394],
              [77.40903, 19.363015],
              [77.401781, 19.356405],
              [77.389682, 19.352362],
              [77.386138, 19.340921],
              [77.380962, 19.338272],
              [77.364422, 19.33873],
              [77.35259, 19.345755],
              [77.352561, 19.346168],
              [77.352144, 19.352147],
              [77.351859, 19.352166],
              [77.342012, 19.352814],
              [77.333999, 19.355235],
              [77.313828, 19.353955],
              [77.313858, 19.353395],
              [77.314561, 19.340213],
              [77.310283, 19.330008],
              [77.301959, 19.33216],
              [77.298093, 19.326994],
              [77.283346, 19.324973],
              [77.280094, 19.314789],
              [77.262594, 19.313661],
              [77.262484, 19.314264],
              [77.262235, 19.315625],
              [77.262005, 19.315692],
              [77.244297, 19.320887],
              [77.238591, 19.309852],
              [77.238202, 19.273738],
              [77.222869, 19.273916],
              [77.222071, 19.269974],
              [77.211047, 19.256525],
              [77.205813, 19.251974],
              [77.205601, 19.242209],
              [77.195544, 19.242857],
              [77.195188, 19.236093],
              [77.187719, 19.233157],
              [77.184243, 19.230051],
              [77.181239, 19.223475],
              [77.179148, 19.217048],
              [77.178272, 19.210809],
              [77.179568, 19.206976],
              [77.179645, 19.206748],
              [77.182038, 19.203274],
              [77.182351, 19.20282],
              [77.18329, 19.193085],
              [77.182236, 19.186914],
              [77.179311, 19.180854],
              [77.181183, 19.175623],
              [77.178908, 19.169817],
              [77.178872, 19.169724],
              [77.18239, 19.164905],
              [77.18884, 19.1646],
              [77.194577, 19.165234],
              [77.194966, 19.165277],
              [77.194059, 19.156344],
              [77.19483, 19.143736],
              [77.191539, 19.130393],
              [77.188972, 19.129435],
              [77.182369, 19.130324],
              [77.182157, 19.124071],
              [77.177714, 19.119434],
              [77.172429, 19.122063],
              [77.168618, 19.11977],
              [77.166322, 19.116158],
              [77.165897, 19.110771],
              [77.166733, 19.105296],
              [77.164399, 19.093368],
              [77.158691, 19.083427],
              [77.153007, 19.077626],
              [77.147687, 19.075369],
              [77.14436, 19.071742],
              [77.141415, 19.070101],
              [77.137396, 19.07062],
              [77.128622, 19.077241],
              [77.125163, 19.078312],
              [77.117183, 19.07613],
              [77.098035, 19.066328],
              [77.090818, 19.068661],
              [77.088008, 19.071499],
              [77.087932, 19.071836],
              [77.087063, 19.075649],
              [77.08753, 19.084042],
              [77.089403, 19.087768],
              [77.091893, 19.090212],
              [77.102078, 19.093398],
              [77.104747, 19.095498],
              [77.105572, 19.098795],
              [77.104397, 19.103193],
              [77.104087, 19.103722],
              [77.104071, 19.103781],
              [77.101782, 19.107692],
              [77.101615, 19.107698],
              [77.104997, 19.113428],
              [77.105207, 19.117106],
              [77.104132, 19.122135],
              [77.099891, 19.130593],
              [77.093495, 19.135886],
              [77.09755, 19.144965],
              [77.11172, 19.14662],
              [77.12064, 19.149732],
              [77.114107, 19.152452],
              [77.113823, 19.156671],
              [77.098475, 19.15582],
              [77.094882, 19.156576],
              [77.100139, 19.172659],
              [77.088358, 19.172153],
              [77.088854, 19.17602],
              [77.084903, 19.175483],
              [77.085331, 19.182471],
              [77.079237, 19.182627],
              [77.07769, 19.187096],
              [77.075892, 19.189724],
              [77.070602, 19.192926],
              [77.062997, 19.19149],
              [77.055842, 19.19594],
              [77.038129, 19.201282],
              [77.038357, 19.205891],
              [77.03853, 19.209372],
              [77.041234, 19.218243],
              [77.046763, 19.221844],
              [77.048647, 19.224085],
              [77.051411, 19.230294],
              [77.049806, 19.232926],
              [77.049345, 19.236315],
              [77.049289, 19.247611],
              [77.041553, 19.244381],
              [77.036801, 19.24378],
              [77.026218, 19.245681],
              [77.0226, 19.247445],
              [77.019049, 19.250589],
              [77.01332, 19.251576],
              [77.011614, 19.258706],
              [77.010561, 19.271176],
              [77.011483, 19.273216],
              [77.021903, 19.274436],
              [77.021884, 19.276268],
              [77.021822, 19.282425],
              [76.997461, 19.281659],
              [76.994015, 19.284344],
              [76.992464, 19.284497],
              [76.989168, 19.28048],
              [76.987428, 19.276128],
              [76.976217, 19.275716],
              [76.970197, 19.276695],
              [76.969817, 19.26787],
              [76.971708, 19.252661],
              [76.96946, 19.253717],
              [76.955432, 19.253889],
              [76.956722, 19.248221],
              [76.950232, 19.248639],
              [76.945914, 19.251397],
              [76.939662, 19.254116],
              [76.936176, 19.254319],
              [76.93291, 19.253333],
              [76.932385, 19.250934],
              [76.929472, 19.2472],
              [76.926177, 19.247499],
              [76.921439, 19.255851],
              [76.92291, 19.263414],
              [76.926795, 19.271118],
              [76.928604, 19.276575],
              [76.928853, 19.279134],
              [76.92923, 19.283018],
              [76.932354, 19.290247],
              [76.929242, 19.290918],
              [76.932206, 19.296674],
              [76.91974, 19.297413],
              [76.902775, 19.297532],
              [76.902238, 19.299817],
              [76.896865, 19.306227],
              [76.893814, 19.30846],
              [76.892971, 19.311381],
              [76.897339, 19.316029],
              [76.90041, 19.320264],
              [76.901578, 19.324146],
              [76.901621, 19.327317],
              [76.901685, 19.332048],
              [76.90048, 19.338086],
              [76.89944, 19.339179],
              [76.893536, 19.345382],
              [76.89172, 19.348559],
              [76.891737, 19.356184],
              [76.895174, 19.366545],
              [76.894715, 19.369659],
              [76.895115, 19.37294],
              [76.895772, 19.378316],
              [76.897166, 19.380826],
              [76.898602, 19.381896],
              [76.9008, 19.384013],
              [76.903971, 19.38795],
              [76.906618, 19.394895],
              [76.910993, 19.402519],
              [76.914689, 19.406921],
              [76.919945, 19.413179],
              [76.92227, 19.417361],
              [76.921118, 19.421104],
              [76.922839, 19.426284],
              [76.924236, 19.42803],
              [76.926664, 19.432611],
              [76.922509, 19.44061],
              [76.921218, 19.446187],
              [76.925398, 19.449765],
              [76.930118, 19.450873],
              [76.933842, 19.457473],
              [76.934866, 19.463466],
              [76.936923, 19.466724],
              [76.948953, 19.47864],
              [76.952986, 19.488738],
              [76.955533, 19.487504],
              [76.959404, 19.483449],
              [76.961656, 19.482392],
              [76.96354, 19.480501],
              [76.964676, 19.477401],
              [76.968202, 19.475727],
              [76.972675, 19.474991],
              [76.980965, 19.476814],
              [76.986429, 19.475087],
              [76.987915, 19.490828],
              [76.97957, 19.487076],
              [76.97953, 19.493139],
              [76.977713, 19.500636],
              [76.977416, 19.505224],
              [76.975535, 19.507189],
              [76.959543, 19.511383],
              [76.959394, 19.513677],
              [76.967901, 19.523131],
              [76.964804, 19.527202],
              [76.965358, 19.528932],
              [76.967549, 19.53577],
              [76.968509, 19.540128],
              [76.969241, 19.54521],
              [76.967313, 19.55574],
              [76.966248, 19.55859],
              [76.9632, 19.563648],
              [76.9573, 19.568388],
              [76.95372, 19.571264],
              [76.951424, 19.574157],
              [76.953759, 19.578065],
              [76.961746, 19.580709],
              [76.961586, 19.583462],
              [76.955848, 19.592718],
              [76.944981, 19.597273],
              [76.944611, 19.613439],
              [76.942764, 19.62213],
              [76.938366, 19.623602],
              [76.926124, 19.61609],
              [76.919828, 19.615776],
              [76.913408, 19.620789],
              [76.912531, 19.625181],
              [76.915801, 19.630579],
              [76.91577, 19.636092],
              [76.913158, 19.63999],
              [76.908241, 19.64292],
              [76.90337, 19.64383],
              [76.898493, 19.640787],
              [76.894627, 19.635514],
              [76.889665, 19.629855],
              [76.885533, 19.625141],
              [76.881008, 19.621123],
              [76.876501, 19.618915],
              [76.871181, 19.618344],
              [76.868391, 19.621501],
              [76.869539, 19.626304],
              [76.874822, 19.636799],
              [76.875667, 19.642147],
              [76.866874, 19.644811],
              [76.862231, 19.644254],
              [76.857168, 19.645066],
              [76.854003, 19.647664],
              [76.853216, 19.652242],
              [76.855124, 19.66184],
              [76.860163, 19.666838],
              [76.86415, 19.669934],
              [76.864632, 19.674171],
              [76.857507, 19.688358],
              [76.853518, 19.70114],
              [76.85092, 19.704301],
              [76.843775, 19.702771],
              [76.8411, 19.700968],
              [76.834904, 19.700377],
              [76.830597, 19.70194],
              [76.818702, 19.704259],
              [76.815957, 19.701351],
              [76.814742, 19.695352],
              [76.827211, 19.681097],
              [76.826157, 19.672344],
              [76.824452, 19.670991],
              [76.819492, 19.667056],
              [76.817804, 19.668674],
              [76.816388, 19.671806],
              [76.81299, 19.679323],
              [76.809347, 19.681542],
              [76.799887, 19.671414],
              [76.794419, 19.668815],
              [76.788356, 19.670798],
              [76.786469, 19.676639],
              [76.787557, 19.687874],
              [76.784531, 19.700675],
              [76.787189, 19.71121],
              [76.790601, 19.718636],
              [76.79003, 19.722208],
              [76.785413, 19.728542],
              [76.781194, 19.730381],
              [76.77555, 19.72695],
              [76.771848, 19.719517],
              [76.76798, 19.71493],
              [76.770016, 19.706978],
              [76.771937, 19.703803],
              [76.773457, 19.697127],
              [76.772693, 19.692607],
              [76.7698, 19.687857],
              [76.764356, 19.684247],
              [76.759986, 19.684427],
              [76.755223, 19.688735],
              [76.7521, 19.693446],
              [76.749076, 19.706062],
              [76.745876, 19.709944],
              [76.742731, 19.71153],
              [76.738375, 19.711067],
              [76.73535, 19.711736],
              [76.733778, 19.71648],
              [76.739063, 19.730566],
              [76.734046, 19.733305],
              [76.729758, 19.737527],
              [76.727348, 19.741009],
              [76.725621, 19.744697],
              [76.723969, 19.749131],
              [76.718675, 19.763333],
              [76.716473, 19.768138],
              [76.714295, 19.770646],
              [76.708576, 19.770244],
              [76.705428, 19.767968],
              [76.7028, 19.764325],
              [76.693127, 19.774589],
              [76.689574, 19.7769],
              [76.687528, 19.781082],
              [76.693416, 19.794265],
              [76.697677, 19.79868],
              [76.702348, 19.806137],
              [76.698824, 19.819019],
              [76.70182, 19.819637],
              [76.706082, 19.835817],
              [76.696185, 19.839274],
              [76.680517, 19.840397],
              [76.676586, 19.838287],
              [76.678627, 19.846054],
              [76.67863, 19.846141],
              [76.685226, 19.849099],
              [76.6893, 19.860022],
              [76.688493, 19.864913],
              [76.690744, 19.8679],
              [76.691393, 19.872357],
              [76.698322, 19.872446],
              [76.711881, 19.868543],
              [76.7236, 19.868921],
              [76.739383, 19.871963],
              [76.742377, 19.880382],
              [76.742855, 19.887939],
              [76.742091, 19.896731],
              [76.746444, 19.906617],
              [76.767251, 19.903698],
              [76.77155, 19.913809],
              [76.774002, 19.922244],
              [76.773328, 19.932686],
              [76.823454, 19.926667],
              [76.8327, 19.948251],
              [76.837128, 19.960764],
              [76.871678, 19.95554],
              [76.871734, 19.955531],
              [76.873724, 19.951288],
              [76.873991, 19.950718],
              [76.878751, 19.949354],
              [76.887208, 19.950252],
              [76.891207, 19.949708],
              [76.896155, 19.945978],
              [76.899266, 19.951584],
              [76.900668, 19.951845],
              [76.900861, 19.962556],
              [76.914894, 19.967688],
              [76.918075, 19.971293],
              [76.927843, 19.975827],
              [76.939037, 19.979243],
              [76.943638, 19.981323],
              [76.946731, 19.983606],
              [76.949273, 19.983031],
              [76.96232, 19.985311],
              [76.968381, 19.989482],
              [76.972564, 19.994147],
              [76.989126, 19.996103],
              [76.991789, 20.000027],
              [76.992637, 20.009097],
              [76.993205, 20.017769],
              [77.000009, 20.012287],
              [77.007452, 20.00689],
              [77.012957, 20.004617],
              [77.015204, 20.002541],
              [77.020865, 20.002859],
              [77.02402, 20.006165],
              [77.027941, 20.008272],
              [77.032014, 20.009928],
              [77.036328, 20.01032],
              [77.042649, 20.008864],
              [77.046409, 20.007187],
              [77.052335, 20.000127],
              [77.061076, 19.99605],
              [77.064541, 19.990015],
              [77.064864, 19.989453],
              [77.065604, 19.985519],
              [77.065687, 19.985075],
              [77.071695, 19.981533],
              [77.071934, 19.981392],
              [77.073122, 19.975389],
              [77.073178, 19.975105],
              [77.077328, 19.97045],
              [77.08365, 19.967055],
              [77.085103, 19.964917],
              [77.08544, 19.96442],
              [77.08466, 19.957322],
              [77.086379, 19.953673],
              [77.086635, 19.953129],
              [77.092717, 19.949291],
              [77.092937, 19.949152],
              [77.094903, 19.94094],
              [77.096434, 19.937369],
              [77.096649, 19.936868],
              [77.102023, 19.932686],
              [77.108753, 19.934564],
              [77.112021, 19.937732],
              [77.118337, 19.940017],
              [77.125793, 19.939802],
              [77.133959, 19.942828],
              [77.137285, 19.946293],
              [77.138056, 19.950982],
              [77.139277, 19.953237],
              [77.157447, 19.966592],
              [77.162545, 19.966786],
              [77.165741, 19.964507],
              [77.171739, 19.964334],
              [77.17701, 19.969232],
              [77.178101, 19.972928],
              [77.178316, 19.977459],
              [77.181674, 19.97983],
              [77.194241, 19.983933],
              [77.200125, 19.990938],
              [77.203963, 19.991337],
              [77.213613, 19.980879],
              [77.217634, 19.978076],
              [77.218002, 19.977819],
              [77.217325, 19.972271],
              [77.211763, 19.967614],
              [77.210478, 19.963858],
              [77.210432, 19.957022],
              [77.208935, 19.947016],
              [77.210314, 19.943417],
              [77.210491, 19.942954],
              [77.214093, 19.939917],
              [77.220359, 19.938692],
              [77.236711, 19.939924],
              [77.239081, 19.938227],
              [77.239316, 19.938058],
              [77.240888, 19.930835],
              [77.240627, 19.923148],
              [77.241648, 19.916054],
              [77.243597, 19.910791],
              [77.243759, 19.910355],
              [77.248263, 19.906179],
              [77.248755, 19.905723],
              [77.240902, 19.899414],
              [77.237678, 19.895957],
              [77.237567, 19.895839],
              [77.240895, 19.892258],
              [77.243955, 19.891244],
              [77.249635, 19.89251],
              [77.262559, 19.899754],
              [77.265635, 19.899374],
              [77.269078, 19.897139],
              [77.273728, 19.900329],
              [77.273725, 19.908891],
              [77.275487, 19.914344],
              [77.279139, 19.916365],
              [77.284765, 19.916022],
              [77.285005, 19.916007],
              [77.285844, 19.910471],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 227,
        censuscode: 512,
        dt_cen_cd: 16,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Hingoli",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [74.814926, 20.633747],
              [74.81236, 20.594632],
              [74.810448, 20.586972],
              [74.807987, 20.584937],
              [74.802162, 20.588488],
              [74.795491, 20.575376],
              [74.794577, 20.570398],
              [74.795632, 20.560705],
              [74.796271, 20.557606],
              [74.799318, 20.55173],
              [74.799345, 20.548176],
              [74.795768, 20.539496],
              [74.787706, 20.538546],
              [74.770633, 20.539341],
              [74.761903, 20.538624],
              [74.762586, 20.528242],
              [74.766805, 20.524194],
              [74.770776, 20.518427],
              [74.772864, 20.509008],
              [74.774589, 20.504578],
              [74.783955, 20.507583],
              [74.78619, 20.500113],
              [74.785437, 20.492948],
              [74.783489, 20.487579],
              [74.779773, 20.48263],
              [74.77354, 20.470597],
              [74.775228, 20.468459],
              [74.784574, 20.469805],
              [74.790762, 20.471918],
              [74.795451, 20.476977],
              [74.799298, 20.472006],
              [74.800609, 20.469068],
              [74.801869, 20.462409],
              [74.802503, 20.452882],
              [74.804207, 20.44777],
              [74.80625, 20.44471],
              [74.807938, 20.442914],
              [74.818641, 20.440454],
              [74.819548, 20.429099],
              [74.827922, 20.425626],
              [74.830558, 20.421305],
              [74.837897, 20.417441],
              [74.842075, 20.409888],
              [74.840944, 20.406401],
              [74.832017, 20.404259],
              [74.828644, 20.402514],
              [74.829708, 20.399462],
              [74.834886, 20.393791],
              [74.843661, 20.387914],
              [74.847151, 20.384547],
              [74.850724, 20.382738],
              [74.854157, 20.373586],
              [74.851812, 20.370913],
              [74.853242, 20.367742],
              [74.856979, 20.363979],
              [74.856274, 20.35057],
              [74.858796, 20.347791],
              [74.860373, 20.341872],
              [74.86108, 20.334697],
              [74.867669, 20.335087],
              [74.866661, 20.31624],
              [74.863468, 20.314264],
              [74.858941, 20.313163],
              [74.861179, 20.30076],
              [74.859351, 20.296079],
              [74.857042, 20.285502],
              [74.859727, 20.281809],
              [74.86306, 20.279713],
              [74.870154, 20.277006],
              [74.908957, 20.27276],
              [74.913827, 20.274345],
              [74.918179, 20.277644],
              [74.923415, 20.273678],
              [74.932022, 20.271951],
              [74.937873, 20.271666],
              [74.934923, 20.269694],
              [74.935768, 20.257492],
              [74.935473, 20.252008],
              [74.934217, 20.246658],
              [74.927566, 20.244813],
              [74.90839, 20.24335],
              [74.911112, 20.215727],
              [74.931417, 20.213691],
              [74.932144, 20.181305],
              [74.926871, 20.177992],
              [74.924454, 20.170661],
              [74.928442, 20.168612],
              [74.925344, 20.163799],
              [74.928836, 20.161008],
              [74.930677, 20.157562],
              [74.930507, 20.15252],
              [74.923882, 20.153568],
              [74.910907, 20.152648],
              [74.906685, 20.165665],
              [74.901599, 20.166894],
              [74.898165, 20.169483],
              [74.899052, 20.176797],
              [74.86945, 20.177612],
              [74.856114, 20.177056],
              [74.856475, 20.186675],
              [74.855889, 20.193384],
              [74.856665, 20.202534],
              [74.85333, 20.208522],
              [74.858602, 20.227094],
              [74.853764, 20.229662],
              [74.844041, 20.231421],
              [74.836376, 20.231966],
              [74.830426, 20.233576],
              [74.832384, 20.239626],
              [74.831875, 20.24238],
              [74.828834, 20.243045],
              [74.823231, 20.242757],
              [74.819656, 20.244114],
              [74.816421, 20.244206],
              [74.809434, 20.23958],
              [74.803402, 20.234255],
              [74.783869, 20.230438],
              [74.784669, 20.225386],
              [74.789854, 20.226022],
              [74.8041, 20.231094],
              [74.790384, 20.20832],
              [74.784369, 20.203959],
              [74.78236, 20.203808],
              [74.780726, 20.204804],
              [74.776106, 20.205309],
              [74.766698, 20.202937],
              [74.759972, 20.199509],
              [74.758841, 20.196427],
              [74.764109, 20.182792],
              [74.756314, 20.183047],
              [74.741679, 20.185936],
              [74.73886, 20.189166],
              [74.739319, 20.193065],
              [74.738491, 20.194673],
              [74.730705, 20.189939],
              [74.724014, 20.190339],
              [74.723086, 20.188922],
              [74.723364, 20.186515],
              [74.71763, 20.178899],
              [74.715269, 20.167517],
              [74.717727, 20.163595],
              [74.718784, 20.160148],
              [74.71546, 20.135069],
              [74.710565, 20.133688],
              [74.710999, 20.128757],
              [74.708603, 20.127168],
              [74.707414, 20.124311],
              [74.709522, 20.121773],
              [74.708012, 20.117493],
              [74.705296, 20.114588],
              [74.706985, 20.113144],
              [74.730464, 20.111428],
              [74.738254, 20.082298],
              [74.729287, 20.079688],
              [74.710848, 20.078375],
              [74.714982, 20.069105],
              [74.722935, 20.054759],
              [74.710336, 20.040262],
              [74.71316, 20.032264],
              [74.718012, 20.026547],
              [74.720227, 20.021141],
              [74.718081, 20.017264],
              [74.713443, 20.016624],
              [74.70093, 20.018228],
              [74.691903, 20.006336],
              [74.690914, 20.000573],
              [74.692947, 19.996375],
              [74.685279, 19.989206],
              [74.686106, 19.983356],
              [74.688582, 19.976769],
              [74.689523, 19.971487],
              [74.687432, 19.967572],
              [74.68562, 19.966351],
              [74.682088, 19.966675],
              [74.677371, 19.964805],
              [74.675196, 19.963125],
              [74.673327, 19.946696],
              [74.65898, 19.947049],
              [74.62757, 19.950787],
              [74.573524, 19.954526],
              [74.567673, 19.95821],
              [74.56204, 19.964427],
              [74.558067, 19.967441],
              [74.53148, 19.975396],
              [74.526567, 19.975526],
              [74.52225, 19.975264],
              [74.520828, 19.971815],
              [74.520484, 19.96842],
              [74.517877, 19.968343],
              [74.514769, 19.969465],
              [74.511649, 19.973],
              [74.497353, 19.969446],
              [74.496002, 19.963523],
              [74.480194, 19.966261],
              [74.480636, 19.971382],
              [74.485371, 19.979914],
              [74.475854, 19.985177],
              [74.469217, 19.987713],
              [74.458241, 19.986015],
              [74.449229, 19.974626],
              [74.445526, 19.974198],
              [74.428953, 19.974404],
              [74.385982, 19.980478],
              [74.37829, 19.971627],
              [74.366728, 19.974108],
              [74.365899, 19.965488],
              [74.351503, 19.966286],
              [74.348134, 19.983711],
              [74.31976, 19.985416],
              [74.319522, 19.978584],
              [74.318263, 19.976789],
              [74.314997, 19.975848],
              [74.312351, 19.972773],
              [74.311538, 19.968286],
              [74.309608, 19.967009],
              [74.306135, 19.968477],
              [74.302221, 19.972168],
              [74.290003, 19.98676],
              [74.284773, 19.968337],
              [74.283516, 19.958911],
              [74.264358, 19.96276],
              [74.259381, 19.962824],
              [74.251694, 19.964079],
              [74.249, 19.94981],
              [74.250217, 19.936784],
              [74.263089, 19.936211],
              [74.272892, 19.932976],
              [74.275157, 19.930349],
              [74.27851, 19.915851],
              [74.277788, 19.908157],
              [74.285895, 19.90496],
              [74.292328, 19.904788],
              [74.29424, 19.900837],
              [74.338307, 19.886012],
              [74.340843, 19.873405],
              [74.364714, 19.870562],
              [74.365829, 19.853006],
              [74.363735, 19.836103],
              [74.372107, 19.835776],
              [74.371925, 19.828938],
              [74.370637, 19.822726],
              [74.371195, 19.814868],
              [74.375083, 19.807427],
              [74.378059, 19.80585],
              [74.37498, 19.804616],
              [74.367942, 19.804559],
              [74.365602, 19.801834],
              [74.333732, 19.799035],
              [74.328488, 19.79468],
              [74.325629, 19.783055],
              [74.326194, 19.773588],
              [74.324464, 19.770352],
              [74.319032, 19.767319],
              [74.311012, 19.768801],
              [74.307894, 19.771298],
              [74.295301, 19.776757],
              [74.281638, 19.778984],
              [74.278251, 19.778385],
              [74.275965, 19.776067],
              [74.272159, 19.767763],
              [74.266651, 19.760306],
              [74.263464, 19.757114],
              [74.258022, 19.755569],
              [74.25314, 19.753115],
              [74.249953, 19.750107],
              [74.246006, 19.743919],
              [74.225366, 19.740172],
              [74.22291, 19.736934],
              [74.196475, 19.737424],
              [74.189388, 19.736961],
              [74.188334, 19.733391],
              [74.181018, 19.731017],
              [74.171332, 19.729955],
              [74.167651, 19.728077],
              [74.167056, 19.726813],
              [74.164292, 19.725058],
              [74.163459, 19.716896],
              [74.162165, 19.712631],
              [74.156258, 19.703559],
              [74.157442, 19.700245],
              [74.154082, 19.696423],
              [74.153533, 19.69056],
              [74.150718, 19.687715],
              [74.141578, 19.69279],
              [74.135981, 19.694924],
              [74.134621, 19.691291],
              [74.137618, 19.682477],
              [74.14365, 19.673289],
              [74.141614, 19.67057],
              [74.137391, 19.669038],
              [74.131953, 19.660947],
              [74.127373, 19.658543],
              [74.121459, 19.643728],
              [74.107541, 19.642896],
              [74.101131, 19.646973],
              [74.098586, 19.641601],
              [74.09678, 19.639747],
              [74.088529, 19.64656],
              [74.083552, 19.647766],
              [74.070638, 19.660098],
              [74.060821, 19.660688],
              [74.038944, 19.666373],
              [74.034079, 19.66845],
              [74.02412, 19.669608],
              [74.019373, 19.672317],
              [74.012852, 19.669435],
              [74.000033, 19.669843],
              [73.991381, 19.670084],
              [73.987699, 19.671221],
              [73.984017, 19.672991],
              [73.98022, 19.676348],
              [73.96223, 19.674032],
              [73.958514, 19.670076],
              [73.956348, 19.672821],
              [73.951438, 19.67238],
              [73.939462, 19.672825],
              [73.915658, 19.68161],
              [73.909518, 19.687856],
              [73.906178, 19.696288],
              [73.912425, 19.698882],
              [73.913169, 19.70104],
              [73.912652, 19.70509],
              [73.908955, 19.705606],
              [73.906924, 19.709932],
              [73.897452, 19.716428],
              [73.896618, 19.719097],
              [73.89892, 19.730828],
              [73.898828, 19.735379],
              [73.901035, 19.740645],
              [73.901563, 19.746528],
              [73.900295, 19.74818],
              [73.893762, 19.749452],
              [73.891233, 19.752526],
              [73.889265, 19.746667],
              [73.88725, 19.743841],
              [73.883181, 19.741853],
              [73.875902, 19.740553],
              [73.869801, 19.742428],
              [73.867723, 19.74953],
              [73.859643, 19.745424],
              [73.842779, 19.740949],
              [73.8415, 19.739286],
              [73.840773, 19.728266],
              [73.83783, 19.72097],
              [73.835393, 19.717441],
              [73.828537, 19.716512],
              [73.824896, 19.714876],
              [73.819358, 19.708523],
              [73.815555, 19.700805],
              [73.81354, 19.685664],
              [73.810622, 19.683838],
              [73.808573, 19.684424],
              [73.805993, 19.689591],
              [73.802596, 19.687767],
              [73.796545, 19.68931],
              [73.795143, 19.687631],
              [73.795556, 19.685648],
              [73.80426, 19.682217],
              [73.805876, 19.678523],
              [73.8049, 19.677006],
              [73.800296, 19.676991],
              [73.79715, 19.676163],
              [73.793286, 19.668532],
              [73.790679, 19.665876],
              [73.789273, 19.663037],
              [73.787446, 19.661289],
              [73.783688, 19.660797],
              [73.781425, 19.656189],
              [73.780804, 19.652889],
              [73.781342, 19.650313],
              [73.783804, 19.648361],
              [73.792402, 19.64752],
              [73.793781, 19.6458],
              [73.790141, 19.643078],
              [73.779362, 19.64239],
              [73.779567, 19.635591],
              [73.7781, 19.631829],
              [73.774578, 19.62972],
              [73.770658, 19.633276],
              [73.764587, 19.629018],
              [73.756113, 19.628761],
              [73.752708, 19.624935],
              [73.748402, 19.623575],
              [73.743315, 19.623705],
              [73.74095, 19.621882],
              [73.736215, 19.620236],
              [73.727757, 19.621633],
              [73.726299, 19.620374],
              [73.722354, 19.619299],
              [73.717085, 19.616906],
              [73.712767, 19.613997],
              [73.712294, 19.602725],
              [73.709617, 19.599694],
              [73.7038, 19.596554],
              [73.688842, 19.595211],
              [73.68744, 19.591204],
              [73.683249, 19.588982],
              [73.67515, 19.590543],
              [73.668232, 19.586841],
              [73.663636, 19.586271],
              [73.654144, 19.589328],
              [73.647433, 19.590257],
              [73.643693, 19.592438],
              [73.641224, 19.595429],
              [73.638389, 19.597441],
              [73.634143, 19.59699],
              [73.623832, 19.589672],
              [73.620211, 19.587029],
              [73.595566, 19.599965],
              [73.590191, 19.601409],
              [73.57959, 19.600276],
              [73.577594, 19.601424],
              [73.586463, 19.608645],
              [73.582476, 19.612257],
              [73.576383, 19.616282],
              [73.565976, 19.616531],
              [73.567025, 19.621457],
              [73.563703, 19.642337],
              [73.558742, 19.644235],
              [73.556338, 19.646934],
              [73.551629, 19.650266],
              [73.546815, 19.659215],
              [73.544289, 19.665817],
              [73.532412, 19.680677],
              [73.531284, 19.685907],
              [73.526759, 19.691815],
              [73.522711, 19.693885],
              [73.520253, 19.701799],
              [73.517773, 19.703351],
              [73.505015, 19.707262],
              [73.499878, 19.71053],
              [73.493767, 19.712151],
              [73.491292, 19.714558],
              [73.490637, 19.720062],
              [73.507087, 19.729795],
              [73.503575, 19.731693],
              [73.504926, 19.736565],
              [73.504214, 19.741956],
              [73.504952, 19.744254],
              [73.503872, 19.74792],
              [73.50394, 19.750961],
              [73.500937, 19.758706],
              [73.492341, 19.759632],
              [73.475733, 19.757639],
              [73.461924, 19.75948],
              [73.458601, 19.760808],
              [73.45074, 19.767234],
              [73.446704, 19.773141],
              [73.4449, 19.777898],
              [73.443818, 19.783986],
              [73.442789, 19.825447],
              [73.435835, 19.830552],
              [73.428868, 19.832388],
              [73.422638, 19.835314],
              [73.420941, 19.836755],
              [73.417927, 19.842601],
              [73.418003, 19.848341],
              [73.416737, 19.852125],
              [73.416761, 19.859751],
              [73.418347, 19.86417],
              [73.42703, 19.869549],
              [73.43528, 19.872933],
              [73.428067, 19.894847],
              [73.426456, 19.905968],
              [73.423685, 19.910613],
              [73.423701, 19.91566],
              [73.434335, 19.926034],
              [73.438472, 19.931021],
              [73.440241, 19.934577],
              [73.442446, 19.940707],
              [73.442946, 19.946556],
              [73.441935, 19.95424],
              [73.448544, 19.955043],
              [73.452732, 19.956417],
              [73.454867, 19.959107],
              [73.448518, 19.966055],
              [73.451087, 19.972933],
              [73.4525, 19.981992],
              [73.44407, 19.979813],
              [73.436674, 19.980336],
              [73.426123, 19.984581],
              [73.420627, 19.99141],
              [73.417211, 20.00104],
              [73.416553, 20.004749],
              [73.413493, 20.009435],
              [73.411082, 20.012675],
              [73.405887, 20.016915],
              [73.398301, 20.016714],
              [73.390761, 20.019548],
              [73.389792, 20.019318],
              [73.386434, 20.013414],
              [73.384288, 20.014331],
              [73.382096, 20.021848],
              [73.380084, 20.024033],
              [73.377401, 20.025462],
              [73.37531, 20.020295],
              [73.375998, 20.016732],
              [73.373109, 20.014724],
              [73.364439, 20.020982],
              [73.363376, 20.035119],
              [73.360347, 20.034657],
              [73.356429, 20.038685],
              [73.352557, 20.039196],
              [73.346183, 20.03668],
              [73.340291, 20.041569],
              [73.335968, 20.039844],
              [73.333533, 20.039675],
              [73.32172, 20.045664],
              [73.315867, 20.049512],
              [73.313891, 20.052444],
              [73.313397, 20.054626],
              [73.311194, 20.057324],
              [73.308542, 20.055834],
              [73.305829, 20.05308],
              [73.305025, 20.05107],
              [73.302677, 20.050898],
              [73.298272, 20.058365],
              [73.295579, 20.060492],
              [73.292692, 20.060038],
              [73.290346, 20.058078],
              [73.290148, 20.054862],
              [73.291212, 20.049747],
              [73.289366, 20.048654],
              [73.285713, 20.050551],
              [73.284544, 20.049348],
              [73.285556, 20.04624],
              [73.284522, 20.044633],
              [73.282857, 20.044765],
              [73.280994, 20.044923],
              [73.279731, 20.046644],
              [73.278575, 20.046597],
              [73.270791, 20.05533],
              [73.270026, 20.055811],
              [73.268603, 20.056713],
              [73.265528, 20.060795],
              [73.265004, 20.063445],
              [73.268479, 20.071661],
              [73.26316, 20.073855],
              [73.263678, 20.076501],
              [73.265942, 20.078678],
              [73.269124, 20.080863],
              [73.271932, 20.081433],
              [73.273661, 20.083449],
              [73.274434, 20.087868],
              [73.272631, 20.093796],
              [73.273197, 20.09707],
              [73.271958, 20.104947],
              [73.268948, 20.107588],
              [73.257215, 20.110576],
              [73.25396, 20.112936],
              [73.249834, 20.120806],
              [73.249897, 20.124743],
              [73.251725, 20.125689],
              [73.253257, 20.128045],
              [73.25544, 20.133854],
              [73.258929, 20.139375],
              [73.274021, 20.145823],
              [73.279655, 20.149615],
              [73.284239, 20.153927],
              [73.283814, 20.162209],
              [73.281272, 20.174459],
              [73.281353, 20.177391],
              [73.284387, 20.186016],
              [73.284718, 20.19389],
              [73.28552, 20.19625],
              [73.288872, 20.196187],
              [73.301867, 20.207218],
              [73.304911, 20.207669],
              [73.311239, 20.204327],
              [73.318665, 20.202486],
              [73.327255, 20.204081],
              [73.338933, 20.199014],
              [73.343741, 20.198435],
              [73.345697, 20.19958],
              [73.348134, 20.202457],
              [73.350222, 20.209064],
              [73.352718, 20.211934],
              [73.35857, 20.213306],
              [73.360211, 20.211642],
              [73.358566, 20.209334],
              [73.355744, 20.200946],
              [73.357863, 20.196289],
              [73.365283, 20.192603],
              [73.366928, 20.194898],
              [73.366276, 20.202837],
              [73.367321, 20.205246],
              [73.374681, 20.202311],
              [73.379562, 20.206214],
              [73.38638, 20.209075],
              [73.388444, 20.205851],
              [73.387338, 20.201541],
              [73.389156, 20.195908],
              [73.393903, 20.194929],
              [73.39659, 20.197857],
              [73.40031, 20.200383],
              [73.407983, 20.200191],
              [73.418028, 20.201442],
              [73.421141, 20.206098],
              [73.42152, 20.212189],
              [73.419094, 20.2153],
              [73.417279, 20.223457],
              [73.413588, 20.231626],
              [73.414028, 20.236624],
              [73.411533, 20.242147],
              [73.4135, 20.247951],
              [73.412843, 20.253578],
              [73.411625, 20.25686],
              [73.413046, 20.263407],
              [73.415674, 20.268986],
              [73.414403, 20.273527],
              [73.415878, 20.276677],
              [73.427512, 20.278849],
              [73.428249, 20.281949],
              [73.422076, 20.297878],
              [73.41985, 20.311734],
              [73.417424, 20.315757],
              [73.416636, 20.320529],
              [73.416732, 20.337485],
              [73.415048, 20.341624],
              [73.414763, 20.351907],
              [73.413061, 20.355419],
              [73.406106, 20.381383],
              [73.403312, 20.383342],
              [73.398986, 20.383747],
              [73.394403, 20.381629],
              [73.389332, 20.374568],
              [73.385794, 20.372787],
              [73.38281, 20.372735],
              [73.381484, 20.380038],
              [73.382604, 20.390034],
              [73.386767, 20.397844],
              [73.389023, 20.399053],
              [73.398948, 20.396107],
              [73.400847, 20.401162],
              [73.400123, 20.404032],
              [73.404403, 20.40765],
              [73.405981, 20.405466],
              [73.407198, 20.405978],
              [73.407701, 20.410456],
              [73.414293, 20.414125],
              [73.421179, 20.41417],
              [73.420703, 20.419753],
              [73.422252, 20.428594],
              [73.427325, 20.435832],
              [73.429419, 20.445476],
              [73.440567, 20.466439],
              [73.443626, 20.471137],
              [73.447536, 20.475101],
              [73.452724, 20.477849],
              [73.456885, 20.483872],
              [73.458356, 20.48801],
              [73.461482, 20.492031],
              [73.467654, 20.494715],
              [73.465837, 20.500755],
              [73.463976, 20.513739],
              [73.465507, 20.515008],
              [73.468635, 20.521717],
              [73.476508, 20.525382],
              [73.489105, 20.535876],
              [73.492593, 20.539888],
              [73.485092, 20.541855],
              [73.473572, 20.543033],
              [73.477652, 20.563708],
              [73.475552, 20.578082],
              [73.472638, 20.583251],
              [73.468501, 20.585963],
              [73.460327, 20.588444],
              [73.446547, 20.594271],
              [73.432029, 20.594813],
              [73.429164, 20.597173],
              [73.430761, 20.600958],
              [73.425486, 20.614412],
              [73.422447, 20.620228],
              [73.419284, 20.624193],
              [73.407567, 20.625877],
              [73.407557, 20.625901],
              [73.40672, 20.627773],
              [73.409597, 20.630186],
              [73.40631, 20.635415],
              [73.402964, 20.638292],
              [73.394302, 20.642327],
              [73.393158, 20.64894],
              [73.395243, 20.652091],
              [73.401466, 20.654725],
              [73.406597, 20.655757],
              [73.409171, 20.657592],
              [73.410823, 20.660174],
              [73.422056, 20.660563],
              [73.427248, 20.662048],
              [73.431651, 20.664513],
              [73.435028, 20.674039],
              [73.435343, 20.677662],
              [73.441882, 20.680411],
              [73.444694, 20.682645],
              [73.446349, 20.68569],
              [73.44838, 20.693039],
              [73.439118, 20.700756],
              [73.445555, 20.710107],
              [73.450566, 20.713952],
              [73.467136, 20.721274],
              [73.472447, 20.719254],
              [73.474582, 20.716834],
              [73.476146, 20.708675],
              [73.480711, 20.706199],
              [73.485323, 20.693894],
              [73.485736, 20.689127],
              [73.489272, 20.685614],
              [73.489196, 20.680551],
              [73.484006, 20.679934],
              [73.48113, 20.678101],
              [73.479349, 20.675171],
              [73.479707, 20.671727],
              [73.481472, 20.669247],
              [73.484459, 20.668035],
              [73.48531, 20.665163],
              [73.487432, 20.662291],
              [73.490396, 20.653033],
              [73.492839, 20.652343],
              [73.499881, 20.658245],
              [73.504348, 20.662598],
              [73.509855, 20.66971],
              [73.512046, 20.66592],
              [73.517234, 20.666711],
              [73.519079, 20.6697],
              [73.522501, 20.672677],
              [73.530503, 20.673405],
              [73.536901, 20.668738],
              [73.545834, 20.654869],
              [73.555142, 20.646918],
              [73.559543, 20.647434],
              [73.56645, 20.650569],
              [73.576449, 20.647392],
              [73.583519, 20.644611],
              [73.595089, 20.637349],
              [73.599661, 20.635781],
              [73.614578, 20.62477],
              [73.618348, 20.62057],
              [73.62192, 20.611769],
              [73.622815, 20.605508],
              [73.624572, 20.60171],
              [73.627462, 20.591128],
              [73.626878, 20.581764],
              [73.62918, 20.578769],
              [73.63192, 20.577385],
              [73.635706, 20.576628],
              [73.639548, 20.576964],
              [73.643385, 20.575862],
              [73.64953, 20.571644],
              [73.654328, 20.565197],
              [73.658347, 20.56226],
              [73.663228, 20.561786],
              [73.66872, 20.563604],
              [73.673919, 20.567099],
              [73.67809, 20.57111],
              [73.68505, 20.574766],
              [73.693665, 20.577788],
              [73.702322, 20.573912],
              [73.712577, 20.575715],
              [73.717023, 20.575188],
              [73.721775, 20.573508],
              [73.73044, 20.57336],
              [73.734343, 20.571975],
              [73.741027, 20.566725],
              [73.756833, 20.582669],
              [73.761975, 20.586508],
              [73.768637, 20.588091],
              [73.772925, 20.591183],
              [73.774341, 20.594393],
              [73.780049, 20.601569],
              [73.785734, 20.603614],
              [73.795438, 20.605078],
              [73.799021, 20.600806],
              [73.809668, 20.608648],
              [73.818541, 20.61328],
              [73.82386, 20.614181],
              [73.82709, 20.613361],
              [73.831489, 20.615011],
              [73.839641, 20.622753],
              [73.836331, 20.64364],
              [73.836718, 20.649557],
              [73.84035, 20.655587],
              [73.838635, 20.666292],
              [73.834769, 20.674363],
              [73.827495, 20.672767],
              [73.81864, 20.672855],
              [73.815866, 20.693053],
              [73.821988, 20.695682],
              [73.826887, 20.698825],
              [73.832453, 20.70111],
              [73.836054, 20.701325],
              [73.85696, 20.693483],
              [73.867045, 20.706891],
              [73.870714, 20.720487],
              [73.875387, 20.726029],
              [73.879058, 20.728762],
              [73.882357, 20.730229],
              [73.89732, 20.72977],
              [73.902303, 20.724355],
              [73.914501, 20.722646],
              [73.921201, 20.729549],
              [73.928731, 20.733724],
              [73.929628, 20.730605],
              [73.943249, 20.741389],
              [73.94217, 20.745781],
              [73.938946, 20.748371],
              [73.94123, 20.751552],
              [73.940912, 20.759855],
              [73.932045, 20.759876],
              [73.934287, 20.767937],
              [73.931843, 20.788737],
              [73.934913, 20.802835],
              [73.933956, 20.807915],
              [73.940063, 20.817714],
              [73.941443, 20.824146],
              [73.941408, 20.828437],
              [73.938892, 20.839174],
              [73.941099, 20.8398],
              [73.945252, 20.838403],
              [73.959084, 20.842849],
              [73.963056, 20.842353],
              [73.967361, 20.846011],
              [73.968182, 20.851361],
              [73.983924, 20.845729],
              [73.987217, 20.843306],
              [73.990516, 20.843363],
              [73.993062, 20.839216],
              [73.998539, 20.836947],
              [74.000032, 20.835608],
              [74.003686, 20.83548],
              [74.010347, 20.836646],
              [74.021586, 20.835726],
              [74.018285, 20.844626],
              [74.019777, 20.848343],
              [74.025654, 20.850831],
              [74.029973, 20.847652],
              [74.033059, 20.842133],
              [74.037124, 20.837301],
              [74.041326, 20.835385],
              [74.047867, 20.835631],
              [74.049911, 20.840265],
              [74.0528, 20.842131],
              [74.056479, 20.844004],
              [74.060666, 20.848214],
              [74.069866, 20.844207],
              [74.074974, 20.849563],
              [74.080016, 20.845242],
              [74.092299, 20.844877],
              [74.097342, 20.841182],
              [74.102755, 20.845105],
              [74.102663, 20.849744],
              [74.101102, 20.854224],
              [74.105336, 20.857514],
              [74.113717, 20.858324],
              [74.115032, 20.862558],
              [74.119146, 20.864938],
              [74.126352, 20.865069],
              [74.13246, 20.863078],
              [74.138602, 20.859033],
              [74.144785, 20.852117],
              [74.15793, 20.852262],
              [74.157782, 20.85839],
              [74.159709, 20.862279],
              [74.167662, 20.86286],
              [74.194254, 20.854435],
              [74.201991, 20.859539],
              [74.207285, 20.856351],
              [74.213697, 20.856822],
              [74.218303, 20.858507],
              [74.221656, 20.858146],
              [74.225501, 20.857084],
              [74.228818, 20.850707],
              [74.235466, 20.849624],
              [74.239884, 20.850857],
              [74.244459, 20.851056],
              [74.249765, 20.856519],
              [74.254111, 20.858437],
              [74.255635, 20.857853],
              [74.260778, 20.851514],
              [74.265121, 20.850513],
              [74.270061, 20.850309],
              [74.276062, 20.851125],
              [74.290888, 20.855205],
              [74.29769, 20.849826],
              [74.307027, 20.848379],
              [74.315774, 20.84202],
              [74.318777, 20.842452],
              [74.326278, 20.847958],
              [74.329338, 20.841685],
              [74.332683, 20.839432],
              [74.336036, 20.838369],
              [74.33886, 20.839214],
              [74.338357, 20.845177],
              [74.339508, 20.851352],
              [74.345401, 20.8469],
              [74.348705, 20.847908],
              [74.348797, 20.859187],
              [74.357274, 20.856839],
              [74.358262, 20.842961],
              [74.358764, 20.845132],
              [74.363385, 20.842641],
              [74.368965, 20.844142],
              [74.385316, 20.840295],
              [74.386131, 20.843495],
              [74.384477, 20.849417],
              [74.385237, 20.853243],
              [74.387495, 20.853173],
              [74.390943, 20.855781],
              [74.394362, 20.85564],
              [74.395117, 20.857815],
              [74.396778, 20.859293],
              [74.397002, 20.849087],
              [74.398433, 20.84564],
              [74.402625, 20.841937],
              [74.405314, 20.835727],
              [74.389156, 20.839634],
              [74.387644, 20.834608],
              [74.395863, 20.830191],
              [74.395715, 20.827152],
              [74.39898, 20.823008],
              [74.40691, 20.815442],
              [74.422105, 20.805351],
              [74.43802, 20.801329],
              [74.450183, 20.80175],
              [74.456078, 20.812474],
              [74.465372, 20.813541],
              [74.467736, 20.818164],
              [74.472053, 20.822194],
              [74.47837, 20.831198],
              [74.483169, 20.828298],
              [74.482754, 20.82251],
              [74.484544, 20.817912],
              [74.491859, 20.816418],
              [74.493845, 20.819218],
              [74.507022, 20.817502],
              [74.507978, 20.814287],
              [74.512308, 20.80789],
              [74.516502, 20.810837],
              [74.524597, 20.814778],
              [74.528107, 20.817671],
              [74.531751, 20.821306],
              [74.533546, 20.824269],
              [74.536317, 20.832266],
              [74.539519, 20.83459],
              [74.542721, 20.831128],
              [74.548365, 20.826952],
              [74.553664, 20.825418],
              [74.567638, 20.823121],
              [74.572623, 20.832762],
              [74.573518, 20.830919],
              [74.574424, 20.823696],
              [74.578335, 20.817009],
              [74.582404, 20.813997],
              [74.589465, 20.812273],
              [74.598623, 20.81128],
              [74.612563, 20.805659],
              [74.62233, 20.798459],
              [74.630128, 20.790544],
              [74.637129, 20.781429],
              [74.645611, 20.780382],
              [74.64998, 20.778044],
              [74.65298, 20.778533],
              [74.657129, 20.777521],
              [74.665033, 20.774188],
              [74.665616, 20.770568],
              [74.661836, 20.759947],
              [74.655033, 20.757256],
              [74.654925, 20.753189],
              [74.656986, 20.751173],
              [74.657123, 20.746923],
              [74.661232, 20.736579],
              [74.658762, 20.733446],
              [74.656018, 20.727508],
              [74.658265, 20.720674],
              [74.656448, 20.709856],
              [74.650855, 20.6949],
              [74.655907, 20.693131],
              [74.670698, 20.693967],
              [74.685222, 20.693094],
              [74.694592, 20.690891],
              [74.71009, 20.689251],
              [74.723176, 20.679271],
              [74.726404, 20.678212],
              [74.730873, 20.679717],
              [74.733153, 20.675631],
              [74.737023, 20.672667],
              [74.738131, 20.66761],
              [74.741308, 20.667701],
              [74.743889, 20.669335],
              [74.749522, 20.670999],
              [74.750123, 20.664352],
              [74.757472, 20.666623],
              [74.759766, 20.663512],
              [74.764069, 20.666796],
              [74.766475, 20.662527],
              [74.76859, 20.661589],
              [74.771287, 20.662364],
              [74.770268, 20.664213],
              [74.774252, 20.665602],
              [74.776985, 20.663571],
              [74.784004, 20.664076],
              [74.790315, 20.660124],
              [74.795148, 20.660872],
              [74.798485, 20.659753],
              [74.800727, 20.65813],
              [74.80566, 20.656645],
              [74.803483, 20.636207],
              [74.808989, 20.637475],
              [74.81294, 20.635714],
              [74.814926, 20.633747],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 404,
        censuscode: 516,
        dt_cen_cd: 20,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Nashik",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [76.276918, 18.556972],
              [76.276348, 18.544821],
              [76.27482, 18.538416],
              [76.268213, 18.532174],
              [76.257983, 18.526031],
              [76.255298, 18.518828],
              [76.256477, 18.50569],
              [76.256104, 18.495265],
              [76.258927, 18.49363],
              [76.258036, 18.489684],
              [76.255276, 18.486042],
              [76.256798, 18.48242],
              [76.269874, 18.473189],
              [76.271928, 18.467889],
              [76.272427, 18.464273],
              [76.268318, 18.464545],
              [76.26347, 18.463842],
              [76.267573, 18.437105],
              [76.271659, 18.420041],
              [76.266903, 18.421517],
              [76.256993, 18.426998],
              [76.239316, 18.434378],
              [76.233071, 18.43329],
              [76.225951, 18.428889],
              [76.222196, 18.42251],
              [76.219569, 18.414906],
              [76.211779, 18.400188],
              [76.200343, 18.398695],
              [76.201394, 18.395247],
              [76.207647, 18.38779],
              [76.216834, 18.382379],
              [76.230681, 18.378293],
              [76.237072, 18.377258],
              [76.243293, 18.377208],
              [76.249008, 18.37509],
              [76.255255, 18.366604],
              [76.259216, 18.364564],
              [76.26392, 18.368356],
              [76.27041, 18.375749],
              [76.275356, 18.380173],
              [76.282175, 18.384861],
              [76.288289, 18.385831],
              [76.289601, 18.379119],
              [76.287504, 18.355868],
              [76.285216, 18.340701],
              [76.31865, 18.328978],
              [76.319528, 18.311381],
              [76.31853, 18.29317],
              [76.316294, 18.281721],
              [76.311473, 18.277186],
              [76.308156, 18.272],
              [76.311262, 18.269624],
              [76.307303, 18.265361],
              [76.294001, 18.258266],
              [76.289234, 18.252702],
              [76.287014, 18.248423],
              [76.283335, 18.248401],
              [76.286783, 18.232603],
              [76.292198, 18.231694],
              [76.297692, 18.231924],
              [76.302135, 18.22971],
              [76.302445, 18.213368],
              [76.298162, 18.213818],
              [76.296149, 18.20673],
              [76.295158, 18.199055],
              [76.282132, 18.182044],
              [76.281106, 18.17203],
              [76.282004, 18.16176],
              [76.281592, 18.154256],
              [76.279195, 18.150383],
              [76.279666, 18.14585],
              [76.277514, 18.143169],
              [76.277029, 18.139453],
              [76.283153, 18.129075],
              [76.295863, 18.121731],
              [76.301449, 18.11646],
              [76.303027, 18.11409],
              [76.305698, 18.108561],
              [76.306448, 18.103799],
              [76.305754, 18.096122],
              [76.308378, 18.091002],
              [76.312162, 18.08615],
              [76.315044, 18.084232],
              [76.321335, 18.076549],
              [76.323862, 18.074867],
              [76.331287, 18.074216],
              [76.342691, 18.078582],
              [76.347824, 18.078989],
              [76.358583, 18.083925],
              [76.370385, 18.087993],
              [76.381765, 18.089306],
              [76.386911, 18.080494],
              [76.398501, 18.066624],
              [76.39959, 18.062536],
              [76.399295, 18.053031],
              [76.402818, 18.050871],
              [76.405181, 18.047125],
              [76.408587, 18.045191],
              [76.418841, 18.041709],
              [76.424702, 18.033794],
              [76.428392, 18.030374],
              [76.441727, 18.032989],
              [76.473123, 18.026182],
              [76.478412, 18.026068],
              [76.482341, 18.026829],
              [76.486844, 18.026439],
              [76.494268, 18.023377],
              [76.502925, 18.02271],
              [76.512751, 18.02438],
              [76.517669, 18.023242],
              [76.522489, 18.024275],
              [76.525039, 18.021214],
              [76.529505, 18.02271],
              [76.53267, 18.021011],
              [76.54014, 18.023114],
              [76.547586, 18.024178],
              [76.557044, 18.029748],
              [76.568141, 18.038965],
              [76.577773, 18.036732],
              [76.582029, 18.040127],
              [76.589098, 18.03815],
              [76.596688, 18.032796],
              [76.602613, 18.032839],
              [76.606204, 18.035833],
              [76.612401, 18.037885],
              [76.610079, 18.019693],
              [76.607382, 18.01044],
              [76.623952, 18.000744],
              [76.625493, 17.999847],
              [76.662389, 17.999418],
              [76.670695, 17.998602],
              [76.676805, 17.996813],
              [76.680181, 17.993872],
              [76.681581, 17.992657],
              [76.68533, 17.98749],
              [76.68947, 17.976598],
              [76.689522, 17.970408],
              [76.679954, 17.970017],
              [76.674, 17.966912],
              [76.675914, 17.952912],
              [76.677274, 17.949521],
              [76.681858, 17.946276],
              [76.676068, 17.925945],
              [76.675592, 17.921965],
              [76.684525, 17.918747],
              [76.718864, 17.91695],
              [76.72434, 17.917824],
              [76.726963, 17.913718],
              [76.735822, 17.911101],
              [76.739314, 17.903796],
              [76.742381, 17.899597],
              [76.741302, 17.893642],
              [76.741381, 17.885218],
              [76.739188, 17.858693],
              [76.747519, 17.859945],
              [76.756329, 17.858242],
              [76.761512, 17.853732],
              [76.76614, 17.851164],
              [76.767535, 17.852469],
              [76.781595, 17.838022],
              [76.787317, 17.833173],
              [76.790048, 17.82818],
              [76.786665, 17.821358],
              [76.783278, 17.816846],
              [76.781338, 17.812017],
              [76.781652, 17.807654],
              [76.778141, 17.80112],
              [76.771868, 17.798763],
              [76.76817, 17.798383],
              [76.764576, 17.788848],
              [76.750651, 17.788076],
              [76.749542, 17.785341],
              [76.745777, 17.785187],
              [76.745317, 17.782521],
              [76.741179, 17.78086],
              [76.726343, 17.786793],
              [76.721071, 17.786998],
              [76.717403, 17.783621],
              [76.71414, 17.776801],
              [76.714486, 17.773072],
              [76.718899, 17.771571],
              [76.72268, 17.769323],
              [76.720783, 17.763058],
              [76.719682, 17.749614],
              [76.723628, 17.749782],
              [76.728232, 17.742137],
              [76.729349, 17.738775],
              [76.705164, 17.730874],
              [76.699814, 17.727794],
              [76.70378, 17.72548],
              [76.705116, 17.720394],
              [76.702472, 17.709049],
              [76.694028, 17.707041],
              [76.692522, 17.703722],
              [76.692873, 17.699929],
              [76.694794, 17.695553],
              [76.6922, 17.681754],
              [76.689914, 17.680305],
              [76.679772, 17.689125],
              [76.673256, 17.690905],
              [76.664729, 17.689632],
              [76.661402, 17.700936],
              [76.659694, 17.710269],
              [76.656762, 17.718129],
              [76.652376, 17.722554],
              [76.638931, 17.725814],
              [76.632134, 17.730692],
              [76.631278, 17.743551],
              [76.628403, 17.75763],
              [76.624814, 17.759544],
              [76.615873, 17.769944],
              [76.610914, 17.767616],
              [76.608289, 17.761221],
              [76.605461, 17.757458],
              [76.600193, 17.729641],
              [76.594629, 17.719241],
              [76.588397, 17.709578],
              [76.578535, 17.704822],
              [76.574556, 17.703851],
              [76.570742, 17.705414],
              [76.569408, 17.741442],
              [76.565876, 17.755276],
              [76.570656, 17.757992],
              [76.574615, 17.761613],
              [76.568834, 17.764498],
              [76.561043, 17.764742],
              [76.539423, 17.760521],
              [76.532788, 17.76011],
              [76.527491, 17.760938],
              [76.524871, 17.760457],
              [76.526206, 17.736274],
              [76.526023, 17.724532],
              [76.524822, 17.716849],
              [76.512108, 17.717531],
              [76.493341, 17.716544],
              [76.487449, 17.715113],
              [76.486709, 17.694318],
              [76.485526, 17.686061],
              [76.485738, 17.671281],
              [76.490387, 17.662325],
              [76.453303, 17.657187],
              [76.452533, 17.653143],
              [76.441824, 17.650997],
              [76.44373, 17.643516],
              [76.435751, 17.646165],
              [76.429645, 17.646044],
              [76.422772, 17.645792],
              [76.412207, 17.648545],
              [76.404817, 17.657246],
              [76.381309, 17.659603],
              [76.379306, 17.668191],
              [76.379851, 17.679498],
              [76.379301, 17.685592],
              [76.369585, 17.684166],
              [76.361605, 17.686711],
              [76.3561, 17.69619],
              [76.33976, 17.694004],
              [76.323471, 17.695977],
              [76.319246, 17.69707],
              [76.316211, 17.715556],
              [76.312101, 17.716773],
              [76.306797, 17.71963],
              [76.299194, 17.729054],
              [76.289889, 17.728006],
              [76.282376, 17.728969],
              [76.271406, 17.727534],
              [76.263714, 17.720715],
              [76.256773, 17.716795],
              [76.251311, 17.707777],
              [76.247474, 17.706243],
              [76.240804, 17.705165],
              [76.239593, 17.697922],
              [76.231471, 17.697446],
              [76.225945, 17.698019],
              [76.222344, 17.696373],
              [76.220076, 17.690543],
              [76.217418, 17.689449],
              [76.212194, 17.689903],
              [76.200269, 17.68847],
              [76.189866, 17.682384],
              [76.176472, 17.68753],
              [76.166417, 17.69286],
              [76.16631, 17.700008],
              [76.149641, 17.699016],
              [76.147336, 17.705169],
              [76.145012, 17.708668],
              [76.149909, 17.71819],
              [76.160089, 17.714688],
              [76.16646, 17.714006],
              [76.173601, 17.72278],
              [76.175627, 17.726638],
              [76.176266, 17.731084],
              [76.162013, 17.732756],
              [76.150021, 17.732809],
              [76.148242, 17.732813],
              [76.145288, 17.744231],
              [76.1455, 17.754289],
              [76.139219, 17.755936],
              [76.134858, 17.759137],
              [76.13128, 17.764148],
              [76.122367, 17.769046],
              [76.120765, 17.765205],
              [76.118727, 17.763242],
              [76.116488, 17.765811],
              [76.116137, 17.769026],
              [76.112612, 17.767134],
              [76.108127, 17.763313],
              [76.10286, 17.761196],
              [76.100043, 17.761274],
              [76.103431, 17.767599],
              [76.103092, 17.772537],
              [76.096419, 17.778662],
              [76.083802, 17.776092],
              [76.069447, 17.769891],
              [76.056182, 17.765338],
              [76.027584, 17.765913],
              [76.021465, 17.76273],
              [76.015391, 17.758154],
              [76.009046, 17.75056],
              [76.006251, 17.750134],
              [76.003082, 17.753618],
              [76.004528, 17.769303],
              [76.007186, 17.7849],
              [76.012262, 17.787245],
              [76.009466, 17.802765],
              [76.010787, 17.806204],
              [76.016926, 17.814387],
              [76.016512, 17.823065],
              [76.018468, 17.829051],
              [76.010866, 17.830722],
              [76.000121, 17.836584],
              [75.983589, 17.842009],
              [75.978028, 17.842313],
              [75.97495, 17.838161],
              [75.974798, 17.832109],
              [75.977283, 17.824938],
              [75.97653, 17.819919],
              [75.968394, 17.818759],
              [75.960021, 17.83087],
              [75.952291, 17.837514],
              [75.946299, 17.844908],
              [75.942893, 17.845657],
              [75.939719, 17.851709],
              [75.932374, 17.850599],
              [75.930376, 17.847351],
              [75.925649, 17.833408],
              [75.919504, 17.832309],
              [75.910591, 17.834821],
              [75.900043, 17.838897],
              [75.889366, 17.844755],
              [75.880755, 17.846891],
              [75.876294, 17.846035],
              [75.864991, 17.855689],
              [75.858058, 17.863867],
              [75.856116, 17.874563],
              [75.845351, 17.891927],
              [75.844498, 17.90133],
              [75.850097, 17.913269],
              [75.85148, 17.919914],
              [75.850365, 17.923765],
              [75.847347, 17.928776],
              [75.843082, 17.930028],
              [75.838811, 17.929383],
              [75.83818, 17.938942],
              [75.840225, 17.957991],
              [75.846585, 17.978247],
              [75.83946, 17.978481],
              [75.848441, 18.000361],
              [75.852114, 18.006432],
              [75.857477, 18.00974],
              [75.864441, 18.012214],
              [75.869718, 18.013213],
              [75.87677, 18.01314],
              [75.88321, 18.011112],
              [75.886406, 18.008302],
              [75.890991, 18.0066],
              [75.896332, 18.007254],
              [75.899976, 18.006617],
              [75.907254, 18.004046],
              [75.908165, 18.00024],
              [75.910733, 17.998375],
              [75.910105, 17.992312],
              [75.911026, 17.985073],
              [75.912893, 17.978326],
              [75.918348, 17.97412],
              [75.927194, 17.972879],
              [75.94066, 17.974886],
              [75.95278, 17.979061],
              [75.961087, 17.979652],
              [75.966479, 17.976955],
              [75.971532, 17.974601],
              [75.975824, 17.970613],
              [75.983842, 17.974986],
              [75.98564, 17.984995],
              [75.98571, 17.990045],
              [75.991212, 17.991618],
              [75.996588, 17.992516],
              [75.998411, 17.994443],
              [76.000023, 18.000014],
              [76.001826, 18.003444],
              [76.003533, 18.016972],
              [76.007279, 18.024648],
              [76.013821, 18.033888],
              [76.016225, 18.039535],
              [76.011996, 18.050099],
              [76.003623, 18.049033],
              [76.001415, 18.05509],
              [76.00002, 18.05518],
              [75.99812, 18.055415],
              [75.996061, 18.056854],
              [75.994417, 18.057804],
              [75.991892, 18.061711],
              [75.991339, 18.067643],
              [75.992894, 18.070652],
              [76.000022, 18.072384],
              [75.999427, 18.074113],
              [75.998618, 18.076088],
              [75.997143, 18.078194],
              [75.996504, 18.080517],
              [75.995977, 18.082834],
              [75.995511, 18.085119],
              [75.995037, 18.087339],
              [75.99453, 18.089492],
              [75.99391, 18.09155],
              [75.992892, 18.093691],
              [75.991306, 18.094609],
              [75.989349, 18.094005],
              [75.987225, 18.093205],
              [75.985109, 18.092897],
              [75.982982, 18.092589],
              [75.980829, 18.092274],
              [75.978665, 18.091946],
              [75.976502, 18.09161],
              [75.974329, 18.091264],
              [75.972167, 18.090927],
              [75.970014, 18.090591],
              [75.967878, 18.090273],
              [75.965762, 18.089986],
              [75.963682, 18.089734],
              [75.961676, 18.089709],
              [75.960393, 18.09138],
              [75.96027, 18.093238],
              [75.960063, 18.095119],
              [75.95949, 18.096968],
              [75.958811, 18.098813],
              [75.957939, 18.100539],
              [75.956738, 18.102039],
              [75.9551, 18.103249],
              [75.953248, 18.104328],
              [75.95148, 18.105476],
              [75.950073, 18.106887],
              [75.94899, 18.108531],
              [75.948001, 18.110251],
              [75.947086, 18.112039],
              [75.946237, 18.113878],
              [75.945424, 18.115742],
              [75.944647, 18.117638],
              [75.94389, 18.119524],
              [75.943133, 18.121411],
              [75.942336, 18.123352],
              [75.941841, 18.125386],
              [75.942296, 18.12723],
              [75.943282, 18.128977],
              [75.94453, 18.130672],
              [75.945876, 18.132344],
              [75.947184, 18.133966],
              [75.948643, 18.135458],
              [75.950063, 18.136973],
              [75.951167, 18.138698],
              [75.952044, 18.140561],
              [75.95299, 18.14238],
              [75.954328, 18.143967],
              [75.955835, 18.145451],
              [75.956764, 18.147205],
              [75.957009, 18.149253],
              [75.957445, 18.151262],
              [75.958177, 18.153183],
              [75.958983, 18.155096],
              [75.959751, 18.157009],
              [75.960405, 18.158935],
              [75.960487, 18.160939],
              [75.959832, 18.162923],
              [75.95915, 18.164885],
              [75.958417, 18.166846],
              [75.957602, 18.16875],
              [75.956657, 18.170556],
              [75.955274, 18.172041],
              [75.9534, 18.173166],
              [75.952, 18.174659],
              [75.950921, 18.176414],
              [75.949975, 18.178275],
              [75.949121, 18.180184],
              [75.948343, 18.182098],
              [75.947886, 18.184127],
              [75.947871, 18.186163],
              [75.948155, 18.188202],
              [75.948504, 18.190246],
              [75.948711, 18.192283],
              [75.948685, 18.194355],
              [75.948455, 18.196466],
              [75.947917, 18.198407],
              [75.946416, 18.199732],
              [75.944698, 18.201001],
              [75.943432, 18.202666],
              [75.94222, 18.204405],
              [75.941132, 18.206196],
              [75.940251, 18.20805],
              [75.939597, 18.209988],
              [75.9391, 18.212077],
              [75.938851, 18.214196],
              [75.938979, 18.216229],
              [75.939568, 18.218107],
              [75.940486, 18.219889],
              [75.94161, 18.221615],
              [75.942867, 18.223319],
              [75.944164, 18.225024],
              [75.945413, 18.226737],
              [75.946534, 18.22849],
              [75.947449, 18.230364],
              [75.948081, 18.232335],
              [75.948373, 18.234356],
              [75.948423, 18.236452],
              [75.948075, 18.238455],
              [75.947336, 18.240352],
              [75.946425, 18.242215],
              [75.945384, 18.244025],
              [75.94423, 18.245769],
              [75.942967, 18.247387],
              [75.941421, 18.248801],
              [75.939722, 18.250071],
              [75.937971, 18.251229],
              [75.936109, 18.252253],
              [75.934274, 18.253299],
              [75.932586, 18.254523],
              [75.930986, 18.255907],
              [75.929479, 18.257395],
              [75.928149, 18.258975],
              [75.927292, 18.260738],
              [75.927466, 18.26283],
              [75.927973, 18.264805],
              [75.928634, 18.266759],
              [75.929266, 18.268723],
              [75.929707, 18.270669],
              [75.929772, 18.272625],
              [75.929509, 18.274578],
              [75.929047, 18.276533],
              [75.928459, 18.278483],
              [75.927844, 18.280431],
              [75.927276, 18.282381],
              [75.926849, 18.284337],
              [75.926971, 18.286333],
              [75.927333, 18.288323],
              [75.926466, 18.290076],
              [75.925547, 18.291892],
              [75.92495, 18.293841],
              [75.924554, 18.295826],
              [75.924395, 18.297828],
              [75.924381, 18.299867],
              [75.924377, 18.30228],
              [75.920226, 18.305679],
              [75.917428, 18.310603],
              [75.911596, 18.31521],
              [75.908215, 18.319006],
              [75.904571, 18.324942],
              [75.902276, 18.335954],
              [75.896255, 18.347657],
              [75.888999, 18.358648],
              [75.887092, 18.363582],
              [75.883653, 18.366046],
              [75.875989, 18.367545],
              [75.87185, 18.367611],
              [75.86671, 18.365214],
              [75.856266, 18.364449],
              [75.851577, 18.364574],
              [75.842913, 18.367103],
              [75.833879, 18.373943],
              [75.830553, 18.377311],
              [75.824593, 18.380603],
              [75.81651, 18.382606],
              [75.806856, 18.383596],
              [75.802289, 18.382964],
              [75.798815, 18.384104],
              [75.795309, 18.391714],
              [75.785568, 18.395223],
              [75.782495, 18.404495],
              [75.774057, 18.411824],
              [75.771708, 18.416214],
              [75.769399, 18.42392],
              [75.769495, 18.432004],
              [75.766086, 18.438305],
              [75.763766, 18.439998],
              [75.751702, 18.436091],
              [75.74574, 18.434965],
              [75.741791, 18.435697],
              [75.728496, 18.43404],
              [75.725742, 18.429782],
              [75.721196, 18.415689],
              [75.718748, 18.411489],
              [75.717557, 18.406921],
              [75.7145, 18.402953],
              [75.713264, 18.399357],
              [75.708717, 18.396032],
              [75.711334, 18.392967],
              [75.718277, 18.391107],
              [75.722717, 18.390763],
              [75.727373, 18.389042],
              [75.728008, 18.386168],
              [75.729303, 18.379053],
              [75.729179, 18.368288],
              [75.731917, 18.360518],
              [75.730248, 18.356703],
              [75.722355, 18.348673],
              [75.720244, 18.343203],
              [75.720938, 18.340737],
              [75.720184, 18.337703],
              [75.71702, 18.338779],
              [75.707899, 18.33975],
              [75.703808, 18.338656],
              [75.701258, 18.335829],
              [75.69879, 18.330014],
              [75.696596, 18.327186],
              [75.689718, 18.32424],
              [75.686775, 18.324039],
              [75.683601, 18.325116],
              [75.676032, 18.329105],
              [75.664637, 18.330388],
              [75.655484, 18.332912],
              [75.651733, 18.330494],
              [75.64916, 18.325544],
              [75.643612, 18.318054],
              [75.642362, 18.313776],
              [75.633866, 18.305002],
              [75.633781, 18.302373],
              [75.629975, 18.29526],
              [75.626956, 18.28739],
              [75.621784, 18.281558],
              [75.618946, 18.274322],
              [75.623645, 18.270484],
              [75.628066, 18.268593],
              [75.633541, 18.264404],
              [75.634129, 18.257233],
              [75.632883, 18.247864],
              [75.630098, 18.245202],
              [75.625164, 18.244519],
              [75.618634, 18.245632],
              [75.605361, 18.243964],
              [75.59686, 18.24555],
              [75.586661, 18.245676],
              [75.578169, 18.243029],
              [75.574843, 18.240095],
              [75.569, 18.226823],
              [75.562387, 18.208057],
              [75.559831, 18.204882],
              [75.555743, 18.20338],
              [75.554575, 18.201109],
              [75.553698, 18.196994],
              [75.55359, 18.187205],
              [75.552164, 18.176679],
              [75.546989, 18.163632],
              [75.550988, 18.150122],
              [75.550873, 18.144913],
              [75.546212, 18.140618],
              [75.541287, 18.139418],
              [75.533377, 18.134409],
              [75.524721, 18.138178],
              [75.520921, 18.141717],
              [75.515746, 18.151109],
              [75.514931, 18.154047],
              [75.511604, 18.157571],
              [75.50815, 18.159502],
              [75.504924, 18.16069],
              [75.500952, 18.159468],
              [75.492991, 18.154703],
              [75.491085, 18.15638],
              [75.491087, 18.174022],
              [75.48463, 18.176095],
              [75.481199, 18.174758],
              [75.477599, 18.174572],
              [75.474732, 18.175867],
              [75.470165, 18.174601],
              [75.468046, 18.172561],
              [75.467097, 18.16759],
              [75.467516, 18.161918],
              [75.465348, 18.161252],
              [75.463761, 18.163733],
              [75.452925, 18.171531],
              [75.444915, 18.174893],
              [75.434133, 18.175468],
              [75.430251, 18.177866],
              [75.428722, 18.180687],
              [75.429239, 18.184629],
              [75.434602, 18.199684],
              [75.436595, 18.201553],
              [75.438705, 18.208118],
              [75.430493, 18.214847],
              [75.427718, 18.219525],
              [75.428786, 18.224601],
              [75.428594, 18.229708],
              [75.4278, 18.233784],
              [75.425014, 18.237706],
              [75.424326, 18.241146],
              [75.428744, 18.244932],
              [75.432547, 18.253594],
              [75.432205, 18.26162],
              [75.428984, 18.264],
              [75.396958, 18.265157],
              [75.397875, 18.279748],
              [75.398811, 18.283408],
              [75.397726, 18.288685],
              [75.40029, 18.293811],
              [75.401167, 18.297467],
              [75.40042, 18.300969],
              [75.396255, 18.304913],
              [75.394184, 18.307968],
              [75.396261, 18.311845],
              [75.404414, 18.31713],
              [75.407662, 18.324023],
              [75.406366, 18.326729],
              [75.401652, 18.329135],
              [75.398891, 18.329737],
              [75.38964, 18.328863],
              [75.387263, 18.331408],
              [75.385455, 18.336928],
              [75.380201, 18.3458],
              [75.376093, 18.350142],
              [75.367794, 18.354644],
              [75.36358, 18.359724],
              [75.362616, 18.366209],
              [75.360313, 18.370018],
              [75.352648, 18.372729],
              [75.347468, 18.377711],
              [75.344068, 18.379577],
              [75.339759, 18.380769],
              [75.337857, 18.383024],
              [75.334139, 18.390514],
              [75.327685, 18.387256],
              [75.322899, 18.395496],
              [75.318828, 18.396689],
              [75.316663, 18.396535],
              [75.311473, 18.39373],
              [75.306769, 18.392176],
              [75.303604, 18.393356],
              [75.30118, 18.397045],
              [75.300362, 18.400488],
              [75.298815, 18.402394],
              [75.290615, 18.405004],
              [75.286487, 18.406763],
              [75.2853, 18.407976],
              [75.28545, 18.411702],
              [75.301642, 18.429278],
              [75.30379, 18.434408],
              [75.299899, 18.442413],
              [75.299884, 18.447508],
              [75.298841, 18.452043],
              [75.298932, 18.455823],
              [75.300359, 18.459991],
              [75.300451, 18.464514],
              [75.302089, 18.472973],
              [75.302983, 18.485163],
              [75.299886, 18.494756],
              [75.299555, 18.498304],
              [75.301101, 18.503214],
              [75.309146, 18.508859],
              [75.311209, 18.511304],
              [75.31203, 18.515704],
              [75.314401, 18.51854],
              [75.317123, 18.520912],
              [75.335555, 18.524905],
              [75.335494, 18.538586],
              [75.343329, 18.553395],
              [75.345864, 18.561674],
              [75.362632, 18.555017],
              [75.380328, 18.550991],
              [75.394101, 18.546254],
              [75.414983, 18.535945],
              [75.419097, 18.533098],
              [75.422552, 18.535291],
              [75.426827, 18.542976],
              [75.430902, 18.547455],
              [75.439359, 18.55234],
              [75.444506, 18.568428],
              [75.452462, 18.58873],
              [75.456074, 18.594869],
              [75.462609, 18.593762],
              [75.465262, 18.600033],
              [75.465716, 18.603985],
              [75.467853, 18.606761],
              [75.473398, 18.607842],
              [75.481919, 18.61227],
              [75.487402, 18.619602],
              [75.488406, 18.62411],
              [75.490957, 18.626141],
              [75.496484, 18.625623],
              [75.507624, 18.621767],
              [75.509588, 18.625015],
              [75.516236, 18.628374],
              [75.525835, 18.638513],
              [75.531513, 18.640672],
              [75.537715, 18.641752],
              [75.542043, 18.641123],
              [75.548122, 18.641683],
              [75.551337, 18.64399],
              [75.554134, 18.653178],
              [75.553924, 18.655935],
              [75.544213, 18.658853],
              [75.543965, 18.664234],
              [75.544683, 18.669729],
              [75.546077, 18.675835],
              [75.548665, 18.682332],
              [75.552298, 18.684181],
              [75.556935, 18.684933],
              [75.577153, 18.685604],
              [75.588841, 18.6877],
              [75.587373, 18.697059],
              [75.592426, 18.696012],
              [75.601652, 18.692527],
              [75.608383, 18.686205],
              [75.611439, 18.681726],
              [75.614522, 18.672436],
              [75.614965, 18.668807],
              [75.621193, 18.661269],
              [75.638055, 18.653786],
              [75.647361, 18.648343],
              [75.653536, 18.646958],
              [75.661831, 18.647387],
              [75.66545, 18.648267],
              [75.66643, 18.64998],
              [75.667356, 18.662623],
              [75.666019, 18.666441],
              [75.666989, 18.672407],
              [75.668958, 18.676467],
              [75.670544, 18.683873],
              [75.670529, 18.687501],
              [75.672848, 18.690404],
              [75.690159, 18.690629],
              [75.697593, 18.688705],
              [75.705979, 18.686426],
              [75.708338, 18.682779],
              [75.713005, 18.680893],
              [75.718155, 18.679569],
              [75.72516, 18.676561],
              [75.730853, 18.675351],
              [75.734666, 18.678121],
              [75.738081, 18.676824],
              [75.743072, 18.677227],
              [75.749336, 18.678715],
              [75.752719, 18.680346],
              [75.76331, 18.6762],
              [75.767837, 18.672928],
              [75.76757, 18.67063],
              [75.77393, 18.669759],
              [75.776371, 18.67284],
              [75.781672, 18.668691],
              [75.782838, 18.662007],
              [75.793301, 18.656662],
              [75.796363, 18.655815],
              [75.797592, 18.657805],
              [75.79889, 18.666035],
              [75.801385, 18.67333],
              [75.811025, 18.67367],
              [75.813702, 18.671228],
              [75.825365, 18.67056],
              [75.827636, 18.664511],
              [75.83181, 18.666173],
              [75.835594, 18.665605],
              [75.837608, 18.663291],
              [75.846404, 18.659158],
              [75.852895, 18.659014],
              [75.858828, 18.661576],
              [75.860185, 18.659491],
              [75.858881, 18.651825],
              [75.860546, 18.650371],
              [75.862764, 18.649884],
              [75.871337, 18.652462],
              [75.874895, 18.652417],
              [75.879058, 18.649034],
              [75.883095, 18.649266],
              [75.885548, 18.648485],
              [75.894388, 18.648191],
              [75.903796, 18.650185],
              [75.916133, 18.650299],
              [75.918465, 18.649469],
              [75.920719, 18.647551],
              [75.929113, 18.645196],
              [75.938625, 18.645981],
              [75.941318, 18.645201],
              [75.94537, 18.642336],
              [75.949439, 18.636901],
              [75.949763, 18.634434],
              [75.948911, 18.629174],
              [75.945975, 18.625491],
              [75.944872, 18.619835],
              [75.945658, 18.616047],
              [75.949806, 18.608446],
              [75.952843, 18.607093],
              [75.957984, 18.607156],
              [75.961474, 18.608373],
              [75.971683, 18.614384],
              [75.993902, 18.620055],
              [75.996747, 18.618709],
              [75.998792, 18.613861],
              [75.998282, 18.610637],
              [75.996612, 18.607088],
              [75.98886, 18.601437],
              [75.98646, 18.595665],
              [75.990646, 18.59038],
              [75.99699, 18.587617],
              [76.000021, 18.585297],
              [76.006104, 18.588392],
              [76.006637, 18.593289],
              [76.004738, 18.60301],
              [76.006518, 18.60547],
              [76.010273, 18.606578],
              [76.020654, 18.604426],
              [76.028245, 18.601813],
              [76.033043, 18.597187],
              [76.035001, 18.593454],
              [76.043225, 18.58803],
              [76.046002, 18.581898],
              [76.049811, 18.57611],
              [76.05173, 18.574727],
              [76.058068, 18.573412],
              [76.069769, 18.576197],
              [76.076357, 18.575938],
              [76.098744, 18.587779],
              [76.103223, 18.587748],
              [76.116204, 18.585116],
              [76.128796, 18.586516],
              [76.144002, 18.58341],
              [76.151383, 18.583125],
              [76.153066, 18.582244],
              [76.15614, 18.57537],
              [76.156364, 18.568639],
              [76.158971, 18.558082],
              [76.163157, 18.559258],
              [76.166135, 18.560964],
              [76.167737, 18.563488],
              [76.167793, 18.5682],
              [76.165824, 18.576734],
              [76.166474, 18.58059],
              [76.170885, 18.585043],
              [76.176873, 18.585519],
              [76.187157, 18.585088],
              [76.199041, 18.58281],
              [76.199321, 18.580158],
              [76.202676, 18.577838],
              [76.212238, 18.578223],
              [76.216506, 18.575937],
              [76.221223, 18.575562],
              [76.234721, 18.57666],
              [76.238999, 18.575303],
              [76.254318, 18.576844],
              [76.254619, 18.566215],
              [76.259374, 18.563756],
              [76.268843, 18.561617],
              [76.276918, 18.556972],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 421,
        censuscode: 525,
        dt_cen_cd: 29,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Osmanabad",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [73.527384, 19.129174],
              [73.528409, 19.126935],
              [73.524396, 19.120285],
              [73.526561, 19.115754],
              [73.52317, 19.112598],
              [73.520143, 19.111514],
              [73.518877, 19.108304],
              [73.521694, 19.104282],
              [73.521443, 19.101241],
              [73.514612, 19.097585],
              [73.512428, 19.094029],
              [73.512787, 19.090812],
              [73.51728, 19.084327],
              [73.524044, 19.084154],
              [73.529357, 19.085526],
              [73.52535, 19.07744],
              [73.523994, 19.070152],
              [73.524042, 19.065851],
              [73.527814, 19.056272],
              [73.524439, 19.058397],
              [73.519252, 19.058576],
              [73.519957, 19.053697],
              [73.518133, 19.04905],
              [73.531283, 19.048524],
              [73.542323, 19.050571],
              [73.542867, 19.048111],
              [73.537829, 19.040769],
              [73.535818, 19.032174],
              [73.540278, 19.032621],
              [73.54605, 19.026651],
              [73.54434, 19.021433],
              [73.5468, 19.017995],
              [73.557227, 19.015968],
              [73.55408, 19.011447],
              [73.5467, 19.00549],
              [73.542587, 19.000675],
              [73.540359, 18.996144],
              [73.535786, 18.996599],
              [73.534369, 18.991184],
              [73.532296, 18.988344],
              [73.526769, 18.985674],
              [73.522585, 18.981856],
              [73.522323, 18.977739],
              [73.521219, 18.976242],
              [73.518522, 18.978377],
              [73.511887, 18.972322],
              [73.513566, 18.969311],
              [73.511786, 18.967682],
              [73.500593, 18.969171],
              [73.487896, 18.97763],
              [73.478587, 18.979152],
              [73.478385, 18.973816],
              [73.479311, 18.965465],
              [73.467498, 18.96838],
              [73.462242, 18.965888],
              [73.461251, 18.964036],
              [73.461554, 18.960946],
              [73.459885, 18.952841],
              [73.456928, 18.946489],
              [73.458721, 18.937177],
              [73.458437, 18.929492],
              [73.455908, 18.92595],
              [73.451423, 18.924332],
              [73.447673, 18.924501],
              [73.441114, 18.927312],
              [73.438829, 18.923436],
              [73.4387, 18.9208],
              [73.436645, 18.917268],
              [73.430607, 18.914363],
              [73.436816, 18.904891],
              [73.439458, 18.898802],
              [73.434589, 18.898032],
              [73.436639, 18.89451],
              [73.437774, 18.888395],
              [73.437654, 18.88198],
              [73.433899, 18.87286],
              [73.427628, 18.862612],
              [73.414953, 18.860103],
              [73.413177, 18.858584],
              [73.40297, 18.842422],
              [73.392457, 18.850619],
              [73.392128, 18.851704],
              [73.388753, 18.852041],
              [73.387038, 18.846745],
              [73.384462, 18.819645],
              [73.376744, 18.816704],
              [73.381045, 18.80239],
              [73.378556, 18.793353],
              [73.375749, 18.788666],
              [73.374027, 18.787197],
              [73.369322, 18.792365],
              [73.368076, 18.791032],
              [73.366189, 18.785837],
              [73.365584, 18.776367],
              [73.36218, 18.761929],
              [73.358398, 18.758305],
              [73.354337, 18.752734],
              [73.358092, 18.751823],
              [73.357296, 18.746197],
              [73.353858, 18.740404],
              [73.352835, 18.737118],
              [73.352044, 18.730978],
              [73.352713, 18.724341],
              [73.352067, 18.723127],
              [73.344915, 18.719445],
              [73.341596, 18.710166],
              [73.335339, 18.70352],
              [73.3317, 18.701625],
              [73.333167, 18.697408],
              [73.334465, 18.695829],
              [73.336223, 18.695224],
              [73.340414, 18.696499],
              [73.342775, 18.695627],
              [73.345697, 18.697169],
              [73.348959, 18.696992],
              [73.353852, 18.705792],
              [73.358503, 18.708334],
              [73.360479, 18.708478],
              [73.361627, 18.70506],
              [73.360811, 18.700802],
              [73.36419, 18.700458],
              [73.370398, 18.70309],
              [73.375244, 18.707988],
              [73.384872, 18.692849],
              [73.385515, 18.687353],
              [73.38414, 18.68366],
              [73.386181, 18.67774],
              [73.386401, 18.668743],
              [73.388287, 18.66161],
              [73.388901, 18.654282],
              [73.386084, 18.654007],
              [73.379147, 18.651193],
              [73.377286, 18.644916],
              [73.370014, 18.643876],
              [73.361188, 18.636099],
              [73.356378, 18.629777],
              [73.355311, 18.622415],
              [73.351482, 18.614617],
              [73.342889, 18.610629],
              [73.343313, 18.604221],
              [73.339678, 18.602436],
              [73.335541, 18.607809],
              [73.33436, 18.606701],
              [73.335358, 18.601842],
              [73.334981, 18.599485],
              [73.330902, 18.595172],
              [73.332118, 18.591585],
              [73.332283, 18.586034],
              [73.331623, 18.582982],
              [73.3255, 18.575994],
              [73.322233, 18.570609],
              [73.322555, 18.563108],
              [73.323588, 18.559346],
              [73.327698, 18.552253],
              [73.332588, 18.548036],
              [73.33674, 18.551203],
              [73.349691, 18.553884],
              [73.357388, 18.557231],
              [73.358326, 18.555411],
              [73.352859, 18.551992],
              [73.346703, 18.549426],
              [73.344571, 18.547665],
              [73.347401, 18.544273],
              [73.344127, 18.542731],
              [73.340702, 18.539229],
              [73.343533, 18.532522],
              [73.356899, 18.532516],
              [73.359676, 18.528441],
              [73.370487, 18.516582],
              [73.384562, 18.504162],
              [73.387177, 18.502422],
              [73.392866, 18.503838],
              [73.394209, 18.503063],
              [73.393049, 18.500862],
              [73.385603, 18.496954],
              [73.383179, 18.494331],
              [73.381683, 18.494078],
              [73.378188, 18.491208],
              [73.379209, 18.485036],
              [73.375192, 18.481015],
              [73.3705, 18.480878],
              [73.368572, 18.484341],
              [73.366806, 18.48546],
              [73.364167, 18.48501],
              [73.36209, 18.483604],
              [73.360806, 18.481691],
              [73.364361, 18.468508],
              [73.370113, 18.466538],
              [73.376293, 18.467332],
              [73.377153, 18.469358],
              [73.376169, 18.477361],
              [73.377695, 18.478763],
              [73.381984, 18.474823],
              [73.38381, 18.476687],
              [73.381411, 18.479568],
              [73.381106, 18.483411],
              [73.383301, 18.484761],
              [73.39139, 18.483468],
              [73.393769, 18.49096],
              [73.397802, 18.490856],
              [73.399649, 18.492259],
              [73.403193, 18.498742],
              [73.405918, 18.50073],
              [73.408449, 18.500437],
              [73.410182, 18.49823],
              [73.407798, 18.493599],
              [73.407624, 18.483854],
              [73.406804, 18.479194],
              [73.404721, 18.474863],
              [73.40673, 18.467272],
              [73.396394, 18.453921],
              [73.396242, 18.449218],
              [73.398043, 18.439443],
              [73.397756, 18.432507],
              [73.399473, 18.427322],
              [73.398851, 18.418539],
              [73.400805, 18.414215],
              [73.400591, 18.409111],
              [73.401789, 18.399901],
              [73.409305, 18.399631],
              [73.411157, 18.400464],
              [73.414558, 18.405395],
              [73.420277, 18.404452],
              [73.421875, 18.40265],
              [73.423373, 18.393219],
              [73.426835, 18.388119],
              [73.427715, 18.379761],
              [73.427123, 18.376088],
              [73.427848, 18.372714],
              [73.436088, 18.365749],
              [73.444372, 18.360038],
              [73.443136, 18.358128],
              [73.437331, 18.3535],
              [73.430888, 18.344507],
              [73.427833, 18.337522],
              [73.428927, 18.333928],
              [73.425136, 18.330603],
              [73.422034, 18.326021],
              [73.423062, 18.321055],
              [73.42572, 18.318747],
              [73.425221, 18.316329],
              [73.421397, 18.308876],
              [73.421734, 18.306756],
              [73.424044, 18.305365],
              [73.436005, 18.308485],
              [73.446394, 18.308603],
              [73.455013, 18.297563],
              [73.461469, 18.299335],
              [73.473091, 18.301137],
              [73.476049, 18.300435],
              [73.478206, 18.293708],
              [73.478666, 18.288727],
              [73.478121, 18.28219],
              [73.480274, 18.279761],
              [73.480115, 18.271329],
              [73.491649, 18.278278],
              [73.500835, 18.281582],
              [73.509344, 18.286363],
              [73.509454, 18.283844],
              [73.504779, 18.280046],
              [73.504353, 18.276431],
              [73.505556, 18.273405],
              [73.508963, 18.274096],
              [73.516215, 18.271978],
              [73.512294, 18.269795],
              [73.505258, 18.259992],
              [73.505178, 18.257755],
              [73.512551, 18.255351],
              [73.517591, 18.25228],
              [73.519379, 18.246181],
              [73.526081, 18.247724],
              [73.532455, 18.247421],
              [73.536769, 18.244565],
              [73.536471, 18.241186],
              [73.529972, 18.234941],
              [73.524762, 18.233998],
              [73.523278, 18.229963],
              [73.531386, 18.22975],
              [73.534847, 18.227745],
              [73.535068, 18.225451],
              [73.529023, 18.217507],
              [73.523406, 18.21283],
              [73.523432, 18.211344],
              [73.526078, 18.211155],
              [73.532536, 18.212519],
              [73.533689, 18.211622],
              [73.53385, 18.209215],
              [73.532438, 18.204321],
              [73.523323, 18.193856],
              [73.521393, 18.187408],
              [73.523345, 18.18572],
              [73.536803, 18.188569],
              [73.538581, 18.190095],
              [73.540084, 18.193553],
              [73.540396, 18.202958],
              [73.541667, 18.205843],
              [73.547971, 18.202163],
              [73.55505, 18.195975],
              [73.557976, 18.2037],
              [73.559534, 18.210432],
              [73.561325, 18.211151],
              [73.56278, 18.20372],
              [73.564328, 18.201282],
              [73.56554, 18.190238],
              [73.570253, 18.185098],
              [73.578635, 18.183226],
              [73.581587, 18.179206],
              [73.590516, 18.176419],
              [73.594235, 18.176705],
              [73.599424, 18.189346],
              [73.602697, 18.187097],
              [73.607292, 18.185679],
              [73.610763, 18.1827],
              [73.616374, 18.181181],
              [73.623953, 18.176294],
              [73.628171, 18.175378],
              [73.632912, 18.175629],
              [73.637788, 18.17496],
              [73.6416, 18.173129],
              [73.647141, 18.172404],
              [73.653622, 18.172507],
              [73.657314, 18.17108],
              [73.662265, 18.165594],
              [73.662202, 18.162439],
              [73.666994, 18.156097],
              [73.665812, 18.154699],
              [73.657077, 18.156749],
              [73.650229, 18.156867],
              [73.649534, 18.154907],
              [73.650773, 18.152753],
              [73.641814, 18.143098],
              [73.63978, 18.142266],
              [73.63909, 18.144258],
              [73.636882, 18.146858],
              [73.634798, 18.145915],
              [73.63233, 18.139281],
              [73.629467, 18.137861],
              [73.627993, 18.132853],
              [73.620292, 18.126777],
              [73.620497, 18.125347],
              [73.628083, 18.124317],
              [73.627987, 18.122595],
              [73.624175, 18.120587],
              [73.620087, 18.120979],
              [73.614525, 18.123473],
              [73.61219, 18.122862],
              [73.605493, 18.118116],
              [73.612151, 18.135819],
              [73.611368, 18.139584],
              [73.60617, 18.138067],
              [73.608199, 18.132029],
              [73.59706, 18.10905],
              [73.596927, 18.106406],
              [73.609212, 18.096691],
              [73.607398, 18.090822],
              [73.602335, 18.084839],
              [73.619913, 18.078128],
              [73.615757, 18.068092],
              [73.612929, 18.057968],
              [73.618449, 18.054904],
              [73.626177, 18.049226],
              [73.628525, 18.04543],
              [73.633916, 18.046085],
              [73.640344, 18.045551],
              [73.649776, 18.041118],
              [73.649899, 18.036994],
              [73.655506, 18.035245],
              [73.65899, 18.03123],
              [73.658617, 18.028417],
              [73.650228, 18.022385],
              [73.65614, 18.013079],
              [73.651472, 18.006983],
              [73.644297, 18.000562],
              [73.642663, 17.995962],
              [73.626014, 17.984575],
              [73.634962, 17.978887],
              [73.636262, 17.975268],
              [73.635859, 17.968315],
              [73.617321, 17.954936],
              [73.614428, 17.949787],
              [73.604007, 17.940782],
              [73.597221, 17.936833],
              [73.594654, 17.935528],
              [73.586673, 17.93799],
              [73.583918, 17.944315],
              [73.575875, 17.943331],
              [73.575792, 17.930245],
              [73.574755, 17.927816],
              [73.555, 17.910459],
              [73.55258, 17.907613],
              [73.546745, 17.903669],
              [73.538397, 17.899809],
              [73.536162, 17.896899],
              [73.534779, 17.893726],
              [73.538403, 17.88884],
              [73.557602, 17.892817],
              [73.560612, 17.891429],
              [73.561436, 17.887474],
              [73.567199, 17.879642],
              [73.570103, 17.876769],
              [73.566433, 17.873953],
              [73.559149, 17.870855],
              [73.550852, 17.864813],
              [73.543541, 17.868093],
              [73.539567, 17.872739],
              [73.538468, 17.877137],
              [73.534772, 17.882534],
              [73.52794, 17.878348],
              [73.522101, 17.872117],
              [73.523072, 17.868107],
              [73.521988, 17.865051],
              [73.51492, 17.860063],
              [73.508688, 17.852617],
              [73.505536, 17.850781],
              [73.499828, 17.850515],
              [73.496188, 17.852583],
              [73.496932, 17.857821],
              [73.49392, 17.86455],
              [73.476321, 17.863862],
              [73.462702, 17.865016],
              [73.458742, 17.858526],
              [73.452551, 17.85532],
              [73.452326, 17.851762],
              [73.449282, 17.850328],
              [73.443123, 17.854762],
              [73.441429, 17.858812],
              [73.441362, 17.861802],
              [73.443989, 17.865747],
              [73.445238, 17.872474],
              [73.444903, 17.873851],
              [73.442025, 17.876732],
              [73.442135, 17.882705],
              [73.438288, 17.901294],
              [73.435661, 17.903546],
              [73.432188, 17.904003],
              [73.431443, 17.904108],
              [73.428812, 17.903715],
              [73.424396, 17.898823],
              [73.424447, 17.896355],
              [73.421976, 17.893733],
              [73.41945, 17.893806],
              [73.416544, 17.892616],
              [73.41455, 17.890341],
              [73.410973, 17.888674],
              [73.408998, 17.885372],
              [73.406554, 17.884301],
              [73.398544, 17.882098],
              [73.39319, 17.881839],
              [73.381033, 17.884497],
              [73.37388, 17.887943],
              [73.37006, 17.899819],
              [73.370517, 17.905567],
              [73.372576, 17.907845],
              [73.378236, 17.911729],
              [73.377429, 17.917284],
              [73.370611, 17.932262],
              [73.365243, 17.93338],
              [73.361975, 17.938724],
              [73.362771, 17.952342],
              [73.36195, 17.954791],
              [73.357214, 17.955809],
              [73.351674, 17.958697],
              [73.345124, 17.968634],
              [73.344101, 17.971888],
              [73.345296, 17.982242],
              [73.349763, 17.990237],
              [73.354907, 17.991118],
              [73.357383, 17.992934],
              [73.360773, 18.000527],
              [73.36237, 18.004937],
              [73.360149, 18.010113],
              [73.347211, 18.02458],
              [73.343796, 18.018271],
              [73.338524, 18.012047],
              [73.334557, 18.012209],
              [73.331525, 18.022654],
              [73.323507, 18.0267],
              [73.316669, 18.026766],
              [73.312089, 18.022903],
              [73.304796, 18.02329],
              [73.297748, 18.029707],
              [73.290576, 18.033883],
              [73.292768, 18.050314],
              [73.29437, 18.054349],
              [73.296985, 18.058012],
              [73.288221, 18.070122],
              [73.277807, 18.069027],
              [73.266109, 18.069334],
              [73.260377, 18.067682],
              [73.255781, 18.063936],
              [73.24929, 18.06141],
              [73.244517, 18.060528],
              [73.236436, 18.056658],
              [73.223762, 18.054258],
              [73.217235, 18.056892],
              [73.212067, 18.060008],
              [73.207876, 18.066232],
              [73.204894, 18.068536],
              [73.200823, 18.067767],
              [73.193421, 18.058635],
              [73.189675, 18.056622],
              [73.183068, 18.05954],
              [73.177633, 18.060419],
              [73.173813, 18.058507],
              [73.167192, 18.049495],
              [73.164454, 18.046576],
              [73.157436, 18.041627],
              [73.154015, 18.036966],
              [73.15206, 18.02919],
              [73.151953, 18.025112],
              [73.150211, 18.021693],
              [73.145364, 18.016838],
              [73.134569, 18.015598],
              [73.128836, 18.005711],
              [73.126509, 18.000096],
              [73.125986, 17.999174],
              [73.123127, 17.994207],
              [73.120927, 17.985221],
              [73.118352, 17.981033],
              [73.115601, 17.978489],
              [73.114706, 17.978537],
              [73.109293, 17.978687],
              [73.104062, 17.981016],
              [73.095625, 17.985243],
              [73.083096, 17.987047],
              [73.078029, 17.98674],
              [73.069374, 17.98683],
              [73.050428, 17.982931],
              [73.041208, 17.97943],
              [73.036331, 17.976286],
              [73.029162, 17.969355],
              [73.028455, 17.963701],
              [73.028109, 17.98675],
              [73.025509, 17.987593],
              [73.01998, 17.991343],
              [73.015744, 18.002336],
              [73.007815, 18.014379],
              [73.007415, 18.016209],
              [73.007392, 18.017125],
              [73.006838, 18.021823],
              [73.015759, 18.025399],
              [73.020074, 18.021878],
              [73.02465, 18.021505],
              [73.025837, 18.022422],
              [73.028164, 18.029546],
              [73.029452, 18.031131],
              [73.030442, 18.034296],
              [73.035735, 18.037868],
              [73.044072, 18.039956],
              [73.046861, 18.042515],
              [73.046588, 18.043868],
              [73.04176, 18.048735],
              [73.03633, 18.047503],
              [73.031675, 18.04475],
              [73.027801, 18.042492],
              [73.026138, 18.039497],
              [73.023139, 18.03553],
              [73.022582, 18.034806],
              [73.017552, 18.030183],
              [73.011827, 18.031662],
              [73.011577, 18.045167],
              [73.011534, 18.046101],
              [73.009339, 18.048768],
              [73.004594, 18.050959],
              [72.996649, 18.04814],
              [72.994485, 18.048053],
              [72.992316, 18.049592],
              [72.992453, 18.059309],
              [72.998438, 18.062595],
              [72.998424, 18.063515],
              [72.998408, 18.064184],
              [72.998615, 18.065979],
              [72.999972, 18.067797],
              [73.002058, 18.070342],
              [73.001621, 18.073731],
              [72.990854, 18.097268],
              [72.981834, 18.104863],
              [72.976011, 18.117771],
              [72.973135, 18.119983],
              [72.970796, 18.1292],
              [72.971258, 18.13148],
              [72.97251, 18.132742],
              [72.97641, 18.133165],
              [72.979016, 18.132984],
              [72.980643, 18.13437],
              [72.984502, 18.141892],
              [72.98583, 18.157765],
              [72.981629, 18.183463],
              [72.977715, 18.194816],
              [72.976221, 18.199154],
              [72.952369, 18.217592],
              [72.950346, 18.21867],
              [72.947711, 18.218528],
              [72.946442, 18.218091],
              [72.945629, 18.217893],
              [72.943424, 18.216378],
              [72.93915, 18.211466],
              [72.937625, 18.210822],
              [72.934027, 18.212559],
              [72.932116, 18.214103],
              [72.932003, 18.219774],
              [72.940451, 18.23166],
              [72.941236, 18.233584],
              [72.941585, 18.236233],
              [72.941028, 18.239939],
              [72.939796, 18.248388],
              [72.93368, 18.2632],
              [72.932007, 18.275154],
              [72.932447, 18.279482],
              [72.93271, 18.280702],
              [72.93739, 18.283508],
              [72.940667, 18.28426],
              [72.9472, 18.284947],
              [72.955094, 18.296744],
              [72.962179, 18.315566],
              [72.962522, 18.316165],
              [72.96072, 18.317351],
              [72.960637, 18.31787],
              [72.959621, 18.319112],
              [72.95735, 18.323264],
              [72.956817, 18.325731],
              [72.955695, 18.328384],
              [72.953544, 18.332321],
              [72.951785, 18.334742],
              [72.951461, 18.335098],
              [72.949159, 18.337006],
              [72.945583, 18.338956],
              [72.94475, 18.339446],
              [72.942806, 18.341449],
              [72.935499, 18.345622],
              [72.920928, 18.353896],
              [72.914649, 18.358344],
              [72.914206, 18.358629],
              [72.913399, 18.359334],
              [72.912549, 18.361099],
              [72.912431, 18.366525],
              [72.913468, 18.367691],
              [72.92151, 18.368775],
              [72.925589, 18.371223],
              [72.927051, 18.374971],
              [72.926639, 18.380911],
              [72.926146, 18.383794],
              [72.912223, 18.392081],
              [72.910782, 18.394326],
              [72.907816, 18.404556],
              [72.904561, 18.431569],
              [72.902937, 18.438905],
              [72.902614, 18.439291],
              [72.902444, 18.440364],
              [72.901552, 18.441449],
              [72.901465, 18.442188],
              [72.894656, 18.449837],
              [72.89213, 18.456558],
              [72.892071, 18.459266],
              [72.895336, 18.461812],
              [72.899275, 18.46596],
              [72.899819, 18.467327],
              [72.900016, 18.474794],
              [72.901259, 18.488833],
              [72.902285, 18.491332],
              [72.902527, 18.49586],
              [72.902847, 18.496551],
              [72.90759, 18.497782],
              [72.909665, 18.501016],
              [72.909266, 18.514329],
              [72.908302, 18.519732],
              [72.907079, 18.522966],
              [72.905356, 18.525634],
              [72.904079, 18.529123],
              [72.903938, 18.529924],
              [72.9035, 18.534558],
              [72.904059, 18.535694],
              [72.904739, 18.53617],
              [72.906769, 18.536212],
              [72.910501, 18.534061],
              [72.916011, 18.530842],
              [72.923733, 18.530213],
              [72.931493, 18.533632],
              [72.933301, 18.534405],
              [72.932236, 18.538311],
              [72.931423, 18.541351],
              [72.928933, 18.541822],
              [72.927696, 18.542463],
              [72.927204, 18.542617],
              [72.926546, 18.542943],
              [72.924663, 18.544263],
              [72.923502, 18.545599],
              [72.921444, 18.548247],
              [72.915871, 18.560968],
              [72.912123, 18.57061],
              [72.909608, 18.574418],
              [72.907805, 18.578536],
              [72.904902, 18.58299],
              [72.902312, 18.587187],
              [72.901564, 18.586269],
              [72.894335, 18.596203],
              [72.892954, 18.598488],
              [72.88957, 18.602446],
              [72.888243, 18.603539],
              [72.885811, 18.605836],
              [72.870693, 18.618011],
              [72.867703, 18.620409],
              [72.866327, 18.622632],
              [72.861715, 18.639375],
              [72.861765, 18.644729],
              [72.861824, 18.648375],
              [72.861851, 18.64969],
              [72.86239, 18.654504],
              [72.862283, 18.658498],
              [72.861617, 18.668976],
              [72.86261, 18.672237],
              [72.862399, 18.678155],
              [72.861674, 18.678598],
              [72.860391, 18.682868],
              [72.860336, 18.685346],
              [72.852943, 18.692749],
              [72.852484, 18.699195],
              [72.852655, 18.704622],
              [72.858961, 18.715174],
              [72.860397, 18.730895],
              [72.860942, 18.737787],
              [72.866007, 18.756659],
              [72.865533, 18.759498],
              [72.864782, 18.763865],
              [72.862799, 18.767459],
              [72.86039, 18.773747],
              [72.85998, 18.782303],
              [72.860567, 18.787461],
              [72.860747, 18.78806],
              [72.864948, 18.804341],
              [72.840019, 18.845343],
              [72.842421, 18.856004],
              [72.845576, 18.865976],
              [72.85135, 18.882145],
              [72.855089, 18.889219],
              [72.859935, 18.897797],
              [72.869532, 18.910835],
              [72.881188, 18.919206],
              [72.900886, 18.929279],
              [72.906443, 18.933282],
              [72.90976, 18.938681],
              [72.914499, 18.950755],
              [72.912194, 18.963777],
              [72.908124, 18.971318],
              [72.903706, 18.975417],
              [72.896816, 18.978772],
              [72.900925, 18.979633],
              [72.913733, 18.98226],
              [72.946772, 18.985739],
              [72.958587, 18.987335],
              [72.962631, 18.987895],
              [72.979814, 18.989212],
              [72.99981, 18.987503],
              [73.008962, 18.986727],
              [73.01739, 18.989354],
              [73.025732, 18.993881],
              [73.030789, 18.999661],
              [73.031195, 19.000117],
              [73.034985, 19.006915],
              [73.043076, 19.013183],
              [73.04609, 19.016971],
              [73.046405, 19.018498],
              [73.048265, 19.027579],
              [73.047718, 19.033259],
              [73.048569, 19.040374],
              [73.04822, 19.051383],
              [73.042727, 19.07128],
              [73.046906, 19.097899],
              [73.048174, 19.099917],
              [73.058251, 19.104232],
              [73.064047, 19.110609],
              [73.067784, 19.110437],
              [73.072188, 19.112047],
              [73.084626, 19.114646],
              [73.088722, 19.115343],
              [73.092894, 19.114315],
              [73.095725, 19.11237],
              [73.096991, 19.108297],
              [73.101459, 19.107498],
              [73.109666, 19.111406],
              [73.112254, 19.109747],
              [73.117263, 19.108953],
              [73.121846, 19.110048],
              [73.126677, 19.109427],
              [73.130358, 19.110117],
              [73.140629, 19.124237],
              [73.144073, 19.126016],
              [73.147688, 19.12361],
              [73.148953, 19.118396],
              [73.15413, 19.11301],
              [73.17676, 19.109017],
              [73.178391, 19.110678],
              [73.18153, 19.117395],
              [73.187938, 19.122221],
              [73.191314, 19.124169],
              [73.194635, 19.125029],
              [73.198013, 19.124743],
              [73.202474, 19.12165],
              [73.205424, 19.111845],
              [73.21042, 19.105196],
              [73.212886, 19.099748],
              [73.215235, 19.096714],
              [73.227773, 19.088177],
              [73.231685, 19.08152],
              [73.234986, 19.07349],
              [73.238779, 19.069079],
              [73.246551, 19.063864],
              [73.249994, 19.064894],
              [73.251084, 19.065989],
              [73.257959, 19.064841],
              [73.262901, 19.066054],
              [73.272215, 19.078552],
              [73.279413, 19.084523],
              [73.281574, 19.083545],
              [73.28767, 19.085617],
              [73.291292, 19.085443],
              [73.294974, 19.082983],
              [73.297983, 19.082975],
              [73.299913, 19.082177],
              [73.298273, 19.076903],
              [73.300323, 19.074953],
              [73.302921, 19.075061],
              [73.30498, 19.081492],
              [73.308301, 19.08201],
              [73.312158, 19.081205],
              [73.316807, 19.08201],
              [73.318461, 19.093652],
              [73.310703, 19.105237],
              [73.310943, 19.107359],
              [73.317108, 19.110002],
              [73.323513, 19.117056],
              [73.327439, 19.119632],
              [73.332698, 19.121071],
              [73.350147, 19.128696],
              [73.359151, 19.129727],
              [73.372536, 19.12898],
              [73.375795, 19.127377],
              [73.384922, 19.131735],
              [73.390111, 19.132304],
              [73.3933, 19.132074],
              [73.4023, 19.134649],
              [73.413036, 19.130111],
              [73.432155, 19.127467],
              [73.441036, 19.129184],
              [73.44569, 19.132683],
              [73.454801, 19.131875],
              [73.459379, 19.130374],
              [73.47261, 19.134898],
              [73.482917, 19.130184],
              [73.486575, 19.124736],
              [73.494982, 19.128284],
              [73.50681, 19.129016],
              [73.51466, 19.130672],
              [73.527384, 19.129174],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 462,
        censuscode: 520,
        dt_cen_cd: 24,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Raigarh",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [73.212067, 18.060008],
              [73.217235, 18.056892],
              [73.223762, 18.054258],
              [73.236436, 18.056658],
              [73.244517, 18.060528],
              [73.24929, 18.06141],
              [73.255781, 18.063936],
              [73.260377, 18.067682],
              [73.266109, 18.069334],
              [73.277807, 18.069027],
              [73.288221, 18.070122],
              [73.296985, 18.058012],
              [73.29437, 18.054349],
              [73.292768, 18.050314],
              [73.290576, 18.033883],
              [73.297748, 18.029707],
              [73.304796, 18.02329],
              [73.312089, 18.022903],
              [73.316669, 18.026766],
              [73.323507, 18.0267],
              [73.331525, 18.022654],
              [73.334557, 18.012209],
              [73.338524, 18.012047],
              [73.343796, 18.018271],
              [73.347211, 18.02458],
              [73.360149, 18.010113],
              [73.36237, 18.004937],
              [73.360773, 18.000527],
              [73.357383, 17.992934],
              [73.354907, 17.991118],
              [73.349763, 17.990237],
              [73.345296, 17.982242],
              [73.344101, 17.971888],
              [73.345124, 17.968634],
              [73.351674, 17.958697],
              [73.357214, 17.955809],
              [73.36195, 17.954791],
              [73.362771, 17.952342],
              [73.361975, 17.938724],
              [73.365243, 17.93338],
              [73.370611, 17.932262],
              [73.377429, 17.917284],
              [73.378236, 17.911729],
              [73.372576, 17.907845],
              [73.370517, 17.905567],
              [73.37006, 17.899819],
              [73.37388, 17.887943],
              [73.381033, 17.884497],
              [73.39319, 17.881839],
              [73.398544, 17.882098],
              [73.406554, 17.884301],
              [73.408998, 17.885372],
              [73.410973, 17.888674],
              [73.41455, 17.890341],
              [73.416544, 17.892616],
              [73.41945, 17.893806],
              [73.421976, 17.893733],
              [73.424447, 17.896355],
              [73.424396, 17.898823],
              [73.428812, 17.903715],
              [73.431443, 17.904108],
              [73.432188, 17.904003],
              [73.435661, 17.903546],
              [73.438288, 17.901294],
              [73.442135, 17.882705],
              [73.442025, 17.876732],
              [73.444903, 17.873851],
              [73.445238, 17.872474],
              [73.443989, 17.865747],
              [73.441362, 17.861802],
              [73.441429, 17.858812],
              [73.443123, 17.854762],
              [73.449282, 17.850328],
              [73.452326, 17.851762],
              [73.452551, 17.85532],
              [73.458742, 17.858526],
              [73.462702, 17.865016],
              [73.476321, 17.863862],
              [73.49392, 17.86455],
              [73.496932, 17.857821],
              [73.496188, 17.852583],
              [73.499828, 17.850515],
              [73.505536, 17.850781],
              [73.508688, 17.852617],
              [73.51492, 17.860063],
              [73.521988, 17.865051],
              [73.523072, 17.868107],
              [73.522101, 17.872117],
              [73.52794, 17.878348],
              [73.534772, 17.882534],
              [73.538468, 17.877137],
              [73.539567, 17.872739],
              [73.543541, 17.868093],
              [73.550852, 17.864813],
              [73.559149, 17.870855],
              [73.566433, 17.873953],
              [73.570103, 17.876769],
              [73.574669, 17.877354],
              [73.576066, 17.876636],
              [73.576979, 17.873199],
              [73.575763, 17.865206],
              [73.576936, 17.858279],
              [73.582514, 17.853833],
              [73.591941, 17.848866],
              [73.596401, 17.847735],
              [73.593864, 17.843843],
              [73.587952, 17.839797],
              [73.585917, 17.837578],
              [73.583531, 17.832779],
              [73.582772, 17.82944],
              [73.583128, 17.826807],
              [73.588055, 17.821261],
              [73.591529, 17.818897],
              [73.595042, 17.817576],
              [73.595562, 17.803698],
              [73.597375, 17.799993],
              [73.602513, 17.794734],
              [73.599491, 17.79233],
              [73.595736, 17.79061],
              [73.586227, 17.78868],
              [73.583371, 17.787324],
              [73.584447, 17.783722],
              [73.589118, 17.781035],
              [73.590788, 17.778367],
              [73.591142, 17.775157],
              [73.588791, 17.764789],
              [73.582528, 17.755387],
              [73.581874, 17.751587],
              [73.57706, 17.744629],
              [73.572884, 17.73635],
              [73.572644, 17.728829],
              [73.566336, 17.721894],
              [73.569859, 17.719141],
              [73.580766, 17.713518],
              [73.579807, 17.709828],
              [73.580742, 17.707432],
              [73.58535, 17.704806],
              [73.587543, 17.702655],
              [73.591593, 17.701282],
              [73.593841, 17.699482],
              [73.6032, 17.703248],
              [73.610473, 17.709785],
              [73.614875, 17.712606],
              [73.619149, 17.711932],
              [73.628775, 17.702957],
              [73.635252, 17.699489],
              [73.63932, 17.700298],
              [73.653729, 17.706836],
              [73.654639, 17.702941],
              [73.656692, 17.698552],
              [73.65938, 17.695502],
              [73.662834, 17.693826],
              [73.665084, 17.695524],
              [73.66714, 17.69464],
              [73.669217, 17.691857],
              [73.674486, 17.689008],
              [73.681704, 17.687629],
              [73.68885, 17.687445],
              [73.690446, 17.685288],
              [73.681568, 17.680683],
              [73.681439, 17.677519],
              [73.692047, 17.674064],
              [73.693558, 17.668634],
              [73.695742, 17.666774],
              [73.697766, 17.663127],
              [73.696645, 17.661733],
              [73.698628, 17.660789],
              [73.70188, 17.660039],
              [73.703221, 17.657985],
              [73.701746, 17.655212],
              [73.698283, 17.651593],
              [73.698119, 17.648033],
              [73.699502, 17.646735],
              [73.701077, 17.643373],
              [73.700227, 17.64038],
              [73.695254, 17.636742],
              [73.693272, 17.634133],
              [73.692291, 17.628775],
              [73.692203, 17.627228],
              [73.696904, 17.62454],
              [73.701453, 17.624953],
              [73.715549, 17.624014],
              [73.720107, 17.623051],
              [73.723089, 17.621549],
              [73.724756, 17.619624],
              [73.725406, 17.616706],
              [73.724181, 17.614215],
              [73.71717, 17.609177],
              [73.716068, 17.606867],
              [73.71784, 17.60494],
              [73.723251, 17.601923],
              [73.724482, 17.599753],
              [73.724662, 17.59557],
              [73.72935, 17.59076],
              [73.722539, 17.584633],
              [73.717439, 17.577033],
              [73.716645, 17.573751],
              [73.719121, 17.571899],
              [73.742178, 17.560418],
              [73.746803, 17.556118],
              [73.747102, 17.548886],
              [73.741634, 17.531478],
              [73.733717, 17.524125],
              [73.729754, 17.522003],
              [73.724901, 17.521931],
              [73.72415, 17.52031],
              [73.717195, 17.51757],
              [73.706349, 17.506554],
              [73.706044, 17.503564],
              [73.708181, 17.496824],
              [73.707762, 17.493203],
              [73.704793, 17.491265],
              [73.696276, 17.488149],
              [73.695043, 17.48641],
              [73.699188, 17.481993],
              [73.698271, 17.479172],
              [73.699453, 17.476092],
              [73.702303, 17.474069],
              [73.707651, 17.465593],
              [73.702519, 17.456223],
              [73.701736, 17.452931],
              [73.703986, 17.450555],
              [73.70664, 17.449511],
              [73.707058, 17.441307],
              [73.705482, 17.439099],
              [73.708018, 17.433454],
              [73.705065, 17.423197],
              [73.70334, 17.421854],
              [73.697724, 17.420902],
              [73.692563, 17.421519],
              [73.688083, 17.420586],
              [73.683405, 17.416955],
              [73.67881, 17.411952],
              [73.673776, 17.404354],
              [73.669504, 17.393499],
              [73.667311, 17.392375],
              [73.662013, 17.393844],
              [73.660226, 17.393531],
              [73.656471, 17.38831],
              [73.653494, 17.387003],
              [73.652038, 17.38859],
              [73.649496, 17.394178],
              [73.648111, 17.394668],
              [73.646389, 17.39378],
              [73.64439, 17.391171],
              [73.64449, 17.388471],
              [73.646609, 17.383401],
              [73.649139, 17.381712],
              [73.654336, 17.382943],
              [73.658188, 17.377658],
              [73.661265, 17.3761],
              [73.664079, 17.3797],
              [73.670104, 17.37308],
              [73.673786, 17.370842],
              [73.682135, 17.363391],
              [73.683835, 17.35515],
              [73.687041, 17.348371],
              [73.687043, 17.345097],
              [73.683756, 17.337996],
              [73.682706, 17.335341],
              [73.680634, 17.32664],
              [73.683995, 17.321529],
              [73.686453, 17.313701],
              [73.685622, 17.30794],
              [73.680382, 17.297078],
              [73.677367, 17.295193],
              [73.677823, 17.293192],
              [73.685121, 17.292377],
              [73.686571, 17.291597],
              [73.688634, 17.288641],
              [73.689912, 17.285221],
              [73.687545, 17.282436],
              [73.687607, 17.280945],
              [73.692482, 17.265642],
              [73.695365, 17.262816],
              [73.696164, 17.262559],
              [73.697102, 17.259569],
              [73.697351, 17.252229],
              [73.694874, 17.248283],
              [73.693195, 17.243437],
              [73.693909, 17.23759],
              [73.695569, 17.235724],
              [73.698419, 17.228935],
              [73.702595, 17.226181],
              [73.708505, 17.224261],
              [73.717042, 17.209349],
              [73.718617, 17.202314],
              [73.71762, 17.200068],
              [73.712724, 17.196663],
              [73.707284, 17.187059],
              [73.702861, 17.183894],
              [73.702141, 17.181651],
              [73.698187, 17.181877],
              [73.693892, 17.178534],
              [73.69812, 17.178601],
              [73.700947, 17.177614],
              [73.709323, 17.169653],
              [73.709278, 17.167295],
              [73.702287, 17.162938],
              [73.689456, 17.158323],
              [73.690049, 17.150408],
              [73.691615, 17.143383],
              [73.694208, 17.138717],
              [73.697444, 17.138536],
              [73.703056, 17.140119],
              [73.710573, 17.140396],
              [73.718463, 17.132374],
              [73.723662, 17.128433],
              [73.729418, 17.126905],
              [73.739449, 17.121595],
              [73.743622, 17.124462],
              [73.746887, 17.131284],
              [73.751278, 17.128533],
              [73.759468, 17.121314],
              [73.763132, 17.117513],
              [73.768842, 17.108761],
              [73.781322, 17.107629],
              [73.788714, 17.093101],
              [73.793286, 17.094715],
              [73.796288, 17.094414],
              [73.807649, 17.085618],
              [73.807766, 17.081492],
              [73.805322, 17.072106],
              [73.803917, 17.061644],
              [73.817278, 17.0635],
              [73.82363, 17.061518],
              [73.834602, 17.053872],
              [73.823091, 17.037932],
              [73.828653, 17.033248],
              [73.834325, 17.025767],
              [73.833784, 17.021969],
              [73.82766, 17.012774],
              [73.831978, 17.00911],
              [73.835351, 17.000401],
              [73.833911, 16.990633],
              [73.831799, 16.98915],
              [73.829125, 16.990081],
              [73.823312, 16.989362],
              [73.817259, 16.98722],
              [73.808013, 16.98956],
              [73.801008, 16.990397],
              [73.796538, 16.992666],
              [73.787751, 16.992767],
              [73.785461, 16.991228],
              [73.786619, 16.985473],
              [73.778293, 16.974723],
              [73.773451, 16.974002],
              [73.767248, 16.967138],
              [73.765848, 16.962605],
              [73.768571, 16.958863],
              [73.776179, 16.952731],
              [73.778245, 16.947897],
              [73.78223, 16.944667],
              [73.783603, 16.945119],
              [73.789848, 16.941348],
              [73.795571, 16.930177],
              [73.795188, 16.926446],
              [73.792051, 16.921357],
              [73.793746, 16.915662],
              [73.793124, 16.912099],
              [73.790346, 16.907866],
              [73.788253, 16.906731],
              [73.780928, 16.909178],
              [73.776457, 16.909136],
              [73.771558, 16.90779],
              [73.767817, 16.908441],
              [73.764118, 16.908048],
              [73.761174, 16.90387],
              [73.757798, 16.906473],
              [73.755889, 16.906889],
              [73.754339, 16.906719],
              [73.752598, 16.905118],
              [73.748482, 16.904858],
              [73.744509, 16.916646],
              [73.739555, 16.912646],
              [73.740369, 16.908505],
              [73.739022, 16.897368],
              [73.74088, 16.897647],
              [73.747529, 16.901752],
              [73.748902, 16.901575],
              [73.750135, 16.898986],
              [73.750872, 16.894556],
              [73.748795, 16.882564],
              [73.762199, 16.873425],
              [73.767843, 16.870417],
              [73.768654, 16.866787],
              [73.767906, 16.86232],
              [73.764004, 16.859983],
              [73.768451, 16.856167],
              [73.769273, 16.854097],
              [73.766095, 16.851874],
              [73.766437, 16.848943],
              [73.760655, 16.842306],
              [73.7523, 16.834366],
              [73.737793, 16.843681],
              [73.734593, 16.838296],
              [73.732586, 16.832511],
              [73.730274, 16.834241],
              [73.728107, 16.832642],
              [73.724795, 16.837027],
              [73.718694, 16.835334],
              [73.712215, 16.829901],
              [73.713506, 16.82651],
              [73.715289, 16.825522],
              [73.718151, 16.825401],
              [73.730483, 16.820519],
              [73.729375, 16.816215],
              [73.734214, 16.816251],
              [73.737884, 16.820653],
              [73.743246, 16.817924],
              [73.747771, 16.81687],
              [73.752881, 16.812944],
              [73.752415, 16.806339],
              [73.753066, 16.80536],
              [73.756413, 16.805686],
              [73.760631, 16.802799],
              [73.761501, 16.798662],
              [73.759268, 16.785637],
              [73.75712, 16.785121],
              [73.756706, 16.781161],
              [73.756815, 16.780131],
              [73.759553, 16.779076],
              [73.761031, 16.777116],
              [73.762123, 16.770107],
              [73.769892, 16.771679],
              [73.778245, 16.780999],
              [73.780579, 16.782368],
              [73.785894, 16.7739],
              [73.787526, 16.76769],
              [73.791732, 16.762786],
              [73.794522, 16.76145],
              [73.801316, 16.760724],
              [73.804142, 16.764153],
              [73.80767, 16.765861],
              [73.813704, 16.766116],
              [73.819124, 16.765],
              [73.823435, 16.758949],
              [73.828065, 16.755481],
              [73.830769, 16.749723],
              [73.832305, 16.748216],
              [73.834806, 16.747282],
              [73.833482, 16.745112],
              [73.83311, 16.742591],
              [73.837024, 16.739978],
              [73.841076, 16.738813],
              [73.841182, 16.736282],
              [73.839007, 16.732909],
              [73.832529, 16.727949],
              [73.828031, 16.714417],
              [73.824522, 16.7165],
              [73.820936, 16.715888],
              [73.816987, 16.713897],
              [73.813448, 16.710009],
              [73.813306, 16.706566],
              [73.816121, 16.707639],
              [73.820106, 16.706472],
              [73.821708, 16.705608],
              [73.823047, 16.701233],
              [73.825434, 16.701512],
              [73.826311, 16.698629],
              [73.827434, 16.697476],
              [73.837376, 16.69369],
              [73.843392, 16.692918],
              [73.847611, 16.691339],
              [73.855632, 16.686595],
              [73.860599, 16.68059],
              [73.860753, 16.677548],
              [73.853446, 16.673276],
              [73.8547, 16.672357],
              [73.859651, 16.672963],
              [73.864825, 16.671611],
              [73.866009, 16.669938],
              [73.865037, 16.667758],
              [73.862033, 16.664788],
              [73.863163, 16.664329],
              [73.858913, 16.66073],
              [73.856093, 16.659429],
              [73.85833, 16.654307],
              [73.85712, 16.65184],
              [73.854975, 16.651619],
              [73.854007, 16.650192],
              [73.848342, 16.650224],
              [73.845678, 16.652189],
              [73.842336, 16.652609],
              [73.833906, 16.648116],
              [73.823495, 16.651847],
              [73.814805, 16.653209],
              [73.810455, 16.654615],
              [73.802623, 16.659531],
              [73.795654, 16.66089],
              [73.788136, 16.659662],
              [73.783371, 16.659741],
              [73.780575, 16.661653],
              [73.772781, 16.662671],
              [73.768167, 16.659763],
              [73.76653, 16.645586],
              [73.767285, 16.643001],
              [73.771655, 16.637175],
              [73.773478, 16.632517],
              [73.774979, 16.624533],
              [73.771941, 16.624948],
              [73.771018, 16.621387],
              [73.768312, 16.617152],
              [73.767689, 16.612849],
              [73.768103, 16.603375],
              [73.76565, 16.601544],
              [73.759986, 16.600318],
              [73.755579, 16.600965],
              [73.744849, 16.600331],
              [73.740199, 16.601498],
              [73.735154, 16.604333],
              [73.72508, 16.603352],
              [73.719203, 16.607057],
              [73.718804, 16.610496],
              [73.715104, 16.610404],
              [73.710588, 16.611403],
              [73.707739, 16.614337],
              [73.702746, 16.625499],
              [73.689733, 16.623899],
              [73.688102, 16.618164],
              [73.685928, 16.614377],
              [73.677499, 16.610114],
              [73.676775, 16.598571],
              [73.670988, 16.587463],
              [73.663962, 16.588352],
              [73.667454, 16.583288],
              [73.662591, 16.578193],
              [73.66145, 16.575902],
              [73.654356, 16.575927],
              [73.649946, 16.574914],
              [73.648681, 16.573258],
              [73.649657, 16.566474],
              [73.648515, 16.564531],
              [73.643738, 16.562536],
              [73.639332, 16.562678],
              [73.637498, 16.564863],
              [73.63518, 16.576303],
              [73.633109, 16.579701],
              [73.623592, 16.582663],
              [73.621619, 16.581067],
              [73.62053, 16.577798],
              [73.614664, 16.573744],
              [73.613633, 16.560314],
              [73.612301, 16.555898],
              [73.610377, 16.552627],
              [73.605764, 16.548287],
              [73.596089, 16.542467],
              [73.591267, 16.543232],
              [73.581194, 16.543384],
              [73.57689, 16.540818],
              [73.573109, 16.535665],
              [73.571481, 16.531478],
              [73.554825, 16.523904],
              [73.552552, 16.521217],
              [73.542932, 16.515222],
              [73.541015, 16.51489],
              [73.526646, 16.523835],
              [73.522245, 16.524084],
              [73.519617, 16.52329],
              [73.513626, 16.51556],
              [73.501018, 16.520311],
              [73.494989, 16.518496],
              [73.488714, 16.514549],
              [73.485728, 16.511005],
              [73.48284, 16.506359],
              [73.480426, 16.49914],
              [73.475413, 16.495706],
              [73.471231, 16.494749],
              [73.470146, 16.494785],
              [73.469438, 16.494268],
              [73.465306, 16.493285],
              [73.462741, 16.493609],
              [73.455328, 16.494539],
              [73.445626, 16.497286],
              [73.436302, 16.500044],
              [73.42908, 16.505884],
              [73.424267, 16.50964],
              [73.420327, 16.511615],
              [73.416843, 16.512517],
              [73.411998, 16.510759],
              [73.407897, 16.509419],
              [73.404521, 16.508477],
              [73.398025, 16.508835],
              [73.388793, 16.510121],
              [73.380704, 16.511486],
              [73.375318, 16.512276],
              [73.370606, 16.514569],
              [73.365544, 16.516101],
              [73.362344, 16.518494],
              [73.361075, 16.520113],
              [73.358006, 16.522238],
              [73.352435, 16.529371],
              [73.34735, 16.540756],
              [73.341119, 16.560588],
              [73.345974, 16.567572],
              [73.346345, 16.572309],
              [73.344209, 16.574554],
              [73.333732, 16.576634],
              [73.330113, 16.578297],
              [73.327784, 16.580394],
              [73.326004, 16.582824],
              [73.322745, 16.589319],
              [73.322443, 16.589249],
              [73.322621, 16.589566],
              [73.321319, 16.593565],
              [73.319972, 16.599475],
              [73.324243, 16.603402],
              [73.331308, 16.60329],
              [73.335557, 16.601317],
              [73.345258, 16.595601],
              [73.350955, 16.591625],
              [73.354965, 16.591],
              [73.356011, 16.591594],
              [73.356107, 16.593065],
              [73.354386, 16.597103],
              [73.343746, 16.601894],
              [73.342934, 16.607763],
              [73.343375, 16.609812],
              [73.345248, 16.610511],
              [73.354669, 16.608917],
              [73.356044, 16.610453],
              [73.357867, 16.614327],
              [73.358235, 16.61617],
              [73.365606, 16.623504],
              [73.367756, 16.624666],
              [73.369414, 16.623803],
              [73.378803, 16.611059],
              [73.379013, 16.605685],
              [73.378479, 16.601845],
              [73.379059, 16.594332],
              [73.39195, 16.58892],
              [73.40197, 16.585655],
              [73.403129, 16.586364],
              [73.403101, 16.587717],
              [73.400966, 16.590393],
              [73.390477, 16.594474],
              [73.386074, 16.596933],
              [73.385448, 16.598738],
              [73.385617, 16.602806],
              [73.388024, 16.605576],
              [73.388411, 16.609795],
              [73.38982, 16.612158],
              [73.391903, 16.613343],
              [73.397604, 16.614192],
              [73.399027, 16.615137],
              [73.398832, 16.619548],
              [73.392366, 16.626678],
              [73.382796, 16.628864],
              [73.379399, 16.62964],
              [73.370036, 16.63615],
              [73.366199, 16.634612],
              [73.358703, 16.626586],
              [73.353061, 16.620591],
              [73.343959, 16.61614],
              [73.335489, 16.61919],
              [73.335554, 16.622804],
              [73.341924, 16.626286],
              [73.341859, 16.631477],
              [73.33518, 16.635916],
              [73.326071, 16.634843],
              [73.324171, 16.635738],
              [73.324809, 16.638982],
              [73.327, 16.640515],
              [73.330803, 16.645109],
              [73.332071, 16.647842],
              [73.330984, 16.662478],
              [73.330836, 16.664339],
              [73.329239, 16.668385],
              [73.32804, 16.670172],
              [73.327471, 16.675359],
              [73.328593, 16.678321],
              [73.330566, 16.680171],
              [73.333253, 16.680669],
              [73.341139, 16.679541],
              [73.342653, 16.680365],
              [73.345648, 16.683794],
              [73.345415, 16.690569],
              [73.345037, 16.691252],
              [73.343874, 16.691009],
              [73.339727, 16.686429],
              [73.33227, 16.687873],
              [73.330696, 16.687662],
              [73.328429, 16.688039],
              [73.322532, 16.690905],
              [73.31577, 16.708212],
              [73.311763, 16.716253],
              [73.311763, 16.716254],
              [73.310146, 16.721784],
              [73.304364, 16.742831],
              [73.302637, 16.754337],
              [73.303558, 16.763397],
              [73.308829, 16.775695],
              [73.314791, 16.784176],
              [73.317645, 16.797092],
              [73.316383, 16.801196],
              [73.314796, 16.804609],
              [73.311965, 16.805734],
              [73.305435, 16.810238],
              [73.300352, 16.818403],
              [73.299277, 16.820199],
              [73.297674, 16.822769],
              [73.293492, 16.834277],
              [73.294241, 16.858002],
              [73.295106, 16.863213],
              [73.292551, 16.87424],
              [73.292804, 16.883163],
              [73.294121, 16.885486],
              [73.297746, 16.887289],
              [73.299147, 16.887573],
              [73.301949, 16.888418],
              [73.312715, 16.885593],
              [73.313741, 16.885913],
              [73.315255, 16.886506],
              [73.315351, 16.887978],
              [73.306279, 16.894834],
              [73.299037, 16.893744],
              [73.286159, 16.891785],
              [73.282364, 16.893071],
              [73.282685, 16.897534],
              [73.28588, 16.908686],
              [73.288885, 16.922366],
              [73.2889, 16.924641],
              [73.289803, 16.926012],
              [73.28934, 16.931706],
              [73.289979, 16.932449],
              [73.288328, 16.940673],
              [73.284978, 16.944909],
              [73.284797, 16.948307],
              [73.290454, 16.954373],
              [73.293873, 16.966089],
              [73.294676, 16.974927],
              [73.2962, 16.974944],
              [73.30169, 16.969845],
              [73.304339, 16.965824],
              [73.30536, 16.963409],
              [73.307793, 16.956835],
              [73.311057, 16.954472],
              [73.312196, 16.953805],
              [73.313274, 16.953321],
              [73.320053, 16.954998],
              [73.327966, 16.95069],
              [73.328707, 16.950296],
              [73.331294, 16.94988],
              [73.332135, 16.950003],
              [73.333706, 16.967886],
              [73.332975, 16.968558],
              [73.331217, 16.96807],
              [73.326046, 16.962108],
              [73.324652, 16.96141],
              [73.319932, 16.96179],
              [73.313278, 16.965292],
              [73.315245, 16.974721],
              [73.315664, 16.977989],
              [73.313386, 16.979651],
              [73.312349, 16.979058],
              [73.311946, 16.974781],
              [73.311122, 16.973981],
              [73.307285, 16.973341],
              [73.306324, 16.973768],
              [73.305748, 16.979638],
              [73.305037, 16.980311],
              [73.299821, 16.982456],
              [73.296284, 16.983548],
              [73.293186, 16.984636],
              [73.28654, 16.989007],
              [73.283448, 16.991024],
              [73.281124, 16.990288],
              [73.276129, 16.984877],
              [73.274872, 16.984535],
              [73.272741, 16.984959],
              [73.271552, 16.992605],
              [73.272039, 16.993486],
              [73.272479, 16.994054],
              [73.274429, 16.995856],
              [73.279642, 16.999386],
              [73.282895, 17.0008],
              [73.284206, 17.002344],
              [73.282688, 17.011118],
              [73.28209, 17.013611],
              [73.280127, 17.017868],
              [73.275368, 17.022543],
              [73.273483, 17.022055],
              [73.265152, 17.016488],
              [73.260633, 17.017997],
              [73.259919, 17.019338],
              [73.25902, 17.024261],
              [73.258966, 17.025523],
              [73.259387, 17.028748],
              [73.26017, 17.030811],
              [73.260146, 17.034256],
              [73.258753, 17.041811],
              [73.257882, 17.046443],
              [73.258102, 17.047337],
              [73.259489, 17.048262],
              [73.263615, 17.049022],
              [73.265024, 17.049041],
              [73.267145, 17.04795],
              [73.272924, 17.042702],
              [73.275746, 17.040202],
              [73.278786, 17.039421],
              [73.280455, 17.039704],
              [73.281905, 17.041479],
              [73.287632, 17.047549],
              [73.288637, 17.052686],
              [73.294058, 17.055678],
              [73.292477, 17.06025],
              [73.291766, 17.063591],
              [73.291691, 17.070527],
              [73.292858, 17.07078],
              [73.295413, 17.072408],
              [73.296156, 17.071066],
              [73.299255, 17.0684],
              [73.301562, 17.067777],
              [73.30233, 17.067556],
              [73.312094, 17.073609],
              [73.3122, 17.074303],
              [73.312394, 17.07678],
              [73.312028, 17.077446],
              [73.309889, 17.078072],
              [73.30936, 17.077995],
              [73.300281, 17.076575],
              [73.297552, 17.077064],
              [73.292936, 17.080061],
              [73.291395, 17.085636],
              [73.29032, 17.089597],
              [73.289628, 17.090023],
              [73.289476, 17.090591],
              [73.288192, 17.095575],
              [73.287365, 17.101448],
              [73.287114, 17.101948],
              [73.282477, 17.111318],
              [73.280804, 17.112867],
              [73.278228, 17.112596],
              [73.27659, 17.112113],
              [73.271386, 17.114297],
              [73.272524, 17.115895],
              [73.273635, 17.119666],
              [73.273673, 17.121291],
              [73.27366, 17.122372],
              [73.273172, 17.126523],
              [73.271165, 17.133272],
              [73.270693, 17.133033],
              [73.269803, 17.135747],
              [73.269403, 17.14638],
              [73.275438, 17.150984],
              [73.277482, 17.154195],
              [73.277466, 17.155342],
              [73.27675, 17.156225],
              [73.271705, 17.155336],
              [73.266853, 17.157642],
              [73.2627, 17.165244],
              [73.258614, 17.18213],
              [73.254566, 17.18541],
              [73.25003, 17.189008],
              [73.2391, 17.194242],
              [73.238947, 17.196029],
              [73.238875, 17.200096],
              [73.248112, 17.19964],
              [73.249115, 17.199609],
              [73.249463, 17.20028],
              [73.248951, 17.21971],
              [73.247325, 17.22196],
              [73.243005, 17.225443],
              [73.240133, 17.226767],
              [73.237768, 17.229258],
              [73.230034, 17.245641],
              [73.228462, 17.248987],
              [73.226596, 17.259366],
              [73.219733, 17.27507],
              [73.215645, 17.278632],
              [73.212874, 17.277209],
              [73.210724, 17.272089],
              [73.20751, 17.273503],
              [73.203874, 17.280235],
              [73.201531, 17.293065],
              [73.189859, 17.299427],
              [73.189557, 17.302591],
              [73.196787, 17.306098],
              [73.200127, 17.303904],
              [73.206298, 17.301532],
              [73.220886, 17.303351],
              [73.222322, 17.302256],
              [73.231786, 17.298411],
              [73.243341, 17.31076],
              [73.245345, 17.31387],
              [73.245853, 17.314872],
              [73.246049, 17.317149],
              [73.242937, 17.319806],
              [73.242265, 17.319839],
              [73.239155, 17.319966],
              [73.230835, 17.322045],
              [73.225911, 17.324329],
              [73.225433, 17.324483],
              [73.223736, 17.326932],
              [73.223213, 17.329403],
              [73.223659, 17.33123],
              [73.230195, 17.33339],
              [73.231133, 17.334529],
              [73.231118, 17.335215],
              [73.222006, 17.344017],
              [73.221515, 17.344538],
              [73.22067, 17.346341],
              [73.220107, 17.351058],
              [73.225472, 17.353316],
              [73.226262, 17.356134],
              [73.225062, 17.357263],
              [73.21909, 17.359336],
              [73.217462, 17.360734],
              [73.219296, 17.369128],
              [73.219402, 17.36982],
              [73.21913, 17.3714],
              [73.216875, 17.371523],
              [73.215478, 17.370833],
              [73.214452, 17.370882],
              [73.212292, 17.372202],
              [73.212147, 17.380331],
              [73.205884, 17.387459],
              [73.19791, 17.389862],
              [73.197243, 17.389987],
              [73.19431, 17.389269],
              [73.191054, 17.385714],
              [73.188048, 17.383737],
              [73.180809, 17.386916],
              [73.179741, 17.387448],
              [73.177825, 17.389002],
              [73.170668, 17.399231],
              [73.168597, 17.403739],
              [73.16843, 17.406014],
              [73.169261, 17.406284],
              [73.170886, 17.406722],
              [73.174765, 17.406451],
              [73.176668, 17.405822],
              [73.186912, 17.41096],
              [73.187605, 17.411324],
              [73.188565, 17.413592],
              [73.189996, 17.419358],
              [73.190051, 17.422764],
              [73.190847, 17.423601],
              [73.190214, 17.431719],
              [73.192749, 17.435606],
              [73.195137, 17.436088],
              [73.196381, 17.43608],
              [73.202285, 17.435664],
              [73.204479, 17.438529],
              [73.20446, 17.439418],
              [73.1973, 17.443383],
              [73.196237, 17.443687],
              [73.191341, 17.44475],
              [73.190202, 17.445068],
              [73.188528, 17.446398],
              [73.187467, 17.453151],
              [73.191983, 17.454846],
              [73.193539, 17.456204],
              [73.194513, 17.46075],
              [73.194576, 17.463918],
              [73.187026, 17.488184],
              [73.183613, 17.508109],
              [73.182876, 17.508836],
              [73.182604, 17.510343],
              [73.177315, 17.516953],
              [73.176544, 17.519219],
              [73.16789, 17.525929],
              [73.160697, 17.531478],
              [73.158825, 17.532906],
              [73.15306, 17.538689],
              [73.149416, 17.542938],
              [73.144618, 17.549146],
              [73.14129, 17.556554],
              [73.142883, 17.566091],
              [73.150102, 17.57096],
              [73.152324, 17.572258],
              [73.156063, 17.573457],
              [73.155544, 17.577702],
              [73.160102, 17.590826],
              [73.152927, 17.59589],
              [73.148893, 17.600062],
              [73.145465, 17.603885],
              [73.14499, 17.603672],
              [73.140452, 17.619165],
              [73.133761, 17.634181],
              [73.132063, 17.636399],
              [73.130491, 17.639792],
              [73.130795, 17.642738],
              [73.13861, 17.641531],
              [73.138057, 17.645123],
              [73.134184, 17.652194],
              [73.130981, 17.658132],
              [73.123707, 17.667256],
              [73.12126, 17.672406],
              [73.120005, 17.676332],
              [73.118364, 17.681639],
              [73.11704, 17.689536],
              [73.117061, 17.692272],
              [73.117088, 17.693145],
              [73.121023, 17.696826],
              [73.124184, 17.698118],
              [73.132709, 17.702479],
              [73.136425, 17.705375],
              [73.137264, 17.70516],
              [73.13932, 17.709149],
              [73.138165, 17.717974],
              [73.138081, 17.71864],
              [73.112015, 17.781334],
              [73.111037, 17.783661],
              [73.108589, 17.789544],
              [73.097717, 17.808312],
              [73.096234, 17.822785],
              [73.093412, 17.831822],
              [73.093205, 17.832645],
              [73.093286, 17.834468],
              [73.097757, 17.836593],
              [73.105726, 17.833091],
              [73.111036, 17.831484],
              [73.115608, 17.83077],
              [73.124706, 17.830916],
              [73.130237, 17.831342],
              [73.125081, 17.833362],
              [73.115984, 17.836264],
              [73.110889, 17.839087],
              [73.110299, 17.839906],
              [73.10209, 17.844578],
              [73.098077, 17.843812],
              [73.092132, 17.838732],
              [73.083462, 17.855311],
              [73.075922, 17.877781],
              [73.075512, 17.886141],
              [73.079439, 17.890282],
              [73.0803, 17.894365],
              [73.07861, 17.895684],
              [73.075307, 17.895623],
              [73.069548, 17.889314],
              [73.068608, 17.888311],
              [73.06697, 17.887559],
              [73.063427, 17.888188],
              [73.055972, 17.893438],
              [73.054578, 17.90575],
              [73.05596, 17.907338],
              [73.057198, 17.910188],
              [73.055311, 17.918125],
              [73.047633, 17.922775],
              [73.044851, 17.929869],
              [73.039426, 17.932081],
              [73.036418, 17.933753],
              [73.033627, 17.936457],
              [73.031794, 17.944986],
              [73.028455, 17.963701],
              [73.029162, 17.969355],
              [73.036331, 17.976286],
              [73.041208, 17.97943],
              [73.050428, 17.982931],
              [73.069374, 17.98683],
              [73.078029, 17.98674],
              [73.083096, 17.987047],
              [73.095625, 17.985243],
              [73.104062, 17.981016],
              [73.109293, 17.978687],
              [73.114706, 17.978537],
              [73.115601, 17.978489],
              [73.118352, 17.981033],
              [73.120927, 17.985221],
              [73.123127, 17.994207],
              [73.125986, 17.999174],
              [73.126509, 18.000096],
              [73.128836, 18.005711],
              [73.134569, 18.015598],
              [73.145364, 18.016838],
              [73.150211, 18.021693],
              [73.151953, 18.025112],
              [73.15206, 18.02919],
              [73.154015, 18.036966],
              [73.157436, 18.041627],
              [73.164454, 18.046576],
              [73.167192, 18.049495],
              [73.173813, 18.058507],
              [73.177633, 18.060419],
              [73.183068, 18.05954],
              [73.189675, 18.056622],
              [73.193421, 18.058635],
              [73.200823, 18.067767],
              [73.204894, 18.068536],
              [73.207876, 18.066232],
              [73.212067, 18.060008],
            ],
          ],
          [
            [
              [73.387006, 16.615938],
              [73.385407, 16.615845],
              [73.384233, 16.615955],
              [73.383495, 16.616024],
              [73.382409, 16.617398],
              [73.382481, 16.619435],
              [73.384065, 16.62126],
              [73.385395, 16.621535],
              [73.386044, 16.62167],
              [73.388445, 16.620071],
              [73.388467, 16.61805],
              [73.387006, 16.615938],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 478,
        censuscode: 528,
        dt_cen_cd: 32,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Ratnagiri",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [75.314401, 18.51854],
              [75.31203, 18.515704],
              [75.311209, 18.511304],
              [75.309146, 18.508859],
              [75.301101, 18.503214],
              [75.299555, 18.498304],
              [75.299886, 18.494756],
              [75.302983, 18.485163],
              [75.302089, 18.472973],
              [75.300451, 18.464514],
              [75.300359, 18.459991],
              [75.298932, 18.455823],
              [75.298841, 18.452043],
              [75.299884, 18.447508],
              [75.299899, 18.442413],
              [75.30379, 18.434408],
              [75.301642, 18.429278],
              [75.28545, 18.411702],
              [75.2853, 18.407976],
              [75.286487, 18.406763],
              [75.290615, 18.405004],
              [75.298815, 18.402394],
              [75.300362, 18.400488],
              [75.30118, 18.397045],
              [75.303604, 18.393356],
              [75.306769, 18.392176],
              [75.311473, 18.39373],
              [75.316663, 18.396535],
              [75.318828, 18.396689],
              [75.322899, 18.395496],
              [75.327685, 18.387256],
              [75.334139, 18.390514],
              [75.337857, 18.383024],
              [75.339759, 18.380769],
              [75.344068, 18.379577],
              [75.347468, 18.377711],
              [75.352648, 18.372729],
              [75.360313, 18.370018],
              [75.362616, 18.366209],
              [75.36358, 18.359724],
              [75.367794, 18.354644],
              [75.376093, 18.350142],
              [75.380201, 18.3458],
              [75.385455, 18.336928],
              [75.387263, 18.331408],
              [75.38964, 18.328863],
              [75.398891, 18.329737],
              [75.401652, 18.329135],
              [75.406366, 18.326729],
              [75.407662, 18.324023],
              [75.404414, 18.31713],
              [75.396261, 18.311845],
              [75.394184, 18.307968],
              [75.396255, 18.304913],
              [75.40042, 18.300969],
              [75.401167, 18.297467],
              [75.40029, 18.293811],
              [75.397726, 18.288685],
              [75.398811, 18.283408],
              [75.397875, 18.279748],
              [75.396958, 18.265157],
              [75.428984, 18.264],
              [75.432205, 18.26162],
              [75.432547, 18.253594],
              [75.428744, 18.244932],
              [75.424326, 18.241146],
              [75.425014, 18.237706],
              [75.4278, 18.233784],
              [75.428594, 18.229708],
              [75.428786, 18.224601],
              [75.427718, 18.219525],
              [75.430493, 18.214847],
              [75.438705, 18.208118],
              [75.436595, 18.201553],
              [75.434602, 18.199684],
              [75.429239, 18.184629],
              [75.428722, 18.180687],
              [75.430251, 18.177866],
              [75.434133, 18.175468],
              [75.444915, 18.174893],
              [75.452925, 18.171531],
              [75.463761, 18.163733],
              [75.465348, 18.161252],
              [75.467516, 18.161918],
              [75.467097, 18.16759],
              [75.468046, 18.172561],
              [75.470165, 18.174601],
              [75.474732, 18.175867],
              [75.477599, 18.174572],
              [75.481199, 18.174758],
              [75.48463, 18.176095],
              [75.491087, 18.174022],
              [75.491085, 18.15638],
              [75.492991, 18.154703],
              [75.500952, 18.159468],
              [75.504924, 18.16069],
              [75.50815, 18.159502],
              [75.511604, 18.157571],
              [75.514931, 18.154047],
              [75.515746, 18.151109],
              [75.520921, 18.141717],
              [75.524721, 18.138178],
              [75.533377, 18.134409],
              [75.541287, 18.139418],
              [75.546212, 18.140618],
              [75.550873, 18.144913],
              [75.550988, 18.150122],
              [75.546989, 18.163632],
              [75.552164, 18.176679],
              [75.55359, 18.187205],
              [75.553698, 18.196994],
              [75.554575, 18.201109],
              [75.555743, 18.20338],
              [75.559831, 18.204882],
              [75.562387, 18.208057],
              [75.569, 18.226823],
              [75.574843, 18.240095],
              [75.578169, 18.243029],
              [75.586661, 18.245676],
              [75.59686, 18.24555],
              [75.605361, 18.243964],
              [75.618634, 18.245632],
              [75.625164, 18.244519],
              [75.630098, 18.245202],
              [75.632883, 18.247864],
              [75.634129, 18.257233],
              [75.633541, 18.264404],
              [75.628066, 18.268593],
              [75.623645, 18.270484],
              [75.618946, 18.274322],
              [75.621784, 18.281558],
              [75.626956, 18.28739],
              [75.629975, 18.29526],
              [75.633781, 18.302373],
              [75.633866, 18.305002],
              [75.642362, 18.313776],
              [75.643612, 18.318054],
              [75.64916, 18.325544],
              [75.651733, 18.330494],
              [75.655484, 18.332912],
              [75.664637, 18.330388],
              [75.676032, 18.329105],
              [75.683601, 18.325116],
              [75.686775, 18.324039],
              [75.689718, 18.32424],
              [75.696596, 18.327186],
              [75.69879, 18.330014],
              [75.701258, 18.335829],
              [75.703808, 18.338656],
              [75.707899, 18.33975],
              [75.71702, 18.338779],
              [75.720184, 18.337703],
              [75.720938, 18.340737],
              [75.720244, 18.343203],
              [75.722355, 18.348673],
              [75.730248, 18.356703],
              [75.731917, 18.360518],
              [75.729179, 18.368288],
              [75.729303, 18.379053],
              [75.728008, 18.386168],
              [75.727373, 18.389042],
              [75.722717, 18.390763],
              [75.718277, 18.391107],
              [75.711334, 18.392967],
              [75.708717, 18.396032],
              [75.713264, 18.399357],
              [75.7145, 18.402953],
              [75.717557, 18.406921],
              [75.718748, 18.411489],
              [75.721196, 18.415689],
              [75.725742, 18.429782],
              [75.728496, 18.43404],
              [75.741791, 18.435697],
              [75.74574, 18.434965],
              [75.751702, 18.436091],
              [75.763766, 18.439998],
              [75.766086, 18.438305],
              [75.769495, 18.432004],
              [75.769399, 18.42392],
              [75.771708, 18.416214],
              [75.774057, 18.411824],
              [75.782495, 18.404495],
              [75.785568, 18.395223],
              [75.795309, 18.391714],
              [75.798815, 18.384104],
              [75.802289, 18.382964],
              [75.806856, 18.383596],
              [75.81651, 18.382606],
              [75.824593, 18.380603],
              [75.830553, 18.377311],
              [75.833879, 18.373943],
              [75.842913, 18.367103],
              [75.851577, 18.364574],
              [75.856266, 18.364449],
              [75.86671, 18.365214],
              [75.87185, 18.367611],
              [75.875989, 18.367545],
              [75.883653, 18.366046],
              [75.887092, 18.363582],
              [75.888999, 18.358648],
              [75.896255, 18.347657],
              [75.902276, 18.335954],
              [75.904571, 18.324942],
              [75.908215, 18.319006],
              [75.911596, 18.31521],
              [75.917428, 18.310603],
              [75.920226, 18.305679],
              [75.924377, 18.30228],
              [75.924381, 18.299867],
              [75.924395, 18.297828],
              [75.924554, 18.295826],
              [75.92495, 18.293841],
              [75.925547, 18.291892],
              [75.926466, 18.290076],
              [75.927333, 18.288323],
              [75.926971, 18.286333],
              [75.926849, 18.284337],
              [75.927276, 18.282381],
              [75.927844, 18.280431],
              [75.928459, 18.278483],
              [75.929047, 18.276533],
              [75.929509, 18.274578],
              [75.929772, 18.272625],
              [75.929707, 18.270669],
              [75.929266, 18.268723],
              [75.928634, 18.266759],
              [75.927973, 18.264805],
              [75.927466, 18.26283],
              [75.927292, 18.260738],
              [75.928149, 18.258975],
              [75.929479, 18.257395],
              [75.930986, 18.255907],
              [75.932586, 18.254523],
              [75.934274, 18.253299],
              [75.936109, 18.252253],
              [75.937971, 18.251229],
              [75.939722, 18.250071],
              [75.941421, 18.248801],
              [75.942967, 18.247387],
              [75.94423, 18.245769],
              [75.945384, 18.244025],
              [75.946425, 18.242215],
              [75.947336, 18.240352],
              [75.948075, 18.238455],
              [75.948423, 18.236452],
              [75.948373, 18.234356],
              [75.948081, 18.232335],
              [75.947449, 18.230364],
              [75.946534, 18.22849],
              [75.945413, 18.226737],
              [75.944164, 18.225024],
              [75.942867, 18.223319],
              [75.94161, 18.221615],
              [75.940486, 18.219889],
              [75.939568, 18.218107],
              [75.938979, 18.216229],
              [75.938851, 18.214196],
              [75.9391, 18.212077],
              [75.939597, 18.209988],
              [75.940251, 18.20805],
              [75.941132, 18.206196],
              [75.94222, 18.204405],
              [75.943432, 18.202666],
              [75.944698, 18.201001],
              [75.946416, 18.199732],
              [75.947917, 18.198407],
              [75.948455, 18.196466],
              [75.948685, 18.194355],
              [75.948711, 18.192283],
              [75.948504, 18.190246],
              [75.948155, 18.188202],
              [75.947871, 18.186163],
              [75.947886, 18.184127],
              [75.948343, 18.182098],
              [75.949121, 18.180184],
              [75.949975, 18.178275],
              [75.950921, 18.176414],
              [75.952, 18.174659],
              [75.9534, 18.173166],
              [75.955274, 18.172041],
              [75.956657, 18.170556],
              [75.957602, 18.16875],
              [75.958417, 18.166846],
              [75.95915, 18.164885],
              [75.959832, 18.162923],
              [75.960487, 18.160939],
              [75.960405, 18.158935],
              [75.959751, 18.157009],
              [75.958983, 18.155096],
              [75.958177, 18.153183],
              [75.957445, 18.151262],
              [75.957009, 18.149253],
              [75.956764, 18.147205],
              [75.955835, 18.145451],
              [75.954328, 18.143967],
              [75.95299, 18.14238],
              [75.952044, 18.140561],
              [75.951167, 18.138698],
              [75.950063, 18.136973],
              [75.948643, 18.135458],
              [75.947184, 18.133966],
              [75.945876, 18.132344],
              [75.94453, 18.130672],
              [75.943282, 18.128977],
              [75.942296, 18.12723],
              [75.941841, 18.125386],
              [75.942336, 18.123352],
              [75.943133, 18.121411],
              [75.94389, 18.119524],
              [75.944647, 18.117638],
              [75.945424, 18.115742],
              [75.946237, 18.113878],
              [75.947086, 18.112039],
              [75.948001, 18.110251],
              [75.94899, 18.108531],
              [75.950073, 18.106887],
              [75.95148, 18.105476],
              [75.953248, 18.104328],
              [75.9551, 18.103249],
              [75.956738, 18.102039],
              [75.957939, 18.100539],
              [75.958811, 18.098813],
              [75.95949, 18.096968],
              [75.960063, 18.095119],
              [75.96027, 18.093238],
              [75.960393, 18.09138],
              [75.961676, 18.089709],
              [75.963682, 18.089734],
              [75.965762, 18.089986],
              [75.967878, 18.090273],
              [75.970014, 18.090591],
              [75.972167, 18.090927],
              [75.974329, 18.091264],
              [75.976502, 18.09161],
              [75.978665, 18.091946],
              [75.980829, 18.092274],
              [75.982982, 18.092589],
              [75.985109, 18.092897],
              [75.987225, 18.093205],
              [75.989349, 18.094005],
              [75.991306, 18.094609],
              [75.992892, 18.093691],
              [75.99391, 18.09155],
              [75.99453, 18.089492],
              [75.995037, 18.087339],
              [75.995511, 18.085119],
              [75.995977, 18.082834],
              [75.996504, 18.080517],
              [75.997143, 18.078194],
              [75.998618, 18.076088],
              [75.999427, 18.074113],
              [76.000022, 18.072384],
              [75.992894, 18.070652],
              [75.991339, 18.067643],
              [75.991892, 18.061711],
              [75.994417, 18.057804],
              [75.996061, 18.056854],
              [75.99812, 18.055415],
              [76.00002, 18.05518],
              [76.001415, 18.05509],
              [76.003623, 18.049033],
              [76.011996, 18.050099],
              [76.016225, 18.039535],
              [76.013821, 18.033888],
              [76.007279, 18.024648],
              [76.003533, 18.016972],
              [76.001826, 18.003444],
              [76.000023, 18.000014],
              [75.998411, 17.994443],
              [75.996588, 17.992516],
              [75.991212, 17.991618],
              [75.98571, 17.990045],
              [75.98564, 17.984995],
              [75.983842, 17.974986],
              [75.975824, 17.970613],
              [75.971532, 17.974601],
              [75.966479, 17.976955],
              [75.961087, 17.979652],
              [75.95278, 17.979061],
              [75.94066, 17.974886],
              [75.927194, 17.972879],
              [75.918348, 17.97412],
              [75.912893, 17.978326],
              [75.911026, 17.985073],
              [75.910105, 17.992312],
              [75.910733, 17.998375],
              [75.908165, 18.00024],
              [75.907254, 18.004046],
              [75.899976, 18.006617],
              [75.896332, 18.007254],
              [75.890991, 18.0066],
              [75.886406, 18.008302],
              [75.88321, 18.011112],
              [75.87677, 18.01314],
              [75.869718, 18.013213],
              [75.864441, 18.012214],
              [75.857477, 18.00974],
              [75.852114, 18.006432],
              [75.848441, 18.000361],
              [75.83946, 17.978481],
              [75.846585, 17.978247],
              [75.840225, 17.957991],
              [75.83818, 17.938942],
              [75.838811, 17.929383],
              [75.843082, 17.930028],
              [75.847347, 17.928776],
              [75.850365, 17.923765],
              [75.85148, 17.919914],
              [75.850097, 17.913269],
              [75.844498, 17.90133],
              [75.845351, 17.891927],
              [75.856116, 17.874563],
              [75.858058, 17.863867],
              [75.864991, 17.855689],
              [75.876294, 17.846035],
              [75.880755, 17.846891],
              [75.889366, 17.844755],
              [75.900043, 17.838897],
              [75.910591, 17.834821],
              [75.919504, 17.832309],
              [75.925649, 17.833408],
              [75.930376, 17.847351],
              [75.932374, 17.850599],
              [75.939719, 17.851709],
              [75.942893, 17.845657],
              [75.946299, 17.844908],
              [75.952291, 17.837514],
              [75.960021, 17.83087],
              [75.968394, 17.818759],
              [75.97653, 17.819919],
              [75.977283, 17.824938],
              [75.974798, 17.832109],
              [75.97495, 17.838161],
              [75.978028, 17.842313],
              [75.983589, 17.842009],
              [76.000121, 17.836584],
              [76.010866, 17.830722],
              [76.018468, 17.829051],
              [76.016512, 17.823065],
              [76.016926, 17.814387],
              [76.010787, 17.806204],
              [76.009466, 17.802765],
              [76.012262, 17.787245],
              [76.007186, 17.7849],
              [76.004528, 17.769303],
              [76.003082, 17.753618],
              [76.006251, 17.750134],
              [76.009046, 17.75056],
              [76.015391, 17.758154],
              [76.021465, 17.76273],
              [76.027584, 17.765913],
              [76.056182, 17.765338],
              [76.069447, 17.769891],
              [76.083802, 17.776092],
              [76.096419, 17.778662],
              [76.103092, 17.772537],
              [76.103431, 17.767599],
              [76.100043, 17.761274],
              [76.10286, 17.761196],
              [76.108127, 17.763313],
              [76.112612, 17.767134],
              [76.116137, 17.769026],
              [76.116488, 17.765811],
              [76.118727, 17.763242],
              [76.120765, 17.765205],
              [76.122367, 17.769046],
              [76.13128, 17.764148],
              [76.134858, 17.759137],
              [76.139219, 17.755936],
              [76.1455, 17.754289],
              [76.145288, 17.744231],
              [76.148242, 17.732813],
              [76.150021, 17.732809],
              [76.162013, 17.732756],
              [76.176266, 17.731084],
              [76.175627, 17.726638],
              [76.173601, 17.72278],
              [76.16646, 17.714006],
              [76.160089, 17.714688],
              [76.149909, 17.71819],
              [76.145012, 17.708668],
              [76.147336, 17.705169],
              [76.149641, 17.699016],
              [76.16631, 17.700008],
              [76.166417, 17.69286],
              [76.176472, 17.68753],
              [76.189866, 17.682384],
              [76.200269, 17.68847],
              [76.212194, 17.689903],
              [76.217418, 17.689449],
              [76.220076, 17.690543],
              [76.222344, 17.696373],
              [76.225945, 17.698019],
              [76.231471, 17.697446],
              [76.239593, 17.697922],
              [76.240804, 17.705165],
              [76.247474, 17.706243],
              [76.251311, 17.707777],
              [76.256773, 17.716795],
              [76.263714, 17.720715],
              [76.271406, 17.727534],
              [76.282376, 17.728969],
              [76.289889, 17.728006],
              [76.299194, 17.729054],
              [76.306797, 17.71963],
              [76.312101, 17.716773],
              [76.316211, 17.715556],
              [76.319246, 17.69707],
              [76.323471, 17.695977],
              [76.33976, 17.694004],
              [76.3561, 17.69619],
              [76.361605, 17.686711],
              [76.369585, 17.684166],
              [76.379301, 17.685592],
              [76.379851, 17.679498],
              [76.379306, 17.668191],
              [76.381309, 17.659603],
              [76.404817, 17.657246],
              [76.412207, 17.648545],
              [76.422772, 17.645792],
              [76.429645, 17.646044],
              [76.428174, 17.641404],
              [76.426732, 17.629963],
              [76.425024, 17.62319],
              [76.421665, 17.615901],
              [76.419105, 17.607489],
              [76.416592, 17.605864],
              [76.382886, 17.602424],
              [76.373817, 17.599575],
              [76.360227, 17.597918],
              [76.349417, 17.597024],
              [76.337077, 17.597649],
              [76.33233, 17.596475],
              [76.333583, 17.57546],
              [76.334924, 17.565133],
              [76.337938, 17.556828],
              [76.340731, 17.54425],
              [76.346544, 17.541889],
              [76.355566, 17.54042],
              [76.36168, 17.537952],
              [76.365395, 17.530229],
              [76.366909, 17.52389],
              [76.367204, 17.518431],
              [76.356779, 17.515087],
              [76.347083, 17.513193],
              [76.344446, 17.509838],
              [76.344219, 17.496082],
              [76.346692, 17.493336],
              [76.355945, 17.4959],
              [76.36739, 17.497038],
              [76.375877, 17.495273],
              [76.373135, 17.487543],
              [76.350773, 17.473889],
              [76.34353, 17.472126],
              [76.338506, 17.472161],
              [76.331507, 17.470571],
              [76.331549, 17.463377],
              [76.334392, 17.434069],
              [76.342709, 17.435628],
              [76.364711, 17.437363],
              [76.374019, 17.436247],
              [76.370719, 17.424876],
              [76.370892, 17.409754],
              [76.362838, 17.376959],
              [76.409034, 17.371215],
              [76.411493, 17.356088],
              [76.411636, 17.349644],
              [76.40302, 17.345935],
              [76.393942, 17.338229],
              [76.384839, 17.321501],
              [76.38263, 17.313774],
              [76.360224, 17.312235],
              [76.353103, 17.312539],
              [76.351426, 17.329643],
              [76.344402, 17.35183],
              [76.335495, 17.351734],
              [76.317772, 17.347283],
              [76.313711, 17.345146],
              [76.319095, 17.333737],
              [76.317918, 17.331336],
              [76.305701, 17.330339],
              [76.296554, 17.330525],
              [76.286397, 17.332228],
              [76.276478, 17.332391],
              [76.273233, 17.349792],
              [76.270751, 17.358354],
              [76.265501, 17.359981],
              [76.256803, 17.359201],
              [76.250513, 17.359707],
              [76.249416, 17.363933],
              [76.25095, 17.368473],
              [76.247206, 17.369683],
              [76.244838, 17.376464],
              [76.230816, 17.372026],
              [76.229425, 17.365016],
              [76.203871, 17.360563],
              [76.193545, 17.360357],
              [76.183215, 17.358262],
              [76.176293, 17.354139],
              [76.172596, 17.350491],
              [76.173782, 17.334018],
              [76.176642, 17.323254],
              [76.179217, 17.315725],
              [76.18291, 17.3161],
              [76.184148, 17.312851],
              [76.176053, 17.299025],
              [76.172156, 17.299393],
              [76.164063, 17.302139],
              [76.164468, 17.32105],
              [76.163409, 17.342668],
              [76.145858, 17.349665],
              [76.137764, 17.354299],
              [76.121309, 17.368045],
              [76.11677, 17.367918],
              [76.102028, 17.363953],
              [76.095961, 17.359503],
              [76.09279, 17.356131],
              [76.090467, 17.352254],
              [76.094101, 17.34879],
              [76.092542, 17.345383],
              [76.086978, 17.340154],
              [76.086843, 17.335438],
              [76.084985, 17.333834],
              [76.078722, 17.331766],
              [76.07344, 17.334027],
              [76.063118, 17.353576],
              [76.060358, 17.3556],
              [76.054427, 17.355965],
              [76.036502, 17.350618],
              [76.021077, 17.350961],
              [76.015235, 17.352254],
              [76.008884, 17.349162],
              [76.003902, 17.344433],
              [75.999986, 17.339396],
              [75.98037, 17.337832],
              [75.971162, 17.338085],
              [75.95941, 17.335449],
              [75.941301, 17.326473],
              [75.93065, 17.325722],
              [75.915672, 17.340551],
              [75.910134, 17.347394],
              [75.897479, 17.352321],
              [75.893035, 17.355178],
              [75.891356, 17.362348],
              [75.895761, 17.37153],
              [75.896333, 17.378537],
              [75.89579, 17.396496],
              [75.893723, 17.407398],
              [75.889613, 17.415089],
              [75.88657, 17.418813],
              [75.88174, 17.420482],
              [75.877746, 17.418022],
              [75.876434, 17.412835],
              [75.878404, 17.40643],
              [75.878223, 17.401822],
              [75.875959, 17.398463],
              [75.864132, 17.387944],
              [75.861229, 17.387354],
              [75.858357, 17.390461],
              [75.855218, 17.409143],
              [75.847087, 17.416805],
              [75.838058, 17.421988],
              [75.826943, 17.42516],
              [75.823842, 17.424287],
              [75.821103, 17.421119],
              [75.819364, 17.408014],
              [75.81639, 17.402664],
              [75.81539, 17.399276],
              [75.816801, 17.389511],
              [75.816705, 17.382221],
              [75.814166, 17.375332],
              [75.810421, 17.371426],
              [75.801406, 17.371578],
              [75.790048, 17.374451],
              [75.781305, 17.380266],
              [75.775596, 17.389647],
              [75.768714, 17.408263],
              [75.763038, 17.409836],
              [75.757664, 17.409809],
              [75.749398, 17.414296],
              [75.735864, 17.423288],
              [75.732818, 17.423037],
              [75.727812, 17.42089],
              [75.721161, 17.413164],
              [75.713942, 17.410315],
              [75.706781, 17.409707],
              [75.695898, 17.411942],
              [75.689865, 17.413975],
              [75.685779, 17.418657],
              [75.679427, 17.437502],
              [75.679465, 17.455287],
              [75.676163, 17.459287],
              [75.669042, 17.46063],
              [75.660859, 17.460982],
              [75.654732, 17.468812],
              [75.648075, 17.474694],
              [75.634061, 17.478787],
              [75.631356, 17.470915],
              [75.62972, 17.462467],
              [75.623762, 17.459392],
              [75.617161, 17.440417],
              [75.613842, 17.423351],
              [75.608536, 17.420857],
              [75.608965, 17.418446],
              [75.613361, 17.410892],
              [75.615146, 17.399989],
              [75.614226, 17.393204],
              [75.608968, 17.39336],
              [75.601699, 17.3912],
              [75.596521, 17.387445],
              [75.586511, 17.384359],
              [75.582034, 17.38354],
              [75.576837, 17.384265],
              [75.582371, 17.352706],
              [75.583152, 17.351154],
              [75.588281, 17.351068],
              [75.596485, 17.346503],
              [75.611534, 17.343696],
              [75.614462, 17.330159],
              [75.612185, 17.320851],
              [75.60438, 17.304683],
              [75.589661, 17.301457],
              [75.580931, 17.293212],
              [75.572239, 17.289845],
              [75.563958, 17.288033],
              [75.556929, 17.284782],
              [75.547357, 17.27768],
              [75.539898, 17.269142],
              [75.528016, 17.259097],
              [75.521261, 17.249991],
              [75.515232, 17.239289],
              [75.505696, 17.238674],
              [75.463831, 17.23893],
              [75.46334, 17.240987],
              [75.466061, 17.245249],
              [75.468062, 17.250261],
              [75.467218, 17.251341],
              [75.447394, 17.255606],
              [75.44057, 17.258846],
              [75.435585, 17.264278],
              [75.43068, 17.267466],
              [75.422168, 17.264839],
              [75.415555, 17.252924],
              [75.409722, 17.240144],
              [75.410302, 17.233719],
              [75.409671, 17.228431],
              [75.407576, 17.220153],
              [75.40334, 17.211057],
              [75.405312, 17.200673],
              [75.408646, 17.190587],
              [75.406074, 17.183279],
              [75.394773, 17.188103],
              [75.386049, 17.190871],
              [75.367382, 17.190877],
              [75.370693, 17.206],
              [75.369864, 17.214777],
              [75.361798, 17.235524],
              [75.355655, 17.236172],
              [75.341892, 17.233283],
              [75.333911, 17.232489],
              [75.330996, 17.218702],
              [75.311548, 17.218999],
              [75.296237, 17.217071],
              [75.288855, 17.215195],
              [75.284782, 17.209079],
              [75.283102, 17.202175],
              [75.284533, 17.192546],
              [75.289699, 17.187176],
              [75.297006, 17.182113],
              [75.305249, 17.170789],
              [75.298556, 17.155245],
              [75.296111, 17.146099],
              [75.270524, 17.148538],
              [75.269665, 17.178843],
              [75.266678, 17.179117],
              [75.269334, 17.183207],
              [75.265104, 17.183352],
              [75.246883, 17.178875],
              [75.232805, 17.180343],
              [75.225034, 17.183217],
              [75.219743, 17.189331],
              [75.213893, 17.199168],
              [75.218076, 17.206034],
              [75.228476, 17.211609],
              [75.234486, 17.212509],
              [75.239415, 17.216154],
              [75.240004, 17.226087],
              [75.238625, 17.235556],
              [75.240372, 17.241252],
              [75.247966, 17.254964],
              [75.236212, 17.255979],
              [75.225177, 17.255627],
              [75.217821, 17.259657],
              [75.211179, 17.261797],
              [75.205743, 17.262333],
              [75.204026, 17.268815],
              [75.191761, 17.266494],
              [75.191005, 17.254949],
              [75.185649, 17.24561],
              [75.181095, 17.240412],
              [75.179991, 17.236394],
              [75.175252, 17.238994],
              [75.161523, 17.240628],
              [75.138191, 17.242194],
              [75.13206, 17.24066],
              [75.126798, 17.242868],
              [75.118466, 17.241314],
              [75.09918, 17.243193],
              [75.097777, 17.247719],
              [75.094147, 17.247062],
              [75.093472, 17.248724],
              [75.088346, 17.248979],
              [75.087708, 17.246732],
              [75.080419, 17.247714],
              [75.075424, 17.23815],
              [75.077234, 17.236145],
              [75.074859, 17.234293],
              [75.079551, 17.221759],
              [75.065583, 17.222858],
              [75.05508, 17.224624],
              [75.026459, 17.223328],
              [75.017264, 17.225033],
              [75.007945, 17.208303],
              [75.000005, 17.208786],
              [74.998122, 17.20888],
              [74.991939, 17.206386],
              [74.988606, 17.203879],
              [74.982168, 17.194196],
              [74.975966, 17.194109],
              [74.971354, 17.19551],
              [74.96552, 17.193856],
              [74.963517, 17.190717],
              [74.964018, 17.186792],
              [74.961478, 17.184112],
              [74.959233, 17.179598],
              [74.958968, 17.175534],
              [74.957376, 17.172792],
              [74.957336, 17.170627],
              [74.96013, 17.164209],
              [74.963578, 17.148851],
              [74.967482, 17.137568],
              [74.970184, 17.134893],
              [74.970087, 17.131783],
              [74.966546, 17.126225],
              [74.956709, 17.126072],
              [74.940939, 17.127879],
              [74.935327, 17.12858],
              [74.929653, 17.130485],
              [74.922089, 17.128417],
              [74.914669, 17.12343],
              [74.912604, 17.120664],
              [74.914363, 17.117066],
              [74.917471, 17.116346],
              [74.917542, 17.113885],
              [74.904814, 17.117804],
              [74.896801, 17.119413],
              [74.895064, 17.12129],
              [74.896957, 17.122617],
              [74.896519, 17.125713],
              [74.894708, 17.128457],
              [74.902966, 17.13287],
              [74.914685, 17.129854],
              [74.918379, 17.130454],
              [74.925784, 17.136704],
              [74.9265, 17.145436],
              [74.923144, 17.154711],
              [74.919099, 17.161736],
              [74.914453, 17.160888],
              [74.911947, 17.159375],
              [74.909074, 17.160729],
              [74.905228, 17.164263],
              [74.907299, 17.167149],
              [74.906561, 17.170301],
              [74.90707, 17.173863],
              [74.905326, 17.17551],
              [74.903788, 17.174301],
              [74.900844, 17.176632],
              [74.900742, 17.182199],
              [74.896199, 17.17539],
              [74.893196, 17.177948],
              [74.888171, 17.179572],
              [74.889998, 17.182347],
              [74.892682, 17.182999],
              [74.893435, 17.185189],
              [74.888952, 17.187226],
              [74.889179, 17.188722],
              [74.890718, 17.189538],
              [74.896678, 17.190039],
              [74.897496, 17.193552],
              [74.895279, 17.194343],
              [74.888419, 17.194633],
              [74.881726, 17.187168],
              [74.877043, 17.191385],
              [74.872162, 17.19014],
              [74.871221, 17.196225],
              [74.866566, 17.195156],
              [74.867312, 17.199296],
              [74.866748, 17.202743],
              [74.871711, 17.201408],
              [74.872378, 17.208259],
              [74.866344, 17.208606],
              [74.858977, 17.204747],
              [74.858313, 17.205547],
              [74.860267, 17.20723],
              [74.860671, 17.209303],
              [74.854881, 17.209139],
              [74.851854, 17.2078],
              [74.850869, 17.210887],
              [74.859011, 17.214747],
              [74.868018, 17.215928],
              [74.878614, 17.21188],
              [74.876185, 17.217846],
              [74.876222, 17.220561],
              [74.87854, 17.221453],
              [74.883919, 17.220358],
              [74.886167, 17.222401],
              [74.887284, 17.224371],
              [74.886151, 17.231968],
              [74.893411, 17.235905],
              [74.895622, 17.235801],
              [74.896442, 17.236849],
              [74.896775, 17.24087],
              [74.899741, 17.242324],
              [74.900092, 17.252176],
              [74.901877, 17.260914],
              [74.906098, 17.270292],
              [74.909355, 17.27419],
              [74.913939, 17.275181],
              [74.937535, 17.27314],
              [74.938592, 17.276114],
              [74.938906, 17.281218],
              [74.940791, 17.285698],
              [74.945684, 17.285906],
              [74.952842, 17.287332],
              [74.958432, 17.290075],
              [74.961869, 17.293376],
              [74.970444, 17.320735],
              [74.97112, 17.327588],
              [74.969484, 17.329883],
              [74.967107, 17.336285],
              [74.968868, 17.340606],
              [74.971419, 17.344431],
              [74.975568, 17.347958],
              [74.987224, 17.355656],
              [75.000021, 17.361997],
              [75.007246, 17.367942],
              [75.003157, 17.384625],
              [74.999963, 17.387652],
              [74.997649, 17.391586],
              [74.998607, 17.404062],
              [75.000031, 17.406834],
              [75.006527, 17.41048],
              [75.015141, 17.408764],
              [75.024156, 17.408433],
              [75.030217, 17.411976],
              [75.034331, 17.419816],
              [75.034242, 17.430613],
              [75.032449, 17.438695],
              [75.03245, 17.445361],
              [75.036751, 17.452166],
              [75.039313, 17.460851],
              [75.040937, 17.473847],
              [75.039788, 17.482391],
              [75.036018, 17.491033],
              [75.032287, 17.494277],
              [75.027633, 17.493734],
              [75.014363, 17.487601],
              [75.000025, 17.4794],
              [74.993131, 17.473971],
              [74.984581, 17.465659],
              [74.980529, 17.464412],
              [74.977284, 17.465971],
              [74.973921, 17.468213],
              [74.971447, 17.472036],
              [74.970601, 17.481164],
              [74.964909, 17.491005],
              [74.957997, 17.496204],
              [74.954224, 17.497286],
              [74.950503, 17.499364],
              [74.950292, 17.502857],
              [74.948609, 17.504499],
              [74.945132, 17.506121],
              [74.941868, 17.510446],
              [74.940961, 17.512623],
              [74.941825, 17.516012],
              [74.944026, 17.517987],
              [74.948559, 17.519756],
              [74.96331, 17.522251],
              [74.976395, 17.531075],
              [74.988819, 17.541592],
              [74.975882, 17.552903],
              [74.96806, 17.55859],
              [74.96607, 17.561558],
              [74.963547, 17.563545],
              [74.96251, 17.566064],
              [74.965175, 17.577105],
              [74.96556, 17.582734],
              [74.965353, 17.586173],
              [74.963168, 17.590295],
              [74.961309, 17.591086],
              [74.960176, 17.590447],
              [74.960013, 17.588091],
              [74.958526, 17.586534],
              [74.945369, 17.586139],
              [74.925606, 17.574973],
              [74.920989, 17.576025],
              [74.917954, 17.581389],
              [74.918885, 17.592459],
              [74.918214, 17.594855],
              [74.918602, 17.598187],
              [74.922111, 17.609902],
              [74.92758, 17.616878],
              [74.921159, 17.617119],
              [74.918036, 17.618308],
              [74.916189, 17.617605],
              [74.912716, 17.618152],
              [74.910077, 17.619621],
              [74.910041, 17.623746],
              [74.911258, 17.628811],
              [74.905534, 17.626518],
              [74.899611, 17.650023],
              [74.894616, 17.653102],
              [74.890078, 17.659532],
              [74.888822, 17.675007],
              [74.885124, 17.681259],
              [74.877484, 17.67844],
              [74.866578, 17.695595],
              [74.86642, 17.700192],
              [74.86944, 17.704466],
              [74.874288, 17.719736],
              [74.874862, 17.723013],
              [74.873283, 17.725935],
              [74.863099, 17.726826],
              [74.857418, 17.72654],
              [74.852639, 17.725298],
              [74.845673, 17.727593],
              [74.840424, 17.725136],
              [74.833991, 17.728749],
              [74.824427, 17.741701],
              [74.81953, 17.747004],
              [74.800848, 17.755162],
              [74.795009, 17.759243],
              [74.78894, 17.761889],
              [74.779943, 17.770594],
              [74.778019, 17.770922],
              [74.767754, 17.76738],
              [74.766253, 17.760874],
              [74.764594, 17.758794],
              [74.761965, 17.75837],
              [74.758228, 17.76126],
              [74.753632, 17.759675],
              [74.74713, 17.763053],
              [74.744179, 17.765035],
              [74.744018, 17.770146],
              [74.750916, 17.768487],
              [74.750816, 17.766822],
              [74.756328, 17.779855],
              [74.755291, 17.782426],
              [74.749747, 17.786852],
              [74.746202, 17.787621],
              [74.740337, 17.787689],
              [74.74056, 17.789581],
              [74.7459, 17.794451],
              [74.747795, 17.797516],
              [74.745463, 17.797264],
              [74.73163, 17.790359],
              [74.725826, 17.788925],
              [74.716701, 17.78517],
              [74.713903, 17.783243],
              [74.713056, 17.791109],
              [74.710437, 17.789245],
              [74.711147, 17.783914],
              [74.707178, 17.785772],
              [74.702148, 17.785605],
              [74.700706, 17.786626],
              [74.701403, 17.788072],
              [74.706172, 17.790923],
              [74.705922, 17.792361],
              [74.69959, 17.79023],
              [74.696839, 17.790268],
              [74.695808, 17.791116],
              [74.6958, 17.792491],
              [74.701997, 17.795479],
              [74.698326, 17.797857],
              [74.69879, 17.79987],
              [74.701395, 17.802705],
              [74.701259, 17.805066],
              [74.69529, 17.802595],
              [74.695962, 17.807711],
              [74.689992, 17.806159],
              [74.686314, 17.80791],
              [74.685341, 17.809963],
              [74.687641, 17.813657],
              [74.68524, 17.81484],
              [74.686227, 17.817844],
              [74.684452, 17.822131],
              [74.685494, 17.826735],
              [74.683961, 17.830275],
              [74.681128, 17.83306],
              [74.679421, 17.836084],
              [74.678811, 17.849975],
              [74.664659, 17.85805],
              [74.660978, 17.861234],
              [74.657555, 17.862174],
              [74.65475, 17.860886],
              [74.64882, 17.847679],
              [74.647732, 17.842156],
              [74.648714, 17.839241],
              [74.645447, 17.836454],
              [74.639534, 17.835076],
              [74.642144, 17.831141],
              [74.642341, 17.829078],
              [74.637556, 17.828287],
              [74.629972, 17.838716],
              [74.628955, 17.83193],
              [74.625744, 17.830577],
              [74.618638, 17.833668],
              [74.615189, 17.836965],
              [74.618577, 17.840906],
              [74.619437, 17.844069],
              [74.610819, 17.843297],
              [74.6087, 17.846484],
              [74.612252, 17.8565],
              [74.614569, 17.85824],
              [74.616664, 17.858493],
              [74.620418, 17.860827],
              [74.624542, 17.862181],
              [74.635056, 17.872325],
              [74.635818, 17.873996],
              [74.63333, 17.89005],
              [74.633272, 17.895846],
              [74.634911, 17.900398],
              [74.639172, 17.906466],
              [74.652481, 17.918357],
              [74.65544, 17.922807],
              [74.658078, 17.929602],
              [74.659162, 17.942468],
              [74.662769, 17.954219],
              [74.668104, 17.975301],
              [74.667185, 17.991684],
              [74.665838, 17.995627],
              [74.664742, 18.000612],
              [74.679602, 18.013276],
              [74.693422, 18.021131],
              [74.710008, 18.029332],
              [74.712276, 18.02804],
              [74.718098, 18.027511],
              [74.726671, 18.029359],
              [74.730391, 18.028699],
              [74.743003, 18.025061],
              [74.747892, 18.018556],
              [74.751122, 18.018412],
              [74.756032, 18.022189],
              [74.760068, 18.024057],
              [74.763439, 18.02415],
              [74.766561, 18.022458],
              [74.772397, 18.016348],
              [74.774167, 18.013066],
              [74.777333, 18.010699],
              [74.783, 18.009875],
              [74.787283, 18.010488],
              [74.793904, 18.009032],
              [74.79842, 18.006536],
              [74.800381, 18.003971],
              [74.801434, 18.000232],
              [74.803221, 17.997997],
              [74.805728, 17.996891],
              [74.807384, 17.996569],
              [74.808807, 17.996701],
              [74.809533, 17.997445],
              [74.810252, 17.998378],
              [74.810448, 17.999389],
              [74.810104, 18.000427],
              [74.809499, 18.002435],
              [74.808636, 18.011047],
              [74.809133, 18.014312],
              [74.80985, 18.015988],
              [74.810264, 18.016688],
              [74.813174, 18.017309],
              [74.815857, 18.016658],
              [74.822745, 18.013617],
              [74.826358, 18.009711],
              [74.829804, 18.00517],
              [74.830787, 18.000389],
              [74.831302, 17.99467],
              [74.832694, 17.992681],
              [74.838942, 17.991527],
              [74.847428, 17.994821],
              [74.852528, 17.994692],
              [74.859196, 17.993208],
              [74.86382, 17.991349],
              [74.864556, 17.98998],
              [74.865302, 17.985861],
              [74.862065, 17.978314],
              [74.861339, 17.971589],
              [74.858312, 17.967891],
              [74.850395, 17.961166],
              [74.848196, 17.958333],
              [74.844947, 17.952329],
              [74.846964, 17.947757],
              [74.851774, 17.945623],
              [74.867436, 17.950981],
              [74.869533, 17.950834],
              [74.874865, 17.944678],
              [74.887062, 17.940652],
              [74.891934, 17.93788],
              [74.896621, 17.937398],
              [74.898952, 17.937704],
              [74.906997, 17.94368],
              [74.911298, 17.94486],
              [74.917119, 17.944848],
              [74.928593, 17.941051],
              [74.939094, 17.93992],
              [74.943545, 17.937665],
              [74.944579, 17.935129],
              [74.943457, 17.924695],
              [74.956311, 17.921053],
              [74.962101, 17.914981],
              [74.975274, 17.916069],
              [74.981208, 17.915306],
              [74.988103, 17.912463],
              [75.000028, 17.910443],
              [75.017706, 17.907411],
              [75.019477, 17.905623],
              [75.019765, 17.898921],
              [75.020902, 17.894211],
              [75.02398, 17.892092],
              [75.026846, 17.893025],
              [75.039371, 17.903262],
              [75.043773, 17.903553],
              [75.051453, 17.900558],
              [75.054468, 17.90193],
              [75.055842, 17.90428],
              [75.048368, 17.913735],
              [75.046452, 17.917591],
              [75.048245, 17.921134],
              [75.05264, 17.924388],
              [75.058483, 17.925187],
              [75.067296, 17.916583],
              [75.072253, 17.914303],
              [75.083242, 17.918518],
              [75.089524, 17.923134],
              [75.087381, 17.927329],
              [75.082605, 17.932243],
              [75.082843, 17.936171],
              [75.084543, 17.938729],
              [75.088982, 17.940755],
              [75.099767, 17.942297],
              [75.106392, 17.936452],
              [75.11105, 17.934623],
              [75.11479, 17.936632],
              [75.118481, 17.944909],
              [75.127547, 17.950407],
              [75.130702, 17.954196],
              [75.129483, 17.957957],
              [75.125609, 17.961153],
              [75.11822, 17.964285],
              [75.117355, 17.968466],
              [75.119814, 17.971021],
              [75.124051, 17.970834],
              [75.129461, 17.969124],
              [75.135026, 17.969576],
              [75.131015, 17.975299],
              [75.1293, 17.979209],
              [75.126861, 17.992062],
              [75.123434, 17.996435],
              [75.120092, 17.997876],
              [75.113923, 17.997706],
              [75.109084, 17.993102],
              [75.105346, 17.977126],
              [75.102613, 17.973208],
              [75.099039, 17.972802],
              [75.089269, 17.975966],
              [75.079359, 17.978263],
              [75.070588, 17.975768],
              [75.063676, 17.959128],
              [75.059115, 17.951276],
              [75.050727, 17.946624],
              [75.040346, 17.946738],
              [75.034495, 17.952361],
              [75.02155, 17.962016],
              [75.021523, 17.967355],
              [75.025043, 17.981029],
              [75.029166, 17.988439],
              [75.039191, 18.000109],
              [75.044994, 18.006779],
              [75.052642, 18.020283],
              [75.057413, 18.024877],
              [75.062539, 18.029294],
              [75.077144, 18.03557],
              [75.083784, 18.042041],
              [75.08639, 18.045854],
              [75.090722, 18.063733],
              [75.092296, 18.066129],
              [75.096872, 18.069519],
              [75.109135, 18.073699],
              [75.115858, 18.074897],
              [75.121307, 18.073986],
              [75.130303, 18.075387],
              [75.132422, 18.077715],
              [75.134229, 18.087033],
              [75.137626, 18.09158],
              [75.143355, 18.095766],
              [75.155747, 18.100453],
              [75.159418, 18.102589],
              [75.163165, 18.106508],
              [75.163717, 18.113389],
              [75.163896, 18.115544],
              [75.162783, 18.118762],
              [75.158062, 18.120982],
              [75.145788, 18.123339],
              [75.139135, 18.122599],
              [75.130543, 18.119821],
              [75.118351, 18.118105],
              [75.109851, 18.119156],
              [75.098695, 18.118404],
              [75.095285, 18.119749],
              [75.093804, 18.122232],
              [75.093403, 18.131392],
              [75.091775, 18.138227],
              [75.091654, 18.146016],
              [75.095326, 18.156055],
              [75.103446, 18.167148],
              [75.110017, 18.178544],
              [75.110874, 18.188433],
              [75.114196, 18.199513],
              [75.111642, 18.210768],
              [75.109635, 18.214337],
              [75.105886, 18.217916],
              [75.102063, 18.220528],
              [75.097151, 18.221151],
              [75.082006, 18.217915],
              [75.073143, 18.211467],
              [75.059365, 18.197563],
              [75.054135, 18.196353],
              [75.049395, 18.1968],
              [75.043633, 18.195308],
              [75.036557, 18.195597],
              [75.032465, 18.193576],
              [75.028054, 18.18898],
              [75.021985, 18.187482],
              [75.013304, 18.198727],
              [75.008331, 18.208103],
              [75.008547, 18.212053],
              [75.014988, 18.223109],
              [75.019708, 18.229308],
              [75.032042, 18.242367],
              [75.037772, 18.246549],
              [75.044779, 18.253419],
              [75.046002, 18.256332],
              [75.044723, 18.26212],
              [75.041375, 18.263126],
              [75.03663, 18.261967],
              [75.031613, 18.258405],
              [75.013117, 18.247807],
              [75.000028, 18.242714],
              [74.99647, 18.242389],
              [74.99318, 18.240984],
              [74.986142, 18.241412],
              [74.976194, 18.245913],
              [74.964, 18.252723],
              [74.955209, 18.260932],
              [74.951108, 18.263428],
              [74.944865, 18.262991],
              [74.935401, 18.260407],
              [74.922504, 18.258401],
              [74.915904, 18.257992],
              [74.906051, 18.259107],
              [74.895179, 18.258978],
              [74.887986, 18.257438],
              [74.88113, 18.252626],
              [74.876674, 18.247314],
              [74.867012, 18.247196],
              [74.850414, 18.243655],
              [74.842016, 18.243256],
              [74.833158, 18.246307],
              [74.82601, 18.252752],
              [74.819434, 18.262532],
              [74.812392, 18.269673],
              [74.796566, 18.279276],
              [74.795136, 18.284265],
              [74.79777, 18.297203],
              [74.799606, 18.299339],
              [74.804094, 18.301367],
              [74.820394, 18.298903],
              [74.829072, 18.295524],
              [74.836651, 18.294938],
              [74.842346, 18.295729],
              [74.846337, 18.299888],
              [74.84378, 18.309636],
              [74.836698, 18.320724],
              [74.832659, 18.329084],
              [74.833877, 18.339199],
              [74.838168, 18.336819],
              [74.851867, 18.330752],
              [74.861689, 18.333744],
              [74.863897, 18.334732],
              [74.865417, 18.339968],
              [74.866074, 18.346242],
              [74.868902, 18.351661],
              [74.871174, 18.35288],
              [74.885442, 18.356418],
              [74.891452, 18.355881],
              [74.907371, 18.356197],
              [74.911997, 18.369506],
              [74.915828, 18.37712],
              [74.924717, 18.378022],
              [74.940216, 18.385286],
              [74.946283, 18.385311],
              [74.950899, 18.386999],
              [74.958102, 18.387757],
              [74.965331, 18.385081],
              [74.968507, 18.386912],
              [74.970766, 18.38949],
              [74.972763, 18.394186],
              [74.983655, 18.399673],
              [75.000032, 18.40362],
              [75.00415, 18.402906],
              [75.006514, 18.405515],
              [75.010743, 18.417793],
              [75.013425, 18.431565],
              [75.01623, 18.436639],
              [75.035372, 18.434348],
              [75.050298, 18.429689],
              [75.053518, 18.427307],
              [75.058987, 18.419988],
              [75.065667, 18.421239],
              [75.070483, 18.423376],
              [75.072523, 18.423526],
              [75.076543, 18.422456],
              [75.078632, 18.420552],
              [75.079869, 18.42512],
              [75.08193, 18.427908],
              [75.084884, 18.429771],
              [75.088498, 18.430024],
              [75.091149, 18.431425],
              [75.092662, 18.433818],
              [75.09215, 18.445273],
              [75.092716, 18.456322],
              [75.094914, 18.461117],
              [75.098736, 18.465427],
              [75.101175, 18.469647],
              [75.105646, 18.489242],
              [75.106978, 18.490491],
              [75.120091, 18.491745],
              [75.12569, 18.493862],
              [75.127845, 18.500491],
              [75.128686, 18.508153],
              [75.134903, 18.526243],
              [75.138092, 18.526621],
              [75.159435, 18.519888],
              [75.172487, 18.522043],
              [75.182875, 18.527731],
              [75.186422, 18.528776],
              [75.197356, 18.528501],
              [75.2008, 18.529898],
              [75.204247, 18.532729],
              [75.208363, 18.543334],
              [75.215371, 18.554429],
              [75.219086, 18.553884],
              [75.222976, 18.550866],
              [75.224389, 18.54747],
              [75.227717, 18.543314],
              [75.231557, 18.542242],
              [75.239977, 18.543482],
              [75.24224, 18.540996],
              [75.244531, 18.534725],
              [75.249021, 18.526207],
              [75.255102, 18.519615],
              [75.261313, 18.508842],
              [75.268477, 18.510317],
              [75.280543, 18.515284],
              [75.308508, 18.518603],
              [75.314401, 18.51854],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 538,
        censuscode: 526,
        dt_cen_cd: 30,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Solapur",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [75.60438, 17.304683],
              [75.623162, 17.295248],
              [75.626358, 17.289578],
              [75.629619, 17.281316],
              [75.631888, 17.278858],
              [75.630835, 17.273691],
              [75.656082, 17.272065],
              [75.658503, 17.262942],
              [75.659545, 17.241527],
              [75.661444, 17.229477],
              [75.662518, 17.215305],
              [75.66075, 17.209896],
              [75.656056, 17.205341],
              [75.642145, 17.195641],
              [75.641211, 17.189727],
              [75.629229, 17.187722],
              [75.628716, 17.183019],
              [75.627053, 17.182312],
              [75.626551, 17.171691],
              [75.629939, 17.161661],
              [75.641321, 17.149247],
              [75.647329, 17.140419],
              [75.648307, 17.134801],
              [75.65135, 17.134356],
              [75.652267, 17.114774],
              [75.672805, 17.115203],
              [75.674222, 17.102798],
              [75.677224, 17.095865],
              [75.676115, 17.089433],
              [75.678871, 17.07997],
              [75.679822, 17.072849],
              [75.677152, 17.064572],
              [75.669688, 17.06328],
              [75.661375, 17.063478],
              [75.653051, 17.056798],
              [75.646499, 17.04828],
              [75.642367, 17.038117],
              [75.646835, 17.034407],
              [75.652663, 17.032363],
              [75.660843, 17.034173],
              [75.670972, 17.037469],
              [75.671836, 17.027917],
              [75.669258, 17.000595],
              [75.667406, 16.985002],
              [75.667557, 16.979549],
              [75.668122, 16.977422],
              [75.671384, 16.975878],
              [75.673337, 16.971146],
              [75.677195, 16.965752],
              [75.67337, 16.962081],
              [75.67012, 16.960347],
              [75.662471, 16.959695],
              [75.654332, 16.957913],
              [75.648301, 16.953805],
              [75.643684, 16.952835],
              [75.638023, 16.960952],
              [75.634961, 16.967586],
              [75.629549, 16.968925],
              [75.619595, 16.969518],
              [75.609184, 16.97138],
              [75.608183, 17.00067],
              [75.608024, 17.00483],
              [75.597918, 17.006943],
              [75.57419, 17.009502],
              [75.56828, 17.007871],
              [75.567665, 17.00057],
              [75.568738, 16.965358],
              [75.556815, 16.966088],
              [75.541095, 16.964855],
              [75.531126, 16.96837],
              [75.528245, 16.967547],
              [75.522292, 16.960452],
              [75.515215, 16.953655],
              [75.508822, 16.949031],
              [75.507467, 16.950307],
              [75.500017, 16.947129],
              [75.490612, 16.944604],
              [75.491121, 16.946896],
              [75.490742, 16.953219],
              [75.489875, 16.959535],
              [75.487781, 16.967079],
              [75.480584, 16.977621],
              [75.466608, 16.981237],
              [75.465924, 16.986987],
              [75.451499, 16.984299],
              [75.441724, 16.981141],
              [75.436763, 16.972538],
              [75.428902, 16.965114],
              [75.414666, 16.971143],
              [75.392498, 16.97801],
              [75.369355, 16.970314],
              [75.362, 16.965236],
              [75.357198, 16.958516],
              [75.342891, 16.954147],
              [75.335504, 16.955158],
              [75.303539, 16.956271],
              [75.292128, 16.955721],
              [75.285807, 16.956365],
              [75.281974, 16.955145],
              [75.28094, 16.944537],
              [75.282942, 16.911057],
              [75.289156, 16.902779],
              [75.284868, 16.884863],
              [75.283013, 16.880463],
              [75.280146, 16.875909],
              [75.265604, 16.86253],
              [75.25524, 16.863791],
              [75.245906, 16.86619],
              [75.240658, 16.866141],
              [75.238195, 16.864617],
              [75.232832, 16.855844],
              [75.230087, 16.8472],
              [75.22717, 16.842586],
              [75.212964, 16.842001],
              [75.185304, 16.842537],
              [75.180189, 16.843681],
              [75.185989, 16.86353],
              [75.189541, 16.871186],
              [75.186671, 16.875119],
              [75.177823, 16.869128],
              [75.168668, 16.866421],
              [75.161286, 16.867184],
              [75.147369, 16.871011],
              [75.137944, 16.875129],
              [75.135193, 16.879864],
              [75.133904, 16.886186],
              [75.135193, 16.894496],
              [75.12439, 16.898743],
              [75.120315, 16.902005],
              [75.118735, 16.908789],
              [75.115485, 16.91152],
              [75.103606, 16.911071],
              [75.094591, 16.915416],
              [75.09134, 16.922682],
              [75.090763, 16.948739],
              [75.087016, 16.950155],
              [75.079536, 16.948108],
              [75.061906, 16.94077],
              [75.051697, 16.940359],
              [75.047231, 16.941153],
              [75.044596, 16.940205],
              [75.041789, 16.935758],
              [75.030871, 16.930245],
              [75.028271, 16.927173],
              [75.026475, 16.932636],
              [75.026664, 16.943023],
              [75.007692, 16.944059],
              [74.999959, 16.947308],
              [74.995774, 16.943379],
              [74.990694, 16.936523],
              [74.982003, 16.9305],
              [74.9776, 16.932095],
              [74.971428, 16.936075],
              [74.965614, 16.937379],
              [74.962818, 16.937118],
              [74.95609, 16.934403],
              [74.954108, 16.930616],
              [74.950597, 16.931472],
              [74.948485, 16.937681],
              [74.944368, 16.937283],
              [74.934381, 16.942441],
              [74.924461, 16.93666],
              [74.922982, 16.927079],
              [74.932915, 16.922202],
              [74.934212, 16.917951],
              [74.940097, 16.914754],
              [74.944079, 16.910661],
              [74.948891, 16.90798],
              [74.96339, 16.906874],
              [74.960213, 16.879402],
              [74.952157, 16.87881],
              [74.944659, 16.881599],
              [74.941191, 16.878631],
              [74.935695, 16.878026],
              [74.935856, 16.873831],
              [74.933091, 16.870682],
              [74.927487, 16.871053],
              [74.92376, 16.864865],
              [74.907862, 16.857455],
              [74.90923, 16.84298],
              [74.908989, 16.832289],
              [74.911755, 16.811782],
              [74.91181, 16.787254],
              [74.919787, 16.771542],
              [74.902916, 16.771376],
              [74.888488, 16.770271],
              [74.864116, 16.772644],
              [74.850652, 16.772345],
              [74.846014, 16.761898],
              [74.799607, 16.75233],
              [74.795887, 16.747219],
              [74.786545, 16.749716],
              [74.774385, 16.750152],
              [74.770915, 16.745566],
              [74.770419, 16.742355],
              [74.764759, 16.74105],
              [74.759143, 16.738362],
              [74.75143, 16.731204],
              [74.749388, 16.727761],
              [74.743478, 16.723696],
              [74.731832, 16.717412],
              [74.717583, 16.714864],
              [74.702923, 16.714662],
              [74.693252, 16.716762],
              [74.697621, 16.722948],
              [74.701045, 16.731378],
              [74.700459, 16.733967],
              [74.661238, 16.749794],
              [74.648005, 16.750742],
              [74.645812, 16.754018],
              [74.644691, 16.757525],
              [74.645081, 16.769237],
              [74.641173, 16.776605],
              [74.631843, 16.785806],
              [74.614043, 16.79509],
              [74.607258, 16.798494],
              [74.599397, 16.801089],
              [74.590992, 16.801799],
              [74.581451, 16.801352],
              [74.569232, 16.80293],
              [74.561844, 16.804834],
              [74.55929, 16.806672],
              [74.557115, 16.81943],
              [74.549385, 16.83064],
              [74.53571, 16.845651],
              [74.529153, 16.846067],
              [74.524804, 16.848023],
              [74.516955, 16.856654],
              [74.513491, 16.854643],
              [74.514774, 16.84413],
              [74.513995, 16.839483],
              [74.507067, 16.835759],
              [74.503723, 16.832437],
              [74.497812, 16.829057],
              [74.496807, 16.834682],
              [74.49479, 16.837611],
              [74.49425, 16.839963],
              [74.494936, 16.851458],
              [74.495956, 16.855531],
              [74.493287, 16.858755],
              [74.486961, 16.859272],
              [74.48571, 16.861408],
              [74.480177, 16.865602],
              [74.47016, 16.867165],
              [74.467289, 16.863546],
              [74.466444, 16.858209],
              [74.46466, 16.854535],
              [74.460772, 16.851569],
              [74.435968, 16.849444],
              [74.429896, 16.844741],
              [74.421131, 16.842281],
              [74.413896, 16.841852],
              [74.40807, 16.845194],
              [74.405087, 16.850197],
              [74.406451, 16.855048],
              [74.411713, 16.860975],
              [74.416061, 16.870991],
              [74.415489, 16.877145],
              [74.404822, 16.875127],
              [74.402843, 16.879877],
              [74.395925, 16.8772],
              [74.387113, 16.86739],
              [74.37971, 16.867076],
              [74.365247, 16.852784],
              [74.361322, 16.853386],
              [74.357974, 16.858449],
              [74.355642, 16.863376],
              [74.35502, 16.869819],
              [74.348587, 16.870177],
              [74.339021, 16.877499],
              [74.332013, 16.876088],
              [74.326708, 16.876196],
              [74.324086, 16.88182],
              [74.319892, 16.885978],
              [74.314432, 16.889995],
              [74.30868, 16.888906],
              [74.297584, 16.891765],
              [74.291963, 16.896416],
              [74.285549, 16.91113],
              [74.281705, 16.915461],
              [74.276668, 16.914124],
              [74.270228, 16.90891],
              [74.257423, 16.904512],
              [74.254463, 16.900031],
              [74.249857, 16.886047],
              [74.243988, 16.885185],
              [74.237552, 16.885549],
              [74.232356, 16.887885],
              [74.232013, 16.894216],
              [74.229585, 16.903046],
              [74.223373, 16.910631],
              [74.217169, 16.910759],
              [74.213049, 16.905437],
              [74.213476, 16.897672],
              [74.212229, 16.892246],
              [74.208637, 16.891798],
              [74.201681, 16.892618],
              [74.192236, 16.891884],
              [74.18779, 16.893232],
              [74.182076, 16.896793],
              [74.176753, 16.898844],
              [74.170234, 16.898175],
              [74.162074, 16.89609],
              [74.158317, 16.890474],
              [74.155023, 16.887209],
              [74.152273, 16.886246],
              [74.14806, 16.883894],
              [74.140643, 16.885915],
              [74.134287, 16.889521],
              [74.123755, 16.902907],
              [74.121327, 16.911425],
              [74.113291, 16.910039],
              [74.108325, 16.908379],
              [74.098033, 16.908564],
              [74.096254, 16.911344],
              [74.093602, 16.913382],
              [74.090278, 16.914742],
              [74.084778, 16.909358],
              [74.07772, 16.904525],
              [74.071502, 16.902483],
              [74.066426, 16.903344],
              [74.065055, 16.908747],
              [74.061147, 16.911276],
              [74.052772, 16.913506],
              [74.047396, 16.9221],
              [74.041782, 16.922208],
              [74.039369, 16.923927],
              [74.036702, 16.932871],
              [74.035982, 16.938475],
              [74.03102, 16.94044],
              [74.026431, 16.940457],
              [74.023537, 16.942076],
              [74.02716, 16.949549],
              [74.026288, 16.953048],
              [74.022774, 16.955807],
              [74.0207, 16.958707],
              [74.020931, 16.961093],
              [74.02547, 16.961617],
              [74.026759, 16.963345],
              [74.025153, 16.965896],
              [74.020582, 16.968946],
              [74.023199, 16.97368],
              [74.023669, 16.978131],
              [74.02268, 16.984409],
              [74.006952, 16.987756],
              [74.000031, 16.990109],
              [73.995575, 16.99462],
              [73.990049, 16.986914],
              [73.985631, 16.985297],
              [73.981069, 16.985762],
              [73.975936, 16.988018],
              [73.971265, 16.993078],
              [73.971064, 16.996146],
              [73.972979, 17.000163],
              [73.972275, 17.004001],
              [73.978881, 17.007736],
              [73.982048, 17.013325],
              [73.98337, 17.02829],
              [73.980998, 17.034109],
              [73.976745, 17.035598],
              [73.974748, 17.038614],
              [73.963824, 17.04816],
              [73.959808, 17.054355],
              [73.954137, 17.054052],
              [73.950327, 17.057379],
              [73.949739, 17.060703],
              [73.944468, 17.06252],
              [73.940318, 17.068661],
              [73.933575, 17.072295],
              [73.931111, 17.073349],
              [73.921991, 17.071739],
              [73.916905, 17.067992],
              [73.915323, 17.074221],
              [73.910724, 17.078806],
              [73.907968, 17.083301],
              [73.904848, 17.097379],
              [73.901849, 17.102274],
              [73.896604, 17.105641],
              [73.886559, 17.109914],
              [73.878096, 17.116687],
              [73.874851, 17.121979],
              [73.876717, 17.125391],
              [73.879619, 17.127672],
              [73.878389, 17.130233],
              [73.874837, 17.131621],
              [73.868506, 17.131471],
              [73.865986, 17.13609],
              [73.864052, 17.137669],
              [73.860518, 17.137903],
              [73.857638, 17.142683],
              [73.849312, 17.152671],
              [73.845825, 17.153768],
              [73.82762, 17.167339],
              [73.81893, 17.168935],
              [73.815118, 17.171747],
              [73.803514, 17.171868],
              [73.793306, 17.178034],
              [73.780595, 17.180035],
              [73.775449, 17.179333],
              [73.77213, 17.17681],
              [73.769931, 17.171268],
              [73.77236, 17.164711],
              [73.777813, 17.156584],
              [73.778569, 17.153721],
              [73.77698, 17.151808],
              [73.768147, 17.153402],
              [73.765815, 17.152563],
              [73.759805, 17.152593],
              [73.756846, 17.154214],
              [73.752282, 17.153681],
              [73.749951, 17.152157],
              [73.746289, 17.160312],
              [73.748405, 17.16924],
              [73.747386, 17.173756],
              [73.743402, 17.175247],
              [73.736481, 17.168495],
              [73.732136, 17.167342],
              [73.723294, 17.16905],
              [73.717104, 17.171707],
              [73.713271, 17.171547],
              [73.709323, 17.169653],
              [73.700947, 17.177614],
              [73.69812, 17.178601],
              [73.693892, 17.178534],
              [73.698187, 17.181877],
              [73.702141, 17.181651],
              [73.702861, 17.183894],
              [73.707284, 17.187059],
              [73.712724, 17.196663],
              [73.71762, 17.200068],
              [73.718617, 17.202314],
              [73.717042, 17.209349],
              [73.708505, 17.224261],
              [73.702595, 17.226181],
              [73.698419, 17.228935],
              [73.695569, 17.235724],
              [73.693909, 17.23759],
              [73.693195, 17.243437],
              [73.694874, 17.248283],
              [73.697351, 17.252229],
              [73.697102, 17.259569],
              [73.696164, 17.262559],
              [73.698616, 17.261771],
              [73.703106, 17.262008],
              [73.712143, 17.259383],
              [73.718249, 17.258958],
              [73.723984, 17.264436],
              [73.726814, 17.269015],
              [73.731867, 17.273794],
              [73.737608, 17.275769],
              [73.742833, 17.275394],
              [73.749471, 17.272503],
              [73.754872, 17.268103],
              [73.756436, 17.263937],
              [73.764252, 17.253721],
              [73.767653, 17.250384],
              [73.771519, 17.247859],
              [73.800461, 17.241908],
              [73.807129, 17.231387],
              [73.815093, 17.231275],
              [73.819768, 17.230471],
              [73.828174, 17.22876],
              [73.832863, 17.226756],
              [73.84418, 17.21378],
              [73.852907, 17.197827],
              [73.861612, 17.195369],
              [73.872168, 17.189208],
              [73.875471, 17.179784],
              [73.881432, 17.172459],
              [73.88346, 17.168877],
              [73.884774, 17.156034],
              [73.887065, 17.15441],
              [73.89728, 17.154838],
              [73.901623, 17.156675],
              [73.905579, 17.155582],
              [73.908619, 17.152129],
              [73.920853, 17.143976],
              [73.925808, 17.139565],
              [73.935222, 17.135346],
              [73.942804, 17.132877],
              [73.975401, 17.129827],
              [73.981982, 17.12896],
              [73.986848, 17.125853],
              [73.987846, 17.123322],
              [73.987204, 17.117722],
              [74.000033, 17.113605],
              [74.00574, 17.111194],
              [74.010805, 17.107758],
              [74.016574, 17.100135],
              [74.023397, 17.094659],
              [74.031856, 17.091316],
              [74.036521, 17.091094],
              [74.048507, 17.096355],
              [74.048684, 17.100775],
              [74.050866, 17.102927],
              [74.056247, 17.102815],
              [74.066494, 17.100025],
              [74.083228, 17.098797],
              [74.096919, 17.101315],
              [74.099732, 17.105545],
              [74.100851, 17.111005],
              [74.102483, 17.113787],
              [74.107074, 17.118544],
              [74.110988, 17.120772],
              [74.115114, 17.120141],
              [74.130099, 17.115384],
              [74.131486, 17.115808],
              [74.144531, 17.119],
              [74.157918, 17.126794],
              [74.162194, 17.132469],
              [74.169271, 17.13984],
              [74.186163, 17.148762],
              [74.208118, 17.144324],
              [74.219033, 17.139394],
              [74.226205, 17.137816],
              [74.233903, 17.137563],
              [74.248015, 17.139851],
              [74.248172, 17.152591],
              [74.235939, 17.152621],
              [74.23618, 17.157043],
              [74.248738, 17.160172],
              [74.250794, 17.168576],
              [74.257287, 17.168765],
              [74.264524, 17.167928],
              [74.273873, 17.169183],
              [74.27879, 17.172228],
              [74.28328, 17.182621],
              [74.287032, 17.197916],
              [74.285853, 17.202381],
              [74.283356, 17.206539],
              [74.280108, 17.209146],
              [74.275004, 17.211498],
              [74.271927, 17.214618],
              [74.271813, 17.219609],
              [74.274711, 17.226819],
              [74.280107, 17.229863],
              [74.281937, 17.231892],
              [74.289099, 17.236965],
              [74.289651, 17.241503],
              [74.284353, 17.245231],
              [74.276635, 17.246922],
              [74.269956, 17.250926],
              [74.26537, 17.255524],
              [74.264951, 17.260681],
              [74.258527, 17.274726],
              [74.260757, 17.288128],
              [74.256999, 17.293246],
              [74.257505, 17.295437],
              [74.260289, 17.297821],
              [74.261944, 17.30473],
              [74.263716, 17.305951],
              [74.285376, 17.307917],
              [74.289718, 17.309458],
              [74.294424, 17.31548],
              [74.292168, 17.319534],
              [74.289753, 17.327429],
              [74.286322, 17.329678],
              [74.281011, 17.335073],
              [74.27996, 17.337412],
              [74.280878, 17.340925],
              [74.287471, 17.349324],
              [74.288642, 17.351926],
              [74.288004, 17.355247],
              [74.286545, 17.357353],
              [74.283195, 17.358349],
              [74.280147, 17.358199],
              [74.267947, 17.354501],
              [74.26311, 17.353751],
              [74.2597, 17.354287],
              [74.256694, 17.356091],
              [74.255054, 17.35837],
              [74.255365, 17.362622],
              [74.261001, 17.371585],
              [74.261911, 17.37521],
              [74.26074, 17.378119],
              [74.262168, 17.384218],
              [74.268733, 17.390324],
              [74.275847, 17.400051],
              [74.277642, 17.405235],
              [74.280934, 17.410323],
              [74.284832, 17.414152],
              [74.286294, 17.417327],
              [74.298042, 17.421044],
              [74.31315, 17.416932],
              [74.335695, 17.414196],
              [74.347762, 17.416863],
              [74.35364, 17.409034],
              [74.372411, 17.407316],
              [74.392106, 17.405635],
              [74.41189, 17.401662],
              [74.422319, 17.397397],
              [74.437573, 17.388712],
              [74.450583, 17.391393],
              [74.470073, 17.389029],
              [74.477581, 17.388112],
              [74.494592, 17.382906],
              [74.502854, 17.387728],
              [74.513916, 17.392641],
              [74.526781, 17.399889],
              [74.530222, 17.40915],
              [74.534668, 17.416154],
              [74.548617, 17.418852],
              [74.558189, 17.412271],
              [74.571124, 17.417235],
              [74.578816, 17.410592],
              [74.586189, 17.414248],
              [74.589927, 17.414354],
              [74.58967, 17.422364],
              [74.598648, 17.434076],
              [74.605011, 17.439982],
              [74.608682, 17.442376],
              [74.610542, 17.442433],
              [74.61734, 17.434626],
              [74.628031, 17.422345],
              [74.636007, 17.406562],
              [74.635338, 17.398523],
              [74.641878, 17.398714],
              [74.644783, 17.395368],
              [74.659599, 17.400382],
              [74.670988, 17.394994],
              [74.67778, 17.387173],
              [74.689908, 17.386852],
              [74.694655, 17.391433],
              [74.691454, 17.393218],
              [74.689378, 17.396084],
              [74.69206, 17.399482],
              [74.689618, 17.405595],
              [74.690654, 17.41014],
              [74.688998, 17.413917],
              [74.685645, 17.415665],
              [74.684765, 17.420647],
              [74.686288, 17.423536],
              [74.692845, 17.425258],
              [74.698381, 17.427946],
              [74.697285, 17.430403],
              [74.695539, 17.4316],
              [74.695281, 17.433549],
              [74.699548, 17.437144],
              [74.699224, 17.440466],
              [74.697017, 17.446473],
              [74.700048, 17.454939],
              [74.698656, 17.457336],
              [74.697343, 17.46324],
              [74.699006, 17.465204],
              [74.698875, 17.466526],
              [74.697178, 17.468231],
              [74.69584, 17.471428],
              [74.696169, 17.474185],
              [74.688338, 17.481178],
              [74.6898, 17.485036],
              [74.694398, 17.486073],
              [74.700798, 17.484696],
              [74.714564, 17.483728],
              [74.721389, 17.482288],
              [74.725712, 17.48009],
              [74.729567, 17.476449],
              [74.734837, 17.47494],
              [74.742071, 17.475289],
              [74.755706, 17.474029],
              [74.765793, 17.469631],
              [74.772167, 17.464626],
              [74.786032, 17.457039],
              [74.793649, 17.453947],
              [74.801618, 17.452165],
              [74.810223, 17.451835],
              [74.817467, 17.457692],
              [74.819196, 17.464883],
              [74.820983, 17.466162],
              [74.824095, 17.465672],
              [74.825918, 17.469301],
              [74.82995, 17.47399],
              [74.837328, 17.485134],
              [74.839582, 17.487509],
              [74.849503, 17.494476],
              [74.851028, 17.498685],
              [74.851479, 17.50265],
              [74.861305, 17.506404],
              [74.863425, 17.510613],
              [74.862011, 17.515835],
              [74.864651, 17.530627],
              [74.860024, 17.541158],
              [74.858702, 17.555979],
              [74.862451, 17.558534],
              [74.871574, 17.562281],
              [74.879181, 17.568483],
              [74.882487, 17.573788],
              [74.88152, 17.591056],
              [74.879736, 17.596956],
              [74.880445, 17.598559],
              [74.882923, 17.603283],
              [74.888029, 17.607439],
              [74.889621, 17.610652],
              [74.898117, 17.618786],
              [74.901426, 17.623677],
              [74.905534, 17.626518],
              [74.911258, 17.628811],
              [74.910041, 17.623746],
              [74.910077, 17.619621],
              [74.912716, 17.618152],
              [74.916189, 17.617605],
              [74.918036, 17.618308],
              [74.921159, 17.617119],
              [74.92758, 17.616878],
              [74.922111, 17.609902],
              [74.918602, 17.598187],
              [74.918214, 17.594855],
              [74.918885, 17.592459],
              [74.917954, 17.581389],
              [74.920989, 17.576025],
              [74.925606, 17.574973],
              [74.945369, 17.586139],
              [74.958526, 17.586534],
              [74.960013, 17.588091],
              [74.960176, 17.590447],
              [74.961309, 17.591086],
              [74.963168, 17.590295],
              [74.965353, 17.586173],
              [74.96556, 17.582734],
              [74.965175, 17.577105],
              [74.96251, 17.566064],
              [74.963547, 17.563545],
              [74.96607, 17.561558],
              [74.96806, 17.55859],
              [74.975882, 17.552903],
              [74.988819, 17.541592],
              [74.976395, 17.531075],
              [74.96331, 17.522251],
              [74.948559, 17.519756],
              [74.944026, 17.517987],
              [74.941825, 17.516012],
              [74.940961, 17.512623],
              [74.941868, 17.510446],
              [74.945132, 17.506121],
              [74.948609, 17.504499],
              [74.950292, 17.502857],
              [74.950503, 17.499364],
              [74.954224, 17.497286],
              [74.957997, 17.496204],
              [74.964909, 17.491005],
              [74.970601, 17.481164],
              [74.971447, 17.472036],
              [74.973921, 17.468213],
              [74.977284, 17.465971],
              [74.980529, 17.464412],
              [74.984581, 17.465659],
              [74.993131, 17.473971],
              [75.000025, 17.4794],
              [75.014363, 17.487601],
              [75.027633, 17.493734],
              [75.032287, 17.494277],
              [75.036018, 17.491033],
              [75.039788, 17.482391],
              [75.040937, 17.473847],
              [75.039313, 17.460851],
              [75.036751, 17.452166],
              [75.03245, 17.445361],
              [75.032449, 17.438695],
              [75.034242, 17.430613],
              [75.034331, 17.419816],
              [75.030217, 17.411976],
              [75.024156, 17.408433],
              [75.015141, 17.408764],
              [75.006527, 17.41048],
              [75.000031, 17.406834],
              [74.998607, 17.404062],
              [74.997649, 17.391586],
              [74.999963, 17.387652],
              [75.003157, 17.384625],
              [75.007246, 17.367942],
              [75.000021, 17.361997],
              [74.987224, 17.355656],
              [74.975568, 17.347958],
              [74.971419, 17.344431],
              [74.968868, 17.340606],
              [74.967107, 17.336285],
              [74.969484, 17.329883],
              [74.97112, 17.327588],
              [74.970444, 17.320735],
              [74.961869, 17.293376],
              [74.958432, 17.290075],
              [74.952842, 17.287332],
              [74.945684, 17.285906],
              [74.940791, 17.285698],
              [74.938906, 17.281218],
              [74.938592, 17.276114],
              [74.937535, 17.27314],
              [74.913939, 17.275181],
              [74.909355, 17.27419],
              [74.906098, 17.270292],
              [74.901877, 17.260914],
              [74.900092, 17.252176],
              [74.899741, 17.242324],
              [74.896775, 17.24087],
              [74.896442, 17.236849],
              [74.895622, 17.235801],
              [74.893411, 17.235905],
              [74.886151, 17.231968],
              [74.887284, 17.224371],
              [74.886167, 17.222401],
              [74.883919, 17.220358],
              [74.87854, 17.221453],
              [74.876222, 17.220561],
              [74.876185, 17.217846],
              [74.878614, 17.21188],
              [74.868018, 17.215928],
              [74.859011, 17.214747],
              [74.850869, 17.210887],
              [74.851854, 17.2078],
              [74.854881, 17.209139],
              [74.860671, 17.209303],
              [74.860267, 17.20723],
              [74.858313, 17.205547],
              [74.858977, 17.204747],
              [74.866344, 17.208606],
              [74.872378, 17.208259],
              [74.871711, 17.201408],
              [74.866748, 17.202743],
              [74.867312, 17.199296],
              [74.866566, 17.195156],
              [74.871221, 17.196225],
              [74.872162, 17.19014],
              [74.877043, 17.191385],
              [74.881726, 17.187168],
              [74.888419, 17.194633],
              [74.895279, 17.194343],
              [74.897496, 17.193552],
              [74.896678, 17.190039],
              [74.890718, 17.189538],
              [74.889179, 17.188722],
              [74.888952, 17.187226],
              [74.893435, 17.185189],
              [74.892682, 17.182999],
              [74.889998, 17.182347],
              [74.888171, 17.179572],
              [74.893196, 17.177948],
              [74.896199, 17.17539],
              [74.900742, 17.182199],
              [74.900844, 17.176632],
              [74.903788, 17.174301],
              [74.905326, 17.17551],
              [74.90707, 17.173863],
              [74.906561, 17.170301],
              [74.907299, 17.167149],
              [74.905228, 17.164263],
              [74.909074, 17.160729],
              [74.911947, 17.159375],
              [74.914453, 17.160888],
              [74.919099, 17.161736],
              [74.923144, 17.154711],
              [74.9265, 17.145436],
              [74.925784, 17.136704],
              [74.918379, 17.130454],
              [74.914685, 17.129854],
              [74.902966, 17.13287],
              [74.894708, 17.128457],
              [74.896519, 17.125713],
              [74.896957, 17.122617],
              [74.895064, 17.12129],
              [74.896801, 17.119413],
              [74.904814, 17.117804],
              [74.917542, 17.113885],
              [74.917471, 17.116346],
              [74.914363, 17.117066],
              [74.912604, 17.120664],
              [74.914669, 17.12343],
              [74.922089, 17.128417],
              [74.929653, 17.130485],
              [74.935327, 17.12858],
              [74.940939, 17.127879],
              [74.956709, 17.126072],
              [74.966546, 17.126225],
              [74.970087, 17.131783],
              [74.970184, 17.134893],
              [74.967482, 17.137568],
              [74.963578, 17.148851],
              [74.96013, 17.164209],
              [74.957336, 17.170627],
              [74.957376, 17.172792],
              [74.958968, 17.175534],
              [74.959233, 17.179598],
              [74.961478, 17.184112],
              [74.964018, 17.186792],
              [74.963517, 17.190717],
              [74.96552, 17.193856],
              [74.971354, 17.19551],
              [74.975966, 17.194109],
              [74.982168, 17.194196],
              [74.988606, 17.203879],
              [74.991939, 17.206386],
              [74.998122, 17.20888],
              [75.000005, 17.208786],
              [75.007945, 17.208303],
              [75.017264, 17.225033],
              [75.026459, 17.223328],
              [75.05508, 17.224624],
              [75.065583, 17.222858],
              [75.079551, 17.221759],
              [75.074859, 17.234293],
              [75.077234, 17.236145],
              [75.075424, 17.23815],
              [75.080419, 17.247714],
              [75.087708, 17.246732],
              [75.088346, 17.248979],
              [75.093472, 17.248724],
              [75.094147, 17.247062],
              [75.097777, 17.247719],
              [75.09918, 17.243193],
              [75.118466, 17.241314],
              [75.126798, 17.242868],
              [75.13206, 17.24066],
              [75.138191, 17.242194],
              [75.161523, 17.240628],
              [75.175252, 17.238994],
              [75.179991, 17.236394],
              [75.181095, 17.240412],
              [75.185649, 17.24561],
              [75.191005, 17.254949],
              [75.191761, 17.266494],
              [75.204026, 17.268815],
              [75.205743, 17.262333],
              [75.211179, 17.261797],
              [75.217821, 17.259657],
              [75.225177, 17.255627],
              [75.236212, 17.255979],
              [75.247966, 17.254964],
              [75.240372, 17.241252],
              [75.238625, 17.235556],
              [75.240004, 17.226087],
              [75.239415, 17.216154],
              [75.234486, 17.212509],
              [75.228476, 17.211609],
              [75.218076, 17.206034],
              [75.213893, 17.199168],
              [75.219743, 17.189331],
              [75.225034, 17.183217],
              [75.232805, 17.180343],
              [75.246883, 17.178875],
              [75.265104, 17.183352],
              [75.269334, 17.183207],
              [75.266678, 17.179117],
              [75.269665, 17.178843],
              [75.270524, 17.148538],
              [75.296111, 17.146099],
              [75.298556, 17.155245],
              [75.305249, 17.170789],
              [75.297006, 17.182113],
              [75.289699, 17.187176],
              [75.284533, 17.192546],
              [75.283102, 17.202175],
              [75.284782, 17.209079],
              [75.288855, 17.215195],
              [75.296237, 17.217071],
              [75.311548, 17.218999],
              [75.330996, 17.218702],
              [75.333911, 17.232489],
              [75.341892, 17.233283],
              [75.355655, 17.236172],
              [75.361798, 17.235524],
              [75.369864, 17.214777],
              [75.370693, 17.206],
              [75.367382, 17.190877],
              [75.386049, 17.190871],
              [75.394773, 17.188103],
              [75.406074, 17.183279],
              [75.408646, 17.190587],
              [75.405312, 17.200673],
              [75.40334, 17.211057],
              [75.407576, 17.220153],
              [75.409671, 17.228431],
              [75.410302, 17.233719],
              [75.409722, 17.240144],
              [75.415555, 17.252924],
              [75.422168, 17.264839],
              [75.43068, 17.267466],
              [75.435585, 17.264278],
              [75.44057, 17.258846],
              [75.447394, 17.255606],
              [75.467218, 17.251341],
              [75.468062, 17.250261],
              [75.466061, 17.245249],
              [75.46334, 17.240987],
              [75.463831, 17.23893],
              [75.505696, 17.238674],
              [75.515232, 17.239289],
              [75.521261, 17.249991],
              [75.528016, 17.259097],
              [75.539898, 17.269142],
              [75.547357, 17.27768],
              [75.556929, 17.284782],
              [75.563958, 17.288033],
              [75.572239, 17.289845],
              [75.580931, 17.293212],
              [75.589661, 17.301457],
              [75.60438, 17.304683],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 499,
        censuscode: 531,
        dt_cen_cd: 35,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Sangli",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [74.710008, 18.029332],
              [74.693422, 18.021131],
              [74.679602, 18.013276],
              [74.664742, 18.000612],
              [74.665838, 17.995627],
              [74.667185, 17.991684],
              [74.668104, 17.975301],
              [74.662769, 17.954219],
              [74.659162, 17.942468],
              [74.658078, 17.929602],
              [74.65544, 17.922807],
              [74.652481, 17.918357],
              [74.639172, 17.906466],
              [74.634911, 17.900398],
              [74.633272, 17.895846],
              [74.63333, 17.89005],
              [74.635818, 17.873996],
              [74.635056, 17.872325],
              [74.624542, 17.862181],
              [74.620418, 17.860827],
              [74.616664, 17.858493],
              [74.614569, 17.85824],
              [74.612252, 17.8565],
              [74.6087, 17.846484],
              [74.610819, 17.843297],
              [74.619437, 17.844069],
              [74.618577, 17.840906],
              [74.615189, 17.836965],
              [74.618638, 17.833668],
              [74.625744, 17.830577],
              [74.628955, 17.83193],
              [74.629972, 17.838716],
              [74.637556, 17.828287],
              [74.642341, 17.829078],
              [74.642144, 17.831141],
              [74.639534, 17.835076],
              [74.645447, 17.836454],
              [74.648714, 17.839241],
              [74.647732, 17.842156],
              [74.64882, 17.847679],
              [74.65475, 17.860886],
              [74.657555, 17.862174],
              [74.660978, 17.861234],
              [74.664659, 17.85805],
              [74.678811, 17.849975],
              [74.679421, 17.836084],
              [74.681128, 17.83306],
              [74.683961, 17.830275],
              [74.685494, 17.826735],
              [74.684452, 17.822131],
              [74.686227, 17.817844],
              [74.68524, 17.81484],
              [74.687641, 17.813657],
              [74.685341, 17.809963],
              [74.686314, 17.80791],
              [74.689992, 17.806159],
              [74.695962, 17.807711],
              [74.69529, 17.802595],
              [74.701259, 17.805066],
              [74.701395, 17.802705],
              [74.69879, 17.79987],
              [74.698326, 17.797857],
              [74.701997, 17.795479],
              [74.6958, 17.792491],
              [74.695808, 17.791116],
              [74.696839, 17.790268],
              [74.69959, 17.79023],
              [74.705922, 17.792361],
              [74.706172, 17.790923],
              [74.701403, 17.788072],
              [74.700706, 17.786626],
              [74.702148, 17.785605],
              [74.707178, 17.785772],
              [74.711147, 17.783914],
              [74.710437, 17.789245],
              [74.713056, 17.791109],
              [74.713903, 17.783243],
              [74.716701, 17.78517],
              [74.725826, 17.788925],
              [74.73163, 17.790359],
              [74.745463, 17.797264],
              [74.747795, 17.797516],
              [74.7459, 17.794451],
              [74.74056, 17.789581],
              [74.740337, 17.787689],
              [74.746202, 17.787621],
              [74.749747, 17.786852],
              [74.755291, 17.782426],
              [74.756328, 17.779855],
              [74.750816, 17.766822],
              [74.750916, 17.768487],
              [74.744018, 17.770146],
              [74.744179, 17.765035],
              [74.74713, 17.763053],
              [74.753632, 17.759675],
              [74.758228, 17.76126],
              [74.761965, 17.75837],
              [74.764594, 17.758794],
              [74.766253, 17.760874],
              [74.767754, 17.76738],
              [74.778019, 17.770922],
              [74.779943, 17.770594],
              [74.78894, 17.761889],
              [74.795009, 17.759243],
              [74.800848, 17.755162],
              [74.81953, 17.747004],
              [74.824427, 17.741701],
              [74.833991, 17.728749],
              [74.840424, 17.725136],
              [74.845673, 17.727593],
              [74.852639, 17.725298],
              [74.857418, 17.72654],
              [74.863099, 17.726826],
              [74.873283, 17.725935],
              [74.874862, 17.723013],
              [74.874288, 17.719736],
              [74.86944, 17.704466],
              [74.86642, 17.700192],
              [74.866578, 17.695595],
              [74.877484, 17.67844],
              [74.885124, 17.681259],
              [74.888822, 17.675007],
              [74.890078, 17.659532],
              [74.894616, 17.653102],
              [74.899611, 17.650023],
              [74.905534, 17.626518],
              [74.901426, 17.623677],
              [74.898117, 17.618786],
              [74.889621, 17.610652],
              [74.888029, 17.607439],
              [74.882923, 17.603283],
              [74.880445, 17.598559],
              [74.879736, 17.596956],
              [74.88152, 17.591056],
              [74.882487, 17.573788],
              [74.879181, 17.568483],
              [74.871574, 17.562281],
              [74.862451, 17.558534],
              [74.858702, 17.555979],
              [74.860024, 17.541158],
              [74.864651, 17.530627],
              [74.862011, 17.515835],
              [74.863425, 17.510613],
              [74.861305, 17.506404],
              [74.851479, 17.50265],
              [74.851028, 17.498685],
              [74.849503, 17.494476],
              [74.839582, 17.487509],
              [74.837328, 17.485134],
              [74.82995, 17.47399],
              [74.825918, 17.469301],
              [74.824095, 17.465672],
              [74.820983, 17.466162],
              [74.819196, 17.464883],
              [74.817467, 17.457692],
              [74.810223, 17.451835],
              [74.801618, 17.452165],
              [74.793649, 17.453947],
              [74.786032, 17.457039],
              [74.772167, 17.464626],
              [74.765793, 17.469631],
              [74.755706, 17.474029],
              [74.742071, 17.475289],
              [74.734837, 17.47494],
              [74.729567, 17.476449],
              [74.725712, 17.48009],
              [74.721389, 17.482288],
              [74.714564, 17.483728],
              [74.700798, 17.484696],
              [74.694398, 17.486073],
              [74.6898, 17.485036],
              [74.688338, 17.481178],
              [74.696169, 17.474185],
              [74.69584, 17.471428],
              [74.697178, 17.468231],
              [74.698875, 17.466526],
              [74.699006, 17.465204],
              [74.697343, 17.46324],
              [74.698656, 17.457336],
              [74.700048, 17.454939],
              [74.697017, 17.446473],
              [74.699224, 17.440466],
              [74.699548, 17.437144],
              [74.695281, 17.433549],
              [74.695539, 17.4316],
              [74.697285, 17.430403],
              [74.698381, 17.427946],
              [74.692845, 17.425258],
              [74.686288, 17.423536],
              [74.684765, 17.420647],
              [74.685645, 17.415665],
              [74.688998, 17.413917],
              [74.690654, 17.41014],
              [74.689618, 17.405595],
              [74.69206, 17.399482],
              [74.689378, 17.396084],
              [74.691454, 17.393218],
              [74.694655, 17.391433],
              [74.689908, 17.386852],
              [74.67778, 17.387173],
              [74.670988, 17.394994],
              [74.659599, 17.400382],
              [74.644783, 17.395368],
              [74.641878, 17.398714],
              [74.635338, 17.398523],
              [74.636007, 17.406562],
              [74.628031, 17.422345],
              [74.61734, 17.434626],
              [74.610542, 17.442433],
              [74.608682, 17.442376],
              [74.605011, 17.439982],
              [74.598648, 17.434076],
              [74.58967, 17.422364],
              [74.589927, 17.414354],
              [74.586189, 17.414248],
              [74.578816, 17.410592],
              [74.571124, 17.417235],
              [74.558189, 17.412271],
              [74.548617, 17.418852],
              [74.534668, 17.416154],
              [74.530222, 17.40915],
              [74.526781, 17.399889],
              [74.513916, 17.392641],
              [74.502854, 17.387728],
              [74.494592, 17.382906],
              [74.477581, 17.388112],
              [74.470073, 17.389029],
              [74.450583, 17.391393],
              [74.437573, 17.388712],
              [74.422319, 17.397397],
              [74.41189, 17.401662],
              [74.392106, 17.405635],
              [74.372411, 17.407316],
              [74.35364, 17.409034],
              [74.347762, 17.416863],
              [74.335695, 17.414196],
              [74.31315, 17.416932],
              [74.298042, 17.421044],
              [74.286294, 17.417327],
              [74.284832, 17.414152],
              [74.280934, 17.410323],
              [74.277642, 17.405235],
              [74.275847, 17.400051],
              [74.268733, 17.390324],
              [74.262168, 17.384218],
              [74.26074, 17.378119],
              [74.261911, 17.37521],
              [74.261001, 17.371585],
              [74.255365, 17.362622],
              [74.255054, 17.35837],
              [74.256694, 17.356091],
              [74.2597, 17.354287],
              [74.26311, 17.353751],
              [74.267947, 17.354501],
              [74.280147, 17.358199],
              [74.283195, 17.358349],
              [74.286545, 17.357353],
              [74.288004, 17.355247],
              [74.288642, 17.351926],
              [74.287471, 17.349324],
              [74.280878, 17.340925],
              [74.27996, 17.337412],
              [74.281011, 17.335073],
              [74.286322, 17.329678],
              [74.289753, 17.327429],
              [74.292168, 17.319534],
              [74.294424, 17.31548],
              [74.289718, 17.309458],
              [74.285376, 17.307917],
              [74.263716, 17.305951],
              [74.261944, 17.30473],
              [74.260289, 17.297821],
              [74.257505, 17.295437],
              [74.256999, 17.293246],
              [74.260757, 17.288128],
              [74.258527, 17.274726],
              [74.264951, 17.260681],
              [74.26537, 17.255524],
              [74.269956, 17.250926],
              [74.276635, 17.246922],
              [74.284353, 17.245231],
              [74.289651, 17.241503],
              [74.289099, 17.236965],
              [74.281937, 17.231892],
              [74.280107, 17.229863],
              [74.274711, 17.226819],
              [74.271813, 17.219609],
              [74.271927, 17.214618],
              [74.275004, 17.211498],
              [74.280108, 17.209146],
              [74.283356, 17.206539],
              [74.285853, 17.202381],
              [74.287032, 17.197916],
              [74.28328, 17.182621],
              [74.27879, 17.172228],
              [74.273873, 17.169183],
              [74.264524, 17.167928],
              [74.257287, 17.168765],
              [74.250794, 17.168576],
              [74.248738, 17.160172],
              [74.23618, 17.157043],
              [74.235939, 17.152621],
              [74.248172, 17.152591],
              [74.248015, 17.139851],
              [74.233903, 17.137563],
              [74.226205, 17.137816],
              [74.219033, 17.139394],
              [74.208118, 17.144324],
              [74.186163, 17.148762],
              [74.169271, 17.13984],
              [74.162194, 17.132469],
              [74.157918, 17.126794],
              [74.144531, 17.119],
              [74.131486, 17.115808],
              [74.130099, 17.115384],
              [74.115114, 17.120141],
              [74.110988, 17.120772],
              [74.107074, 17.118544],
              [74.102483, 17.113787],
              [74.100851, 17.111005],
              [74.099732, 17.105545],
              [74.096919, 17.101315],
              [74.083228, 17.098797],
              [74.066494, 17.100025],
              [74.056247, 17.102815],
              [74.050866, 17.102927],
              [74.048684, 17.100775],
              [74.048507, 17.096355],
              [74.036521, 17.091094],
              [74.031856, 17.091316],
              [74.023397, 17.094659],
              [74.016574, 17.100135],
              [74.010805, 17.107758],
              [74.00574, 17.111194],
              [74.000033, 17.113605],
              [73.987204, 17.117722],
              [73.987846, 17.123322],
              [73.986848, 17.125853],
              [73.981982, 17.12896],
              [73.975401, 17.129827],
              [73.942804, 17.132877],
              [73.935222, 17.135346],
              [73.925808, 17.139565],
              [73.920853, 17.143976],
              [73.908619, 17.152129],
              [73.905579, 17.155582],
              [73.901623, 17.156675],
              [73.89728, 17.154838],
              [73.887065, 17.15441],
              [73.884774, 17.156034],
              [73.88346, 17.168877],
              [73.881432, 17.172459],
              [73.875471, 17.179784],
              [73.872168, 17.189208],
              [73.861612, 17.195369],
              [73.852907, 17.197827],
              [73.84418, 17.21378],
              [73.832863, 17.226756],
              [73.828174, 17.22876],
              [73.819768, 17.230471],
              [73.815093, 17.231275],
              [73.807129, 17.231387],
              [73.800461, 17.241908],
              [73.771519, 17.247859],
              [73.767653, 17.250384],
              [73.764252, 17.253721],
              [73.756436, 17.263937],
              [73.754872, 17.268103],
              [73.749471, 17.272503],
              [73.742833, 17.275394],
              [73.737608, 17.275769],
              [73.731867, 17.273794],
              [73.726814, 17.269015],
              [73.723984, 17.264436],
              [73.718249, 17.258958],
              [73.712143, 17.259383],
              [73.703106, 17.262008],
              [73.698616, 17.261771],
              [73.696164, 17.262559],
              [73.695365, 17.262816],
              [73.692482, 17.265642],
              [73.687607, 17.280945],
              [73.687545, 17.282436],
              [73.689912, 17.285221],
              [73.688634, 17.288641],
              [73.686571, 17.291597],
              [73.685121, 17.292377],
              [73.677823, 17.293192],
              [73.677367, 17.295193],
              [73.680382, 17.297078],
              [73.685622, 17.30794],
              [73.686453, 17.313701],
              [73.683995, 17.321529],
              [73.680634, 17.32664],
              [73.682706, 17.335341],
              [73.683756, 17.337996],
              [73.687043, 17.345097],
              [73.687041, 17.348371],
              [73.683835, 17.35515],
              [73.682135, 17.363391],
              [73.673786, 17.370842],
              [73.670104, 17.37308],
              [73.664079, 17.3797],
              [73.661265, 17.3761],
              [73.658188, 17.377658],
              [73.654336, 17.382943],
              [73.649139, 17.381712],
              [73.646609, 17.383401],
              [73.64449, 17.388471],
              [73.64439, 17.391171],
              [73.646389, 17.39378],
              [73.648111, 17.394668],
              [73.649496, 17.394178],
              [73.652038, 17.38859],
              [73.653494, 17.387003],
              [73.656471, 17.38831],
              [73.660226, 17.393531],
              [73.662013, 17.393844],
              [73.667311, 17.392375],
              [73.669504, 17.393499],
              [73.673776, 17.404354],
              [73.67881, 17.411952],
              [73.683405, 17.416955],
              [73.688083, 17.420586],
              [73.692563, 17.421519],
              [73.697724, 17.420902],
              [73.70334, 17.421854],
              [73.705065, 17.423197],
              [73.708018, 17.433454],
              [73.705482, 17.439099],
              [73.707058, 17.441307],
              [73.70664, 17.449511],
              [73.703986, 17.450555],
              [73.701736, 17.452931],
              [73.702519, 17.456223],
              [73.707651, 17.465593],
              [73.702303, 17.474069],
              [73.699453, 17.476092],
              [73.698271, 17.479172],
              [73.699188, 17.481993],
              [73.695043, 17.48641],
              [73.696276, 17.488149],
              [73.704793, 17.491265],
              [73.707762, 17.493203],
              [73.708181, 17.496824],
              [73.706044, 17.503564],
              [73.706349, 17.506554],
              [73.717195, 17.51757],
              [73.72415, 17.52031],
              [73.724901, 17.521931],
              [73.729754, 17.522003],
              [73.733717, 17.524125],
              [73.741634, 17.531478],
              [73.747102, 17.548886],
              [73.746803, 17.556118],
              [73.742178, 17.560418],
              [73.719121, 17.571899],
              [73.716645, 17.573751],
              [73.717439, 17.577033],
              [73.722539, 17.584633],
              [73.72935, 17.59076],
              [73.724662, 17.59557],
              [73.724482, 17.599753],
              [73.723251, 17.601923],
              [73.71784, 17.60494],
              [73.716068, 17.606867],
              [73.71717, 17.609177],
              [73.724181, 17.614215],
              [73.725406, 17.616706],
              [73.724756, 17.619624],
              [73.723089, 17.621549],
              [73.720107, 17.623051],
              [73.715549, 17.624014],
              [73.701453, 17.624953],
              [73.696904, 17.62454],
              [73.692203, 17.627228],
              [73.692291, 17.628775],
              [73.693272, 17.634133],
              [73.695254, 17.636742],
              [73.700227, 17.64038],
              [73.701077, 17.643373],
              [73.699502, 17.646735],
              [73.698119, 17.648033],
              [73.698283, 17.651593],
              [73.701746, 17.655212],
              [73.703221, 17.657985],
              [73.70188, 17.660039],
              [73.698628, 17.660789],
              [73.696645, 17.661733],
              [73.697766, 17.663127],
              [73.695742, 17.666774],
              [73.693558, 17.668634],
              [73.692047, 17.674064],
              [73.681439, 17.677519],
              [73.681568, 17.680683],
              [73.690446, 17.685288],
              [73.68885, 17.687445],
              [73.681704, 17.687629],
              [73.674486, 17.689008],
              [73.669217, 17.691857],
              [73.66714, 17.69464],
              [73.665084, 17.695524],
              [73.662834, 17.693826],
              [73.65938, 17.695502],
              [73.656692, 17.698552],
              [73.654639, 17.702941],
              [73.653729, 17.706836],
              [73.63932, 17.700298],
              [73.635252, 17.699489],
              [73.628775, 17.702957],
              [73.619149, 17.711932],
              [73.614875, 17.712606],
              [73.610473, 17.709785],
              [73.6032, 17.703248],
              [73.593841, 17.699482],
              [73.591593, 17.701282],
              [73.587543, 17.702655],
              [73.58535, 17.704806],
              [73.580742, 17.707432],
              [73.579807, 17.709828],
              [73.580766, 17.713518],
              [73.569859, 17.719141],
              [73.566336, 17.721894],
              [73.572644, 17.728829],
              [73.572884, 17.73635],
              [73.57706, 17.744629],
              [73.581874, 17.751587],
              [73.582528, 17.755387],
              [73.588791, 17.764789],
              [73.591142, 17.775157],
              [73.590788, 17.778367],
              [73.589118, 17.781035],
              [73.584447, 17.783722],
              [73.583371, 17.787324],
              [73.586227, 17.78868],
              [73.595736, 17.79061],
              [73.599491, 17.79233],
              [73.602513, 17.794734],
              [73.597375, 17.799993],
              [73.595562, 17.803698],
              [73.595042, 17.817576],
              [73.591529, 17.818897],
              [73.588055, 17.821261],
              [73.583128, 17.826807],
              [73.582772, 17.82944],
              [73.583531, 17.832779],
              [73.585917, 17.837578],
              [73.587952, 17.839797],
              [73.593864, 17.843843],
              [73.596401, 17.847735],
              [73.591941, 17.848866],
              [73.582514, 17.853833],
              [73.576936, 17.858279],
              [73.575763, 17.865206],
              [73.576979, 17.873199],
              [73.576066, 17.876636],
              [73.574669, 17.877354],
              [73.570103, 17.876769],
              [73.567199, 17.879642],
              [73.561436, 17.887474],
              [73.560612, 17.891429],
              [73.557602, 17.892817],
              [73.538403, 17.88884],
              [73.534779, 17.893726],
              [73.536162, 17.896899],
              [73.538397, 17.899809],
              [73.546745, 17.903669],
              [73.55258, 17.907613],
              [73.555, 17.910459],
              [73.574755, 17.927816],
              [73.575792, 17.930245],
              [73.575875, 17.943331],
              [73.583918, 17.944315],
              [73.586673, 17.93799],
              [73.594654, 17.935528],
              [73.597221, 17.936833],
              [73.604007, 17.940782],
              [73.614428, 17.949787],
              [73.617321, 17.954936],
              [73.635859, 17.968315],
              [73.636262, 17.975268],
              [73.634962, 17.978887],
              [73.626014, 17.984575],
              [73.642663, 17.995962],
              [73.644297, 18.000562],
              [73.651472, 18.006983],
              [73.65614, 18.013079],
              [73.650228, 18.022385],
              [73.658617, 18.028417],
              [73.664522, 18.026841],
              [73.683979, 18.038025],
              [73.705605, 18.048152],
              [73.713478, 18.043738],
              [73.725297, 18.044485],
              [73.732988, 18.040255],
              [73.750231, 18.039082],
              [73.759621, 18.037331],
              [73.759403, 18.035721],
              [73.758114, 18.034042],
              [73.758514, 18.031412],
              [73.762021, 18.026365],
              [73.766602, 18.024887],
              [73.776407, 18.026976],
              [73.788105, 18.023885],
              [73.791668, 18.022109],
              [73.796383, 18.023491],
              [73.800902, 18.026196],
              [73.81322, 18.03588],
              [73.820002, 18.035339],
              [73.828994, 18.031734],
              [73.839602, 18.031351],
              [73.845004, 18.034561],
              [73.846989, 18.040931],
              [73.850884, 18.037484],
              [73.854316, 18.032955],
              [73.857693, 18.031563],
              [73.860717, 18.033602],
              [73.86156, 18.036468],
              [73.86481, 18.039246],
              [73.866738, 18.042136],
              [73.866029, 18.044639],
              [73.867, 18.047971],
              [73.871489, 18.04866],
              [73.873349, 18.052527],
              [73.870829, 18.069585],
              [73.871021, 18.07327],
              [73.876074, 18.080995],
              [73.880466, 18.084571],
              [73.879815, 18.088705],
              [73.871264, 18.103411],
              [73.86324, 18.113969],
              [73.862187, 18.119805],
              [73.877606, 18.116414],
              [73.890645, 18.115792],
              [73.893248, 18.118011],
              [73.89445, 18.121981],
              [73.896268, 18.124642],
              [73.899903, 18.126807],
              [73.902754, 18.13241],
              [73.903658, 18.136086],
              [73.897129, 18.139209],
              [73.891904, 18.150711],
              [73.883271, 18.157648],
              [73.87989, 18.162585],
              [73.87642, 18.165636],
              [73.874135, 18.169439],
              [73.873837, 18.172932],
              [73.875548, 18.175479],
              [73.877565, 18.176251],
              [73.88313, 18.174317],
              [73.887476, 18.176502],
              [73.890552, 18.179004],
              [73.893853, 18.183236],
              [73.897466, 18.182425],
              [73.89869, 18.169775],
              [73.901218, 18.165109],
              [73.902435, 18.160539],
              [73.904546, 18.159929],
              [73.911177, 18.165345],
              [73.920298, 18.169913],
              [73.932911, 18.173315],
              [73.937711, 18.172888],
              [73.943793, 18.179457],
              [73.945814, 18.180515],
              [73.953279, 18.174751],
              [73.956997, 18.170905],
              [73.969145, 18.163439],
              [73.973048, 18.158547],
              [73.978424, 18.154743],
              [73.990011, 18.149396],
              [73.994999, 18.149861],
              [74.000032, 18.154194],
              [74.001629, 18.156273],
              [74.003672, 18.156466],
              [74.006361, 18.152939],
              [74.009522, 18.145968],
              [74.023989, 18.137347],
              [74.027824, 18.133598],
              [74.03175, 18.13169],
              [74.0359, 18.130996],
              [74.043918, 18.132807],
              [74.051942, 18.138125],
              [74.061474, 18.137216],
              [74.065994, 18.134852],
              [74.068373, 18.13183],
              [74.070282, 18.12726],
              [74.073804, 18.123566],
              [74.077432, 18.12131],
              [74.083692, 18.120057],
              [74.097618, 18.120503],
              [74.102232, 18.122101],
              [74.109027, 18.127229],
              [74.11771, 18.130313],
              [74.123432, 18.129048],
              [74.134281, 18.11694],
              [74.147645, 18.118634],
              [74.151221, 18.116944],
              [74.157554, 18.109605],
              [74.162807, 18.10645],
              [74.171254, 18.10734],
              [74.183058, 18.110906],
              [74.188661, 18.110799],
              [74.193383, 18.105735],
              [74.20833, 18.098822],
              [74.219553, 18.096525],
              [74.230754, 18.099054],
              [74.237785, 18.098661],
              [74.241342, 18.097096],
              [74.249244, 18.089772],
              [74.257309, 18.084231],
              [74.265209, 18.080577],
              [74.279952, 18.074577],
              [74.293039, 18.073051],
              [74.297763, 18.069479],
              [74.302997, 18.068604],
              [74.306927, 18.071058],
              [74.317356, 18.073349],
              [74.320325, 18.076303],
              [74.325032, 18.084159],
              [74.329248, 18.087987],
              [74.33345, 18.088545],
              [74.346841, 18.094301],
              [74.353252, 18.096031],
              [74.357522, 18.096068],
              [74.362378, 18.087158],
              [74.365533, 18.084833],
              [74.36928, 18.08344],
              [74.376492, 18.073569],
              [74.380073, 18.070504],
              [74.384285, 18.070025],
              [74.388698, 18.07242],
              [74.393974, 18.073508],
              [74.400453, 18.070115],
              [74.410907, 18.070104],
              [74.423627, 18.066316],
              [74.432956, 18.065135],
              [74.440385, 18.061707],
              [74.445672, 18.056755],
              [74.449475, 18.055013],
              [74.454094, 18.050688],
              [74.459839, 18.047815],
              [74.464294, 18.047283],
              [74.472204, 18.048614],
              [74.478914, 18.050802],
              [74.487732, 18.056503],
              [74.493292, 18.058679],
              [74.508727, 18.059501],
              [74.521777, 18.059219],
              [74.527804, 18.057838],
              [74.535269, 18.057326],
              [74.546343, 18.066892],
              [74.551364, 18.069633],
              [74.558706, 18.069464],
              [74.561922, 18.067028],
              [74.566571, 18.06103],
              [74.568683, 18.056171],
              [74.578865, 18.051838],
              [74.582608, 18.046584],
              [74.585231, 18.048616],
              [74.586555, 18.054024],
              [74.590039, 18.055255],
              [74.606048, 18.047176],
              [74.610908, 18.046932],
              [74.617194, 18.04779],
              [74.628782, 18.055403],
              [74.633843, 18.053609],
              [74.63861, 18.044861],
              [74.641104, 18.044535],
              [74.649864, 18.052988],
              [74.654487, 18.058827],
              [74.65435, 18.065374],
              [74.656612, 18.068607],
              [74.66517, 18.068842],
              [74.673162, 18.063391],
              [74.686302, 18.059135],
              [74.689603, 18.043079],
              [74.692582, 18.039089],
              [74.70124, 18.036736],
              [74.707997, 18.030471],
              [74.710008, 18.029332],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 505,
        censuscode: 527,
        dt_cen_cd: 31,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Satara",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [78.341507, 21.588748],
              [78.346779, 21.581116],
              [78.352421, 21.57711],
              [78.359415, 21.575171],
              [78.365726, 21.576558],
              [78.370813, 21.580177],
              [78.378911, 21.588226],
              [78.382407, 21.593853],
              [78.376822, 21.609],
              [78.37646, 21.613255],
              [78.380498, 21.615671],
              [78.384305, 21.616876],
              [78.388348, 21.614874],
              [78.394117, 21.608799],
              [78.397368, 21.608343],
              [78.40387, 21.609326],
              [78.409322, 21.608353],
              [78.415698, 21.604858],
              [78.424109, 21.602571],
              [78.427412, 21.60022],
              [78.420668, 21.586435],
              [78.418333, 21.57604],
              [78.420782, 21.571395],
              [78.423912, 21.569904],
              [78.427098, 21.562034],
              [78.425559, 21.553131],
              [78.425436, 21.547108],
              [78.426785, 21.544184],
              [78.430347, 21.540623],
              [78.432361, 21.536668],
              [78.431686, 21.528568],
              [78.432666, 21.52512],
              [78.437021, 21.51829],
              [78.435117, 21.507557],
              [78.434935, 21.500151],
              [78.432106, 21.497738],
              [78.432842, 21.488374],
              [78.430394, 21.4797],
              [78.431739, 21.475745],
              [78.435777, 21.472646],
              [78.437926, 21.469549],
              [78.439271, 21.460532],
              [78.442574, 21.448533],
              [78.444476, 21.445437],
              [78.441402, 21.442042],
              [78.441222, 21.439635],
              [78.443922, 21.431774],
              [78.443969, 21.421952],
              [78.451079, 21.415354],
              [78.451507, 21.411157],
              [78.450458, 21.406972],
              [78.448685, 21.404555],
              [78.446237, 21.402776],
              [78.43509, 21.400928],
              [78.428896, 21.397992],
              [78.423325, 21.396894],
              [78.421362, 21.395281],
              [78.422403, 21.390981],
              [78.41812, 21.388044],
              [78.41095, 21.387117],
              [78.409422, 21.383675],
              [78.405927, 21.38315],
              [78.401945, 21.383552],
              [78.397418, 21.385156],
              [78.392333, 21.389627],
              [78.389086, 21.389733],
              [78.384067, 21.386345],
              [78.381741, 21.387319],
              [78.379354, 21.39122],
              [78.376416, 21.39403],
              [78.373778, 21.394537],
              [78.367226, 21.391149],
              [78.366983, 21.383568],
              [78.358351, 21.380393],
              [78.354797, 21.379986],
              [78.350753, 21.380791],
              [78.348489, 21.384859],
              [78.344077, 21.376641],
              [78.338756, 21.372563],
              [78.333055, 21.371117],
              [78.330239, 21.368527],
              [78.326325, 21.366452],
              [78.321791, 21.366275],
              [78.317568, 21.363973],
              [78.313278, 21.360637],
              [78.310768, 21.356958],
              [78.286586, 21.349909],
              [78.275997, 21.350807],
              [78.270614, 21.343448],
              [78.252256, 21.33698],
              [78.251274, 21.328596],
              [78.231691, 21.326948],
              [78.22042, 21.33077],
              [78.202056, 21.329755],
              [78.178486, 21.331091],
              [78.15798, 21.329776],
              [78.155404, 21.331488],
              [78.15295, 21.337518],
              [78.150245, 21.341297],
              [78.144425, 21.34077],
              [78.139036, 21.34323],
              [78.131564, 21.344759],
              [78.124149, 21.347899],
              [78.116762, 21.348527],
              [78.112845, 21.349725],
              [78.105247, 21.354758],
              [78.100347, 21.353589],
              [78.096669, 21.353697],
              [78.090174, 21.356668],
              [78.081907, 21.35578],
              [78.07512, 21.353292],
              [78.074388, 21.350816],
              [78.076109, 21.347831],
              [78.078023, 21.340666],
              [78.079764, 21.328034],
              [78.075631, 21.313712],
              [78.070875, 21.305488],
              [78.068061, 21.302671],
              [78.068007, 21.298821],
              [78.072054, 21.294527],
              [78.075977, 21.292468],
              [78.079102, 21.289777],
              [78.08125, 21.286915],
              [78.082486, 21.282612],
              [78.081697, 21.277787],
              [78.078829, 21.274849],
              [78.075771, 21.273977],
              [78.06634, 21.277339],
              [78.061197, 21.274223],
              [78.05884, 21.262038],
              [78.05592, 21.25364],
              [78.055493, 21.249164],
              [78.058638, 21.240217],
              [78.060904, 21.238334],
              [78.068371, 21.238474],
              [78.071745, 21.235322],
              [78.074196, 21.228795],
              [78.071024, 21.224192],
              [78.073842, 21.219563],
              [78.077705, 21.216479],
              [78.087368, 21.211999],
              [78.098762, 21.199217],
              [78.09994, 21.193899],
              [78.099636, 21.187189],
              [78.093344, 21.180924],
              [78.094562, 21.176904],
              [78.098425, 21.175072],
              [78.110011, 21.164484],
              [78.116816, 21.159359],
              [78.119094, 21.156648],
              [78.12644, 21.151711],
              [78.130305, 21.148092],
              [78.134339, 21.146659],
              [78.142853, 21.140406],
              [78.145311, 21.137193],
              [78.144814, 21.135073],
              [78.140173, 21.131328],
              [78.137631, 21.121377],
              [78.133056, 21.11545],
              [78.132206, 21.11298],
              [78.132513, 21.110164],
              [78.134851, 21.105058],
              [78.136927, 21.103511],
              [78.145612, 21.102326],
              [78.147623, 21.099581],
              [78.152235, 21.078337],
              [78.153942, 21.074901],
              [78.153952, 21.071911],
              [78.152777, 21.063348],
              [78.150442, 21.056681],
              [78.15217, 21.047209],
              [78.151231, 21.044396],
              [78.147767, 21.039843],
              [78.142345, 21.03719],
              [78.140301, 21.034948],
              [78.146654, 21.02589],
              [78.147215, 21.022729],
              [78.146053, 21.018936],
              [78.14087, 21.011744],
              [78.139002, 21.007948],
              [78.137575, 21.004094],
              [78.138098, 21.000314],
              [78.139466, 20.999715],
              [78.143324, 20.994854],
              [78.148098, 20.990071],
              [78.149563, 20.985894],
              [78.150452, 20.966065],
              [78.148779, 20.962939],
              [78.146123, 20.952225],
              [78.148651, 20.950577],
              [78.152386, 20.949809],
              [78.167501, 20.943448],
              [78.16955, 20.940998],
              [78.172137, 20.934871],
              [78.172611, 20.931774],
              [78.176327, 20.927838],
              [78.177464, 20.925096],
              [78.178234, 20.922566],
              [78.178722, 20.913441],
              [78.181013, 20.911788],
              [78.182689, 20.90905],
              [78.183043, 20.906235],
              [78.184401, 20.904641],
              [78.19993, 20.899035],
              [78.204687, 20.899479],
              [78.212596, 20.90197],
              [78.215992, 20.908266],
              [78.223178, 20.900451],
              [78.227533, 20.89952],
              [78.233497, 20.896063],
              [78.23778, 20.895591],
              [78.242158, 20.892462],
              [78.247322, 20.889923],
              [78.250252, 20.88949],
              [78.252538, 20.887615],
              [78.255677, 20.886442],
              [78.265243, 20.869453],
              [78.272746, 20.865159],
              [78.275457, 20.858573],
              [78.278994, 20.845273],
              [78.279981, 20.843899],
              [78.281903, 20.842079],
              [78.284237, 20.841179],
              [78.28838, 20.841503],
              [78.291136, 20.840955],
              [78.292246, 20.839702],
              [78.292561, 20.829929],
              [78.293867, 20.827651],
              [78.296684, 20.826987],
              [78.300461, 20.827761],
              [78.302514, 20.829624],
              [78.304238, 20.833079],
              [78.30655, 20.834021],
              [78.309231, 20.834444],
              [78.312625, 20.831723],
              [78.314451, 20.826569],
              [78.317857, 20.823091],
              [78.31819, 20.820965],
              [78.311253, 20.814583],
              [78.304371, 20.813549],
              [78.299758, 20.811208],
              [78.299096, 20.805799],
              [78.295542, 20.802435],
              [78.296641, 20.792846],
              [78.294136, 20.783364],
              [78.293677, 20.781622],
              [78.29428, 20.777947],
              [78.308372, 20.763417],
              [78.310305, 20.758338],
              [78.306877, 20.747259],
              [78.306846, 20.744499],
              [78.307921, 20.742041],
              [78.311198, 20.738505],
              [78.311366, 20.734949],
              [78.30822, 20.72325],
              [78.300708, 20.714859],
              [78.301854, 20.710903],
              [78.299353, 20.700996],
              [78.296606, 20.696835],
              [78.292565, 20.698288],
              [78.289178, 20.700505],
              [78.286823, 20.699103],
              [78.281453, 20.698823],
              [78.279534, 20.696391],
              [78.274891, 20.696747],
              [78.259648, 20.695695],
              [78.257333, 20.691414],
              [78.256755, 20.684517],
              [78.254016, 20.683915],
              [78.236602, 20.68634],
              [78.233691, 20.689651],
              [78.231289, 20.690954],
              [78.226467, 20.691311],
              [78.21338, 20.68935],
              [78.212529, 20.689053],
              [78.211063, 20.680194],
              [78.209045, 20.67649],
              [78.200246, 20.677215],
              [78.193547, 20.676585],
              [78.182863, 20.677223],
              [78.181129, 20.670545],
              [78.173802, 20.671396],
              [78.169609, 20.669975],
              [78.168129, 20.667085],
              [78.158916, 20.667224],
              [78.159023, 20.659132],
              [78.145343, 20.660547],
              [78.136144, 20.659886],
              [78.132241, 20.66433],
              [78.130803, 20.662709],
              [78.125032, 20.660814],
              [78.126601, 20.657605],
              [78.132327, 20.654046],
              [78.131369, 20.648004],
              [78.126413, 20.648989],
              [78.119728, 20.648006],
              [78.112271, 20.648963],
              [78.111902, 20.640167],
              [78.103916, 20.640207],
              [78.101491, 20.643917],
              [78.093298, 20.640962],
              [78.097368, 20.65083],
              [78.098216, 20.659519],
              [78.100302, 20.659021],
              [78.100322, 20.665977],
              [78.095662, 20.667539],
              [78.094961, 20.669775],
              [78.089057, 20.668793],
              [78.089017, 20.672067],
              [78.084912, 20.673064],
              [78.083079, 20.668903],
              [78.081017, 20.668546],
              [78.080213, 20.664688],
              [78.077062, 20.663786],
              [78.077484, 20.667698],
              [78.070895, 20.668326],
              [78.071526, 20.671094],
              [78.06363, 20.672682],
              [78.063258, 20.669395],
              [78.05873, 20.670105],
              [78.058391, 20.668024],
              [78.041688, 20.667519],
              [78.040556, 20.666129],
              [78.03866, 20.666447],
              [78.036444, 20.659478],
              [78.034119, 20.659737],
              [78.028487, 20.656809],
              [78.025559, 20.648856],
              [78.02126, 20.642255],
              [78.025249, 20.636667],
              [78.027358, 20.633816],
              [78.026645, 20.632831],
              [78.022405, 20.631182],
              [78.020315, 20.628172],
              [78.015153, 20.626563],
              [78.000011, 20.62443],
              [77.996081, 20.622844],
              [77.988408, 20.612554],
              [77.982009, 20.607938],
              [77.978904, 20.603337],
              [77.976419, 20.59443],
              [77.973804, 20.590099],
              [77.970605, 20.587354],
              [77.957528, 20.58137],
              [77.95106, 20.575336],
              [77.951348, 20.579961],
              [77.944571, 20.579519],
              [77.943074, 20.576387],
              [77.939395, 20.575286],
              [77.934105, 20.577054],
              [77.931509, 20.573471],
              [77.930658, 20.568727],
              [77.928496, 20.566579],
              [77.926488, 20.561042],
              [77.924327, 20.558545],
              [77.921778, 20.560112],
              [77.922191, 20.564172],
              [77.919335, 20.565236],
              [77.912373, 20.565422],
              [77.917334, 20.577868],
              [77.918482, 20.588158],
              [77.915181, 20.588712],
              [77.918131, 20.59606],
              [77.919082, 20.604524],
              [77.916482, 20.606477],
              [77.909059, 20.608905],
              [77.906894, 20.612223],
              [77.900871, 20.614532],
              [77.893089, 20.623464],
              [77.888249, 20.621685],
              [77.88565, 20.618457],
              [77.882883, 20.616909],
              [77.881373, 20.612084],
              [77.877371, 20.609369],
              [77.873225, 20.609798],
              [77.868666, 20.61155],
              [77.866136, 20.609253],
              [77.864673, 20.598209],
              [77.865793, 20.594872],
              [77.862109, 20.592415],
              [77.854569, 20.589492],
              [77.846682, 20.587654],
              [77.847185, 20.577556],
              [77.848086, 20.576219],
              [77.846803, 20.570388],
              [77.837603, 20.565569],
              [77.827484, 20.573272],
              [77.821398, 20.581043],
              [77.817102, 20.585283],
              [77.81151, 20.587188],
              [77.806968, 20.566802],
              [77.794204, 20.560178],
              [77.789714, 20.55638],
              [77.785599, 20.547533],
              [77.782447, 20.543718],
              [77.771608, 20.539935],
              [77.766037, 20.544653],
              [77.756032, 20.544701],
              [77.750509, 20.547911],
              [77.745296, 20.558186],
              [77.741911, 20.561375],
              [77.735549, 20.559897],
              [77.729832, 20.562705],
              [77.721079, 20.565435],
              [77.711684, 20.567081],
              [77.702843, 20.567407],
              [77.692941, 20.57267],
              [77.690794, 20.578027],
              [77.687387, 20.579724],
              [77.666826, 20.580435],
              [77.662592, 20.571589],
              [77.65975, 20.568222],
              [77.659176, 20.56519],
              [77.655632, 20.564194],
              [77.653073, 20.564183],
              [77.645942, 20.565394],
              [77.638434, 20.565229],
              [77.630762, 20.566791],
              [77.635487, 20.577308],
              [77.640638, 20.586152],
              [77.649567, 20.608558],
              [77.651798, 20.61858],
              [77.652169, 20.625749],
              [77.655728, 20.647172],
              [77.655428, 20.648257],
              [77.652579, 20.650466],
              [77.651144, 20.653691],
              [77.652937, 20.656605],
              [77.652933, 20.662623],
              [77.649753, 20.662419],
              [77.638961, 20.656788],
              [77.637012, 20.657428],
              [77.636305, 20.667595],
              [77.637526, 20.68135],
              [77.638039, 20.683867],
              [77.640527, 20.688494],
              [77.640488, 20.690554],
              [77.64026, 20.692793],
              [77.633936, 20.702437],
              [77.634354, 20.708218],
              [77.63353, 20.711498],
              [77.631032, 20.713128],
              [77.623422, 20.715776],
              [77.617801, 20.715712],
              [77.614171, 20.719012],
              [77.616378, 20.727717],
              [77.617848, 20.728451],
              [77.625728, 20.727456],
              [77.625076, 20.730273],
              [77.626939, 20.733409],
              [77.627927, 20.734607],
              [77.630015, 20.735054],
              [77.631608, 20.736298],
              [77.632723, 20.738068],
              [77.634539, 20.742641],
              [77.636485, 20.75513],
              [77.634426, 20.756753],
              [77.63125, 20.757866],
              [77.620624, 20.757565],
              [77.617146, 20.758567],
              [77.616114, 20.759898],
              [77.616118, 20.759908],
              [77.619555, 20.76887],
              [77.61974, 20.775981],
              [77.620936, 20.779531],
              [77.619166, 20.780059],
              [77.612306, 20.778285],
              [77.612582, 20.795373],
              [77.610834, 20.798201],
              [77.607049, 20.798118],
              [77.59578, 20.802636],
              [77.591787, 20.807379],
              [77.58574, 20.808461],
              [77.581031, 20.807928],
              [77.578824, 20.80743],
              [77.570948, 20.808245],
              [77.568139, 20.816123],
              [77.559707, 20.823023],
              [77.554827, 20.824333],
              [77.553195, 20.826577],
              [77.552731, 20.829858],
              [77.553588, 20.836675],
              [77.553036, 20.843792],
              [77.551155, 20.853149],
              [77.549269, 20.853912],
              [77.538932, 20.853835],
              [77.534767, 20.852257],
              [77.529466, 20.848005],
              [77.524914, 20.8512],
              [77.516887, 20.849947],
              [77.515021, 20.853003],
              [77.502635, 20.856772],
              [77.497472, 20.859738],
              [77.493621, 20.860975],
              [77.477059, 20.862491],
              [77.478362, 20.871081],
              [77.480221, 20.874855],
              [77.479581, 20.879271],
              [77.473461, 20.877834],
              [77.466878, 20.880463],
              [77.464794, 20.880425],
              [77.462274, 20.879071],
              [77.461721, 20.878041],
              [77.46378, 20.87596],
              [77.459967, 20.872659],
              [77.460428, 20.869794],
              [77.457665, 20.867233],
              [77.456161, 20.86312],
              [77.456079, 20.860651],
              [77.458612, 20.856788],
              [77.463321, 20.856516],
              [77.464162, 20.855364],
              [77.452271, 20.851221],
              [77.446894, 20.851315],
              [77.440056, 20.852517],
              [77.439258, 20.852123],
              [77.439845, 20.849252],
              [77.438033, 20.845018],
              [77.433699, 20.844887],
              [77.431153, 20.847771],
              [77.427622, 20.849403],
              [77.4248, 20.849429],
              [77.422652, 20.847264],
              [77.418596, 20.845345],
              [77.415363, 20.846285],
              [77.411236, 20.850108],
              [77.405898, 20.847911],
              [77.401802, 20.847141],
              [77.396021, 20.843632],
              [77.389518, 20.848439],
              [77.382944, 20.843781],
              [77.378284, 20.842617],
              [77.373583, 20.843512],
              [77.367023, 20.848839],
              [77.357776, 20.846732],
              [77.353411, 20.844176],
              [77.348595, 20.845535],
              [77.337469, 20.845908],
              [77.332776, 20.847373],
              [77.329735, 20.849743],
              [77.32799, 20.854236],
              [77.327825, 20.856991],
              [77.321158, 20.855837],
              [77.312046, 20.856242],
              [77.309221, 20.855002],
              [77.303261, 20.850509],
              [77.294463, 20.850923],
              [77.290459, 20.847336],
              [77.287211, 20.846442],
              [77.278564, 20.851665],
              [77.271674, 20.853546],
              [77.269155, 20.852757],
              [77.26436, 20.848318],
              [77.260497, 20.846281],
              [77.257932, 20.846761],
              [77.253285, 20.855395],
              [77.247774, 20.854576],
              [77.244294, 20.855175],
              [77.238014, 20.858022],
              [77.230295, 20.856994],
              [77.22737, 20.857756],
              [77.223642, 20.857664],
              [77.220028, 20.856831],
              [77.213568, 20.851361],
              [77.192551, 20.853053],
              [77.18795, 20.851709],
              [77.182389, 20.852202],
              [77.173726, 20.854555],
              [77.170868, 20.856921],
              [77.170948, 20.859851],
              [77.169314, 20.86278],
              [77.163411, 20.868039],
              [77.160428, 20.869039],
              [77.158096, 20.867214],
              [77.1542, 20.8607],
              [77.145157, 20.862193],
              [77.138004, 20.862291],
              [77.134156, 20.863354],
              [77.135641, 20.875958],
              [77.135652, 20.888466],
              [77.139321, 20.898195],
              [77.136758, 20.900221],
              [77.138508, 20.905938],
              [77.136836, 20.912492],
              [77.136802, 20.9161],
              [77.142529, 20.923639],
              [77.145234, 20.924712],
              [77.145973, 20.926428],
              [77.146256, 20.931584],
              [77.150845, 20.942917],
              [77.153607, 20.955],
              [77.157089, 20.96323],
              [77.162955, 20.971687],
              [77.156718, 20.973096],
              [77.147847, 20.972873],
              [77.136168, 20.974373],
              [77.135761, 20.987284],
              [77.151244, 20.988216],
              [77.164531, 20.988075],
              [77.169367, 20.98988],
              [77.169168, 20.996648],
              [77.167905, 21.000381],
              [77.170732, 21.003473],
              [77.173003, 21.004402],
              [77.173738, 21.007611],
              [77.173413, 21.022955],
              [77.160875, 21.028773],
              [77.153238, 21.034079],
              [77.150972, 21.036794],
              [77.150077, 21.041148],
              [77.15034, 21.044424],
              [77.152248, 21.047973],
              [77.151217, 21.054218],
              [77.151854, 21.058198],
              [77.149196, 21.072685],
              [77.16007, 21.073551],
              [77.171525, 21.073284],
              [77.176042, 21.074802],
              [77.175242, 21.083005],
              [77.176618, 21.086999],
              [77.175459, 21.089733],
              [77.172812, 21.092898],
              [77.171945, 21.100758],
              [77.172358, 21.106913],
              [77.171528, 21.113505],
              [77.172541, 21.119908],
              [77.18031, 21.119964],
              [77.18247, 21.122023],
              [77.188426, 21.121228],
              [77.195816, 21.121732],
              [77.196909, 21.13865],
              [77.193601, 21.138987],
              [77.190737, 21.13536],
              [77.171276, 21.135462],
              [77.163917, 21.136275],
              [77.163692, 21.140815],
              [77.164658, 21.144105],
              [77.161236, 21.143803],
              [77.159059, 21.1456],
              [77.162539, 21.151079],
              [77.16493, 21.159812],
              [77.164857, 21.165498],
              [77.162525, 21.168893],
              [77.161985, 21.171066],
              [77.165366, 21.17867],
              [77.165159, 21.182743],
              [77.167466, 21.186242],
              [77.17146, 21.188395],
              [77.17357, 21.192983],
              [77.178962, 21.19241],
              [77.17868, 21.196884],
              [77.179669, 21.199671],
              [77.182762, 21.2037],
              [77.18065, 21.207739],
              [77.175068, 21.208194],
              [77.175953, 21.215681],
              [77.173092, 21.225964],
              [77.16476, 21.237104],
              [77.16078, 21.238007],
              [77.155594, 21.237205],
              [77.152665, 21.234319],
              [77.1472, 21.226667],
              [77.138357, 21.225259],
              [77.130029, 21.222833],
              [77.121524, 21.226094],
              [77.119365, 21.220987],
              [77.116097, 21.219076],
              [77.110602, 21.219008],
              [77.10439, 21.220482],
              [77.092712, 21.225293],
              [77.087987, 21.223242],
              [77.07987, 21.217102],
              [77.077307, 21.219468],
              [77.073468, 21.221515],
              [77.069179, 21.221723],
              [77.064486, 21.223548],
              [77.060996, 21.226529],
              [77.060238, 21.230241],
              [77.05789, 21.233984],
              [77.051567, 21.237321],
              [77.043776, 21.243435],
              [77.037132, 21.245159],
              [77.023824, 21.245943],
              [77.020223, 21.237474],
              [77.011166, 21.237301],
              [77.004188, 21.228904],
              [77.00307, 21.22104],
              [77.005025, 21.214816],
              [77.006042, 21.207078],
              [76.999156, 21.204106],
              [76.9799, 21.204413],
              [76.964566, 21.199645],
              [76.963707, 21.199543],
              [76.955906, 21.198628],
              [76.943643, 21.20119],
              [76.942319, 21.201467],
              [76.921591, 21.202222],
              [76.897068, 21.198611],
              [76.878669, 21.194033],
              [76.855988, 21.190783],
              [76.848082, 21.193365],
              [76.842557, 21.189779],
              [76.827189, 21.187325],
              [76.809105, 21.186076],
              [76.807195, 21.185953],
              [76.792711, 21.184789],
              [76.788814, 21.189001],
              [76.78376, 21.188962],
              [76.782549, 21.192769],
              [76.779476, 21.192027],
              [76.772777, 21.190625],
              [76.768024, 21.191868],
              [76.765988, 21.193971],
              [76.764622, 21.202135],
              [76.760537, 21.221237],
              [76.759107, 21.223332],
              [76.756398, 21.222813],
              [76.754053, 21.218561],
              [76.75101, 21.219772],
              [76.748364, 21.222064],
              [76.74757, 21.228205],
              [76.746217, 21.234135],
              [76.744657, 21.238979],
              [76.744692, 21.243796],
              [76.74954, 21.250566],
              [76.749049, 21.253266],
              [76.746164, 21.255908],
              [76.737367, 21.269375],
              [76.730128, 21.281147],
              [76.724093, 21.289067],
              [76.715575, 21.285627],
              [76.709138, 21.285134],
              [76.699304, 21.286822],
              [76.684943, 21.288204],
              [76.675752, 21.281974],
              [76.662796, 21.280226],
              [76.650341, 21.297831],
              [76.64142, 21.308435],
              [76.627515, 21.327506],
              [76.626204, 21.332857],
              [76.630339, 21.337524],
              [76.670187, 21.367204],
              [76.720988, 21.398365],
              [76.734017, 21.406518],
              [76.739177, 21.412998],
              [76.740378, 21.427066],
              [76.745367, 21.440823],
              [76.758563, 21.447602],
              [76.777835, 21.457794],
              [76.78624, 21.464155],
              [76.787183, 21.474381],
              [76.792264, 21.480008],
              [76.793886, 21.487533],
              [76.788558, 21.496862],
              [76.772287, 21.508371],
              [76.764984, 21.520255],
              [76.769564, 21.525149],
              [76.77738, 21.529629],
              [76.787634, 21.532902],
              [76.789934, 21.537725],
              [76.786678, 21.543636],
              [76.784947, 21.549056],
              [76.782346, 21.560045],
              [76.785701, 21.575532],
              [76.793618, 21.584968],
              [76.795549, 21.592717],
              [76.797502, 21.595079],
              [76.806019, 21.594369],
              [76.825386, 21.590237],
              [76.835759, 21.590621],
              [76.840874, 21.598052],
              [76.850026, 21.610844],
              [76.85441, 21.61257],
              [76.863009, 21.609842],
              [76.894077, 21.598263],
              [76.903468, 21.598378],
              [76.908023, 21.60206],
              [76.913934, 21.612482],
              [76.981207, 21.663513],
              [76.999857, 21.679117],
              [77.004171, 21.679674],
              [77.012759, 21.681902],
              [77.020755, 21.6883],
              [77.025963, 21.691282],
              [77.031819, 21.693565],
              [77.036926, 21.698016],
              [77.062205, 21.706907],
              [77.064774, 21.712542],
              [77.071764, 21.719302],
              [77.075074, 21.720423],
              [77.078052, 21.719866],
              [77.082999, 21.716196],
              [77.08653, 21.716127],
              [77.096713, 21.717122],
              [77.106912, 21.72039],
              [77.11699, 21.722358],
              [77.123931, 21.72285],
              [77.136187, 21.719828],
              [77.150376, 21.712171],
              [77.160664, 21.710929],
              [77.165319, 21.711638],
              [77.167955, 21.71444],
              [77.170953, 21.723276],
              [77.174359, 21.724776],
              [77.186759, 21.722023],
              [77.19098, 21.720095],
              [77.187266, 21.701998],
              [77.204326, 21.693876],
              [77.210381, 21.691565],
              [77.213194, 21.694676],
              [77.220961, 21.69599],
              [77.224605, 21.697671],
              [77.226243, 21.701729],
              [77.227607, 21.715429],
              [77.242973, 21.714661],
              [77.25823, 21.712739],
              [77.261104, 21.713383],
              [77.265851, 21.721175],
              [77.270455, 21.726616],
              [77.28627, 21.721778],
              [77.288944, 21.726374],
              [77.290014, 21.733979],
              [77.28641, 21.736029],
              [77.286219, 21.739183],
              [77.287586, 21.743977],
              [77.285406, 21.745659],
              [77.281396, 21.746666],
              [77.280186, 21.757321],
              [77.283103, 21.758766],
              [77.289396, 21.760269],
              [77.296824, 21.757445],
              [77.312056, 21.757181],
              [77.324512, 21.754567],
              [77.329174, 21.754896],
              [77.340627, 21.759099],
              [77.345527, 21.759371],
              [77.356635, 21.757014],
              [77.379213, 21.75466],
              [77.404465, 21.753737],
              [77.41634, 21.755296],
              [77.441908, 21.760289],
              [77.447293, 21.761087],
              [77.453309, 21.760984],
              [77.456049, 21.761895],
              [77.462117, 21.765751],
              [77.474828, 21.768823],
              [77.478932, 21.769018],
              [77.481232, 21.7678],
              [77.480482, 21.765539],
              [77.478617, 21.763319],
              [77.47933, 21.755467],
              [77.492308, 21.747851],
              [77.50037, 21.746804],
              [77.503343, 21.742499],
              [77.509552, 21.738826],
              [77.511874, 21.732901],
              [77.521429, 21.724649],
              [77.522347, 21.7188],
              [77.524568, 21.711785],
              [77.526973, 21.711192],
              [77.529642, 21.712681],
              [77.536936, 21.710356],
              [77.53947, 21.705928],
              [77.545746, 21.6987],
              [77.548125, 21.690123],
              [77.549226, 21.683766],
              [77.550915, 21.679267],
              [77.554079, 21.673981],
              [77.562148, 21.666382],
              [77.561112, 21.653321],
              [77.563943, 21.642926],
              [77.56911, 21.632792],
              [77.574904, 21.624805],
              [77.57455, 21.621295],
              [77.571403, 21.618828],
              [77.571743, 21.614003],
              [77.573498, 21.608925],
              [77.575783, 21.585475],
              [77.573804, 21.573484],
              [77.573557, 21.567619],
              [77.574545, 21.560458],
              [77.577651, 21.555346],
              [77.589095, 21.556657],
              [77.594257, 21.559453],
              [77.609358, 21.54877],
              [77.610733, 21.540643],
              [77.598474, 21.531041],
              [77.592822, 21.528234],
              [77.581443, 21.527089],
              [77.570521, 21.527625],
              [77.556912, 21.534027],
              [77.544231, 21.536764],
              [77.538825, 21.53689],
              [77.532663, 21.538614],
              [77.515368, 21.545336],
              [77.510708, 21.548633],
              [77.507811, 21.552488],
              [77.487415, 21.551104],
              [77.472126, 21.552293],
              [77.468108, 21.553765],
              [77.460864, 21.554366],
              [77.455306, 21.553398],
              [77.453659, 21.549739],
              [77.453605, 21.546182],
              [77.449981, 21.543403],
              [77.445397, 21.542453],
              [77.43519, 21.544197],
              [77.432262, 21.543454],
              [77.426808, 21.540351],
              [77.423201, 21.536495],
              [77.420249, 21.530862],
              [77.422089, 21.518653],
              [77.424079, 21.514101],
              [77.434416, 21.500059],
              [77.442525, 21.487175],
              [77.44068, 21.481391],
              [77.438442, 21.47951],
              [77.441149, 21.476065],
              [77.441626, 21.470785],
              [77.452235, 21.467553],
              [77.457116, 21.465178],
              [77.460488, 21.464956],
              [77.47264, 21.454799],
              [77.471923, 21.450818],
              [77.47311, 21.44659],
              [77.472188, 21.440826],
              [77.472546, 21.434972],
              [77.476372, 21.430623],
              [77.480466, 21.418811],
              [77.485107, 21.41362],
              [77.487522, 21.396486],
              [77.486335, 21.388357],
              [77.490376, 21.375744],
              [77.505107, 21.377243],
              [77.513922, 21.374773],
              [77.515871, 21.381644],
              [77.517346, 21.384201],
              [77.522612, 21.387811],
              [77.524121, 21.391694],
              [77.525255, 21.402861],
              [77.528567, 21.409073],
              [77.53058, 21.419002],
              [77.547551, 21.409386],
              [77.548728, 21.40539],
              [77.555294, 21.40167],
              [77.562381, 21.39618],
              [77.562709, 21.392276],
              [77.558687, 21.390814],
              [77.557697, 21.388382],
              [77.559881, 21.380151],
              [77.565985, 21.371419],
              [77.568812, 21.370673],
              [77.574384, 21.371299],
              [77.57952, 21.368522],
              [77.584322, 21.367179],
              [77.587957, 21.362537],
              [77.59053, 21.365806],
              [77.605032, 21.363332],
              [77.608366, 21.365058],
              [77.609346, 21.36841],
              [77.605592, 21.382249],
              [77.604208, 21.383939],
              [77.604208, 21.387161],
              [77.602738, 21.390579],
              [77.605103, 21.391597],
              [77.615025, 21.391849],
              [77.618767, 21.388701],
              [77.632903, 21.389028],
              [77.639793, 21.387553],
              [77.642823, 21.386001],
              [77.64508, 21.386738],
              [77.646189, 21.389459],
              [77.649525, 21.391417],
              [77.654608, 21.391452],
              [77.655215, 21.388247],
              [77.665737, 21.386039],
              [77.667002, 21.3837],
              [77.666731, 21.375535],
              [77.668447, 21.371716],
              [77.670878, 21.369577],
              [77.673672, 21.37101],
              [77.684772, 21.383574],
              [77.691973, 21.3948],
              [77.694844, 21.395141],
              [77.697248, 21.394612],
              [77.697954, 21.392616],
              [77.696312, 21.37874],
              [77.699246, 21.37586],
              [77.708066, 21.3758],
              [77.708872, 21.37156],
              [77.708954, 21.357199],
              [77.728645, 21.362272],
              [77.73764, 21.36285],
              [77.742137, 21.364762],
              [77.747159, 21.378189],
              [77.75027, 21.382327],
              [77.75373, 21.383826],
              [77.760708, 21.384528],
              [77.765215, 21.382547],
              [77.768884, 21.382788],
              [77.780393, 21.386159],
              [77.789374, 21.387524],
              [77.793971, 21.387378],
              [77.797314, 21.388879],
              [77.797837, 21.39774],
              [77.799859, 21.40438],
              [77.803245, 21.410421],
              [77.808396, 21.410114],
              [77.82193, 21.406855],
              [77.837859, 21.399664],
              [77.850557, 21.392272],
              [77.858705, 21.388889],
              [77.8672, 21.386303],
              [77.887405, 21.383683],
              [77.885876, 21.375889],
              [77.890667, 21.378625],
              [77.896332, 21.377253],
              [77.903075, 21.376624],
              [77.909557, 21.377778],
              [77.915808, 21.380977],
              [77.922321, 21.382956],
              [77.928975, 21.384279],
              [77.935843, 21.384042],
              [77.942859, 21.385132],
              [77.945222, 21.397156],
              [77.96408, 21.399652],
              [77.975699, 21.399603],
              [77.984437, 21.401025],
              [78.00002, 21.411999],
              [78.00392, 21.414386],
              [78.008647, 21.414106],
              [78.011275, 21.416635],
              [78.023824, 21.418818],
              [78.033375, 21.423589],
              [78.047746, 21.433258],
              [78.055344, 21.435261],
              [78.068014, 21.437092],
              [78.082886, 21.443944],
              [78.09685, 21.454249],
              [78.105114, 21.459185],
              [78.113447, 21.462412],
              [78.131627, 21.471636],
              [78.147237, 21.480349],
              [78.173812, 21.496734],
              [78.175036, 21.50029],
              [78.175825, 21.506726],
              [78.182131, 21.512541],
              [78.172482, 21.524235],
              [78.175553, 21.526937],
              [78.176157, 21.53395],
              [78.175104, 21.540376],
              [78.177233, 21.55147],
              [78.181768, 21.554872],
              [78.185443, 21.556833],
              [78.220021, 21.551924],
              [78.231241, 21.554645],
              [78.243306, 21.563684],
              [78.251153, 21.562213],
              [78.273896, 21.568918],
              [78.274873, 21.570581],
              [78.273654, 21.572935],
              [78.263155, 21.580095],
              [78.260029, 21.583425],
              [78.259781, 21.588013],
              [78.262235, 21.590025],
              [78.266825, 21.591934],
              [78.27076, 21.592456],
              [78.275718, 21.591141],
              [78.28628, 21.584957],
              [78.304666, 21.583274],
              [78.30645, 21.578623],
              [78.306522, 21.571101],
              [78.308787, 21.569666],
              [78.313508, 21.571918],
              [78.323435, 21.573826],
              [78.327669, 21.575615],
              [78.333183, 21.579413],
              [78.341507, 21.588748],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 16,
        censuscode: 503,
        dt_cen_cd: 7,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Amravati",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [79.92223, 21.524148],
              [79.924381, 21.519877],
              [79.928399, 21.512069],
              [79.929977, 21.503879],
              [79.929685, 21.498357],
              [79.925857, 21.486484],
              [79.923893, 21.481881],
              [79.918451, 21.475814],
              [79.902641, 21.461746],
              [79.899476, 21.45845],
              [79.892158, 21.450481],
              [79.889704, 21.445325],
              [79.884204, 21.440628],
              [79.88116, 21.436116],
              [79.883038, 21.42443],
              [79.878423, 21.42001],
              [79.870564, 21.41577],
              [79.851603, 21.409863],
              [79.842149, 21.401431],
              [79.836199, 21.397421],
              [79.819794, 21.386362],
              [79.80251, 21.379439],
              [79.799468, 21.376858],
              [79.797813, 21.367285],
              [79.801658, 21.357996],
              [79.806087, 21.352849],
              [79.808343, 21.355152],
              [79.811197, 21.351015],
              [79.813062, 21.35249],
              [79.814248, 21.34697],
              [79.811695, 21.346231],
              [79.812194, 21.340894],
              [79.811318, 21.33528],
              [79.815252, 21.331328],
              [79.815372, 21.315869],
              [79.823031, 21.31689],
              [79.827058, 21.316343],
              [79.834436, 21.306689],
              [79.835708, 21.309911],
              [79.838752, 21.31019],
              [79.838855, 21.306418],
              [79.837974, 21.304392],
              [79.834933, 21.301445],
              [79.829928, 21.299691],
              [79.828468, 21.289659],
              [79.833672, 21.289389],
              [79.835932, 21.288011],
              [79.837509, 21.283136],
              [79.827794, 21.278984],
              [79.826039, 21.270333],
              [79.830655, 21.268222],
              [79.833219, 21.259759],
              [79.847847, 21.258303],
              [79.865418, 21.258227],
              [79.865524, 21.250866],
              [79.861596, 21.252243],
              [79.85679, 21.248926],
              [79.85433, 21.253892],
              [79.842648, 21.255077],
              [79.841868, 21.250935],
              [79.8456, 21.248455],
              [79.848353, 21.245053],
              [79.832472, 21.229578],
              [79.836895, 21.224154],
              [79.848963, 21.226651],
              [79.852885, 21.230059],
              [79.856026, 21.228774],
              [79.860245, 21.23025],
              [79.868981, 21.228878],
              [79.86947, 21.230627],
              [79.864554, 21.239732],
              [79.864647, 21.244425],
              [79.867392, 21.247279],
              [79.87966, 21.24913],
              [79.887313, 21.252448],
              [79.889083, 21.248585],
              [79.89566, 21.248866],
              [79.901654, 21.240405],
              [79.905579, 21.240499],
              [79.922846, 21.253299],
              [79.94189, 21.252203],
              [79.952103, 21.238865],
              [79.956914, 21.235094],
              [79.971637, 21.228104],
              [79.991658, 21.229947],
              [79.996075, 21.223782],
              [80, 21.220194],
              [80.003435, 21.21817],
              [80.00471, 21.217249],
              [80.008047, 21.216053],
              [80.01158, 21.217433],
              [80.015996, 21.220561],
              [80.019431, 21.222769],
              [80.020181, 21.223339],
              [80.023063, 21.225529],
              [80.023703, 21.225289],
              [80.026988, 21.224056],
              [80.027183, 21.219547],
              [80.027771, 21.216695],
              [80.030323, 21.215038],
              [80.036112, 21.213197],
              [80.03984, 21.209239],
              [80.045826, 21.210158],
              [80.049751, 21.210248],
              [80.051124, 21.208316],
              [80.052202, 21.205187],
              [80.052986, 21.201966],
              [80.056424, 21.200287],
              [80.058283, 21.199664],
              [80.059852, 21.197363],
              [80.060456, 21.195302],
              [80.062573, 21.18876],
              [80.063183, 21.18586],
              [80.063181, 21.18356],
              [80.062395, 21.180892],
              [80.061217, 21.179053],
              [80.062588, 21.174359],
              [80.06642, 21.170971],
              [80.06987, 21.167381],
              [80.074256, 21.162209],
              [80.076172, 21.158638],
              [80.077396, 21.156666],
              [80.078599, 21.155143],
              [80.080038, 21.153557],
              [80.080767, 21.151295],
              [80.081523, 21.149173],
              [80.083661, 21.143434],
              [80.080073, 21.140524],
              [80.075026, 21.136907],
              [80.073456, 21.134975],
              [80.072964, 21.131571],
              [80.07305, 21.122054],
              [80.072958, 21.120898],
              [80.072368, 21.118875],
              [80.070014, 21.11722],
              [80.064521, 21.114462],
              [80.062951, 21.111702],
              [80.061281, 21.105355],
              [80.061966, 21.102042],
              [80.063828, 21.100938],
              [80.064989, 21.100899],
              [80.071048, 21.101066],
              [80.075496, 21.101484],
              [80.078045, 21.101391],
              [80.080986, 21.100193],
              [80.081082, 21.097157],
              [80.078431, 21.091086],
              [80.07843, 21.08943],
              [80.080977, 21.085013],
              [80.081661, 21.081332],
              [80.081867, 21.076688],
              [80.082124, 21.069913],
              [80.082727, 21.062839],
              [80.077431, 21.05723],
              [80.078116, 21.055021],
              [80.078703, 21.054539],
              [80.081251, 21.052444],
              [80.08419, 21.051338],
              [80.087031, 21.048208],
              [80.085755, 21.046001],
              [80.083303, 21.043518],
              [80.082109, 21.042735],
              [80.078817, 21.040614],
              [80.076245, 21.039106],
              [80.071833, 21.036072],
              [80.06899, 21.033406],
              [80.068302, 21.030186],
              [80.066734, 21.029543],
              [80.056244, 21.019059],
              [80.052224, 21.013633],
              [80.051145, 21.009401],
              [80.049968, 21.007286],
              [80.048694, 21.005354],
              [80.047615, 21.003055],
              [80.043402, 21.00278],
              [80.039777, 21.003057],
              [80.037329, 21.004713],
              [80.034684, 21.006002],
              [80.032363, 21.006597],
              [80.029099, 21.007843],
              [80.027238, 21.00812],
              [80.02567, 21.007292],
              [80.024494, 21.004992],
              [80.019399, 21.001221],
              [80.018321, 21.002969],
              [80.017538, 21.004625],
              [80.015872, 21.008029],
              [80.015873, 21.009869],
              [80.012052, 21.012629],
              [80.008916, 21.013274],
              [80.005487, 21.014286],
              [80.003919, 21.01539],
              [80.003527, 21.016954],
              [80.001764, 21.020266],
              [80, 21.022014],
              [79.997158, 21.02137],
              [79.987557, 21.007754],
              [79.965708, 21.008762],
              [79.952969, 21.013082],
              [79.949246, 21.011793],
              [79.947875, 21.009309],
              [79.94866, 21.007101],
              [79.953855, 21.000111],
              [79.954741, 20.988244],
              [79.943679, 20.970485],
              [79.941823, 20.959261],
              [79.945157, 20.948683],
              [79.946094, 20.940708],
              [79.948494, 20.929549],
              [79.94781, 20.926054],
              [79.944696, 20.923238],
              [79.93788, 20.917076],
              [79.933708, 20.912929],
              [79.927259, 20.905347],
              [79.911012, 20.897703],
              [79.909356, 20.886571],
              [79.905345, 20.883625],
              [79.901908, 20.881866],
              [79.889689, 20.875612],
              [79.880486, 20.879192],
              [79.873826, 20.882774],
              [79.865317, 20.876144],
              [79.864833, 20.870348],
              [79.867481, 20.865107],
              [79.868076, 20.862604],
              [79.868893, 20.857112],
              [79.868009, 20.852986],
              [79.866714, 20.849836],
              [79.862803, 20.845786],
              [79.863396, 20.841003],
              [79.86327, 20.837],
              [79.862922, 20.825917],
              [79.859503, 20.820763],
              [79.862342, 20.819018],
              [79.863422, 20.814879],
              [79.858433, 20.814783],
              [79.856677, 20.810274],
              [79.867147, 20.808168],
              [79.866468, 20.802004],
              [79.868334, 20.795383],
              [79.866, 20.781308],
              [79.870403, 20.780392],
              [79.87697, 20.783869],
              [79.885066, 20.78997],
              [79.886453, 20.769184],
              [79.888803, 20.766242],
              [79.893886, 20.768361],
              [79.896773, 20.771233],
              [79.899192, 20.773638],
              [79.904344, 20.778762],
              [79.910015, 20.781525],
              [79.918091, 20.783057],
              [79.927484, 20.784837],
              [79.935248, 20.785769],
              [79.940334, 20.785311],
              [79.937894, 20.773813],
              [79.926943, 20.768657],
              [79.925673, 20.765529],
              [79.926029, 20.75895],
              [79.926464, 20.750905],
              [79.926075, 20.746398],
              [79.917079, 20.746117],
              [79.915911, 20.738206],
              [79.928817, 20.739225],
              [79.929657, 20.728703],
              [79.931957, 20.71752],
              [79.934404, 20.71191],
              [79.947209, 20.71587],
              [79.95327, 20.716884],
              [79.960895, 20.716334],
              [79.970379, 20.713945],
              [79.972335, 20.709439],
              [79.972043, 20.701253],
              [79.966278, 20.693618],
              [79.96453, 20.68987],
              [79.964497, 20.689879],
              [79.961435, 20.690664],
              [79.949104, 20.680939],
              [79.943026, 20.6783],
              [79.934456, 20.676176],
              [79.934705, 20.671607],
              [79.932995, 20.666525],
              [79.903887, 20.676431],
              [79.894263, 20.683076],
              [79.879146, 20.684638],
              [79.849886, 20.677568],
              [79.841968, 20.678781],
              [79.828459, 20.682447],
              [79.802879, 20.684219],
              [79.800582, 20.695305],
              [79.796838, 20.698892],
              [79.793891, 20.70792],
              [79.789304, 20.717419],
              [79.782597, 20.723206],
              [79.761744, 20.731055],
              [79.75818, 20.723394],
              [79.753946, 20.710637],
              [79.760913, 20.706795],
              [79.757681, 20.700859],
              [79.75256, 20.685751],
              [79.735428, 20.682551],
              [79.723286, 20.682642],
              [79.713494, 20.6853],
              [79.693469, 20.668746],
              [79.693833, 20.662498],
              [79.701569, 20.644717],
              [79.695665, 20.640339],
              [79.691046, 20.641346],
              [79.686379, 20.644879],
              [79.679761, 20.647397],
              [79.671651, 20.648375],
              [79.664756, 20.653696],
              [79.663321, 20.662485],
              [79.653367, 20.667599],
              [79.6446, 20.669843],
              [79.62315, 20.672973],
              [79.613155, 20.691165],
              [79.605094, 20.69087],
              [79.598301, 20.689199],
              [79.580917, 20.691035],
              [79.567829, 20.694161],
              [79.565952, 20.701571],
              [79.548372, 20.70214],
              [79.534576, 20.701712],
              [79.527494, 20.707666],
              [79.520787, 20.708688],
              [79.518563, 20.70531],
              [79.509017, 20.703948],
              [79.509309, 20.707651],
              [79.51375, 20.714209],
              [79.521904, 20.724813],
              [79.535458, 20.739986],
              [79.533313, 20.745912],
              [79.533259, 20.748892],
              [79.537192, 20.765028],
              [79.53557, 20.772848],
              [79.537509, 20.776329],
              [79.54556, 20.78589],
              [79.549021, 20.792902],
              [79.56043, 20.802868],
              [79.560413, 20.809638],
              [79.554314, 20.820927],
              [79.551672, 20.830564],
              [79.549055, 20.836022],
              [79.541595, 20.847803],
              [79.543517, 20.849621],
              [79.546192, 20.850069],
              [79.554487, 20.848116],
              [79.559825, 20.853318],
              [79.566313, 20.849606],
              [79.568749, 20.84707],
              [79.568948, 20.843577],
              [79.57903, 20.843482],
              [79.583033, 20.842415],
              [79.588257, 20.846934],
              [79.596131, 20.85637],
              [79.60422, 20.864266],
              [79.612716, 20.864778],
              [79.617426, 20.864116],
              [79.619129, 20.864723],
              [79.615946, 20.867994],
              [79.615433, 20.872162],
              [79.611277, 20.878398],
              [79.616588, 20.902533],
              [79.621937, 20.907227],
              [79.639302, 20.913638],
              [79.644136, 20.916538],
              [79.651578, 20.926601],
              [79.659012, 20.9436],
              [79.660915, 20.952813],
              [79.659524, 20.957888],
              [79.659604, 20.969417],
              [79.653513, 20.97751],
              [79.647205, 20.981884],
              [79.643091, 20.984615],
              [79.63758, 20.990897],
              [79.63649, 20.996511],
              [79.636701, 21.000608],
              [79.618879, 21.026698],
              [79.612629, 21.038412],
              [79.610207, 21.050465],
              [79.607377, 21.056308],
              [79.603583, 21.061658],
              [79.599651, 21.072462],
              [79.592576, 21.076618],
              [79.588722, 21.076097],
              [79.586451, 21.072813],
              [79.581987, 21.068589],
              [79.577966, 21.066004],
              [79.57312, 21.067232],
              [79.568884, 21.070045],
              [79.558184, 21.083524],
              [79.551934, 21.086385],
              [79.542688, 21.081001],
              [79.529472, 21.075318],
              [79.523014, 21.08766],
              [79.530651, 21.088291],
              [79.533182, 21.095602],
              [79.53104, 21.09738],
              [79.530904, 21.099846],
              [79.532772, 21.101227],
              [79.533818, 21.103436],
              [79.530106, 21.105913],
              [79.53202, 21.107925],
              [79.528366, 21.114536],
              [79.527544, 21.117493],
              [79.513704, 21.121323],
              [79.51211, 21.124719],
              [79.512831, 21.128018],
              [79.511766, 21.131497],
              [79.50768, 21.133839],
              [79.498343, 21.135966],
              [79.492735, 21.13936],
              [79.493404, 21.141341],
              [79.504019, 21.143957],
              [79.506218, 21.145807],
              [79.510491, 21.16267],
              [79.498137, 21.17166],
              [79.499183, 21.180142],
              [79.501646, 21.183267],
              [79.519612, 21.173349],
              [79.5264, 21.175512],
              [79.532552, 21.174492],
              [79.531404, 21.170313],
              [79.528618, 21.167645],
              [79.534339, 21.156089],
              [79.543833, 21.155637],
              [79.548134, 21.156968],
              [79.551865, 21.157251],
              [79.556188, 21.15595],
              [79.561778, 21.155488],
              [79.562033, 21.160784],
              [79.560704, 21.163733],
              [79.554728, 21.170161],
              [79.554545, 21.172109],
              [79.562961, 21.187081],
              [79.5618, 21.190493],
              [79.560396, 21.192007],
              [79.559513, 21.201638],
              [79.558026, 21.204061],
              [79.554135, 21.204863],
              [79.553179, 21.206153],
              [79.556084, 21.208777],
              [79.563879, 21.225606],
              [79.560515, 21.234526],
              [79.56112, 21.236329],
              [79.5657, 21.241926],
              [79.571464, 21.247044],
              [79.56897, 21.25352],
              [79.571279, 21.273765],
              [79.575923, 21.273739],
              [79.576719, 21.277434],
              [79.5756, 21.283324],
              [79.568085, 21.299022],
              [79.565232, 21.301921],
              [79.558724, 21.302698],
              [79.556027, 21.306244],
              [79.556865, 21.308798],
              [79.559043, 21.310988],
              [79.558107, 21.31332],
              [79.55495, 21.316101],
              [79.558405, 21.322638],
              [79.557913, 21.327966],
              [79.556918, 21.330299],
              [79.547694, 21.331345],
              [79.535742, 21.34799],
              [79.529378, 21.351541],
              [79.526449, 21.354722],
              [79.523309, 21.364059],
              [79.517753, 21.368891],
              [79.516032, 21.372746],
              [79.507623, 21.386117],
              [79.500351, 21.397557],
              [79.487886, 21.398666],
              [79.491605, 21.40252],
              [79.49165, 21.404821],
              [79.48328, 21.427325],
              [79.479611, 21.426921],
              [79.471503, 21.424208],
              [79.460421, 21.425936],
              [79.455231, 21.428998],
              [79.450496, 21.434946],
              [79.452406, 21.448508],
              [79.45021, 21.451774],
              [79.449303, 21.456517],
              [79.456268, 21.4588],
              [79.45933, 21.460672],
              [79.470019, 21.479104],
              [79.474607, 21.480802],
              [79.475124, 21.483627],
              [79.485759, 21.502003],
              [79.493194, 21.508321],
              [79.496903, 21.514412],
              [79.503764, 21.521457],
              [79.514229, 21.534129],
              [79.529347, 21.540049],
              [79.534511, 21.539637],
              [79.542714, 21.543442],
              [79.553496, 21.543534],
              [79.566415, 21.54726],
              [79.577472, 21.543058],
              [79.582271, 21.542621],
              [79.595659, 21.548826],
              [79.601049, 21.54893],
              [79.605545, 21.550041],
              [79.614868, 21.555205],
              [79.622972, 21.556485],
              [79.631515, 21.554152],
              [79.640458, 21.554247],
              [79.646933, 21.55478],
              [79.653683, 21.556478],
              [79.656812, 21.558121],
              [79.660145, 21.562755],
              [79.664336, 21.576618],
              [79.669156, 21.579003],
              [79.691066, 21.579995],
              [79.695571, 21.582945],
              [79.697446, 21.587189],
              [79.700039, 21.590257],
              [79.705576, 21.591621],
              [79.712422, 21.590214],
              [79.720075, 21.590443],
              [79.738886, 21.601854],
              [79.75118, 21.597205],
              [79.775085, 21.589801],
              [79.798117, 21.580814],
              [79.809503, 21.572061],
              [79.817987, 21.563744],
              [79.824529, 21.558472],
              [79.831373, 21.5462],
              [79.847891, 21.541328],
              [79.856914, 21.537049],
              [79.861118, 21.532055],
              [79.863436, 21.530451],
              [79.878254, 21.529095],
              [79.883062, 21.528022],
              [79.892221, 21.5292],
              [79.896141, 21.523446],
              [79.898679, 21.522838],
              [79.907582, 21.523946],
              [79.922218, 21.524076],
              [79.92223, 21.524148],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 71,
        censuscode: 506,
        dt_cen_cd: 10,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Bhandara",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [72.958587, 18.987335],
              [72.946772, 18.985739],
              [72.913733, 18.98226],
              [72.900925, 18.979633],
              [72.896816, 18.978772],
              [72.882426, 18.981199],
              [72.880362, 18.984392],
              [72.879, 18.991473],
              [72.88282, 18.999998],
              [72.884655, 19.012667],
              [72.879732, 19.01551],
              [72.875604, 19.017897],
              [72.871248, 19.022467],
              [72.874562, 19.03003],
              [72.876293, 19.040275],
              [72.877106, 19.04566],
              [72.868478, 19.051697],
              [72.863549, 19.053351],
              [72.859401, 19.054734],
              [72.85372, 19.051907],
              [72.8473, 19.04716],
              [72.843645, 19.04673],
              [72.840901, 19.045531],
              [72.834251, 19.041907],
              [72.827283, 19.032488],
              [72.824023, 19.031227],
              [72.817682, 19.032537],
              [72.81607, 19.03885],
              [72.817863, 19.048398],
              [72.817387, 19.048848],
              [72.818076, 19.049525],
              [72.817024, 19.054263],
              [72.816748, 19.061257],
              [72.816916, 19.064432],
              [72.817125, 19.06575],
              [72.817769, 19.067943],
              [72.819045, 19.070065],
              [72.820182, 19.072262],
              [72.821186, 19.074006],
              [72.821779, 19.075203],
              [72.821821, 19.07586],
              [72.821845, 19.078336],
              [72.822507, 19.080832],
              [72.823078, 19.090546],
              [72.822443, 19.104206],
              [72.82184, 19.108052],
              [72.821729, 19.108947],
              [72.822042, 19.10973],
              [72.826334, 19.111662],
              [72.827115, 19.111978],
              [72.825785, 19.124471],
              [72.820267, 19.126146],
              [72.819751, 19.122248],
              [72.817738, 19.122528],
              [72.812638, 19.126711],
              [72.807708, 19.133085],
              [72.806585, 19.135491],
              [72.806706, 19.137375],
              [72.799767, 19.137486],
              [72.795201, 19.124644],
              [72.793143, 19.123742],
              [72.786026, 19.124331],
              [72.783635, 19.125175],
              [72.784001, 19.130396],
              [72.787527, 19.136808],
              [72.78769, 19.145403],
              [72.78692, 19.1483],
              [72.780633, 19.152713],
              [72.780238, 19.154059],
              [72.779967, 19.156305],
              [72.78037, 19.157619],
              [72.781029, 19.160301],
              [72.789246, 19.165983],
              [72.791676, 19.168517],
              [72.794468, 19.176502],
              [72.794637, 19.182751],
              [72.793931, 19.189215],
              [72.79421, 19.190639],
              [72.788892, 19.192084],
              [72.786126, 19.192142],
              [72.784662, 19.193699],
              [72.784158, 19.194577],
              [72.782742, 19.205845],
              [72.781837, 19.208127],
              [72.77899, 19.21613],
              [72.780188, 19.222765],
              [72.782019, 19.236812],
              [72.78229, 19.244117],
              [72.782233, 19.257853],
              [72.78162, 19.261283],
              [72.781523, 19.263249],
              [72.790598, 19.260077],
              [72.79586, 19.259684],
              [72.800335, 19.260957],
              [72.805591, 19.256396],
              [72.818203, 19.245473],
              [72.824788, 19.244677],
              [72.829087, 19.245429],
              [72.835256, 19.249282],
              [72.837009, 19.25284],
              [72.838084, 19.263856],
              [72.842203, 19.265989],
              [72.856356, 19.269182],
              [72.856478, 19.269217],
              [72.867002, 19.26498],
              [72.873787, 19.259702],
              [72.888489, 19.251155],
              [72.892727, 19.249669],
              [72.907614, 19.246755],
              [72.906764, 19.241871],
              [72.911424, 19.234189],
              [72.921832, 19.221447],
              [72.927466, 19.213243],
              [72.937264, 19.205038],
              [72.937335, 19.189713],
              [72.948342, 19.186604],
              [72.955895, 19.183341],
              [72.963518, 19.181441],
              [72.971138, 19.176744],
              [72.972941, 19.173559],
              [72.974534, 19.170766],
              [72.979737, 19.161553],
              [72.982869, 19.15602],
              [72.983351, 19.151311],
              [72.982508, 19.144875],
              [72.979607, 19.13374],
              [72.973139, 19.120014],
              [72.970299, 19.111746],
              [72.967762, 19.093551],
              [72.969395, 19.081432],
              [72.968725, 19.074722],
              [72.970303, 19.066805],
              [72.971987, 19.05963],
              [72.97804, 19.047232],
              [72.979184, 19.041036],
              [72.978525, 19.032716],
              [72.975019, 19.02462],
              [72.961547, 18.999788],
              [72.958587, 18.987335],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 383,
        censuscode: 518,
        dt_cen_cd: 22,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Mumbai Suburban",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [75.618891, 21.390876],
              [75.620477, 21.385606],
              [75.622953, 21.382006],
              [75.626169, 21.379739],
              [75.628824, 21.378957],
              [75.632033, 21.379499],
              [75.639248, 21.379214],
              [75.64518, 21.380194],
              [75.654319, 21.379751],
              [75.658257, 21.38047],
              [75.672899, 21.378073],
              [75.674556, 21.379175],
              [75.677956, 21.379889],
              [75.684307, 21.379945],
              [75.687335, 21.382044],
              [75.689236, 21.385219],
              [75.694362, 21.387267],
              [75.706337, 21.38903],
              [75.713433, 21.389317],
              [75.721215, 21.388694],
              [75.722324, 21.386861],
              [75.732572, 21.391028],
              [75.735217, 21.390411],
              [75.737998, 21.391125],
              [75.743742, 21.390887],
              [75.74578, 21.389414],
              [75.754366, 21.386087],
              [75.758644, 21.383197],
              [75.759834, 21.383403],
              [75.773569, 21.384349],
              [75.792017, 21.386908],
              [75.801208, 21.387841],
              [75.805294, 21.386719],
              [75.812327, 21.385019],
              [75.83252, 21.380995],
              [75.843328, 21.38714],
              [75.846545, 21.385825],
              [75.851299, 21.387033],
              [75.859272, 21.384982],
              [75.862734, 21.384985],
              [75.868171, 21.388191],
              [75.872249, 21.393175],
              [75.876147, 21.395857],
              [75.882146, 21.396102],
              [75.888137, 21.397304],
              [75.895683, 21.396413],
              [75.8971, 21.394932],
              [75.905133, 21.393314],
              [75.912355, 21.38833],
              [75.916623, 21.387507],
              [75.932468, 21.389198],
              [75.937548, 21.390546],
              [75.948137, 21.390659],
              [75.959597, 21.393855],
              [75.968952, 21.391641],
              [75.98512, 21.374863],
              [75.991886, 21.373771],
              [76.00052, 21.372493],
              [76.016289, 21.367568],
              [76.027833, 21.365827],
              [76.034956, 21.362959],
              [76.042391, 21.356586],
              [76.047415, 21.352898],
              [76.052769, 21.350401],
              [76.066103, 21.35688],
              [76.077704, 21.361951],
              [76.088637, 21.367667],
              [76.095548, 21.370353],
              [76.099179, 21.37161],
              [76.107481, 21.35789],
              [76.116509, 21.33649],
              [76.122787, 21.319364],
              [76.127817, 21.305074],
              [76.129806, 21.295252],
              [76.135527, 21.289248],
              [76.140445, 21.28676],
              [76.145569, 21.285525],
              [76.14773, 21.279125],
              [76.150376, 21.271979],
              [76.154447, 21.266585],
              [76.156621, 21.260987],
              [76.159808, 21.256921],
              [76.158669, 21.251332],
              [76.154865, 21.246929],
              [76.151484, 21.24341],
              [76.144675, 21.240372],
              [76.144653, 21.239274],
              [76.144951, 21.235887],
              [76.146083, 21.230987],
              [76.148558, 21.229445],
              [76.153854, 21.227624],
              [76.15992, 21.225052],
              [76.164633, 21.221974],
              [76.16373, 21.219758],
              [76.162097, 21.2145],
              [76.164874, 21.209625],
              [76.168535, 21.205936],
              [76.168297, 21.2037],
              [76.167643, 21.201407],
              [76.166287, 21.197875],
              [76.166488, 21.193324],
              [76.169663, 21.189709],
              [76.173317, 21.18613],
              [76.171229, 21.180018],
              [76.169713, 21.172333],
              [76.167425, 21.168579],
              [76.161458, 21.169849],
              [76.1556, 21.170412],
              [76.143498, 21.170981],
              [76.131197, 21.173403],
              [76.127882, 21.175768],
              [76.119856, 21.172526],
              [76.114762, 21.16831],
              [76.114393, 21.162504],
              [76.119376, 21.157984],
              [76.124555, 21.156963],
              [76.128903, 21.154571],
              [76.132173, 21.150546],
              [76.140398, 21.137948],
              [76.141414, 21.133899],
              [76.13984, 21.131518],
              [76.134637, 21.128211],
              [76.136135, 21.124099],
              [76.142625, 21.118964],
              [76.151971, 21.112911],
              [76.162743, 21.107869],
              [76.167989, 21.104206],
              [76.16901, 21.103323],
              [76.169652, 21.101637],
              [76.169852, 21.099334],
              [76.169806, 21.096579],
              [76.168674, 21.091147],
              [76.167569, 21.087495],
              [76.169175, 21.083744],
              [76.173185, 21.082528],
              [76.177844, 21.083418],
              [76.181351, 21.08535],
              [76.184439, 21.087874],
              [76.189643, 21.088232],
              [76.20931, 21.088109],
              [76.228163, 21.089378],
              [76.235799, 21.091836],
              [76.262875, 21.092625],
              [76.270015, 21.090881],
              [76.274032, 21.083344],
              [76.27855, 21.075967],
              [76.282551, 21.073255],
              [76.286573, 21.07444],
              [76.297943, 21.075131],
              [76.335743, 21.075136],
              [76.357956, 21.077621],
              [76.362299, 21.077949],
              [76.366781, 21.077022],
              [76.369613, 21.076658],
              [76.372995, 21.07651],
              [76.377374, 21.075265],
              [76.380641, 21.076437],
              [76.382067, 21.077023],
              [76.383794, 21.077511],
              [76.383528, 21.077282],
              [76.384546, 21.076176],
              [76.385536, 21.074567],
              [76.386384, 21.072627],
              [76.386967, 21.070476],
              [76.38767, 21.067557],
              [76.38743, 21.065568],
              [76.387027, 21.062376],
              [76.387508, 21.059116],
              [76.388721, 21.055284],
              [76.390669, 21.04954],
              [76.393156, 21.045995],
              [76.394829, 21.043773],
              [76.39556, 21.042033],
              [76.396515, 21.04008],
              [76.397358, 21.036403],
              [76.398041, 21.032551],
              [76.398154, 21.030318],
              [76.39691, 21.028466],
              [76.396222, 21.026646],
              [76.394939, 21.025004],
              [76.394085, 21.022892],
              [76.393558, 21.020551],
              [76.394256, 21.018663],
              [76.394794, 21.015922],
              [76.394407, 21.014139],
              [76.393862, 21.012444],
              [76.392455, 21.010494],
              [76.390146, 21.00063],
              [76.386985, 20.99287],
              [76.383684, 20.987959],
              [76.383313, 20.977512],
              [76.379715, 20.976613],
              [76.376106, 20.976634],
              [76.36797, 20.977813],
              [76.36723, 20.973272],
              [76.365369, 20.970036],
              [76.3603, 20.964994],
              [76.353971, 20.962397],
              [76.35439, 20.958105],
              [76.353797, 20.955919],
              [76.346893, 20.956248],
              [76.346905, 20.949767],
              [76.338883, 20.951224],
              [76.320203, 20.950497],
              [76.314567, 20.951647],
              [76.29886, 20.957201],
              [76.293051, 20.957595],
              [76.288521, 20.958059],
              [76.284686, 20.957444],
              [76.280576, 20.958198],
              [76.27862, 20.96827],
              [76.276321, 20.971799],
              [76.27287, 20.974053],
              [76.267186, 20.979894],
              [76.258813, 20.984906],
              [76.252239, 20.9877],
              [76.247032, 20.988154],
              [76.239549, 20.990703],
              [76.232281, 21.000469],
              [76.230278, 21.007914],
              [76.2283, 21.00991],
              [76.225809, 21.011913],
              [76.220779, 21.012999],
              [76.215027, 21.013386],
              [76.212813, 21.013512],
              [76.207735, 21.013298],
              [76.203876, 21.014043],
              [76.200459, 21.014849],
              [76.197608, 21.016765],
              [76.195603, 21.018658],
              [76.193398, 21.021535],
              [76.191457, 21.023497],
              [76.188619, 21.025606],
              [76.186172, 21.026837],
              [76.182908, 21.028119],
              [76.177422, 21.03019],
              [76.17386, 21.032253],
              [76.170488, 21.035123],
              [76.170073, 21.036516],
              [76.168499, 21.03906],
              [76.167343, 21.040155],
              [76.166506, 21.040024],
              [76.165935, 21.038067],
              [76.165067, 21.036402],
              [76.164236, 21.033185],
              [76.164978, 21.030148],
              [76.165177, 21.027457],
              [76.165155, 21.022622],
              [76.163816, 21.020306],
              [76.16363, 21.01471],
              [76.162407, 21.010666],
              [76.162314, 21.008305],
              [76.15943, 21.000347],
              [76.156529, 20.997638],
              [76.147559, 20.991856],
              [76.144706, 20.985851],
              [76.132149, 20.978759],
              [76.124658, 20.977241],
              [76.122655, 20.975266],
              [76.117261, 20.962753],
              [76.116414, 20.957812],
              [76.113305, 20.952552],
              [76.109747, 20.948774],
              [76.104573, 20.947227],
              [76.100387, 20.944825],
              [76.092143, 20.943496],
              [76.092819, 20.939794],
              [76.090206, 20.933799],
              [76.089652, 20.929266],
              [76.084115, 20.927527],
              [76.080715, 20.908039],
              [76.093081, 20.90585],
              [76.100925, 20.903305],
              [76.10407, 20.901106],
              [76.105148, 20.898249],
              [76.11155, 20.894431],
              [76.115413, 20.893275],
              [76.115212, 20.890286],
              [76.111655, 20.881702],
              [76.107726, 20.878207],
              [76.0987, 20.872538],
              [76.082823, 20.854097],
              [76.080851, 20.850861],
              [76.080365, 20.846211],
              [76.075555, 20.844889],
              [76.075465, 20.837943],
              [76.073906, 20.8358],
              [76.073938, 20.833564],
              [76.068065, 20.829539],
              [76.066879, 20.827347],
              [76.065562, 20.825316],
              [76.061207, 20.826754],
              [76.058295, 20.825111],
              [76.056351, 20.819987],
              [76.054791, 20.818306],
              [76.051082, 20.816474],
              [76.049735, 20.812498],
              [76.052361, 20.807888],
              [76.057548, 20.803538],
              [76.050853, 20.797424],
              [76.0499, 20.795067],
              [76.050727, 20.792781],
              [76.049418, 20.790584],
              [76.049933, 20.788237],
              [76.042985, 20.783396],
              [76.035568, 20.785705],
              [76.01855, 20.784685],
              [76.012314, 20.785522],
              [76.01207, 20.780533],
              [76.000024, 20.779342],
              [75.997982, 20.777942],
              [75.997061, 20.771287],
              [75.997519, 20.767872],
              [75.996204, 20.764918],
              [75.990324, 20.763127],
              [75.986907, 20.758846],
              [75.98836, 20.754006],
              [75.991322, 20.750849],
              [76.000027, 20.743198],
              [76.002471, 20.74221],
              [76.007047, 20.741858],
              [76.012152, 20.738656],
              [76.012611, 20.731779],
              [76.016033, 20.731419],
              [76.016367, 20.729415],
              [76.014413, 20.729338],
              [76.016247, 20.724947],
              [76.017355, 20.724043],
              [76.013319, 20.72043],
              [76.000023, 20.715617],
              [75.998718, 20.712691],
              [75.998885, 20.709026],
              [75.997071, 20.696561],
              [75.998847, 20.693834],
              [76.000031, 20.690834],
              [76.003495, 20.688644],
              [76.003871, 20.683771],
              [76.003661, 20.680844],
              [76.000027, 20.674256],
              [75.99923, 20.672659],
              [75.998138, 20.667358],
              [76.000028, 20.658936],
              [76.002577, 20.65811],
              [76.004368, 20.655954],
              [76.006362, 20.652941],
              [76.006713, 20.649502],
              [76.008843, 20.645453],
              [76.011074, 20.643022],
              [76.010618, 20.639265],
              [76.008601, 20.63589],
              [76.001672, 20.634074],
              [76.000025, 20.632609],
              [75.99844, 20.629417],
              [75.993191, 20.626765],
              [75.991077, 20.623145],
              [75.987913, 20.622844],
              [75.972932, 20.624165],
              [75.961543, 20.623853],
              [75.95715, 20.624974],
              [75.956644, 20.615933],
              [75.954924, 20.606465],
              [75.951425, 20.603442],
              [75.948338, 20.601907],
              [75.933518, 20.599697],
              [75.933799, 20.595696],
              [75.93528, 20.593703],
              [75.935541, 20.581591],
              [75.934605, 20.57809],
              [75.933695, 20.554821],
              [75.931666, 20.550881],
              [75.929671, 20.549861],
              [75.922774, 20.552343],
              [75.921215, 20.555852],
              [75.914558, 20.558239],
              [75.889526, 20.563359],
              [75.888683, 20.568101],
              [75.888942, 20.577557],
              [75.887396, 20.596833],
              [75.871777, 20.600824],
              [75.86916, 20.623565],
              [75.856067, 20.624806],
              [75.855889, 20.618298],
              [75.843357, 20.618454],
              [75.840756, 20.616544],
              [75.839446, 20.609173],
              [75.840728, 20.603021],
              [75.845376, 20.595589],
              [75.833943, 20.595283],
              [75.834481, 20.580559],
              [75.829618, 20.574348],
              [75.837603, 20.573076],
              [75.849067, 20.569986],
              [75.845932, 20.56761],
              [75.838013, 20.563666],
              [75.826485, 20.560796],
              [75.820579, 20.561694],
              [75.817256, 20.564835],
              [75.81102, 20.568405],
              [75.805699, 20.569917],
              [75.789208, 20.565366],
              [75.788024, 20.568104],
              [75.791325, 20.57732],
              [75.789699, 20.586594],
              [75.785135, 20.586783],
              [75.772318, 20.579263],
              [75.766854, 20.578409],
              [75.759783, 20.579946],
              [75.759035, 20.586533],
              [75.760199, 20.601236],
              [75.75871, 20.614193],
              [75.751335, 20.615899],
              [75.733392, 20.610096],
              [75.731019, 20.610419],
              [75.72438, 20.620516],
              [75.706496, 20.615337],
              [75.703118, 20.617718],
              [75.700085, 20.622505],
              [75.699551, 20.631283],
              [75.702365, 20.645313],
              [75.703062, 20.652844],
              [75.705877, 20.661535],
              [75.700973, 20.664522],
              [75.689786, 20.668323],
              [75.674739, 20.669373],
              [75.669433, 20.670473],
              [75.666701, 20.669925],
              [75.660608, 20.666021],
              [75.65798, 20.66186],
              [75.656266, 20.652489],
              [75.66058, 20.653509],
              [75.662531, 20.643428],
              [75.660596, 20.642139],
              [75.662747, 20.63539],
              [75.66234, 20.628551],
              [75.659998, 20.626638],
              [75.654339, 20.626343],
              [75.652797, 20.623231],
              [75.648335, 20.620031],
              [75.63324, 20.619701],
              [75.624838, 20.625237],
              [75.614994, 20.624153],
              [75.608938, 20.621971],
              [75.610911, 20.615158],
              [75.614941, 20.609227],
              [75.611568, 20.606956],
              [75.605081, 20.60482],
              [75.590323, 20.602651],
              [75.585506, 20.603576],
              [75.581874, 20.60692],
              [75.578174, 20.605793],
              [75.572727, 20.608837],
              [75.571177, 20.610539],
              [75.564949, 20.61271],
              [75.558909, 20.613444],
              [75.557605, 20.611308],
              [75.557558, 20.605275],
              [75.55562, 20.604281],
              [75.543827, 20.608917],
              [75.541427, 20.610619],
              [75.536741, 20.609651],
              [75.533631, 20.596454],
              [75.525734, 20.595164],
              [75.522518, 20.590357],
              [75.525501, 20.576309],
              [75.525091, 20.570279],
              [75.526108, 20.567073],
              [75.526196, 20.560688],
              [75.518617, 20.558538],
              [75.513798, 20.554573],
              [75.508637, 20.554349],
              [75.506368, 20.550761],
              [75.506296, 20.547481],
              [75.505407, 20.545233],
              [75.502678, 20.544911],
              [75.498813, 20.542571],
              [75.497996, 20.540087],
              [75.497799, 20.532162],
              [75.49567, 20.527769],
              [75.489727, 20.530971],
              [75.487168, 20.540085],
              [75.484704, 20.543098],
              [75.473329, 20.542675],
              [75.468991, 20.54441],
              [75.46826, 20.548935],
              [75.464434, 20.552975],
              [75.460909, 20.552931],
              [75.461371, 20.536795],
              [75.463384, 20.52728],
              [75.463523, 20.521709],
              [75.462584, 20.518943],
              [75.458614, 20.516016],
              [75.451864, 20.529042],
              [75.450985, 20.540288],
              [75.439214, 20.538023],
              [75.435569, 20.533215],
              [75.430584, 20.533042],
              [75.428531, 20.532096],
              [75.427233, 20.529093],
              [75.430382, 20.525511],
              [75.432414, 20.519616],
              [75.434277, 20.516708],
              [75.434202, 20.51326],
              [75.425049, 20.515391],
              [75.41967, 20.51786],
              [75.412661, 20.523407],
              [75.406718, 20.522067],
              [75.397323, 20.524083],
              [75.395864, 20.532975],
              [75.395586, 20.566235],
              [75.394131, 20.574437],
              [75.391261, 20.579633],
              [75.386094, 20.579506],
              [75.372698, 20.575441],
              [75.37025, 20.576906],
              [75.365051, 20.583508],
              [75.364047, 20.58952],
              [75.362223, 20.594099],
              [75.362544, 20.596865],
              [75.358909, 20.591355],
              [75.353093, 20.58956],
              [75.350654, 20.590225],
              [75.343423, 20.589729],
              [75.32879, 20.592196],
              [75.321313, 20.591532],
              [75.317908, 20.586952],
              [75.318063, 20.576664],
              [75.312016, 20.577738],
              [75.307216, 20.577735],
              [75.300661, 20.576448],
              [75.298015, 20.574865],
              [75.295826, 20.570181],
              [75.292924, 20.569167],
              [75.285516, 20.568384],
              [75.274555, 20.56917],
              [75.2668, 20.571133],
              [75.259992, 20.578919],
              [75.254829, 20.570068],
              [75.252193, 20.555209],
              [75.244958, 20.551596],
              [75.246881, 20.548588],
              [75.247389, 20.542794],
              [75.24367, 20.539236],
              [75.242634, 20.539052],
              [75.243081, 20.533715],
              [75.239555, 20.521605],
              [75.237964, 20.521984],
              [75.23168, 20.51984],
              [75.228501, 20.51664],
              [75.227374, 20.514433],
              [75.226672, 20.50863],
              [75.228241, 20.501059],
              [75.23116, 20.493053],
              [75.230014, 20.492347],
              [75.225622, 20.493446],
              [75.221084, 20.496195],
              [75.211691, 20.498319],
              [75.213049, 20.492821],
              [75.210095, 20.491342],
              [75.203323, 20.492286],
              [75.202175, 20.491819],
              [75.200821, 20.48525],
              [75.200583, 20.480764],
              [75.201321, 20.476286],
              [75.18913, 20.474121],
              [75.182609, 20.47558],
              [75.178927, 20.477606],
              [75.17286, 20.47649],
              [75.167933, 20.476715],
              [75.16345, 20.475967],
              [75.162669, 20.475148],
              [75.162053, 20.454868],
              [75.16146, 20.449519],
              [75.162772, 20.442638],
              [75.161473, 20.436585],
              [75.155435, 20.433979],
              [75.148759, 20.433489],
              [75.141025, 20.434588],
              [75.134873, 20.431581],
              [75.129466, 20.431507],
              [75.125852, 20.429038],
              [75.124949, 20.424606],
              [75.121118, 20.424669],
              [75.117444, 20.41847],
              [75.114333, 20.41481],
              [75.108432, 20.411859],
              [75.108078, 20.407027],
              [75.113769, 20.396124],
              [75.11635, 20.394207],
              [75.118469, 20.386074],
              [75.122524, 20.375095],
              [75.126432, 20.357333],
              [75.125456, 20.349392],
              [75.122691, 20.347569],
              [75.111091, 20.347478],
              [75.104384, 20.345252],
              [75.099616, 20.343063],
              [75.097192, 20.338834],
              [75.092334, 20.334633],
              [75.075012, 20.335894],
              [75.069327, 20.335067],
              [75.062591, 20.335095],
              [75.059456, 20.334011],
              [75.057398, 20.329681],
              [75.056229, 20.322363],
              [75.057389, 20.313809],
              [75.056509, 20.307308],
              [75.048254, 20.307706],
              [75.033305, 20.316416],
              [75.024885, 20.323084],
              [75.012597, 20.329799],
              [75.000025, 20.336852],
              [74.995391, 20.335896],
              [74.991922, 20.333728],
              [74.988932, 20.3303],
              [74.985386, 20.317402],
              [74.987469, 20.302375],
              [74.971015, 20.304068],
              [74.953623, 20.28979],
              [74.944383, 20.279863],
              [74.948992, 20.273168],
              [74.943465, 20.270504],
              [74.934923, 20.269694],
              [74.937873, 20.271666],
              [74.932022, 20.271951],
              [74.923415, 20.273678],
              [74.918179, 20.277644],
              [74.913827, 20.274345],
              [74.908957, 20.27276],
              [74.870154, 20.277006],
              [74.86306, 20.279713],
              [74.859727, 20.281809],
              [74.857042, 20.285502],
              [74.859351, 20.296079],
              [74.861179, 20.30076],
              [74.858941, 20.313163],
              [74.863468, 20.314264],
              [74.866661, 20.31624],
              [74.867669, 20.335087],
              [74.86108, 20.334697],
              [74.860373, 20.341872],
              [74.858796, 20.347791],
              [74.856274, 20.35057],
              [74.856979, 20.363979],
              [74.853242, 20.367742],
              [74.851812, 20.370913],
              [74.854157, 20.373586],
              [74.850724, 20.382738],
              [74.847151, 20.384547],
              [74.843661, 20.387914],
              [74.834886, 20.393791],
              [74.829708, 20.399462],
              [74.828644, 20.402514],
              [74.832017, 20.404259],
              [74.840944, 20.406401],
              [74.842075, 20.409888],
              [74.837897, 20.417441],
              [74.830558, 20.421305],
              [74.827922, 20.425626],
              [74.819548, 20.429099],
              [74.818641, 20.440454],
              [74.807938, 20.442914],
              [74.80625, 20.44471],
              [74.804207, 20.44777],
              [74.802503, 20.452882],
              [74.801869, 20.462409],
              [74.800609, 20.469068],
              [74.799298, 20.472006],
              [74.795451, 20.476977],
              [74.790762, 20.471918],
              [74.784574, 20.469805],
              [74.775228, 20.468459],
              [74.77354, 20.470597],
              [74.779773, 20.48263],
              [74.783489, 20.487579],
              [74.785437, 20.492948],
              [74.78619, 20.500113],
              [74.783955, 20.507583],
              [74.774589, 20.504578],
              [74.772864, 20.509008],
              [74.770776, 20.518427],
              [74.766805, 20.524194],
              [74.762586, 20.528242],
              [74.761903, 20.538624],
              [74.770633, 20.539341],
              [74.787706, 20.538546],
              [74.795768, 20.539496],
              [74.799345, 20.548176],
              [74.799318, 20.55173],
              [74.796271, 20.557606],
              [74.795632, 20.560705],
              [74.794577, 20.570398],
              [74.795491, 20.575376],
              [74.802162, 20.588488],
              [74.807987, 20.584937],
              [74.810448, 20.586972],
              [74.81236, 20.594632],
              [74.814926, 20.633747],
              [74.828667, 20.631993],
              [74.836139, 20.633475],
              [74.840658, 20.633313],
              [74.843451, 20.637415],
              [74.856485, 20.635177],
              [74.868429, 20.638095],
              [74.876411, 20.641918],
              [74.887365, 20.644152],
              [74.891732, 20.646284],
              [74.897714, 20.651661],
              [74.900961, 20.65793],
              [74.914196, 20.65724],
              [74.929459, 20.657447],
              [74.932172, 20.66033],
              [74.934058, 20.664783],
              [74.937088, 20.669228],
              [74.941227, 20.673833],
              [74.942364, 20.682608],
              [74.954829, 20.691473],
              [74.955958, 20.694189],
              [74.953335, 20.698799],
              [74.952595, 20.704022],
              [74.953473, 20.711799],
              [74.960208, 20.715652],
              [74.957668, 20.717034],
              [74.954088, 20.717344],
              [74.950758, 20.719249],
              [74.951016, 20.72045],
              [74.961033, 20.719292],
              [74.964876, 20.720291],
              [74.971798, 20.725645],
              [74.983865, 20.732492],
              [74.989065, 20.733592],
              [74.991206, 20.736417],
              [74.994256, 20.748726],
              [74.992654, 20.761774],
              [74.990363, 20.766418],
              [74.98846, 20.773117],
              [74.984022, 20.777957],
              [74.973981, 20.783766],
              [74.968052, 20.797081],
              [74.965364, 20.801054],
              [74.963057, 20.802447],
              [74.96193, 20.804862],
              [74.96288, 20.807816],
              [74.968006, 20.811769],
              [74.968338, 20.819199],
              [74.974841, 20.821245],
              [74.982543, 20.821385],
              [74.986463, 20.822257],
              [74.98352, 20.830871],
              [74.983436, 20.834642],
              [74.981679, 20.840446],
              [74.981952, 20.843249],
              [74.967569, 20.851527],
              [74.966834, 20.856686],
              [74.970307, 20.877286],
              [74.967795, 20.883062],
              [74.960795, 20.887165],
              [74.960119, 20.894308],
              [74.962269, 20.902531],
              [74.961985, 20.905124],
              [74.955935, 20.90019],
              [74.949992, 20.911645],
              [74.9457, 20.914363],
              [74.934631, 20.917322],
              [74.935078, 20.925882],
              [74.914152, 20.926828],
              [74.911816, 20.945905],
              [74.912629, 20.962026],
              [74.918315, 20.962442],
              [74.930222, 20.960921],
              [74.930782, 20.967156],
              [74.928624, 20.971945],
              [74.929769, 20.977682],
              [74.926534, 20.980947],
              [74.919141, 20.98584],
              [74.916598, 20.98992],
              [74.91642, 21.000201],
              [74.918292, 21.006791],
              [74.921211, 21.010568],
              [74.910183, 21.031989],
              [74.905705, 21.03571],
              [74.894252, 21.039756],
              [74.891106, 21.052448],
              [74.864862, 21.051229],
              [74.858108, 21.063058],
              [74.859521, 21.065447],
              [74.868192, 21.072824],
              [74.874123, 21.088215],
              [74.872762, 21.092709],
              [74.87005, 21.097112],
              [74.870888, 21.101426],
              [74.874561, 21.10488],
              [74.886694, 21.113278],
              [74.884971, 21.127752],
              [74.886345, 21.137249],
              [74.888813, 21.145051],
              [74.892967, 21.1514],
              [74.8984, 21.155767],
              [74.902854, 21.157875],
              [74.913455, 21.166023],
              [74.918738, 21.166586],
              [74.928151, 21.165639],
              [74.93206, 21.166919],
              [74.936633, 21.171776],
              [74.952196, 21.181601],
              [74.9588, 21.186896],
              [74.963432, 21.191756],
              [74.964208, 21.196581],
              [74.962747, 21.199306],
              [74.958199, 21.200576],
              [74.953683, 21.2003],
              [74.951891, 21.200942],
              [74.952441, 21.202608],
              [74.95552, 21.203996],
              [74.958129, 21.206468],
              [74.959523, 21.208902],
              [74.959004, 21.21164],
              [74.95724, 21.213022],
              [74.949346, 21.216218],
              [74.944101, 21.221499],
              [74.94376, 21.224966],
              [74.952929, 21.221269],
              [74.96397, 21.222579],
              [74.97368, 21.220878],
              [74.980004, 21.209721],
              [74.990238, 21.195148],
              [74.999217, 21.187357],
              [75.002461, 21.187886],
              [75.004797, 21.189211],
              [75.009543, 21.191947],
              [75.01385, 21.192801],
              [75.017287, 21.192455],
              [75.019177, 21.193298],
              [75.024552, 21.19351],
              [75.032886, 21.192102],
              [75.038582, 21.202776],
              [75.039712, 21.207049],
              [75.041912, 21.211166],
              [75.047711, 21.213352],
              [75.055305, 21.213897],
              [75.058038, 21.218556],
              [75.064549, 21.223648],
              [75.067346, 21.224872],
              [75.079107, 21.227856],
              [75.089002, 21.228017],
              [75.092279, 21.232073],
              [75.09717, 21.232703],
              [75.104386, 21.236002],
              [75.11913, 21.261745],
              [75.12606, 21.264753],
              [75.128744, 21.267538],
              [75.130272, 21.26991],
              [75.130609, 21.272901],
              [75.128769, 21.28145],
              [75.130282, 21.285019],
              [75.139569, 21.293753],
              [75.138569, 21.305232],
              [75.135425, 21.313693],
              [75.136753, 21.316704],
              [75.149249, 21.318277],
              [75.151981, 21.323026],
              [75.144836, 21.331849],
              [75.125627, 21.339263],
              [75.123337, 21.340791],
              [75.121524, 21.343821],
              [75.125311, 21.348748],
              [75.128748, 21.350157],
              [75.135411, 21.349319],
              [75.140783, 21.347769],
              [75.148225, 21.349121],
              [75.149054, 21.354189],
              [75.138531, 21.360618],
              [75.136094, 21.365641],
              [75.141566, 21.38415],
              [75.152079, 21.388352],
              [75.154712, 21.391485],
              [75.157148, 21.395704],
              [75.157928, 21.398697],
              [75.161053, 21.402754],
              [75.165678, 21.402744],
              [75.172411, 21.401326],
              [75.177884, 21.403168],
              [75.181936, 21.405517],
              [75.183276, 21.407717],
              [75.190227, 21.411468],
              [75.192997, 21.412478],
              [75.205718, 21.41368],
              [75.208822, 21.41206],
              [75.218153, 21.408713],
              [75.230601, 21.414425],
              [75.234738, 21.414925],
              [75.241845, 21.412765],
              [75.246057, 21.408494],
              [75.252381, 21.403971],
              [75.257505, 21.403048],
              [75.265454, 21.406694],
              [75.275086, 21.406684],
              [75.287048, 21.409621],
              [75.290129, 21.411723],
              [75.298148, 21.41347],
              [75.300375, 21.41263],
              [75.301676, 21.39301],
              [75.300332, 21.390241],
              [75.300413, 21.387076],
              [75.30718, 21.392314],
              [75.310505, 21.393099],
              [75.319466, 21.390209],
              [75.325393, 21.392046],
              [75.333479, 21.392479],
              [75.352425, 21.391291],
              [75.356678, 21.393975],
              [75.360051, 21.401017],
              [75.36562, 21.396702],
              [75.377378, 21.390218],
              [75.380038, 21.385425],
              [75.383199, 21.383391],
              [75.391844, 21.381863],
              [75.394124, 21.382462],
              [75.397159, 21.380771],
              [75.399688, 21.381767],
              [75.40259, 21.38157],
              [75.408056, 21.387706],
              [75.412189, 21.388847],
              [75.418802, 21.388049],
              [75.430521, 21.391721],
              [75.435158, 21.388496],
              [75.442508, 21.38879],
              [75.445034, 21.388245],
              [75.448981, 21.390176],
              [75.453369, 21.389817],
              [75.458976, 21.390787],
              [75.464536, 21.389123],
              [75.467378, 21.391963],
              [75.483801, 21.389019],
              [75.495464, 21.388492],
              [75.499535, 21.389332],
              [75.509183, 21.385751],
              [75.515353, 21.384487],
              [75.523685, 21.38491],
              [75.528506, 21.382485],
              [75.539085, 21.374943],
              [75.544453, 21.373553],
              [75.546308, 21.370418],
              [75.5473, 21.370247],
              [75.5505, 21.373205],
              [75.554512, 21.3752],
              [75.55901, 21.380008],
              [75.560312, 21.378923],
              [75.559453, 21.376563],
              [75.563401, 21.375849],
              [75.565189, 21.376901],
              [75.571293, 21.375983],
              [75.580488, 21.377611],
              [75.580794, 21.378592],
              [75.575789, 21.38326],
              [75.584127, 21.385339],
              [75.587013, 21.386632],
              [75.590526, 21.389472],
              [75.602261, 21.388257],
              [75.608239, 21.392732],
              [75.6188, 21.39118],
              [75.618891, 21.390876],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 245,
        censuscode: 499,
        dt_cen_cd: 3,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Jalgaon",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [76.026249, 20.643784],
              [76.032844, 20.638478],
              [76.033755, 20.63407],
              [76.031612, 20.62544],
              [76.0343, 20.616528],
              [76.038158, 20.610781],
              [76.039961, 20.603516],
              [76.040342, 20.597208],
              [76.038847, 20.595243],
              [76.038643, 20.588009],
              [76.042136, 20.581631],
              [76.041867, 20.578933],
              [76.037843, 20.570156],
              [76.038062, 20.567468],
              [76.039759, 20.563642],
              [76.03988, 20.559404],
              [76.040301, 20.555048],
              [76.036228, 20.554133],
              [76.032255, 20.555345],
              [76.02613, 20.553085],
              [76.021138, 20.552221],
              [76.018487, 20.550294],
              [76.019448, 20.54675],
              [76.019652, 20.535732],
              [76.018451, 20.530272],
              [76.013854, 20.532105],
              [76.01213, 20.533747],
              [76.01159, 20.537012],
              [76.008565, 20.535878],
              [76.001985, 20.530744],
              [76.000021, 20.530546],
              [75.998878, 20.529902],
              [75.994792, 20.533585],
              [75.990764, 20.530404],
              [75.983272, 20.529458],
              [75.973985, 20.533465],
              [75.973427, 20.529393],
              [75.970758, 20.52298],
              [75.958558, 20.527394],
              [75.957911, 20.524423],
              [75.956419, 20.522191],
              [75.954193, 20.52047],
              [75.950552, 20.51955],
              [75.949349, 20.513142],
              [75.944338, 20.503917],
              [75.942421, 20.495611],
              [75.944162, 20.486351],
              [75.947611, 20.481851],
              [75.950746, 20.473519],
              [75.95536, 20.473384],
              [75.954583, 20.46644],
              [75.95818, 20.46573],
              [75.957673, 20.456727],
              [75.949078, 20.446676],
              [75.94482, 20.436196],
              [75.942201, 20.425553],
              [75.945197, 20.423226],
              [75.94834, 20.413607],
              [75.949307, 20.408849],
              [75.948482, 20.400636],
              [75.950553, 20.394386],
              [75.953694, 20.389931],
              [75.965158, 20.380381],
              [75.968141, 20.373618],
              [75.960307, 20.373542],
              [75.960124, 20.368351],
              [75.953282, 20.371746],
              [75.94217, 20.371231],
              [75.944407, 20.361144],
              [75.944678, 20.351566],
              [75.942435, 20.345097],
              [75.937937, 20.340203],
              [75.934191, 20.338017],
              [75.932689, 20.331402],
              [75.929624, 20.328233],
              [75.92663, 20.323306],
              [75.926237, 20.320143],
              [75.927071, 20.309778],
              [75.928139, 20.306915],
              [75.932924, 20.304054],
              [75.94588, 20.300363],
              [75.950805, 20.300619],
              [75.955204, 20.303189],
              [75.969132, 20.313546],
              [75.975292, 20.316453],
              [75.97792, 20.314847],
              [75.978257, 20.312145],
              [75.980158, 20.310235],
              [75.984121, 20.309374],
              [75.994517, 20.309202],
              [75.995316, 20.311831],
              [75.997699, 20.313059],
              [76.000029, 20.311551],
              [76.004499, 20.305473],
              [76.004609, 20.302147],
              [76.002392, 20.299195],
              [76.002919, 20.296162],
              [76.001117, 20.290282],
              [76.002423, 20.287951],
              [76.008435, 20.288947],
              [76.017808, 20.288956],
              [76.018879, 20.286384],
              [76.026352, 20.287171],
              [76.031143, 20.28843],
              [76.030538, 20.292613],
              [76.030893, 20.297669],
              [76.033635, 20.306595],
              [76.036499, 20.310996],
              [76.037431, 20.314392],
              [76.045242, 20.326651],
              [76.049556, 20.335712],
              [76.053103, 20.339092],
              [76.056311, 20.340903],
              [76.065064, 20.341987],
              [76.068332, 20.343527],
              [76.069341, 20.345434],
              [76.072244, 20.346617],
              [76.07852, 20.355527],
              [76.080103, 20.36031],
              [76.083145, 20.364708],
              [76.087008, 20.362811],
              [76.087759, 20.360805],
              [76.092378, 20.357483],
              [76.091941, 20.348235],
              [76.095573, 20.345527],
              [76.097686, 20.346704],
              [76.100227, 20.352988],
              [76.104056, 20.353555],
              [76.108993, 20.35292],
              [76.113288, 20.345867],
              [76.116457, 20.345209],
              [76.119305, 20.346398],
              [76.121624, 20.345789],
              [76.122639, 20.342941],
              [76.12411, 20.341637],
              [76.12745, 20.342248],
              [76.128923, 20.341118],
              [76.128966, 20.337732],
              [76.126651, 20.328991],
              [76.126586, 20.324278],
              [76.131461, 20.319463],
              [76.129787, 20.316748],
              [76.126285, 20.31521],
              [76.12745, 20.313792],
              [76.129831, 20.313307],
              [76.132551, 20.314655],
              [76.133739, 20.317142],
              [76.136053, 20.317112],
              [76.141894, 20.312078],
              [76.145504, 20.310969],
              [76.148871, 20.306243],
              [76.142046, 20.301972],
              [76.141884, 20.299905],
              [76.145113, 20.299653],
              [76.152466, 20.300603],
              [76.156402, 20.302719],
              [76.160715, 20.297781],
              [76.167867, 20.295281],
              [76.172259, 20.294531],
              [76.176289, 20.298537],
              [76.177002, 20.300266],
              [76.183038, 20.298964],
              [76.184908, 20.300132],
              [76.191723, 20.300444],
              [76.192261, 20.301081],
              [76.194889, 20.300309],
              [76.191785, 20.290572],
              [76.188568, 20.284687],
              [76.183721, 20.267815],
              [76.178488, 20.263453],
              [76.172192, 20.256085],
              [76.170658, 20.251884],
              [76.170237, 20.24665],
              [76.166402, 20.236683],
              [76.153463, 20.235605],
              [76.149944, 20.234705],
              [76.146896, 20.231106],
              [76.138466, 20.229056],
              [76.138142, 20.225555],
              [76.134178, 20.221719],
              [76.135193, 20.2184],
              [76.140755, 20.210954],
              [76.151463, 20.205972],
              [76.151244, 20.204539],
              [76.143086, 20.199617],
              [76.13544, 20.198663],
              [76.132745, 20.190599],
              [76.133797, 20.183961],
              [76.13267, 20.182104],
              [76.128855, 20.180913],
              [76.128164, 20.177806],
              [76.126439, 20.174747],
              [76.126925, 20.170101],
              [76.125623, 20.167391],
              [76.122511, 20.168327],
              [76.121486, 20.167741],
              [76.1228, 20.159835],
              [76.118422, 20.159673],
              [76.110923, 20.161585],
              [76.10684, 20.152986],
              [76.109957, 20.142235],
              [76.109344, 20.137811],
              [76.107232, 20.132043],
              [76.102344, 20.129118],
              [76.101513, 20.123252],
              [76.102371, 20.11758],
              [76.098929, 20.106864],
              [76.097408, 20.097263],
              [76.095434, 20.095005],
              [76.092149, 20.095932],
              [76.089044, 20.100952],
              [76.085186, 20.098085],
              [76.078468, 20.101332],
              [76.071429, 20.100381],
              [76.065632, 20.097842],
              [76.061857, 20.098832],
              [76.057298, 20.098429],
              [76.056534, 20.096808],
              [76.055468, 20.08555],
              [76.061643, 20.087065],
              [76.066915, 20.083227],
              [76.070626, 20.074093],
              [76.068129, 20.069585],
              [76.060807, 20.066967],
              [76.057318, 20.063764],
              [76.02731, 20.060457],
              [76.019722, 20.058986],
              [76.024776, 20.044707],
              [76.024084, 20.03213],
              [76.024713, 20.023131],
              [76.013055, 20.023041],
              [76.009808, 20.018807],
              [76.008032, 20.014596],
              [76.003671, 20.012654],
              [76.000021, 20.013289],
              [75.99423, 20.004886],
              [75.985837, 20.00281],
              [75.976133, 20.000891],
              [75.968568, 20.002213],
              [75.968185, 20.001211],
              [75.967254, 20.00009],
              [75.966691, 19.994491],
              [75.969651, 19.989505],
              [75.974436, 19.984869],
              [75.984216, 19.981816],
              [75.988338, 19.981069],
              [75.990454, 19.975157],
              [75.994765, 19.976831],
              [76.00003, 19.973428],
              [76.005129, 19.971857],
              [76.011259, 19.971423],
              [76.013504, 19.971725],
              [76.016654, 19.973968],
              [76.016496, 19.966012],
              [76.014014, 19.953228],
              [76.028848, 19.948094],
              [76.037651, 19.947921],
              [76.042556, 19.950463],
              [76.04421, 19.945038],
              [76.048625, 19.947247],
              [76.053314, 19.941584],
              [76.05463, 19.940246],
              [76.049288, 19.937018],
              [76.051556, 19.931939],
              [76.058207, 19.93051],
              [76.060326, 19.924174],
              [76.061372, 19.918155],
              [76.063564, 19.915712],
              [76.080546, 19.911524],
              [76.080856, 19.889911],
              [76.081608, 19.884568],
              [76.083293, 19.880983],
              [76.093723, 19.870986],
              [76.096068, 19.866821],
              [76.100235, 19.855912],
              [76.109541, 19.860272],
              [76.120562, 19.859438],
              [76.121074, 19.86413],
              [76.129309, 19.862828],
              [76.135007, 19.856421],
              [76.137005, 19.850079],
              [76.14011, 19.844462],
              [76.14971, 19.845253],
              [76.149141, 19.853519],
              [76.149545, 19.855182],
              [76.151983, 19.855884],
              [76.169829, 19.850164],
              [76.17461, 19.849331],
              [76.187867, 19.850972],
              [76.193398, 19.854765],
              [76.19693, 19.858259],
              [76.198834, 19.862289],
              [76.209857, 19.861632],
              [76.212166, 19.864683],
              [76.214553, 19.8659],
              [76.230103, 19.863771],
              [76.24099, 19.870787],
              [76.248361, 19.869389],
              [76.252027, 19.870523],
              [76.256575, 19.873303],
              [76.262156, 19.873259],
              [76.283124, 19.871996],
              [76.294748, 19.870686],
              [76.29819, 19.869586],
              [76.301027, 19.875269],
              [76.305145, 19.877651],
              [76.308622, 19.878677],
              [76.310044, 19.876984],
              [76.312153, 19.875902],
              [76.31413, 19.874886],
              [76.318487, 19.877159],
              [76.320489, 19.877401],
              [76.32408, 19.880489],
              [76.327685, 19.881906],
              [76.334616, 19.882638],
              [76.339578, 19.881907],
              [76.343473, 19.888199],
              [76.34396, 19.891337],
              [76.345971, 19.891644],
              [76.347995, 19.88977],
              [76.353119, 19.89369],
              [76.354499, 19.896178],
              [76.354949, 19.900243],
              [76.357601, 19.908106],
              [76.366135, 19.921581],
              [76.366261, 19.924788],
              [76.36816, 19.925668],
              [76.373033, 19.923342],
              [76.378949, 19.918921],
              [76.383501, 19.918659],
              [76.387978, 19.906366],
              [76.390234, 19.904254],
              [76.39414, 19.905495],
              [76.399305, 19.908486],
              [76.403472, 19.915806],
              [76.408217, 19.919719],
              [76.417653, 19.917589],
              [76.440206, 19.916447],
              [76.447643, 19.918141],
              [76.451523, 19.920465],
              [76.465172, 19.917331],
              [76.482753, 19.919041],
              [76.490679, 19.918074],
              [76.493265, 19.916938],
              [76.491138, 19.90838],
              [76.49128, 19.903557],
              [76.492073, 19.898269],
              [76.495317, 19.891041],
              [76.500246, 19.883479],
              [76.511515, 19.874082],
              [76.515436, 19.87612],
              [76.519814, 19.870819],
              [76.52638, 19.868615],
              [76.533625, 19.864282],
              [76.530271, 19.860508],
              [76.532356, 19.855884],
              [76.532974, 19.850789],
              [76.533018, 19.850419],
              [76.530906, 19.847885],
              [76.520603, 19.848325],
              [76.52232, 19.841069],
              [76.518981, 19.839851],
              [76.518894, 19.839819],
              [76.521181, 19.836772],
              [76.521607, 19.836206],
              [76.517774, 19.835374],
              [76.518241, 19.831804],
              [76.512186, 19.829695],
              [76.511542, 19.827763],
              [76.511407, 19.827358],
              [76.515145, 19.825891],
              [76.515733, 19.82566],
              [76.510176, 19.817979],
              [76.510052, 19.817808],
              [76.512599, 19.815472],
              [76.512729, 19.815352],
              [76.51446, 19.811295],
              [76.51491, 19.807165],
              [76.511724, 19.800288],
              [76.499873, 19.799095],
              [76.486176, 19.799655],
              [76.483846, 19.792828],
              [76.484714, 19.785946],
              [76.48473, 19.785817],
              [76.489899, 19.778257],
              [76.502384, 19.772328],
              [76.512379, 19.770145],
              [76.512834, 19.770046],
              [76.510842, 19.762294],
              [76.49937, 19.761834],
              [76.493878, 19.760234],
              [76.488551, 19.75495],
              [76.485138, 19.748709],
              [76.485744, 19.743197],
              [76.459995, 19.746525],
              [76.458726, 19.723416],
              [76.458696, 19.72287],
              [76.48497, 19.719897],
              [76.485243, 19.719867],
              [76.487547, 19.697231],
              [76.487902, 19.676923],
              [76.471449, 19.678519],
              [76.466236, 19.667272],
              [76.460238, 19.664696],
              [76.453616, 19.666608],
              [76.450074, 19.659626],
              [76.444405, 19.641614],
              [76.444226, 19.641046],
              [76.452747, 19.640718],
              [76.453063, 19.640706],
              [76.453412, 19.626017],
              [76.452086, 19.612112],
              [76.442565, 19.611729],
              [76.434165, 19.601931],
              [76.433868, 19.601584],
              [76.43795, 19.600023],
              [76.438314, 19.599884],
              [76.437267, 19.58612],
              [76.43723, 19.585628],
              [76.448158, 19.582808],
              [76.448555, 19.582706],
              [76.445837, 19.563444],
              [76.446475, 19.553677],
              [76.442573, 19.540744],
              [76.413258, 19.532095],
              [76.41322, 19.532768],
              [76.41295, 19.53761],
              [76.41265, 19.537664],
              [76.396114, 19.540635],
              [76.395849, 19.530778],
              [76.378645, 19.536103],
              [76.372635, 19.515347],
              [76.37248, 19.504968],
              [76.372473, 19.504456],
              [76.377475, 19.503343],
              [76.377236, 19.499675],
              [76.374075, 19.496005],
              [76.371507, 19.48929],
              [76.36551, 19.468367],
              [76.344952, 19.469912],
              [76.341355, 19.453927],
              [76.336022, 19.456499],
              [76.327654, 19.455914],
              [76.315236, 19.463952],
              [76.310217, 19.455275],
              [76.303565, 19.431955],
              [76.290912, 19.432076],
              [76.286084, 19.396792],
              [76.286492, 19.396777],
              [76.286414, 19.396206],
              [76.292353, 19.395983],
              [76.285288, 19.366308],
              [76.267555, 19.36601],
              [76.261689, 19.357355],
              [76.262158, 19.356974],
              [76.262019, 19.356769],
              [76.267729, 19.352128],
              [76.274678, 19.348609],
              [76.280265, 19.348824],
              [76.280731, 19.348841],
              [76.279673, 19.344159],
              [76.273802, 19.338536],
              [76.26859, 19.334963],
              [76.265055, 19.333659],
              [76.25764, 19.334485],
              [76.241914, 19.337882],
              [76.235079, 19.313351],
              [76.213346, 19.318232],
              [76.210094, 19.300981],
              [76.2102, 19.298724],
              [76.210223, 19.298228],
              [76.216842, 19.296261],
              [76.221282, 19.293974],
              [76.221685, 19.293766],
              [76.220608, 19.28822],
              [76.217643, 19.288048],
              [76.209269, 19.277538],
              [76.209015, 19.277714],
              [76.19901, 19.284646],
              [76.195354, 19.286378],
              [76.185132, 19.28903],
              [76.179849, 19.288097],
              [76.172076, 19.283241],
              [76.167034, 19.282078],
              [76.163545, 19.283053],
              [76.161271, 19.28745],
              [76.159732, 19.295219],
              [76.158263, 19.297202],
              [76.152904, 19.29552],
              [76.142168, 19.290666],
              [76.137961, 19.292118],
              [76.134739, 19.294297],
              [76.129348, 19.300187],
              [76.12803, 19.303536],
              [76.125195, 19.303928],
              [76.121631, 19.301352],
              [76.117552, 19.296558],
              [76.115799, 19.29636],
              [76.112014, 19.301169],
              [76.107647, 19.306717],
              [76.101318, 19.308147],
              [76.098278, 19.306886],
              [76.095686, 19.298042],
              [76.095546, 19.293973],
              [76.091793, 19.284237],
              [76.083547, 19.279635],
              [76.077255, 19.279402],
              [76.072487, 19.280177],
              [76.065407, 19.28289],
              [76.054492, 19.284743],
              [76.050676, 19.283945],
              [76.039281, 19.285906],
              [76.031554, 19.289841],
              [76.028059, 19.297016],
              [76.026876, 19.301151],
              [76.026527, 19.312001],
              [76.025126, 19.321064],
              [76.022741, 19.326087],
              [76.023153, 19.328825],
              [76.024987, 19.332806],
              [76.025246, 19.336814],
              [76.023401, 19.338855],
              [76.019427, 19.339385],
              [76.01583, 19.338356],
              [76.012715, 19.336347],
              [76.000023, 19.323322],
              [75.983405, 19.312133],
              [75.970855, 19.299316],
              [75.954973, 19.294268],
              [75.946032, 19.293093],
              [75.938212, 19.292406],
              [75.933683, 19.293619],
              [75.920419, 19.300694],
              [75.907117, 19.319132],
              [75.90479, 19.33024],
              [75.90645, 19.343124],
              [75.909494, 19.351523],
              [75.916349, 19.361796],
              [75.915397, 19.365084],
              [75.922186, 19.373637],
              [75.922917, 19.376278],
              [75.921797, 19.384101],
              [75.917995, 19.387798],
              [75.909958, 19.389214],
              [75.904158, 19.387635],
              [75.899489, 19.385062],
              [75.894701, 19.380655],
              [75.887269, 19.378388],
              [75.881829, 19.38061],
              [75.873796, 19.380656],
              [75.867612, 19.375214],
              [75.852258, 19.371851],
              [75.839684, 19.370603],
              [75.835999, 19.371717],
              [75.817465, 19.383476],
              [75.811317, 19.388221],
              [75.796521, 19.396624],
              [75.783646, 19.396783],
              [75.771984, 19.395217],
              [75.765872, 19.393518],
              [75.758126, 19.389295],
              [75.761738, 19.38119],
              [75.762019, 19.371651],
              [75.758754, 19.368572],
              [75.754441, 19.358654],
              [75.7513, 19.35728],
              [75.739518, 19.358191],
              [75.712562, 19.357298],
              [75.704765, 19.358292],
              [75.701199, 19.360199],
              [75.688023, 19.355301],
              [75.681499, 19.356237],
              [75.678597, 19.35819],
              [75.676488, 19.364278],
              [75.674021, 19.366694],
              [75.655706, 19.365754],
              [75.650326, 19.368696],
              [75.641584, 19.380991],
              [75.628817, 19.374466],
              [75.62217, 19.37385],
              [75.615285, 19.378445],
              [75.611659, 19.382124],
              [75.609871, 19.381439],
              [75.61587, 19.399891],
              [75.617568, 19.408726],
              [75.618435, 19.424891],
              [75.612391, 19.428053],
              [75.609615, 19.430351],
              [75.611335, 19.453337],
              [75.614904, 19.456553],
              [75.619388, 19.467844],
              [75.623919, 19.463883],
              [75.629656, 19.460673],
              [75.632079, 19.460501],
              [75.6348, 19.464397],
              [75.636086, 19.470187],
              [75.64281, 19.486182],
              [75.645306, 19.498729],
              [75.644115, 19.511689],
              [75.64395, 19.528206],
              [75.650865, 19.54512],
              [75.655719, 19.554457],
              [75.657128, 19.566674],
              [75.65514, 19.57665],
              [75.654545, 19.585481],
              [75.653281, 19.588177],
              [75.653348, 19.592078],
              [75.651898, 19.59483],
              [75.616013, 19.598056],
              [75.613896, 19.602132],
              [75.600827, 19.602249],
              [75.598658, 19.606838],
              [75.599928, 19.610102],
              [75.595395, 19.619396],
              [75.592372, 19.628969],
              [75.590939, 19.637627],
              [75.600375, 19.640609],
              [75.607164, 19.641352],
              [75.610384, 19.656196],
              [75.633512, 19.655385],
              [75.635776, 19.678724],
              [75.630045, 19.701316],
              [75.633018, 19.704349],
              [75.636263, 19.734445],
              [75.629786, 19.737663],
              [75.630214, 19.745342],
              [75.627918, 19.745861],
              [75.628047, 19.751698],
              [75.628062, 19.752562],
              [75.62786, 19.775907],
              [75.638518, 19.776153],
              [75.636571, 19.782536],
              [75.645388, 19.78489],
              [75.645197, 19.792389],
              [75.64142, 19.800872],
              [75.636641, 19.813621],
              [75.652602, 19.815065],
              [75.652346, 19.824704],
              [75.647622, 19.835311],
              [75.647228, 19.850297],
              [75.650261, 19.870728],
              [75.647505, 19.873877],
              [75.65009, 19.877152],
              [75.653666, 19.91046],
              [75.66241, 19.91602],
              [75.667628, 19.920429],
              [75.666574, 19.926833],
              [75.668014, 19.939727],
              [75.650822, 19.951112],
              [75.640938, 19.955161],
              [75.637382, 19.955083],
              [75.64079, 19.960518],
              [75.637902, 19.969024],
              [75.633981, 19.982861],
              [75.636334, 19.9947],
              [75.630007, 20.000604],
              [75.638006, 20.002914],
              [75.638539, 20.003783],
              [75.613194, 20.004503],
              [75.604972, 20.005861],
              [75.601378, 20.008578],
              [75.601104, 20.014067],
              [75.59872, 20.01827],
              [75.595484, 20.020782],
              [75.593688, 20.023317],
              [75.593465, 20.028138],
              [75.60295, 20.046912],
              [75.60738, 20.051785],
              [75.606327, 20.054297],
              [75.603309, 20.056091],
              [75.600285, 20.062476],
              [75.596536, 20.060834],
              [75.594276, 20.061271],
              [75.591766, 20.068275],
              [75.589548, 20.078512],
              [75.589202, 20.084128],
              [75.589375, 20.10196],
              [75.606993, 20.103609],
              [75.620832, 20.103724],
              [75.627162, 20.105375],
              [75.629512, 20.109393],
              [75.63578, 20.128028],
              [75.635316, 20.131985],
              [75.636159, 20.137624],
              [75.638708, 20.142362],
              [75.639581, 20.146108],
              [75.643418, 20.15965],
              [75.643235, 20.164482],
              [75.644726, 20.17628],
              [75.647644, 20.18499],
              [75.648715, 20.19133],
              [75.67445, 20.188218],
              [75.676929, 20.188986],
              [75.679211, 20.191023],
              [75.683937, 20.201484],
              [75.684145, 20.2043],
              [75.680176, 20.215008],
              [75.680059, 20.219716],
              [75.681577, 20.229222],
              [75.680794, 20.232943],
              [75.677248, 20.234919],
              [75.67576, 20.237313],
              [75.676084, 20.240135],
              [75.6794, 20.246899],
              [75.682662, 20.258082],
              [75.68956, 20.265166],
              [75.692765, 20.270428],
              [75.696229, 20.280236],
              [75.696639, 20.286162],
              [75.691971, 20.295132],
              [75.688153, 20.299517],
              [75.684352, 20.306828],
              [75.685725, 20.309372],
              [75.705225, 20.313719],
              [75.708182, 20.315759],
              [75.711936, 20.317058],
              [75.718856, 20.331845],
              [75.72628, 20.331062],
              [75.734415, 20.33155],
              [75.735268, 20.336215],
              [75.74072, 20.337937],
              [75.744923, 20.336953],
              [75.746108, 20.329207],
              [75.750504, 20.327817],
              [75.755845, 20.327764],
              [75.763439, 20.332436],
              [75.76704, 20.336441],
              [75.769092, 20.337605],
              [75.773356, 20.336788],
              [75.769448, 20.353522],
              [75.766173, 20.358198],
              [75.760862, 20.360325],
              [75.759706, 20.369957],
              [75.754536, 20.37094],
              [75.751707, 20.37338],
              [75.750556, 20.377739],
              [75.751061, 20.381535],
              [75.754342, 20.391445],
              [75.754659, 20.395693],
              [75.754494, 20.399202],
              [75.752493, 20.403775],
              [75.749736, 20.405925],
              [75.740287, 20.408179],
              [75.737295, 20.414294],
              [75.739238, 20.419429],
              [75.742901, 20.423365],
              [75.748045, 20.424859],
              [75.750666, 20.424536],
              [75.759692, 20.427159],
              [75.762746, 20.435746],
              [75.762769, 20.439373],
              [75.765489, 20.450708],
              [75.768974, 20.454075],
              [75.773696, 20.456076],
              [75.778141, 20.455431],
              [75.782638, 20.455765],
              [75.79621, 20.453956],
              [75.798958, 20.453003],
              [75.798258, 20.461093],
              [75.799572, 20.463291],
              [75.81175, 20.466225],
              [75.815467, 20.46569],
              [75.817838, 20.470988],
              [75.819754, 20.473468],
              [75.825589, 20.47428],
              [75.830953, 20.472716],
              [75.838643, 20.464879],
              [75.840438, 20.461566],
              [75.84381, 20.460048],
              [75.853165, 20.459855],
              [75.85751, 20.462875],
              [75.859409, 20.461923],
              [75.86898, 20.448189],
              [75.869248, 20.446174],
              [75.865031, 20.442983],
              [75.86523, 20.441204],
              [75.870109, 20.440219],
              [75.874176, 20.44031],
              [75.878333, 20.438916],
              [75.881905, 20.439808],
              [75.884114, 20.443793],
              [75.884208, 20.445573],
              [75.894345, 20.447045],
              [75.877675, 20.453838],
              [75.876199, 20.455545],
              [75.874919, 20.461262],
              [75.872701, 20.463831],
              [75.869838, 20.463851],
              [75.867881, 20.465391],
              [75.8667, 20.467497],
              [75.864351, 20.476705],
              [75.861851, 20.48173],
              [75.859536, 20.48194],
              [75.856208, 20.481047],
              [75.851671, 20.490232],
              [75.853175, 20.496552],
              [75.853535, 20.507537],
              [75.856695, 20.507669],
              [75.856915, 20.509676],
              [75.860378, 20.510204],
              [75.861581, 20.511238],
              [75.862605, 20.517851],
              [75.864671, 20.52324],
              [75.863079, 20.523865],
              [75.863586, 20.527649],
              [75.867911, 20.52731],
              [75.87359, 20.529827],
              [75.876146, 20.529932],
              [75.879279, 20.527475],
              [75.887143, 20.526001],
              [75.88642, 20.531107],
              [75.879325, 20.539367],
              [75.871885, 20.551527],
              [75.867095, 20.556181],
              [75.86497, 20.561746],
              [75.870219, 20.559853],
              [75.875766, 20.559123],
              [75.888326, 20.561405],
              [75.889526, 20.563359],
              [75.914558, 20.558239],
              [75.921215, 20.555852],
              [75.922774, 20.552343],
              [75.929671, 20.549861],
              [75.931666, 20.550881],
              [75.933695, 20.554821],
              [75.934605, 20.57809],
              [75.935541, 20.581591],
              [75.93528, 20.593703],
              [75.933799, 20.595696],
              [75.933518, 20.599697],
              [75.948338, 20.601907],
              [75.951425, 20.603442],
              [75.954924, 20.606465],
              [75.956644, 20.615933],
              [75.95715, 20.624974],
              [75.961543, 20.623853],
              [75.972932, 20.624165],
              [75.987913, 20.622844],
              [75.991077, 20.623145],
              [75.993191, 20.626765],
              [75.99844, 20.629417],
              [76.000025, 20.632609],
              [76.001672, 20.634074],
              [76.008601, 20.63589],
              [76.010618, 20.639265],
              [76.011074, 20.643022],
              [76.013699, 20.642933],
              [76.017991, 20.645573],
              [76.02257, 20.64512],
              [76.026249, 20.643784],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 246,
        censuscode: 514,
        dt_cen_cd: 18,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Jalna",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [72.896816, 18.978772],
              [72.903706, 18.975417],
              [72.908124, 18.971318],
              [72.912194, 18.963777],
              [72.914499, 18.950755],
              [72.90976, 18.938681],
              [72.906443, 18.933282],
              [72.900886, 18.929279],
              [72.881188, 18.919206],
              [72.869532, 18.910835],
              [72.859935, 18.897797],
              [72.855089, 18.889219],
              [72.85135, 18.882145],
              [72.845576, 18.865976],
              [72.842421, 18.856004],
              [72.840019, 18.845343],
              [72.811169, 18.89356],
              [72.80959, 18.894058],
              [72.807545, 18.895808],
              [72.805685, 18.904605],
              [72.806197, 18.908685],
              [72.806888, 18.910162],
              [72.811595, 18.920758],
              [72.813351, 18.923166],
              [72.814195, 18.923292],
              [72.821203, 18.932862],
              [72.821046, 18.934304],
              [72.821991, 18.934327],
              [72.822762, 18.937483],
              [72.822737, 18.938844],
              [72.822277, 18.943148],
              [72.816904, 18.949583],
              [72.812807, 18.951537],
              [72.809729, 18.951016],
              [72.8083, 18.950154],
              [72.803011, 18.946918],
              [72.796185, 18.941012],
              [72.794477, 18.938606],
              [72.7941, 18.938029],
              [72.787649, 18.939477],
              [72.787497, 18.940827],
              [72.787642, 18.944895],
              [72.788325, 18.946794],
              [72.790088, 18.949839],
              [72.793467, 18.954409],
              [72.793982, 18.955206],
              [72.793954, 18.956326],
              [72.799565, 18.964715],
              [72.802158, 18.970303],
              [72.807885, 18.980143],
              [72.812707, 19.003984],
              [72.81329, 19.014379],
              [72.814659, 19.016681],
              [72.816483, 19.017457],
              [72.8202, 19.01871],
              [72.817682, 19.032537],
              [72.824023, 19.031227],
              [72.827283, 19.032488],
              [72.834251, 19.041907],
              [72.840901, 19.045531],
              [72.843645, 19.04673],
              [72.8473, 19.04716],
              [72.85372, 19.051907],
              [72.859401, 19.054734],
              [72.863549, 19.053351],
              [72.868478, 19.051697],
              [72.877106, 19.04566],
              [72.876293, 19.040275],
              [72.874562, 19.03003],
              [72.871248, 19.022467],
              [72.875604, 19.017897],
              [72.879732, 19.01551],
              [72.884655, 19.012667],
              [72.88282, 18.999998],
              [72.879, 18.991473],
              [72.880362, 18.984392],
              [72.882426, 18.981199],
              [72.896816, 18.978772],
            ],
          ],
        ],
      },
      properties: {
        cartodb_id: 382,
        censuscode: 519,
        dt_cen_cd: 23,
        st_cen_cd: 27,
        st_nm: "Maharashtra",
        district: "Mumbai",
      },
    },
  ],
};

// 2. UPDATE PROJECTION TO CENTER ON MAHARASHTRA
const PROJECTION_CONFIG = {
  scale: 3000, // Zoomed in scale
  center: [76.5, 19.5], // East Latitude, North Longitude center of Maharashtra
};

const DONATED_COLOR = "#C1F2B0"; // Green
const NOT_DONATED_COLOR = "#F7B787"; // Orange
const DEFAULT_COLOR = "#9FB1e8"; // Default color
const DONATED_HOVER_COLOR = "#65B741"; // Green hover
const NOT_DONATED_HOVER_COLOR = "#EE7214"; // Orange hover
const DEFAULT_HOVER_COLOR = "#1A44AD"; // Default hover color

const geographyStyle = {
  default: {
    outline: "none",
    stroke: "#FFFFFF", // Adds a white border between districts
    strokeWidth: 0.5,
  },
  hover: {
    transition: "all 250ms",
    outline: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
  },
  pressed: {
    outline: "none",
  },
};

function MaharashtraMap() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [tooltipContent, setTooltipContent] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 50, // Increased to accommodate all districts
    search: "",
    searchable: ["name", "udise_no"],
    sort: "region.name",
    type: REGIONS_TYPE.DISTRICT, // Changed to DISTRICT
    parent: "YOUR_MAHARASHTRA_STATE_ID", // Replace with the actual ID for Maharashtra
    sortDirection: 1,
    validated: true,
  });

 const onMouseEnter = (geo, current) => {
   return () => {
     const districtName = current?.value
       ? current.value.name
       : geo.properties.district || geo.properties.name;
     const donated = current?.value?.donated ?? 0;
     const not_donated = current?.value?.not_donated ?? 0;

     setTooltipContent({
       name: districtName,
       donated: donated,
       not_donated: not_donated,
       district_id: current?.value ? current.value.district_id : null,
     });
   };
 };

  const onMouseLeave = () => {
    setTooltipContent("");
  };

  const onClick = (current) => {
    if (current) {
      const districtName = current.value
        ? current.value.name
        : current.district;
      const donated = current.value?.donated ?? 0;
      const not_donated = current.value?.not_donated ?? 0;

      setTooltipContent({
        name: districtName,
        donated: donated,
        not_donated: not_donated,
        district_id: current.value ? current.value.district_id : null,
      });
    } else {
      setTooltipContent("");
    }
  };

 return (
   <Box
     sx={{
       p: 3,
       borderRadius: 4,
       background: "#fafafa",
       boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
       border: "1px solid #e5e7eb",
     }}
   >
     <Box
       sx={{
         display: "flex",
         justifyContent: "space-between",
         alignItems: "center",
        //  mb: 3,
        //  pb: 2,
         borderBottom: "1px solid #E5E7EB",
       }}
     >
       <Box>
         <Typography
           variant="h5"
           fontWeight={700}
           color="#1E293B"
           sx={{ letterSpacing: 0.5 }}
         >
           Maharashtra District Overview
         </Typography>

         <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
           Hover over a district to view its details.
         </Typography>
       </Box>

       <Box
         sx={{
           px: 2,
           py: 0.7,
           borderRadius: 5,
           bgcolor: "#E8F5E9",
           color: "#2E7D32",
           fontWeight: 600,
           fontSize: 13,
           border: "1px solid #C8E6C9",
         }}
       >
         📍 Maharashtra
       </Box>
     </Box>
     <Grid container spacing={3}>
       <Grid item xs={12}>
         <Box
           sx={{
             width: "60%",
             mx: "auto",
             height: 400,
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
           }}
         >
           <ComposableMap
             projection="geoMercator"
             projectionConfig={{
               scale: 3600,
               center: [75.8, 19.5],
             }}
             width={850}
             height={650}
             style={{
               width: "100%",
               height: "auto",
             }}
           >
             <Geographies geography={MAHARASHTRA_TOPO_JSON}>
               {({ geographies }) =>
                 geographies.map((geo) => {
                   const geoName =
                     geo.properties.district ||
                     geo.properties.DISTRICT ||
                     geo.properties.NAME_2 ||
                     geo.properties.name;

                   const current = data.find((s) => s.id === geoName);

                   return (
                     <Geography
                       key={geo.rsmKey}
                       geography={geo}
                       data-tooltip-id="map-tooltip"
                       data-tooltip-content={current?.value?.name || geoName}
                       fill={
                         current
                           ? current.value.donated
                             ? DONATED_COLOR
                             : current.value.not_donated
                               ? NOT_DONATED_COLOR
                               : "#dbeafe"
                           : "#dbeafe"
                       }
                       stroke="#ffffff"
                       strokeWidth={1}
                       style={{
                         default: {
                           outline: "none",
                           transition: "all .25s ease",
                         },
                         hover: {
                           outline: "none",
                           cursor: "pointer",
                           fill: "#2563eb",
                         },
                         pressed: {
                           outline: "none",
                           fill: "#1d4ed8",
                         },
                       }}
                       onClick={() => onClick(current)}
                       onMouseEnter={onMouseEnter(geo, current)}
                       onMouseLeave={onMouseLeave}
                     />
                   );
                 })
               }
             </Geographies>
           </ComposableMap>
         </Box>

         <Tooltip
           id="map-tooltip"
           float
           style={{
             background: "#1E293B",
             color: "#fff",
             borderRadius: "10px",
             padding: "8px 14px",
             fontSize: "14px",
             fontWeight: 600,
             boxShadow: "0 6px 18px rgba(0,0,0,.25)",
             zIndex: 9999,
           }}
         />
       </Grid>
     </Grid>
   </Box>
 );
}

export default MaharashtraMap;
